import * as tslib_1 from "tslib";
import { APP_INITIALIZER, ApplicationRef, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactory, ComponentFactoryResolver, ContentChild, ContentChildren, Directive, ElementRef, EventEmitter, Host, HostBinding, HostListener, Inject, Injectable, InjectionToken, Injector, Input, NgModule, NgZone, Optional, Output, Pipe, Renderer, Renderer2, SkipSelf, TemplateRef, Type, ViewChild, ViewContainerRef, ViewEncapsulation, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BACKSPACE, ComponentPortal, DOWN_ARROW, Directionality, DomPortalHost, ENTER, ESCAPE, LEFT_ARROW, ObserveContentModule, Platform, PlatformModule, PortalModule, RIGHT_ARROW, RxChain, TAB, TemplatePortal, UP_ARROW } from '@angular/cdk';
import { Subject as Subject$1 } from 'rxjs/Subject';
import { Subscription as Subscription$1 } from 'rxjs/Subscription';
import { fromEvent as fromEvent$1 } from 'rxjs/observable/fromEvent';
import { merge as merge$1 } from 'rxjs/observable/merge';
import { auditTime as auditTime$1 } from 'rxjs/operator/auditTime';
import { DOCUMENT } from '@angular/platform-browser';
import { BehaviorSubject as BehaviorSubject$1 } from 'rxjs/BehaviorSubject';
import { distinctUntilChanged as distinctUntilChanged$1 } from 'rxjs/operator/distinctUntilChanged';
import { _do as _do$1 } from 'rxjs/operator/do';
import { filter as filter$1 } from 'rxjs/operator/filter';
import { map as map$1 } from 'rxjs/operator/map';
import { pluck as pluck$1 } from 'rxjs/operator/pluck';
import { takeUntil as takeUntil$1 } from 'rxjs/operator/takeUntil';
import { debounceTime as debounceTime$1 } from 'rxjs/operator/debounceTime';
import { Observable as Observable$1 } from 'rxjs/Observable';
import { of as of$1 } from 'rxjs/observable/of';
import { startWith as startWith$1 } from 'rxjs/operator/startWith';
import { throttleTime as throttleTime$1 } from 'rxjs/operator/throttleTime';
var NzRowComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function NzRowComponent(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._classList = [];
        this._prefixCls = 'ant-row';
        this._align = 'top';
        this._justify = 'start';
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzRowComponent.prototype, "nzType", {
        /**
         * @return {?}
         */
        get: function () {
            return this._type;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._type = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzRowComponent.prototype, "nzAlign", {
        /**
         * @return {?}
         */
        get: function () {
            return this._align;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._align = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzRowComponent.prototype, "nzJustify", {
        /**
         * @return {?}
         */
        get: function () {
            return this._justify;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._justify = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzRowComponent.prototype, "nzGutter", {
        /**
         * @return {?}
         */
        get: function () {
            return this._gutter;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._gutter = value;
            this.setStyle();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    NzRowComponent.prototype.setStyle = function () {
        this._renderer.setStyle(this._el, 'margin-left', "-" + this._gutter / 2 + "px");
        this._renderer.setStyle(this._el, 'margin-right', "-" + this._gutter / 2 + "px");
    };
    /**
     * temp solution since no method add classMap to host https://github.com/angular/angular/issues/7289
     * @return {?}
     */
    NzRowComponent.prototype.setClassMap = function () {
        var _this = this;
        this._classList.forEach(function (_className) {
            _this._renderer.removeClass(_this._el, _className);
        });
        this._classList = [
            (!this.nzType) && this._prefixCls,
            this.nzType && this._prefixCls + "-" + this.nzType,
            this.nzType && this.nzAlign && this._prefixCls + "-" + this.nzType + "-" + this.nzAlign,
            this.nzType && this.nzJustify && this._prefixCls + "-" + this.nzType + "-" + this.nzJustify
        ].filter(function (item) {
            return !!item;
        });
        this._classList.forEach(function (_className) {
            _this._renderer.addClass(_this._el, _className);
        });
    };
    /**
     * @return {?}
     */
    NzRowComponent.prototype.ngOnInit = function () {
        this.setClassMap();
    };
    return NzRowComponent;
}());
NzRowComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-row],nz-row',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-row {\n  position: relative;\n  margin-left: 0;\n  margin-right: 0;\n  height: auto;\n  zoom: 1;\n  display: block;\n}\n.ant-row:before,\n.ant-row:after {\n  content: \" \";\n  display: table;\n}\n.ant-row:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-row-flex {\n  display: flex;\n  flex-flow: row wrap;\n}\n.ant-row-flex:before,\n.ant-row-flex:after {\n  display: flex;\n}\n.ant-row-flex-start {\n  justify-content: flex-start;\n}\n.ant-row-flex-center {\n  justify-content: center;\n}\n.ant-row-flex-end {\n  justify-content: flex-end;\n}\n.ant-row-flex-space-between {\n  justify-content: space-between;\n}\n.ant-row-flex-space-around {\n  justify-content: space-around;\n}\n.ant-row-flex-top {\n  align-items: flex-start;\n}\n.ant-row-flex-middle {\n  align-items: center;\n}\n.ant-row-flex-bottom {\n  align-items: flex-end;\n}\n.ant-col {\n  position: relative;\n  display: block;\n}\n.ant-col-1, .ant-col-xs-1, .ant-col-sm-1, .ant-col-md-1, .ant-col-lg-1, .ant-col-2, .ant-col-xs-2, .ant-col-sm-2, .ant-col-md-2, .ant-col-lg-2, .ant-col-3, .ant-col-xs-3, .ant-col-sm-3, .ant-col-md-3, .ant-col-lg-3, .ant-col-4, .ant-col-xs-4, .ant-col-sm-4, .ant-col-md-4, .ant-col-lg-4, .ant-col-5, .ant-col-xs-5, .ant-col-sm-5, .ant-col-md-5, .ant-col-lg-5, .ant-col-6, .ant-col-xs-6, .ant-col-sm-6, .ant-col-md-6, .ant-col-lg-6, .ant-col-7, .ant-col-xs-7, .ant-col-sm-7, .ant-col-md-7, .ant-col-lg-7, .ant-col-8, .ant-col-xs-8, .ant-col-sm-8, .ant-col-md-8, .ant-col-lg-8, .ant-col-9, .ant-col-xs-9, .ant-col-sm-9, .ant-col-md-9, .ant-col-lg-9, .ant-col-10, .ant-col-xs-10, .ant-col-sm-10, .ant-col-md-10, .ant-col-lg-10, .ant-col-11, .ant-col-xs-11, .ant-col-sm-11, .ant-col-md-11, .ant-col-lg-11, .ant-col-12, .ant-col-xs-12, .ant-col-sm-12, .ant-col-md-12, .ant-col-lg-12, .ant-col-13, .ant-col-xs-13, .ant-col-sm-13, .ant-col-md-13, .ant-col-lg-13, .ant-col-14, .ant-col-xs-14, .ant-col-sm-14, .ant-col-md-14, .ant-col-lg-14, .ant-col-15, .ant-col-xs-15, .ant-col-sm-15, .ant-col-md-15, .ant-col-lg-15, .ant-col-16, .ant-col-xs-16, .ant-col-sm-16, .ant-col-md-16, .ant-col-lg-16, .ant-col-17, .ant-col-xs-17, .ant-col-sm-17, .ant-col-md-17, .ant-col-lg-17, .ant-col-18, .ant-col-xs-18, .ant-col-sm-18, .ant-col-md-18, .ant-col-lg-18, .ant-col-19, .ant-col-xs-19, .ant-col-sm-19, .ant-col-md-19, .ant-col-lg-19, .ant-col-20, .ant-col-xs-20, .ant-col-sm-20, .ant-col-md-20, .ant-col-lg-20, .ant-col-21, .ant-col-xs-21, .ant-col-sm-21, .ant-col-md-21, .ant-col-lg-21, .ant-col-22, .ant-col-xs-22, .ant-col-sm-22, .ant-col-md-22, .ant-col-lg-22, .ant-col-23, .ant-col-xs-23, .ant-col-sm-23, .ant-col-md-23, .ant-col-lg-23, .ant-col-24, .ant-col-xs-24, .ant-col-sm-24, .ant-col-md-24, .ant-col-lg-24 {\n  position: relative;\n  min-height: 1px;\n  padding-left: 0;\n  padding-right: 0;\n}\n.ant-col-1, .ant-col-2, .ant-col-3, .ant-col-4, .ant-col-5, .ant-col-6, .ant-col-7, .ant-col-8, .ant-col-9, .ant-col-10, .ant-col-11, .ant-col-12, .ant-col-13, .ant-col-14, .ant-col-15, .ant-col-16, .ant-col-17, .ant-col-18, .ant-col-19, .ant-col-20, .ant-col-21, .ant-col-22, .ant-col-23, .ant-col-24 {\n  float: left;\n  flex: 0 0 auto;\n}\n.ant-col-24 {\n  display: block;\n  width: 100%;\n}\n.ant-col-push-24 {\n  left: 100%;\n}\n.ant-col-pull-24 {\n  right: 100%;\n}\n.ant-col-offset-24 {\n  margin-left: 100%;\n}\n.ant-col-order-24 {\n  order: 24;\n}\n.ant-col-23 {\n  display: block;\n  width: 95.83333333%;\n}\n.ant-col-push-23 {\n  left: 95.83333333%;\n}\n.ant-col-pull-23 {\n  right: 95.83333333%;\n}\n.ant-col-offset-23 {\n  margin-left: 95.83333333%;\n}\n.ant-col-order-23 {\n  order: 23;\n}\n.ant-col-22 {\n  display: block;\n  width: 91.66666667%;\n}\n.ant-col-push-22 {\n  left: 91.66666667%;\n}\n.ant-col-pull-22 {\n  right: 91.66666667%;\n}\n.ant-col-offset-22 {\n  margin-left: 91.66666667%;\n}\n.ant-col-order-22 {\n  order: 22;\n}\n.ant-col-21 {\n  display: block;\n  width: 87.5%;\n}\n.ant-col-push-21 {\n  left: 87.5%;\n}\n.ant-col-pull-21 {\n  right: 87.5%;\n}\n.ant-col-offset-21 {\n  margin-left: 87.5%;\n}\n.ant-col-order-21 {\n  order: 21;\n}\n.ant-col-20 {\n  display: block;\n  width: 83.33333333%;\n}\n.ant-col-push-20 {\n  left: 83.33333333%;\n}\n.ant-col-pull-20 {\n  right: 83.33333333%;\n}\n.ant-col-offset-20 {\n  margin-left: 83.33333333%;\n}\n.ant-col-order-20 {\n  order: 20;\n}\n.ant-col-19 {\n  display: block;\n  width: 79.16666667%;\n}\n.ant-col-push-19 {\n  left: 79.16666667%;\n}\n.ant-col-pull-19 {\n  right: 79.16666667%;\n}\n.ant-col-offset-19 {\n  margin-left: 79.16666667%;\n}\n.ant-col-order-19 {\n  order: 19;\n}\n.ant-col-18 {\n  display: block;\n  width: 75%;\n}\n.ant-col-push-18 {\n  left: 75%;\n}\n.ant-col-pull-18 {\n  right: 75%;\n}\n.ant-col-offset-18 {\n  margin-left: 75%;\n}\n.ant-col-order-18 {\n  order: 18;\n}\n.ant-col-17 {\n  display: block;\n  width: 70.83333333%;\n}\n.ant-col-push-17 {\n  left: 70.83333333%;\n}\n.ant-col-pull-17 {\n  right: 70.83333333%;\n}\n.ant-col-offset-17 {\n  margin-left: 70.83333333%;\n}\n.ant-col-order-17 {\n  order: 17;\n}\n.ant-col-16 {\n  display: block;\n  width: 66.66666667%;\n}\n.ant-col-push-16 {\n  left: 66.66666667%;\n}\n.ant-col-pull-16 {\n  right: 66.66666667%;\n}\n.ant-col-offset-16 {\n  margin-left: 66.66666667%;\n}\n.ant-col-order-16 {\n  order: 16;\n}\n.ant-col-15 {\n  display: block;\n  width: 62.5%;\n}\n.ant-col-push-15 {\n  left: 62.5%;\n}\n.ant-col-pull-15 {\n  right: 62.5%;\n}\n.ant-col-offset-15 {\n  margin-left: 62.5%;\n}\n.ant-col-order-15 {\n  order: 15;\n}\n.ant-col-14 {\n  display: block;\n  width: 58.33333333%;\n}\n.ant-col-push-14 {\n  left: 58.33333333%;\n}\n.ant-col-pull-14 {\n  right: 58.33333333%;\n}\n.ant-col-offset-14 {\n  margin-left: 58.33333333%;\n}\n.ant-col-order-14 {\n  order: 14;\n}\n.ant-col-13 {\n  display: block;\n  width: 54.16666667%;\n}\n.ant-col-push-13 {\n  left: 54.16666667%;\n}\n.ant-col-pull-13 {\n  right: 54.16666667%;\n}\n.ant-col-offset-13 {\n  margin-left: 54.16666667%;\n}\n.ant-col-order-13 {\n  order: 13;\n}\n.ant-col-12 {\n  display: block;\n  width: 50%;\n}\n.ant-col-push-12 {\n  left: 50%;\n}\n.ant-col-pull-12 {\n  right: 50%;\n}\n.ant-col-offset-12 {\n  margin-left: 50%;\n}\n.ant-col-order-12 {\n  order: 12;\n}\n.ant-col-11 {\n  display: block;\n  width: 45.83333333%;\n}\n.ant-col-push-11 {\n  left: 45.83333333%;\n}\n.ant-col-pull-11 {\n  right: 45.83333333%;\n}\n.ant-col-offset-11 {\n  margin-left: 45.83333333%;\n}\n.ant-col-order-11 {\n  order: 11;\n}\n.ant-col-10 {\n  display: block;\n  width: 41.66666667%;\n}\n.ant-col-push-10 {\n  left: 41.66666667%;\n}\n.ant-col-pull-10 {\n  right: 41.66666667%;\n}\n.ant-col-offset-10 {\n  margin-left: 41.66666667%;\n}\n.ant-col-order-10 {\n  order: 10;\n}\n.ant-col-9 {\n  display: block;\n  width: 37.5%;\n}\n.ant-col-push-9 {\n  left: 37.5%;\n}\n.ant-col-pull-9 {\n  right: 37.5%;\n}\n.ant-col-offset-9 {\n  margin-left: 37.5%;\n}\n.ant-col-order-9 {\n  order: 9;\n}\n.ant-col-8 {\n  display: block;\n  width: 33.33333333%;\n}\n.ant-col-push-8 {\n  left: 33.33333333%;\n}\n.ant-col-pull-8 {\n  right: 33.33333333%;\n}\n.ant-col-offset-8 {\n  margin-left: 33.33333333%;\n}\n.ant-col-order-8 {\n  order: 8;\n}\n.ant-col-7 {\n  display: block;\n  width: 29.16666667%;\n}\n.ant-col-push-7 {\n  left: 29.16666667%;\n}\n.ant-col-pull-7 {\n  right: 29.16666667%;\n}\n.ant-col-offset-7 {\n  margin-left: 29.16666667%;\n}\n.ant-col-order-7 {\n  order: 7;\n}\n.ant-col-6 {\n  display: block;\n  width: 25%;\n}\n.ant-col-push-6 {\n  left: 25%;\n}\n.ant-col-pull-6 {\n  right: 25%;\n}\n.ant-col-offset-6 {\n  margin-left: 25%;\n}\n.ant-col-order-6 {\n  order: 6;\n}\n.ant-col-5 {\n  display: block;\n  width: 20.83333333%;\n}\n.ant-col-push-5 {\n  left: 20.83333333%;\n}\n.ant-col-pull-5 {\n  right: 20.83333333%;\n}\n.ant-col-offset-5 {\n  margin-left: 20.83333333%;\n}\n.ant-col-order-5 {\n  order: 5;\n}\n.ant-col-4 {\n  display: block;\n  width: 16.66666667%;\n}\n.ant-col-push-4 {\n  left: 16.66666667%;\n}\n.ant-col-pull-4 {\n  right: 16.66666667%;\n}\n.ant-col-offset-4 {\n  margin-left: 16.66666667%;\n}\n.ant-col-order-4 {\n  order: 4;\n}\n.ant-col-3 {\n  display: block;\n  width: 12.5%;\n}\n.ant-col-push-3 {\n  left: 12.5%;\n}\n.ant-col-pull-3 {\n  right: 12.5%;\n}\n.ant-col-offset-3 {\n  margin-left: 12.5%;\n}\n.ant-col-order-3 {\n  order: 3;\n}\n.ant-col-2 {\n  display: block;\n  width: 8.33333333%;\n}\n.ant-col-push-2 {\n  left: 8.33333333%;\n}\n.ant-col-pull-2 {\n  right: 8.33333333%;\n}\n.ant-col-offset-2 {\n  margin-left: 8.33333333%;\n}\n.ant-col-order-2 {\n  order: 2;\n}\n.ant-col-1 {\n  display: block;\n  width: 4.16666667%;\n}\n.ant-col-push-1 {\n  left: 4.16666667%;\n}\n.ant-col-pull-1 {\n  right: 4.16666667%;\n}\n.ant-col-offset-1 {\n  margin-left: 4.16666667%;\n}\n.ant-col-order-1 {\n  order: 1;\n}\n.ant-col-0 {\n  display: none;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-offset-0 {\n  margin-left: 0;\n}\n.ant-col-order-0 {\n  order: 0;\n}\n.ant-col-xs-1, .ant-col-xs-2, .ant-col-xs-3, .ant-col-xs-4, .ant-col-xs-5, .ant-col-xs-6, .ant-col-xs-7, .ant-col-xs-8, .ant-col-xs-9, .ant-col-xs-10, .ant-col-xs-11, .ant-col-xs-12, .ant-col-xs-13, .ant-col-xs-14, .ant-col-xs-15, .ant-col-xs-16, .ant-col-xs-17, .ant-col-xs-18, .ant-col-xs-19, .ant-col-xs-20, .ant-col-xs-21, .ant-col-xs-22, .ant-col-xs-23, .ant-col-xs-24 {\n  float: left;\n  flex: 0 0 auto;\n}\n.ant-col-xs-24 {\n  display: block;\n  width: 100%;\n}\n.ant-col-xs-push-24 {\n  left: 100%;\n}\n.ant-col-xs-pull-24 {\n  right: 100%;\n}\n.ant-col-xs-offset-24 {\n  margin-left: 100%;\n}\n.ant-col-xs-order-24 {\n  order: 24;\n}\n.ant-col-xs-23 {\n  display: block;\n  width: 95.83333333%;\n}\n.ant-col-xs-push-23 {\n  left: 95.83333333%;\n}\n.ant-col-xs-pull-23 {\n  right: 95.83333333%;\n}\n.ant-col-xs-offset-23 {\n  margin-left: 95.83333333%;\n}\n.ant-col-xs-order-23 {\n  order: 23;\n}\n.ant-col-xs-22 {\n  display: block;\n  width: 91.66666667%;\n}\n.ant-col-xs-push-22 {\n  left: 91.66666667%;\n}\n.ant-col-xs-pull-22 {\n  right: 91.66666667%;\n}\n.ant-col-xs-offset-22 {\n  margin-left: 91.66666667%;\n}\n.ant-col-xs-order-22 {\n  order: 22;\n}\n.ant-col-xs-21 {\n  display: block;\n  width: 87.5%;\n}\n.ant-col-xs-push-21 {\n  left: 87.5%;\n}\n.ant-col-xs-pull-21 {\n  right: 87.5%;\n}\n.ant-col-xs-offset-21 {\n  margin-left: 87.5%;\n}\n.ant-col-xs-order-21 {\n  order: 21;\n}\n.ant-col-xs-20 {\n  display: block;\n  width: 83.33333333%;\n}\n.ant-col-xs-push-20 {\n  left: 83.33333333%;\n}\n.ant-col-xs-pull-20 {\n  right: 83.33333333%;\n}\n.ant-col-xs-offset-20 {\n  margin-left: 83.33333333%;\n}\n.ant-col-xs-order-20 {\n  order: 20;\n}\n.ant-col-xs-19 {\n  display: block;\n  width: 79.16666667%;\n}\n.ant-col-xs-push-19 {\n  left: 79.16666667%;\n}\n.ant-col-xs-pull-19 {\n  right: 79.16666667%;\n}\n.ant-col-xs-offset-19 {\n  margin-left: 79.16666667%;\n}\n.ant-col-xs-order-19 {\n  order: 19;\n}\n.ant-col-xs-18 {\n  display: block;\n  width: 75%;\n}\n.ant-col-xs-push-18 {\n  left: 75%;\n}\n.ant-col-xs-pull-18 {\n  right: 75%;\n}\n.ant-col-xs-offset-18 {\n  margin-left: 75%;\n}\n.ant-col-xs-order-18 {\n  order: 18;\n}\n.ant-col-xs-17 {\n  display: block;\n  width: 70.83333333%;\n}\n.ant-col-xs-push-17 {\n  left: 70.83333333%;\n}\n.ant-col-xs-pull-17 {\n  right: 70.83333333%;\n}\n.ant-col-xs-offset-17 {\n  margin-left: 70.83333333%;\n}\n.ant-col-xs-order-17 {\n  order: 17;\n}\n.ant-col-xs-16 {\n  display: block;\n  width: 66.66666667%;\n}\n.ant-col-xs-push-16 {\n  left: 66.66666667%;\n}\n.ant-col-xs-pull-16 {\n  right: 66.66666667%;\n}\n.ant-col-xs-offset-16 {\n  margin-left: 66.66666667%;\n}\n.ant-col-xs-order-16 {\n  order: 16;\n}\n.ant-col-xs-15 {\n  display: block;\n  width: 62.5%;\n}\n.ant-col-xs-push-15 {\n  left: 62.5%;\n}\n.ant-col-xs-pull-15 {\n  right: 62.5%;\n}\n.ant-col-xs-offset-15 {\n  margin-left: 62.5%;\n}\n.ant-col-xs-order-15 {\n  order: 15;\n}\n.ant-col-xs-14 {\n  display: block;\n  width: 58.33333333%;\n}\n.ant-col-xs-push-14 {\n  left: 58.33333333%;\n}\n.ant-col-xs-pull-14 {\n  right: 58.33333333%;\n}\n.ant-col-xs-offset-14 {\n  margin-left: 58.33333333%;\n}\n.ant-col-xs-order-14 {\n  order: 14;\n}\n.ant-col-xs-13 {\n  display: block;\n  width: 54.16666667%;\n}\n.ant-col-xs-push-13 {\n  left: 54.16666667%;\n}\n.ant-col-xs-pull-13 {\n  right: 54.16666667%;\n}\n.ant-col-xs-offset-13 {\n  margin-left: 54.16666667%;\n}\n.ant-col-xs-order-13 {\n  order: 13;\n}\n.ant-col-xs-12 {\n  display: block;\n  width: 50%;\n}\n.ant-col-xs-push-12 {\n  left: 50%;\n}\n.ant-col-xs-pull-12 {\n  right: 50%;\n}\n.ant-col-xs-offset-12 {\n  margin-left: 50%;\n}\n.ant-col-xs-order-12 {\n  order: 12;\n}\n.ant-col-xs-11 {\n  display: block;\n  width: 45.83333333%;\n}\n.ant-col-xs-push-11 {\n  left: 45.83333333%;\n}\n.ant-col-xs-pull-11 {\n  right: 45.83333333%;\n}\n.ant-col-xs-offset-11 {\n  margin-left: 45.83333333%;\n}\n.ant-col-xs-order-11 {\n  order: 11;\n}\n.ant-col-xs-10 {\n  display: block;\n  width: 41.66666667%;\n}\n.ant-col-xs-push-10 {\n  left: 41.66666667%;\n}\n.ant-col-xs-pull-10 {\n  right: 41.66666667%;\n}\n.ant-col-xs-offset-10 {\n  margin-left: 41.66666667%;\n}\n.ant-col-xs-order-10 {\n  order: 10;\n}\n.ant-col-xs-9 {\n  display: block;\n  width: 37.5%;\n}\n.ant-col-xs-push-9 {\n  left: 37.5%;\n}\n.ant-col-xs-pull-9 {\n  right: 37.5%;\n}\n.ant-col-xs-offset-9 {\n  margin-left: 37.5%;\n}\n.ant-col-xs-order-9 {\n  order: 9;\n}\n.ant-col-xs-8 {\n  display: block;\n  width: 33.33333333%;\n}\n.ant-col-xs-push-8 {\n  left: 33.33333333%;\n}\n.ant-col-xs-pull-8 {\n  right: 33.33333333%;\n}\n.ant-col-xs-offset-8 {\n  margin-left: 33.33333333%;\n}\n.ant-col-xs-order-8 {\n  order: 8;\n}\n.ant-col-xs-7 {\n  display: block;\n  width: 29.16666667%;\n}\n.ant-col-xs-push-7 {\n  left: 29.16666667%;\n}\n.ant-col-xs-pull-7 {\n  right: 29.16666667%;\n}\n.ant-col-xs-offset-7 {\n  margin-left: 29.16666667%;\n}\n.ant-col-xs-order-7 {\n  order: 7;\n}\n.ant-col-xs-6 {\n  display: block;\n  width: 25%;\n}\n.ant-col-xs-push-6 {\n  left: 25%;\n}\n.ant-col-xs-pull-6 {\n  right: 25%;\n}\n.ant-col-xs-offset-6 {\n  margin-left: 25%;\n}\n.ant-col-xs-order-6 {\n  order: 6;\n}\n.ant-col-xs-5 {\n  display: block;\n  width: 20.83333333%;\n}\n.ant-col-xs-push-5 {\n  left: 20.83333333%;\n}\n.ant-col-xs-pull-5 {\n  right: 20.83333333%;\n}\n.ant-col-xs-offset-5 {\n  margin-left: 20.83333333%;\n}\n.ant-col-xs-order-5 {\n  order: 5;\n}\n.ant-col-xs-4 {\n  display: block;\n  width: 16.66666667%;\n}\n.ant-col-xs-push-4 {\n  left: 16.66666667%;\n}\n.ant-col-xs-pull-4 {\n  right: 16.66666667%;\n}\n.ant-col-xs-offset-4 {\n  margin-left: 16.66666667%;\n}\n.ant-col-xs-order-4 {\n  order: 4;\n}\n.ant-col-xs-3 {\n  display: block;\n  width: 12.5%;\n}\n.ant-col-xs-push-3 {\n  left: 12.5%;\n}\n.ant-col-xs-pull-3 {\n  right: 12.5%;\n}\n.ant-col-xs-offset-3 {\n  margin-left: 12.5%;\n}\n.ant-col-xs-order-3 {\n  order: 3;\n}\n.ant-col-xs-2 {\n  display: block;\n  width: 8.33333333%;\n}\n.ant-col-xs-push-2 {\n  left: 8.33333333%;\n}\n.ant-col-xs-pull-2 {\n  right: 8.33333333%;\n}\n.ant-col-xs-offset-2 {\n  margin-left: 8.33333333%;\n}\n.ant-col-xs-order-2 {\n  order: 2;\n}\n.ant-col-xs-1 {\n  display: block;\n  width: 4.16666667%;\n}\n.ant-col-xs-push-1 {\n  left: 4.16666667%;\n}\n.ant-col-xs-pull-1 {\n  right: 4.16666667%;\n}\n.ant-col-xs-offset-1 {\n  margin-left: 4.16666667%;\n}\n.ant-col-xs-order-1 {\n  order: 1;\n}\n.ant-col-xs-0 {\n  display: none;\n}\n.ant-col-push-0 {\n  left: auto;\n}\n.ant-col-pull-0 {\n  right: auto;\n}\n.ant-col-xs-push-0 {\n  left: auto;\n}\n.ant-col-xs-pull-0 {\n  right: auto;\n}\n.ant-col-xs-offset-0 {\n  margin-left: 0;\n}\n.ant-col-xs-order-0 {\n  order: 0;\n}\n@media (min-width: 768px) {\n  .ant-col-sm-1, .ant-col-sm-2, .ant-col-sm-3, .ant-col-sm-4, .ant-col-sm-5, .ant-col-sm-6, .ant-col-sm-7, .ant-col-sm-8, .ant-col-sm-9, .ant-col-sm-10, .ant-col-sm-11, .ant-col-sm-12, .ant-col-sm-13, .ant-col-sm-14, .ant-col-sm-15, .ant-col-sm-16, .ant-col-sm-17, .ant-col-sm-18, .ant-col-sm-19, .ant-col-sm-20, .ant-col-sm-21, .ant-col-sm-22, .ant-col-sm-23, .ant-col-sm-24 {\n    float: left;\n    flex: 0 0 auto;\n  }\n  .ant-col-sm-24 {\n    display: block;\n    width: 100%;\n  }\n  .ant-col-sm-push-24 {\n    left: 100%;\n  }\n  .ant-col-sm-pull-24 {\n    right: 100%;\n  }\n  .ant-col-sm-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-sm-order-24 {\n    order: 24;\n  }\n  .ant-col-sm-23 {\n    display: block;\n    width: 95.83333333%;\n  }\n  .ant-col-sm-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-sm-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-sm-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-sm-order-23 {\n    order: 23;\n  }\n  .ant-col-sm-22 {\n    display: block;\n    width: 91.66666667%;\n  }\n  .ant-col-sm-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-sm-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-sm-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-sm-order-22 {\n    order: 22;\n  }\n  .ant-col-sm-21 {\n    display: block;\n    width: 87.5%;\n  }\n  .ant-col-sm-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-sm-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-sm-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-sm-order-21 {\n    order: 21;\n  }\n  .ant-col-sm-20 {\n    display: block;\n    width: 83.33333333%;\n  }\n  .ant-col-sm-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-sm-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-sm-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-sm-order-20 {\n    order: 20;\n  }\n  .ant-col-sm-19 {\n    display: block;\n    width: 79.16666667%;\n  }\n  .ant-col-sm-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-sm-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-sm-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-sm-order-19 {\n    order: 19;\n  }\n  .ant-col-sm-18 {\n    display: block;\n    width: 75%;\n  }\n  .ant-col-sm-push-18 {\n    left: 75%;\n  }\n  .ant-col-sm-pull-18 {\n    right: 75%;\n  }\n  .ant-col-sm-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-sm-order-18 {\n    order: 18;\n  }\n  .ant-col-sm-17 {\n    display: block;\n    width: 70.83333333%;\n  }\n  .ant-col-sm-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-sm-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-sm-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-sm-order-17 {\n    order: 17;\n  }\n  .ant-col-sm-16 {\n    display: block;\n    width: 66.66666667%;\n  }\n  .ant-col-sm-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-sm-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-sm-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-sm-order-16 {\n    order: 16;\n  }\n  .ant-col-sm-15 {\n    display: block;\n    width: 62.5%;\n  }\n  .ant-col-sm-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-sm-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-sm-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-sm-order-15 {\n    order: 15;\n  }\n  .ant-col-sm-14 {\n    display: block;\n    width: 58.33333333%;\n  }\n  .ant-col-sm-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-sm-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-sm-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-sm-order-14 {\n    order: 14;\n  }\n  .ant-col-sm-13 {\n    display: block;\n    width: 54.16666667%;\n  }\n  .ant-col-sm-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-sm-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-sm-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-sm-order-13 {\n    order: 13;\n  }\n  .ant-col-sm-12 {\n    display: block;\n    width: 50%;\n  }\n  .ant-col-sm-push-12 {\n    left: 50%;\n  }\n  .ant-col-sm-pull-12 {\n    right: 50%;\n  }\n  .ant-col-sm-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-sm-order-12 {\n    order: 12;\n  }\n  .ant-col-sm-11 {\n    display: block;\n    width: 45.83333333%;\n  }\n  .ant-col-sm-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-sm-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-sm-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-sm-order-11 {\n    order: 11;\n  }\n  .ant-col-sm-10 {\n    display: block;\n    width: 41.66666667%;\n  }\n  .ant-col-sm-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-sm-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-sm-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-sm-order-10 {\n    order: 10;\n  }\n  .ant-col-sm-9 {\n    display: block;\n    width: 37.5%;\n  }\n  .ant-col-sm-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-sm-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-sm-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-sm-order-9 {\n    order: 9;\n  }\n  .ant-col-sm-8 {\n    display: block;\n    width: 33.33333333%;\n  }\n  .ant-col-sm-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-sm-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-sm-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-sm-order-8 {\n    order: 8;\n  }\n  .ant-col-sm-7 {\n    display: block;\n    width: 29.16666667%;\n  }\n  .ant-col-sm-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-sm-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-sm-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-sm-order-7 {\n    order: 7;\n  }\n  .ant-col-sm-6 {\n    display: block;\n    width: 25%;\n  }\n  .ant-col-sm-push-6 {\n    left: 25%;\n  }\n  .ant-col-sm-pull-6 {\n    right: 25%;\n  }\n  .ant-col-sm-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-sm-order-6 {\n    order: 6;\n  }\n  .ant-col-sm-5 {\n    display: block;\n    width: 20.83333333%;\n  }\n  .ant-col-sm-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-sm-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-sm-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-sm-order-5 {\n    order: 5;\n  }\n  .ant-col-sm-4 {\n    display: block;\n    width: 16.66666667%;\n  }\n  .ant-col-sm-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-sm-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-sm-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-sm-order-4 {\n    order: 4;\n  }\n  .ant-col-sm-3 {\n    display: block;\n    width: 12.5%;\n  }\n  .ant-col-sm-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-sm-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-sm-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-sm-order-3 {\n    order: 3;\n  }\n  .ant-col-sm-2 {\n    display: block;\n    width: 8.33333333%;\n  }\n  .ant-col-sm-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-sm-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-sm-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-sm-order-2 {\n    order: 2;\n  }\n  .ant-col-sm-1 {\n    display: block;\n    width: 4.16666667%;\n  }\n  .ant-col-sm-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-sm-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-sm-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-sm-order-1 {\n    order: 1;\n  }\n  .ant-col-sm-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-sm-push-0 {\n    left: auto;\n  }\n  .ant-col-sm-pull-0 {\n    right: auto;\n  }\n  .ant-col-sm-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-sm-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 992px) {\n  .ant-col-md-1, .ant-col-md-2, .ant-col-md-3, .ant-col-md-4, .ant-col-md-5, .ant-col-md-6, .ant-col-md-7, .ant-col-md-8, .ant-col-md-9, .ant-col-md-10, .ant-col-md-11, .ant-col-md-12, .ant-col-md-13, .ant-col-md-14, .ant-col-md-15, .ant-col-md-16, .ant-col-md-17, .ant-col-md-18, .ant-col-md-19, .ant-col-md-20, .ant-col-md-21, .ant-col-md-22, .ant-col-md-23, .ant-col-md-24 {\n    float: left;\n    flex: 0 0 auto;\n  }\n  .ant-col-md-24 {\n    display: block;\n    width: 100%;\n  }\n  .ant-col-md-push-24 {\n    left: 100%;\n  }\n  .ant-col-md-pull-24 {\n    right: 100%;\n  }\n  .ant-col-md-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-md-order-24 {\n    order: 24;\n  }\n  .ant-col-md-23 {\n    display: block;\n    width: 95.83333333%;\n  }\n  .ant-col-md-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-md-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-md-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-md-order-23 {\n    order: 23;\n  }\n  .ant-col-md-22 {\n    display: block;\n    width: 91.66666667%;\n  }\n  .ant-col-md-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-md-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-md-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-md-order-22 {\n    order: 22;\n  }\n  .ant-col-md-21 {\n    display: block;\n    width: 87.5%;\n  }\n  .ant-col-md-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-md-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-md-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-md-order-21 {\n    order: 21;\n  }\n  .ant-col-md-20 {\n    display: block;\n    width: 83.33333333%;\n  }\n  .ant-col-md-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-md-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-md-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-md-order-20 {\n    order: 20;\n  }\n  .ant-col-md-19 {\n    display: block;\n    width: 79.16666667%;\n  }\n  .ant-col-md-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-md-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-md-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-md-order-19 {\n    order: 19;\n  }\n  .ant-col-md-18 {\n    display: block;\n    width: 75%;\n  }\n  .ant-col-md-push-18 {\n    left: 75%;\n  }\n  .ant-col-md-pull-18 {\n    right: 75%;\n  }\n  .ant-col-md-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-md-order-18 {\n    order: 18;\n  }\n  .ant-col-md-17 {\n    display: block;\n    width: 70.83333333%;\n  }\n  .ant-col-md-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-md-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-md-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-md-order-17 {\n    order: 17;\n  }\n  .ant-col-md-16 {\n    display: block;\n    width: 66.66666667%;\n  }\n  .ant-col-md-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-md-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-md-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-md-order-16 {\n    order: 16;\n  }\n  .ant-col-md-15 {\n    display: block;\n    width: 62.5%;\n  }\n  .ant-col-md-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-md-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-md-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-md-order-15 {\n    order: 15;\n  }\n  .ant-col-md-14 {\n    display: block;\n    width: 58.33333333%;\n  }\n  .ant-col-md-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-md-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-md-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-md-order-14 {\n    order: 14;\n  }\n  .ant-col-md-13 {\n    display: block;\n    width: 54.16666667%;\n  }\n  .ant-col-md-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-md-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-md-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-md-order-13 {\n    order: 13;\n  }\n  .ant-col-md-12 {\n    display: block;\n    width: 50%;\n  }\n  .ant-col-md-push-12 {\n    left: 50%;\n  }\n  .ant-col-md-pull-12 {\n    right: 50%;\n  }\n  .ant-col-md-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-md-order-12 {\n    order: 12;\n  }\n  .ant-col-md-11 {\n    display: block;\n    width: 45.83333333%;\n  }\n  .ant-col-md-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-md-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-md-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-md-order-11 {\n    order: 11;\n  }\n  .ant-col-md-10 {\n    display: block;\n    width: 41.66666667%;\n  }\n  .ant-col-md-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-md-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-md-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-md-order-10 {\n    order: 10;\n  }\n  .ant-col-md-9 {\n    display: block;\n    width: 37.5%;\n  }\n  .ant-col-md-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-md-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-md-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-md-order-9 {\n    order: 9;\n  }\n  .ant-col-md-8 {\n    display: block;\n    width: 33.33333333%;\n  }\n  .ant-col-md-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-md-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-md-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-md-order-8 {\n    order: 8;\n  }\n  .ant-col-md-7 {\n    display: block;\n    width: 29.16666667%;\n  }\n  .ant-col-md-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-md-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-md-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-md-order-7 {\n    order: 7;\n  }\n  .ant-col-md-6 {\n    display: block;\n    width: 25%;\n  }\n  .ant-col-md-push-6 {\n    left: 25%;\n  }\n  .ant-col-md-pull-6 {\n    right: 25%;\n  }\n  .ant-col-md-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-md-order-6 {\n    order: 6;\n  }\n  .ant-col-md-5 {\n    display: block;\n    width: 20.83333333%;\n  }\n  .ant-col-md-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-md-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-md-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-md-order-5 {\n    order: 5;\n  }\n  .ant-col-md-4 {\n    display: block;\n    width: 16.66666667%;\n  }\n  .ant-col-md-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-md-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-md-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-md-order-4 {\n    order: 4;\n  }\n  .ant-col-md-3 {\n    display: block;\n    width: 12.5%;\n  }\n  .ant-col-md-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-md-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-md-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-md-order-3 {\n    order: 3;\n  }\n  .ant-col-md-2 {\n    display: block;\n    width: 8.33333333%;\n  }\n  .ant-col-md-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-md-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-md-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-md-order-2 {\n    order: 2;\n  }\n  .ant-col-md-1 {\n    display: block;\n    width: 4.16666667%;\n  }\n  .ant-col-md-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-md-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-md-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-md-order-1 {\n    order: 1;\n  }\n  .ant-col-md-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-md-push-0 {\n    left: auto;\n  }\n  .ant-col-md-pull-0 {\n    right: auto;\n  }\n  .ant-col-md-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-md-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .ant-col-lg-1, .ant-col-lg-2, .ant-col-lg-3, .ant-col-lg-4, .ant-col-lg-5, .ant-col-lg-6, .ant-col-lg-7, .ant-col-lg-8, .ant-col-lg-9, .ant-col-lg-10, .ant-col-lg-11, .ant-col-lg-12, .ant-col-lg-13, .ant-col-lg-14, .ant-col-lg-15, .ant-col-lg-16, .ant-col-lg-17, .ant-col-lg-18, .ant-col-lg-19, .ant-col-lg-20, .ant-col-lg-21, .ant-col-lg-22, .ant-col-lg-23, .ant-col-lg-24 {\n    float: left;\n    flex: 0 0 auto;\n  }\n  .ant-col-lg-24 {\n    display: block;\n    width: 100%;\n  }\n  .ant-col-lg-push-24 {\n    left: 100%;\n  }\n  .ant-col-lg-pull-24 {\n    right: 100%;\n  }\n  .ant-col-lg-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-lg-order-24 {\n    order: 24;\n  }\n  .ant-col-lg-23 {\n    display: block;\n    width: 95.83333333%;\n  }\n  .ant-col-lg-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-lg-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-lg-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-lg-order-23 {\n    order: 23;\n  }\n  .ant-col-lg-22 {\n    display: block;\n    width: 91.66666667%;\n  }\n  .ant-col-lg-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-lg-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-lg-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-lg-order-22 {\n    order: 22;\n  }\n  .ant-col-lg-21 {\n    display: block;\n    width: 87.5%;\n  }\n  .ant-col-lg-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-lg-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-lg-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-lg-order-21 {\n    order: 21;\n  }\n  .ant-col-lg-20 {\n    display: block;\n    width: 83.33333333%;\n  }\n  .ant-col-lg-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-lg-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-lg-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-lg-order-20 {\n    order: 20;\n  }\n  .ant-col-lg-19 {\n    display: block;\n    width: 79.16666667%;\n  }\n  .ant-col-lg-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-lg-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-lg-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-lg-order-19 {\n    order: 19;\n  }\n  .ant-col-lg-18 {\n    display: block;\n    width: 75%;\n  }\n  .ant-col-lg-push-18 {\n    left: 75%;\n  }\n  .ant-col-lg-pull-18 {\n    right: 75%;\n  }\n  .ant-col-lg-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-lg-order-18 {\n    order: 18;\n  }\n  .ant-col-lg-17 {\n    display: block;\n    width: 70.83333333%;\n  }\n  .ant-col-lg-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-lg-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-lg-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-lg-order-17 {\n    order: 17;\n  }\n  .ant-col-lg-16 {\n    display: block;\n    width: 66.66666667%;\n  }\n  .ant-col-lg-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-lg-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-lg-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-lg-order-16 {\n    order: 16;\n  }\n  .ant-col-lg-15 {\n    display: block;\n    width: 62.5%;\n  }\n  .ant-col-lg-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-lg-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-lg-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-lg-order-15 {\n    order: 15;\n  }\n  .ant-col-lg-14 {\n    display: block;\n    width: 58.33333333%;\n  }\n  .ant-col-lg-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-lg-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-lg-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-lg-order-14 {\n    order: 14;\n  }\n  .ant-col-lg-13 {\n    display: block;\n    width: 54.16666667%;\n  }\n  .ant-col-lg-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-lg-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-lg-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-lg-order-13 {\n    order: 13;\n  }\n  .ant-col-lg-12 {\n    display: block;\n    width: 50%;\n  }\n  .ant-col-lg-push-12 {\n    left: 50%;\n  }\n  .ant-col-lg-pull-12 {\n    right: 50%;\n  }\n  .ant-col-lg-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-lg-order-12 {\n    order: 12;\n  }\n  .ant-col-lg-11 {\n    display: block;\n    width: 45.83333333%;\n  }\n  .ant-col-lg-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-lg-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-lg-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-lg-order-11 {\n    order: 11;\n  }\n  .ant-col-lg-10 {\n    display: block;\n    width: 41.66666667%;\n  }\n  .ant-col-lg-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-lg-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-lg-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-lg-order-10 {\n    order: 10;\n  }\n  .ant-col-lg-9 {\n    display: block;\n    width: 37.5%;\n  }\n  .ant-col-lg-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-lg-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-lg-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-lg-order-9 {\n    order: 9;\n  }\n  .ant-col-lg-8 {\n    display: block;\n    width: 33.33333333%;\n  }\n  .ant-col-lg-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-lg-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-lg-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-lg-order-8 {\n    order: 8;\n  }\n  .ant-col-lg-7 {\n    display: block;\n    width: 29.16666667%;\n  }\n  .ant-col-lg-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-lg-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-lg-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-lg-order-7 {\n    order: 7;\n  }\n  .ant-col-lg-6 {\n    display: block;\n    width: 25%;\n  }\n  .ant-col-lg-push-6 {\n    left: 25%;\n  }\n  .ant-col-lg-pull-6 {\n    right: 25%;\n  }\n  .ant-col-lg-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-lg-order-6 {\n    order: 6;\n  }\n  .ant-col-lg-5 {\n    display: block;\n    width: 20.83333333%;\n  }\n  .ant-col-lg-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-lg-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-lg-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-lg-order-5 {\n    order: 5;\n  }\n  .ant-col-lg-4 {\n    display: block;\n    width: 16.66666667%;\n  }\n  .ant-col-lg-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-lg-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-lg-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-lg-order-4 {\n    order: 4;\n  }\n  .ant-col-lg-3 {\n    display: block;\n    width: 12.5%;\n  }\n  .ant-col-lg-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-lg-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-lg-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-lg-order-3 {\n    order: 3;\n  }\n  .ant-col-lg-2 {\n    display: block;\n    width: 8.33333333%;\n  }\n  .ant-col-lg-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-lg-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-lg-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-lg-order-2 {\n    order: 2;\n  }\n  .ant-col-lg-1 {\n    display: block;\n    width: 4.16666667%;\n  }\n  .ant-col-lg-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-lg-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-lg-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-lg-order-1 {\n    order: 1;\n  }\n  .ant-col-lg-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-lg-push-0 {\n    left: auto;\n  }\n  .ant-col-lg-pull-0 {\n    right: auto;\n  }\n  .ant-col-lg-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-lg-order-0 {\n    order: 0;\n  }\n}\n@media (min-width: 1600px) {\n  .ant-col-xl-1, .ant-col-xl-2, .ant-col-xl-3, .ant-col-xl-4, .ant-col-xl-5, .ant-col-xl-6, .ant-col-xl-7, .ant-col-xl-8, .ant-col-xl-9, .ant-col-xl-10, .ant-col-xl-11, .ant-col-xl-12, .ant-col-xl-13, .ant-col-xl-14, .ant-col-xl-15, .ant-col-xl-16, .ant-col-xl-17, .ant-col-xl-18, .ant-col-xl-19, .ant-col-xl-20, .ant-col-xl-21, .ant-col-xl-22, .ant-col-xl-23, .ant-col-xl-24 {\n    float: left;\n    flex: 0 0 auto;\n  }\n  .ant-col-xl-24 {\n    display: block;\n    width: 100%;\n  }\n  .ant-col-xl-push-24 {\n    left: 100%;\n  }\n  .ant-col-xl-pull-24 {\n    right: 100%;\n  }\n  .ant-col-xl-offset-24 {\n    margin-left: 100%;\n  }\n  .ant-col-xl-order-24 {\n    order: 24;\n  }\n  .ant-col-xl-23 {\n    display: block;\n    width: 95.83333333%;\n  }\n  .ant-col-xl-push-23 {\n    left: 95.83333333%;\n  }\n  .ant-col-xl-pull-23 {\n    right: 95.83333333%;\n  }\n  .ant-col-xl-offset-23 {\n    margin-left: 95.83333333%;\n  }\n  .ant-col-xl-order-23 {\n    order: 23;\n  }\n  .ant-col-xl-22 {\n    display: block;\n    width: 91.66666667%;\n  }\n  .ant-col-xl-push-22 {\n    left: 91.66666667%;\n  }\n  .ant-col-xl-pull-22 {\n    right: 91.66666667%;\n  }\n  .ant-col-xl-offset-22 {\n    margin-left: 91.66666667%;\n  }\n  .ant-col-xl-order-22 {\n    order: 22;\n  }\n  .ant-col-xl-21 {\n    display: block;\n    width: 87.5%;\n  }\n  .ant-col-xl-push-21 {\n    left: 87.5%;\n  }\n  .ant-col-xl-pull-21 {\n    right: 87.5%;\n  }\n  .ant-col-xl-offset-21 {\n    margin-left: 87.5%;\n  }\n  .ant-col-xl-order-21 {\n    order: 21;\n  }\n  .ant-col-xl-20 {\n    display: block;\n    width: 83.33333333%;\n  }\n  .ant-col-xl-push-20 {\n    left: 83.33333333%;\n  }\n  .ant-col-xl-pull-20 {\n    right: 83.33333333%;\n  }\n  .ant-col-xl-offset-20 {\n    margin-left: 83.33333333%;\n  }\n  .ant-col-xl-order-20 {\n    order: 20;\n  }\n  .ant-col-xl-19 {\n    display: block;\n    width: 79.16666667%;\n  }\n  .ant-col-xl-push-19 {\n    left: 79.16666667%;\n  }\n  .ant-col-xl-pull-19 {\n    right: 79.16666667%;\n  }\n  .ant-col-xl-offset-19 {\n    margin-left: 79.16666667%;\n  }\n  .ant-col-xl-order-19 {\n    order: 19;\n  }\n  .ant-col-xl-18 {\n    display: block;\n    width: 75%;\n  }\n  .ant-col-xl-push-18 {\n    left: 75%;\n  }\n  .ant-col-xl-pull-18 {\n    right: 75%;\n  }\n  .ant-col-xl-offset-18 {\n    margin-left: 75%;\n  }\n  .ant-col-xl-order-18 {\n    order: 18;\n  }\n  .ant-col-xl-17 {\n    display: block;\n    width: 70.83333333%;\n  }\n  .ant-col-xl-push-17 {\n    left: 70.83333333%;\n  }\n  .ant-col-xl-pull-17 {\n    right: 70.83333333%;\n  }\n  .ant-col-xl-offset-17 {\n    margin-left: 70.83333333%;\n  }\n  .ant-col-xl-order-17 {\n    order: 17;\n  }\n  .ant-col-xl-16 {\n    display: block;\n    width: 66.66666667%;\n  }\n  .ant-col-xl-push-16 {\n    left: 66.66666667%;\n  }\n  .ant-col-xl-pull-16 {\n    right: 66.66666667%;\n  }\n  .ant-col-xl-offset-16 {\n    margin-left: 66.66666667%;\n  }\n  .ant-col-xl-order-16 {\n    order: 16;\n  }\n  .ant-col-xl-15 {\n    display: block;\n    width: 62.5%;\n  }\n  .ant-col-xl-push-15 {\n    left: 62.5%;\n  }\n  .ant-col-xl-pull-15 {\n    right: 62.5%;\n  }\n  .ant-col-xl-offset-15 {\n    margin-left: 62.5%;\n  }\n  .ant-col-xl-order-15 {\n    order: 15;\n  }\n  .ant-col-xl-14 {\n    display: block;\n    width: 58.33333333%;\n  }\n  .ant-col-xl-push-14 {\n    left: 58.33333333%;\n  }\n  .ant-col-xl-pull-14 {\n    right: 58.33333333%;\n  }\n  .ant-col-xl-offset-14 {\n    margin-left: 58.33333333%;\n  }\n  .ant-col-xl-order-14 {\n    order: 14;\n  }\n  .ant-col-xl-13 {\n    display: block;\n    width: 54.16666667%;\n  }\n  .ant-col-xl-push-13 {\n    left: 54.16666667%;\n  }\n  .ant-col-xl-pull-13 {\n    right: 54.16666667%;\n  }\n  .ant-col-xl-offset-13 {\n    margin-left: 54.16666667%;\n  }\n  .ant-col-xl-order-13 {\n    order: 13;\n  }\n  .ant-col-xl-12 {\n    display: block;\n    width: 50%;\n  }\n  .ant-col-xl-push-12 {\n    left: 50%;\n  }\n  .ant-col-xl-pull-12 {\n    right: 50%;\n  }\n  .ant-col-xl-offset-12 {\n    margin-left: 50%;\n  }\n  .ant-col-xl-order-12 {\n    order: 12;\n  }\n  .ant-col-xl-11 {\n    display: block;\n    width: 45.83333333%;\n  }\n  .ant-col-xl-push-11 {\n    left: 45.83333333%;\n  }\n  .ant-col-xl-pull-11 {\n    right: 45.83333333%;\n  }\n  .ant-col-xl-offset-11 {\n    margin-left: 45.83333333%;\n  }\n  .ant-col-xl-order-11 {\n    order: 11;\n  }\n  .ant-col-xl-10 {\n    display: block;\n    width: 41.66666667%;\n  }\n  .ant-col-xl-push-10 {\n    left: 41.66666667%;\n  }\n  .ant-col-xl-pull-10 {\n    right: 41.66666667%;\n  }\n  .ant-col-xl-offset-10 {\n    margin-left: 41.66666667%;\n  }\n  .ant-col-xl-order-10 {\n    order: 10;\n  }\n  .ant-col-xl-9 {\n    display: block;\n    width: 37.5%;\n  }\n  .ant-col-xl-push-9 {\n    left: 37.5%;\n  }\n  .ant-col-xl-pull-9 {\n    right: 37.5%;\n  }\n  .ant-col-xl-offset-9 {\n    margin-left: 37.5%;\n  }\n  .ant-col-xl-order-9 {\n    order: 9;\n  }\n  .ant-col-xl-8 {\n    display: block;\n    width: 33.33333333%;\n  }\n  .ant-col-xl-push-8 {\n    left: 33.33333333%;\n  }\n  .ant-col-xl-pull-8 {\n    right: 33.33333333%;\n  }\n  .ant-col-xl-offset-8 {\n    margin-left: 33.33333333%;\n  }\n  .ant-col-xl-order-8 {\n    order: 8;\n  }\n  .ant-col-xl-7 {\n    display: block;\n    width: 29.16666667%;\n  }\n  .ant-col-xl-push-7 {\n    left: 29.16666667%;\n  }\n  .ant-col-xl-pull-7 {\n    right: 29.16666667%;\n  }\n  .ant-col-xl-offset-7 {\n    margin-left: 29.16666667%;\n  }\n  .ant-col-xl-order-7 {\n    order: 7;\n  }\n  .ant-col-xl-6 {\n    display: block;\n    width: 25%;\n  }\n  .ant-col-xl-push-6 {\n    left: 25%;\n  }\n  .ant-col-xl-pull-6 {\n    right: 25%;\n  }\n  .ant-col-xl-offset-6 {\n    margin-left: 25%;\n  }\n  .ant-col-xl-order-6 {\n    order: 6;\n  }\n  .ant-col-xl-5 {\n    display: block;\n    width: 20.83333333%;\n  }\n  .ant-col-xl-push-5 {\n    left: 20.83333333%;\n  }\n  .ant-col-xl-pull-5 {\n    right: 20.83333333%;\n  }\n  .ant-col-xl-offset-5 {\n    margin-left: 20.83333333%;\n  }\n  .ant-col-xl-order-5 {\n    order: 5;\n  }\n  .ant-col-xl-4 {\n    display: block;\n    width: 16.66666667%;\n  }\n  .ant-col-xl-push-4 {\n    left: 16.66666667%;\n  }\n  .ant-col-xl-pull-4 {\n    right: 16.66666667%;\n  }\n  .ant-col-xl-offset-4 {\n    margin-left: 16.66666667%;\n  }\n  .ant-col-xl-order-4 {\n    order: 4;\n  }\n  .ant-col-xl-3 {\n    display: block;\n    width: 12.5%;\n  }\n  .ant-col-xl-push-3 {\n    left: 12.5%;\n  }\n  .ant-col-xl-pull-3 {\n    right: 12.5%;\n  }\n  .ant-col-xl-offset-3 {\n    margin-left: 12.5%;\n  }\n  .ant-col-xl-order-3 {\n    order: 3;\n  }\n  .ant-col-xl-2 {\n    display: block;\n    width: 8.33333333%;\n  }\n  .ant-col-xl-push-2 {\n    left: 8.33333333%;\n  }\n  .ant-col-xl-pull-2 {\n    right: 8.33333333%;\n  }\n  .ant-col-xl-offset-2 {\n    margin-left: 8.33333333%;\n  }\n  .ant-col-xl-order-2 {\n    order: 2;\n  }\n  .ant-col-xl-1 {\n    display: block;\n    width: 4.16666667%;\n  }\n  .ant-col-xl-push-1 {\n    left: 4.16666667%;\n  }\n  .ant-col-xl-pull-1 {\n    right: 4.16666667%;\n  }\n  .ant-col-xl-offset-1 {\n    margin-left: 4.16666667%;\n  }\n  .ant-col-xl-order-1 {\n    order: 1;\n  }\n  .ant-col-xl-0 {\n    display: none;\n  }\n  .ant-col-push-0 {\n    left: auto;\n  }\n  .ant-col-pull-0 {\n    right: auto;\n  }\n  .ant-col-xl-push-0 {\n    left: auto;\n  }\n  .ant-col-xl-pull-0 {\n    right: auto;\n  }\n  .ant-col-xl-offset-0 {\n    margin-left: 0;\n  }\n  .ant-col-xl-order-0 {\n    order: 0;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzRowComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzRowComponent.propDecorators = {
    'nzType': [{ type: Input },],
    'nzAlign': [{ type: Input },],
    'nzJustify': [{ type: Input },],
    'nzGutter': [{ type: Input },],
};
/**
 * @abstract
 */
var NzColComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _nzRow
     * @param {?} _renderer
     */
    function NzColComponent(_elementRef, _nzRow, _renderer) {
        this._elementRef = _elementRef;
        this._nzRow = _nzRow;
        this._renderer = _renderer;
        this._classList = [];
        this._prefixCls = 'ant-col';
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzColComponent.prototype, "paddingLeft", {
        /**
         * @return {?}
         */
        get: function () {
            return this._nzRow && this._nzRow._gutter / 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzColComponent.prototype, "paddingRight", {
        /**
         * @return {?}
         */
        get: function () {
            return this._nzRow && this._nzRow._gutter / 2;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * temp solution since no method add classMap to host https://github.com/angular/angular/issues/7289
     * @return {?}
     */
    NzColComponent.prototype.setClassMap = function () {
        var _this = this;
        this._classList.forEach(function (_className) {
            _this._renderer.removeClass(_this._el, _className);
        });
        this._classList = [
            this.nzSpan && this._prefixCls + "-" + this.nzSpan,
            this.nzOrder && this._prefixCls + "-order-" + this.nzOrder,
            this.nzOffset && this._prefixCls + "-offset-" + this.nzOffset,
            this.nzPull && this._prefixCls + "-pull-" + this.nzPull,
            this.nzPush && this._prefixCls + "-push-" + this.nzPush
        ].concat(this.generateClass());
        this._classList = this._classList.filter(function (item) {
            return !!item;
        });
        this._classList.forEach(function (_className) {
            _this._renderer.addClass(_this._el, _className);
        });
    };
    /**
     * @return {?}
     */
    NzColComponent.prototype.generateClass = function () {
        var _this = this;
        var /** @type {?} */ listOfSizeInputName = ['nzXs', 'nzSm', 'nzMd', 'nzLg', 'nzXl'];
        var /** @type {?} */ listOfClassName = [];
        listOfSizeInputName.forEach(function (name) {
            var /** @type {?} */ sizeName = name.replace('nz', '').toLowerCase();
            if ((typeof (_this[name]) === 'number') || (typeof (_this[name]) === 'string')) {
                listOfClassName.push(_this[name] && _this._prefixCls + "-" + sizeName + "-" + _this[name]);
            }
            else {
                listOfClassName.push(_this[name] && _this[name]['span'] && _this._prefixCls + "-" + sizeName + "-" + _this[name]['span']);
                listOfClassName.push(_this[name] && _this[name]['pull'] && _this._prefixCls + "-" + sizeName + "-pull-" + _this[name]['pull']);
                listOfClassName.push(_this[name] && _this[name]['push'] && _this._prefixCls + "-" + sizeName + "-push-" + _this[name]['push']);
                listOfClassName.push(_this[name] && _this[name]['offset'] && _this._prefixCls + "-" + sizeName + "-offset-" + _this[name]['offset']);
                listOfClassName.push(_this[name] && _this[name]['order'] && _this._prefixCls + "-" + sizeName + "-order-" + _this[name]['order']);
            }
        });
        return listOfClassName;
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NzColComponent.prototype.ngOnChanges = function (changes) {
        this.setClassMap();
    };
    /**
     * @return {?}
     */
    NzColComponent.prototype.ngOnInit = function () {
        this.setClassMap();
    };
    return NzColComponent;
}());
NzColComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-col',
                template: "\n    <ng-content></ng-content>\n  ",
                styles: []
            },] },
];
/**
 * @nocollapse
 */
NzColComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: NzRowComponent, decorators: [{ type: Optional }, { type: Host },] },
    { type: Renderer2, },
]; };
NzColComponent.propDecorators = {
    'paddingLeft': [{ type: HostBinding, args: ['style.padding-left.px',] },],
    'paddingRight': [{ type: HostBinding, args: ['style.padding-right.px',] },],
    'nzSpan': [{ type: Input },],
    'nzOrder': [{ type: Input },],
    'nzOffset': [{ type: Input },],
    'nzPush': [{ type: Input },],
    'nzPull': [{ type: Input },],
    'nzXs': [{ type: Input },],
    'nzSm': [{ type: Input },],
    'nzMd': [{ type: Input },],
    'nzLg': [{ type: Input },],
    'nzXl': [{ type: Input },],
};
var NzColDirective = (function (_super) {
    tslib_1.__extends(NzColDirective, _super);
    function NzColDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NzColDirective;
}(NzColComponent));
NzColDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-col]'
            },] },
];
/**
 * @nocollapse
 */
NzColDirective.ctorParameters = function () { return []; };
var NzGridModule = (function () {
    function NzGridModule() {
    }
    return NzGridModule;
}());
NzGridModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzRowComponent, NzColDirective, NzColComponent],
                exports: [NzRowComponent, NzColDirective, NzColComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzGridModule.ctorParameters = function () { return []; };
var NzButtonGroupComponent = (function () {
    function NzButtonGroupComponent() {
        this._prefixCls = 'ant-btn-group';
        this._sizeMap = { large: 'lg', small: 'sm' };
    }
    Object.defineProperty(NzButtonGroupComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._size = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzButtonGroupComponent.prototype, "_classMap", {
        /**
         * @return {?}
         */
        get: function () {
            return _a = {},
                _a[this._prefixCls] = true,
                _a[this._prefixCls + "-" + this._sizeMap[this.nzSize]] = this._sizeMap[this.nzSize],
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    NzButtonGroupComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        /** trim text node between button */
        Array.from(this._groupWrapper.nativeElement.childNodes).forEach(function (node) {
            if (node.nodeType === 3) {
                _this._groupWrapper.nativeElement.removeChild(node);
            }
        });
    };
    return NzButtonGroupComponent;
}());
NzButtonGroupComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-button-group',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div [ngClass]=\"_classMap\" #groupWrapper>\n      <ng-content></ng-content>\n    </div>\n  ",
                styles: []
            },] },
];
/**
 * @nocollapse
 */
NzButtonGroupComponent.ctorParameters = function () { return []; };
NzButtonGroupComponent.propDecorators = {
    '_groupWrapper': [{ type: ViewChild, args: ['groupWrapper',] },],
    'nzSize': [{ type: Input },],
};
var NzButtonComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function NzButtonComponent(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._classList = [];
        this._iconOnly = false;
        this._loading = false;
        this._clicked = false;
        this._ghost = false;
        this._prefixCls = 'ant-btn';
        this._sizeMap = { large: 'lg', small: 'sm' };
        this._el = this._elementRef.nativeElement;
        this.nativeElement = this._elementRef.nativeElement;
        this._renderer.addClass(this._el, this._prefixCls);
    }
    Object.defineProperty(NzButtonComponent.prototype, "nzGhost", {
        /**
         * @return {?}
         */
        get: function () {
            return this._ghost;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._ghost = value;
            this._setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzButtonComponent.prototype, "nzType", {
        /**
         * @return {?}
         */
        get: function () {
            return this._type;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._type = value;
            this._setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzButtonComponent.prototype, "nzShape", {
        /**
         * @return {?}
         */
        get: function () {
            return this._shape;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._shape = value;
            this._setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzButtonComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._size = value;
            this._setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzButtonComponent.prototype, "nzLoading", {
        /**
         * @return {?}
         */
        get: function () {
            return this._loading;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._loading = value;
            this._setClassMap();
            this._setIconDisplay(value);
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * toggle button clicked animation
     * @return {?}
     */
    NzButtonComponent.prototype._onClick = function () {
        var _this = this;
        this._clicked = true;
        this._setClassMap();
        setTimeout(function () {
            _this._clicked = false;
            _this._setClassMap();
        }, 300);
    };
    ;
    /**
     * @param {?} value
     * @return {?}
     */
    NzButtonComponent.prototype._setIconDisplay = function (value) {
        var /** @type {?} */ innerI = this._iconElement;
        if (innerI) {
            this._renderer.setStyle(innerI, 'display', value ? 'none' : 'inline-block');
        }
    };
    /**
     * temp solution since no method add classMap to host https://github.com/angular/angular/issues/7289
     * @return {?}
     */
    NzButtonComponent.prototype._setClassMap = function () {
        var _this = this;
        this._classList.forEach(function (_className) {
            _this._renderer.removeClass(_this._el, _className);
        });
        this._classList = [
            this.nzType && this._prefixCls + "-" + this.nzType,
            this.nzShape && this._prefixCls + "-" + this.nzShape,
            this._sizeMap[this.nzSize] && this._prefixCls + "-" + this._sizeMap[this.nzSize],
            this.nzLoading && this._prefixCls + "-loading",
            this._clicked && this._prefixCls + "-clicked",
            this._iconOnly && this._prefixCls + "-icon-only",
            this.nzGhost && this._prefixCls + "-background-ghost",
        ].filter(function (item) {
            return !!item;
        });
        this._classList.forEach(function (_className) {
            _this._renderer.addClass(_this._el, _className);
        });
    };
    /**
     * @return {?}
     */
    NzButtonComponent.prototype.ngAfterContentInit = function () {
        this._iconElement = this._innerIElement;
        /** check if host children only has i element */
        if (this._iconElement && this._el.children.length === 1 && (this._iconElement.isEqualNode(this._el.children[0]))) {
            this._iconOnly = true;
            this._setClassMap();
        }
        this._setIconDisplay(this.nzLoading);
    };
    Object.defineProperty(NzButtonComponent.prototype, "_innerIElement", {
        /**
         * @return {?}
         */
        get: function () {
            return this._el.querySelector('i');
        },
        enumerable: true,
        configurable: true
    });
    return NzButtonComponent;
}());
NzButtonComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-button]',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <i class=\"anticon anticon-spin anticon-loading\" *ngIf=\"nzLoading\"></i>\n    <ng-content></ng-content>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: 500;\n  text-align: center;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1.15;\n  padding: 0 15px;\n  font-size: 12px;\n  border-radius: 4px;\n  height: 28px;\n  user-select: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  position: relative;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n.ant-btn > .anticon {\n  line-height: 1;\n}\n.ant-btn,\n.ant-btn:active,\n.ant-btn:focus {\n  outline: 0;\n}\n.ant-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-btn:not([disabled]):active {\n  outline: 0;\n  transition: none;\n}\n.ant-btn.disabled,\n.ant-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-btn.disabled > *,\n.ant-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-btn-lg {\n  padding: 0 15px;\n  font-size: 14px;\n  border-radius: 4px;\n  height: 32px;\n}\n.ant-btn-sm {\n  padding: 0 7px;\n  font-size: 12px;\n  border-radius: 4px;\n  height: 22px;\n}\n.ant-btn > a:only-child {\n  color: currentColor;\n}\n.ant-btn > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn:hover,\n.ant-btn:focus {\n  color: #108ee9;\n  background-color: #fff;\n  border-color: #108ee9;\n}\n.ant-btn:hover > a:only-child,\n.ant-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn:hover > a:only-child:after,\n.ant-btn:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn:active,\n.ant-btn.active {\n  color: #0e77ca;\n  background-color: #fff;\n  border-color: #0e77ca;\n}\n.ant-btn:active > a:only-child,\n.ant-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn:active > a:only-child:after,\n.ant-btn.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn.disabled,\n.ant-btn[disabled],\n.ant-btn.disabled:hover,\n.ant-btn[disabled]:hover,\n.ant-btn.disabled:focus,\n.ant-btn[disabled]:focus,\n.ant-btn.disabled:active,\n.ant-btn[disabled]:active,\n.ant-btn.disabled.active,\n.ant-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-btn.disabled > a:only-child,\n.ant-btn[disabled] > a:only-child,\n.ant-btn.disabled:hover > a:only-child,\n.ant-btn[disabled]:hover > a:only-child,\n.ant-btn.disabled:focus > a:only-child,\n.ant-btn[disabled]:focus > a:only-child,\n.ant-btn.disabled:active > a:only-child,\n.ant-btn[disabled]:active > a:only-child,\n.ant-btn.disabled.active > a:only-child,\n.ant-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn.disabled > a:only-child:after,\n.ant-btn[disabled] > a:only-child:after,\n.ant-btn.disabled:hover > a:only-child:after,\n.ant-btn[disabled]:hover > a:only-child:after,\n.ant-btn.disabled:focus > a:only-child:after,\n.ant-btn[disabled]:focus > a:only-child:after,\n.ant-btn.disabled:active > a:only-child:after,\n.ant-btn[disabled]:active > a:only-child:after,\n.ant-btn.disabled.active > a:only-child:after,\n.ant-btn[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn:hover,\n.ant-btn:focus,\n.ant-btn:active,\n.ant-btn.active {\n  background: #fff;\n}\n.ant-btn-primary {\n  color: #fff;\n  background-color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-btn-primary > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus {\n  color: #fff;\n  background-color: #49a9ee;\n  border-color: #49a9ee;\n}\n.ant-btn-primary:hover > a:only-child,\n.ant-btn-primary:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary:hover > a:only-child:after,\n.ant-btn-primary:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-primary:active,\n.ant-btn-primary.active {\n  color: #fff;\n  background-color: #0e77ca;\n  border-color: #0e77ca;\n}\n.ant-btn-primary:active > a:only-child,\n.ant-btn-primary.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary:active > a:only-child:after,\n.ant-btn-primary.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-primary.disabled,\n.ant-btn-primary[disabled],\n.ant-btn-primary.disabled:hover,\n.ant-btn-primary[disabled]:hover,\n.ant-btn-primary.disabled:focus,\n.ant-btn-primary[disabled]:focus,\n.ant-btn-primary.disabled:active,\n.ant-btn-primary[disabled]:active,\n.ant-btn-primary.disabled.active,\n.ant-btn-primary[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-btn-primary.disabled > a:only-child,\n.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-primary.disabled:hover > a:only-child,\n.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-primary.disabled:focus > a:only-child,\n.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-primary.disabled:active > a:only-child,\n.ant-btn-primary[disabled]:active > a:only-child,\n.ant-btn-primary.disabled.active > a:only-child,\n.ant-btn-primary[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-primary.disabled > a:only-child:after,\n.ant-btn-primary[disabled] > a:only-child:after,\n.ant-btn-primary.disabled:hover > a:only-child:after,\n.ant-btn-primary[disabled]:hover > a:only-child:after,\n.ant-btn-primary.disabled:focus > a:only-child:after,\n.ant-btn-primary[disabled]:focus > a:only-child:after,\n.ant-btn-primary.disabled:active > a:only-child:after,\n.ant-btn-primary[disabled]:active > a:only-child:after,\n.ant-btn-primary.disabled.active > a:only-child:after,\n.ant-btn-primary[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {\n  border-right-color: #0e77ca;\n  border-left-color: #0e77ca;\n}\n.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {\n  border-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {\n  border-right-color: #0e77ca;\n}\n.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {\n  border-right-color: #d9d9d9;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child),\n.ant-btn-group .ant-btn-primary + .ant-btn-primary {\n  border-left-color: #0e77ca;\n}\n.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],\n.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {\n  border-left-color: #d9d9d9;\n}\n.ant-btn-ghost {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: transparent;\n  border-color: #d9d9d9;\n}\n.ant-btn-ghost > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-ghost:hover,\n.ant-btn-ghost:focus {\n  color: #108ee9;\n  background-color: transparent;\n  border-color: #108ee9;\n}\n.ant-btn-ghost:hover > a:only-child,\n.ant-btn-ghost:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost:hover > a:only-child:after,\n.ant-btn-ghost:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-ghost:active,\n.ant-btn-ghost.active {\n  color: #0e77ca;\n  background-color: transparent;\n  border-color: #0e77ca;\n}\n.ant-btn-ghost:active > a:only-child,\n.ant-btn-ghost.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost:active > a:only-child:after,\n.ant-btn-ghost.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-ghost.disabled,\n.ant-btn-ghost[disabled],\n.ant-btn-ghost.disabled:hover,\n.ant-btn-ghost[disabled]:hover,\n.ant-btn-ghost.disabled:focus,\n.ant-btn-ghost[disabled]:focus,\n.ant-btn-ghost.disabled:active,\n.ant-btn-ghost[disabled]:active,\n.ant-btn-ghost.disabled.active,\n.ant-btn-ghost[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-btn-ghost.disabled > a:only-child,\n.ant-btn-ghost[disabled] > a:only-child,\n.ant-btn-ghost.disabled:hover > a:only-child,\n.ant-btn-ghost[disabled]:hover > a:only-child,\n.ant-btn-ghost.disabled:focus > a:only-child,\n.ant-btn-ghost[disabled]:focus > a:only-child,\n.ant-btn-ghost.disabled:active > a:only-child,\n.ant-btn-ghost[disabled]:active > a:only-child,\n.ant-btn-ghost.disabled.active > a:only-child,\n.ant-btn-ghost[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-ghost.disabled > a:only-child:after,\n.ant-btn-ghost[disabled] > a:only-child:after,\n.ant-btn-ghost.disabled:hover > a:only-child:after,\n.ant-btn-ghost[disabled]:hover > a:only-child:after,\n.ant-btn-ghost.disabled:focus > a:only-child:after,\n.ant-btn-ghost[disabled]:focus > a:only-child:after,\n.ant-btn-ghost.disabled:active > a:only-child:after,\n.ant-btn-ghost[disabled]:active > a:only-child:after,\n.ant-btn-ghost.disabled.active > a:only-child:after,\n.ant-btn-ghost[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-dashed {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-style: dashed;\n}\n.ant-btn-dashed > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-dashed:hover,\n.ant-btn-dashed:focus {\n  color: #108ee9;\n  background-color: #fff;\n  border-color: #108ee9;\n}\n.ant-btn-dashed:hover > a:only-child,\n.ant-btn-dashed:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed:hover > a:only-child:after,\n.ant-btn-dashed:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-dashed:active,\n.ant-btn-dashed.active {\n  color: #0e77ca;\n  background-color: #fff;\n  border-color: #0e77ca;\n}\n.ant-btn-dashed:active > a:only-child,\n.ant-btn-dashed.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed:active > a:only-child:after,\n.ant-btn-dashed.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-dashed.disabled,\n.ant-btn-dashed[disabled],\n.ant-btn-dashed.disabled:hover,\n.ant-btn-dashed[disabled]:hover,\n.ant-btn-dashed.disabled:focus,\n.ant-btn-dashed[disabled]:focus,\n.ant-btn-dashed.disabled:active,\n.ant-btn-dashed[disabled]:active,\n.ant-btn-dashed.disabled.active,\n.ant-btn-dashed[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-btn-dashed.disabled > a:only-child,\n.ant-btn-dashed[disabled] > a:only-child,\n.ant-btn-dashed.disabled:hover > a:only-child,\n.ant-btn-dashed[disabled]:hover > a:only-child,\n.ant-btn-dashed.disabled:focus > a:only-child,\n.ant-btn-dashed[disabled]:focus > a:only-child,\n.ant-btn-dashed.disabled:active > a:only-child,\n.ant-btn-dashed[disabled]:active > a:only-child,\n.ant-btn-dashed.disabled.active > a:only-child,\n.ant-btn-dashed[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-dashed.disabled > a:only-child:after,\n.ant-btn-dashed[disabled] > a:only-child:after,\n.ant-btn-dashed.disabled:hover > a:only-child:after,\n.ant-btn-dashed[disabled]:hover > a:only-child:after,\n.ant-btn-dashed.disabled:focus > a:only-child:after,\n.ant-btn-dashed[disabled]:focus > a:only-child:after,\n.ant-btn-dashed.disabled:active > a:only-child:after,\n.ant-btn-dashed[disabled]:active > a:only-child:after,\n.ant-btn-dashed.disabled.active > a:only-child:after,\n.ant-btn-dashed[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-danger {\n  color: #f04134;\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-btn-danger > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-danger:hover,\n.ant-btn-danger:focus {\n  color: #fff;\n  background-color: #f04134;\n  border-color: #f04134;\n}\n.ant-btn-danger:hover > a:only-child,\n.ant-btn-danger:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger:hover > a:only-child:after,\n.ant-btn-danger:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-danger:active,\n.ant-btn-danger.active {\n  color: #fff;\n  background-color: #d73435;\n  border-color: #d73435;\n}\n.ant-btn-danger:active > a:only-child,\n.ant-btn-danger.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger:active > a:only-child:after,\n.ant-btn-danger.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-danger.disabled,\n.ant-btn-danger[disabled],\n.ant-btn-danger.disabled:hover,\n.ant-btn-danger[disabled]:hover,\n.ant-btn-danger.disabled:focus,\n.ant-btn-danger[disabled]:focus,\n.ant-btn-danger.disabled:active,\n.ant-btn-danger[disabled]:active,\n.ant-btn-danger.disabled.active,\n.ant-btn-danger[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-btn-danger.disabled > a:only-child,\n.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-danger.disabled:hover > a:only-child,\n.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-danger.disabled:focus > a:only-child,\n.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-danger.disabled:active > a:only-child,\n.ant-btn-danger[disabled]:active > a:only-child,\n.ant-btn-danger.disabled.active > a:only-child,\n.ant-btn-danger[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-danger.disabled > a:only-child:after,\n.ant-btn-danger[disabled] > a:only-child:after,\n.ant-btn-danger.disabled:hover > a:only-child:after,\n.ant-btn-danger[disabled]:hover > a:only-child:after,\n.ant-btn-danger.disabled:focus > a:only-child:after,\n.ant-btn-danger[disabled]:focus > a:only-child:after,\n.ant-btn-danger.disabled:active > a:only-child:after,\n.ant-btn-danger[disabled]:active > a:only-child:after,\n.ant-btn-danger.disabled.active > a:only-child:after,\n.ant-btn-danger[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-circle,\n.ant-btn-circle-outline {\n  width: 28px;\n  padding: 0;\n  font-size: 14px;\n  border-radius: 50%;\n  height: 28px;\n}\n.ant-btn-circle.ant-btn-lg,\n.ant-btn-circle-outline.ant-btn-lg {\n  width: 32px;\n  padding: 0;\n  font-size: 16px;\n  border-radius: 50%;\n  height: 32px;\n}\n.ant-btn-circle.ant-btn-sm,\n.ant-btn-circle-outline.ant-btn-sm {\n  width: 22px;\n  padding: 0;\n  font-size: 12px;\n  border-radius: 50%;\n  height: 22px;\n}\n.ant-btn:before {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  bottom: -1px;\n  right: -1px;\n  background: #fff;\n  opacity: 0.35;\n  content: '';\n  border-radius: inherit;\n  z-index: 1;\n  transition: opacity .2s;\n  pointer-events: none;\n  display: none;\n}\n.ant-btn .anticon {\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-btn.ant-btn-loading:before {\n  display: block;\n}\n.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {\n  padding-left: 29px;\n  pointer-events: none;\n  position: relative;\n}\n.ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) .anticon {\n  margin-left: -14px;\n}\n.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {\n  padding-left: 24px;\n}\n.ant-btn-sm.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) .anticon {\n  margin-left: -17px;\n}\n.ant-btn-group {\n  position: relative;\n  display: inline-block;\n}\n.ant-btn-group > .ant-btn {\n  position: relative;\n  z-index: 1;\n}\n.ant-btn-group > .ant-btn:hover,\n.ant-btn-group > .ant-btn:focus,\n.ant-btn-group > .ant-btn:active,\n.ant-btn-group > .ant-btn.active {\n  z-index: 2;\n}\n.ant-btn-group > .ant-btn:disabled {\n  z-index: 0;\n}\n.ant-btn-group-lg > .ant-btn {\n  padding: 0 15px;\n  font-size: 14px;\n  border-radius: 4px;\n  height: 32px;\n}\n.ant-btn-group-sm > .ant-btn {\n  padding: 0 7px;\n  font-size: 12px;\n  border-radius: 4px;\n  height: 22px;\n}\n.ant-btn-group-sm > .ant-btn > .anticon {\n  font-size: 12px;\n}\n.ant-btn-group .ant-btn + .ant-btn,\n.ant-btn + .ant-btn-group,\n.ant-btn-group + .ant-btn,\n.ant-btn-group + .ant-btn-group {\n  margin-left: -1px;\n}\n.ant-btn-group .ant-btn:not(:first-child):not(:last-child) {\n  border-radius: 0;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-btn-group > .ant-btn:first-child {\n  margin-left: 0;\n}\n.ant-btn-group > .ant-btn:first-child:not(:last-child) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  padding-right: 8px;\n}\n.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  padding-left: 8px;\n}\n.ant-btn-group > .ant-btn-group {\n  float: left;\n}\n.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {\n  border-radius: 0;\n}\n.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  padding-right: 8px;\n}\n.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  padding-left: 8px;\n}\n.ant-btn:not(.ant-btn-circle):not(.ant-btn-circle-outline).ant-btn-icon-only {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-btn:focus > span,\n.ant-btn:active > span {\n  position: relative;\n}\n.ant-btn > .anticon + span,\n.ant-btn > span + .anticon {\n  margin-left: 0.5em;\n}\n.ant-btn-clicked:after {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  bottom: -1px;\n  right: -1px;\n  border-radius: inherit;\n  border: 0 solid #108ee9;\n  opacity: 0.4;\n  animation: buttonEffect .4s;\n  display: block;\n}\n.ant-btn-danger.ant-btn-clicked:after {\n  border-color: #f04134;\n}\n.ant-btn-background-ghost {\n  background: transparent !important;\n  border-color: #fff;\n  color: #fff;\n}\n.ant-btn-background-ghost.ant-btn-primary {\n  color: #108ee9;\n  background-color: transparent;\n  border-color: #108ee9;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover,\n.ant-btn-background-ghost.ant-btn-primary:focus {\n  color: #49a9ee;\n  background-color: transparent;\n  border-color: #49a9ee;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-background-ghost.ant-btn-primary:active,\n.ant-btn-background-ghost.ant-btn-primary.active {\n  color: #0e77ca;\n  background-color: transparent;\n  border-color: #0e77ca;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary:active > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-background-ghost.ant-btn-primary.disabled,\n.ant-btn-background-ghost.ant-btn-primary[disabled],\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-primary.disabled > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:hover > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:focus > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary.disabled:active > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary.disabled.active > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-primary[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-background-ghost.ant-btn-danger {\n  color: #f04134;\n  background-color: transparent;\n  border-color: #f04134;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover,\n.ant-btn-background-ghost.ant-btn-danger:focus {\n  color: #f46e65;\n  background-color: transparent;\n  border-color: #f46e65;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-background-ghost.ant-btn-danger:active,\n.ant-btn-background-ghost.ant-btn-danger.active {\n  color: #d73435;\n  background-color: transparent;\n  border-color: #d73435;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger:active > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-btn-background-ghost.ant-btn-danger.disabled,\n.ant-btn-background-ghost.ant-btn-danger[disabled],\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-btn-background-ghost.ant-btn-danger.disabled > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:hover > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:focus > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger.disabled:active > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger.disabled.active > a:only-child:after,\n.ant-btn-background-ghost.ant-btn-danger[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n@keyframes buttonEffect {\n  to {\n    opacity: 0;\n    top: -6px;\n    left: -6px;\n    bottom: -6px;\n    right: -6px;\n    border-width: 6px;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzButtonComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzButtonComponent.propDecorators = {
    'nzGhost': [{ type: Input },],
    'nzType': [{ type: Input },],
    'nzShape': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzLoading': [{ type: Input },],
    '_onClick': [{ type: HostListener, args: ['click',] },],
};
var NzButtonModule = (function () {
    function NzButtonModule() {
    }
    return NzButtonModule;
}());
NzButtonModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzButtonComponent, NzButtonGroupComponent],
                exports: [NzButtonComponent, NzButtonGroupComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzButtonModule.ctorParameters = function () { return []; };
var FadeAnimation = trigger('fadeAnimation', [
    state('void', style({ opacity: 0 })),
    state('true', style({ opacity: 1 })),
    state('false', style({ opacity: 0 })),
    transition('* => true', animate('150ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
    transition('* => void', animate('150ms cubic-bezier(0.4, 0.0, 1, 1)')),
]);
/**
 * @author MoXun
 */
var NzAlertComponent = (function () {
    function NzAlertComponent() {
        this._display = true;
        this.nzType = 'info';
        this.nzBanner = false;
        this.nzCloseable = false;
        this.nzShowIcon = false;
        this.nzOnClose = new EventEmitter();
    }
    Object.defineProperty(NzAlertComponent.prototype, "_classMap", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ antAlert = 'ant-alert';
            return _a = {},
                _a["" + antAlert] = true,
                _a[antAlert + "-" + this.nzType] = true,
                _a[antAlert + "-no-icon"] = !this.nzShowIcon,
                _a[antAlert + "-banner"] = this.nzBanner,
                _a[antAlert + "-with-description"] = !!this.nzDescription,
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzAlertComponent.prototype.closeAlert = function () {
        this._display = false;
        this.nzOnClose.emit(true);
    };
    return NzAlertComponent;
}());
NzAlertComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-alert',
                encapsulation: ViewEncapsulation.None,
                animations: [FadeAnimation],
                template: "\n    <div [ngClass]=\"_classMap\" *ngIf=\"_display\" [@fadeAnimation]>\n      <i\n        class=\"ant-alert-icon anticon\"\n        [class.anticon-cross-circle-o]=\"nzType==='error'\"\n        [class.anticon-check-circle-o]=\"nzType==='success'\"\n        [class.anticon-info-circle-o]=\"nzType==='info'\"\n        [class.anticon-exclamation-circle-o]=\"nzType==='warning'\"\n        *ngIf=\"nzShowIcon&&nzDescription\"></i>\n      <i\n        class=\"ant-alert-icon anticon\"\n        [class.anticon-cross-circle]=\"nzType==='error'\"\n        [class.anticon-check-circle]=\"nzType==='success'\"\n        [class.anticon-info-circle]=\"nzType==='info'\"\n        [class.anticon-exclamation-circle]=\"nzType==='warning'\"\n        *ngIf=\"nzShowIcon&&!nzDescription\"></i>\n      <ng-template [ngIf]=\"nzMessage\">\n        <span class=\"ant-alert-message\">{{nzMessage}}</span>\n      </ng-template>\n      <ng-template [ngIf]=\"!nzMessage\">\n        <ng-content select=\"[alert-body]\"></ng-content>\n      </ng-template>\n      <ng-template [ngIf]=\"nzDescription\">\n        <span class=\"ant-alert-description\">{{nzDescription}}</span>\n      </ng-template>\n      <ng-template [ngIf]=\"!nzDescription\">\n        <ng-content select=\"alert-description\"></ng-content>\n      </ng-template>\n      <ng-template [ngIf]=\"nzCloseable || nzCloseText\">\n        <a *ngIf=\"nzCloseable\" (click)=\"closeAlert($event)\" class=\"ant-alert-close-icon\">\n          <i class=\"anticon anticon-cross\"></i>\n        </a>\n        <a *ngIf=\"nzCloseText\" class=\"ant-alert-close-icon\" (click)=\"closeAlert()\">{{nzCloseText}}</a>\n      </ng-template>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-alert {\n  position: relative;\n  padding: 8px 48px 8px 38px;\n  border-radius: 4px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n  line-height: 1.5;\n}\n.ant-alert.ant-alert-no-icon {\n  padding: 8px 48px 8px 16px;\n}\n.ant-alert-icon {\n  font-size: 14px;\n  top: 10px;\n  left: 16px;\n  position: absolute;\n}\n.ant-alert-description {\n  font-size: 12px;\n  line-height: 21px;\n  display: none;\n}\n.ant-alert-success {\n  border: 1px solid #cfefdf;\n  background-color: #ebf8f2;\n}\n.ant-alert-success .ant-alert-icon {\n  color: #00a854;\n}\n.ant-alert-info {\n  border: 1px solid #d2eafb;\n  background-color: #ecf6fd;\n}\n.ant-alert-info .ant-alert-icon {\n  color: #108ee9;\n}\n.ant-alert-warning {\n  border: 1px solid #fff3cf;\n  background-color: #fffaeb;\n}\n.ant-alert-warning .ant-alert-icon {\n  color: #ffbf00;\n}\n.ant-alert-error {\n  border: 1px solid #fcdbd9;\n  background-color: #fef0ef;\n}\n.ant-alert-error .ant-alert-icon {\n  color: #f04134;\n}\n.ant-alert-close-icon {\n  font-size: 12px;\n  position: absolute;\n  right: 16px;\n  top: 10px;\n  height: 12px;\n  line-height: 12px;\n  overflow: hidden;\n  cursor: pointer;\n}\n.ant-alert-close-icon .anticon-cross {\n  color: rgba(0, 0, 0, 0.43);\n  transition: color .3s ease;\n}\n.ant-alert-close-icon .anticon-cross:hover {\n  color: #404040;\n}\n.ant-alert-close-text {\n  position: absolute;\n  right: 16px;\n}\n.ant-alert-with-description {\n  padding: 16px 16px 16px 60px;\n  position: relative;\n  border-radius: 4px;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 1.5;\n}\n.ant-alert-with-description.ant-alert-no-icon {\n  padding: 16px;\n}\n.ant-alert-with-description .ant-alert-icon {\n  position: absolute;\n  top: 16px;\n  left: 20px;\n  font-size: 24px;\n}\n.ant-alert-with-description .ant-alert-close-icon {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  cursor: pointer;\n  font-size: 12px;\n}\n.ant-alert-with-description .ant-alert-message {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.85);\n  display: block;\n  margin-bottom: 4px;\n}\n.ant-alert-with-description .ant-alert-description {\n  display: block;\n}\n.ant-alert.ant-alert-close {\n  height: 0 !important;\n  margin: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  transform-origin: 50% 0;\n}\n.ant-alert-slide-up-leave {\n  animation: antAlertSlideUpOut 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  animation-fill-mode: both;\n}\n.ant-alert-banner {\n  border-radius: 0;\n  border: 0;\n  margin-bottom: 0;\n}\n@keyframes antAlertSlideUpIn {\n  0% {\n    opacity: 0;\n    transform-origin: 0% 0%;\n    transform: scaleY(0);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 0% 0%;\n    transform: scaleY(1);\n  }\n}\n@keyframes antAlertSlideUpOut {\n  0% {\n    opacity: 1;\n    transform-origin: 0% 0%;\n    transform: scaleY(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 0% 0%;\n    transform: scaleY(0);\n  }\n}\n",
                    "nz-alert {\n  display: block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzAlertComponent.ctorParameters = function () { return []; };
NzAlertComponent.propDecorators = {
    'nzType': [{ type: Input },],
    'nzBanner': [{ type: Input },],
    'nzCloseable': [{ type: Input },],
    'nzDescription': [{ type: Input },],
    'nzShowIcon': [{ type: Input },],
    'nzCloseText': [{ type: Input },],
    'nzMessage': [{ type: Input },],
    'nzOnClose': [{ type: Output },],
};
var NzAlertModule = (function () {
    function NzAlertModule() {
    }
    return NzAlertModule;
}());
NzAlertModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzAlertComponent],
                exports: [NzAlertComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzAlertModule.ctorParameters = function () { return []; };
var NzBadgeComponent = (function () {
    function NzBadgeComponent() {
        this._showZero = false;
        this.countArray = [];
        this.countSingleArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        this._nzBadge = true;
        this.nzOverflowCount = 99;
        this.nzDot = false;
    }
    Object.defineProperty(NzBadgeComponent.prototype, "setNoWrapper", {
        /**
         * @return {?}
         */
        get: function () {
            return !this.content;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzBadgeComponent.prototype, "nzShowZero", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showZero;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._showZero = true;
            }
            else {
                this._showZero = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzBadgeComponent.prototype, "nzCount", {
        /**
         * @return {?}
         */
        get: function () {
            return this.count;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value < 0) {
                this.count = 0;
            }
            else {
                this.count = value;
            }
            this.countArray = this.count.toString().split('');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzBadgeComponent.prototype.ngOnInit = function () {
        this.maxNumberArray = this.nzOverflowCount.toString().split('');
    };
    return NzBadgeComponent;
}());
NzBadgeComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-badge',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('enterLeave', [
                        transition('void => *', [
                            style({ opacity: 0 }),
                            animate('0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46)')
                        ]),
                        transition('* => void', [
                            style({ opacity: 1 }),
                            animate('0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46)')
                        ])
                    ])
                ],
                template: "\n    <ng-template *ngIf=\"content\" [ngTemplateOutlet]=\"content\"></ng-template>\n    <span class=\"ant-badge-status-dot ant-badge-status-{{nzStatus}}\" *ngIf=\"nzStatus\"></span>\n    <span class=\"ant-badge-status-text\" *ngIf=\"nzText\">{{nzText}}</span>\n    <sup [@enterLeave]\n         [ngStyle]=\"nzStyle\"\n         *ngIf=\"(nzDot)||(nzCount>0)||((nzCount==0)&&nzShowZero)\"\n         data-show=\"true\"\n         class=\"ant-scroll-number\"\n         [class.ant-badge-count]=\"!nzDot\"\n         [class.ant-badge-dot]=\"nzDot\">\n      <ng-template ngFor\n                   [ngForOf]=\"maxNumberArray\"\n                   let-number\n                   let-i=\"index\"><span *ngIf=\"nzCount<=nzOverflowCount\"\n                                       class=\"ant-scroll-number-only\"\n                                       [style.transform]=\"'translateY('+((-countArray[i]*100))+'%)'\">\n        <ng-template [ngIf]=\"(!nzDot)&&(countArray[i]!=null)\">\n          <p *ngFor=\"let p of countSingleArray\" [class.current]=\"p==countArray[i]\">{{p}}</p>\n        </ng-template>\n        </span></ng-template>\n      <ng-template [ngIf]=\"nzCount>nzOverflowCount\">{{nzOverflowCount}}+</ng-template>\n    </sup>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-badge {\n  position: relative;\n  display: inline-block;\n  line-height: 1;\n  vertical-align: middle;\n}\n.ant-badge-count {\n  position: absolute;\n  transform: translateX(-50%);\n  top: -10px;\n  height: 20px;\n  border-radius: 10px;\n  min-width: 20px;\n  background: #f04134;\n  color: #fff;\n  line-height: 20px;\n  text-align: center;\n  padding: 0 6px;\n  font-size: 12px;\n  white-space: nowrap;\n  transform-origin: -10% center;\n  font-family: tahoma;\n}\n.ant-badge-count a,\n.ant-badge-count a:hover {\n  color: #fff;\n}\n.ant-badge-dot {\n  position: absolute;\n  transform: translateX(-50%);\n  transform-origin: 0 center;\n  top: -4px;\n  height: 8px;\n  width: 8px;\n  border-radius: 100%;\n  background: #f04134;\n  z-index: 10;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-status {\n  line-height: inherit;\n  vertical-align: baseline;\n}\n.ant-badge-status-dot {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 50%;\n}\n.ant-badge-status-success {\n  background-color: #00a854;\n}\n.ant-badge-status-processing {\n  background-color: #108ee9;\n  position: relative;\n}\n.ant-badge-status-processing:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 1px solid #108ee9;\n  content: '';\n  animation: antStatusProcessing 1.2s infinite ease-in-out;\n}\n.ant-badge-status-default {\n  background-color: #d9d9d9;\n}\n.ant-badge-status-error {\n  background-color: #f04134;\n}\n.ant-badge-status-warning {\n  background-color: #ffbf00;\n}\n.ant-badge-status-text {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n  margin-left: 8px;\n}\n.ant-badge-zoom-appear,\n.ant-badge-zoom-enter {\n  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  animation-fill-mode: both;\n}\n.ant-badge-zoom-leave {\n  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n  animation-fill-mode: both;\n}\n.ant-badge-not-a-wrapper .ant-badge-count {\n  top: auto;\n  display: block;\n  position: relative;\n  transform: none !important;\n}\n@keyframes antStatusProcessing {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n.ant-scroll-number {\n  overflow: hidden;\n}\n.ant-scroll-number-only {\n  display: inline-block;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  height: 20px;\n}\n.ant-scroll-number-only > p {\n  height: 20px;\n}\n@keyframes antZoomBadgeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0) translateX(-50%);\n  }\n  100% {\n    transform: scale(1) translateX(-50%);\n  }\n}\n@keyframes antZoomBadgeOut {\n  0% {\n    transform: scale(1) translateX(-50%);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0) translateX(-50%);\n  }\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-badge {\n  position: relative;\n  display: inline-block;\n  line-height: 1;\n  vertical-align: middle;\n}\n.ant-badge-count {\n  position: absolute;\n  transform: translateX(-50%);\n  top: -10px;\n  height: 20px;\n  border-radius: 10px;\n  min-width: 20px;\n  background: #f04134;\n  color: #fff;\n  line-height: 20px;\n  text-align: center;\n  padding: 0 6px;\n  font-size: 12px;\n  white-space: nowrap;\n  transform-origin: -10% center;\n  font-family: tahoma;\n}\n.ant-badge-count a,\n.ant-badge-count a:hover {\n  color: #fff;\n}\n.ant-badge-dot {\n  position: absolute;\n  transform: translateX(-50%);\n  transform-origin: 0 center;\n  top: -4px;\n  height: 8px;\n  width: 8px;\n  border-radius: 100%;\n  background: #f04134;\n  z-index: 10;\n  box-shadow: 0 0 0 1px #fff;\n}\n.ant-badge-status {\n  line-height: inherit;\n  vertical-align: baseline;\n}\n.ant-badge-status-dot {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 50%;\n}\n.ant-badge-status-success {\n  background-color: #00a854;\n}\n.ant-badge-status-processing {\n  background-color: #108ee9;\n  position: relative;\n}\n.ant-badge-status-processing:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 1px solid #108ee9;\n  content: '';\n  animation: antStatusProcessing 1.2s infinite ease-in-out;\n}\n.ant-badge-status-default {\n  background-color: #d9d9d9;\n}\n.ant-badge-status-error {\n  background-color: #f04134;\n}\n.ant-badge-status-warning {\n  background-color: #ffbf00;\n}\n.ant-badge-status-text {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n  margin-left: 8px;\n}\n.ant-badge-zoom-appear,\n.ant-badge-zoom-enter {\n  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  animation-fill-mode: both;\n}\n.ant-badge-zoom-leave {\n  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n  animation-fill-mode: both;\n}\n.ant-badge-not-a-wrapper .ant-badge-count {\n  top: auto;\n  display: block;\n  position: relative;\n  transform: none !important;\n}\n@keyframes antStatusProcessing {\n  0% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n.ant-scroll-number {\n  overflow: hidden;\n}\n.ant-scroll-number-only {\n  display: inline-block;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  height: 20px;\n}\n.ant-scroll-number-only > p {\n  height: 20px;\n}\n@keyframes antZoomBadgeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0) translateX(-50%);\n  }\n  100% {\n    transform: scale(1) translateX(-50%);\n  }\n}\n@keyframes antZoomBadgeOut {\n  0% {\n    transform: scale(1) translateX(-50%);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0) translateX(-50%);\n  }\n}\n.ant-badge-count {\n  position: absolute;\n  transform: translateX(50%);\n  right: 0;\n}\n.ant-badge-dot {\n  position: absolute;\n  transform: translateX(50%);\n  right: 0;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzBadgeComponent.ctorParameters = function () { return []; };
NzBadgeComponent.propDecorators = {
    'content': [{ type: ContentChild, args: ['content',] },],
    '_nzBadge': [{ type: HostBinding, args: ['class.ant-badge',] },],
    'setNoWrapper': [{ type: HostBinding, args: ['class.ant-badge-not-a-wrapper',] },],
    'nzOverflowCount': [{ type: Input },],
    'nzShowZero': [{ type: Input },],
    'nzDot': [{ type: Input },],
    'nzText': [{ type: Input },],
    'nzStyle': [{ type: Input },],
    'nzStatus': [{ type: Input }, { type: HostBinding, args: ['class.ant-badge-status',] },],
    'nzCount': [{ type: Input },],
};
var NzBadgeModule = (function () {
    function NzBadgeModule() {
    }
    return NzBadgeModule;
}());
NzBadgeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzBadgeComponent],
                exports: [NzBadgeComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzBadgeModule.ctorParameters = function () { return []; };
var NzCalendarComponent = (function () {
    /**
     * @param {?} _elementRef
     */
    function NzCalendarComponent(_elementRef) {
        this._elementRef = _elementRef;
        this._weeksCalendar = [];
        this._quartersCalendar = [];
        this._listOfWeekName = [];
        this._listOfMonthName = [];
        this._listOfYearName = [];
        this._yearUnit = '年';
        this._monthUnit = '月';
        this._showMonth = moment(new Date()).month();
        this._showYear = moment(new Date()).year();
        this._value = new Date();
        this._locale = 'zh-cn';
        this.nzClickDay = new EventEmitter();
        this.nzClickMonth = new EventEmitter();
        this.nzClearTime = true;
        this.nzDatePicker = false;
        this.nzMode = 'year';
        this.nzFullScreen = true;
        this.nzShowHeader = true;
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzCalendarComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value || new Date();
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value === value) {
                return;
            }
            this._value = value || new Date();
            this._showMonth = moment(this._value).month();
            this._showYear = moment(this._value).year();
            this._buildCalendar();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCalendarComponent.prototype, "nzShowYear", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showYear;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._showYear = value;
            this._buildCalendar();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCalendarComponent.prototype, "nzShowMonth", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showMonth;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._showMonth = value;
            this._buildCalendar();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCalendarComponent.prototype, "nzLocale", {
        /**
         * @return {?}
         */
        get: function () {
            return this._locale;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._locale = value;
            moment.locale(this._locale);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} date
     * @return {?}
     */
    NzCalendarComponent.prototype._removeTime = function (date) {
        if (this.nzClearTime) {
            return date.hour(0).minute(0).second(0).millisecond(0);
        }
        else {
            return date;
        }
    };
    ;
    /**
     * @param {?} $event
     * @param {?} day
     * @return {?}
     */
    NzCalendarComponent.prototype._clickDay = function ($event, day) {
        $event.preventDefault();
        $event.stopPropagation();
        if (day.disabled) {
            return;
        }
        this.nzClickDay.emit(day);
    };
    ;
    /**
     * @param {?} $event
     * @param {?} month
     * @return {?}
     */
    NzCalendarComponent.prototype._clickMonth = function ($event, month) {
        $event.preventDefault();
        $event.stopPropagation();
        this.nzClickMonth.emit(month);
    };
    ;
    /**
     * @param {?} d
     * @return {?}
     */
    NzCalendarComponent.prototype._buildMonth = function (d) {
        var /** @type {?} */ weeks = [];
        var /** @type {?} */ _rawDate = this._removeTime(d);
        var /** @type {?} */ start = _rawDate.clone().date(1).day(0);
        var /** @type {?} */ month = _rawDate.clone();
        var /** @type {?} */ done = false;
        var /** @type {?} */ date = start.clone();
        var /** @type {?} */ monthIndex = date.month();
        var /** @type {?} */ count = 0;
        while (!done) {
            weeks.push({ days: this._buildWeek(date.clone(), month) });
            date.add(1, 'w');
            done = count++ > 4;
            monthIndex = date.month();
        }
        return weeks;
    };
    ;
    /**
     * @param {?} date
     * @param {?} month
     * @return {?}
     */
    NzCalendarComponent.prototype._buildWeek = function (date, month) {
        var /** @type {?} */ days = [];
        for (var /** @type {?} */ i = 0; i < 7; i++) {
            days.push({
                number: date.date(),
                isLastMonth: date.month() < month.month(),
                isNextMonth: date.month() > month.month(),
                isCurrentDay: date.isSame(new Date(), 'day'),
                isSelectedDay: date.isSame(this.nzValue, 'day'),
                title: date.format('YYYY-MM-DD'),
                date: date,
                disabled: this.nzDisabledDate && this.nzDisabledDate(date.toDate()),
                firstDisabled: this.nzDisabledDate && this.nzDisabledDate(date.toDate()) && (date.day() === 0 || (date.day() !== 0 && this.nzDisabledDate && !this.nzDisabledDate(date.clone().subtract(1, 'day').toDate()))),
                lastDisabled: this.nzDisabledDate && this.nzDisabledDate(date.toDate()) && (date.day() === 6 || (date.day() !== 6 && this.nzDisabledDate && !this.nzDisabledDate(date.clone().add(1, 'day').toDate())))
            });
            date = date.clone();
            date.add(1, 'd');
        }
        return days;
    };
    ;
    /**
     * @param {?} date
     * @return {?}
     */
    NzCalendarComponent.prototype._buildYears = function (date) {
        var /** @type {?} */ quarters = [];
        var /** @type {?} */ months = [];
        for (var /** @type {?} */ i = 0; i < 12; i++) {
            months.push({
                index: i,
                name: this._listOfMonthName[i],
                year: date.year(),
                isCurrentMonth: moment(new Date()).month() === i && date.isSame(new Date(), 'year'),
                isSelectedMonth: this._showMonth === i
            });
            if ((i + 1) % 3 === 0) {
                quarters.push(months);
                months = [];
            }
        }
        return quarters;
    };
    ;
    /**
     * @return {?}
     */
    NzCalendarComponent.prototype._buildCalendar = function () {
        moment.locale(this._locale);
        /** TODO replace with real i18n*/
        if (this._locale !== 'zh-cn') {
            try {
                this._yearUnit = moment.duration(12, 'month').humanize().split(' ')[1][0].toUpperCase() + moment.duration(12, 'month').humanize().split(' ')[1].slice(1, moment.duration(12, 'month').humanize().split(' ')[1].length);
                this._monthUnit = moment.duration(4, 'week').humanize().split(' ')[1][0].toUpperCase() + moment.duration(4, 'week').humanize().split(' ')[1].slice(1, moment.duration(4, 'week').humanize().split(' ')[1].length);
            }
            catch (e) {
            }
        }
        this._listOfYearName = this._generateYears(this._showYear);
        this._listOfWeekName = moment.weekdaysMin();
        this._listOfMonthName = moment.months();
        var /** @type {?} */ date = moment(this.nzValue).year(this._showYear).month(this._showMonth);
        this._weeksCalendar = this._buildMonth(date);
        this._quartersCalendar = this._buildYears(date);
    };
    ;
    /**
     * @param {?} year
     * @return {?}
     */
    NzCalendarComponent.prototype._generateYears = function (year) {
        var /** @type {?} */ listOfYears = [];
        for (var _i = 0, _a = Array.from(Array(20).keys()); _i < _a.length; _i++) {
            var i = _a[_i];
            listOfYears.push(i - 10 + year);
        }
        return listOfYears;
    };
    ;
    /**
     * @return {?}
     */
    NzCalendarComponent.prototype.ngOnInit = function () {
        this._buildCalendar();
    };
    return NzCalendarComponent;
}());
NzCalendarComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-calendar',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div\n      [class.ant-fullcalendar-fullscreen]=\"nzFullScreen\"\n      [class.ant-patch-full-height]=\"nzDatePicker\">\n      <div class=\"ant-fullcalendar-header\" *ngIf=\"nzShowHeader\">\n        <nz-select\n          class=\"ant-fullcalendar-year-select\" style=\"width: 75px;\"\n          [ngModel]=\"_showYear\"\n          (ngModelChange)=\"_showYear = $event;_buildCalendar()\">\n          <nz-option\n            *ngFor=\"let year of _listOfYearName\"\n            [nzLabel]=\"year\"\n            [nzValue]=\"year\">\n          </nz-option>\n        </nz-select>\n        <nz-select\n          class=\"ant-fullcalendar-month-select\"\n          style=\"width: 70px;\"\n          *ngIf=\"nzMode == 'year'\"\n          [ngModel]=\"_showMonth\"\n          (ngModelChange)=\"_showMonth = $event;_buildCalendar()\">\n          <nz-option\n            *ngFor=\"let _month of _listOfMonthName;let i = index;\"\n            [nzLabel]=\"_month\"\n            [nzValue]=\"i\">\n          </nz-option>\n        </nz-select>\n        <nz-radio-group [(ngModel)]=\"nzMode\">\n          <label nz-radio-button [nzValue]=\"'year'\">\n            <span>{{_yearUnit}}</span>\n          </label><label nz-radio-button [nzValue]=\"'month'\">\n          <span>{{_monthUnit}}</span>\n        </label>\n        </nz-radio-group>\n      </div>\n      <div\n        [class.ant-fullcalendar-fullscreen]=\"nzFullScreen\"\n        [class.ant-fullcalendar]=\"!nzDatePicker\"\n        [class.ant-fullcalendar-full]=\"!nzDatePicker\"\n        [class.ant-patch-full-height]=\"nzDatePicker\">\n        <div\n          [class.ant-fullcalendar-calendar-body]=\"!nzDatePicker\"\n          [class.ant-calendar-body]=\"!nzDatePicker\"\n          [class.ant-patch-full-height]=\"nzDatePicker\">\n          <table\n            [class.ant-fullcalendar-table]=\"!nzDatePicker\"\n            [class.ant-calendar-table]=\"nzDatePicker\"\n            [class.ant-patch-full-height]=\"nzDatePicker\"\n            *ngIf=\"nzMode == 'year'\">\n            <thead>\n              <tr>\n                <th\n                  *ngFor=\"let _min of _listOfWeekName\"\n                  [class.ant-fullcalendar-column-header]=\"!nzDatePicker\"\n                  [class.ant-calendar-column-header]=\"nzDatePicker\">\n                  <span class=\"ant-fullcalendar-column-header-inner\">{{_min}}</span>\n                </th>\n              </tr>\n            </thead>\n            <tbody\n              [class.ant-fullcalendartbody]=\"!nzDatePicker\"\n              [class.ant-calendartbody]=\"nzDatePicker\">\n              <tr *ngFor=\"let week of _weeksCalendar\">\n                <ng-template [ngIf]=\"!nzDatePicker\">\n                  <td\n                    [attr.title]=\"day.title\"\n                    *ngFor=\"let day of week.days\"\n                    [class.ant-fullcalendar-cell]=\"!nzDatePicker\"\n                    [class.ant-calendar-cell]=\"nzDatePicker\"\n                    [class.ant-fullcalendar-last-month-cell]=\"day.isLastMonth\"\n                    [class.ant-fullcalendar-next-month-btn-day]=\"day.isNextMonth\"\n                    [class.ant-fullcalendar-selected-day]=\"day.isSelectedDay\"\n                    [class.ant-fullcalendar-today]=\"day.isCurrentDay\">\n                    <div class=\"ant-fullcalendar-date\">\n                      <div class=\"ant-fullcalendar-value\" (click)=\"_clickDay($event,day)\">{{day.number}}</div>\n                      <div class=\"ant-fullcalendar-content\">\n                        <ng-template\n                          *ngIf=\"dateCell\"\n                          [ngTemplateOutlet]=\"dateCell\"\n                          [ngTemplateOutletContext]=\"{ $implicit: day}\">\n                        </ng-template>\n                      </div>\n                    </div>\n                  </td>\n                </ng-template>\n                <ng-template [ngIf]=\"nzDatePicker\">\n                  <td\n                    [attr.title]=\"day.title\"\n                    *ngFor=\"let day of week.days\"\n                    class=\"ant-calendar-cell\"\n                    [class.ant-calendar-disabled-cell-first-of-row]=\"day.firstDisabled\"\n                    [class.ant-calendar-disabled-cell-last-of-row]=\"day.lastDisabled\"\n                    [class.ant-calendar-disabled-cell]=\"day.disabled\"\n                    [class.ant-calendar-last-month-cell]=\"day.isLastMonth\"\n                    [class.ant-calendar-next-month-btn-day]=\"day.isNextMonth\"\n                    [class.ant-calendar-selected-day]=\"day.isSelectedDay\"\n                    [class.ant-calendar-today]=\"day.isCurrentDay\">\n                    <div class=\"ant-calendar-date\" (click)=\"_clickDay($event,day)\">{{day.number}}</div>\n                  </td>\n                </ng-template>\n              </tr>\n            </tbody>\n          </table>\n          <table\n            [class.ant-fullcalendar-month-panel-table]=\"!nzDatePicker\"\n            [class.ant-calendar-month-panel-table]=\"nzDatePicker\"\n            *ngIf=\"nzMode == 'month'\">\n            <tbody class=\"ant-fullcalendar-month-panel-tbody\">\n              <tr *ngFor=\"let quarter of _quartersCalendar\">\n                <ng-template [ngIf]=\"!nzDatePicker\">\n                  <td\n                    *ngFor=\"let month of quarter\"\n                    [attr.title]=\"month.name\"\n                    class=\"ant-fullcalendar-month-panel-cell\"\n                    [class.ant-fullcalendar-month-panel-selected-cell]=\"month.isSelectedMonth\"\n                    [class.ant-fullcalendar-month-panel-current-cell]=\"month.isCurrentMonth\">\n                    <div class=\"ant-fullcalendar-month\">\n                      <div class=\"ant-fullcalendar-value\" (click)=\"_clickMonth($event,month)\">{{month.name}}</div>\n                      <div class=\"ant-fullcalendar-content\">\n                        <ng-template\n                          *ngIf=\"monthCell\"\n                          [ngTemplateOutlet]=\"monthCell\"\n                          [ngTemplateOutletContext]=\"{ $implicit: month}\">\n                        </ng-template>\n                      </div>\n                    </div>\n                  </td>\n                </ng-template>\n                <ng-template [ngIf]=\"nzDatePicker\">\n                  <td\n                    *ngFor=\"let month of quarter\"\n                    [attr.title]=\"month.name\"\n                    class=\"ant-calendar-month-panel-cell\"\n                    [class.ant-calendar-month-panel-selected-cell]=\"month.isSelectedMonth\"\n                    [class.ant-calendar-month-panel-current-cell]=\"month.isCurrentMonth\">\n                    <div class=\"ant-calendar-month-panel-month\" (click)=\"_clickMonth($event,month)\">\n                      {{month.name}}\n                    </div>\n                  </td>\n                </ng-template>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-fullcalendar {\n  font-size: 12px;\n  line-height: 1.5;\n  outline: none;\n  border-top: 1px solid #d9d9d9;\n}\n.ant-fullcalendar-month-select {\n  margin-left: 5px;\n}\n.ant-fullcalendar-header {\n  padding: 11px 16px 11px 0;\n  text-align: right;\n}\n.ant-fullcalendar-header .ant-select-dropdown {\n  text-align: left;\n}\n.ant-fullcalendar-header .ant-radio-group {\n  margin-left: 8px;\n  text-align: left;\n}\n.ant-fullcalendar-header label.ant-radio-button {\n  height: 22px;\n  line-height: 20px;\n  padding: 0 10px;\n}\n.ant-fullcalendar-date-panel {\n  position: relative;\n  outline: none;\n}\n.ant-fullcalendar-calendar-body {\n  padding: 8px 8px 14px;\n}\n.ant-fullcalendar table {\n  border-collapse: collapse;\n  max-width: 100%;\n  background-color: transparent;\n  width: 100%;\n  height: 246px;\n}\n.ant-fullcalendar table,\n.ant-fullcalendar th,\n.ant-fullcalendar td {\n  border: 0;\n}\n.ant-fullcalendar td {\n  position: relative;\n}\n.ant-fullcalendar-calendar-table {\n  border-spacing: 0;\n  margin-bottom: 0;\n}\n.ant-fullcalendar-column-header {\n  line-height: 18px;\n  padding: 0;\n  width: 33px;\n  text-align: center;\n}\n.ant-fullcalendar-column-header .ant-fullcalendar-column-header-inner {\n  display: block;\n  font-weight: normal;\n}\n.ant-fullcalendar-week-number-header .ant-fullcalendar-column-header-inner {\n  display: none;\n}\n.ant-fullcalendar-month,\n.ant-fullcalendar-date {\n  text-align: center;\n  transition: all .3s;\n}\n.ant-fullcalendar-value {\n  display: block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  border-radius: 4px;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  background: transparent;\n  line-height: 22px;\n  transition: all .3s;\n}\n.ant-fullcalendar-value:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-fullcalendar-value:active {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-fullcalendar-month-panel-cell .ant-fullcalendar-value {\n  width: 48px;\n}\n.ant-fullcalendar-today .ant-fullcalendar-value,\n.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {\n  box-shadow: 0 0 0 1px #108ee9;\n}\n.ant-fullcalendar-selected-day .ant-fullcalendar-value,\n.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-fullcalendar-disabled-cell-first-of-row .ant-fullcalendar-value {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-fullcalendar-disabled-cell-last-of-row .ant-fullcalendar-value {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-fullcalendar-last-month-cell .ant-fullcalendar-value,\n.ant-fullcalendar-next-month-btn-day .ant-fullcalendar-value {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-fullcalendar-month-panel-table {\n  table-layout: fixed;\n  width: 100%;\n  border-collapse: separate;\n}\n.ant-fullcalendar-content {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: -9px;\n}\n.ant-fullcalendar-fullscreen {\n  border-top: 0;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-table {\n  table-layout: fixed;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-header .ant-radio-group {\n  margin-left: 16px;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-header label.ant-radio-button {\n  height: 28px;\n  line-height: 26px;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-date {\n  text-align: left;\n  margin: 0 4px;\n  display: block;\n  color: rgba(0, 0, 0, 0.65);\n  height: 116px;\n  padding: 4px 8px;\n  border-top: 2px solid #e9e9e9;\n  transition: background .3s;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month:hover,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-date:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month:active,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-date:active {\n  background: #d2eafb;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-column-header {\n  text-align: right;\n  padding-right: 12px;\n  padding-bottom: 5px;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-value {\n  text-align: right;\n  background: transparent;\n  width: auto;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-value {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-month,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date {\n  border-top-color: #108ee9;\n  background: transparent;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-value {\n  box-shadow: none;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {\n  background: #ecf6fd;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value {\n  color: #108ee9;\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-last-month-cell .ant-fullcalendar-date,\n.ant-fullcalendar-fullscreen .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-date {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-fullcalendar-fullscreen .ant-fullcalendar-content {\n  height: 90px;\n  overflow-y: auto;\n  position: static;\n  width: auto;\n  left: auto;\n  bottom: auto;\n}\n.ant-fullcalendar-disabled-cell .ant-fullcalendar-date,\n.ant-fullcalendar-disabled-cell .ant-fullcalendar-date:hover {\n  cursor: not-allowed;\n}\n.ant-fullcalendar-disabled-cell:not(.ant-fullcalendar-today) .ant-fullcalendar-date,\n.ant-fullcalendar-disabled-cell:not(.ant-fullcalendar-today) .ant-fullcalendar-date:hover {\n  background: transparent;\n}\n.ant-fullcalendar-disabled-cell .ant-fullcalendar-value {\n  color: rgba(0, 0, 0, 0.25);\n  border-radius: 0;\n  width: auto;\n  cursor: not-allowed;\n}\n",
                    "nz-calendar {\n  display: block;\n  position: relative;\n}\n.ant-patch-full-height {\n  height: 100%;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCalendarComponent.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NzCalendarComponent.propDecorators = {
    'dateCell': [{ type: ContentChild, args: ['dateCell',] },],
    'monthCell': [{ type: ContentChild, args: ['monthCell',] },],
    'nzClickDay': [{ type: Output },],
    'nzClickMonth': [{ type: Output },],
    'nzClearTime': [{ type: Input },],
    'nzDatePicker': [{ type: Input }, { type: HostBinding, args: ['class.ant-patch-full-height',] },],
    'nzMode': [{ type: Input },],
    'nzFullScreen': [{ type: Input },],
    'nzShowHeader': [{ type: Input },],
    'nzDisabledDate': [{ type: Input },],
    'nzValue': [{ type: Input },],
    'nzShowYear': [{ type: Input },],
    'nzShowMonth': [{ type: Input },],
    'nzLocale': [{ type: Input },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * OverlayState is a bag of values for either the initial configuration or current state of an
 * overlay.
 */
var OverlayState = (function () {
    function OverlayState() {
        /**
         * Custom class to add to the overlay pane.
         */
        this.panelClass = '';
        /**
         * Whether the overlay has a backdrop.
         */
        this.hasBackdrop = false;
        /**
         * Custom class to add to the backdrop
         */
        this.backdropClass = 'cdk-overlay-dark-backdrop';
        /**
         * The direction of the text in the overlay panel.
         */
        this.direction = 'ltr';
        // TODO(jelbourn): configuration still to add
        // - focus trap
        // - disable pointer events
        // - z-index
    }
    return OverlayState;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Reference to an overlay that has been created with the Overlay service.
 * Used to manipulate or dispose of said overlay.
 */
var OverlayRef = (function () {
    /**
     * @param {?} _portalHost
     * @param {?} _pane
     * @param {?} _state
     * @param {?} _scrollStrategy
     * @param {?} _ngZone
     */
    function OverlayRef(_portalHost, _pane, _state, _scrollStrategy, _ngZone) {
        this._portalHost = _portalHost;
        this._pane = _pane;
        this._state = _state;
        this._scrollStrategy = _scrollStrategy;
        this._ngZone = _ngZone;
        this._backdropElement = null;
        this._backdropClick = new Subject$1();
        this._attachments = new Subject$1();
        this._detachments = new Subject$1();
        _scrollStrategy.attach(this);
    }
    Object.defineProperty(OverlayRef.prototype, "overlayElement", {
        /**
         * The overlay's HTML element
         * @return {?}
         */
        get: function () {
            return this._pane;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Attaches the overlay to a portal instance and adds the backdrop.
     * @param {?} portal Portal instance to which to attach the overlay.
     * @return {?} The portal attachment result.
     */
    OverlayRef.prototype.attach = function (portal) {
        var /** @type {?} */ attachResult = this._portalHost.attach(portal);
        // Update the pane element with the given state configuration.
        this._updateStackingOrder();
        this.updateSize();
        this.updateDirection();
        this.updatePosition();
        this._scrollStrategy.enable();
        // Enable pointer events for the overlay pane element.
        this._togglePointerEvents(true);
        if (this._state.hasBackdrop) {
            this._attachBackdrop();
        }
        if (this._state.panelClass) {
            this._pane.classList.add(this._state.panelClass);
        }
        // Only emit the `attachments` event once all other setup is done.
        this._attachments.next();
        return attachResult;
    };
    /**
     * Detaches an overlay from a portal.
     * @return {?} Resolves when the overlay has been detached.
     */
    OverlayRef.prototype.detach = function () {
        this.detachBackdrop();
        // When the overlay is detached, the pane element should disable pointer events.
        // This is necessary because otherwise the pane element will cover the page and disable
        // pointer events therefore. Depends on the position strategy and the applied pane boundaries.
        this._togglePointerEvents(false);
        this._scrollStrategy.disable();
        var /** @type {?} */ detachmentResult = this._portalHost.detach();
        // Only emit after everything is detached.
        this._detachments.next();
        return detachmentResult;
    };
    /**
     * Cleans up the overlay from the DOM.
     * @return {?}
     */
    OverlayRef.prototype.dispose = function () {
        if (this._state.positionStrategy) {
            this._state.positionStrategy.dispose();
        }
        if (this._scrollStrategy) {
            this._scrollStrategy.disable();
        }
        this.detachBackdrop();
        this._portalHost.dispose();
        this._attachments.complete();
        this._backdropClick.complete();
        this._detachments.next();
        this._detachments.complete();
    };
    /**
     * Checks whether the overlay has been attached.
     * @return {?}
     */
    OverlayRef.prototype.hasAttached = function () {
        return this._portalHost.hasAttached();
    };
    /**
     * Returns an observable that emits when the backdrop has been clicked.
     * @return {?}
     */
    OverlayRef.prototype.backdropClick = function () {
        return this._backdropClick.asObservable();
    };
    /**
     * Returns an observable that emits when the overlay has been attached.
     * @return {?}
     */
    OverlayRef.prototype.attachments = function () {
        return this._attachments.asObservable();
    };
    /**
     * Returns an observable that emits when the overlay has been detached.
     * @return {?}
     */
    OverlayRef.prototype.detachments = function () {
        return this._detachments.asObservable();
    };
    /**
     * Gets the current state config of the overlay.
     * @return {?}
     */
    OverlayRef.prototype.getState = function () {
        return this._state;
    };
    /**
     * Updates the position of the overlay based on the position strategy.
     * @return {?}
     */
    OverlayRef.prototype.updatePosition = function () {
        if (this._state.positionStrategy) {
            this._state.positionStrategy.apply(this._pane);
        }
    };
    /**
     * Updates the text direction of the overlay panel.
     * @return {?}
     */
    OverlayRef.prototype.updateDirection = function () {
        this._pane.setAttribute('dir', this._state.direction);
    };
    /**
     * Updates the size of the overlay based on the overlay config.
     * @return {?}
     */
    OverlayRef.prototype.updateSize = function () {
        if (this._state.width || this._state.width === 0) {
            this._pane.style.width = formatCssUnit(this._state.width);
        }
        if (this._state.height || this._state.height === 0) {
            this._pane.style.height = formatCssUnit(this._state.height);
        }
        if (this._state.minWidth || this._state.minWidth === 0) {
            this._pane.style.minWidth = formatCssUnit(this._state.minWidth);
        }
        if (this._state.minHeight || this._state.minHeight === 0) {
            this._pane.style.minHeight = formatCssUnit(this._state.minHeight);
        }
    };
    /**
     * Toggles the pointer events for the overlay pane element.
     * @param {?} enablePointer
     * @return {?}
     */
    OverlayRef.prototype._togglePointerEvents = function (enablePointer) {
        this._pane.style.pointerEvents = enablePointer ? 'auto' : 'none';
    };
    /**
     * Attaches a backdrop for this overlay.
     * @return {?}
     */
    OverlayRef.prototype._attachBackdrop = function () {
        var _this = this;
        this._backdropElement = document.createElement('div');
        this._backdropElement.classList.add('nz-overlay-backdrop');
        if (this._state.backdropClass) {
            this._backdropElement.classList.add(this._state.backdropClass);
        }
        // Insert the backdrop before the pane in the DOM order,
        // in order to handle stacked overlays properly.
        this._pane.parentElement.insertBefore(this._backdropElement, this._pane);
        // Forward backdrop clicks such that the consumer of the overlay can perform whatever
        // action desired when such a click occurs (usually closing the overlay).
        this._backdropElement.addEventListener('click', function () { return _this._backdropClick.next(null); });
        // Add class to fade-in the backdrop after one frame.
        requestAnimationFrame(function () {
            if (_this._backdropElement) {
                _this._backdropElement.classList.add('nz-overlay-backdrop-showing');
            }
        });
    };
    /**
     * Updates the stacking order of the element, moving it to the top if necessary.
     * This is required in cases where one overlay was detached, while another one,
     * that should be behind it, was destroyed. The next time both of them are opened,
     * the stacking will be wrong, because the detached element's pane will still be
     * in its original DOM position.
     * @return {?}
     */
    OverlayRef.prototype._updateStackingOrder = function () {
        if (this._pane.nextSibling) {
            this._pane.parentNode.appendChild(this._pane);
        }
    };
    /**
     * Detaches the backdrop (if any) associated with the overlay.
     * @return {?}
     */
    OverlayRef.prototype.detachBackdrop = function () {
        var _this = this;
        var /** @type {?} */ backdropToDetach = this._backdropElement;
        if (backdropToDetach) {
            var /** @type {?} */ finishDetach_1 = function () {
                // It may not be attached to anything in certain cases (e.g. unit tests).
                if (backdropToDetach && backdropToDetach.parentNode) {
                    backdropToDetach.parentNode.removeChild(backdropToDetach);
                }
                // It is possible that a new portal has been attached to this overlay since we started
                // removing the backdrop. If that is the case, only clear the backdrop reference if it
                // is still the same instance that we started to remove.
                if (_this._backdropElement === backdropToDetach) {
                    _this._backdropElement = null;
                }
            };
            backdropToDetach.classList.remove('nz-overlay-backdrop-showing');
            if (this._state.backdropClass) {
                backdropToDetach.classList.remove(this._state.backdropClass);
            }
            backdropToDetach.addEventListener('transitionend', finishDetach_1);
            // If the backdrop doesn't have a transition, the `transitionend` event won't fire.
            // In this case we make it unclickable and we try to remove it after a delay.
            backdropToDetach.style.pointerEvents = 'none';
            // Run this outside the Angular zone because there's nothing that Angular cares about.
            // If it were to run inside the Angular zone, every test that used Overlay would have to be
            // either async or fakeAsync.
            this._ngZone.runOutsideAngular(function () {
                setTimeout(finishDetach_1, 500);
            });
        }
    };
    return OverlayRef;
}());
/**
 * @param {?} value
 * @return {?}
 */
function formatCssUnit(value) {
    return typeof value === 'string' ? (value) : value + "px";
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Time in ms to throttle the scrolling events by default.
 */
var DEFAULT_SCROLL_TIME = 20;
/**
 * Service contained all registered Scrollable references and emits an event when any one of the
 * Scrollable references emit a scrolled event.
 */
var ScrollDispatcher = (function () {
    /**
     * @param {?} _ngZone
     * @param {?} _platform
     */
    function ScrollDispatcher(_ngZone, _platform) {
        this._ngZone = _ngZone;
        this._platform = _platform;
        /**
         * Subject for notifying that a registered scrollable reference element has been scrolled.
         */
        this._scrolled = new Subject$1();
        /**
         * Keeps track of the global `scroll` and `resize` subscriptions.
         */
        this._globalSubscription = null;
        /**
         * Keeps track of the amount of subscriptions to `scrolled`. Used for cleaning up afterwards.
         */
        this._scrolledCount = 0;
        /**
         * Map of all the scrollable references that are registered with the service and their
         * scroll event subscriptions.
         */
        this.scrollableReferences = new Map();
    }
    /**
     * Registers a Scrollable with the service and listens for its scrolled events. When the
     * scrollable is scrolled, the service emits the event in its scrolled observable.
     * @param {?} scrollable Scrollable instance to be registered.
     * @return {?}
     */
    ScrollDispatcher.prototype.register = function (scrollable) {
        var _this = this;
        var /** @type {?} */ scrollSubscription = scrollable.elementScrolled().subscribe(function () { return _this._notify(); });
        this.scrollableReferences.set(scrollable, scrollSubscription);
    };
    /**
     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
     * @param {?} scrollable Scrollable instance to be deregistered.
     * @return {?}
     */
    ScrollDispatcher.prototype.deregister = function (scrollable) {
        var /** @type {?} */ scrollableReference = this.scrollableReferences.get(scrollable);
        if (scrollableReference) {
            scrollableReference.unsubscribe();
            this.scrollableReferences.delete(scrollable);
        }
    };
    /**
     * Subscribes to an observable that emits an event whenever any of the registered Scrollable
     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
     * to override the default "throttle" time.
     * @param {?=} auditTimeInMs
     * @param {?=} callback
     * @return {?}
     */
    ScrollDispatcher.prototype.scrolled = function (auditTimeInMs, callback) {
        var _this = this;
        if (auditTimeInMs === void 0) { auditTimeInMs = DEFAULT_SCROLL_TIME; }
        // Scroll events can only happen on the browser, so do nothing if we're not on the browser.
        if (!this._platform.isBrowser) {
            return Subscription$1.EMPTY;
        }
        // In the case of a 0ms delay, use an observable without auditTime
        // since it does add a perceptible delay in processing overhead.
        var /** @type {?} */ observable = auditTimeInMs > 0 ?
            auditTime$1.call(this._scrolled.asObservable(), auditTimeInMs) :
            this._scrolled.asObservable();
        this._scrolledCount++;
        if (!this._globalSubscription) {
            this._globalSubscription = this._ngZone.runOutsideAngular(function () {
                return merge$1(fromEvent$1(window.document, 'scroll'), fromEvent$1(window, 'resize')).subscribe(function () { return _this._notify(); });
            });
        }
        // Note that we need to do the subscribing from here, in order to be able to remove
        // the global event listeners once there are no more subscriptions.
        var /** @type {?} */ subscription = observable.subscribe(callback);
        subscription.add(function () {
            _this._scrolledCount--;
            if (_this._globalSubscription && !_this.scrollableReferences.size && !_this._scrolledCount) {
                _this._globalSubscription.unsubscribe();
                _this._globalSubscription = null;
            }
        });
        return subscription;
    };
    /**
     * Returns all registered Scrollables that contain the provided element.
     * @param {?} elementRef
     * @return {?}
     */
    ScrollDispatcher.prototype.getScrollContainers = function (elementRef) {
        var _this = this;
        var /** @type {?} */ scrollingContainers = [];
        this.scrollableReferences.forEach(function (_subscription, scrollable) {
            if (_this.scrollableContainsElement(scrollable, elementRef)) {
                scrollingContainers.push(scrollable);
            }
        });
        return scrollingContainers;
    };
    /**
     * Returns true if the element is contained within the provided Scrollable.
     * @param {?} scrollable
     * @param {?} elementRef
     * @return {?}
     */
    ScrollDispatcher.prototype.scrollableContainsElement = function (scrollable, elementRef) {
        var /** @type {?} */ element = elementRef.nativeElement;
        var /** @type {?} */ scrollableElement = scrollable.getElementRef().nativeElement;
        // Traverse through the element parents until we reach null, checking if any of the elements
        // are the scrollable's element.
        do {
            if (element === scrollableElement) {
                return true;
            }
        } while (element = element.parentElement);
        return false;
    };
    /**
     * Sends a notification that a scroll event has been fired.
     * @return {?}
     */
    ScrollDispatcher.prototype._notify = function () {
        this._scrolled.next();
    };
    return ScrollDispatcher;
}());
ScrollDispatcher.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ScrollDispatcher.ctorParameters = function () { return [
    { type: NgZone, },
    { type: Platform, },
]; };
/**
 * @param {?} parentDispatcher
 * @param {?} ngZone
 * @param {?} platform
 * @return {?}
 */
function SCROLL_DISPATCHER_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
    return parentDispatcher || new ScrollDispatcher(ngZone, platform);
}
var SCROLL_DISPATCHER_PROVIDER = {
    // If there is already a ScrollDispatcher available, use that. Otherwise, provide a new one.
    provide: ScrollDispatcher,
    deps: [[new Optional(), new SkipSelf(), ScrollDispatcher], NgZone, Platform],
    useFactory: SCROLL_DISPATCHER_PROVIDER_FACTORY
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Simple utility for getting the bounds of the browser viewport.
 * \@docs-private
 */
var ViewportRuler = (function () {
    /**
     * @param {?} scrollDispatcher
     */
    function ViewportRuler(scrollDispatcher) {
        var _this = this;
        // Subscribe to scroll and resize events and update the document rectangle on changes.
        scrollDispatcher.scrolled(0, function () { return _this._cacheViewportGeometry(); });
    }
    /**
     * Gets a ClientRect for the viewport's bounds.
     * @param {?=} documentRect
     * @return {?}
     */
    ViewportRuler.prototype.getViewportRect = function (documentRect) {
        if (documentRect === void 0) { documentRect = this._documentRect; }
        // Cache the document bounding rect so that we don't recompute it for multiple calls.
        if (!documentRect) {
            this._cacheViewportGeometry();
            documentRect = this._documentRect;
        }
        // Use the document element's bounding rect rather than the window scroll properties
        // (e.g. pageYOffset, scrollY) due to in issue in Chrome and IE where window scroll
        // properties and client coordinates (boundingClientRect, clientX/Y, etc.) are in different
        // conceptual viewports. Under most circumstances these viewports are equivalent, but they
        // can disagree when the page is pinch-zoomed (on devices that support touch).
        // See https://bugs.chromium.org/p/chromium/issues/detail?id=489206#c4
        // We use the documentElement instead of the body because, by default (without a css reset)
        // browsers typically give the document body an 8px margin, which is not included in
        // getBoundingClientRect().
        var /** @type {?} */ scrollPosition = this.getViewportScrollPosition(documentRect);
        var /** @type {?} */ height = window.innerHeight;
        var /** @type {?} */ width = window.innerWidth;
        return {
            top: scrollPosition.top,
            left: scrollPosition.left,
            bottom: scrollPosition.top + height,
            right: scrollPosition.left + width,
            height: height,
            width: width,
        };
    };
    /**
     * Gets the (top, left) scroll position of the viewport.
     * @param {?=} documentRect
     * @return {?}
     */
    ViewportRuler.prototype.getViewportScrollPosition = function (documentRect) {
        if (documentRect === void 0) { documentRect = this._documentRect; }
        // Cache the document bounding rect so that we don't recompute it for multiple calls.
        if (!documentRect) {
            this._cacheViewportGeometry();
            documentRect = this._documentRect;
        }
        // The top-left-corner of the viewport is determined by the scroll position of the document
        // body, normally just (scrollLeft, scrollTop). However, Chrome and Firefox disagree about
        // whether `document.body` or `document.documentElement` is the scrolled element, so reading
        // `scrollTop` and `scrollLeft` is inconsistent. However, using the bounding rect of
        // `document.documentElement` works consistently, where the `top` and `left` values will
        // equal negative the scroll position.
        var /** @type {?} */ top = -documentRect.top || document.body.scrollTop || window.scrollY ||
            document.documentElement.scrollTop || 0;
        var /** @type {?} */ left = -documentRect.left || document.body.scrollLeft || window.scrollX ||
            document.documentElement.scrollLeft || 0;
        return { top: top, left: left };
    };
    /**
     * Caches the latest client rectangle of the document element.
     * @return {?}
     */
    ViewportRuler.prototype._cacheViewportGeometry = function () {
        this._documentRect = document.documentElement.getBoundingClientRect();
    };
    return ViewportRuler;
}());
ViewportRuler.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ViewportRuler.ctorParameters = function () { return [
    { type: ScrollDispatcher, },
]; };
/**
 * @param {?} parentRuler
 * @param {?} scrollDispatcher
 * @return {?}
 */
function VIEWPORT_RULER_PROVIDER_FACTORY(parentRuler, scrollDispatcher) {
    return parentRuler || new ViewportRuler(scrollDispatcher);
}
var VIEWPORT_RULER_PROVIDER = {
    // If there is already a ViewportRuler available, use that. Otherwise, provide a new one.
    provide: ViewportRuler,
    deps: [[new Optional(), new SkipSelf(), ViewportRuler], ScrollDispatcher],
    useFactory: VIEWPORT_RULER_PROVIDER_FACTORY
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Horizontal dimension of a connection point on the perimeter of the origin or overlay element. */
/**
 * The points of the origin element and the overlay element to connect.
 */
var ConnectionPositionPair = (function () {
    /**
     * @param {?} origin
     * @param {?} overlay
     */
    function ConnectionPositionPair(origin, overlay) {
        this.originX = origin.originX;
        this.originY = origin.originY;
        this.overlayX = overlay.overlayX;
        this.overlayY = overlay.overlayY;
    }
    return ConnectionPositionPair;
}());
/**
 * Set of properties regarding the position of the origin and overlay relative to the viewport
 * with respect to the containing Scrollable elements.
 *
 * The overlay and origin are clipped if any part of their bounding client rectangle exceeds the
 * bounds of any one of the strategy's Scrollable's bounding client rectangle.
 *
 * The overlay and origin are outside view if there is no overlap between their bounding client
 * rectangle and any one of the strategy's Scrollable's bounding client rectangle.
 *
 *       -----------                    -----------
 *       | outside |                    | clipped |
 *       |  view   |              --------------------------
 *       |         |              |     |         |        |
 *       ----------               |     -----------        |
 *  --------------------------    |                        |
 *  |                        |    |      Scrollable        |
 *  |                        |    |                        |
 *  |                        |     --------------------------
 *  |      Scrollable        |
 *  |                        |
 *  --------------------------
 */
var ScrollableViewProperties = (function () {
    function ScrollableViewProperties() {
    }
    return ScrollableViewProperties;
}());
/**
 * The change event emitted by the strategy when a fallback position is used.
 */
var ConnectedOverlayPositionChange = (function () {
    /**
     * @param {?} connectionPair
     * @param {?} scrollableViewProperties
     */
    function ConnectedOverlayPositionChange(connectionPair, scrollableViewProperties) {
        this.connectionPair = connectionPair;
        this.scrollableViewProperties = scrollableViewProperties;
    }
    return ConnectedOverlayPositionChange;
}());
/**
 * @nocollapse
 */
ConnectedOverlayPositionChange.ctorParameters = function () { return [
    { type: ConnectionPositionPair, },
    { type: ScrollableViewProperties, decorators: [{ type: Optional },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A strategy for positioning overlays. Using this strategy, an overlay is given an
 * implicit position relative some origin element. The relative position is defined in terms of
 * a point on the origin element that is connected to a point on the overlay element. For example,
 * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
 * of the overlay.
 */
var ConnectedPositionStrategy = (function () {
    /**
     * @param {?} _connectedTo
     * @param {?} _originPos
     * @param {?} _overlayPos
     * @param {?} _viewportRuler
     */
    function ConnectedPositionStrategy(_connectedTo, _originPos, _overlayPos, _viewportRuler) {
        this._connectedTo = _connectedTo;
        this._originPos = _originPos;
        this._overlayPos = _overlayPos;
        this._viewportRuler = _viewportRuler;
        this._dir = 'ltr';
        /**
         * The offset in pixels for the overlay connection point on the x-axis
         */
        this._offsetX = 0;
        /**
         * The offset in pixels for the overlay connection point on the y-axis
         */
        this._offsetY = 0;
        /**
         * The Scrollable containers used to check scrollable view properties on position change.
         */
        this.scrollables = [];
        /**
         * Ordered list of preferred positions, from most to least desirable.
         */
        this._preferredPositions = [];
        this._onPositionChange = new Subject$1();
        this._origin = this._connectedTo.nativeElement;
        this.withFallbackPosition(_originPos, _overlayPos);
    }
    Object.defineProperty(ConnectedPositionStrategy.prototype, "_isRtl", {
        /**
         * Whether the we're dealing with an RTL context
         * @return {?}
         */
        get: function () {
            return this._dir === 'rtl';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedPositionStrategy.prototype, "onPositionChange", {
        /**
         * Emits an event when the connection point changes.
         * @return {?}
         */
        get: function () {
            return this._onPositionChange.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedPositionStrategy.prototype, "positions", {
        /**
         * Ordered list of preferred positions, from most to least desirable.
         * @return {?}
         */
        get: function () {
            return this._preferredPositions;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * To be used to for any cleanup after the element gets destroyed.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.dispose = function () { };
    /**
     * Updates the position of the overlay element, using whichever preferred position relative
     * to the origin fits on-screen.
     * \@docs-private
     *
     * @param {?} element Element to which to apply the CSS styles.
     * @return {?} Resolves when the styles have been applied.
     */
    ConnectedPositionStrategy.prototype.apply = function (element) {
        // Cache the overlay pane element in case re-calculating position is necessary
        this._pane = element;
        // We need the bounding rects for the origin and the overlay to determine how to position
        // the overlay relative to the origin.
        var /** @type {?} */ originRect = this._origin.getBoundingClientRect();
        var /** @type {?} */ overlayRect = element.getBoundingClientRect();
        // We use the viewport rect to determine whether a position would go off-screen.
        var /** @type {?} */ viewportRect = this._viewportRuler.getViewportRect();
        // Fallback point if none of the fallbacks fit into the viewport.
        var /** @type {?} */ fallbackPoint;
        var /** @type {?} */ fallbackPosition;
        // We want to place the overlay in the first of the preferred positions such that the
        // overlay fits on-screen.
        for (var _i = 0, _a = this._preferredPositions; _i < _a.length; _i++) {
            var pos = _a[_i];
            // Get the (x, y) point of connection on the origin, and then use that to get the
            // (top, left) coordinate for the overlay at `pos`.
            var /** @type {?} */ originPoint = this._getOriginConnectionPoint(originRect, pos);
            var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, viewportRect, pos);
            // If the overlay in the calculated position fits on-screen, put it there and we're done.
            if (overlayPoint.fitsInViewport) {
                this._setElementPosition(element, overlayRect, overlayPoint, pos);
                // Save the last connected position in case the position needs to be re-calculated.
                this._lastConnectedPosition = pos;
                // Notify that the position has been changed along with its change properties.
                var /** @type {?} */ scrollableViewProperties = this.getScrollableViewProperties(element);
                var /** @type {?} */ positionChange = new ConnectedOverlayPositionChange(pos, scrollableViewProperties);
                this._onPositionChange.next(positionChange);
                return;
            }
            else if (!fallbackPoint || fallbackPoint.visibleArea < overlayPoint.visibleArea) {
                fallbackPoint = overlayPoint;
                fallbackPosition = pos;
            }
        }
        // If none of the preferred positions were in the viewport, take the one
        // with the largest visible area.
        this._setElementPosition(element, overlayRect, fallbackPoint, fallbackPosition);
    };
    /**
     * This re-aligns the overlay element with the trigger in its last calculated position,
     * even if a position higher in the "preferred positions" list would now fit. This
     * allows one to re-align the panel without changing the orientation of the panel.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.recalculateLastPosition = function () {
        var /** @type {?} */ originRect = this._origin.getBoundingClientRect();
        var /** @type {?} */ overlayRect = this._pane.getBoundingClientRect();
        var /** @type {?} */ viewportRect = this._viewportRuler.getViewportRect();
        var /** @type {?} */ lastPosition = this._lastConnectedPosition || this._preferredPositions[0];
        var /** @type {?} */ originPoint = this._getOriginConnectionPoint(originRect, lastPosition);
        var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, viewportRect, lastPosition);
        this._setElementPosition(this._pane, overlayRect, overlayPoint, lastPosition);
    };
    /**
     * Sets the list of Scrollable containers that host the origin element so that
     * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
     * Scrollable must be an ancestor element of the strategy's origin element.
     * @param {?} scrollables
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withScrollableContainers = function (scrollables) {
        this.scrollables = scrollables;
    };
    /**
     * Adds a new preferred fallback position.
     * @param {?} originPos
     * @param {?} overlayPos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withFallbackPosition = function (originPos, overlayPos) {
        this._preferredPositions.push(new ConnectionPositionPair(originPos, overlayPos));
        return this;
    };
    /**
     * Sets the layout direction so the overlay's position can be adjusted to match.
     * @param {?} dir New layout direction.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withDirection = function (dir) {
        this._dir = dir;
        return this;
    };
    /**
     * Sets an offset for the overlay's connection point on the x-axis
     * @param {?} offset New offset in the X axis.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withOffsetX = function (offset) {
        this._offsetX = offset;
        return this;
    };
    /**
     * Sets an offset for the overlay's connection point on the y-axis
     * @param {?} offset New offset in the Y axis.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withOffsetY = function (offset) {
        this._offsetY = offset;
        return this;
    };
    /**
     * Gets the horizontal (x) "start" dimension based on whether the overlay is in an RTL context.
     * @param {?} rect
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getStartX = function (rect) {
        return this._isRtl ? rect.right : rect.left;
    };
    /**
     * Gets the horizontal (x) "end" dimension based on whether the overlay is in an RTL context.
     * @param {?} rect
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getEndX = function (rect) {
        return this._isRtl ? rect.left : rect.right;
    };
    /**
     * Gets the (x, y) coordinate of a connection point on the origin based on a relative position.
     * @param {?} originRect
     * @param {?} pos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getOriginConnectionPoint = function (originRect, pos) {
        var /** @type {?} */ originStartX = this._getStartX(originRect);
        var /** @type {?} */ originEndX = this._getEndX(originRect);
        var /** @type {?} */ x;
        if (pos.originX === 'center') {
            x = originStartX + (originRect.width / 2);
        }
        else {
            x = pos.originX === 'start' ? originStartX : originEndX;
        }
        var /** @type {?} */ y;
        if (pos.originY === 'center') {
            y = originRect.top + (originRect.height / 2);
        }
        else {
            y = pos.originY === 'top' ? originRect.top : originRect.bottom;
        }
        return { x: x, y: y };
    };
    /**
     * Gets the (x, y) coordinate of the top-left corner of the overlay given a given position and
     * origin point to which the overlay should be connected, as well as how much of the element
     * would be inside the viewport at that position.
     * @param {?} originPoint
     * @param {?} overlayRect
     * @param {?} viewportRect
     * @param {?} pos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getOverlayPoint = function (originPoint, overlayRect, viewportRect, pos) {
        // Calculate the (overlayStartX, overlayStartY), the start of the potential overlay position
        // relative to the origin point.
        var /** @type {?} */ overlayStartX;
        if (pos.overlayX === 'center') {
            overlayStartX = -overlayRect.width / 2;
        }
        else if (pos.overlayX === 'start') {
            overlayStartX = this._isRtl ? -overlayRect.width : 0;
        }
        else {
            overlayStartX = this._isRtl ? 0 : -overlayRect.width;
        }
        var /** @type {?} */ overlayStartY;
        if (pos.overlayY === 'center') {
            overlayStartY = -overlayRect.height / 2;
        }
        else {
            overlayStartY = pos.overlayY === 'top' ? 0 : -overlayRect.height;
        }
        // The (x, y) coordinates of the overlay.
        var /** @type {?} */ x = originPoint.x + overlayStartX + this._offsetX;
        var /** @type {?} */ y = originPoint.y + overlayStartY + this._offsetY;
        // How much the overlay would overflow at this position, on each side.
        var /** @type {?} */ leftOverflow = 0 - x;
        var /** @type {?} */ rightOverflow = (x + overlayRect.width) - viewportRect.width;
        var /** @type {?} */ topOverflow = 0 - y;
        var /** @type {?} */ bottomOverflow = (y + overlayRect.height) - viewportRect.height;
        // Visible parts of the element on each axis.
        var /** @type {?} */ visibleWidth = this._subtractOverflows(overlayRect.width, leftOverflow, rightOverflow);
        var /** @type {?} */ visibleHeight = this._subtractOverflows(overlayRect.height, topOverflow, bottomOverflow);
        // The area of the element that's within the viewport.
        var /** @type {?} */ visibleArea = visibleWidth * visibleHeight;
        var /** @type {?} */ fitsInViewport = (overlayRect.width * overlayRect.height) === visibleArea;
        return { x: x, y: y, fitsInViewport: fitsInViewport, visibleArea: visibleArea };
    };
    /**
     * Gets the view properties of the trigger and overlay, including whether they are clipped
     * or completely outside the view of any of the strategy's scrollables.
     * @param {?} overlay
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.getScrollableViewProperties = function (overlay) {
        var _this = this;
        var /** @type {?} */ originBounds = this._getElementBounds(this._origin);
        var /** @type {?} */ overlayBounds = this._getElementBounds(overlay);
        var /** @type {?} */ scrollContainerBounds = this.scrollables.map(function (scrollable) {
            return _this._getElementBounds(scrollable.getElementRef().nativeElement);
        });
        return {
            isOriginClipped: this.isElementClipped(originBounds, scrollContainerBounds),
            isOriginOutsideView: this.isElementOutsideView(originBounds, scrollContainerBounds),
            isOverlayClipped: this.isElementClipped(overlayBounds, scrollContainerBounds),
            isOverlayOutsideView: this.isElementOutsideView(overlayBounds, scrollContainerBounds),
        };
    };
    /**
     * Whether the element is completely out of the view of any of the containers.
     * @param {?} elementBounds
     * @param {?} containersBounds
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.isElementOutsideView = function (elementBounds, containersBounds) {
        return containersBounds.some(function (containerBounds) {
            var /** @type {?} */ outsideAbove = elementBounds.bottom < containerBounds.top;
            var /** @type {?} */ outsideBelow = elementBounds.top > containerBounds.bottom;
            var /** @type {?} */ outsideLeft = elementBounds.right < containerBounds.left;
            var /** @type {?} */ outsideRight = elementBounds.left > containerBounds.right;
            return outsideAbove || outsideBelow || outsideLeft || outsideRight;
        });
    };
    /**
     * Whether the element is clipped by any of the containers.
     * @param {?} elementBounds
     * @param {?} containersBounds
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.isElementClipped = function (elementBounds, containersBounds) {
        return containersBounds.some(function (containerBounds) {
            var /** @type {?} */ clippedAbove = elementBounds.top < containerBounds.top;
            var /** @type {?} */ clippedBelow = elementBounds.bottom > containerBounds.bottom;
            var /** @type {?} */ clippedLeft = elementBounds.left < containerBounds.left;
            var /** @type {?} */ clippedRight = elementBounds.right > containerBounds.right;
            return clippedAbove || clippedBelow || clippedLeft || clippedRight;
        });
    };
    /**
     * Physically positions the overlay element to the given coordinate.
     * @param {?} element
     * @param {?} overlayRect
     * @param {?} overlayPoint
     * @param {?} pos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._setElementPosition = function (element, overlayRect, overlayPoint, pos) {
        // We want to set either `top` or `bottom` based on whether the overlay wants to appear above
        // or below the origin and the direction in which the element will expand.
        var /** @type {?} */ verticalStyleProperty = pos.overlayY === 'bottom' ? 'bottom' : 'top';
        // When using `bottom`, we adjust the y position such that it is the distance
        // from the bottom of the viewport rather than the top.
        var /** @type {?} */ y = verticalStyleProperty === 'top' ?
            overlayPoint.y :
            document.documentElement.clientHeight - (overlayPoint.y + overlayRect.height);
        // We want to set either `left` or `right` based on whether the overlay wants to appear "before"
        // or "after" the origin, which determines the direction in which the element will expand.
        // For the horizontal axis, the meaning of "before" and "after" change based on whether the
        // page is in RTL or LTR.
        var /** @type {?} */ horizontalStyleProperty;
        if (this._dir === 'rtl') {
            horizontalStyleProperty = pos.overlayX === 'end' ? 'left' : 'right';
        }
        else {
            horizontalStyleProperty = pos.overlayX === 'end' ? 'right' : 'left';
        }
        // When we're setting `right`, we adjust the x position such that it is the distance
        // from the right edge of the viewport rather than the left edge.
        var /** @type {?} */ x = horizontalStyleProperty === 'left' ?
            overlayPoint.x :
            document.documentElement.clientWidth - (overlayPoint.x + overlayRect.width);
        // Reset any existing styles. This is necessary in case the preferred position has
        // changed since the last `apply`.
        ['top', 'bottom', 'left', 'right'].forEach(function (p) { return element.style[p] = null; });
        element.style[verticalStyleProperty] = y + "px";
        element.style[horizontalStyleProperty] = x + "px";
    };
    /**
     * Returns the bounding positions of the provided element with respect to the viewport.
     * @param {?} element
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getElementBounds = function (element) {
        var /** @type {?} */ boundingClientRect = element.getBoundingClientRect();
        return {
            top: boundingClientRect.top,
            right: boundingClientRect.left + boundingClientRect.width,
            bottom: boundingClientRect.top + boundingClientRect.height,
            left: boundingClientRect.left
        };
    };
    /**
     * Subtracts the amount that an element is overflowing on an axis from it's length.
     * @param {?} length
     * @param {...?} overflows
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._subtractOverflows = function (length) {
        var overflows = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            overflows[_i - 1] = arguments[_i];
        }
        return overflows.reduce(function (currentValue, currentOverflow) {
            return currentValue - Math.max(currentOverflow, 0);
        }, length);
    };
    return ConnectedPositionStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A strategy for positioning overlays. Using this strategy, an overlay is given an
 * explicit position relative to the browser's viewport. We use flexbox, instead of
 * transforms, in order to avoid issues with subpixel rendering which can cause the
 * element to become blurry.
 */
var GlobalPositionStrategy = (function () {
    function GlobalPositionStrategy() {
        this._cssPosition = 'static';
        this._topOffset = '';
        this._bottomOffset = '';
        this._leftOffset = '';
        this._rightOffset = '';
        this._alignItems = '';
        this._justifyContent = '';
        this._width = '';
        this._height = '';
        this._wrapper = null;
    }
    /**
     * Sets the top position of the overlay. Clears any previously set vertical position.
     * @param {?=} value New top offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.top = function (value) {
        if (value === void 0) { value = ''; }
        this._bottomOffset = '';
        this._topOffset = value;
        this._alignItems = 'flex-start';
        return this;
    };
    /**
     * Sets the left position of the overlay. Clears any previously set horizontal position.
     * @param {?=} value New left offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.left = function (value) {
        if (value === void 0) { value = ''; }
        this._rightOffset = '';
        this._leftOffset = value;
        this._justifyContent = 'flex-start';
        return this;
    };
    /**
     * Sets the bottom position of the overlay. Clears any previously set vertical position.
     * @param {?=} value New bottom offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.bottom = function (value) {
        if (value === void 0) { value = ''; }
        this._topOffset = '';
        this._bottomOffset = value;
        this._alignItems = 'flex-end';
        return this;
    };
    /**
     * Sets the right position of the overlay. Clears any previously set horizontal position.
     * @param {?=} value New right offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.right = function (value) {
        if (value === void 0) { value = ''; }
        this._leftOffset = '';
        this._rightOffset = value;
        this._justifyContent = 'flex-end';
        return this;
    };
    /**
     * Sets the overlay width and clears any previously set width.
     * @param {?=} value New width for the overlay
     * @return {?}
     */
    GlobalPositionStrategy.prototype.width = function (value) {
        if (value === void 0) { value = ''; }
        this._width = value;
        // When the width is 100%, we should reset the `left` and the offset,
        // in order to ensure that the element is flush against the viewport edge.
        if (value === '100%') {
            this.left('0px');
        }
        return this;
    };
    /**
     * Sets the overlay height and clears any previously set height.
     * @param {?=} value New height for the overlay
     * @return {?}
     */
    GlobalPositionStrategy.prototype.height = function (value) {
        if (value === void 0) { value = ''; }
        this._height = value;
        // When the height is 100%, we should reset the `top` and the offset,
        // in order to ensure that the element is flush against the viewport edge.
        if (value === '100%') {
            this.top('0px');
        }
        return this;
    };
    /**
     * Centers the overlay horizontally with an optional offset.
     * Clears any previously set horizontal position.
     *
     * @param {?=} offset Overlay offset from the horizontal center.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.centerHorizontally = function (offset) {
        if (offset === void 0) { offset = ''; }
        this.left(offset);
        this._justifyContent = 'center';
        return this;
    };
    /**
     * Centers the overlay vertically with an optional offset.
     * Clears any previously set vertical position.
     *
     * @param {?=} offset Overlay offset from the vertical center.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.centerVertically = function (offset) {
        if (offset === void 0) { offset = ''; }
        this.top(offset);
        this._alignItems = 'center';
        return this;
    };
    /**
     * Apply the position to the element.
     * \@docs-private
     *
     * @param {?} element Element to which to apply the CSS.
     * @return {?} Resolved when the styles have been applied.
     */
    GlobalPositionStrategy.prototype.apply = function (element) {
        if (!this._wrapper && element.parentNode) {
            this._wrapper = document.createElement('div');
            this._wrapper.classList.add('cdk-global-overlay-wrapper');
            element.parentNode.insertBefore(this._wrapper, element);
            this._wrapper.appendChild(element);
        }
        var /** @type {?} */ styles = element.style;
        var /** @type {?} */ parentStyles = ((element.parentNode)).style;
        styles.position = this._cssPosition;
        styles.marginTop = this._topOffset;
        styles.marginLeft = this._leftOffset;
        styles.marginBottom = this._bottomOffset;
        styles.marginRight = this._rightOffset;
        styles.width = this._width;
        styles.height = this._height;
        parentStyles.justifyContent = this._justifyContent;
        parentStyles.alignItems = this._alignItems;
    };
    /**
     * Removes the wrapper element from the DOM.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.dispose = function () {
        if (this._wrapper && this._wrapper.parentNode) {
            this._wrapper.parentNode.removeChild(this._wrapper);
            this._wrapper = null;
        }
    };
    return GlobalPositionStrategy;
}());
/**
 * Free position strategy for overlay without origin
 * @author lingyi.zcs
 */
var FreePositionStrategy = (function () {
    function FreePositionStrategy() {
    }
    /**
     * Apply the position to the element. (NOTE: normally will triggered by scrolling)
     * \@docs-private
     *
     * @param {?} element Element to which to apply the CSS.
     * @return {?} Resolved when the styles have been applied.
     */
    FreePositionStrategy.prototype.apply = function (element) {
        if (!this._wrapper) {
            this._wrapper = document.createElement('div');
            this._wrapper.classList.add('cdk-free-overlay-wrapper');
            element.parentNode.insertBefore(this._wrapper, element);
            this._wrapper.appendChild(element);
            // // Initialized style once
            // const style = element.style;
            // style.position = this._cssPosition;
            // style.top = this._top;
            // style.left = this._left;
            // style.width = this._width;
            // style.height = this._height;
        }
        // TODO: do somethings while triggered (eg. by scrolling)
    };
    /**
     * Removes the wrapper element from the DOM.
     * @return {?}
     */
    FreePositionStrategy.prototype.dispose = function () {
        if (this._wrapper && this._wrapper.parentNode) {
            this._wrapper.parentNode.removeChild(this._wrapper);
            this._wrapper = null;
        }
    };
    return FreePositionStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Builder for overlay position strategy.
 */
var OverlayPositionBuilder = (function () {
    /**
     * @param {?} _viewportRuler
     */
    function OverlayPositionBuilder(_viewportRuler) {
        this._viewportRuler = _viewportRuler;
    }
    /**
     * Creates a free position strategy
     * @return {?}
     */
    OverlayPositionBuilder.prototype.free = function () {
        return new FreePositionStrategy();
    };
    /**
     * Creates a global position strategy.
     * @return {?}
     */
    OverlayPositionBuilder.prototype.global = function () {
        return new GlobalPositionStrategy();
    };
    /**
     * Creates a relative position strategy.
     * @param {?} elementRef
     * @param {?} originPos
     * @param {?} overlayPos
     * @return {?}
     */
    OverlayPositionBuilder.prototype.connectedTo = function (elementRef, originPos, overlayPos) {
        return new ConnectedPositionStrategy(elementRef, originPos, overlayPos, this._viewportRuler);
    };
    return OverlayPositionBuilder;
}());
OverlayPositionBuilder.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
OverlayPositionBuilder.ctorParameters = function () { return [
    { type: ViewportRuler, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The OverlayContainer is the container in which all overlays will load.
 * It should be provided in the root component to ensure it is properly shared.
 */
var OverlayContainer = (function () {
    function OverlayContainer() {
    }
    Object.defineProperty(OverlayContainer.prototype, "themeClass", {
        /**
         * Base theme to be applied to all overlay-based components.
         * @return {?}
         */
        get: function () { return this._themeClass; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._containerElement) {
                this._containerElement.classList.remove(this._themeClass);
                if (value) {
                    this._containerElement.classList.add(value);
                }
            }
            this._themeClass = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This method returns the overlay container element.  It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @return {?} the container element
     */
    OverlayContainer.prototype.getContainerElement = function () {
        if (!this._containerElement) {
            this._createContainer();
        }
        return this._containerElement;
    };
    /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     * @return {?}
     */
    OverlayContainer.prototype._createContainer = function () {
        var /** @type {?} */ container = document.createElement('div');
        container.classList.add('nz-overlay-container');
        if (this._themeClass) {
            container.classList.add(this._themeClass);
        }
        document.body.appendChild(container);
        this._containerElement = container;
    };
    return OverlayContainer;
}());
OverlayContainer.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
OverlayContainer.ctorParameters = function () { return []; };
/**
 * @param {?} parentContainer
 * @return {?}
 */
function OVERLAY_CONTAINER_PROVIDER_FACTORY(parentContainer) {
    return parentContainer || new OverlayContainer();
}
var OVERLAY_CONTAINER_PROVIDER = {
    // If there is already an OverlayContainer available, use that. Otherwise, provide a new one.
    provide: OverlayContainer,
    deps: [[new Optional(), new SkipSelf(), OverlayContainer]],
    useFactory: OVERLAY_CONTAINER_PROVIDER_FACTORY
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Sends an event when the directive's element is scrolled. Registers itself with the
 * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
 * can be listened to through the service.
 */
var Scrollable = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _scroll
     * @param {?} _ngZone
     * @param {?} _renderer
     */
    function Scrollable(_elementRef, _scroll, _ngZone, _renderer) {
        this._elementRef = _elementRef;
        this._scroll = _scroll;
        this._ngZone = _ngZone;
        this._renderer = _renderer;
        this._elementScrolled = new Subject$1();
    }
    /**
     * @return {?}
     */
    Scrollable.prototype.ngOnInit = function () {
        var _this = this;
        this._scrollListener = this._ngZone.runOutsideAngular(function () {
            return _this._renderer.listen(_this.getElementRef().nativeElement, 'scroll', function (event) {
                _this._elementScrolled.next(event);
            });
        });
        this._scroll.register(this);
    };
    /**
     * @return {?}
     */
    Scrollable.prototype.ngOnDestroy = function () {
        this._scroll.deregister(this);
        if (this._scrollListener) {
            this._scrollListener();
            this._scrollListener = null;
        }
    };
    /**
     * Returns observable that emits when a scroll event is fired on the host element.
     * @return {?}
     */
    Scrollable.prototype.elementScrolled = function () {
        return this._elementScrolled.asObservable();
    };
    /**
     * @return {?}
     */
    Scrollable.prototype.getElementRef = function () {
        return this._elementRef;
    };
    return Scrollable;
}());
Scrollable.decorators = [
    { type: Directive, args: [{
                selector: '[cdk-scrollable], [cdkScrollable]'
            },] },
];
/**
 * @nocollapse
 */
Scrollable.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: ScrollDispatcher, },
    { type: NgZone, },
    { type: Renderer2, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Describes a strategy that will be used by an overlay
 * to handle scroll events while it is open.
 * @abstract
 */
/**
 * Returns an error to be thrown when attempting to attach an already-attached scroll strategy.
 * @return {?}
 */
function getMdScrollStrategyAlreadyAttachedError() {
    return Error("Scroll strategy has already been attached.");
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Strategy that will close the overlay as soon as the user starts scrolling.
 */
var CloseScrollStrategy = (function () {
    /**
     * @param {?} _scrollDispatcher
     */
    function CloseScrollStrategy(_scrollDispatcher) {
        this._scrollDispatcher = _scrollDispatcher;
        this._scrollSubscription = null;
    }
    /**
     * @param {?} overlayRef
     * @return {?}
     */
    CloseScrollStrategy.prototype.attach = function (overlayRef) {
        if (this._overlayRef) {
            throw getMdScrollStrategyAlreadyAttachedError();
        }
        this._overlayRef = overlayRef;
    };
    /**
     * @return {?}
     */
    CloseScrollStrategy.prototype.enable = function () {
        var _this = this;
        if (!this._scrollSubscription) {
            this._scrollSubscription = this._scrollDispatcher.scrolled(0, function () {
                if (_this._overlayRef.hasAttached()) {
                    _this._overlayRef.detach();
                }
                _this.disable();
            });
        }
    };
    /**
     * @return {?}
     */
    CloseScrollStrategy.prototype.disable = function () {
        if (this._scrollSubscription) {
            this._scrollSubscription.unsubscribe();
            this._scrollSubscription = null;
        }
    };
    return CloseScrollStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Scroll strategy that doesn't do anything.
 */
var NoopScrollStrategy = (function () {
    function NoopScrollStrategy() {
    }
    /**
     * @return {?}
     */
    NoopScrollStrategy.prototype.enable = function () { };
    /**
     * @return {?}
     */
    NoopScrollStrategy.prototype.disable = function () { };
    /**
     * @return {?}
     */
    NoopScrollStrategy.prototype.attach = function () { };
    return NoopScrollStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Strategy that will prevent the user from scrolling while the overlay is visible.
 */
var BlockScrollStrategy = (function () {
    /**
     * @param {?} _viewportRuler
     */
    function BlockScrollStrategy(_viewportRuler) {
        this._viewportRuler = _viewportRuler;
        this._previousHTMLStyles = { top: '', left: '' };
        this._isEnabled = false;
    }
    /**
     * @return {?}
     */
    BlockScrollStrategy.prototype.attach = function () { };
    /**
     * @return {?}
     */
    BlockScrollStrategy.prototype.enable = function () {
        if (this._canBeEnabled()) {
            var /** @type {?} */ root = document.documentElement;
            this._previousScrollPosition = this._viewportRuler.getViewportScrollPosition();
            // Cache the previous inline styles in case the user had set them.
            this._previousHTMLStyles.left = root.style.left || '';
            this._previousHTMLStyles.top = root.style.top || '';
            // Note: we're using the `html` node, instead of the `body`, because the `body` may
            // have the user agent margin, whereas the `html` is guaranteed not to have one.
            root.style.left = -this._previousScrollPosition.left + "px";
            root.style.top = -this._previousScrollPosition.top + "px";
            root.classList.add('cdk-global-scrollblock');
            this._isEnabled = true;
        }
    };
    /**
     * @return {?}
     */
    BlockScrollStrategy.prototype.disable = function () {
        if (this._isEnabled) {
            this._isEnabled = false;
            document.documentElement.style.left = this._previousHTMLStyles.left;
            document.documentElement.style.top = this._previousHTMLStyles.top;
            document.documentElement.classList.remove('cdk-global-scrollblock');
            window.scroll(this._previousScrollPosition.left, this._previousScrollPosition.top);
        }
    };
    /**
     * @return {?}
     */
    BlockScrollStrategy.prototype._canBeEnabled = function () {
        // Since the scroll strategies can't be singletons, we have to use a global CSS class
        // (`cdk-global-scrollblock`) to make sure that we don't try to disable global
        // scrolling multiple times.
        if (document.documentElement.classList.contains('cdk-global-scrollblock') || this._isEnabled) {
            return false;
        }
        var /** @type {?} */ body = document.body;
        var /** @type {?} */ viewport = this._viewportRuler.getViewportRect();
        return body.scrollHeight > viewport.height || body.scrollWidth > viewport.width;
    };
    return BlockScrollStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Strategy that will update the element position as the user is scrolling.
 */
var RepositionScrollStrategy = (function () {
    /**
     * @param {?} _scrollDispatcher
     * @param {?=} _config
     */
    function RepositionScrollStrategy(_scrollDispatcher, _config) {
        this._scrollDispatcher = _scrollDispatcher;
        this._config = _config;
        this._scrollSubscription = null;
    }
    /**
     * @param {?} overlayRef
     * @return {?}
     */
    RepositionScrollStrategy.prototype.attach = function (overlayRef) {
        if (this._overlayRef) {
            throw getMdScrollStrategyAlreadyAttachedError();
        }
        this._overlayRef = overlayRef;
    };
    /**
     * @return {?}
     */
    RepositionScrollStrategy.prototype.enable = function () {
        var _this = this;
        if (!this._scrollSubscription) {
            var /** @type {?} */ throttle = this._config ? this._config.scrollThrottle : 0;
            this._scrollSubscription = this._scrollDispatcher.scrolled(throttle, function () {
                _this._overlayRef.updatePosition();
            });
        }
    };
    /**
     * @return {?}
     */
    RepositionScrollStrategy.prototype.disable = function () {
        if (this._scrollSubscription) {
            this._scrollSubscription.unsubscribe();
            this._scrollSubscription = null;
        }
    };
    return RepositionScrollStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Options for how an overlay will handle scrolling.
 *
 * Users can provide a custom value for `ScrollStrategyOptions` to replace the default
 * behaviors. This class primarily acts as a factory for ScrollStrategy instances.
 */
var ScrollStrategyOptions = (function () {
    /**
     * @param {?} _scrollDispatcher
     * @param {?} _viewportRuler
     */
    function ScrollStrategyOptions(_scrollDispatcher, _viewportRuler) {
        var _this = this;
        this._scrollDispatcher = _scrollDispatcher;
        this._viewportRuler = _viewportRuler;
        /**
         * Do nothing on scroll.
         */
        this.noop = function () { return new NoopScrollStrategy(); };
        /**
         * Close the overlay as soon as the user scrolls.
         */
        this.close = function () { return new CloseScrollStrategy(_this._scrollDispatcher); };
        /**
         * Block scrolling.
         */
        this.block = function () { return new BlockScrollStrategy(_this._viewportRuler); };
        /**
         * Update the overlay's position on scroll.
         * @param config Configuration to be used inside the scroll strategy.
         * Allows debouncing the reposition calls.
         */
        this.reposition = function (config) { return new RepositionScrollStrategy(_this._scrollDispatcher, config); };
    }
    return ScrollStrategyOptions;
}());
ScrollStrategyOptions.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ScrollStrategyOptions.ctorParameters = function () { return [
    { type: ScrollDispatcher, },
    { type: ViewportRuler, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ScrollDispatchModule = (function () {
    function ScrollDispatchModule() {
    }
    return ScrollDispatchModule;
}());
ScrollDispatchModule.decorators = [
    { type: NgModule, args: [{
                imports: [PlatformModule],
                exports: [Scrollable],
                declarations: [Scrollable],
                providers: [SCROLL_DISPATCHER_PROVIDER, ScrollStrategyOptions],
            },] },
];
/**
 * @nocollapse
 */
ScrollDispatchModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Next overlay unique ID.
 */
var nextUniqueId = 0;
/**
 * The default state for newly created overlays.
 */
var defaultState = new OverlayState();
/**
 * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
 * used as a low-level building building block for other components. Dialogs, tooltips, menus,
 * selects, etc. can all be built using overlays. The service should primarily be used by authors
 * of re-usable components rather than developers building end-user applications.
 *
 * An overlay *is* a PortalHost, so any kind of Portal can be loaded into one.
 */
var Overlay = (function () {
    /**
     * @param {?} scrollStrategies
     * @param {?} _overlayContainer
     * @param {?} _componentFactoryResolver
     * @param {?} _positionBuilder
     * @param {?} _appRef
     * @param {?} _injector
     * @param {?} _ngZone
     */
    function Overlay(scrollStrategies, _overlayContainer, _componentFactoryResolver, _positionBuilder, _appRef, _injector, _ngZone) {
        this.scrollStrategies = scrollStrategies;
        this._overlayContainer = _overlayContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._positionBuilder = _positionBuilder;
        this._appRef = _appRef;
        this._injector = _injector;
        this._ngZone = _ngZone;
    }
    /**
     * Creates an overlay.
     * @param {?=} state State to apply to the overlay.
     * @param {?=} paneClassName
     * @return {?} Reference to the created overlay.
     */
    Overlay.prototype.create = function (state$$1, paneClassName) {
        if (state$$1 === void 0) { state$$1 = defaultState; }
        return this._createOverlayRef(this._createPaneElement(paneClassName), state$$1);
    };
    /**
     * Returns a position builder that can be used, via fluent API,
     * to construct and configure a position strategy.
     * @return {?}
     */
    Overlay.prototype.position = function () {
        return this._positionBuilder;
    };
    /**
     * Creates the DOM element for an overlay and appends it to the overlay container.
     * @param {?=} className
     * @return {?} Newly-created pane element
     */
    Overlay.prototype._createPaneElement = function (className) {
        var /** @type {?} */ pane = document.createElement('div');
        pane.id = "nz-overlay-" + nextUniqueId++;
        pane.classList.add('nz-overlay-pane');
        if (className) {
            var /** @type {?} */ classList = className.split(' ');
            classList.forEach(function (c) {
                pane.classList.add(c);
            });
        }
        this._overlayContainer.getContainerElement().appendChild(pane);
        return pane;
    };
    /**
     * Create a DomPortalHost into which the overlay content can be loaded.
     * @param {?} pane The DOM element to turn into a portal host.
     * @return {?} A portal host for the given DOM element.
     */
    Overlay.prototype._createPortalHost = function (pane) {
        return new DomPortalHost(pane, this._componentFactoryResolver, this._appRef, this._injector);
    };
    /**
     * Creates an OverlayRef for an overlay in the given DOM element.
     * @param {?} pane DOM element for the overlay
     * @param {?} state
     * @return {?}
     */
    Overlay.prototype._createOverlayRef = function (pane, state$$1) {
        var /** @type {?} */ scrollStrategy = state$$1.scrollStrategy || this.scrollStrategies.noop();
        var /** @type {?} */ portalHost = this._createPortalHost(pane);
        return new OverlayRef(portalHost, pane, state$$1, scrollStrategy, this._ngZone);
    };
    return Overlay;
}());
Overlay.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Overlay.ctorParameters = function () { return [
    { type: ScrollStrategyOptions, },
    { type: OverlayContainer, },
    { type: ComponentFactoryResolver, },
    { type: OverlayPositionBuilder, },
    { type: ApplicationRef, },
    { type: Injector, },
    { type: NgZone, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
/**
 * Default set of positions for the overlay. Follows the behavior of a dropdown.
 */
var defaultPositionList = [
    new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
    new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' }),
];
/**
 * Directive applied to an element to make it usable as an origin for an Overlay using a
 * ConnectedPositionStrategy.
 */
var OverlayOrigin = (function () {
    /**
     * @param {?} elementRef
     */
    function OverlayOrigin(elementRef) {
        this.elementRef = elementRef;
    }
    return OverlayOrigin;
}());
OverlayOrigin.decorators = [
    { type: Directive, args: [{
                selector: '[nz-overlay-origin]',
                exportAs: 'nzOverlayOrigin',
            },] },
];
/**
 * @nocollapse
 */
OverlayOrigin.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
/**
 * Directive to facilitate declarative creation of an Overlay using a ConnectedPositionStrategy.
 */
var ConnectedOverlayDirective = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _renderer
     * @param {?} templateRef
     * @param {?} viewContainerRef
     * @param {?} _dir
     */
    function ConnectedOverlayDirective(_overlay, _renderer, templateRef, viewContainerRef, _dir) {
        this._overlay = _overlay;
        this._renderer = _renderer;
        this._dir = _dir;
        this._hasBackdrop = false;
        this._offsetX = 0;
        this._offsetY = 0;
        /**
         * Strategy to be used when handling scroll events while the overlay is open.
         */
        this.scrollStrategy = this._overlay.scrollStrategies.reposition();
        /**
         * Whether the overlay is open.
         */
        this.open = false;
        /**
         * Event emitted when the backdrop is clicked.
         */
        this.backdropClick = new EventEmitter();
        /**
         * Event emitted when the position has changed.
         */
        this.positionChange = new EventEmitter();
        /**
         * Event emitted when the overlay has been attached.
         */
        this.attach = new EventEmitter();
        /**
         * Event emitted when the overlay has been detached.
         */
        this.detach = new EventEmitter();
        this._templatePortal = new TemplatePortal(templateRef, viewContainerRef);
    }
    Object.defineProperty(ConnectedOverlayDirective.prototype, "offsetX", {
        /**
         * The offset in pixels for the overlay connection point on the x-axis
         * @return {?}
         */
        get: function () {
            return this._offsetX;
        },
        /**
         * @param {?} offsetX
         * @return {?}
         */
        set: function (offsetX) {
            this._offsetX = offsetX;
            if (this._position) {
                this._position.withOffsetX(offsetX);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "offsetY", {
        /**
         * The offset in pixels for the overlay connection point on the y-axis
         * @return {?}
         */
        get: function () {
            return this._offsetY;
        },
        /**
         * @param {?} offsetY
         * @return {?}
         */
        set: function (offsetY) {
            this._offsetY = offsetY;
            if (this._position) {
                this._position.withOffsetY(offsetY);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "hasBackdrop", {
        /**
         * Whether or not the overlay should attach a backdrop.
         * @return {?}
         */
        get: function () {
            return this._hasBackdrop;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._hasBackdrop = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "overlayRef", {
        /**
         * The associated overlay reference.
         * @return {?}
         */
        get: function () {
            return this._overlayRef;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "dir", {
        /**
         * The element's layout direction.
         * @return {?}
         */
        get: function () {
            return this._dir ? this._dir.value : 'ltr';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ConnectedOverlayDirective.prototype.ngOnDestroy = function () {
        this._destroyOverlay();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    ConnectedOverlayDirective.prototype.ngOnChanges = function (changes) {
        if (changes['open']) {
            this.open ? this._attachOverlay() : this._detachOverlay();
        }
    };
    /**
     * Creates an overlay
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._createOverlay = function () {
        if (!this.positions || !this.positions.length) {
            this.positions = defaultPositionList;
        }
        this._overlayRef = this._overlay.create(this._buildConfig(), this.paneClass);
    };
    /**
     * Builds the overlay config based on the directive's inputs
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._buildConfig = function () {
        var /** @type {?} */ overlayConfig = new OverlayState();
        if (this.width || this.width === 0) {
            overlayConfig.width = this.width;
        }
        if (this.height || this.height === 0) {
            overlayConfig.height = this.height;
        }
        if (this.minWidth || this.minWidth === 0) {
            overlayConfig.minWidth = this.minWidth;
        }
        if (this.minHeight || this.minHeight === 0) {
            overlayConfig.minHeight = this.minHeight;
        }
        overlayConfig.hasBackdrop = this.hasBackdrop;
        if (this.backdropClass) {
            overlayConfig.backdropClass = this.backdropClass;
        }
        this._position = (this._createPositionStrategy());
        overlayConfig.positionStrategy = this._position;
        overlayConfig.scrollStrategy = this.scrollStrategy;
        return overlayConfig;
    };
    /**
     * Returns the position strategy of the overlay to be set on the overlay config
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._createPositionStrategy = function () {
        var /** @type {?} */ pos = this.positions[0];
        var /** @type {?} */ originPoint = { originX: pos.originX, originY: pos.originY };
        var /** @type {?} */ overlayPoint = { overlayX: pos.overlayX, overlayY: pos.overlayY };
        var /** @type {?} */ strategy = this._overlay.position()
            .connectedTo(this.origin.elementRef, originPoint, overlayPoint)
            .withOffsetX(this.offsetX)
            .withOffsetY(this.offsetY);
        this._handlePositionChanges(strategy);
        return strategy;
    };
    /**
     * @param {?} strategy
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._handlePositionChanges = function (strategy) {
        var _this = this;
        for (var /** @type {?} */ i = 1; i < this.positions.length; i++) {
            strategy.withFallbackPosition({ originX: this.positions[i].originX, originY: this.positions[i].originY }, { overlayX: this.positions[i].overlayX, overlayY: this.positions[i].overlayY });
        }
        this._positionSubscription =
            strategy.onPositionChange.subscribe(function (pos) { return _this.positionChange.emit(pos); });
    };
    /**
     * Attaches the overlay and subscribes to backdrop clicks if backdrop exists
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._attachOverlay = function () {
        var _this = this;
        if (!this._overlayRef) {
            this._createOverlay();
        }
        this._position.withDirection(this.dir);
        this._overlayRef.getState().direction = this.dir;
        this._initEscapeListener();
        if (!this._overlayRef.hasAttached()) {
            this._overlayRef.attach(this._templatePortal);
            this.attach.emit();
        }
        if (this.hasBackdrop) {
            this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function () {
                _this.backdropClick.emit();
            });
        }
    };
    /**
     * Detaches the overlay and unsubscribes to backdrop clicks if backdrop exists
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._detachOverlay = function () {
        if (this._overlayRef) {
            this._overlayRef.detach();
            this.detach.emit();
        }
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
            this._backdropSubscription = null;
        }
        if (this._escapeListener) {
            this._escapeListener();
        }
    };
    /**
     * Destroys the overlay created by this directive.
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._destroyOverlay = function () {
        if (this._overlayRef) {
            this._overlayRef.dispose();
        }
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
        }
        if (this._positionSubscription) {
            this._positionSubscription.unsubscribe();
        }
        if (this._escapeListener) {
            this._escapeListener();
        }
    };
    /**
     * Sets the event listener that closes the overlay when pressing Escape.
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._initEscapeListener = function () {
        var _this = this;
        this._escapeListener = this._renderer.listen('document', 'keydown', function (event) {
            if (event.keyCode === ESCAPE) {
                _this._detachOverlay();
            }
        });
    };
    return ConnectedOverlayDirective;
}());
ConnectedOverlayDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-connected-overlay]',
                exportAs: 'nzConnectedOverlay'
            },] },
];
/**
 * @nocollapse
 */
ConnectedOverlayDirective.ctorParameters = function () { return [
    { type: Overlay, },
    { type: Renderer2, },
    { type: TemplateRef, },
    { type: ViewContainerRef, },
    { type: Directionality, decorators: [{ type: Optional },] },
]; };
ConnectedOverlayDirective.propDecorators = {
    'origin': [{ type: Input },],
    'positions': [{ type: Input },],
    'offsetX': [{ type: Input },],
    'offsetY': [{ type: Input },],
    'width': [{ type: Input },],
    'height': [{ type: Input },],
    'minWidth': [{ type: Input },],
    'minHeight': [{ type: Input },],
    'backdropClass': [{ type: Input },],
    'paneClass': [{ type: Input },],
    'scrollStrategy': [{ type: Input },],
    'open': [{ type: Input },],
    'hasBackdrop': [{ type: Input },],
    'backdropClick': [{ type: Output },],
    'positionChange': [{ type: Output },],
    'attach': [{ type: Output },],
    'detach': [{ type: Output },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The FullscreenOverlayContainer is the alternative to OverlayContainer
 * that supports correct displaying of overlay elements in Fullscreen mode
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullScreen
 * It should be provided in the root component that way:
 * providers: [
 *   {provide: OverlayContainer, useClass: FullscreenOverlayContainer}
 * ],
 */
var FullscreenOverlayContainer = (function (_super) {
    tslib_1.__extends(FullscreenOverlayContainer, _super);
    function FullscreenOverlayContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._createContainer = function () {
        var _this = this;
        _super.prototype._createContainer.call(this);
        this._adjustParentForFullscreenChange();
        this._addFullscreenChangeListener(function () { return _this._adjustParentForFullscreenChange(); });
    };
    /**
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._adjustParentForFullscreenChange = function () {
        if (!this._containerElement) {
            return;
        }
        var /** @type {?} */ fullscreenElement = this.getFullscreenElement();
        var /** @type {?} */ parent = fullscreenElement || document.body;
        parent.appendChild(this._containerElement);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._addFullscreenChangeListener = function (fn) {
        if (document.fullscreenEnabled) {
            document.addEventListener('fullscreenchange', fn);
        }
        else if (document.webkitFullscreenEnabled) {
            document.addEventListener('webkitfullscreenchange', fn);
        }
        else if (((document)).mozFullScreenEnabled) {
            document.addEventListener('mozfullscreenchange', fn);
        }
        else if (((document)).msFullscreenEnabled) {
            document.addEventListener('MSFullscreenChange', fn);
        }
    };
    /**
     * When the page is put into fullscreen mode, a specific element is specified.
     * Only that element and its children are visible when in fullscreen mode.
     * @return {?}
     */
    FullscreenOverlayContainer.prototype.getFullscreenElement = function () {
        return document.fullscreenElement ||
            document.webkitFullscreenElement ||
            ((document)).mozFullScreenElement ||
            ((document)).msFullscreenElement ||
            null;
    };
    return FullscreenOverlayContainer;
}(OverlayContainer));
FullscreenOverlayContainer.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
FullscreenOverlayContainer.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var OVERLAY_PROVIDERS = [
    Overlay,
    OverlayPositionBuilder,
    VIEWPORT_RULER_PROVIDER,
    OVERLAY_CONTAINER_PROVIDER,
];
var OverlayModule = (function () {
    function OverlayModule() {
    }
    return OverlayModule;
}());
OverlayModule.decorators = [
    { type: NgModule, args: [{
                imports: [ScrollDispatchModule],
                exports: [ConnectedOverlayDirective, OverlayOrigin, ScrollDispatchModule],
                declarations: [ConnectedOverlayDirective, OverlayOrigin],
                providers: [OVERLAY_PROVIDERS],
            },] },
];
/**
 * @nocollapse
 */
OverlayModule.ctorParameters = function () { return []; };
var NzOptionPipe = (function () {
    function NzOptionPipe() {
    }
    /**
     * @param {?} options
     * @param {?} value
     * @return {?}
     */
    NzOptionPipe.prototype.transform = function (options, value) {
        if (value.searchText) {
            var /** @type {?} */ _options = options.filter(function (option) { return option.nzLabel && (option.nzLabel.toLowerCase().indexOf(value.searchText.toLowerCase()) !== -1); });
            if (value.tags) {
                _options = options.filter(function (option) { return option.nzLabel && (option.nzLabel.toLowerCase() === value.searchText.toLowerCase()); });
            }
            if (_options.length) {
                return _options;
            }
            else {
                return ([{
                        nzValue: value.value,
                        _value: value.value,
                        nzDisabled: value.disabled,
                        _disabled: value.disabled,
                        nzLabel: value.notFoundContent,
                        _label: value.notFoundContent,
                    }]);
            }
        }
        else {
            return options;
        }
    };
    return NzOptionPipe;
}());
NzOptionPipe.decorators = [
    { type: Pipe, args: [{ name: 'nzOptionPipe' },] },
];
/**
 * @nocollapse
 */
NzOptionPipe.ctorParameters = function () { return []; };
var DropDownAnimation = trigger('dropDownAnimation', [
    state('bottom', style({
        opacity: 1,
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%'
    })),
    transition('void => bottom', [
        style({
            opacity: 0,
            transform: 'scaleY(0)',
            transformOrigin: '0% 0%'
        }),
        animate('150ms cubic-bezier(0.25, 0.8, 0.25, 1)')
    ]),
    state('top', style({
        opacity: 1,
        transform: 'scaleY(1)',
        transformOrigin: '0% 100%'
    })),
    transition('void => top', [
        style({
            opacity: 0,
            transform: 'scaleY(0)',
            transformOrigin: '0% 100%'
        }),
        animate('150ms cubic-bezier(0.25, 0.8, 0.25, 1)')
    ]),
    transition('* => void', [
        animate('250ms 100ms linear', style({ opacity: 0 }))
    ])
]);
var TagAnimation = trigger('tagAnimation', [
    state('*', style({ opacity: 1, transform: 'scale(1)' })),
    transition('void => *', [
        style({ opacity: 0, transform: 'scale(0)' }),
        animate('150ms linear')
    ]),
    state('void', style({ opacity: 0, transform: 'scale(0)' })),
    transition('* => void', [
        style({ opacity: 1, transform: 'scale(1)' }),
        animate('150ms linear')
    ])
]);
/**
 * complex but work well
 * TODO: rebuild latter
 */
var NzSelectComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function NzSelectComponent(_elementRef, _renderer) {
        var _this = this;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._prefixCls = 'ant-select';
        this._classList = [];
        this._dropDownPrefixCls = this._prefixCls + "-dropdown";
        this._selectionPrefixCls = this._prefixCls + "-selection";
        this._placeholder = 'Placeholder';
        this._notFoundContent = 'Not found';
        this._isOpen = false;
        this._disabled = false;
        this._showSearch = false;
        this._isTags = false;
        this._searchText = '';
        this._triggerWidth = 0;
        this._selectedOptions = new Set();
        this._options = [];
        this._cacheOptions = [];
        this._filterOptions = [];
        this._tagsOptions = [];
        this._isMultiInit = false;
        this._dropDownPosition = 'bottom';
        this._isMultiple = false;
        this._composing = false;
        this._keepUnListOptions = false;
        this._allowClear = false;
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.nzSearchChange = new EventEmitter();
        this.nzOpenChange = new EventEmitter();
        this.nzFilter = true;
        this.nzMaxMultiple = Infinity;
        /**
         * new nz-option insert or new tags insert
         */
        this.addOption = function (option) {
            _this._options.push(option);
            if (!_this._isTags) {
                if (option.nzValue) {
                    _this.updateSelectedOption(_this._value);
                }
                else {
                    _this.forceUpdateSelectedOption(_this._value);
                }
            }
        };
        /**
         * cancel select multiple option
         */
        this.unSelectMultipleOption = function (option, $event, emitChange) {
            if (emitChange === void 0) { emitChange = true; }
            _this._operatingMultipleOption = option;
            _this._selectedOptions.delete(option);
            if (emitChange) {
                _this.emitMultipleOptions();
            }
            // 对Tag进行特殊处理
            if (_this._isTags && (_this._options.indexOf(option) !== -1) && (_this._tagsOptions.indexOf(option) !== -1)) {
                _this.removeOption(option);
                _this._tagsOptions.splice(_this._tagsOptions.indexOf(option), 1);
            }
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
        };
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzSelectComponent.prototype, "nzAllowClear", {
        /**
         * @return {?}
         */
        get: function () {
            return this._allowClear;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._allowClear = true;
            }
            else {
                this._allowClear = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSelectComponent.prototype, "nzKeepUnListOptions", {
        /**
         * @return {?}
         */
        get: function () {
            return this._keepUnListOptions;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._keepUnListOptions = true;
            }
            else {
                this._keepUnListOptions = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSelectComponent.prototype, "nzMode", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._mode = value;
            if (this._mode === 'multiple') {
                this.nzMultiple = true;
            }
            else if (this._mode === 'tags') {
                this.nzTags = true;
            }
            else if (this._mode === 'combobox') {
                this.nzShowSearch = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSelectComponent.prototype, "nzMultiple", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isMultiple;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._isMultiple = value;
            if (this._isMultiple) {
                this.nzShowSearch = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSelectComponent.prototype, "nzPlaceHolder", {
        /**
         * @return {?}
         */
        get: function () {
            return this._placeholder;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._placeholder = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzSelectComponent.prototype, "nzNotFoundContent", {
        /**
         * @return {?}
         */
        get: function () {
            return this._notFoundContent;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._notFoundContent = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzSelectComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._size = { large: 'lg', small: 'sm' }[value];
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzSelectComponent.prototype, "nzShowSearch", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showSearch;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._showSearch = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzSelectComponent.prototype, "nzTags", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isTags;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._isTags = value;
            this.nzMultiple = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzSelectComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
            this.closeDropDown();
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzSelectComponent.prototype, "nzOpen", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isOpen;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._isOpen === value) {
                return;
            }
            if (value === true) {
                this.scrollToActive();
                if (!this._triggerWidth) {
                    this._setTriggerWidth();
                }
            }
            this._isOpen = value;
            this.nzOpenChange.emit(this._isOpen);
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * nz-option remove or tags remove
     * @param {?} option
     * @return {?}
     */
    NzSelectComponent.prototype.removeOption = function (option) {
        this._options.splice(this._options.indexOf(option), 1);
        if (!this._isTags) {
            this.forceUpdateSelectedOption(this._value);
        }
    };
    /**
     * dropdown position changed
     * @param {?} position
     * @return {?}
     */
    NzSelectComponent.prototype.onPositionChange = function (position) {
        this._dropDownPosition = position.connectionPair.originY;
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.compositionStart = function () {
        this._composing = true;
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.compositionEnd = function () {
        this._composing = false;
    };
    /**
     * clear single selected option
     * @param {?=} $event
     * @return {?}
     */
    NzSelectComponent.prototype.clearSelect = function ($event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this._selectedOption = null;
        this.nzValue = null;
        this.onChange(null);
    };
    /**
     * click dropdown option by user
     * @param {?} option
     * @param {?=} $event
     * @return {?}
     */
    NzSelectComponent.prototype.clickOption = function (option, $event) {
        if (!option) {
            return;
        }
        this.chooseOption(option, true, $event);
        this.clearSearchText();
        if (!this._isMultiple) {
            this.nzOpen = false;
        }
    };
    /**
     * choose option
     * @param {?} option
     * @param {?=} isUserClick
     * @param {?=} $event
     * @return {?}
     */
    NzSelectComponent.prototype.chooseOption = function (option, isUserClick, $event) {
        if (isUserClick === void 0) { isUserClick = false; }
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this._activeFilterOption = option;
        if (option && !option.nzDisabled) {
            if (!this.nzMultiple) {
                this._selectedOption = option;
                this._value = option.nzValue;
                if (isUserClick) {
                    this.onChange(option.nzValue);
                }
            }
            else {
                if (isUserClick) {
                    this.isInSet(this._selectedOptions, option) ? this.unSelectMultipleOption(option) : this.selectMultipleOption(option);
                }
            }
        }
    };
    /**
     * @param {?} element
     * @param {?} text
     * @return {?}
     */
    NzSelectComponent.prototype.updateWidth = function (element, text) {
        var _this = this;
        if (text) {
            /** wait for scroll width change */
            setTimeout(function (_) {
                _this._renderer.setStyle(element, 'width', element.scrollWidth + "px");
            });
        }
        else {
            this._renderer.removeStyle(element, 'width');
        }
    };
    /**
     * determine if option in set
     * @param {?} set
     * @param {?} option
     * @return {?}
     */
    NzSelectComponent.prototype.isInSet = function (set, option) {
        return (((Array.from(set))).find(function (data) { return data.nzValue === option.nzValue; }));
    };
    /**
     * select multiple option
     * @param {?} option
     * @param {?=} $event
     * @return {?}
     */
    NzSelectComponent.prototype.selectMultipleOption = function (option, $event) {
        /** if tags do push to tag option */
        if (this._isTags && (this._options.indexOf(option) === -1) && (this._tagsOptions.indexOf(option) === -1)) {
            this.addOption(option);
            this._tagsOptions.push(option);
        }
        this._operatingMultipleOption = option;
        if (this._selectedOptions.size < this.nzMaxMultiple) {
            this._selectedOptions.add(option);
        }
        this.emitMultipleOptions();
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
    };
    /**
     * emit multiple options
     * @return {?}
     */
    NzSelectComponent.prototype.emitMultipleOptions = function () {
        if (this._isMultiInit) {
            return;
        }
        var /** @type {?} */ arrayOptions = (Array.from(this._selectedOptions));
        this.onChange(arrayOptions.map(function (item) { return item.nzValue; }));
    };
    /**
     * update selected option when add remove option etc
     * @param {?} currentModelValue
     * @param {?=} triggerByNgModel
     * @return {?}
     */
    NzSelectComponent.prototype.updateSelectedOption = function (currentModelValue, triggerByNgModel) {
        var _this = this;
        if (triggerByNgModel === void 0) { triggerByNgModel = false; }
        if (currentModelValue == null) {
            return;
        }
        if (this.nzMultiple) {
            var /** @type {?} */ selectedOptions = this._options.filter(function (item) {
                return (item != null) && (currentModelValue.indexOf(item.nzValue) !== -1);
            });
            if ((this.nzKeepUnListOptions || this.nzTags) && (!triggerByNgModel)) {
                selectedOptions.forEach(function (option) {
                    if (!_this._selectedOptions.has(option)) {
                        _this._selectedOptions.add(option);
                    }
                });
            }
            else {
                this._selectedOptions = new Set();
                selectedOptions.forEach(function (option) {
                    _this._selectedOptions.add(option);
                });
            }
        }
        else {
            var /** @type {?} */ selectedOption = this._options.filter(function (item) {
                return (item != null) && (item.nzValue === currentModelValue);
            });
            this.chooseOption(selectedOption[0]);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSelectComponent.prototype.forceUpdateSelectedOption = function (value) {
        var _this = this;
        /** trigger dirty check */
        setTimeout(function (_) {
            _this.updateSelectedOption(value);
        });
    };
    Object.defineProperty(NzSelectComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateValue(value);
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?=} emitChange
     * @return {?}
     */
    NzSelectComponent.prototype.clearAllSelectedOption = function (emitChange) {
        var _this = this;
        if (emitChange === void 0) { emitChange = true; }
        this._selectedOptions.forEach(function (item) {
            _this.unSelectMultipleOption(item, null, emitChange);
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NzSelectComponent.prototype.handleKeyEnterEvent = function (event) {
        /** when composing end */
        if (!this._composing && this._isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.updateFilterOption(false);
            this.clickOption(this._activeFilterOption);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NzSelectComponent.prototype.handleKeyBackspaceEvent = function (event) {
        if ((!this._searchText) && (!this._composing) && (this._isMultiple)) {
            event.preventDefault();
            var /** @type {?} */ lastOption = Array.from(this._selectedOptions).pop();
            this.unSelectMultipleOption(lastOption);
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzSelectComponent.prototype.handleKeyDownEvent = function ($event) {
        if (this._isOpen) {
            $event.preventDefault();
            $event.stopPropagation();
            this._activeFilterOption = this.nextOption(this._activeFilterOption, this._filterOptions);
            this.scrollToActive();
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzSelectComponent.prototype.handleKeyUpEvent = function ($event) {
        if (this._isOpen) {
            $event.preventDefault();
            $event.stopPropagation();
            this._activeFilterOption = this.preOption(this._activeFilterOption, this._filterOptions);
            this.scrollToActive();
        }
    };
    /**
     * @param {?} option
     * @param {?} options
     * @return {?}
     */
    NzSelectComponent.prototype.preOption = function (option, options) {
        return options[options.indexOf(option) - 1] || options[options.length - 1];
    };
    /**
     * @param {?} option
     * @param {?} options
     * @return {?}
     */
    NzSelectComponent.prototype.nextOption = function (option, options) {
        return options[options.indexOf(option) + 1] || options[0];
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.clearSearchText = function () {
        this._searchText = '';
        this.updateFilterOption();
    };
    /**
     * @param {?=} updateActiveFilter
     * @return {?}
     */
    NzSelectComponent.prototype.updateFilterOption = function (updateActiveFilter) {
        if (updateActiveFilter === void 0) { updateActiveFilter = true; }
        if (this.nzFilter) {
            this._filterOptions = new NzOptionPipe().transform(this._options, {
                'searchText': this._searchText,
                'tags': this._isTags,
                'notFoundContent': this._isTags ? this._searchText : this._notFoundContent,
                'disabled': !this._isTags,
                'value': this._isTags ? this._searchText : 'disabled'
            });
        }
        else {
            this._filterOptions = this._options;
        }
        /** TODO: cause pre & next key selection not work */
        if (updateActiveFilter && !this._selectedOption) {
            this._activeFilterOption = this._filterOptions[0];
        }
    };
    /**
     * @param {?} searchValue
     * @return {?}
     */
    NzSelectComponent.prototype.onSearchChange = function (searchValue) {
        this.nzSearchChange.emit(searchValue);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzSelectComponent.prototype.onClick = function (e) {
        var _this = this;
        e.preventDefault();
        if (!this._disabled) {
            this.nzOpen = !this.nzOpen;
            if (this.nzShowSearch) {
                /** wait for search display */
                setTimeout(function (_) {
                    _this.searchInputElementRef.nativeElement.focus();
                });
            }
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzSelectComponent.prototype.onKeyDown = function (e) {
        var _this = this;
        var /** @type {?} */ keyCode = e.keyCode;
        if (keyCode === TAB && this.nzOpen) {
            this.nzOpen = false;
            return;
        }
        if ((keyCode !== DOWN_ARROW && keyCode !== ENTER) || this.nzOpen) {
            return;
        }
        e.preventDefault();
        if (!this._disabled) {
            this.nzOpen = true;
            if (this.nzShowSearch) {
                /** wait for search display */
                setTimeout(function (_) {
                    _this.searchInputElementRef.nativeElement.focus();
                });
            }
        }
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.closeDropDown = function () {
        if (!this.nzOpen) {
            return;
        }
        this.onTouched();
        if (this.nzMultiple) {
            this._renderer.removeStyle(this.searchInputElementRef.nativeElement, 'width');
        }
        this.clearSearchText();
        this.nzOpen = false;
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.setClassMap = function () {
        var _this = this;
        this._classList.forEach(function (_className) {
            _this._renderer.removeClass(_this._el, _className);
        });
        this._classList = [
            this._prefixCls,
            (this._mode === 'combobox') && this._prefixCls + "-combobox",
            (!this._disabled) && this._prefixCls + "-enabled",
            (this._disabled) && this._prefixCls + "-disabled",
            this._isOpen && this._prefixCls + "-open",
            this._showSearch && this._prefixCls + "-show-search",
            this._size && this._prefixCls + "-" + this._size
        ].filter(function (item) {
            return !!item;
        });
        this._classList.forEach(function (_className) {
            _this._renderer.addClass(_this._el, _className);
        });
        this._selectionClassMap = (_a = {},
            _a[this._selectionPrefixCls] = true,
            _a[this._selectionPrefixCls + "--single"] = !this.nzMultiple,
            _a[this._selectionPrefixCls + "--multiple"] = this.nzMultiple,
            _a);
        var _a;
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.setDropDownClassMap = function () {
        this._dropDownClassMap = (_a = {},
            _a[this._dropDownPrefixCls] = true,
            _a['component-select'] = this._mode === 'combobox',
            _a[this._dropDownPrefixCls + "--single"] = !this.nzMultiple,
            _a[this._dropDownPrefixCls + "--multiple"] = this.nzMultiple,
            _a[this._dropDownPrefixCls + "-placement-bottomLeft"] = this._dropDownPosition === 'bottom',
            _a[this._dropDownPrefixCls + "-placement-topLeft"] = this._dropDownPosition === 'top',
            _a);
        var _a;
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.scrollToActive = function () {
        var _this = this;
        /** wait for dropdown display */
        setTimeout(function (_) {
            if (_this._activeFilterOption && _this._activeFilterOption.nzValue) {
                var /** @type {?} */ index = _this._filterOptions.findIndex(function (option) { return option.nzValue === _this._activeFilterOption.nzValue; });
                try {
                    var /** @type {?} */ scrollPane = _this.dropdownUl.nativeElement.children[index];
                    scrollPane.scrollIntoViewIfNeeded(false);
                }
                catch (e) {
                }
            }
        });
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.flushComponentState = function () {
        this.updateFilterOption();
        if (!this.nzMultiple) {
            this.updateSelectedOption(this._value);
        }
        else {
            if (this._value) {
                this.updateSelectedOption(this._value);
            }
        }
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype._setTriggerWidth = function () {
        this._triggerWidth = this._getTriggerRect().width;
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype._getTriggerRect = function () {
        return this.trigger.nativeElement.getBoundingClientRect();
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSelectComponent.prototype.writeValue = function (value) {
        this._updateValue(value, false);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzSelectComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzSelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzSelectComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.ngAfterContentInit = function () {
        if (this._value != null) {
            this.flushComponentState();
        }
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.ngOnInit = function () {
        this.updateFilterOption();
        this.setClassMap();
        this.setDropDownClassMap();
    };
    /**
     * @return {?}
     */
    NzSelectComponent.prototype.ngAfterContentChecked = function () {
        if (this._cacheOptions !== this._options) {
            /** update filter option after every content check cycle */
            this.updateFilterOption();
            this._cacheOptions = this._options;
        }
        else {
            this.updateFilterOption(false);
        }
    };
    /**
     * @param {?} value
     * @param {?=} emitChange
     * @return {?}
     */
    NzSelectComponent.prototype._updateValue = function (value, emitChange) {
        if (emitChange === void 0) { emitChange = true; }
        if (this._value === value) {
            return;
        }
        if ((value == null) && this.nzMultiple) {
            this._value = [];
        }
        else {
            this._value = value;
        }
        if (!this.nzMultiple) {
            if (value == null) {
                this._selectedOption = null;
            }
            else {
                this.updateSelectedOption(value);
            }
        }
        else {
            if (value) {
                if (value.length === 0) {
                    this.clearAllSelectedOption(emitChange);
                }
                else {
                    this.updateSelectedOption(value, true);
                }
            }
            else if (value == null) {
                this.clearAllSelectedOption(emitChange);
            }
        }
    };
    return NzSelectComponent;
}());
NzSelectComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-select',
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzSelectComponent; }),
                        multi: true
                    }
                ],
                animations: [
                    DropDownAnimation,
                    TagAnimation
                ],
                template: "\n    <div\n      tabindex=\"0\"\n      #trigger\n      nz-overlay-origin\n      #origin=\"nzOverlayOrigin\"\n      [ngClass]=\"_selectionClassMap\"\n      (keydown.Enter)=\"handleKeyEnterEvent($event)\"\n      (keydown.Backspace)=\"handleKeyBackspaceEvent($event)\"\n      (keydown.ArrowUp)=\"handleKeyUpEvent($event)\"\n      (keydown.ArrowDown)=\"handleKeyDownEvent($event)\">\n      <div class=\"ant-select-selection__rendered\" *ngIf=\"!nzShowSearch\">\n        <div class=\"ant-select-selection-selected-value\">\n          {{_selectedOption?.nzLabel}}\n        </div>\n      </div>\n      <div class=\"ant-select-selection__rendered\" *ngIf=\"nzShowSearch\">\n        <div\n          [hidden]=\"_searchText||(!nzOpen&&_selectedOption)||_selectedOptions.size\"\n          class=\"ant-select-selection__placeholder\">\n          <ng-template [ngIf]=\"(!_composing)&&_selectedOption\">\n            {{_selectedOption.nzLabel}}\n          </ng-template>\n          <ng-template [ngIf]=\"(!_composing)&&(!_selectedOption)\">\n            {{nzPlaceHolder}}\n          </ng-template>\n        </div>\n        <ul *ngIf=\"nzMultiple\">\n          <li\n            *ngFor=\"let option of _selectedOptions\"\n            [@tagAnimation] [attr.title]=\"option?.nzValue\"\n            class=\"ant-select-selection__choice\" style=\"-webkit-user-select: none;\">\n            <div class=\"ant-select-selection__choice__content\">{{option?.nzLabel}}</div><!----><span class=\"ant-select-selection__choice__remove\" (click)=\"unSelectMultipleOption(option,$event)\"></span>\n          </li>\n          <li class=\"ant-select-search ant-select-search--inline\">\n            <div class=\"ant-select-search__field__wrap\">\n              <input\n                class=\"ant-select-search__field\"\n                (compositionstart)=\"compositionStart()\"\n                (compositionend)=\"compositionEnd();updateWidth(searchInput,_searchText);\"\n                [(ngModel)]=\"_searchText\"\n                (ngModelChange)=\"updateFilterOption();onSearchChange($event);\"\n                (keydown)=\"updateWidth(searchInput,_searchText)\"\n                (blur)=\"onTouched()\"\n                #searchInput>\n              <span class=\"ant-select-search__field__mirror\"></span></div>\n          </li>\n        </ul>\n        <div\n          *ngIf=\"!nzMultiple\"\n          class=\"ant-select-selection-selected-value\"\n          [hidden]=\"!(_selectedOption?.nzLabel)||nzOpen\">\n          {{_selectedOption?.nzLabel}}\n        </div>\n        <div *ngIf=\"!nzMultiple\" [hidden]=\"!nzOpen\" class=\"ant-select-search ant-select-search--inline\">\n          <div class=\"ant-select-search__field__wrap\">\n            <input\n              class=\"ant-select-search__field\"\n              (blur)=\"onTouched()\"\n              (compositionstart)=\"compositionStart()\"\n              (compositionend)=\"compositionEnd()\"\n              [(ngModel)]=\"_searchText\"\n              (ngModelChange)=\"updateFilterOption();onSearchChange($event);\"\n              #searchInput>\n            <span class=\"ant-select-search__field__mirror\"></span>\n          </div>\n        </div>\n      </div>\n      <span\n        (click)=\"onTouched();clearSelect($event)\"\n        class=\"ant-select-selection__clear\"\n        style=\"-webkit-user-select: none;\"\n        *ngIf=\"_selectedOption?.nzLabel&&nzAllowClear&&!nzMultiple\">\n      </span>\n      <span class=\"ant-select-arrow\"><b></b></span></div>\n    <ng-template\n      nz-connected-overlay\n      hasBackdrop\n      [origin]=\"origin\"\n      (backdropClick)=\"closeDropDown()\"\n      (detach)=\"closeDropDown();\"\n      (positionChange)=\"onPositionChange($event)\"\n      [width]=\"_triggerWidth\"\n      [open]=\"_isOpen\">\n      <div\n        [ngClass]=\"_dropDownClassMap\" [@dropDownAnimation]=\"_dropDownPosition\">\n        <div style=\"overflow: auto;\">\n          <ul class=\"ant-select-dropdown-menu ant-select-dropdown-menu-vertical ant-select-dropdown-menu-root\" #dropdownUl>\n            <li\n              *ngFor=\"let option of _filterOptions\"\n              [class.ant-select-dropdown-menu-item-disabled]=\"option.nzDisabled\"\n              [class.ant-select-dropdown-menu-item-active]=\"option.nzValue == _activeFilterOption?.nzValue\"\n              [class.ant-select-dropdown-menu-item-selected]=\"(option.nzValue==(_selectedOption?.nzValue))||(isInSet(_selectedOptions,option))\"\n              class=\"ant-select-dropdown-menu-item\"\n              (click)=\"clickOption(option,$event)\">\n              {{option.nzLabel}}\n            </li>\n          </ul>\n        </div>\n      </div>\n    </ng-template>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-select {\n  box-sizing: border-box;\n  display: inline-block;\n  position: relative;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n}\n.ant-select > ul > li > a {\n  padding: 0;\n  background-color: #fff;\n}\n.ant-select-arrow {\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  line-height: 1;\n  margin-top: -6px;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 9px 9;\n  transform: scale(0.75) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n.ant-select-arrow:before {\n  display: block;\n  font-family: \"anticon\" !important;\n}\n:root .ant-select-arrow {\n  filter: none;\n}\n:root .ant-select-arrow {\n  font-size: 12px;\n}\n.ant-select-arrow * {\n  display: none;\n}\n.ant-select-arrow:before {\n  content: '\\e61d';\n  transition: transform 0.2s ease;\n}\n.ant-select-selection {\n  outline: none;\n  user-select: none;\n  box-sizing: border-box;\n  display: block;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select-selection:hover {\n  border-color: #49a9ee;\n}\n.ant-select-focused .ant-select-selection,\n.ant-select-selection:focus,\n.ant-select-selection:active {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-select-selection__clear {\n  display: inline-block;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n  opacity: 0;\n  position: absolute;\n  right: 8px;\n  z-index: 1;\n  background: #fff;\n  top: 50%;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  line-height: 12px;\n  cursor: pointer;\n  transition: color 0.3s ease, opacity 0.15s ease;\n}\n.ant-select-selection__clear:before {\n  display: block;\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e62e\";\n}\n.ant-select-selection__clear:hover {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-select-selection:hover .ant-select-selection__clear {\n  opacity: 1;\n}\n.ant-select-selection-selected-value {\n  float: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  padding-right: 14px;\n}\n.ant-select-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-disabled .ant-select-selection {\n  background: #f7f7f7;\n  cursor: not-allowed;\n}\n.ant-select-disabled .ant-select-selection:hover,\n.ant-select-disabled .ant-select-selection:focus,\n.ant-select-disabled .ant-select-selection:active {\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n.ant-select-disabled .ant-select-selection__clear {\n  display: none;\n  visibility: hidden;\n  pointer-events: none;\n}\n.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice {\n  background: #eee;\n  color: #aaa;\n  padding-right: 10px;\n}\n.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  display: none;\n}\n.ant-select-selection--single {\n  height: 28px;\n  position: relative;\n  cursor: pointer;\n}\n.ant-select-selection__rendered {\n  display: block;\n  margin-left: 7px;\n  margin-right: 7px;\n  position: relative;\n  line-height: 26px;\n}\n.ant-select-selection__rendered:after {\n  content: '.';\n  visibility: hidden;\n  pointer-events: none;\n  display: inline-block;\n  width: 0;\n}\n.ant-select-lg .ant-select-selection--single {\n  height: 32px;\n}\n.ant-select-lg .ant-select-selection__rendered {\n  line-height: 30px;\n}\n.ant-select-lg .ant-select-selection--multiple {\n  min-height: 32px;\n}\n.ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear {\n  top: 16px;\n}\n.ant-select-sm .ant-select-selection--single {\n  height: 22px;\n}\n.ant-select-sm .ant-select-selection__rendered {\n  line-height: 20px;\n}\n.ant-select-sm .ant-select-selection--multiple {\n  min-height: 22px;\n}\n.ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li {\n  height: 14px;\n  line-height: 14px;\n}\n.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear {\n  top: 11px;\n}\n.ant-select-disabled .ant-select-selection__choice__remove {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: default;\n}\n.ant-select-disabled .ant-select-selection__choice__remove:hover {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-search__field__wrap {\n  display: inline-block;\n  position: relative;\n}\n.ant-select-selection__placeholder,\n.ant-select-search__field__placeholder {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 9px;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 20px;\n  height: 20px;\n  max-width: 100%;\n  margin-top: -10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n}\n.ant-select-search__field__placeholder {\n  left: 8px;\n}\n.ant-select-search--inline {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n.ant-select-selection--multiple .ant-select-search--inline {\n  float: left;\n  position: static;\n}\n.ant-select-search--inline .ant-select-search__field__wrap {\n  width: 100%;\n  height: 100%;\n}\n.ant-select-search--inline .ant-select-search__field {\n  border-width: 0;\n  font-size: 100%;\n  height: 100%;\n  width: 100%;\n  background: transparent;\n  outline: 0;\n  border-radius: 4px;\n}\n.ant-select-search--inline .ant-select-search__field__mirror {\n  position: absolute;\n  top: 0;\n  left: -9999px;\n  white-space: pre;\n  pointer-events: none;\n}\n.ant-select-search--inline > i {\n  float: right;\n}\n.ant-select-selection--multiple {\n  min-height: 28px;\n  cursor: text;\n  padding-bottom: 3px;\n  zoom: 1;\n}\n.ant-select-selection--multiple:before,\n.ant-select-selection--multiple:after {\n  content: \" \";\n  display: table;\n}\n.ant-select-selection--multiple:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-select-selection--multiple .ant-select-search--inline {\n  width: auto;\n  padding: 0;\n  max-width: 100%;\n}\n.ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field {\n  max-width: 100%;\n  width: 0.75em;\n}\n.ant-select-selection--multiple .ant-select-selection__rendered {\n  margin-left: 5px;\n  margin-bottom: -3px;\n  height: auto;\n}\n.ant-select-selection--multiple > ul > li,\n.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {\n  margin-top: 3px;\n  height: 20px;\n  line-height: 20px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #f3f3f3;\n  border-radius: 4px;\n  cursor: default;\n  float: left;\n  margin-right: 4px;\n  max-width: 99%;\n  position: relative;\n  overflow: hidden;\n  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  padding: 0 20px 0 10px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__disabled {\n  padding: 0 10px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__content {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove {\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  line-height: 1;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: rgba(0, 0, 0, 0.43);\n  line-height: inherit;\n  cursor: pointer;\n  font-weight: bold;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  position: absolute;\n  right: 4px;\n  padding: 0 0 0 8px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove:before {\n  display: block;\n  font-family: \"anticon\" !important;\n}\n:root .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  filter: none;\n}\n:root .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  font-size: 12px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove:hover {\n  color: #404040;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove:before {\n  content: \"\\e633\";\n}\n.ant-select-selection--multiple .ant-select-selection__clear {\n  top: 14px;\n}\n.ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered {\n  margin-right: 20px;\n}\n.ant-select-open .ant-select-arrow {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -ms-transform: rotate(180deg);\n}\n.ant-select-open .ant-select-arrow:before {\n  transform: rotate(180deg);\n}\n.ant-select-open .ant-select-selection {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-select-combobox .ant-select-arrow {\n  display: none;\n}\n.ant-select-combobox .ant-select-search--inline {\n  height: 100%;\n  width: 100%;\n  float: none;\n}\n.ant-select-combobox .ant-select-search__field__wrap {\n  width: 100%;\n  height: 100%;\n}\n.ant-select-combobox .ant-select-search__field {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  box-shadow: none;\n}\n.ant-select-combobox.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered {\n  margin-right: 20px;\n}\n.ant-select-dropdown {\n  background-color: #fff;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  box-sizing: border-box;\n  z-index: 1050;\n  left: -9999px;\n  top: -9999px;\n  position: absolute;\n  outline: none;\n  overflow: hidden;\n  font-size: 12px;\n}\n.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,\n.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpIn;\n}\n.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft,\n.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownIn;\n}\n.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpOut;\n}\n.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownOut;\n}\n.ant-select-dropdown-hidden {\n  display: none;\n}\n.ant-select-dropdown-menu {\n  outline: none;\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n  max-height: 250px;\n  overflow: auto;\n}\n.ant-select-dropdown-menu-item-group-list {\n  margin: 0;\n  padding: 0;\n}\n.ant-select-dropdown-menu-item-group-list > .ant-select-dropdown-menu-item {\n  padding-left: 16px;\n}\n.ant-select-dropdown-menu-item-group-title {\n  color: rgba(0, 0, 0, 0.43);\n  line-height: 1.5;\n  padding: 8px;\n}\n.ant-select-dropdown-menu-item {\n  position: relative;\n  display: block;\n  padding: 7px 8px;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.65);\n  white-space: nowrap;\n  cursor: pointer;\n  overflow: hidden;\n  transition: background 0.3s ease;\n}\n.ant-select-dropdown-menu-item:hover {\n  background-color: #ecf6fd;\n}\n.ant-select-dropdown-menu-item-active {\n  background-color: #ecf6fd;\n}\n.ant-select-dropdown-menu-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-dropdown-menu-item-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-select-dropdown-menu-item-selected,\n.ant-select-dropdown-menu-item-selected:hover {\n  background-color: #f7f7f7;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-select-dropdown-menu-item-divider {\n  height: 1px;\n  margin: 1px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n  line-height: 0;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e632\";\n  color: transparent;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  transition: all 0.2s ease;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 8px;\n  font-weight: bold;\n  text-shadow: 0 0.1px 0, 0.1px 0 0, 0 -0.1px 0, -0.1px 0;\n}\n:root .ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {\n  filter: none;\n}\n:root .ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {\n  font-size: 12px;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:hover:after {\n  color: #ddd;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-disabled:after {\n  display: none;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:after,\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover:after {\n  color: #108ee9;\n  display: inline-block;\n}\n.ant-select-dropdown-container-open .ant-select-dropdown,\n.ant-select-dropdown-open .ant-select-dropdown {\n  display: block;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-select {\n  box-sizing: border-box;\n  display: inline-block;\n  position: relative;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n}\n.ant-select > ul > li > a {\n  padding: 0;\n  background-color: #fff;\n}\n.ant-select-arrow {\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  line-height: 1;\n  margin-top: -6px;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 9px 9;\n  transform: scale(0.75) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n.ant-select-arrow:before {\n  display: block;\n  font-family: \"anticon\" !important;\n}\n:root .ant-select-arrow {\n  filter: none;\n}\n:root .ant-select-arrow {\n  font-size: 12px;\n}\n.ant-select-arrow * {\n  display: none;\n}\n.ant-select-arrow:before {\n  content: '\\e61d';\n  transition: transform 0.2s ease;\n}\n.ant-select-selection {\n  outline: none;\n  user-select: none;\n  box-sizing: border-box;\n  display: block;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select-selection:hover {\n  border-color: #49a9ee;\n}\n.ant-select-focused .ant-select-selection,\n.ant-select-selection:focus,\n.ant-select-selection:active {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-select-selection__clear {\n  display: inline-block;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n  opacity: 0;\n  position: absolute;\n  right: 8px;\n  z-index: 1;\n  background: #fff;\n  top: 50%;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  line-height: 12px;\n  cursor: pointer;\n  transition: color 0.3s ease, opacity 0.15s ease;\n}\n.ant-select-selection__clear:before {\n  display: block;\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e62e\";\n}\n.ant-select-selection__clear:hover {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-select-selection:hover .ant-select-selection__clear {\n  opacity: 1;\n}\n.ant-select-selection-selected-value {\n  float: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  padding-right: 14px;\n}\n.ant-select-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-disabled .ant-select-selection {\n  background: #f7f7f7;\n  cursor: not-allowed;\n}\n.ant-select-disabled .ant-select-selection:hover,\n.ant-select-disabled .ant-select-selection:focus,\n.ant-select-disabled .ant-select-selection:active {\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n.ant-select-disabled .ant-select-selection__clear {\n  display: none;\n  visibility: hidden;\n  pointer-events: none;\n}\n.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice {\n  background: #eee;\n  color: #aaa;\n  padding-right: 10px;\n}\n.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  display: none;\n}\n.ant-select-selection--single {\n  height: 28px;\n  position: relative;\n  cursor: pointer;\n}\n.ant-select-selection__rendered {\n  display: block;\n  margin-left: 7px;\n  margin-right: 7px;\n  position: relative;\n  line-height: 26px;\n}\n.ant-select-selection__rendered:after {\n  content: '.';\n  visibility: hidden;\n  pointer-events: none;\n  display: inline-block;\n  width: 0;\n}\n.ant-select-lg .ant-select-selection--single {\n  height: 32px;\n}\n.ant-select-lg .ant-select-selection__rendered {\n  line-height: 30px;\n}\n.ant-select-lg .ant-select-selection--multiple {\n  min-height: 32px;\n}\n.ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li {\n  height: 24px;\n  line-height: 24px;\n}\n.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear {\n  top: 16px;\n}\n.ant-select-sm .ant-select-selection--single {\n  height: 22px;\n}\n.ant-select-sm .ant-select-selection__rendered {\n  line-height: 20px;\n}\n.ant-select-sm .ant-select-selection--multiple {\n  min-height: 22px;\n}\n.ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li {\n  height: 14px;\n  line-height: 14px;\n}\n.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear {\n  top: 11px;\n}\n.ant-select-disabled .ant-select-selection__choice__remove {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: default;\n}\n.ant-select-disabled .ant-select-selection__choice__remove:hover {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-select-search__field__wrap {\n  display: inline-block;\n  position: relative;\n}\n.ant-select-selection__placeholder,\n.ant-select-search__field__placeholder {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 9px;\n  color: rgba(0, 0, 0, 0.25);\n  line-height: 20px;\n  height: 20px;\n  max-width: 100%;\n  margin-top: -10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n}\n.ant-select-search__field__placeholder {\n  left: 8px;\n}\n.ant-select-search--inline {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n.ant-select-selection--multiple .ant-select-search--inline {\n  float: left;\n  position: static;\n}\n.ant-select-search--inline .ant-select-search__field__wrap {\n  width: 100%;\n  height: 100%;\n}\n.ant-select-search--inline .ant-select-search__field {\n  border-width: 0;\n  font-size: 100%;\n  height: 100%;\n  width: 100%;\n  background: transparent;\n  outline: 0;\n  border-radius: 4px;\n}\n.ant-select-search--inline .ant-select-search__field__mirror {\n  position: absolute;\n  top: 0;\n  left: -9999px;\n  white-space: pre;\n  pointer-events: none;\n}\n.ant-select-search--inline > i {\n  float: right;\n}\n.ant-select-selection--multiple {\n  min-height: 28px;\n  cursor: text;\n  padding-bottom: 3px;\n  zoom: 1;\n}\n.ant-select-selection--multiple:before,\n.ant-select-selection--multiple:after {\n  content: \" \";\n  display: table;\n}\n.ant-select-selection--multiple:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-select-selection--multiple .ant-select-search--inline {\n  width: auto;\n  padding: 0;\n  max-width: 100%;\n}\n.ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field {\n  max-width: 100%;\n  width: 0.75em;\n}\n.ant-select-selection--multiple .ant-select-selection__rendered {\n  margin-left: 5px;\n  margin-bottom: -3px;\n  height: auto;\n}\n.ant-select-selection--multiple > ul > li,\n.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {\n  margin-top: 3px;\n  height: 20px;\n  line-height: 20px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #f3f3f3;\n  border-radius: 4px;\n  cursor: default;\n  float: left;\n  margin-right: 4px;\n  max-width: 99%;\n  position: relative;\n  overflow: hidden;\n  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  padding: 0 20px 0 10px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__disabled {\n  padding: 0 10px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__content {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove {\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  line-height: 1;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: rgba(0, 0, 0, 0.43);\n  line-height: inherit;\n  cursor: pointer;\n  font-weight: bold;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  position: absolute;\n  right: 4px;\n  padding: 0 0 0 8px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove:before {\n  display: block;\n  font-family: \"anticon\" !important;\n}\n:root .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  filter: none;\n}\n:root .ant-select-selection--multiple .ant-select-selection__choice__remove {\n  font-size: 12px;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove:hover {\n  color: #404040;\n}\n.ant-select-selection--multiple .ant-select-selection__choice__remove:before {\n  content: \"\\e633\";\n}\n.ant-select-selection--multiple .ant-select-selection__clear {\n  top: 14px;\n}\n.ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered {\n  margin-right: 20px;\n}\n.ant-select-open .ant-select-arrow {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -ms-transform: rotate(180deg);\n}\n.ant-select-open .ant-select-arrow:before {\n  transform: rotate(180deg);\n}\n.ant-select-open .ant-select-selection {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-select-combobox .ant-select-arrow {\n  display: none;\n}\n.ant-select-combobox .ant-select-search--inline {\n  height: 100%;\n  width: 100%;\n  float: none;\n}\n.ant-select-combobox .ant-select-search__field__wrap {\n  width: 100%;\n  height: 100%;\n}\n.ant-select-combobox .ant-select-search__field {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  box-shadow: none;\n}\n.ant-select-combobox.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered {\n  margin-right: 20px;\n}\n.ant-select-dropdown {\n  background-color: #fff;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  box-sizing: border-box;\n  z-index: 1050;\n  left: -9999px;\n  top: -9999px;\n  position: absolute;\n  outline: none;\n  overflow: hidden;\n  font-size: 12px;\n}\n.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,\n.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpIn;\n}\n.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft,\n.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownIn;\n}\n.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {\n  animation-name: antSlideUpOut;\n}\n.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft {\n  animation-name: antSlideDownOut;\n}\n.ant-select-dropdown-hidden {\n  display: none;\n}\n.ant-select-dropdown-menu {\n  outline: none;\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n  max-height: 250px;\n  overflow: auto;\n}\n.ant-select-dropdown-menu-item-group-list {\n  margin: 0;\n  padding: 0;\n}\n.ant-select-dropdown-menu-item-group-list > .ant-select-dropdown-menu-item {\n  padding-left: 16px;\n}\n.ant-select-dropdown-menu-item-group-title {\n  color: rgba(0, 0, 0, 0.43);\n  line-height: 1.5;\n  padding: 8px;\n}\n.ant-select-dropdown-menu-item {\n  position: relative;\n  display: block;\n  padding: 7px 8px;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.65);\n  white-space: nowrap;\n  cursor: pointer;\n  overflow: hidden;\n  transition: background 0.3s ease;\n}\n.ant-select-dropdown-menu-item:hover {\n  background-color: #ecf6fd;\n}\n.ant-select-dropdown-menu-item-active {\n  background-color: #ecf6fd;\n}\n.ant-select-dropdown-menu-item-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-select-dropdown-menu-item-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-select-dropdown-menu-item-selected,\n.ant-select-dropdown-menu-item-selected:hover {\n  background-color: #f7f7f7;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-select-dropdown-menu-item-divider {\n  height: 1px;\n  margin: 1px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n  line-height: 0;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e632\";\n  color: transparent;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  transition: all 0.2s ease;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 8px;\n  font-weight: bold;\n  text-shadow: 0 0.1px 0, 0.1px 0 0, 0 -0.1px 0, -0.1px 0;\n}\n:root .ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {\n  filter: none;\n}\n:root .ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {\n  font-size: 12px;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:hover:after {\n  color: #ddd;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-disabled:after {\n  display: none;\n}\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:after,\n.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover:after {\n  color: #108ee9;\n  display: inline-block;\n}\n.ant-select-dropdown-container-open .ant-select-dropdown,\n.ant-select-dropdown-open .ant-select-dropdown {\n  display: block;\n}\nnz-select .ant-select {\n  width: 100%;\n}\n.ant-select-dropdown {\n  top: 100%;\n  left: 0;\n  position: relative;\n  width: 100%;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.ant-select-dropdown.ant-select-dropdown-placement-topLeft {\n  top: -100%;\n  transform: translateY(-100%) !important;\n}\n.ant-select-dropdown-menu-item {\n  line-height: 1.5;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzSelectComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzSelectComponent.propDecorators = {
    'searchInputElementRef': [{ type: ViewChild, args: ['searchInput',] },],
    'trigger': [{ type: ViewChild, args: ['trigger',] },],
    'dropdownUl': [{ type: ViewChild, args: ['dropdownUl',] },],
    'nzSearchChange': [{ type: Output },],
    'nzOpenChange': [{ type: Output },],
    'nzFilter': [{ type: Input },],
    'nzMaxMultiple': [{ type: Input },],
    'nzAllowClear': [{ type: Input },],
    'nzKeepUnListOptions': [{ type: Input },],
    'nzMode': [{ type: Input },],
    'nzMultiple': [{ type: Input },],
    'nzPlaceHolder': [{ type: Input },],
    'nzNotFoundContent': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzShowSearch': [{ type: Input },],
    'nzTags': [{ type: Input },],
    'nzDisabled': [{ type: Input },],
    'nzOpen': [{ type: Input },],
    'onClick': [{ type: HostListener, args: ['click', ['$event'],] },],
    'onKeyDown': [{ type: HostListener, args: ['keydown', ['$event'],] },],
};
var NzOptionComponent = (function () {
    /**
     * @param {?} _nzSelect
     */
    function NzOptionComponent(_nzSelect) {
        this._nzSelect = _nzSelect;
        this._disabled = false;
    }
    Object.defineProperty(NzOptionComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value === value) {
                return;
            }
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzOptionComponent.prototype, "nzLabel", {
        /**
         * @return {?}
         */
        get: function () {
            return this._label;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._label === value) {
                return;
            }
            this._label = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzOptionComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    NzOptionComponent.prototype.ngOnInit = function () {
        this._nzSelect.addOption(this);
    };
    /**
     * @return {?}
     */
    NzOptionComponent.prototype.ngOnDestroy = function () {
        this._nzSelect.removeOption(this);
    };
    return NzOptionComponent;
}());
NzOptionComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-option',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n  ",
                styles: []
            },] },
];
/**
 * @nocollapse
 */
NzOptionComponent.ctorParameters = function () { return [
    { type: NzSelectComponent, },
]; };
NzOptionComponent.propDecorators = {
    'nzValue': [{ type: Input },],
    'nzLabel': [{ type: Input },],
    'nzDisabled': [{ type: Input },],
};
var NzSelectModule = (function () {
    function NzSelectModule() {
    }
    return NzSelectModule;
}());
NzSelectModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule, OverlayModule],
                declarations: [NzOptionPipe, NzOptionComponent, NzSelectComponent],
                exports: [NzOptionPipe, NzOptionComponent, NzSelectComponent]
            },] },
];
/**
 * @nocollapse
 */
NzSelectModule.ctorParameters = function () { return []; };
var NzRadioGroupComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _render
     */
    function NzRadioGroupComponent(_elementRef, _render) {
        this._elementRef = _elementRef;
        this._render = _render;
        this._prefixCls = 'ant-radio-group';
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.radios = [];
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzRadioGroupComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._size = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzRadioGroupComponent.prototype, "isLarge", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size === 'large';
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzRadioGroupComponent.prototype, "isSmall", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size === 'small';
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?} radio
     * @return {?}
     */
    NzRadioGroupComponent.prototype.addRadio = function (radio) {
        this.radios.push(radio);
    };
    /**
     * @param {?} radio
     * @return {?}
     */
    NzRadioGroupComponent.prototype.selectRadio = function (radio) {
        this.updateValue(radio.nzValue);
        this.onChange(radio.nzValue);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzRadioGroupComponent.prototype.updateValue = function (value) {
        var _this = this;
        if (this._value === value) {
            return;
        }
        this._value = value;
        this.radios.forEach(function (item) {
            item.nzChecked = item.nzValue === _this._value;
        });
    };
    /**
     * @return {?}
     */
    NzRadioGroupComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.radios.forEach(function (item) {
            item.nzChecked = item.nzValue === _this._value;
        });
        /** trim text node between radio button */
        Array.from(this._el.childNodes).forEach(function (node) {
            if (node.nodeType === 3) {
                _this._el.removeChild(node);
            }
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzRadioGroupComponent.prototype.writeValue = function (value) {
        this.updateValue(value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzRadioGroupComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzRadioGroupComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzRadioGroupComponent.prototype.setDisabledState = function (isDisabled) {
        this.radios.forEach(function (radio) {
            radio.nzDisabled = isDisabled;
        });
    };
    /**
     * @return {?}
     */
    NzRadioGroupComponent.prototype.ngOnInit = function () {
        this._render.setElementClass(this._el, "" + this._prefixCls, true);
    };
    return NzRadioGroupComponent;
}());
NzRadioGroupComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-radio-group',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzRadioGroupComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-radio-group {\n  display: inline-block;\n  font-size: 12px;\n}\n.ant-radio-wrapper {\n  font-size: 12px;\n  display: inline-block;\n  position: relative;\n  white-space: nowrap;\n  margin-right: 8px;\n  cursor: pointer;\n}\n.ant-radio {\n  white-space: nowrap;\n  outline: none;\n  display: inline-block;\n  position: relative;\n  line-height: 1;\n  vertical-align: text-bottom;\n  cursor: pointer;\n}\n.ant-radio-wrapper:hover .ant-radio .ant-radio-inner,\n.ant-radio:hover .ant-radio-inner,\n.ant-radio-focused .ant-radio-inner {\n  border-color: #108ee9;\n}\n.ant-radio-checked:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 1px solid #108ee9;\n  content: '';\n  animation: antRadioEffect 0.36s ease-in-out;\n  animation-fill-mode: both;\n  visibility: hidden;\n}\n.ant-radio:hover:after,\n.ant-radio-wrapper:hover .ant-radio:after {\n  visibility: visible;\n}\n.ant-radio-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 14px;\n  height: 14px;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 14px;\n  border-color: #d9d9d9;\n  background-color: #fff;\n  transition: all 0.3s;\n}\n.ant-radio-inner:after {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  left: 3px;\n  top: 3px;\n  border-radius: 4px;\n  display: table;\n  border-top: 0;\n  border-left: 0;\n  content: ' ';\n  background-color: #108ee9;\n  opacity: 0;\n  transform: scale(0);\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-input {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n.ant-radio-checked .ant-radio-inner {\n  border-color: #108ee9;\n}\n.ant-radio-checked .ant-radio-inner:after {\n  transform: scale(1);\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-disabled .ant-radio-inner {\n  border-color: #d9d9d9 !important;\n  background-color: #f7f7f7;\n}\n.ant-radio-disabled .ant-radio-inner:after {\n  background-color: #ccc;\n}\n.ant-radio-disabled .ant-radio-input {\n  cursor: not-allowed;\n}\n.ant-radio-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\nspan.ant-radio + * {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-radio-button-wrapper {\n  margin: 0;\n  height: 28px;\n  line-height: 26px;\n  color: rgba(0, 0, 0, 0.65);\n  display: inline-block;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  border: 1px solid #d9d9d9;\n  border-left: 0;\n  background: #fff;\n  padding: 0 16px;\n  position: relative;\n}\n.ant-radio-button-wrapper a {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-radio-button-wrapper > .ant-radio-button {\n  margin-left: 0;\n  display: block;\n  width: 0;\n  height: 0;\n}\n.ant-radio-group-large .ant-radio-button-wrapper {\n  height: 32px;\n  line-height: 30px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 22px;\n  line-height: 20px;\n  padding: 0 12px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper:first-child {\n  border-radius: 2px 0 0 2px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper:last-child {\n  border-radius: 0 2px 2px 0;\n}\n.ant-radio-button-wrapper:not(:first-child)::before {\n  content: \"\";\n  display: block;\n  top: 0;\n  left: -1px;\n  width: 1px;\n  height: 100%;\n  position: absolute;\n  background-color: #d9d9d9;\n}\n.ant-radio-button-wrapper:first-child {\n  border-radius: 4px 0 0 4px;\n  border-left: 1px solid #d9d9d9;\n}\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0 4px 4px 0;\n}\n.ant-radio-button-wrapper:first-child:last-child {\n  border-radius: 4px;\n}\n.ant-radio-button-wrapper:hover,\n.ant-radio-button-wrapper-focused {\n  color: #108ee9;\n  position: relative;\n}\n.ant-radio-button-wrapper .ant-radio-inner,\n.ant-radio-button-wrapper input[type=\"checkbox\"],\n.ant-radio-button-wrapper input[type=\"radio\"] {\n  opacity: 0;\n  filter: alpha(opacity=0);\n  width: 0;\n  height: 0;\n}\n.ant-radio-button-wrapper-checked {\n  background: #fff;\n  border-color: #108ee9;\n  color: #108ee9;\n  box-shadow: -1px 0 0 0 #108ee9;\n  z-index: 1;\n}\n.ant-radio-button-wrapper-checked::before {\n  background-color: #108ee9 !important;\n  opacity: 0.1;\n}\n.ant-radio-button-wrapper-checked:first-child {\n  border-color: #108ee9;\n  box-shadow: none !important;\n}\n.ant-radio-button-wrapper-checked:hover {\n  border-color: #49a9ee;\n  box-shadow: -1px 0 0 0 #49a9ee;\n  color: #49a9ee;\n}\n.ant-radio-button-wrapper-checked:active {\n  border-color: #0e77ca;\n  box-shadow: -1px 0 0 0 #0e77ca;\n  color: #0e77ca;\n}\n.ant-radio-button-wrapper-disabled {\n  border-color: #d9d9d9;\n  background-color: #f7f7f7;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-radio-button-wrapper-disabled:first-child,\n.ant-radio-button-wrapper-disabled:hover {\n  border-color: #d9d9d9;\n  background-color: #f7f7f7;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-radio-button-wrapper-disabled:first-child {\n  border-left-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {\n  color: #fff;\n  background-color: #e6e6e6;\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n@keyframes antRadioEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzRadioGroupComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer, },
]; };
NzRadioGroupComponent.propDecorators = {
    'nzSize': [{ type: Input },],
    'isLarge': [{ type: HostBinding, args: ['class.ant-radio-group-large',] },],
    'isSmall': [{ type: HostBinding, args: ['class.ant-radio-group-small',] },],
};
var NzRadioComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _nzRadioGroup
     */
    function NzRadioComponent(_elementRef, _renderer, _nzRadioGroup) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._nzRadioGroup = _nzRadioGroup;
        this._prefixCls = 'ant-radio';
        this._innerPrefixCls = this._prefixCls + "-inner";
        this._inputPrefixCls = this._prefixCls + "-input";
        this._checked = false;
        this._focused = false;
        this._disabled = false;
        this._el = this._elementRef.nativeElement;
        this._nzRadioGroup.addRadio(this);
    }
    Object.defineProperty(NzRadioComponent.prototype, "nzChecked", {
        /**
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._checked = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzRadioComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value === value) {
                return;
            }
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzRadioComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?} e
     * @return {?}
     */
    NzRadioComponent.prototype.onClick = function (e) {
        e.preventDefault();
        if (!this._disabled) {
            this._checked = true;
            this.setClassMap();
            this._nzRadioGroup.selectRadio(this);
        }
    };
    /**
     * @return {?}
     */
    NzRadioComponent.prototype.nzFocus = function () {
        this._focused = true;
        this.setClassMap();
    };
    /**
     * @return {?}
     */
    NzRadioComponent.prototype.nzBlur = function () {
        this._focused = false;
        this.setClassMap();
        this._nzRadioGroup.onTouched();
    };
    /**
     * @return {?}
     */
    NzRadioComponent.prototype.setClassMap = function () {
        this._classMap = (_a = {},
            _a[this._prefixCls] = true,
            _a[this._prefixCls + "-checked"] = this._checked,
            _a[this._prefixCls + "-focused"] = this._focused,
            _a[this._prefixCls + "-disabled"] = this._disabled,
            _a);
        var _a;
    };
    /**
     * @return {?}
     */
    NzRadioComponent.prototype.ngOnInit = function () {
        this._renderer.addClass(this._el, this._prefixCls + "-wrapper");
        this.setClassMap();
    };
    return NzRadioComponent;
}());
NzRadioComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-radio]',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <span [ngClass]=\"_classMap\">\n      <span [ngClass]=\"_innerPrefixCls\"></span>\n      <input type=\"radio\" [ngClass]=\"_inputPrefixCls\" [(ngModel)]=\"nzChecked\" (focus)=\"nzFocus()\" (blur)=\"nzBlur()\">\n    </span>\n    <ng-content></ng-content>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-radio-group {\n  display: inline-block;\n  font-size: 12px;\n}\n.ant-radio-wrapper {\n  font-size: 12px;\n  display: inline-block;\n  position: relative;\n  white-space: nowrap;\n  margin-right: 8px;\n  cursor: pointer;\n}\n.ant-radio {\n  white-space: nowrap;\n  outline: none;\n  display: inline-block;\n  position: relative;\n  line-height: 1;\n  vertical-align: text-bottom;\n  cursor: pointer;\n}\n.ant-radio-wrapper:hover .ant-radio .ant-radio-inner,\n.ant-radio:hover .ant-radio-inner,\n.ant-radio-focused .ant-radio-inner {\n  border-color: #108ee9;\n}\n.ant-radio-checked:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 1px solid #108ee9;\n  content: '';\n  animation: antRadioEffect 0.36s ease-in-out;\n  animation-fill-mode: both;\n  visibility: hidden;\n}\n.ant-radio:hover:after,\n.ant-radio-wrapper:hover .ant-radio:after {\n  visibility: visible;\n}\n.ant-radio-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 14px;\n  height: 14px;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 14px;\n  border-color: #d9d9d9;\n  background-color: #fff;\n  transition: all 0.3s;\n}\n.ant-radio-inner:after {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  left: 3px;\n  top: 3px;\n  border-radius: 4px;\n  display: table;\n  border-top: 0;\n  border-left: 0;\n  content: ' ';\n  background-color: #108ee9;\n  opacity: 0;\n  transform: scale(0);\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-input {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n.ant-radio-checked .ant-radio-inner {\n  border-color: #108ee9;\n}\n.ant-radio-checked .ant-radio-inner:after {\n  transform: scale(1);\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-disabled .ant-radio-inner {\n  border-color: #d9d9d9 !important;\n  background-color: #f7f7f7;\n}\n.ant-radio-disabled .ant-radio-inner:after {\n  background-color: #ccc;\n}\n.ant-radio-disabled .ant-radio-input {\n  cursor: not-allowed;\n}\n.ant-radio-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\nspan.ant-radio + * {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-radio-button-wrapper {\n  margin: 0;\n  height: 28px;\n  line-height: 26px;\n  color: rgba(0, 0, 0, 0.65);\n  display: inline-block;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  border: 1px solid #d9d9d9;\n  border-left: 0;\n  background: #fff;\n  padding: 0 16px;\n  position: relative;\n}\n.ant-radio-button-wrapper a {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-radio-button-wrapper > .ant-radio-button {\n  margin-left: 0;\n  display: block;\n  width: 0;\n  height: 0;\n}\n.ant-radio-group-large .ant-radio-button-wrapper {\n  height: 32px;\n  line-height: 30px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 22px;\n  line-height: 20px;\n  padding: 0 12px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper:first-child {\n  border-radius: 2px 0 0 2px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper:last-child {\n  border-radius: 0 2px 2px 0;\n}\n.ant-radio-button-wrapper:not(:first-child)::before {\n  content: \"\";\n  display: block;\n  top: 0;\n  left: -1px;\n  width: 1px;\n  height: 100%;\n  position: absolute;\n  background-color: #d9d9d9;\n}\n.ant-radio-button-wrapper:first-child {\n  border-radius: 4px 0 0 4px;\n  border-left: 1px solid #d9d9d9;\n}\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0 4px 4px 0;\n}\n.ant-radio-button-wrapper:first-child:last-child {\n  border-radius: 4px;\n}\n.ant-radio-button-wrapper:hover,\n.ant-radio-button-wrapper-focused {\n  color: #108ee9;\n  position: relative;\n}\n.ant-radio-button-wrapper .ant-radio-inner,\n.ant-radio-button-wrapper input[type=\"checkbox\"],\n.ant-radio-button-wrapper input[type=\"radio\"] {\n  opacity: 0;\n  filter: alpha(opacity=0);\n  width: 0;\n  height: 0;\n}\n.ant-radio-button-wrapper-checked {\n  background: #fff;\n  border-color: #108ee9;\n  color: #108ee9;\n  box-shadow: -1px 0 0 0 #108ee9;\n  z-index: 1;\n}\n.ant-radio-button-wrapper-checked::before {\n  background-color: #108ee9 !important;\n  opacity: 0.1;\n}\n.ant-radio-button-wrapper-checked:first-child {\n  border-color: #108ee9;\n  box-shadow: none !important;\n}\n.ant-radio-button-wrapper-checked:hover {\n  border-color: #49a9ee;\n  box-shadow: -1px 0 0 0 #49a9ee;\n  color: #49a9ee;\n}\n.ant-radio-button-wrapper-checked:active {\n  border-color: #0e77ca;\n  box-shadow: -1px 0 0 0 #0e77ca;\n  color: #0e77ca;\n}\n.ant-radio-button-wrapper-disabled {\n  border-color: #d9d9d9;\n  background-color: #f7f7f7;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-radio-button-wrapper-disabled:first-child,\n.ant-radio-button-wrapper-disabled:hover {\n  border-color: #d9d9d9;\n  background-color: #f7f7f7;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-radio-button-wrapper-disabled:first-child {\n  border-left-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {\n  color: #fff;\n  background-color: #e6e6e6;\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n@keyframes antRadioEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzRadioComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: NzRadioGroupComponent, },
]; };
NzRadioComponent.propDecorators = {
    'nzChecked': [{ type: Input }, { type: HostBinding, args: ['class.ant-radio-wrapper-checked',] },],
    'nzValue': [{ type: Input },],
    'nzDisabled': [{ type: Input }, { type: HostBinding, args: ['class.ant-radio-wrapper-disabled',] },],
    'onClick': [{ type: HostListener, args: ['click', ['$event'],] },],
};
var NzRadioButtonComponent = (function (_super) {
    tslib_1.__extends(NzRadioButtonComponent, _super);
    function NzRadioButtonComponent() {
        var _this = _super.apply(this, arguments) || this;
        _this._prefixCls = 'ant-radio-button';
        _this._innerPrefixCls = _this._prefixCls + "-inner";
        _this._inputPrefixCls = _this._prefixCls + "-input";
        return _this;
    }
    Object.defineProperty(NzRadioButtonComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzRadioButtonComponent.prototype, "nzChecked", {
        /**
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._checked = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    return NzRadioButtonComponent;
}(NzRadioComponent));
NzRadioButtonComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-radio-button]',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <span [ngClass]=\"_classMap\">\n      <span [ngClass]=\"_innerPrefixCls\"></span>\n      <input type=\"radio\" [ngClass]=\"_inputPrefixCls\" [(ngModel)]=\"nzChecked\" (focus)=\"nzFocus()\" (blur)=\"nzBlur()\">\n    </span>\n    <ng-content></ng-content>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-radio-group {\n  display: inline-block;\n  font-size: 12px;\n}\n.ant-radio-wrapper {\n  font-size: 12px;\n  display: inline-block;\n  position: relative;\n  white-space: nowrap;\n  margin-right: 8px;\n  cursor: pointer;\n}\n.ant-radio {\n  white-space: nowrap;\n  outline: none;\n  display: inline-block;\n  position: relative;\n  line-height: 1;\n  vertical-align: text-bottom;\n  cursor: pointer;\n}\n.ant-radio-wrapper:hover .ant-radio .ant-radio-inner,\n.ant-radio:hover .ant-radio-inner,\n.ant-radio-focused .ant-radio-inner {\n  border-color: #108ee9;\n}\n.ant-radio-checked:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 1px solid #108ee9;\n  content: '';\n  animation: antRadioEffect 0.36s ease-in-out;\n  animation-fill-mode: both;\n  visibility: hidden;\n}\n.ant-radio:hover:after,\n.ant-radio-wrapper:hover .ant-radio:after {\n  visibility: visible;\n}\n.ant-radio-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 14px;\n  height: 14px;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 14px;\n  border-color: #d9d9d9;\n  background-color: #fff;\n  transition: all 0.3s;\n}\n.ant-radio-inner:after {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  left: 3px;\n  top: 3px;\n  border-radius: 4px;\n  display: table;\n  border-top: 0;\n  border-left: 0;\n  content: ' ';\n  background-color: #108ee9;\n  opacity: 0;\n  transform: scale(0);\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-input {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n.ant-radio-checked .ant-radio-inner {\n  border-color: #108ee9;\n}\n.ant-radio-checked .ant-radio-inner:after {\n  transform: scale(1);\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-radio-disabled .ant-radio-inner {\n  border-color: #d9d9d9 !important;\n  background-color: #f7f7f7;\n}\n.ant-radio-disabled .ant-radio-inner:after {\n  background-color: #ccc;\n}\n.ant-radio-disabled .ant-radio-input {\n  cursor: not-allowed;\n}\n.ant-radio-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\nspan.ant-radio + * {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-radio-button-wrapper {\n  margin: 0;\n  height: 28px;\n  line-height: 26px;\n  color: rgba(0, 0, 0, 0.65);\n  display: inline-block;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  border: 1px solid #d9d9d9;\n  border-left: 0;\n  background: #fff;\n  padding: 0 16px;\n  position: relative;\n}\n.ant-radio-button-wrapper a {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-radio-button-wrapper > .ant-radio-button {\n  margin-left: 0;\n  display: block;\n  width: 0;\n  height: 0;\n}\n.ant-radio-group-large .ant-radio-button-wrapper {\n  height: 32px;\n  line-height: 30px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 22px;\n  line-height: 20px;\n  padding: 0 12px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper:first-child {\n  border-radius: 2px 0 0 2px;\n}\n.ant-radio-group-small .ant-radio-button-wrapper:last-child {\n  border-radius: 0 2px 2px 0;\n}\n.ant-radio-button-wrapper:not(:first-child)::before {\n  content: \"\";\n  display: block;\n  top: 0;\n  left: -1px;\n  width: 1px;\n  height: 100%;\n  position: absolute;\n  background-color: #d9d9d9;\n}\n.ant-radio-button-wrapper:first-child {\n  border-radius: 4px 0 0 4px;\n  border-left: 1px solid #d9d9d9;\n}\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0 4px 4px 0;\n}\n.ant-radio-button-wrapper:first-child:last-child {\n  border-radius: 4px;\n}\n.ant-radio-button-wrapper:hover,\n.ant-radio-button-wrapper-focused {\n  color: #108ee9;\n  position: relative;\n}\n.ant-radio-button-wrapper .ant-radio-inner,\n.ant-radio-button-wrapper input[type=\"checkbox\"],\n.ant-radio-button-wrapper input[type=\"radio\"] {\n  opacity: 0;\n  filter: alpha(opacity=0);\n  width: 0;\n  height: 0;\n}\n.ant-radio-button-wrapper-checked {\n  background: #fff;\n  border-color: #108ee9;\n  color: #108ee9;\n  box-shadow: -1px 0 0 0 #108ee9;\n  z-index: 1;\n}\n.ant-radio-button-wrapper-checked::before {\n  background-color: #108ee9 !important;\n  opacity: 0.1;\n}\n.ant-radio-button-wrapper-checked:first-child {\n  border-color: #108ee9;\n  box-shadow: none !important;\n}\n.ant-radio-button-wrapper-checked:hover {\n  border-color: #49a9ee;\n  box-shadow: -1px 0 0 0 #49a9ee;\n  color: #49a9ee;\n}\n.ant-radio-button-wrapper-checked:active {\n  border-color: #0e77ca;\n  box-shadow: -1px 0 0 0 #0e77ca;\n  color: #0e77ca;\n}\n.ant-radio-button-wrapper-disabled {\n  border-color: #d9d9d9;\n  background-color: #f7f7f7;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-radio-button-wrapper-disabled:first-child,\n.ant-radio-button-wrapper-disabled:hover {\n  border-color: #d9d9d9;\n  background-color: #f7f7f7;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-radio-button-wrapper-disabled:first-child {\n  border-left-color: #d9d9d9;\n}\n.ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked {\n  color: #fff;\n  background-color: #e6e6e6;\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n@keyframes antRadioEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzRadioButtonComponent.ctorParameters = function () { return []; };
NzRadioButtonComponent.propDecorators = {
    'nzDisabled': [{ type: Input }, { type: HostBinding, args: ['class.ant-radio-button-wrapper-disabled',] },],
    'nzChecked': [{ type: Input }, { type: HostBinding, args: ['class.ant-radio-button-wrapper-checked',] },],
};
var NzRadioModule = (function () {
    function NzRadioModule() {
    }
    return NzRadioModule;
}());
NzRadioModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule],
                exports: [NzRadioComponent, NzRadioButtonComponent, NzRadioGroupComponent],
                declarations: [NzRadioComponent, NzRadioButtonComponent, NzRadioGroupComponent]
            },] },
];
/**
 * @nocollapse
 */
NzRadioModule.ctorParameters = function () { return []; };
var NzCalendarModule = (function () {
    function NzCalendarModule() {
    }
    return NzCalendarModule;
}());
NzCalendarModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, NzSelectModule, NzRadioModule, FormsModule],
                declarations: [NzCalendarComponent],
                exports: [NzCalendarComponent]
            },] },
];
/**
 * @nocollapse
 */
NzCalendarModule.ctorParameters = function () { return []; };
var ESC = 27;
/**
 * @param {?} value
 * @return {?}
 */
function toArray(value) {
    var /** @type {?} */ ret = value;
    if (value === undefined || value === null) {
        ret = [];
    }
    else if (!Array.isArray(value)) {
        ret = [value];
    }
    return ret;
}
/**
 * @param {?} array1
 * @param {?} array2
 * @return {?}
 */
function arrayEquals(array1, array2) {
    if (!array1 || !array2 || array1.length !== array2.length) {
        return false;
    }
    var /** @type {?} */ len = array1.length;
    for (var /** @type {?} */ i = 0; i < len; i++) {
        if (array1[i] !== array2[i]) {
            return false;
        }
    }
    return true;
}
var defaultDisplayRender = function (label) { return label.join(' / '); };
var NzCascaderComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _render
     * @param {?} _cdr
     */
    function NzCascaderComponent(_elementRef, _render, _cdr) {
        this._elementRef = _elementRef;
        this._render = _render;
        this._cdr = _cdr;
        this._prefixCls = 'ant-cascader';
        this._inputPrefixCls = 'ant-input';
        this._dropDownPosition = 'bottom';
        this._focused = false;
        this._popupVisible = false;
        this._displayLabelIsTemplate = false;
        this._displayLabelContext = {};
        this.__inputValue = '';
        // selection will trigger value change
        this._selectedOptions = [];
        // activaction will not triiger value change
        this._activatedOptions = [];
        // all data columns
        this._nzColumns = [];
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        /**
         * Whether is disabled
         */
        this.nzDisabled = false;
        /**
         * Input size, one of `large` `default` `small`
         */
        this.nzSize = 'default';
        /**
         * Input placeholder
         */
        this.nzPlaceHolder = 'Please select';
        /**
         * Whether show input box. Defaults to `true`.
         */
        this.nzShowInput = true;
        /**
         * Whether can search. Defaults to `false`.
         */
        this.nzShowSearch = false;
        /**
         * Whether allow clear. Defaults to `true`.
         */
        this.nzAllowClear = true;
        /**
         * Hover text for the clear icon
         */
        this.nzClearText = 'Clear';
        /**
         * Whether to show arrow
         */
        this.nzShowArrow = true;
        /**
         * Specify content to show when no result matches.
         */
        this.nzNotFoundContent = 'Not Found';
        /**
         * Whether cache children when they were loaded asych
         */
        this.nzEnableCache = true;
        /**
         * Expand column item when click or hover, one of 'click' 'hover'
         */
        this.nzExpandTrigger = 'click';
        /**
         * Change value on each selection if set to true
         */
        this.nzChangeOnSelect = false;
        /**
         * Delay time to show when mouse enter, when `nzExpandTrigger` is `hover`.
         */
        this.nzMouseEnterDelay = 150;
        /**
         * Delay time to hide when mouse enter, when `nzExpandTrigger` is `hover`.
         */
        this.nzMouseLeaveDelay = 150;
        /**
         * Triggering mode: can be Array<'click'|'hover'>
         */
        this.nzTriggerAction = ['click'];
        /**
         * Property name for getting `value` in the option
         */
        this.nzValueProperty = 'value';
        /**
         * Property name for getting `label` in the option
         */
        this.nzLabelProperty = 'label';
        this.tabIndex = '0';
        /**
         * Event: emit on popup show or hide
         */
        this.nzVisibleChange = new EventEmitter();
        /**
         * Event: emit on values changed
         */
        this.nzChange = new EventEmitter();
        /**
         * Event: emit on values and selection changed
         */
        this.nzSelectionChange = new EventEmitter();
        /**
         * Event: emit on option selected, event data：{option: any, index: number}
         */
        this.nzSelect = new EventEmitter();
        /**
         * Event: emit before loading children. event data：{option: any|null, index: number, resolve, reject}
         */
        this.nzLoad = new EventEmitter();
        /**
         * Event: emit on the clear button clicked
         */
        this.nzClear = new EventEmitter();
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzCascaderComponent.prototype, "_inputValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this.__inputValue;
        },
        /**
         * @param {?} inputValue
         * @return {?}
         */
        set: function (inputValue) {
            this.__inputValue = inputValue;
            if (inputValue.length) {
                this._addHostClass(this._prefixCls + "-picker-with-value");
            }
            else {
                this._removeHostClass(this._prefixCls + "-picker-with-value");
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} position
     * @return {?}
     */
    NzCascaderComponent.prototype.onPositionChange = function (position) {
        var /** @type {?} */ _position = position.connectionPair.originY === 'bottom' ? 'bottom' : 'top';
        if (this._dropDownPosition !== _position) {
            this._dropDownPosition = _position;
            this._cdr.detectChanges();
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype.nzFocus = function () {
        this._focused = true;
        this._addHostClass(this._prefixCls + "-focused");
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype.nzBlur = function () {
        this._focused = false;
        this._removeHostClass(this._prefixCls + "-focused");
    };
    Object.defineProperty(NzCascaderComponent.prototype, "_pickerLabelCls", {
        /**
         * @return {?}
         */
        get: function () {
            return _a = {},
                _a[this._prefixCls + "-picker-label"] = true,
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCascaderComponent.prototype, "_arrowCls", {
        /**
         * @return {?}
         */
        get: function () {
            return _a = {},
                _a[this._prefixCls + "-picker-arrow"] = true,
                _a[this._prefixCls + "-picker-arrow-expand"] = this._popupVisible,
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCascaderComponent.prototype, "_clearCls", {
        /**
         * @return {?}
         */
        get: function () {
            return _a = {},
                _a[this._prefixCls + "-picker-clear"] = true,
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCascaderComponent.prototype, "_inputCls", {
        /**
         * @return {?}
         */
        get: function () {
            return _a = {},
                _a[this._prefixCls + "-input"] = 1,
                _a[this._inputPrefixCls + "-disabled"] = this.nzDisabled,
                _a[this._inputPrefixCls + "-lg"] = this.nzSize === 'large',
                _a[this._inputPrefixCls + "-sm"] = this.nzSize === 'small',
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCascaderComponent.prototype, "_menuCls", {
        /**
         * @return {?}
         */
        get: function () {
            return _a = {},
                _a[this._prefixCls + "-menus"] = true,
                _a[this._prefixCls + "-menus-hidden"] = !this._popupVisible,
                _a["" + this.nzPopupClassName] = this.nzPopupClassName,
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCascaderComponent.prototype, "_columnCls", {
        /**
         * 获取菜单中列的样式
         * @return {?}
         */
        get: function () {
            return _a = {},
                _a[this._prefixCls + "-menu"] = true,
                _a["" + this.nzColumnClassName] = this.nzColumnClassName,
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * 获取列中Option的样式
     * @param {?} option
     * @param {?} index
     * @return {?}
     */
    NzCascaderComponent.prototype._getOptionCls = function (option, index) {
        return _a = {},
            _a[this._prefixCls + "-menu-item"] = true,
            _a[this._prefixCls + "-menu-item-expand"] = !option.isLeaf,
            _a[this._prefixCls + "-menu-item-active"] = this._isActiveOption(option, index),
            _a[this._prefixCls + "-menu-item-disabled"] = option.disabled,
            _a[this._prefixCls + "-menu-item-loading"] = option.loading,
            _a;
        var _a;
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._getLabel = function () {
        return this._displayLabelIsTemplate ? '' : this._displayLabel;
    };
    /**
     * prevent input change event
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._handlerInputChange = function (event) {
        event.stopPropagation();
    };
    /**
     * input blur
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._handleInputBlur = function (event) {
        if (!this.nzShowSearch) {
            return;
        }
        if (this._popupVisible) {
            this.nzFocus();
        }
        else {
            this.nzBlur();
        }
    };
    /**
     * input focus
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._handleInputFocus = function (event) {
        if (!this.nzShowSearch) {
            return;
        }
        this.nzFocus();
    };
    /**
     * input key down
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._handleInputKeyDown = function (event) {
    };
    /**
     * @param {?} inputValue
     * @param {?=} fireSearch
     * @return {?}
     */
    NzCascaderComponent.prototype._setInputValue = function (inputValue, fireSearch) {
        if (fireSearch === void 0) { fireSearch = true; }
        if (inputValue !== this._inputValue) {
            this._inputValue = inputValue;
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._hasInput = function () {
        return this._inputValue.length > 0;
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._hasSelection = function () {
        return this._selectedOptions.length > 0;
    };
    Object.defineProperty(NzCascaderComponent.prototype, "_showClearIcon", {
        /**
         * Whether the clear button is visible
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ isSelected = this._hasSelection();
            var /** @type {?} */ isHasInput = this._hasInput();
            return this.nzAllowClear && !this.nzDisabled && (isSelected || isHasInput);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * clear the input box and selected options
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._clearSelection = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this._displayLabel = '';
        this._displayLabelIsTemplate = false;
        this._selectedOptions = [];
        this._activatedOptions = [];
        this._setInputValue('', false);
        this.setPopupVisible(false);
        // trigger change event
        this._onValueChange();
    };
    Object.defineProperty(NzCascaderComponent.prototype, "_displayRender", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzDisplayRender || defaultDisplayRender;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._buildDisplayLabel = function () {
        var _this = this;
        var /** @type {?} */ selectedOptions = this._selectedOptions;
        var /** @type {?} */ labels = selectedOptions.map(function (o) { return o[_this.nzLabelProperty || 'label']; });
        // 设置当前控件的显示值
        this._displayLabel = this._displayRender.call(this, labels, selectedOptions);
        this._displayLabelIsTemplate = !(typeof this._displayLabel === 'string');
        this._displayLabelContext = { labels: labels, selectedOptions: selectedOptions };
    };
    /**
     * 由用户来定义点击后是否变更
     * @param {?} option
     * @param {?} index
     * @return {?}
     */
    NzCascaderComponent.prototype._isChangeOn = function (option, index) {
        if (typeof this.nzChangeOn === 'function') {
            return this.nzChangeOn(option, index) === true;
        }
        return false;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype.onKeyDown = function (event) {
        var /** @type {?} */ keyCode = event.keyCode;
        if (keyCode !== DOWN_ARROW &&
            keyCode !== UP_ARROW &&
            keyCode !== LEFT_ARROW &&
            keyCode !== RIGHT_ARROW &&
            keyCode !== ENTER &&
            keyCode !== BACKSPACE &&
            keyCode !== ESC) {
            return;
        }
        // Press any keys above to reopen menu
        if (!this._isPopupVisible() &&
            keyCode !== BACKSPACE &&
            keyCode !== ESC) {
            this.setPopupVisible(true);
            return;
        }
        // Press ESC to close menu
        if (keyCode === ESC) {
            this.setPopupVisible(false);
            return;
        }
        if (this._isPopupVisible()) {
            event.preventDefault();
            if (keyCode === DOWN_ARROW) {
                this._moveDown();
            }
            if (keyCode === UP_ARROW) {
                this._moveUp();
            }
            if (keyCode === LEFT_ARROW) {
                this._moveLeft();
            }
            if (keyCode === RIGHT_ARROW) {
                this._moveRight();
            }
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._onTriggerClick = function (event) {
        if (this.nzDisabled) {
            return;
        }
        this.onTouched(); // set your control to 'touched'
        if (this._isClickTiggerAction()) {
            this._delaySetPopupVisible(!this._popupVisible, 100);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._onTriggerMouseEnter = function (event) {
        if (this.nzDisabled) {
            return;
        }
        if (this._isPointerTiggerAction()) {
            this._delaySetPopupVisible(true, this.nzMouseEnterDelay);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._onTriggerMouseLeave = function (event) {
        if (this.nzDisabled) {
            return;
        }
        if (!this._isPopupVisible()) {
            return;
        }
        if (this._isPointerTiggerAction()) {
            var /** @type {?} */ currEl = this._el;
            var /** @type {?} */ popupEl = this.menu && (this.menu.nativeElement);
            if (currEl.contains(/** @type {?} */ (event.target)) ||
                (popupEl && popupEl.contains(/** @type {?} */ (event.target)))) {
                return; // 还在菜单内部
            }
            this._delaySetPopupVisible(false, this.nzMouseLeaveDelay);
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._isClickTiggerAction = function () {
        if (typeof this.nzTriggerAction === 'string') {
            return this.nzTriggerAction === 'click';
        }
        return this.nzTriggerAction.indexOf('click') !== -1;
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._isPointerTiggerAction = function () {
        if (typeof this.nzTriggerAction === 'string') {
            return this.nzTriggerAction === 'hover';
        }
        return this.nzTriggerAction.indexOf('hover') !== -1;
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._closeMenu = function () {
        this._clearDelayTimer();
        this.setPopupVisible(false);
    };
    /**
     * 显示或者隐藏菜单
     *
     * @param {?} visible true-显示，false-隐藏
     * @param {?} delay 延迟时间
     * @return {?}
     */
    NzCascaderComponent.prototype._delaySetPopupVisible = function (visible, delay) {
        var _this = this;
        this._clearDelayTimer();
        if (delay) {
            this._delayTimer = setTimeout(function () {
                _this.setPopupVisible(visible);
                _this._clearDelayTimer();
            }, delay);
        }
        else {
            this.setPopupVisible(visible);
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._isPopupVisible = function () {
        return this._popupVisible;
    };
    /**
     * @param {?} popupVisible
     * @return {?}
     */
    NzCascaderComponent.prototype.setPopupVisible = function (popupVisible) {
        if (this.nzDisabled) {
            return;
        }
        if (this._popupVisible !== popupVisible) {
            this._popupVisible = popupVisible;
            // We must listen to `mousedown` or `touchstart`, edge case:
            // https://github.com/ant-design/ant-design/issues/5804
            // https://github.com/react-component/calendar/issues/250
            // https://github.com/react-component/trigger/issues/50
            if (popupVisible) {
                if (!this._clickOutsideHandler) {
                    this._clickOutsideHandler = this._render.listen('document', 'mousedown', this._onDocumentClick.bind(this));
                }
                // always hide on mobile
                if (!this._touchOutsideHandler) {
                    this._touchOutsideHandler = this._render.listen('document', 'touchstart', this._onDocumentClick.bind(this));
                }
            }
            if (!popupVisible) {
                this._clearOutsideHandler();
            }
            if (popupVisible) {
                this._beforeVisible();
            }
            this.nzVisibleChange.emit(popupVisible);
        }
    };
    /**
     * load init data if necessary
     * @return {?}
     */
    NzCascaderComponent.prototype._beforeVisible = function () {
        var _this = this;
        if (!this._nzColumns.length) {
            new Promise(function (resolve, reject) {
                _this.nzLoad.emit({
                    option: null,
                    index: -1,
                    resolve: resolve,
                    reject: reject
                });
            }).then(function (children) {
                _this._setColumnData(children, 0);
            }, function (reason) {
                // should not be here
            });
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NzCascaderComponent.prototype._onDocumentClick = function (event) {
        var /** @type {?} */ target = (event.target);
        var /** @type {?} */ popupEl = this.menu && (this.menu.nativeElement);
        if (!this._el.contains(target) && !popupEl.contains(target)) {
            this.setPopupVisible(false);
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._clearOutsideHandler = function () {
        if (this._clickOutsideHandler) {
            this._clickOutsideHandler(); // Removes "listen" listener
            this._clickOutsideHandler = null;
        }
        if (this._touchOutsideHandler) {
            this._touchOutsideHandler(); // Removes "listen" listener
            this._touchOutsideHandler = null;
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._clearDelayTimer = function () {
        if (this._delayTimer) {
            clearTimeout(this._delayTimer);
            this._delayTimer = null;
        }
    };
    /**
     * 获取Option的值，例如，可以指定labelProperty="name"来取Name
     * @param {?} option
     * @return {?}
     */
    NzCascaderComponent.prototype._getOptionLabel = function (option) {
        return option[this.nzLabelProperty || 'label'];
    };
    /**
     * 获取Option的值，例如，可以指定valueProperty="id"来取ID
     * @param {?} option
     * @return {?}
     */
    NzCascaderComponent.prototype._getOptionValue = function (option) {
        return option[this.nzValueProperty || 'value'];
    };
    /**
     * @param {?} option
     * @param {?} index
     * @return {?}
     */
    NzCascaderComponent.prototype._isActiveOption = function (option, index) {
        var /** @type {?} */ activeOpt = this._activatedOptions[index];
        if (activeOpt === option) {
            return true;
        }
        if (activeOpt && this._getOptionValue(activeOpt) === this._getOptionValue(option)) {
            return true;
        }
        return false;
    };
    /**
     * 设置某列的激活的菜单选项
     *
     * @param {?} option 菜单选项
     * @param {?} index  选项所在的列组的索引
     * @return {?}
     */
    NzCascaderComponent.prototype._setActiveOption = function (option, index) {
        if (!option || option.disabled) {
            return;
        }
        this._activatedOptions[index] = option;
        // 当直接选择最后一级时，前面的选项要补全。例如，选择“城市”，则自动补全“国家”、“省份”
        for (var /** @type {?} */ i = index - 1; i >= 0; i--) {
            if (!this._activatedOptions[i]) {
                this._activatedOptions[i] = this._activatedOptions[i + 1].parent;
            }
        }
        // 截断多余的选项，如选择“省份”，则只会有“国家”、“省份”，去掉“城市”、“区县”
        if (index < this._activatedOptions.length - 1) {
            this._activatedOptions = this._activatedOptions.slice(0, index + 1);
        }
        // trigger select event, and display label
        this._onSelectOption(option, index);
    };
    /**
     * @param {?} option
     * @param {?} index
     * @return {?}
     */
    NzCascaderComponent.prototype._onSelectOption = function (option, index) {
        var _this = this;
        // trigger `nzSelect` event
        this.nzSelect.emit({
            option: option,
            index: index
        });
        // load children directly
        if (option.children && option.children.length) {
            option.isLeaf = false;
            option.children.forEach(function (child) { return child.parent = option; });
            this._setColumnData(option.children, index + 1);
        }
        else if (!option.isLeaf) {
            // load children async
            new Promise(function (resolve, reject) {
                _this.nzLoad.emit({
                    option: option,
                    index: index,
                    resolve: resolve,
                    reject: reject
                });
            }).then(function (children) {
                children.forEach(function (child) { return child.parent = option; });
                _this._setColumnData(children, index + 1);
                if (_this.nzEnableCache) {
                    option.children = children; // next time we load children directly
                }
            }, function (reason) {
                option.isLeaf = true;
            });
        }
        else {
            // clicking leaf node will remove any children columns
            if (index < this._nzColumns.length - 1) {
                this._nzColumns = this._nzColumns.slice(0, index + 1);
            }
        }
        // 生成显示
        if (option.isLeaf || this.nzChangeOnSelect || this._isChangeOn(option, index)) {
            this._selectedOptions = this._activatedOptions;
            // 设置当前控件的显示值
            this._buildDisplayLabel();
            // 触发变更事件
            this._onValueChange();
        }
        // close menu if click on leaf
        if (option.isLeaf) {
            this._delaySetPopupVisible(false, this.nzMouseLeaveDelay);
        }
    };
    /**
     * @param {?} options
     * @param {?} index
     * @return {?}
     */
    NzCascaderComponent.prototype._setColumnData = function (options, index) {
        if (!arrayEquals(this._nzColumns[index], options)) {
            this._nzColumns[index] = options;
            if (index < this._nzColumns.length - 1) {
                this._nzColumns = this._nzColumns.slice(0, index + 1);
            }
        }
    };
    /**
     * 鼠标点击选项
     *
     * @param {?} option 菜单选项
     * @param {?} index 选项所在的列组的索引
     * @param {?} event 鼠标事件
     * @return {?}
     */
    NzCascaderComponent.prototype._onOptionClick = function (option, index, event) {
        event.preventDefault();
        // Keep focused state for keyboard support
        this._el.focus();
        if (option && option.disabled) {
            return;
        }
        this._setActiveOption(option, index);
    };
    /**
     * press `up` or `down` arrow to select the sibling option.
     * @param {?} isUp
     * @return {?}
     */
    NzCascaderComponent.prototype._moveUpOrDown = function (isUp) {
        var /** @type {?} */ columnIndex = Math.max(this._activatedOptions.length - 1, 0);
        // 该组中已经被激活的选项
        var /** @type {?} */ activeOption = this._activatedOptions[columnIndex];
        // 该组所有的选项，用于遍历获取下一个被激活的选项
        var /** @type {?} */ options = this._nzColumns[columnIndex];
        if (!options || !options.length) {
            return;
        }
        var /** @type {?} */ length = options.length;
        var /** @type {?} */ nextOptIndex = -1;
        if (!activeOption) {
            nextOptIndex = isUp ? length : -1;
        }
        else {
            nextOptIndex = options.indexOf(activeOption);
        }
        while (true) {
            nextOptIndex = isUp ? nextOptIndex - 1 : nextOptIndex + 1;
            if (nextOptIndex < 0 || nextOptIndex >= length) {
                break;
            }
            var /** @type {?} */ nextOption = options[nextOptIndex];
            if (!nextOption || nextOption.disabled) {
                continue;
            }
            this._setActiveOption(nextOption, columnIndex);
            break;
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._moveUp = function () {
        this._moveUpOrDown(true);
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._moveDown = function () {
        this._moveUpOrDown(false);
    };
    /**
     * press `left` arrow to remove the last selected option.
     * If there is no option selected, emit `nzClear` event.
     * @return {?}
     */
    NzCascaderComponent.prototype._moveLeft = function () {
        var /** @type {?} */ options = this._selectedOptions;
        if (options.length) {
            options.pop(); // Remove the last one
            var /** @type {?} */ len = options.length;
            if (len) {
                this._setActiveOption(options[len - 1], len - 1);
            }
            else {
                this.nzClear.emit();
            }
        }
    };
    /**
     * press `right` arrow to select the next column option.
     * @return {?}
     */
    NzCascaderComponent.prototype._moveRight = function () {
        var /** @type {?} */ columns = this._nzColumns;
        var /** @type {?} */ length = this._selectedOptions.length;
        if (length === 0) {
            return;
        }
        var /** @type {?} */ nextColIndex = length;
        var /** @type {?} */ options = columns.length > nextColIndex ? columns[nextColIndex] : null;
        if (options) {
            var /** @type {?} */ len = options.length;
            for (var /** @type {?} */ i = 0; i < len; i++) {
                var /** @type {?} */ activeOpt = options[i];
                if (activeOpt && !activeOpt.disabled) {
                    this._setActiveOption(activeOpt, nextColIndex);
                    return;
                }
            }
        }
    };
    /**
     * 鼠标划入选项
     *
     * @param {?} option 菜单选项
     * @param {?} index 选项所在的列组的索引
     * @param {?} event 鼠标事件
     * @return {?}
     */
    NzCascaderComponent.prototype._onOptionMouseEnter = function (option, index, event) {
        event.preventDefault();
        if (this.nzExpandTrigger === 'hover' && !option.isLeaf) {
            this._delaySelect(option, index, true);
        }
    };
    /**
     * 鼠标划出选项
     *
     * @param {?} option 菜单选项
     * @param {?} index 选项所在的列组的索引
     * @param {?} event 鼠标事件
     * @return {?}
     */
    NzCascaderComponent.prototype._onOptionMouseLeave = function (option, index, event) {
        event.preventDefault();
        if (this.nzExpandTrigger === 'hover' && !option.isLeaf) {
            this._delaySelect(option, index, false);
        }
    };
    /**
     * @param {?} option
     * @param {?} index
     * @param {?} doSelect
     * @return {?}
     */
    NzCascaderComponent.prototype._delaySelect = function (option, index, doSelect) {
        var _this = this;
        if (this._delayTimer) {
            clearTimeout(this._delayTimer);
            this._delayTimer = null;
        }
        if (doSelect) {
            this._delayTimer = setTimeout(function () {
                _this._setActiveOption(option, index);
                _this._delayTimer = null;
            }, 150);
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._getSubmitValue = function () {
        var _this = this;
        var /** @type {?} */ values = [];
        this._selectedOptions.forEach(function (option) {
            values.push(_this._getOptionValue(option));
        });
        return values;
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype._onValueChange = function () {
        var /** @type {?} */ value = this._getSubmitValue();
        if (!arrayEquals(this._lastValue, value)) {
            this._lastValue = value;
            this.onChange(value); // Angular need this
            if (value.length === 0) {
                this.nzClear.emit(); // first trigger `clear` and then `change`
            }
            this.nzSelectionChange.emit(this._selectedOptions);
            this.nzChange.emit(value);
        }
    };
    /**
     * @param {?} classname
     * @return {?}
     */
    NzCascaderComponent.prototype._addHostClass = function (classname) {
        this._render.addClass(this._el, classname);
    };
    /**
     * @param {?} classname
     * @return {?}
     */
    NzCascaderComponent.prototype._removeHostClass = function (classname) {
        this._render.removeClass(this._el, classname);
    };
    /**
     * Write a new value to the element.
     *
     * \@Override (From ControlValueAccessor interface)
     * @param {?} value
     * @return {?}
     */
    NzCascaderComponent.prototype.writeValue = function (value) {
        var _this = this;
        var /** @type {?} */ array = [];
        toArray(value).forEach(function (v, index) {
            if (typeof v !== 'object') {
                var /** @type {?} */ obj = {};
                obj[_this.nzValueProperty] = v;
                obj[_this.nzLabelProperty] = v;
                array[index] = obj;
            }
            else {
                array[index] = v;
            }
        });
        this._activatedOptions = array;
        this._selectedOptions = array;
        this._buildDisplayLabel();
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzCascaderComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzCascaderComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzCascaderComponent.prototype.setDisabledState = function (isDisabled) {
        if (isDisabled) {
            this._closeMenu();
            this._addHostClass(this._prefixCls + "-picker-disabled");
        }
        else {
            this._removeHostClass(this._prefixCls + "-picker-disabled");
        }
        this.nzDisabled = isDisabled;
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype.ngOnInit = function () {
        // 设置第一列
        if (this.nzOptions && this.nzOptions.length) {
            this._nzColumns.push(this.nzOptions);
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype.ngOnDestroy = function () {
        if (this._delayTimer) {
            clearTimeout(this._delayTimer);
            this._delayTimer = null;
        }
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NzCascaderComponent.prototype.ngOnChanges = function (changes) {
        var /** @type {?} */ nzDisabled = changes['nzDisabled'];
        if (nzDisabled) {
            if (nzDisabled.currentValue) {
                this._addHostClass(this._prefixCls + "-picker-disabled");
            }
            else {
                this._removeHostClass(this._prefixCls + "-picker-disabled");
            }
        }
        var /** @type {?} */ nzOptions = changes['nzOptions'];
        if (nzOptions && !nzOptions.isFirstChange()) {
            this._nzColumns.splice(0);
            var /** @type {?} */ newOptions = nzOptions.currentValue;
            if (newOptions && newOptions.length) {
                this._nzColumns.push(newOptions);
                this._clearSelection(null);
            }
        }
    };
    /**
     * @return {?}
     */
    NzCascaderComponent.prototype.ngAfterViewInit = function () {
        this._addHostClass(this._prefixCls);
        this._addHostClass(this._prefixCls + "-picker");
    };
    return NzCascaderComponent;
}());
NzCascaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-cascader',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    DropDownAnimation
                ],
                template: "\n    <div\n      nz-overlay-origin\n      #origin=\"nzOverlayOrigin\"\n      #trigger\n    >\n      <div *ngIf=\"nzShowInput\">\n        <input #input\n          nz-input\n          [attr.autoComplete]=\"'off'\"\n          [attr.placeholder]=\"_hasInput() || _hasSelection() ? null : nzPlaceHolder\"\n          [readonly]=\"!nzShowSearch\"\n          [disabled]=\"nzDisabled\"\n          [nzSize]=\"nzSize\"\n          [ngClass]=\"_inputCls\"\n          [(ngModel)]=\"_inputValue\"\n          (blur)=\"_handleInputBlur($event)\"\n          (focus)=\"_handleInputFocus($event)\"\n          (keydown)=\"_handleInputKeyDown($event)\"\n          (change)=\"_handlerInputChange($event)\"\n        >\n        <i *ngIf=\"_showClearIcon\"\n          [class]=\"'anticon anticon-cross-circle'\"\n          [ngClass]=\"_clearCls\"\n          [attr.title]=\"nzClearText\"\n          (click)=\"_clearSelection($event)\"></i>\n        <i *ngIf=\"nzShowArrow\"\n          class=\"anticon anticon-down\"\n          [ngClass]=\"_arrowCls\"></i>\n        <span [ngClass]=\"_pickerLabelCls\">\n          <ng-container *ngIf=\"_displayLabelIsTemplate\">\n            <ng-container *ngTemplateOutlet=\"_displayLabel; context: _displayLabelContext\"></ng-container>\n          </ng-container>\n          <ng-container *ngIf=\"!_displayLabelIsTemplate\">{{_displayLabel}}</ng-container>\n        </span>\n      </div>\n      <ng-content></ng-content>\n    </div>\n    <ng-template\n      nz-connected-overlay\n      hasBackdrop\n      [origin]=\"origin\"\n      (backdropClick)=\"_closeMenu()\"\n      (detach)=\"_closeMenu()\"\n      (positionChange)=\"onPositionChange($event)\"\n      [open]=\"_popupVisible\"\n    >\n      <div #menu\n        [ngClass]=\"_menuCls\"\n        [@dropDownAnimation]=\"_dropDownPosition\"\n      >\n        <ul *ngFor=\"let options of _nzColumns; let i = index;\"\n          [ngClass]=\"_columnCls\"\n          [attr.data-key]=\"i\">\n          <li *ngFor=\"let option of options\"\n            [attr.data-key]=\"_getOptionValue(option)\"\n            [attr.title]=\"option.title || _getOptionLabel(option)\"\n            [ngClass]=\"_getOptionCls(option, i)\"\n            (mouseenter)=\"_onOptionMouseEnter(option, i, $event)\"\n            (mouseleave)=\"_onOptionMouseLeave(option, i, $event)\"\n            (click)=\"_onOptionClick(option, i, $event)\"\n          >\n            {{_getOptionLabel(option)}}\n          </li>\n        </ul>\n      </div>\n    </ng-template>\n  ",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzCascaderComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-cascader {\n  font-size: 12px;\n}\n.ant-cascader-input.ant-input {\n  background-color: transparent !important;\n  cursor: pointer;\n  width: 100%;\n  display: block;\n}\n.ant-cascader-picker {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n  font-size: 12px;\n  background-color: #fff;\n  border-radius: 4px;\n  outline: 0;\n}\n.ant-cascader-picker-with-value .ant-cascader-picker-label {\n  color: transparent;\n}\n.ant-cascader-picker-disabled {\n  cursor: not-allowed;\n  background: #f7f7f7;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-cascader-picker-disabled .ant-cascader-input {\n  cursor: not-allowed;\n}\n.ant-cascader-picker:focus .ant-cascader-input {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-cascader-picker-label {\n  position: absolute;\n  left: 0;\n  height: 20px;\n  line-height: 20px;\n  top: 50%;\n  margin-top: -10px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  padding: 0 12px 0 8px;\n}\n.ant-cascader-picker-clear {\n  opacity: 0;\n  position: absolute;\n  right: 8px;\n  z-index: 2;\n  background: #fff;\n  top: 50%;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  line-height: 12px;\n  cursor: pointer;\n  transition: color 0.3s ease, opacity 0.15s ease;\n}\n.ant-cascader-picker-clear:hover {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-cascader-picker:hover .ant-cascader-picker-clear {\n  opacity: 1;\n}\n.ant-cascader-picker-arrow {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  right: 8px;\n  width: 12px;\n  height: 12px;\n  margin-top: -6px;\n  line-height: 12px;\n  color: rgba(0, 0, 0, 0.43);\n  display: inline-block;\n  font-size: 12px;\n  font-size: 9px 9;\n  transform: scale(0.75) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-cascader-picker-arrow {\n  filter: none;\n}\n:root .ant-cascader-picker-arrow {\n  font-size: 12px;\n}\n.ant-cascader-picker-arrow:before {\n  transition: transform 0.2s ease;\n}\n.ant-cascader-picker-arrow.ant-cascader-picker-arrow-expand {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n}\n.ant-cascader-picker-arrow.ant-cascader-picker-arrow-expand:before {\n  transform: rotate(180deg);\n}\n.ant-cascader-menus {\n  font-size: 12px;\n  background: #fff;\n  position: absolute;\n  z-index: 1050;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  white-space: nowrap;\n}\n.ant-cascader-menus-empty,\n.ant-cascader-menus-hidden {\n  display: none;\n}\n.ant-cascader-menus.slide-up-enter.slide-up-enter-active.ant-cascader-menus-placement-bottomLeft,\n.ant-cascader-menus.slide-up-appear.slide-up-appear-active.ant-cascader-menus-placement-bottomLeft {\n  animation-name: antSlideUpIn;\n}\n.ant-cascader-menus.slide-up-enter.slide-up-enter-active.ant-cascader-menus-placement-topLeft,\n.ant-cascader-menus.slide-up-appear.slide-up-appear-active.ant-cascader-menus-placement-topLeft {\n  animation-name: antSlideDownIn;\n}\n.ant-cascader-menus.slide-up-leave.slide-up-leave-active.ant-cascader-menus-placement-bottomLeft {\n  animation-name: antSlideUpOut;\n}\n.ant-cascader-menus.slide-up-leave.slide-up-leave-active.ant-cascader-menus-placement-topLeft {\n  animation-name: antSlideDownOut;\n}\n.ant-cascader-menu {\n  display: inline-block;\n  vertical-align: top;\n  min-width: 111px;\n  height: 180px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border-right: 1px solid #e9e9e9;\n  overflow: auto;\n}\n.ant-cascader-menu:first-child {\n  border-radius: 4px 0 0 4px;\n}\n.ant-cascader-menu:last-child {\n  border-right-color: transparent;\n  margin-right: -1px;\n  border-radius: 0 4px 4px 0;\n}\n.ant-cascader-menu:only-child {\n  border-radius: 4px;\n}\n.ant-cascader-menu-item {\n  padding: 7px 8px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.3s;\n}\n.ant-cascader-menu-item:hover {\n  background: #ecf6fd;\n}\n.ant-cascader-menu-item-disabled {\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-cascader-menu-item-disabled:hover {\n  background: transparent;\n}\n.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled),\n.ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {\n  background: #f7f7f7;\n  font-weight: bold;\n}\n.ant-cascader-menu-item-expand {\n  position: relative;\n}\n.ant-cascader-menu-item-expand:after {\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e61f\";\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  color: rgba(0, 0, 0, 0.43);\n  position: absolute;\n  right: 8px;\n}\n:root .ant-cascader-menu-item-expand:after {\n  filter: none;\n}\n:root .ant-cascader-menu-item-expand:after {\n  font-size: 12px;\n}\n.ant-cascader-menu-item-loading:after {\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e64d\";\n  animation: loadingCircle 1s infinite linear;\n}\n.ant-cascader-menu-item .ant-cascader-menu-item-keyword {\n  color: #f04134;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-cascader {\n  display: block;\n}\n.ant-cascader-menus {\n  top: 100%;\n  left: 0;\n  position: relative;\n  width: 100%;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCascaderComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: ChangeDetectorRef, },
]; };
NzCascaderComponent.propDecorators = {
    'nzDisabled': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzPlaceHolder': [{ type: Input },],
    'nzShowInput': [{ type: Input },],
    'nzShowSearch': [{ type: Input },],
    'nzAllowClear': [{ type: Input },],
    'nzClearText': [{ type: Input },],
    'nzShowArrow': [{ type: Input },],
    'nzNotFoundContent': [{ type: Input },],
    'nzPopupClassName': [{ type: Input },],
    'nzColumnClassName': [{ type: Input },],
    'nzOptions': [{ type: Input },],
    'nzEnableCache': [{ type: Input },],
    'nzExpandTrigger': [{ type: Input },],
    'nzChangeOnSelect': [{ type: Input },],
    'nzChangeOn': [{ type: Input },],
    'nzMouseEnterDelay': [{ type: Input },],
    'nzMouseLeaveDelay': [{ type: Input },],
    'nzTriggerAction': [{ type: Input },],
    'nzDisplayRender': [{ type: Input },],
    'nzValueProperty': [{ type: Input },],
    'nzLabelProperty': [{ type: Input },],
    'menu': [{ type: ViewChild, args: ['menu',] },],
    'tabIndex': [{ type: HostBinding, args: ['attr.tabIndex',] },],
    'nzVisibleChange': [{ type: Output },],
    'nzChange': [{ type: Output },],
    'nzSelectionChange': [{ type: Output },],
    'nzSelect': [{ type: Output },],
    'nzLoad': [{ type: Output },],
    'nzClear': [{ type: Output },],
    'onKeyDown': [{ type: HostListener, args: ['keydown', ['$event'],] },],
    '_onTriggerClick': [{ type: HostListener, args: ['click', ['$event'],] },],
    '_onTriggerMouseEnter': [{ type: HostListener, args: ['mouseenter', ['$event'],] },],
    '_onTriggerMouseLeave': [{ type: HostListener, args: ['mouseleave', ['$event'],] },],
};
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
];
var computedStyleCache = {};
var hiddenTextarea;
/**
 * @param {?} node
 * @param {?=} useCache
 * @return {?}
 */
function calculateNodeStyling(node, useCache) {
    if (useCache === void 0) { useCache = false; }
    var /** @type {?} */ nodeRef = (node.getAttribute('id') ||
        node.getAttribute('data-reactid') ||
        node.getAttribute('name'));
    if (useCache && computedStyleCache[nodeRef]) {
        return computedStyleCache[nodeRef];
    }
    var /** @type {?} */ style$$1 = window.getComputedStyle(node);
    var /** @type {?} */ boxSizing = (style$$1.getPropertyValue('box-sizing') ||
        style$$1.getPropertyValue('-moz-box-sizing') ||
        style$$1.getPropertyValue('-webkit-box-sizing'));
    var /** @type {?} */ paddingSize = (parseFloat(style$$1.getPropertyValue('padding-bottom')) +
        parseFloat(style$$1.getPropertyValue('padding-top')));
    var /** @type {?} */ borderSize = (parseFloat(style$$1.getPropertyValue('border-bottom-width')) +
        parseFloat(style$$1.getPropertyValue('border-top-width')));
    var /** @type {?} */ sizingStyle = SIZING_STYLE
        .map(function (name) { return name + ":" + style$$1.getPropertyValue(name); })
        .join(';');
    var /** @type {?} */ nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing,
    };
    if (useCache && nodeRef) {
        computedStyleCache[nodeRef] = nodeInfo;
    }
    return nodeInfo;
}
/**
 * @param {?} uiTextNode
 * @param {?=} useCache
 * @param {?=} minRows
 * @param {?=} maxRows
 * @return {?}
 */
function calculateNodeHeight(uiTextNode, useCache, minRows, maxRows) {
    if (useCache === void 0) { useCache = false; }
    if (minRows === void 0) { minRows = null; }
    if (maxRows === void 0) { maxRows = null; }
    if (!hiddenTextarea) {
        hiddenTextarea = document.createElement('textarea');
        document.body.appendChild(hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) {
        hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    }
    else {
        hiddenTextarea.removeAttribute('wrap');
    }
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _a = calculateNodeStyling(uiTextNode, useCache), paddingSize = _a.paddingSize, borderSize = _a.borderSize, boxSizing = _a.boxSizing, sizingStyle = _a.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    hiddenTextarea.setAttribute('style', sizingStyle + ";" + HIDDEN_TEXTAREA_STYLE);
    hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var /** @type {?} */ minHeight = -Infinity;
    var /** @type {?} */ maxHeight = Infinity;
    var /** @type {?} */ height = hiddenTextarea.scrollHeight;
    var /** @type {?} */ overflowY;
    if (boxSizing === 'border-box') {
        // border-box: add border, since height = content + padding + border
        height = height + borderSize;
    }
    else if (boxSizing === 'content-box') {
        // remove padding, since height = content
        height = height - paddingSize;
    }
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        hiddenTextarea.value = '';
        var /** @type {?} */ singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') {
                minHeight = minHeight + paddingSize + borderSize;
            }
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') {
                maxHeight = maxHeight + paddingSize + borderSize;
            }
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    // Remove scroll bar flash when autosize without maxRows
    if (!maxRows) {
        overflowY = 'hidden';
    }
    return { height: height, minHeight: minHeight, maxHeight: maxHeight, overflowY: overflowY };
}
var NzInputComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function NzInputComponent(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._size = 'default';
        this._prefixCls = 'ant-input';
        this._composing = false;
        this._disabled = false;
        this._readonly = false;
        this._autosize = false;
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.nzType = 'text';
        this.nzBlur = new EventEmitter();
        this.nzFocus = new EventEmitter();
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzInputComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._size = { large: 'lg', small: 'sm' }[value];
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputComponent.prototype, "nzReadonly", {
        /**
         * @return {?}
         */
        get: function () {
            return this._readonly;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._readonly = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputComponent.prototype, "nzAutosize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._autosize;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (typeof value === 'string') {
                this._autosize = true;
            }
            else {
                this._autosize = (value);
            }
            if (this._autosize) {
                this.nzRows = 1;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} e
     * @return {?}
     */
    NzInputComponent.prototype.compositionStart = function (e) {
        this._composing = true;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzInputComponent.prototype.compositionEnd = function (e) {
        this._composing = false;
        this.onChange(this._value);
    };
    Object.defineProperty(NzInputComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if ((this._value === value) || (((this._value === undefined) || (this._value === null)) && ((value === undefined) || (value === null)))) {
                return;
            }
            this._value = value;
            if (!this._composing) {
                this.onChange(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?} $event
     * @return {?}
     */
    NzInputComponent.prototype._emitBlur = function ($event) {
        this.nzBlur.emit($event);
        this.onTouched();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzInputComponent.prototype._emitFocus = function ($event) {
        this.nzFocus.emit($event);
    };
    /**
     * @return {?}
     */
    NzInputComponent.prototype.setClassMap = function () {
        this._classMap = (_a = {},
            _a[this._prefixCls + '-' + this._size] = true,
            _a[this._prefixCls + "-disabled"] = this._disabled,
            _a);
        var _a;
    };
    /**
     * @return {?}
     */
    NzInputComponent.prototype.resizeTextarea = function () {
        var /** @type {?} */ textAreaRef = this.textAreaRef.nativeElement;
        // eliminate jitter
        textAreaRef.style.height = 'auto';
        var /** @type {?} */ maxRows = this.nzAutosize ? ((this.nzAutosize)).maxRows || null : null;
        var /** @type {?} */ minRows = this.nzAutosize ? ((this.nzAutosize)).minRows || null : null;
        var /** @type {?} */ textareaStyles = calculateNodeHeight(textAreaRef, false, minRows, maxRows);
        textAreaRef.style.height = textareaStyles.height + "px";
        textAreaRef.style.overflowY = textareaStyles.overflowY;
    };
    /**
     * @return {?}
     */
    NzInputComponent.prototype.textareaOnChange = function () {
        if (this.nzType === 'textarea' && this.nzAutosize) {
            this.resizeTextarea();
        }
    };
    /**
     * @return {?}
     */
    NzInputComponent.prototype.ngAfterContentInit = function () {
        if (this.nzType === 'search' || this._prefixContent || this._suffixContent) {
            this._renderer.setAttribute(this._el, 'class', this._prefixCls + "-affix-wrapper");
        }
        else {
            this._renderer.setAttribute(this._el, 'class', this._prefixCls + "-wrapper");
        }
        if ((this._addOnContentBefore || this._addOnContentAfter)) {
            this._renderer.setAttribute(this._el, 'class', this._prefixCls + "-group");
        }
    };
    /**
     * @return {?}
     */
    NzInputComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.nzType === 'textarea' && this.nzAutosize) {
            setTimeout(function () { return _this.resizeTextarea(); }, 0);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzInputComponent.prototype.writeValue = function (value) {
        // this.nzValue = value; // [NOTE] nzValue will trigger the onChange which leads to a new "VIEW -> MODEL updating"
        this._value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzInputComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    return NzInputComponent;
}());
NzInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-input',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <span class=\"ant-input-group-addon\" *ngIf=\"_addOnContentBefore\">\n      <ng-template [ngTemplateOutlet]=\"_addOnContentBefore\">\n      </ng-template>\n    </span>\n    <span class=\"ant-input-prefix\" *ngIf=\"_prefixContent\">\n      <ng-template [ngTemplateOutlet]=\"_prefixContent\">\n      </ng-template>\n    </span>\n    <ng-template [ngIf]=\"nzType!='textarea'\">\n      <input\n        (blur)=\"_emitBlur($event)\"\n        (focus)=\"_emitFocus($event)\"\n        [attr.id]=\"nzId\"\n        [disabled]=\"nzDisabled\"\n        [readonly]=\"nzReadonly\"\n        [attr.type]=\"nzType\"\n        class=\"ant-input\"\n        [class.ant-input-search]=\"nzType==='search'\"\n        [ngClass]=\"_classMap\"\n        [attr.placeholder]=\"nzPlaceHolder\"\n        [(ngModel)]=\"nzValue\">\n    </ng-template>\n    <ng-template [ngIf]=\"nzType=='textarea'\">\n      <textarea\n        (blur)=\"_emitBlur($event)\"\n        (focus)=\"_emitFocus($event)\"\n        (input)=\"textareaOnChange($event)\"\n        [attr.id]=\"nzId\"\n        #inputTextarea\n        [disabled]=\"nzDisabled\"\n        [readonly]=\"nzReadonly\"\n        type=\"textarea\"\n        [attr.rows]=\"nzRows\"\n        [attr.cols]=\"nzCols\"\n        class=\"ant-input\"\n        [ngClass]=\"_classMap\"\n        [attr.placeholder]=\"nzPlaceHolder\"\n        [(ngModel)]=\"nzValue\"></textarea>\n    </ng-template>\n    <span class=\"ant-input-suffix\" *ngIf=\"(nzType==='search')||(_suffixContent)\">\n      <i class=\"anticon anticon-search ant-input-search-icon\" *ngIf=\"nzType==='search'\"></i>\n      <ng-template [ngTemplateOutlet]=\"_suffixContent\">\n      </ng-template>\n    </span>\n    <span class=\"ant-input-group-addon\" *ngIf=\"_addOnContentAfter\">\n      <ng-template [ngTemplateOutlet]=\"_addOnContentAfter\">\n      </ng-template>\n    </span>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzInputComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-input-search-icon {\n  cursor: pointer;\n  transition: all .3s;\n  font-size: 14px;\n}\n.ant-input-search-icon:hover {\n  color: #108ee9;\n}\n.ant-search-input-wrapper {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-search-input.ant-input-group .ant-input:first-child,\n.ant-search-input.ant-input-group .ant-select:first-child {\n  border-radius: 4px;\n  position: absolute;\n  top: -1px;\n  width: 100%;\n}\n.ant-search-input.ant-input-group .ant-input:first-child {\n  padding-right: 36px;\n}\n.ant-search-input .ant-search-btn {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-radius: 0 3px 3px 0;\n  left: -1px;\n  position: relative;\n  border-width: 0 0 0 1px;\n  z-index: 2;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-search-input .ant-search-btn > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:hover,\n.ant-search-input .ant-search-btn:focus {\n  color: #108ee9;\n  background-color: #fff;\n  border-color: #108ee9;\n}\n.ant-search-input .ant-search-btn:hover > a:only-child,\n.ant-search-input .ant-search-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn:hover > a:only-child:after,\n.ant-search-input .ant-search-btn:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:active,\n.ant-search-input .ant-search-btn.active {\n  color: #0e77ca;\n  background-color: #fff;\n  border-color: #0e77ca;\n}\n.ant-search-input .ant-search-btn:active > a:only-child,\n.ant-search-input .ant-search-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn:active > a:only-child:after,\n.ant-search-input .ant-search-btn.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn.disabled,\n.ant-search-input .ant-search-btn[disabled],\n.ant-search-input .ant-search-btn.disabled:hover,\n.ant-search-input .ant-search-btn[disabled]:hover,\n.ant-search-input .ant-search-btn.disabled:focus,\n.ant-search-input .ant-search-btn[disabled]:focus,\n.ant-search-input .ant-search-btn.disabled:active,\n.ant-search-input .ant-search-btn[disabled]:active,\n.ant-search-input .ant-search-btn.disabled.active,\n.ant-search-input .ant-search-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-search-input .ant-search-btn.disabled > a:only-child,\n.ant-search-input .ant-search-btn[disabled] > a:only-child,\n.ant-search-input .ant-search-btn.disabled:hover > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:hover > a:only-child,\n.ant-search-input .ant-search-btn.disabled:focus > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:focus > a:only-child,\n.ant-search-input .ant-search-btn.disabled:active > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:active > a:only-child,\n.ant-search-input .ant-search-btn.disabled.active > a:only-child,\n.ant-search-input .ant-search-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn.disabled > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled] > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:hover > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:hover > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:focus > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:focus > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:active > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:active > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled.active > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:hover,\n.ant-search-input .ant-search-btn:focus,\n.ant-search-input .ant-search-btn:active,\n.ant-search-input .ant-search-btn.active {\n  background: #fff;\n}\n.ant-search-input .ant-search-btn:hover {\n  border-color: #d9d9d9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty,\n.ant-search-input:hover .ant-search-btn-noempty {\n  color: #fff;\n  background-color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover,\n.ant-search-input:hover .ant-search-btn-noempty:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus,\n.ant-search-input:hover .ant-search-btn-noempty:focus {\n  color: #fff;\n  background-color: #49a9ee;\n  border-color: #49a9ee;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:focus > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active,\n.ant-search-input:hover .ant-search-btn-noempty:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active,\n.ant-search-input:hover .ant-search-btn-noempty.active {\n  color: #fff;\n  background-color: #0e77ca;\n  border-color: #0e77ca;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled,\n.ant-search-input:hover .ant-search-btn-noempty.disabled,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled],\n.ant-search-input:hover .ant-search-btn-noempty[disabled],\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled] > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled] > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled] > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled] > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-select-combobox .ant-select-selection__rendered {\n  margin-right: 29px;\n}\n.ant-input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n}\n.ant-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input:hover {\n  border-color: #49a9ee;\n}\n.ant-input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n}\n.ant-input-group[class*=\"col-\"] {\n  float: none;\n  padding-left: 0;\n  padding-right: 0;\n}\n.ant-input-group > [class*=\"col-\"] {\n  padding-right: 8px;\n}\n.ant-input-group > [class*=\"col-\"]:last-child {\n  padding-right: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap,\n.ant-input-group > .ant-input {\n  display: table-cell;\n}\n.ant-input-group-addon:not(:first-child):not(:last-child),\n.ant-input-group-wrap:not(:first-child):not(:last-child),\n.ant-input-group > .ant-input:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap {\n  width: 1px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.ant-input-group-wrap > * {\n  display: block !important;\n}\n.ant-input-group .ant-input {\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.ant-input-group .ant-input:focus {\n  z-index: 1;\n}\n.ant-input-group-addon {\n  padding: 4px 7px;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.65);\n  text-align: center;\n  background-color: #eee;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  position: relative;\n  transition: all .3s;\n}\n.ant-input-group-addon .ant-select {\n  margin: -5px -7px;\n}\n.ant-input-group-addon .ant-select .ant-select-selection {\n  background-color: inherit;\n  margin: -1px;\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.ant-input-group-addon .ant-select-open .ant-select-selection,\n.ant-input-group-addon .ant-select-focused .ant-select-selection {\n  color: #108ee9;\n}\n.ant-input-group-addon > i:only-child:after {\n  position: absolute;\n  content: '';\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.ant-input-group > .ant-input:first-child,\n.ant-input-group-addon:first-child {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group > .ant-input:first-child .ant-select .ant-select-selection,\n.ant-input-group-addon:first-child .ant-select .ant-select-selection {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group-addon:first-child {\n  border-right: 0;\n}\n.ant-input-group-addon:last-child {\n  border-left: 0;\n}\n.ant-input-group > .ant-input:last-child,\n.ant-input-group-addon:last-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group > .ant-input:last-child .ant-select .ant-select-selection,\n.ant-input-group-addon:last-child .ant-select .ant-select-selection {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group-lg .ant-input,\n.ant-input-group-lg > .ant-input-group-addon {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-input-group-sm .ant-input,\n.ant-input-group-sm > .ant-input-group-addon {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-input-group-lg .ant-select-selection--single {\n  height: 32px;\n}\n.ant-input-group-sm .ant-select-selection--single {\n  height: 22px;\n}\n.ant-input-group .ant-input-affix-wrapper {\n  display: table-cell;\n  width: 100%;\n  float: left;\n}\n.ant-input-group.ant-input-group-compact > * {\n  border-radius: 0;\n  border-right-width: 0;\n  vertical-align: middle;\n  float: none;\n  display: inline-block;\n}\n.ant-input-group.ant-input-group-compact .ant-input {\n  float: none;\n  z-index: auto;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {\n  border-radius: 0;\n  border-right-width: 0;\n}\n.ant-input-group.ant-input-group-compact > *:first-child,\n.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:first-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:first-child .ant-time-picker-input {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-input-group.ant-input-group-compact > *:last-child,\n.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:last-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:last-child .ant-time-picker-input {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-right-width: 1px;\n}\n.ant-input-group-wrapper {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-input-affix-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.ant-input-affix-wrapper .ant-input {\n  z-index: 1;\n}\n.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #49a9ee;\n}\n.ant-input-affix-wrapper .ant-input-prefix,\n.ant-input-affix-wrapper .ant-input-suffix {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  line-height: 0;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-input-affix-wrapper .ant-input-prefix {\n  left: 7px;\n}\n.ant-input-affix-wrapper .ant-input-suffix {\n  right: 7px;\n}\n.ant-input-affix-wrapper .ant-input:not(:first-child) {\n  padding-left: 24px;\n}\n.ant-input-affix-wrapper .ant-input:not(:last-child) {\n  padding-right: 24px;\n}\n.ant-input-affix-wrapper .ant-input {\n  min-height: 100%;\n}\n",
                    "nz-input {\n  display: inline-block;\n  width: 100%;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzInputComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzInputComponent.propDecorators = {
    'nzPlaceHolder': [{ type: Input },],
    'nzType': [{ type: Input },],
    'nzId': [{ type: Input },],
    'nzRows': [{ type: Input },],
    'nzCols': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzDisabled': [{ type: Input },],
    'nzReadonly': [{ type: Input },],
    'nzAutosize': [{ type: Input },],
    'nzBlur': [{ type: Output },],
    'nzFocus': [{ type: Output },],
    'textAreaRef': [{ type: ViewChild, args: ['inputTextarea',] },],
    '_addOnContentBefore': [{ type: ContentChild, args: ['addOnBefore',] },],
    '_addOnContentAfter': [{ type: ContentChild, args: ['addOnAfter',] },],
    '_prefixContent': [{ type: ContentChild, args: ['prefix',] },],
    '_suffixContent': [{ type: ContentChild, args: ['suffix',] },],
    'compositionStart': [{ type: HostListener, args: ['compositionstart', ['$event'],] },],
    'compositionEnd': [{ type: HostListener, args: ['compositionend', ['$event'],] },],
};
var NzInputDirectiveComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _render
     */
    function NzInputDirectiveComponent(_elementRef, _render) {
        this._elementRef = _elementRef;
        this._render = _render;
        this.size = 'default';
        this._readonly = false;
        this._autosize = false;
        this._disabled = false;
        this._nzInput = true;
        this.nativeElement = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzInputDirectiveComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this.size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.size = { large: 'lg', small: 'sm' }[value];
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputDirectiveComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._render.setAttribute(this.nativeElement, 'disabled', '');
            }
            else {
                this._render.removeAttribute(this.nativeElement, 'disabled');
            }
            this._disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputDirectiveComponent.prototype, "nzReadonly", {
        /**
         * @return {?}
         */
        get: function () {
            return this._readonly;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._render.setAttribute(this.nativeElement, 'readonly', '');
            }
            else {
                this._render.removeAttribute(this.nativeElement, 'readonly');
            }
            this._readonly = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputDirectiveComponent.prototype, "nzAutosize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._autosize;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (typeof value === 'string') {
                this._autosize = true;
            }
            else {
                this._autosize = (value);
            }
            if (this._autosize) {
                this._render.setAttribute(this.nativeElement, 'autosize', '');
            }
            else {
                this._render.removeAttribute(this.nativeElement, 'autosize');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzInputDirectiveComponent.prototype, "setLgClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.size === 'lg';
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputDirectiveComponent.prototype, "setSmClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.size === 'sm';
        },
        enumerable: true,
        configurable: true
    });
    ;
    return NzInputDirectiveComponent;
}());
NzInputDirectiveComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-input]',
                encapsulation: ViewEncapsulation.None,
                template: "",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-input-search-icon {\n  cursor: pointer;\n  transition: all .3s;\n  font-size: 14px;\n}\n.ant-input-search-icon:hover {\n  color: #108ee9;\n}\n.ant-search-input-wrapper {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-search-input.ant-input-group .ant-input:first-child,\n.ant-search-input.ant-input-group .ant-select:first-child {\n  border-radius: 4px;\n  position: absolute;\n  top: -1px;\n  width: 100%;\n}\n.ant-search-input.ant-input-group .ant-input:first-child {\n  padding-right: 36px;\n}\n.ant-search-input .ant-search-btn {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-radius: 0 3px 3px 0;\n  left: -1px;\n  position: relative;\n  border-width: 0 0 0 1px;\n  z-index: 2;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-search-input .ant-search-btn > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:hover,\n.ant-search-input .ant-search-btn:focus {\n  color: #108ee9;\n  background-color: #fff;\n  border-color: #108ee9;\n}\n.ant-search-input .ant-search-btn:hover > a:only-child,\n.ant-search-input .ant-search-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn:hover > a:only-child:after,\n.ant-search-input .ant-search-btn:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:active,\n.ant-search-input .ant-search-btn.active {\n  color: #0e77ca;\n  background-color: #fff;\n  border-color: #0e77ca;\n}\n.ant-search-input .ant-search-btn:active > a:only-child,\n.ant-search-input .ant-search-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn:active > a:only-child:after,\n.ant-search-input .ant-search-btn.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn.disabled,\n.ant-search-input .ant-search-btn[disabled],\n.ant-search-input .ant-search-btn.disabled:hover,\n.ant-search-input .ant-search-btn[disabled]:hover,\n.ant-search-input .ant-search-btn.disabled:focus,\n.ant-search-input .ant-search-btn[disabled]:focus,\n.ant-search-input .ant-search-btn.disabled:active,\n.ant-search-input .ant-search-btn[disabled]:active,\n.ant-search-input .ant-search-btn.disabled.active,\n.ant-search-input .ant-search-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-search-input .ant-search-btn.disabled > a:only-child,\n.ant-search-input .ant-search-btn[disabled] > a:only-child,\n.ant-search-input .ant-search-btn.disabled:hover > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:hover > a:only-child,\n.ant-search-input .ant-search-btn.disabled:focus > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:focus > a:only-child,\n.ant-search-input .ant-search-btn.disabled:active > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:active > a:only-child,\n.ant-search-input .ant-search-btn.disabled.active > a:only-child,\n.ant-search-input .ant-search-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn.disabled > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled] > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:hover > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:hover > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:focus > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:focus > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:active > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:active > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled.active > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:hover,\n.ant-search-input .ant-search-btn:focus,\n.ant-search-input .ant-search-btn:active,\n.ant-search-input .ant-search-btn.active {\n  background: #fff;\n}\n.ant-search-input .ant-search-btn:hover {\n  border-color: #d9d9d9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty,\n.ant-search-input:hover .ant-search-btn-noempty {\n  color: #fff;\n  background-color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover,\n.ant-search-input:hover .ant-search-btn-noempty:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus,\n.ant-search-input:hover .ant-search-btn-noempty:focus {\n  color: #fff;\n  background-color: #49a9ee;\n  border-color: #49a9ee;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:focus > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active,\n.ant-search-input:hover .ant-search-btn-noempty:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active,\n.ant-search-input:hover .ant-search-btn-noempty.active {\n  color: #fff;\n  background-color: #0e77ca;\n  border-color: #0e77ca;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled,\n.ant-search-input:hover .ant-search-btn-noempty.disabled,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled],\n.ant-search-input:hover .ant-search-btn-noempty[disabled],\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled] > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled] > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled] > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled] > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-select-combobox .ant-select-selection__rendered {\n  margin-right: 29px;\n}\n.ant-input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n}\n.ant-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input:hover {\n  border-color: #49a9ee;\n}\n.ant-input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n}\n.ant-input-group[class*=\"col-\"] {\n  float: none;\n  padding-left: 0;\n  padding-right: 0;\n}\n.ant-input-group > [class*=\"col-\"] {\n  padding-right: 8px;\n}\n.ant-input-group > [class*=\"col-\"]:last-child {\n  padding-right: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap,\n.ant-input-group > .ant-input {\n  display: table-cell;\n}\n.ant-input-group-addon:not(:first-child):not(:last-child),\n.ant-input-group-wrap:not(:first-child):not(:last-child),\n.ant-input-group > .ant-input:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap {\n  width: 1px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.ant-input-group-wrap > * {\n  display: block !important;\n}\n.ant-input-group .ant-input {\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.ant-input-group .ant-input:focus {\n  z-index: 1;\n}\n.ant-input-group-addon {\n  padding: 4px 7px;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.65);\n  text-align: center;\n  background-color: #eee;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  position: relative;\n  transition: all .3s;\n}\n.ant-input-group-addon .ant-select {\n  margin: -5px -7px;\n}\n.ant-input-group-addon .ant-select .ant-select-selection {\n  background-color: inherit;\n  margin: -1px;\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.ant-input-group-addon .ant-select-open .ant-select-selection,\n.ant-input-group-addon .ant-select-focused .ant-select-selection {\n  color: #108ee9;\n}\n.ant-input-group-addon > i:only-child:after {\n  position: absolute;\n  content: '';\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.ant-input-group > .ant-input:first-child,\n.ant-input-group-addon:first-child {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group > .ant-input:first-child .ant-select .ant-select-selection,\n.ant-input-group-addon:first-child .ant-select .ant-select-selection {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group-addon:first-child {\n  border-right: 0;\n}\n.ant-input-group-addon:last-child {\n  border-left: 0;\n}\n.ant-input-group > .ant-input:last-child,\n.ant-input-group-addon:last-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group > .ant-input:last-child .ant-select .ant-select-selection,\n.ant-input-group-addon:last-child .ant-select .ant-select-selection {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group-lg .ant-input,\n.ant-input-group-lg > .ant-input-group-addon {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-input-group-sm .ant-input,\n.ant-input-group-sm > .ant-input-group-addon {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-input-group-lg .ant-select-selection--single {\n  height: 32px;\n}\n.ant-input-group-sm .ant-select-selection--single {\n  height: 22px;\n}\n.ant-input-group .ant-input-affix-wrapper {\n  display: table-cell;\n  width: 100%;\n  float: left;\n}\n.ant-input-group.ant-input-group-compact > * {\n  border-radius: 0;\n  border-right-width: 0;\n  vertical-align: middle;\n  float: none;\n  display: inline-block;\n}\n.ant-input-group.ant-input-group-compact .ant-input {\n  float: none;\n  z-index: auto;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {\n  border-radius: 0;\n  border-right-width: 0;\n}\n.ant-input-group.ant-input-group-compact > *:first-child,\n.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:first-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:first-child .ant-time-picker-input {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-input-group.ant-input-group-compact > *:last-child,\n.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:last-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:last-child .ant-time-picker-input {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-right-width: 1px;\n}\n.ant-input-group-wrapper {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-input-affix-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.ant-input-affix-wrapper .ant-input {\n  z-index: 1;\n}\n.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #49a9ee;\n}\n.ant-input-affix-wrapper .ant-input-prefix,\n.ant-input-affix-wrapper .ant-input-suffix {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  line-height: 0;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-input-affix-wrapper .ant-input-prefix {\n  left: 7px;\n}\n.ant-input-affix-wrapper .ant-input-suffix {\n  right: 7px;\n}\n.ant-input-affix-wrapper .ant-input:not(:first-child) {\n  padding-left: 24px;\n}\n.ant-input-affix-wrapper .ant-input:not(:last-child) {\n  padding-right: 24px;\n}\n.ant-input-affix-wrapper .ant-input {\n  min-height: 100%;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzInputDirectiveComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzInputDirectiveComponent.propDecorators = {
    '_disabled': [{ type: HostBinding, args: ["class.ant-input-disabled",] },],
    'nzSize': [{ type: Input },],
    'nzDisabled': [{ type: Input },],
    'nzReadonly': [{ type: Input },],
    'nzAutosize': [{ type: Input },],
    '_nzInput': [{ type: HostBinding, args: ["class.ant-input",] },],
    'setLgClass': [{ type: HostBinding, args: ["class.ant-input-lg",] },],
    'setSmClass': [{ type: HostBinding, args: ["class.ant-input-sm",] },],
};
var NzInputGroupComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _render
     */
    function NzInputGroupComponent(_elementRef, _render) {
        this._elementRef = _elementRef;
        this._render = _render;
        this._prefixCls = 'ant-input';
        this.nzCompact = false;
        this._el = this._elementRef.nativeElement;
        this._render.addClass(this._el, this._prefixCls + "-group");
    }
    Object.defineProperty(NzInputGroupComponent.prototype, "_isLarge", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzSize === 'lg';
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputGroupComponent.prototype, "_isSmall", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzSize === 'sm';
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    NzInputGroupComponent.prototype.ngOnInit = function () {
    };
    return NzInputGroupComponent;
}());
NzInputGroupComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-input-group',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-input-search-icon {\n  cursor: pointer;\n  transition: all .3s;\n  font-size: 14px;\n}\n.ant-input-search-icon:hover {\n  color: #108ee9;\n}\n.ant-search-input-wrapper {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-search-input.ant-input-group .ant-input:first-child,\n.ant-search-input.ant-input-group .ant-select:first-child {\n  border-radius: 4px;\n  position: absolute;\n  top: -1px;\n  width: 100%;\n}\n.ant-search-input.ant-input-group .ant-input:first-child {\n  padding-right: 36px;\n}\n.ant-search-input .ant-search-btn {\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border-color: #d9d9d9;\n  border-radius: 0 3px 3px 0;\n  left: -1px;\n  position: relative;\n  border-width: 0 0 0 1px;\n  z-index: 2;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-search-input .ant-search-btn > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:hover,\n.ant-search-input .ant-search-btn:focus {\n  color: #108ee9;\n  background-color: #fff;\n  border-color: #108ee9;\n}\n.ant-search-input .ant-search-btn:hover > a:only-child,\n.ant-search-input .ant-search-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn:hover > a:only-child:after,\n.ant-search-input .ant-search-btn:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:active,\n.ant-search-input .ant-search-btn.active {\n  color: #0e77ca;\n  background-color: #fff;\n  border-color: #0e77ca;\n}\n.ant-search-input .ant-search-btn:active > a:only-child,\n.ant-search-input .ant-search-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn:active > a:only-child:after,\n.ant-search-input .ant-search-btn.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn.disabled,\n.ant-search-input .ant-search-btn[disabled],\n.ant-search-input .ant-search-btn.disabled:hover,\n.ant-search-input .ant-search-btn[disabled]:hover,\n.ant-search-input .ant-search-btn.disabled:focus,\n.ant-search-input .ant-search-btn[disabled]:focus,\n.ant-search-input .ant-search-btn.disabled:active,\n.ant-search-input .ant-search-btn[disabled]:active,\n.ant-search-input .ant-search-btn.disabled.active,\n.ant-search-input .ant-search-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-search-input .ant-search-btn.disabled > a:only-child,\n.ant-search-input .ant-search-btn[disabled] > a:only-child,\n.ant-search-input .ant-search-btn.disabled:hover > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:hover > a:only-child,\n.ant-search-input .ant-search-btn.disabled:focus > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:focus > a:only-child,\n.ant-search-input .ant-search-btn.disabled:active > a:only-child,\n.ant-search-input .ant-search-btn[disabled]:active > a:only-child,\n.ant-search-input .ant-search-btn.disabled.active > a:only-child,\n.ant-search-input .ant-search-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input .ant-search-btn.disabled > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled] > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:hover > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:hover > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:focus > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:focus > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled:active > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled]:active > a:only-child:after,\n.ant-search-input .ant-search-btn.disabled.active > a:only-child:after,\n.ant-search-input .ant-search-btn[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-search-btn:hover,\n.ant-search-input .ant-search-btn:focus,\n.ant-search-input .ant-search-btn:active,\n.ant-search-input .ant-search-btn.active {\n  background: #fff;\n}\n.ant-search-input .ant-search-btn:hover {\n  border-color: #d9d9d9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty,\n.ant-search-input:hover .ant-search-btn-noempty {\n  color: #fff;\n  background-color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover,\n.ant-search-input:hover .ant-search-btn-noempty:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus,\n.ant-search-input:hover .ant-search-btn-noempty:focus {\n  color: #fff;\n  background-color: #49a9ee;\n  border-color: #49a9ee;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:focus > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active,\n.ant-search-input:hover .ant-search-btn-noempty:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active,\n.ant-search-input:hover .ant-search-btn-noempty.active {\n  color: #fff;\n  background-color: #0e77ca;\n  border-color: #0e77ca;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled,\n.ant-search-input:hover .ant-search-btn-noempty.disabled,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled],\n.ant-search-input:hover .ant-search-btn-noempty[disabled],\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled] > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled] > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active > a:only-child,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active > a:only-child,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled] > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled] > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:hover > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:hover > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:focus > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:focus > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:focus > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled]:active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled]:active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty.disabled.active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty.disabled.active > a:only-child:after,\n.ant-search-input.ant-search-input-focus .ant-search-btn-noempty[disabled].active > a:only-child:after,\n.ant-search-input:hover .ant-search-btn-noempty[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-search-input .ant-select-combobox .ant-select-selection__rendered {\n  margin-right: 29px;\n}\n.ant-input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n}\n.ant-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input:hover {\n  border-color: #49a9ee;\n}\n.ant-input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n}\n.ant-input-group[class*=\"col-\"] {\n  float: none;\n  padding-left: 0;\n  padding-right: 0;\n}\n.ant-input-group > [class*=\"col-\"] {\n  padding-right: 8px;\n}\n.ant-input-group > [class*=\"col-\"]:last-child {\n  padding-right: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap,\n.ant-input-group > .ant-input {\n  display: table-cell;\n}\n.ant-input-group-addon:not(:first-child):not(:last-child),\n.ant-input-group-wrap:not(:first-child):not(:last-child),\n.ant-input-group > .ant-input:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.ant-input-group-addon,\n.ant-input-group-wrap {\n  width: 1px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.ant-input-group-wrap > * {\n  display: block !important;\n}\n.ant-input-group .ant-input {\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n.ant-input-group .ant-input:focus {\n  z-index: 1;\n}\n.ant-input-group-addon {\n  padding: 4px 7px;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.65);\n  text-align: center;\n  background-color: #eee;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  position: relative;\n  transition: all .3s;\n}\n.ant-input-group-addon .ant-select {\n  margin: -5px -7px;\n}\n.ant-input-group-addon .ant-select .ant-select-selection {\n  background-color: inherit;\n  margin: -1px;\n  border: 1px solid transparent;\n  box-shadow: none;\n}\n.ant-input-group-addon .ant-select-open .ant-select-selection,\n.ant-input-group-addon .ant-select-focused .ant-select-selection {\n  color: #108ee9;\n}\n.ant-input-group-addon > i:only-child:after {\n  position: absolute;\n  content: '';\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.ant-input-group > .ant-input:first-child,\n.ant-input-group-addon:first-child {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group > .ant-input:first-child .ant-select .ant-select-selection,\n.ant-input-group-addon:first-child .ant-select .ant-select-selection {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:first-child) .ant-input {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-input-group-addon:first-child {\n  border-right: 0;\n}\n.ant-input-group-addon:last-child {\n  border-left: 0;\n}\n.ant-input-group > .ant-input:last-child,\n.ant-input-group-addon:last-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group > .ant-input:last-child .ant-select .ant-select-selection,\n.ant-input-group-addon:last-child .ant-select .ant-select-selection {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group-lg .ant-input,\n.ant-input-group-lg > .ant-input-group-addon {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-input-group-sm .ant-input,\n.ant-input-group-sm > .ant-input-group-addon {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-input-group-lg .ant-select-selection--single {\n  height: 32px;\n}\n.ant-input-group-sm .ant-select-selection--single {\n  height: 22px;\n}\n.ant-input-group .ant-input-affix-wrapper {\n  display: table-cell;\n  width: 100%;\n  float: left;\n}\n.ant-input-group.ant-input-group-compact > * {\n  border-radius: 0;\n  border-right-width: 0;\n  vertical-align: middle;\n  float: none;\n  display: inline-block;\n}\n.ant-input-group.ant-input-group-compact .ant-input {\n  float: none;\n  z-index: auto;\n}\n.ant-input-group.ant-input-group-compact > .ant-select > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {\n  border-radius: 0;\n  border-right-width: 0;\n}\n.ant-input-group.ant-input-group-compact > *:first-child,\n.ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:first-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:first-child .ant-time-picker-input {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-input-group.ant-input-group-compact > *:last-child,\n.ant-input-group.ant-input-group-compact > .ant-select:last-child > .ant-select-selection,\n.ant-input-group.ant-input-group-compact > .ant-calendar-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n.ant-input-group.ant-input-group-compact > .ant-mention-wrapper:last-child .ant-mention-editor,\n.ant-input-group.ant-input-group-compact > .ant-time-picker:last-child .ant-time-picker-input {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-right-width: 1px;\n}\n.ant-input-group-wrapper {\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-input-affix-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.ant-input-affix-wrapper .ant-input {\n  z-index: 1;\n}\n.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {\n  border-color: #49a9ee;\n}\n.ant-input-affix-wrapper .ant-input-prefix,\n.ant-input-affix-wrapper .ant-input-suffix {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  line-height: 0;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-input-affix-wrapper .ant-input-prefix {\n  left: 7px;\n}\n.ant-input-affix-wrapper .ant-input-suffix {\n  right: 7px;\n}\n.ant-input-affix-wrapper .ant-input:not(:first-child) {\n  padding-left: 24px;\n}\n.ant-input-affix-wrapper .ant-input:not(:last-child) {\n  padding-right: 24px;\n}\n.ant-input-affix-wrapper .ant-input {\n  min-height: 100%;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzInputGroupComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzInputGroupComponent.propDecorators = {
    '_isLarge': [{ type: HostBinding, args: ["class.ant-input-group-lg",] },],
    '_isSmall': [{ type: HostBinding, args: ["class.ant-input-group-sm",] },],
    'nzSize': [{ type: Input },],
    'nzCompact': [{ type: Input }, { type: HostBinding, args: ["class.ant-input-group-compact",] },],
};
var NzInputModule = (function () {
    function NzInputModule() {
    }
    return NzInputModule;
}());
NzInputModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzInputComponent, NzInputGroupComponent, NzInputDirectiveComponent],
                exports: [NzInputComponent, NzInputGroupComponent, NzInputDirectiveComponent],
                imports: [CommonModule, FormsModule]
            },] },
];
/**
 * @nocollapse
 */
NzInputModule.ctorParameters = function () { return []; };
var NzCascaderModule = (function () {
    function NzCascaderModule() {
    }
    return NzCascaderModule;
}());
NzCascaderModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule, OverlayModule, NzInputModule],
                declarations: [
                    NzCascaderComponent
                ],
                exports: [
                    NzCascaderComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCascaderModule.ctorParameters = function () { return []; };
var NzCheckboxComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _render
     */
    function NzCheckboxComponent(_elementRef, _render) {
        this._elementRef = _elementRef;
        this._render = _render;
        this._prefixCls = 'ant-checkbox';
        this._innerPrefixCls = this._prefixCls + "-inner";
        this._inputPrefixCls = this._prefixCls + "-input";
        this._checked = false;
        this._focused = false;
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.nzDisabled = false;
        this.nzIndeterminate = false;
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzCheckboxComponent.prototype, "nzChecked", {
        /**
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?} e
     * @return {?}
     */
    NzCheckboxComponent.prototype.onClick = function (e) {
        e.preventDefault();
        if (!this.nzDisabled) {
            this.updateValue(!this._checked);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzCheckboxComponent.prototype.updateValue = function (value) {
        if (value === this._checked) {
            return;
        }
        this.onChange(value);
        this._checked = value;
    };
    /**
     * @return {?}
     */
    NzCheckboxComponent.prototype.nzFocus = function () {
        this._focused = true;
    };
    /**
     * @return {?}
     */
    NzCheckboxComponent.prototype.nzBlur = function () {
        this._focused = false;
    };
    Object.defineProperty(NzCheckboxComponent.prototype, "_classMap", {
        /**
         * @return {?}
         */
        get: function () {
            return _a = {},
                _a[this._prefixCls] = true,
                _a[this._prefixCls + "-checked"] = this._checked && (!this.nzIndeterminate),
                _a[this._prefixCls + "-focused"] = this._focused,
                _a[this._prefixCls + "-disabled"] = this.nzDisabled,
                _a[this._prefixCls + "-indeterminate"] = this.nzIndeterminate,
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    NzCheckboxComponent.prototype.writeValue = function (value) {
        this._checked = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzCheckboxComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzCheckboxComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzCheckboxComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    /**
     * @return {?}
     */
    NzCheckboxComponent.prototype.ngOnInit = function () {
        this._render.addClass(this._el, this._prefixCls + "-wrapper");
    };
    return NzCheckboxComponent;
}());
NzCheckboxComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-checkbox]',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <span [ngClass]=\"_classMap\">\n      <span [ngClass]=\"_innerPrefixCls\"></span>\n      <input type=\"checkbox\"\n        [ngClass]=\"_inputPrefixCls\"\n        [ngModel]=\"nzChecked\"\n        (focus)=\"nzFocus()\"\n        (blur)=\"onTouched();nzBlur()\">\n    </span>\n    <ng-content></ng-content>\n  ",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzCheckboxComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n@keyframes antCheckboxEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n.ant-checkbox {\n  white-space: nowrap;\n  cursor: pointer;\n  outline: none;\n  display: inline-block;\n  line-height: 1;\n  position: relative;\n  vertical-align: text-bottom;\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n  border-color: #108ee9;\n}\n.ant-checkbox-checked:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  border: 1px solid #108ee9;\n  content: '';\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: both;\n  visibility: hidden;\n}\n.ant-checkbox:hover:after,\n.ant-checkbox-wrapper:hover .ant-checkbox:after {\n  visibility: visible;\n}\n.ant-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  background-color: #fff;\n  transition: all .3s;\n}\n.ant-checkbox-inner:after {\n  transform: rotate(45deg) scale(0);\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  display: table;\n  width: 5px;\n  height: 8px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  content: ' ';\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n}\n.ant-checkbox-input {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner:after {\n  content: ' ';\n  transform: scale(1);\n  position: absolute;\n  left: 2px;\n  top: 5px;\n  width: 8px;\n  height: 1px;\n}\n.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner:after {\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-checkbox-checked .ant-checkbox-inner:after {\n  transform: rotate(45deg) scale(1);\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  display: table;\n  width: 5px;\n  height: 8px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  content: ' ';\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n}\n.ant-checkbox-checked .ant-checkbox-inner,\n.ant-checkbox-indeterminate .ant-checkbox-inner {\n  background-color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after {\n  animation-name: none;\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-checkbox-disabled .ant-checkbox-input {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled .ant-checkbox-inner {\n  border-color: #d9d9d9 !important;\n  background-color: #f7f7f7;\n}\n.ant-checkbox-disabled .ant-checkbox-inner:after {\n  animation-name: none;\n  border-color: #f7f7f7;\n}\n.ant-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-checkbox-wrapper {\n  cursor: pointer;\n  font-size: 12px;\n  display: inline-block;\n}\n.ant-checkbox-wrapper:not(:last-child) {\n  margin-right: 8px;\n}\n.ant-checkbox-wrapper + span,\n.ant-checkbox + span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-checkbox-group {\n  font-size: 12px;\n}\n.ant-checkbox-group-item {\n  display: inline-block;\n}\n@media \0screen {\n  .ant-checkbox-checked .ant-checkbox-inner:before,\n  .ant-checkbox-checked .ant-checkbox-inner:after {\n    font-family: 'anticon';\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    content: \"\\e632\";\n    font-weight: bold;\n    font-size: 8px;\n    border: 0;\n    color: #fff;\n    left: 2px;\n    top: 3px;\n    position: absolute;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCheckboxComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzCheckboxComponent.propDecorators = {
    'nzDisabled': [{ type: Input },],
    'nzIndeterminate': [{ type: Input },],
    'nzChecked': [{ type: Input },],
    'onClick': [{ type: HostListener, args: ['click', ['$event'],] },],
};
var NzCheckboxGroupComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _render
     */
    function NzCheckboxGroupComponent(_elementRef, _render) {
        this._elementRef = _elementRef;
        this._render = _render;
        this._prefixCls = 'ant-checkbox-group';
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.nzDisabled = false;
        this._el = this._elementRef.nativeElement;
        this._render.setElementClass(this._el, "" + this._prefixCls, true);
    }
    /**
     * @return {?}
     */
    NzCheckboxGroupComponent.prototype._optionChange = function () {
        this.onChange(this._options);
    };
    /**
     * @return {?}
     */
    NzCheckboxGroupComponent.prototype.ngAfterContentInit = function () {
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzCheckboxGroupComponent.prototype.writeValue = function (value) {
        this._options = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzCheckboxGroupComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzCheckboxGroupComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzCheckboxGroupComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    /**
     * @return {?}
     */
    NzCheckboxGroupComponent.prototype.ngOnInit = function () {
    };
    return NzCheckboxGroupComponent;
}());
NzCheckboxGroupComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-checkbox-group',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <label\n      [class.ant-checkbox-vertical]=\"nzType=='vertical'\"\n      nz-checkbox\n      *ngFor=\"let option of _options\"\n      [nzDisabled]=\"option.disabled||nzDisabled\"\n      [(ngModel)]=\"option.checked\"\n      (ngModelChange)=\"_optionChange()\">\n      <span>{{option.label}}</span>\n    </label>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzCheckboxGroupComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n@keyframes antCheckboxEffect {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n.ant-checkbox {\n  white-space: nowrap;\n  cursor: pointer;\n  outline: none;\n  display: inline-block;\n  line-height: 1;\n  position: relative;\n  vertical-align: text-bottom;\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n  border-color: #108ee9;\n}\n.ant-checkbox-checked:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  border: 1px solid #108ee9;\n  content: '';\n  animation: antCheckboxEffect 0.36s ease-in-out;\n  animation-fill-mode: both;\n  visibility: hidden;\n}\n.ant-checkbox:hover:after,\n.ant-checkbox-wrapper:hover .ant-checkbox:after {\n  visibility: visible;\n}\n.ant-checkbox-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  background-color: #fff;\n  transition: all .3s;\n}\n.ant-checkbox-inner:after {\n  transform: rotate(45deg) scale(0);\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  display: table;\n  width: 5px;\n  height: 8px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  content: ' ';\n  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);\n}\n.ant-checkbox-input {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner:after {\n  content: ' ';\n  transform: scale(1);\n  position: absolute;\n  left: 2px;\n  top: 5px;\n  width: 8px;\n  height: 1px;\n}\n.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner:after {\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-checkbox-checked .ant-checkbox-inner:after {\n  transform: rotate(45deg) scale(1);\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  display: table;\n  width: 5px;\n  height: 8px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  content: ' ';\n  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;\n}\n.ant-checkbox-checked .ant-checkbox-inner,\n.ant-checkbox-indeterminate .ant-checkbox-inner {\n  background-color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-checkbox-disabled {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after {\n  animation-name: none;\n  border-color: rgba(0, 0, 0, 0.25);\n}\n.ant-checkbox-disabled .ant-checkbox-input {\n  cursor: not-allowed;\n}\n.ant-checkbox-disabled .ant-checkbox-inner {\n  border-color: #d9d9d9 !important;\n  background-color: #f7f7f7;\n}\n.ant-checkbox-disabled .ant-checkbox-inner:after {\n  animation-name: none;\n  border-color: #f7f7f7;\n}\n.ant-checkbox-disabled + span {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-checkbox-wrapper {\n  cursor: pointer;\n  font-size: 12px;\n  display: inline-block;\n}\n.ant-checkbox-wrapper:not(:last-child) {\n  margin-right: 8px;\n}\n.ant-checkbox-wrapper + span,\n.ant-checkbox + span {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-checkbox-group {\n  font-size: 12px;\n}\n.ant-checkbox-group-item {\n  display: inline-block;\n}\n@media \0screen {\n  .ant-checkbox-checked .ant-checkbox-inner:before,\n  .ant-checkbox-checked .ant-checkbox-inner:after {\n    font-family: 'anticon';\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    content: \"\\e632\";\n    font-weight: bold;\n    font-size: 8px;\n    border: 0;\n    color: #fff;\n    left: 2px;\n    top: 3px;\n    position: absolute;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCheckboxGroupComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer, },
]; };
NzCheckboxGroupComponent.propDecorators = {
    'nzDisabled': [{ type: Input },],
    'nzType': [{ type: Input },],
};
var NzCheckboxModule = (function () {
    function NzCheckboxModule() {
    }
    return NzCheckboxModule;
}());
NzCheckboxModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule],
                declarations: [
                    NzCheckboxComponent,
                    NzCheckboxGroupComponent
                ],
                exports: [
                    NzCheckboxComponent,
                    NzCheckboxGroupComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCheckboxModule.ctorParameters = function () { return []; };
var NzTimePickerInnerComponent = (function () {
    /**
     * @param {?} _cdr
     */
    function NzTimePickerInnerComponent(_cdr) {
        this._cdr = _cdr;
        this._now = new Date();
        this._open = false;
        this._hourList = [];
        this._minuteList = [];
        this._secondList = [];
        this._value = null;
        this._selectedHour = moment(this._now).hours();
        this._selectedMinute = moment(this._now).minutes();
        this._selectedSecond = moment(this._now).seconds();
        this._format = 'HH:mm:ss';
        this._showHour = this._format.indexOf('HH') > -1;
        this._showMinute = this._format.indexOf('mm') > -1;
        this._showSecond = this._format.indexOf('ss') > -1;
        this._width = (+this._showHour + +this._showMinute + +this._showSecond) * 56 + 1 + 'px';
        this._hideDisabledOptions = false;
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.nzPlaceHolder = '请选择时间';
        this.nzSize = 'default';
        this.nzDisabled = false;
    }
    Object.defineProperty(NzTimePickerInnerComponent.prototype, "nzHideDisabledOptions", {
        /**
         * @return {?}
         */
        get: function () {
            return this._hideDisabledOptions;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._hideDisabledOptions = true;
            }
            else {
                this._hideDisabledOptions = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTimePickerInnerComponent.prototype, "nzFormat", {
        /**
         * @return {?}
         */
        get: function () {
            return this._format;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._format = value;
            this._showHour = this._format.indexOf('HH') > -1;
            this._showMinute = this._format.indexOf('mm') > -1;
            this._showSecond = this._format.indexOf('ss') > -1;
            this._width = (+this._showHour + +this._showMinute + +this._showSecond) * 56 + 1 + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTimePickerInnerComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value || this._now;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value === value) {
                return;
            }
            this._value = value;
            this._selectedHour = moment(this.nzValue).hours();
            this._selectedMinute = moment(this.nzValue).minutes();
            this._selectedSecond = moment(this.nzValue).seconds();
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    /**
     * @param {?} instance
     * @param {?} index
     * @param {?=} duration
     * @param {?=} unit
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._scrollToSelected = function (instance, index, duration, unit) {
        if (duration === void 0) { duration = 0; }
        var /** @type {?} */ _transIndex = this._translateIndex(index, unit);
        var /** @type {?} */ currentOption = instance.children[0].children[_transIndex] || instance.children[0].children[0];
        this.scrollTo(instance, currentOption.offsetTop, duration);
    };
    /**
     * @param {?} element
     * @param {?} to
     * @param {?} duration
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype.scrollTo = function (element, to, duration) {
        var _this = this;
        var /** @type {?} */ requestAnimationFrame = window.requestAnimationFrame || function requestAnimationFrameTimeout() {
            return setTimeout(arguments[0], 10);
        };
        if (duration <= 0) {
            element.scrollTop = to;
            return;
        }
        var /** @type {?} */ difference = to - element.scrollTop;
        var /** @type {?} */ perTick = difference / duration * 10;
        requestAnimationFrame(function () {
            element.scrollTop = element.scrollTop + perTick;
            if (element.scrollTop === to) {
                return;
            }
            _this.scrollTo(element, to, duration - 10);
        });
    };
    ;
    /**
     * @param {?} instance
     * @param {?} index
     * @param {?} disabled
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._selectHour = function (instance, index, disabled) {
        if (disabled) {
            return;
        }
        this._scrollToSelected(instance, index, 120, 'hour');
        this._selectedHour = index;
        this.nzValue = moment(this.nzValue).hour(index).toDate();
        this.onChange(this._value);
        this._buildMinutes();
        this._buildSeconds();
    };
    /**
     * @param {?} instance
     * @param {?} index
     * @param {?} disabled
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._selectMinute = function (instance, index, disabled) {
        if (disabled) {
            return;
        }
        this._scrollToSelected(instance, index, 120, 'minute');
        this._selectedMinute = index;
        this.nzValue = moment(this.nzValue).minute(index).toDate();
        this.onChange(this._value);
        this._buildSeconds();
    };
    /**
     * @param {?} instance
     * @param {?} index
     * @param {?} disabled
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._selectSecond = function (instance, index, disabled) {
        if (disabled) {
            return;
        }
        this._scrollToSelected(instance, index, 120, 'second');
        this._selectedSecond = index;
        this.nzValue = moment(this.nzValue).second(index).toDate();
        this.onChange(this._value);
    };
    /**
     * @param {?} index
     * @param {?} unit
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._translateIndex = function (index, unit) {
        if (!this.nzHideDisabledOptions) {
            return index;
        }
        if (unit === 'hour') {
            var /** @type {?} */ disabledHours = this.nzDisabledHours && this.nzDisabledHours();
            return this._calcIndex(disabledHours, index);
        }
        else if (unit === 'minute') {
            var /** @type {?} */ disabledMinutes = this.nzDisabledMinutes && this.nzDisabledMinutes(this._selectedHour);
            return this._calcIndex(disabledMinutes, index);
        }
        else if (unit === 'second') {
            var /** @type {?} */ disabledSeconds = this.nzDisabledSeconds && this.nzDisabledSeconds(this._selectedHour, this._selectedMinute);
            return this._calcIndex(disabledSeconds, index);
        }
    };
    /**
     * @param {?} array
     * @param {?} index
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._calcIndex = function (array, index) {
        if (array && array.length) {
            return index - array.reduce(function (pre, value) {
                return pre + (value < index ? 1 : 0);
            }, 0);
        }
        else {
            return index;
        }
    };
    /**
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._initPosition = function () {
        this._selectedHour = moment(this.nzValue).hours();
        this._selectedMinute = moment(this.nzValue).minutes();
        this._selectedSecond = moment(this.nzValue).seconds();
        if (this._showHour) {
            this._scrollToSelected(this._hourListInstance.nativeElement, this._selectedHour, 0, 'hour');
        }
        if (this._showMinute) {
            this._scrollToSelected(this._minuteListInstance.nativeElement, this._selectedMinute, 0, 'minute');
        }
        if (this._showSecond) {
            this._scrollToSelected(this._secondListInstance.nativeElement, this._selectedSecond, 0, 'second');
        }
    };
    /**
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._buildTime = function () {
        this._buildHours();
        this._buildMinutes();
        this._buildSeconds();
    };
    /**
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._buildHours = function () {
        this._hourList = [];
        for (var /** @type {?} */ i = 0; i <= 23; i++) {
            this._hourList.push({
                disabled: this.nzDisabledHours && (this.nzDisabledHours().indexOf(i) !== -1),
                name: i.toString().length === 1 ? ('0' + i) : ('' + i),
                index: i
            });
        }
    };
    /**
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._buildMinutes = function () {
        this._minuteList = [];
        for (var /** @type {?} */ i = 0; i <= 59; i++) {
            this._minuteList.push({
                disabled: this.nzDisabledMinutes && (this.nzDisabledMinutes(this._selectedHour).indexOf(i) !== -1),
                name: i.toString().length === 1 ? ('0' + i) : ('' + i),
                index: i
            });
        }
    };
    /**
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype._buildSeconds = function () {
        this._secondList = [];
        for (var /** @type {?} */ i = 0; i <= 59; i++) {
            this._secondList.push({
                disabled: this.nzDisabledSeconds && (this.nzDisabledSeconds(this._selectedHour, this._selectedMinute).indexOf(i) !== -1),
                name: i.toString().length === 1 ? ('0' + i) : ('' + i),
                index: i
            });
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype.writeValue = function (value) {
        this.nzValue = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    /**
     * @return {?}
     */
    NzTimePickerInnerComponent.prototype.ngOnInit = function () {
        this._buildTime();
    };
    return NzTimePickerInnerComponent;
}());
NzTimePickerInnerComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-timepicker-inner',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <span\n      class=\"ant-calendar-time-picker\"\n      [ngClass]=\"{'ant-time-picker-large':nzSize=='large','ant-time-picker-small':nzSize=='small'}\">\n      <div\n        class=\"ant-calendar-time-picker-panel\"\n        [@dropDownAnimation]=\"'bottom'\">\n        <div class=\"ant-calendar-time-picker-inner\"\n          [class.ant-calendar-time-picker-column-3]=\"_showHour&&_showMinute&&_showSecond\"\n          [class.ant-calendar-time-picker-column-2]=\"_showHour&&_showMinute&&!_showSecond\"\n          [class.ant-calendar-time-picker-column-1]=\"_showHour&&(!_showMinute)&&(!_showSecond)\">\n        <div class=\"ant-calendar-time-picker-combobox\">\n          <div\n            class=\"ant-calendar-time-picker-select\"\n            #hourListInstance\n            *ngIf=\"_showHour\">\n            <ul>\n              <ng-template\n                ngFor\n                let-_hour\n                [ngForOf]=\"_hourList\"\n                let-i=\"index\">\n                 <li\n                   [ngClass]=\"_hour.name\"\n                   *ngIf=\"!(nzHideDisabledOptions&&_hour.disabled)\"\n                   [class.ant-time-picker-panel-select-option-selected]=\"_hour.index===_selectedHour\"\n                   [class.ant-time-picker-panel-select-option-disabled]=\"_hour.disabled\"\n                   (click)=\"_selectHour(hourListInstance,_hour.index,_hour.disabled)\">\n                   {{_hour.name}}\n                 </li>\n              </ng-template>\n            </ul>\n          </div>\n          <div\n            class=\"ant-calendar-time-picker-select\"\n            #minuteListInstance\n            *ngIf=\"_showMinute\">\n            <ul>\n              <ng-template\n                ngFor\n                let-_minute\n                [ngForOf]=\"_minuteList\"\n                let-i=\"index\">\n                 <li\n                   [ngClass]=\"_minute.name\"\n                   *ngIf=\"!(nzHideDisabledOptions&&_minute.disabled)\"\n                   [class.ant-time-picker-panel-select-option-selected]=\"_minute.index===_selectedMinute\"\n                   [class.ant-time-picker-panel-select-option-disabled]=\"_minute.disabled\"\n                   (click)=\"_selectMinute(minuteListInstance,_minute.index,_minute.disabled)\">\n                   {{_minute.name}}\n                 </li>\n              </ng-template>\n            </ul>\n          </div>\n          <div\n            class=\"ant-calendar-time-picker-select\"\n            #secondListInstance\n            *ngIf=\"_showSecond\">\n            <ul>\n              <ng-template\n                ngFor\n                let-_second\n                [ngForOf]=\"_secondList\"\n                let-i=\"index\">\n                 <li\n                   [ngClass]=\"_second.name\"\n                   *ngIf=\"!(nzHideDisabledOptions&&_second.disabled)\"\n                   [class.ant-time-picker-panel-select-option-selected]=\"_second.index===_selectedSecond\"\n                   [class.ant-time-picker-panel-select-option-disabled]=\"_second.disabled\"\n                   (click)=\"_selectSecond(secondListInstance,_second.index,_second.disabled)\">\n                   {{_second.name}}\n                 </li>\n              </ng-template>\n            </ul>\n          </div>\n        </div>\n      </div>\n      </div>\n    </span>",
                animations: [
                    DropDownAnimation
                ],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzTimePickerInnerComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-time-picker-panel {\n  z-index: 1050;\n  position: absolute;\n}\n.ant-time-picker-panel-inner {\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n  line-height: 1.5;\n  overflow: hidden;\n  left: -2px;\n}\n.ant-time-picker-panel-input {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  width: 100%;\n  cursor: auto;\n  line-height: 1.5;\n  outline: 0;\n}\n.ant-time-picker-panel-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-time-picker-panel-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-panel-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-panel-input-wrap {\n  box-sizing: border-box;\n  position: relative;\n  padding: 6px;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-time-picker-panel-input-invalid {\n  border-color: red;\n}\n.ant-time-picker-panel-clear-btn {\n  position: absolute;\n  right: 5px;\n  cursor: pointer;\n  overflow: hidden;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 20px;\n  top: 5px;\n  margin: 0;\n}\n.ant-time-picker-panel-clear-btn:after {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  display: inline-block;\n  line-height: 1;\n  width: 20px;\n  transition: color 0.3s ease;\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e62e\";\n}\n.ant-time-picker-panel-clear-btn:hover:after {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-time-picker-panel-narrow .ant-time-picker-panel-input-wrap {\n  max-width: 112px;\n}\n.ant-time-picker-panel-select {\n  float: left;\n  font-size: 12px;\n  border-left: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  width: 56px;\n  overflow: hidden;\n  position: relative;\n  max-height: 144px;\n}\n.ant-time-picker-panel-select:hover {\n  overflow-y: auto;\n}\n.ant-time-picker-panel-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.ant-time-picker-panel-select:last-child {\n  border-right: 0;\n}\n.ant-time-picker-panel-select:only-child {\n  width: 100%;\n}\n.ant-time-picker-panel-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0 0 120px;\n  width: 100%;\n}\n.ant-time-picker-panel-select li {\n  list-style: none;\n  box-sizing: content-box;\n  margin: 0;\n  padding: 0 0 0 8px;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  text-align: left;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.3s;\n}\n.ant-time-picker-panel-select li:hover {\n  background: #ecf6fd;\n}\nli.ant-time-picker-panel-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.ant-time-picker-panel-select-option-selected:hover {\n  background: #f7f7f7;\n}\nli.ant-time-picker-panel-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-time-picker-panel-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-time-picker-panel-combobox {\n  zoom: 1;\n}\n.ant-time-picker-panel-combobox:before,\n.ant-time-picker-panel-combobox:after {\n  content: \" \";\n  display: table;\n}\n.ant-time-picker-panel-combobox:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-time-picker-panel-addon {\n  padding: 8px;\n  border-top: 1px solid #e9e9e9;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-time-picker {\n  position: relative;\n  display: inline-block;\n  outline: none;\n  font-size: 12px;\n  transition: opacity 0.3s ease;\n  width: 100px;\n}\n.ant-time-picker-input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n}\n.ant-time-picker-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-time-picker-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input:hover {\n  border-color: #49a9ee;\n}\n.ant-time-picker-input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-time-picker-input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-time-picker-input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-time-picker-input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-time-picker-input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-time-picker-input[disabled] {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input[disabled]:hover {\n  border-color: #e2e2e2;\n}\n.ant-time-picker-large .ant-time-picker-input {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-time-picker-small .ant-time-picker-input {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-time-picker-open {\n  opacity: 0;\n}\n.ant-time-picker-icon {\n  position: absolute;\n  user-select: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  width: 12px;\n  height: 12px;\n  line-height: 12px;\n  right: 8px;\n  color: rgba(0, 0, 0, 0.43);\n  top: 50%;\n  margin-top: -6px;\n}\n.ant-time-picker-icon:after {\n  content: \"\\e641\";\n  font-family: \"anticon\";\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n  display: block;\n  line-height: 1;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-time-picker-panel {\n  z-index: 1050;\n  position: absolute;\n}\n.ant-time-picker-panel-inner {\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n  line-height: 1.5;\n  overflow: hidden;\n  left: -2px;\n}\n.ant-time-picker-panel-input {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  width: 100%;\n  cursor: auto;\n  line-height: 1.5;\n  outline: 0;\n}\n.ant-time-picker-panel-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-time-picker-panel-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-panel-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-panel-input-wrap {\n  box-sizing: border-box;\n  position: relative;\n  padding: 6px;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-time-picker-panel-input-invalid {\n  border-color: red;\n}\n.ant-time-picker-panel-clear-btn {\n  position: absolute;\n  right: 5px;\n  cursor: pointer;\n  overflow: hidden;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 20px;\n  top: 5px;\n  margin: 0;\n}\n.ant-time-picker-panel-clear-btn:after {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  display: inline-block;\n  line-height: 1;\n  width: 20px;\n  transition: color 0.3s ease;\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e62e\";\n}\n.ant-time-picker-panel-clear-btn:hover:after {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-time-picker-panel-narrow .ant-time-picker-panel-input-wrap {\n  max-width: 112px;\n}\n.ant-time-picker-panel-select {\n  float: left;\n  font-size: 12px;\n  border-left: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  width: 56px;\n  overflow: hidden;\n  position: relative;\n  max-height: 144px;\n}\n.ant-time-picker-panel-select:hover {\n  overflow-y: auto;\n}\n.ant-time-picker-panel-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.ant-time-picker-panel-select:last-child {\n  border-right: 0;\n}\n.ant-time-picker-panel-select:only-child {\n  width: 100%;\n}\n.ant-time-picker-panel-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0 0 120px;\n  width: 100%;\n}\n.ant-time-picker-panel-select li {\n  list-style: none;\n  box-sizing: content-box;\n  margin: 0;\n  padding: 0 0 0 8px;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  text-align: left;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.3s;\n}\n.ant-time-picker-panel-select li:hover {\n  background: #ecf6fd;\n}\nli.ant-time-picker-panel-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.ant-time-picker-panel-select-option-selected:hover {\n  background: #f7f7f7;\n}\nli.ant-time-picker-panel-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-time-picker-panel-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-time-picker-panel-combobox {\n  zoom: 1;\n}\n.ant-time-picker-panel-combobox:before,\n.ant-time-picker-panel-combobox:after {\n  content: \" \";\n  display: table;\n}\n.ant-time-picker-panel-combobox:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-time-picker-panel-addon {\n  padding: 8px;\n  border-top: 1px solid #e9e9e9;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-time-picker {\n  position: relative;\n  display: inline-block;\n  outline: none;\n  font-size: 12px;\n  transition: opacity 0.3s ease;\n  width: 100px;\n}\n.ant-time-picker-input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n}\n.ant-time-picker-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-time-picker-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input:hover {\n  border-color: #49a9ee;\n}\n.ant-time-picker-input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-time-picker-input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-time-picker-input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-time-picker-input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-time-picker-input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-time-picker-input[disabled] {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input[disabled]:hover {\n  border-color: #e2e2e2;\n}\n.ant-time-picker-large .ant-time-picker-input {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-time-picker-small .ant-time-picker-input {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-time-picker-open {\n  opacity: 0;\n}\n.ant-time-picker-icon {\n  position: absolute;\n  user-select: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  width: 12px;\n  height: 12px;\n  line-height: 12px;\n  right: 8px;\n  color: rgba(0, 0, 0, 0.43);\n  top: 50%;\n  margin-top: -6px;\n}\n.ant-time-picker-icon:after {\n  content: \"\\e641\";\n  font-family: \"anticon\";\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n  display: block;\n  line-height: 1;\n}\n.ant-time-picker-panel {\n  position: relative;\n  left: 0;\n}\n.ant-time-picker-panel.top {\n  bottom: -8px;\n}\n.ant-time-picker-panel.bottom {\n  top: -2px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzTimePickerInnerComponent.ctorParameters = function () { return [
    { type: ChangeDetectorRef, },
]; };
NzTimePickerInnerComponent.propDecorators = {
    '_hourListInstance': [{ type: ViewChild, args: ['hourListInstance',] },],
    '_minuteListInstance': [{ type: ViewChild, args: ['minuteListInstance',] },],
    '_inputTimeInstance': [{ type: ViewChild, args: ['inputTimeInstance',] },],
    '_secondListInstance': [{ type: ViewChild, args: ['secondListInstance',] },],
    'nzHideDisabledOptions': [{ type: Input },],
    'nzPlaceHolder': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzDisabledHours': [{ type: Input },],
    'nzDisabledMinutes': [{ type: Input },],
    'nzDisabledSeconds': [{ type: Input },],
    'nzDisabled': [{ type: Input },],
    'nzFormat': [{ type: Input },],
};
var POSITION_MAP = {
    'top': {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom'
    },
    'topCenter': {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom'
    },
    'topLeft': {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom'
    },
    'topRight': {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom'
    },
    'right': {
        originX: 'end',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
    },
    'rightTop': {
        originX: 'end',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
    },
    'rightBottom': {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'bottom',
    },
    'bottom': {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
    },
    'bottomCenter': {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
    },
    'bottomLeft': {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
    },
    'bottomRight': {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
    },
    'left': {
        originX: 'start',
        originY: 'center',
        overlayX: 'end',
        overlayY: 'center',
    },
    'leftTop': {
        originX: 'start',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'top',
    },
    'leftBottom': {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'bottom',
    },
};
var DEFAULT_4_POSITIONS = _objectValues([POSITION_MAP['top'], POSITION_MAP['right'], POSITION_MAP['bottom'], POSITION_MAP['left']]);
var DEFAULT_DROPDOWN_POSITIONS = _objectValues([POSITION_MAP['bottomLeft'], POSITION_MAP['topLeft']]);
var DEFAULT_DATEPICKER_POSITIONS = ([
    {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
    },
    {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'bottom',
    }
]);
/**
 * @param {?} array
 * @param {?} iteratee
 * @return {?}
 */
function arrayMap(array, iteratee) {
    var /** @type {?} */ index = -1;
    var /** @type {?} */ length = array == null ? 0 : array.length, /** @type {?} */ result = Array(length);
    while (++index < length) {
        result[index] = iteratee(array[index], index, array);
    }
    return result;
}
/**
 * @param {?} object
 * @param {?} props
 * @return {?}
 */
function baseValues(object, props) {
    return arrayMap(props, function (key) {
        return object[key];
    });
}
/**
 * @param {?} object
 * @return {?}
 */
function _objectValues(object) {
    return object == null ? [] : baseValues(object, Object.keys(object));
}
var NzDatePickerComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _cdr
     */
    function NzDatePickerComponent(_elementRef, _cdr) {
        this._elementRef = _elementRef;
        this._cdr = _cdr;
        this._open = false;
        this._mode = 'year';
        this._dropDownPosition = 'bottom';
        this._triggerWidth = 0;
        this._value = null;
        this._disabled = false;
        this._today = new Date();
        this._selectedMonth = moment(this.nzValue).month();
        this._selectedYear = moment(this.nzValue).year();
        this._selectedDate = moment(this.nzValue).date();
        this._showMonth = moment(new Date()).month();
        this._showYear = moment(new Date()).year();
        this._startDecade = Math.floor(this._showYear / 10) * 10;
        this._yearPanel = [];
        this._positions = DEFAULT_DATEPICKER_POSITIONS.slice();
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.nzAllowClear = true;
        this.nzShowTime = null;
        this.nzPlaceHolder = '请选择日期';
        this.nzFormat = 'YYYY-MM-DD';
        this.nzSize = '';
        this.nzMode = 'day';
        this._nzCalendarPicker = true;
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzDatePickerComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
            this._closeCalendar();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._setTriggerWidth = function () {
        this._triggerWidth = this.trigger.nativeElement.getBoundingClientRect().width;
    };
    /**
     * @param {?} position
     * @return {?}
     */
    NzDatePickerComponent.prototype.onPositionChange = function (position) {
        var /** @type {?} */ _position = position.connectionPair.originY === 'bottom' ? 'top' : 'bottom';
        if (this._dropDownPosition !== _position) {
            this._dropDownPosition = _position;
            this._cdr.detectChanges();
        }
    };
    Object.defineProperty(NzDatePickerComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value || new Date();
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateValue(value);
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    /**
     * @param {?} $event
     * @return {?}
     */
    NzDatePickerComponent.prototype._changeTime = function ($event) {
        this._value = $event;
    };
    /**
     * @param {?} box
     * @return {?}
     */
    NzDatePickerComponent.prototype._blurInput = function (box) {
        if (Date.parse(box.value)) {
            this.nzValue = new Date(box.value);
            this.onChange(this._value);
        }
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._preYear = function () {
        this._showYear = this._showYear - 1;
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._nextYear = function () {
        this._showYear = this._showYear + 1;
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._preMonth = function () {
        if (this._showMonth - 1 < 0) {
            this._showMonth = 11;
            this._preYear();
        }
        else {
            this._showMonth = this._showMonth - 1;
        }
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._nextMonth = function () {
        if (this._showMonth + 1 > 11) {
            this._showMonth = 0;
            this._nextYear();
        }
        else {
            this._showMonth = this._showMonth + 1;
        }
    };
    /**
     * @param {?} year
     * @param {?} $event
     * @return {?}
     */
    NzDatePickerComponent.prototype._setShowYear = function (year, $event) {
        $event.stopPropagation();
        this._showYear = year;
        this._mode = this.nzMode === 'day' ? 'year' : 'month';
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._preDecade = function () {
        this._startDecade = this._startDecade - 10;
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._nextDecade = function () {
        this._startDecade = this._startDecade + 10;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzDatePickerComponent.prototype._clearValue = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.nzValue = null;
        this.onChange(this._value);
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._changeToToday = function () {
        this.nzValue = new Date();
        this.onChange(this._value);
        this._closeCalendar();
    };
    /**
     * @param {?} day
     * @return {?}
     */
    NzDatePickerComponent.prototype._clickDay = function (day) {
        if (!this.nzShowTime) {
            this._closeCalendar();
            this.nzValue = day.date.toDate();
            this.onChange(this._value);
        }
        else {
            this.nzValue = moment(this.nzValue).year(day.date.year()).month(day.date.month()).date(day.date.date()).toDate();
            this.onChange(this._value);
        }
    };
    /**
     * @param {?} month
     * @return {?}
     */
    NzDatePickerComponent.prototype._clickMonth = function (month) {
        if (this.nzMode === 'month') {
            this._closeCalendar();
            this.nzValue = moment(this.nzValue).year(this._showYear).month(month.index).toDate();
            this.onChange(this._value);
        }
        else {
            this._showMonth = month.index;
            this._mode = 'year';
        }
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._openCalendar = function () {
        if (this.nzDisabled) {
            return;
        }
        this._mode = this.nzMode === 'day' ? 'year' : 'month';
        this._open = true;
        this._setTriggerWidth();
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._closeCalendar = function () {
        if (!this._open) {
            return;
        }
        if (this.nzShowTime) {
            this.onChange(this._value);
        }
        this._open = false;
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._changeMonthView = function () {
        this._mode = 'month';
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzDatePickerComponent.prototype._changeDecadeView = function ($event) {
        $event.stopPropagation();
        this._mode = 'decade';
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzDatePickerComponent.prototype._changeTimeView = function ($event) {
        var _this = this;
        $event.stopPropagation();
        this._mode = 'time';
        setTimeout(function (_) {
            _this.timePickerInner._initPosition();
        });
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzDatePickerComponent.prototype._changeYearView = function ($event) {
        $event.stopPropagation();
        this._mode = 'year';
    };
    Object.defineProperty(NzDatePickerComponent.prototype, "_showClearIcon", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value && !this.nzDisabled && this.nzAllowClear;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype._generateYearPanel = function () {
        var /** @type {?} */ _t = [];
        for (var /** @type {?} */ i = 0; i < 10; i++) {
            if (i === 1 || i === 4 || i === 7 || i === 9) {
                _t.push(i);
                this._yearPanel.push(_t);
                _t = [];
            }
            else {
                _t.push(i);
            }
        }
        this._yearPanel[0].unshift('start');
        this._yearPanel[3].push('end');
    };
    /**
     * @return {?}
     */
    NzDatePickerComponent.prototype.ngOnInit = function () {
        this._generateYearPanel();
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzDatePickerComponent.prototype.writeValue = function (value) {
        // this.nzValue = value;
        this._updateValue(value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzDatePickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzDatePickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzDatePickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzDatePickerComponent.prototype._updateValue = function (value) {
        if (this._value === value) {
            return;
        }
        this._value = value;
        this._selectedMonth = moment(this.nzValue).month();
        this._selectedYear = moment(this.nzValue).year();
        this._selectedDate = moment(this.nzValue).date();
        this._showYear = moment(this.nzValue).year();
        this._showMonth = moment(this.nzValue).month();
        this._startDecade = Math.floor(this._showYear / 10) * 10;
    };
    return NzDatePickerComponent;
}());
NzDatePickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-datepicker',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    DropDownAnimation
                ],
                template: "\n    <span style=\"display: block\"\n      (click)=\"_openCalendar()\"\n      nz-overlay-origin\n      #origin=\"nzOverlayOrigin\"\n      #trigger>\n      <input\n        nz-input\n        (blur)=\"onTouched()\"\n        [attr.placeholder]=\"nzPlaceHolder\"\n        [nzDisabled]=\"nzDisabled\"\n        [nzSize]=\"nzSize\"\n        class=\"ant-calendar-picker-input\"\n        [value]=\"_value|nzDate:nzFormat\">\n      <i class=\"ant-calendar-picker-clear anticon anticon-cross-circle\"\n        *ngIf=\"_showClearIcon\"\n        (click)=\"onTouched();_clearValue($event)\">\n      </i>\n      <span class=\"ant-calendar-picker-icon\"></span>\n    </span>\n    <ng-template\n      nz-connected-overlay\n      hasBackdrop\n      [positions]=\"_positions\"\n      [origin]=\"origin\"\n      (backdropClick)=\"_closeCalendar()\"\n      (detach)=\"_closeCalendar()\"\n      (positionChange)=\"onPositionChange($event)\"\n      [open]=\"_open\">\n      <div class=\"ant-calendar-picker-container\"\n        [class.top]=\"_dropDownPosition==='top'\"\n        [class.bottom]=\"_dropDownPosition==='bottom'\"\n        [@dropDownAnimation]=\"_dropDownPosition\">\n        <div class=\"ant-calendar\" tabindex=\"0\" [class.ant-calendar-time]=\"nzShowTime\">\n          <div class=\"ant-calendar-input-wrap\">\n            <div class=\"ant-calendar-date-input-wrap\">\n              <input class=\"ant-calendar-input\"\n                [attr.placeholder]=\"nzPlaceHolder\"\n                [value]=\"_value|nzDate:nzFormat\"\n                #dateBox\n                (blur)=\"_blurInput(dateBox)\">\n            </div>\n            <a class=\"ant-calendar-clear-btn\" title=\"\u6E05\u9664\"></a>\n          </div>\n          <div class=\"ant-calendar-date-panel\">\n            <div class=\"ant-calendar-header\">\n              <div style=\"position: relative;\" *ngIf=\"_mode!='time'\">\n                <a class=\"ant-calendar-prev-year-btn\" title=\"\u4E0A\u4E00\u5E74\" (click)=\"_preYear()\"></a>\n                <a class=\"ant-calendar-prev-month-btn\" title=\"\u4E0A\u4E2A\u6708\" (click)=\"_preMonth()\"></a>\n                <span class=\"ant-calendar-ym-select\">\n                <a class=\"ant-calendar-month-select\" title=\"\u9009\u62E9\u6708\u4EFD\" (click)=\"_changeMonthView()\">{{_showMonth + 1}}\u6708</a>\n                <a class=\"ant-calendar-year-select\" title=\"\u9009\u62E9\u5E74\u4EFD\" (click)=\"_changeDecadeView($event)\">{{_showYear}}\u5E74</a>\n                </span>\n                <a class=\"ant-calendar-next-month-btn\" title=\"\u4E0B\u4E2A\u6708\" (click)=\"_nextMonth()\"></a>\n                <a class=\"ant-calendar-next-year-btn\" title=\"\u4E0B\u4E00\u5E74\" (click)=\"_nextYear()\"></a>\n              </div>\n              <div style=\"position: relative;\" *ngIf=\"_mode=='time'\">\n                <span class=\"ant-calendar-my-select\">\n                  <a class=\"ant-calendar-year-select\" title=\"Choose a month\">{{_selectedYear}}\u5E74</a>\n                  <a class=\"ant-calendar-month-select\" title=\"Choose a month\">{{_showMonth + 1}}\u6708</a>\n                  <a class=\"ant-calendar-day-select\">{{_selectedDate}}\u65E5</a>\n                </span>\n              </div>\n              <div class=\"ant-calendar-month-panel\" *ngIf=\"_mode=='month'\">\n                <div>\n                  <div class=\"ant-calendar-month-panel-header\">\n                    <a class=\"ant-calendar-month-panel-prev-year-btn\" title=\"\u4E0A\u4E00\u5E74\" (click)=\"_preYear()\"></a>\n                    <a class=\"ant-calendar-month-panel-year-select\" title=\"\u9009\u62E9\u5E74\u4EFD\" (click)=\"_changeDecadeView($event)\">\n                      <span class=\"ant-calendar-month-panel-year-select-content\">{{_showYear}}</span>\n                      <span class=\"ant-calendar-month-panel-year-select-arrow\">x</span>\n                    </a>\n                    <a class=\"ant-calendar-month-panel-next-year-btn\" title=\"\u4E0B\u4E00\u5E74\" (click)=\"_nextYear()\"></a>\n                  </div>\n                  <div class=\"ant-calendar-month-panel-body\">\n                    <nz-calendar\n                      [nzClearTime]=\"!nzShowTime\"\n                      [nzDisabledDate]=\"nzDisabledDate\"\n                      (nzClickDay)=\"_clickDay($event)\"\n                      [nzShowMonth]=\"_showMonth\"\n                      [nzShowYear]=\"_showYear\"\n                      [nzValue]=\"_value\"\n                      (nzClickMonth)=\"_clickMonth($event)\"\n                      [nzMode]=\"'month'\"\n                      [nzFullScreen]=\"false\"\n                      [nzShowHeader]=\"false\"\n                      [nzDatePicker]=\"true\">\n                    </nz-calendar>\n                  </div>\n                </div>\n              </div>\n              <div class=\"ant-calendar-year-panel\" *ngIf=\"_mode=='decade'\">\n                <div>\n                  <div class=\"ant-calendar-year-panel-header\">\n                    <a class=\"ant-calendar-year-panel-prev-decade-btn\" title=\"\u4E0A\u4E00\u5E74\u4EE3\" (click)=\"_preDecade()\"></a>\n                    <a class=\"ant-calendar-year-panel-decade-select\" title=\"\u9009\u62E9\u5E74\u4EE3\">\n                      <span class=\"ant-calendar-year-panel-decade-select-content\">{{_startDecade}}-{{_startDecade + 9}}</span>\n                      <span class=\"ant-calendar-year-panel-decade-select-arrow\">x</span>\n                    </a>\n                    <a class=\"ant-calendar-year-panel-next-decade-btn\" title=\"\u4E0B\u4E00\u5E74\u4EE3\" (click)=\"_nextDecade()\"></a>\n                  </div>\n                  <div class=\"ant-calendar-year-panel-body\">\n                    <table class=\"ant-calendar-year-panel-table\" cellspacing=\"0\" role=\"grid\">\n                      <tbody class=\"ant-calendar-year-panel-tbody\">\n                        <tr *ngFor=\"let tr of _yearPanel\">\n                          <ng-template ngFor let-td [ngForOf]=\"tr\">\n                            <td class=\"ant-calendar-year-panel-cell ant-calendar-year-panel-last-decade-cell\" *ngIf=\"td=='start'\">\n                              <a class=\"ant-calendar-year-panel-year\" (click)=\"_preDecade()\">{{_startDecade - 1}}</a>\n                            </td>\n                            <td *ngIf=\"(td!='start')&&(td!='end')\" [attr.title]=\"_startDecade+td\" class=\"ant-calendar-year-panel-cell\" [ngClass]=\"{'ant-calendar-year-panel-selected-cell':(_startDecade+td==_showYear)}\">\n                              <a class=\"ant-calendar-year-panel-year\" (click)=\"_setShowYear(_startDecade+td,$event)\">{{_startDecade + td}}</a>\n                            </td>\n                            <td class=\"ant-calendar-year-panel-cell ant-calendar-year-panel-next-decade-cell\" *ngIf=\"td=='end'\">\n                              <a class=\"ant-calendar-year-panel-year\" (click)=\"_nextDecade()\">{{_startDecade + 10}}</a>\n                            </td>\n                          </ng-template>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <nz-timepicker-inner\n              [nzPlaceHolder]=\"nzShowTime&&nzShowTime.nzPlaceHolder||'\u8BF7\u9009\u62E9\u65F6\u95F4'\"\n              [nzFormat]=\"nzShowTime&&nzShowTime.nzFormat||'HH:mm:ss'\"\n              [nzDisabled]=\"nzShowTime&&nzShowTime.nzDisabled||false\"\n              [nzDisabledHours]=\"nzShowTime&&nzShowTime.nzDisabledHours||null\"\n              [nzDisabledMinutes]=\"nzShowTime&&nzShowTime.nzDisabledMinutes||null\"\n              [nzDisabledSeconds]=\"nzShowTime&&nzShowTime.nzDisabledSeconds||null\"\n              [nzHideDisabledOptions]=\"nzShowTime&&nzShowTime.nzHideDisabledOptions||false\"\n              [ngModel]=\"_value\" (ngModelChange)=\"_changeTime($event)\"\n              *ngIf=\"nzShowTime&&(_mode == 'time')\"></nz-timepicker-inner>\n            <div class=\"ant-calendar-calendar-body\">\n              <nz-calendar [nzClearTime]=\"!nzShowTime\" [nzDisabledDate]=\"nzDisabledDate\" (nzClickDay)=\"_clickDay($event)\" [nzShowMonth]=\"_showMonth\" [nzShowYear]=\"_showYear\" [nzValue]=\"_value\" (nzClickMonth)=\"_clickMonth($event)\" [nzMode]=\"'year'\" [nzFullScreen]=\"false\" [nzShowHeader]=\"false\" [nzDatePicker]=\"true\"></nz-calendar>\n            </div>\n            <div class=\"ant-calendar-footer ant-calendar-footer-show-ok\">\n                <span class=\"ant-calendar-footer-btn\">\n                  <a class=\"ant-calendar-today-btn \" [attr.title]=\"_today|nzDate:nzFormat\" (click)=\"_changeToToday()\">{{nzShowTime ? '\u6B64\u523B' : '\u4ECA\u5929'}}</a>\n                  <a class=\"ant-calendar-time-picker-btn\" (click)=\"_changeTimeView($event)\" *ngIf=\"(_mode != 'time')&&nzShowTime\">\u9009\u62E9\u65F6\u95F4</a>\n                  <a class=\"ant-calendar-time-picker-btn\" (click)=\"_changeYearView($event)\" *ngIf=\"(_mode == 'time')&&nzShowTime\">\u9009\u62E9\u65E5\u671F</a>\n                  <a class=\"ant-calendar-ok-btn\" *ngIf=\"nzShowTime\" (click)=\"_closeCalendar()\">\u786E \u5B9A</a>\n                </span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzDatePickerComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-calendar-picker-container {\n  position: absolute;\n  z-index: 1050;\n}\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topRight,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomRight,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-calendar-picker {\n  position: relative;\n  display: inline-block;\n  outline: none;\n  font-size: 12px;\n  transition: opacity 0.3s;\n}\n.ant-calendar-picker-input {\n  outline: none;\n  display: block;\n}\n.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {\n  border-color: #108ee9;\n}\n.ant-calendar-picker-clear,\n.ant-calendar-picker-icon {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  right: 8px;\n  top: 50%;\n  margin-top: -7px;\n  line-height: 14px;\n  font-size: 12px;\n  transition: all .3s;\n  user-select: none;\n}\n.ant-calendar-picker-clear {\n  opacity: 0;\n  z-index: 1;\n  color: rgba(0, 0, 0, 0.25);\n  background: #fff;\n  pointer-events: none;\n  cursor: pointer;\n}\n.ant-calendar-picker-clear:hover {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-calendar-picker:hover .ant-calendar-picker-clear {\n  opacity: 1;\n  pointer-events: auto;\n}\n.ant-calendar-picker-icon {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-calendar-picker-icon:after {\n  content: \"\\e6bb\";\n  font-family: \"anticon\";\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n  display: inline-block;\n  line-height: 1;\n}\n.ant-calendar {\n  position: relative;\n  outline: none;\n  width: 231px;\n  border: 1px solid #fff;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n  line-height: 1.5;\n}\n.ant-calendar-input-wrap {\n  height: 34px;\n  padding: 6px;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-input {\n  border: 0;\n  width: 100%;\n  cursor: auto;\n  outline: 0;\n  height: 22px;\n  color: rgba(0, 0, 0, 0.65);\n  background: #fff;\n}\n.ant-calendar-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-calendar-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-week-number {\n  width: 286px;\n}\n.ant-calendar-week-number-cell {\n  text-align: center;\n}\n.ant-calendar-header {\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  user-select: none;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-header a:hover {\n  color: #49a9ee;\n}\n.ant-calendar-header .ant-calendar-century-select,\n.ant-calendar-header .ant-calendar-decade-select,\n.ant-calendar-header .ant-calendar-year-select,\n.ant-calendar-header .ant-calendar-month-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-header .ant-calendar-century-select-arrow,\n.ant-calendar-header .ant-calendar-decade-select-arrow,\n.ant-calendar-header .ant-calendar-year-select-arrow,\n.ant-calendar-header .ant-calendar-month-select-arrow {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn,\n.ant-calendar-header .ant-calendar-next-century-btn,\n.ant-calendar-header .ant-calendar-prev-decade-btn,\n.ant-calendar-header .ant-calendar-next-decade-btn,\n.ant-calendar-header .ant-calendar-prev-month-btn,\n.ant-calendar-header .ant-calendar-next-month-btn,\n.ant-calendar-header .ant-calendar-prev-year-btn,\n.ant-calendar-header .ant-calendar-next-year-btn {\n  position: absolute;\n  top: 0;\n  color: rgba(0, 0, 0, 0.43);\n  font-family: Arial, \"Hiragino Sans GB\", \"Microsoft Yahei\", \"Microsoft Sans Serif\", sans-serif;\n  padding: 0 5px;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 34px;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn,\n.ant-calendar-header .ant-calendar-prev-decade-btn,\n.ant-calendar-header .ant-calendar-prev-year-btn {\n  left: 7px;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn:after,\n.ant-calendar-header .ant-calendar-prev-decade-btn:after,\n.ant-calendar-header .ant-calendar-prev-year-btn:after {\n  content: '\u00AB';\n}\n.ant-calendar-header .ant-calendar-next-century-btn,\n.ant-calendar-header .ant-calendar-next-decade-btn,\n.ant-calendar-header .ant-calendar-next-year-btn {\n  right: 7px;\n}\n.ant-calendar-header .ant-calendar-next-century-btn:after,\n.ant-calendar-header .ant-calendar-next-decade-btn:after,\n.ant-calendar-header .ant-calendar-next-year-btn:after {\n  content: '\u00BB';\n}\n.ant-calendar-header .ant-calendar-prev-month-btn {\n  left: 29px;\n}\n.ant-calendar-header .ant-calendar-prev-month-btn:after {\n  content: '\u2039';\n}\n.ant-calendar-header .ant-calendar-next-month-btn {\n  right: 29px;\n}\n.ant-calendar-header .ant-calendar-next-month-btn:after {\n  content: '\u203A';\n}\n.ant-calendar-body {\n  padding: 4px 8px;\n}\n.ant-calendar table {\n  border-collapse: collapse;\n  max-width: 100%;\n  background-color: transparent;\n  width: 100%;\n}\n.ant-calendar table,\n.ant-calendar th,\n.ant-calendar td {\n  border: 0;\n}\n.ant-calendar-calendar-table {\n  border-spacing: 0;\n  margin-bottom: 0;\n}\n.ant-calendar-column-header {\n  line-height: 18px;\n  width: 33px;\n  padding: 6px 0;\n  text-align: center;\n}\n.ant-calendar-column-header .ant-calendar-column-header-inner {\n  display: block;\n  font-weight: normal;\n}\n.ant-calendar-week-number-header .ant-calendar-column-header-inner {\n  display: none;\n}\n.ant-calendar-cell {\n  padding: 4px 0;\n}\n.ant-calendar-date {\n  display: block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  border-radius: 2px;\n  width: 20px;\n  height: 20px;\n  line-height: 18px;\n  border: 1px solid transparent;\n  padding: 0;\n  background: transparent;\n  text-align: center;\n  transition: background 0.3s ease;\n}\n.ant-calendar-date-panel {\n  position: relative;\n}\n.ant-calendar-date:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-calendar-date:active {\n  color: #fff;\n  background: #49a9ee;\n}\n.ant-calendar-today .ant-calendar-date {\n  border-color: #108ee9;\n  font-weight: bold;\n  color: #108ee9;\n}\n.ant-calendar-last-month-cell .ant-calendar-date,\n.ant-calendar-next-month-btn-day .ant-calendar-date {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-selected-day .ant-calendar-date {\n  background: #108ee9;\n  color: #fff;\n  border: 1px solid transparent;\n}\n.ant-calendar-selected-day .ant-calendar-date:hover {\n  background: #108ee9;\n}\n.ant-calendar-disabled-cell .ant-calendar-date {\n  cursor: not-allowed;\n  color: #bcbcbc;\n  background: #f7f7f7;\n  border-radius: 0;\n  width: auto;\n  border: 1px solid transparent;\n}\n.ant-calendar-disabled-cell .ant-calendar-date:hover {\n  background: #f7f7f7;\n}\n.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date {\n  position: relative;\n  margin-right: 5px;\n  padding-left: 5px;\n}\n.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date:before {\n  content: \" \";\n  position: absolute;\n  top: -1px;\n  left: 5px;\n  width: 20px;\n  height: 20px;\n  border: 1px solid #bcbcbc;\n  border-radius: 4px;\n}\n.ant-calendar-disabled-cell-first-of-row .ant-calendar-date {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-calendar-disabled-cell-last-of-row .ant-calendar-date {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-calendar-footer {\n  border-top: 1px solid #e9e9e9;\n  line-height: 38px;\n  padding: 0 12px;\n}\n.ant-calendar-footer:empty {\n  border-top: 0;\n}\n.ant-calendar-footer-btn {\n  text-align: center;\n  display: block;\n}\n.ant-calendar-footer-extra + .ant-calendar-footer-btn {\n  border-top: 1px solid #e9e9e9;\n  margin: 0 -12px;\n  padding: 0 12px;\n}\n.ant-calendar .ant-calendar-today-btn,\n.ant-calendar .ant-calendar-clear-btn {\n  display: inline-block;\n  text-align: center;\n  margin: 0 0 0 8px;\n}\n.ant-calendar .ant-calendar-today-btn-disabled,\n.ant-calendar .ant-calendar-clear-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-today-btn:only-child,\n.ant-calendar .ant-calendar-clear-btn:only-child {\n  margin: 0;\n}\n.ant-calendar .ant-calendar-clear-btn {\n  display: none;\n  position: absolute;\n  right: 5px;\n  text-indent: -76px;\n  overflow: hidden;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 20px;\n  top: 7px;\n  margin: 0;\n}\n.ant-calendar .ant-calendar-clear-btn:after {\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e62e\";\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  display: inline-block;\n  line-height: 1;\n  width: 20px;\n  text-indent: 43px;\n  transition: color 0.3s ease;\n}\n.ant-calendar .ant-calendar-clear-btn:hover:after {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-calendar .ant-calendar-ok-btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: 500;\n  text-align: center;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1.15;\n  padding: 0 15px;\n  height: 28px;\n  user-select: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  position: relative;\n  color: #fff;\n  background-color: #108ee9;\n  border-color: #108ee9;\n  padding: 0 7px;\n  font-size: 12px;\n  border-radius: 4px;\n  height: 22px;\n  line-height: 1.5;\n}\n.ant-calendar .ant-calendar-ok-btn > .anticon {\n  line-height: 1;\n}\n.ant-calendar .ant-calendar-ok-btn,\n.ant-calendar .ant-calendar-ok-btn:active,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  outline: 0;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):active {\n  outline: 0;\n  transition: none;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled > *,\n.ant-calendar .ant-calendar-ok-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-calendar .ant-calendar-ok-btn-lg {\n  padding: 0 15px;\n  font-size: 14px;\n  border-radius: 4px;\n  height: 32px;\n}\n.ant-calendar .ant-calendar-ok-btn-sm {\n  padding: 0 7px;\n  font-size: 12px;\n  border-radius: 4px;\n  height: 22px;\n}\n.ant-calendar .ant-calendar-ok-btn > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn:hover,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  color: #fff;\n  background-color: #49a9ee;\n  border-color: #49a9ee;\n}\n.ant-calendar .ant-calendar-ok-btn:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn:hover > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn:active,\n.ant-calendar .ant-calendar-ok-btn.active {\n  color: #fff;\n  background-color: #0e77ca;\n  border-color: #0e77ca;\n}\n.ant-calendar .ant-calendar-ok-btn:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn:active > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled],\n.ant-calendar .ant-calendar-ok-btn.disabled:hover,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus,\n.ant-calendar .ant-calendar-ok-btn.disabled:active,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active,\n.ant-calendar .ant-calendar-ok-btn.disabled.active,\n.ant-calendar .ant-calendar-ok-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar-time-picker {\n  position: absolute;\n  width: 100%;\n  top: 34px;\n  background-color: #fff;\n}\n.ant-calendar-time-picker-panel {\n  z-index: 1050;\n  position: absolute;\n  width: 100%;\n}\n.ant-calendar-time-picker-inner {\n  display: inline-block;\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  background-clip: padding-box;\n  line-height: 1.5;\n  overflow: hidden;\n  width: 100%;\n}\n.ant-calendar-time-picker-combobox {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-1,\n.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {\n  width: 50%;\n}\n.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {\n  width: 33.33%;\n}\n.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {\n  width: 25%;\n}\n.ant-calendar-time-picker-input-wrap {\n  display: none;\n}\n.ant-calendar-time-picker-select {\n  float: left;\n  font-size: 12px;\n  border-right: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  height: 206px;\n}\n.ant-calendar-time-picker-select:hover {\n  overflow-y: auto;\n}\n.ant-calendar-time-picker-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.ant-calendar-time-picker-select:last-child {\n  border-right: 0;\n}\n.ant-calendar-time-picker-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-height: 206px;\n}\n.ant-calendar-time-picker-select li {\n  text-align: center;\n  list-style: none;\n  box-sizing: content-box;\n  margin: 0;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.3s ease;\n}\n.ant-calendar-time-picker-select li:last-child:after {\n  content: '';\n  height: 182px;\n  display: block;\n}\n.ant-calendar-time-picker-select li:hover {\n  background: #ecf6fd;\n}\nli.ant-calendar-time-picker-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.ant-calendar-time-picker-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-calendar-time-picker-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-calendar-time .ant-calendar-day-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-time .ant-calendar-footer {\n  position: relative;\n  height: auto;\n  line-height: auto;\n}\n.ant-calendar-time .ant-calendar-footer-btn {\n  text-align: right;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {\n  float: left;\n  margin: 0;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-time-picker {\n  position: absolute;\n  width: 100%;\n  top: 34px;\n  background-color: #fff;\n}\n.ant-calendar-time-picker-panel {\n  z-index: 1050;\n  position: absolute;\n  width: 100%;\n}\n.ant-calendar-time-picker-inner {\n  display: inline-block;\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  background-clip: padding-box;\n  line-height: 1.5;\n  overflow: hidden;\n  width: 100%;\n}\n.ant-calendar-time-picker-combobox {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-1,\n.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {\n  width: 50%;\n}\n.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {\n  width: 33.33%;\n}\n.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {\n  width: 25%;\n}\n.ant-calendar-time-picker-input-wrap {\n  display: none;\n}\n.ant-calendar-time-picker-select {\n  float: left;\n  font-size: 12px;\n  border-right: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  height: 206px;\n}\n.ant-calendar-time-picker-select:hover {\n  overflow-y: auto;\n}\n.ant-calendar-time-picker-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.ant-calendar-time-picker-select:last-child {\n  border-right: 0;\n}\n.ant-calendar-time-picker-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-height: 206px;\n}\n.ant-calendar-time-picker-select li {\n  text-align: center;\n  list-style: none;\n  box-sizing: content-box;\n  margin: 0;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.3s ease;\n}\n.ant-calendar-time-picker-select li:last-child:after {\n  content: '';\n  height: 182px;\n  display: block;\n}\n.ant-calendar-time-picker-select li:hover {\n  background: #ecf6fd;\n}\nli.ant-calendar-time-picker-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.ant-calendar-time-picker-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-calendar-time-picker-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-calendar-time .ant-calendar-day-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-time .ant-calendar-footer {\n  position: relative;\n  height: auto;\n  line-height: auto;\n}\n.ant-calendar-time .ant-calendar-footer-btn {\n  text-align: right;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {\n  float: left;\n  margin: 0;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-month-panel {\n  position: absolute;\n  top: 1px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  border-radius: 4px;\n  background: #fff;\n  outline: none;\n}\n.ant-calendar-month-panel > div {\n  height: 100%;\n}\n.ant-calendar-month-panel-hidden {\n  display: none;\n}\n.ant-calendar-month-panel-header {\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  user-select: none;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-month-panel-header a:hover {\n  color: #49a9ee;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  color: rgba(0, 0, 0, 0.43);\n  font-family: Arial, \"Hiragino Sans GB\", \"Microsoft Yahei\", \"Microsoft Sans Serif\", sans-serif;\n  padding: 0 5px;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 34px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn {\n  left: 7px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:after {\n  content: '\u00AB';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {\n  right: 7px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:after {\n  content: '\u00BB';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn {\n  left: 29px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:after {\n  content: '\u2039';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn {\n  right: 29px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:after {\n  content: '\u203A';\n}\n.ant-calendar-month-panel-body {\n  height: calc(100% - 34px);\n}\n.ant-calendar-month-panel-table {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  border-collapse: separate;\n}\n.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-month-panel-cell {\n  text-align: center;\n}\n.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month,\n.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month:hover {\n  cursor: not-allowed;\n  color: #bcbcbc;\n  background: #f7f7f7;\n}\n.ant-calendar-month-panel-month {\n  display: inline-block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  background: transparent;\n  text-align: center;\n  height: 24px;\n  line-height: 24px;\n  padding: 0 6px;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-month-panel-month:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-calendar-year-panel {\n  position: absolute;\n  top: 1px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  border-radius: 4px;\n  background: #fff;\n  outline: none;\n}\n.ant-calendar-year-panel > div {\n  height: 100%;\n}\n.ant-calendar-year-panel-hidden {\n  display: none;\n}\n.ant-calendar-year-panel-header {\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  user-select: none;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-year-panel-header a:hover {\n  color: #49a9ee;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  color: rgba(0, 0, 0, 0.43);\n  font-family: Arial, \"Hiragino Sans GB\", \"Microsoft Yahei\", \"Microsoft Sans Serif\", sans-serif;\n  padding: 0 5px;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 34px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn {\n  left: 7px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:after {\n  content: '\u00AB';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {\n  right: 7px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:after {\n  content: '\u00BB';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn {\n  left: 29px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:after {\n  content: '\u2039';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn {\n  right: 29px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:after {\n  content: '\u203A';\n}\n.ant-calendar-year-panel-body {\n  height: calc(100% - 34px);\n}\n.ant-calendar-year-panel-table {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  border-collapse: separate;\n}\n.ant-calendar-year-panel-cell {\n  text-align: center;\n}\n.ant-calendar-year-panel-year {\n  display: inline-block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  background: transparent;\n  text-align: center;\n  height: 24px;\n  line-height: 24px;\n  padding: 0 6px;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-year-panel-year:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-year-panel-last-decade-cell .ant-calendar-year-panel-year,\n.ant-calendar-year-panel-next-decade-cell .ant-calendar-year-panel-year {\n  user-select: none;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-decade-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  background: #fff;\n  border-radius: 4px;\n  outline: none;\n}\n.ant-calendar-decade-panel-hidden {\n  display: none;\n}\n.ant-calendar-decade-panel-header {\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  user-select: none;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-decade-panel-header a:hover {\n  color: #49a9ee;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  color: rgba(0, 0, 0, 0.43);\n  font-family: Arial, \"Hiragino Sans GB\", \"Microsoft Yahei\", \"Microsoft Sans Serif\", sans-serif;\n  padding: 0 5px;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 34px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn {\n  left: 7px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:after {\n  content: '\u00AB';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  right: 7px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:after {\n  content: '\u00BB';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn {\n  left: 29px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:after {\n  content: '\u2039';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn {\n  right: 29px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:after {\n  content: '\u203A';\n}\n.ant-calendar-decade-panel-body {\n  height: calc(100% - 34px);\n}\n.ant-calendar-decade-panel-table {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  border-collapse: separate;\n}\n.ant-calendar-decade-panel-cell {\n  text-align: center;\n  white-space: nowrap;\n}\n.ant-calendar-decade-panel-decade {\n  display: inline-block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  background: transparent;\n  text-align: center;\n  height: 24px;\n  line-height: 24px;\n  padding: 0 6px;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-decade-panel-decade:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-decade-panel-last-century-cell .ant-calendar-decade-panel-decade,\n.ant-calendar-decade-panel-next-century-cell .ant-calendar-decade-panel-decade {\n  user-select: none;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-month .ant-calendar-month-panel,\n.ant-calendar-month .ant-calendar-year-panel {\n  top: 0;\n  height: 248px;\n}\n",
                    "nz-datepicker {\n  display: inline-block;\n  position: relative;\n}\n/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-calendar-picker-container {\n  position: absolute;\n  z-index: 1050;\n}\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topRight,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomRight,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topLeft,\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomLeft,\n.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-calendar-picker {\n  position: relative;\n  display: inline-block;\n  outline: none;\n  font-size: 12px;\n  transition: opacity 0.3s;\n}\n.ant-calendar-picker-input {\n  outline: none;\n  display: block;\n}\n.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {\n  border-color: #108ee9;\n}\n.ant-calendar-picker-clear,\n.ant-calendar-picker-icon {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  right: 8px;\n  top: 50%;\n  margin-top: -7px;\n  line-height: 14px;\n  font-size: 12px;\n  transition: all .3s;\n  user-select: none;\n}\n.ant-calendar-picker-clear {\n  opacity: 0;\n  z-index: 1;\n  color: rgba(0, 0, 0, 0.25);\n  background: #fff;\n  pointer-events: none;\n  cursor: pointer;\n}\n.ant-calendar-picker-clear:hover {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-calendar-picker:hover .ant-calendar-picker-clear {\n  opacity: 1;\n  pointer-events: auto;\n}\n.ant-calendar-picker-icon {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-calendar-picker-icon:after {\n  content: \"\\e6bb\";\n  font-family: \"anticon\";\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n  display: inline-block;\n  line-height: 1;\n}\n.ant-calendar {\n  position: relative;\n  outline: none;\n  width: 231px;\n  border: 1px solid #fff;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n  line-height: 1.5;\n}\n.ant-calendar-input-wrap {\n  height: 34px;\n  padding: 6px;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-input {\n  border: 0;\n  width: 100%;\n  cursor: auto;\n  outline: 0;\n  height: 22px;\n  color: rgba(0, 0, 0, 0.65);\n  background: #fff;\n}\n.ant-calendar-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-calendar-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-week-number {\n  width: 286px;\n}\n.ant-calendar-week-number-cell {\n  text-align: center;\n}\n.ant-calendar-header {\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  user-select: none;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-header a:hover {\n  color: #49a9ee;\n}\n.ant-calendar-header .ant-calendar-century-select,\n.ant-calendar-header .ant-calendar-decade-select,\n.ant-calendar-header .ant-calendar-year-select,\n.ant-calendar-header .ant-calendar-month-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-header .ant-calendar-century-select-arrow,\n.ant-calendar-header .ant-calendar-decade-select-arrow,\n.ant-calendar-header .ant-calendar-year-select-arrow,\n.ant-calendar-header .ant-calendar-month-select-arrow {\n  display: none;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn,\n.ant-calendar-header .ant-calendar-next-century-btn,\n.ant-calendar-header .ant-calendar-prev-decade-btn,\n.ant-calendar-header .ant-calendar-next-decade-btn,\n.ant-calendar-header .ant-calendar-prev-month-btn,\n.ant-calendar-header .ant-calendar-next-month-btn,\n.ant-calendar-header .ant-calendar-prev-year-btn,\n.ant-calendar-header .ant-calendar-next-year-btn {\n  position: absolute;\n  top: 0;\n  color: rgba(0, 0, 0, 0.43);\n  font-family: Arial, \"Hiragino Sans GB\", \"Microsoft Yahei\", \"Microsoft Sans Serif\", sans-serif;\n  padding: 0 5px;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 34px;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn,\n.ant-calendar-header .ant-calendar-prev-decade-btn,\n.ant-calendar-header .ant-calendar-prev-year-btn {\n  left: 7px;\n}\n.ant-calendar-header .ant-calendar-prev-century-btn:after,\n.ant-calendar-header .ant-calendar-prev-decade-btn:after,\n.ant-calendar-header .ant-calendar-prev-year-btn:after {\n  content: '\u00AB';\n}\n.ant-calendar-header .ant-calendar-next-century-btn,\n.ant-calendar-header .ant-calendar-next-decade-btn,\n.ant-calendar-header .ant-calendar-next-year-btn {\n  right: 7px;\n}\n.ant-calendar-header .ant-calendar-next-century-btn:after,\n.ant-calendar-header .ant-calendar-next-decade-btn:after,\n.ant-calendar-header .ant-calendar-next-year-btn:after {\n  content: '\u00BB';\n}\n.ant-calendar-header .ant-calendar-prev-month-btn {\n  left: 29px;\n}\n.ant-calendar-header .ant-calendar-prev-month-btn:after {\n  content: '\u2039';\n}\n.ant-calendar-header .ant-calendar-next-month-btn {\n  right: 29px;\n}\n.ant-calendar-header .ant-calendar-next-month-btn:after {\n  content: '\u203A';\n}\n.ant-calendar-body {\n  padding: 4px 8px;\n}\n.ant-calendar table {\n  border-collapse: collapse;\n  max-width: 100%;\n  background-color: transparent;\n  width: 100%;\n}\n.ant-calendar table,\n.ant-calendar th,\n.ant-calendar td {\n  border: 0;\n}\n.ant-calendar-calendar-table {\n  border-spacing: 0;\n  margin-bottom: 0;\n}\n.ant-calendar-column-header {\n  line-height: 18px;\n  width: 33px;\n  padding: 6px 0;\n  text-align: center;\n}\n.ant-calendar-column-header .ant-calendar-column-header-inner {\n  display: block;\n  font-weight: normal;\n}\n.ant-calendar-week-number-header .ant-calendar-column-header-inner {\n  display: none;\n}\n.ant-calendar-cell {\n  padding: 4px 0;\n}\n.ant-calendar-date {\n  display: block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  border-radius: 2px;\n  width: 20px;\n  height: 20px;\n  line-height: 18px;\n  border: 1px solid transparent;\n  padding: 0;\n  background: transparent;\n  text-align: center;\n  transition: background 0.3s ease;\n}\n.ant-calendar-date-panel {\n  position: relative;\n}\n.ant-calendar-date:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-calendar-date:active {\n  color: #fff;\n  background: #49a9ee;\n}\n.ant-calendar-today .ant-calendar-date {\n  border-color: #108ee9;\n  font-weight: bold;\n  color: #108ee9;\n}\n.ant-calendar-last-month-cell .ant-calendar-date,\n.ant-calendar-next-month-btn-day .ant-calendar-date {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-selected-day .ant-calendar-date {\n  background: #108ee9;\n  color: #fff;\n  border: 1px solid transparent;\n}\n.ant-calendar-selected-day .ant-calendar-date:hover {\n  background: #108ee9;\n}\n.ant-calendar-disabled-cell .ant-calendar-date {\n  cursor: not-allowed;\n  color: #bcbcbc;\n  background: #f7f7f7;\n  border-radius: 0;\n  width: auto;\n  border: 1px solid transparent;\n}\n.ant-calendar-disabled-cell .ant-calendar-date:hover {\n  background: #f7f7f7;\n}\n.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date {\n  position: relative;\n  margin-right: 5px;\n  padding-left: 5px;\n}\n.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date:before {\n  content: \" \";\n  position: absolute;\n  top: -1px;\n  left: 5px;\n  width: 20px;\n  height: 20px;\n  border: 1px solid #bcbcbc;\n  border-radius: 4px;\n}\n.ant-calendar-disabled-cell-first-of-row .ant-calendar-date {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.ant-calendar-disabled-cell-last-of-row .ant-calendar-date {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.ant-calendar-footer {\n  border-top: 1px solid #e9e9e9;\n  line-height: 38px;\n  padding: 0 12px;\n}\n.ant-calendar-footer:empty {\n  border-top: 0;\n}\n.ant-calendar-footer-btn {\n  text-align: center;\n  display: block;\n}\n.ant-calendar-footer-extra + .ant-calendar-footer-btn {\n  border-top: 1px solid #e9e9e9;\n  margin: 0 -12px;\n  padding: 0 12px;\n}\n.ant-calendar .ant-calendar-today-btn,\n.ant-calendar .ant-calendar-clear-btn {\n  display: inline-block;\n  text-align: center;\n  margin: 0 0 0 8px;\n}\n.ant-calendar .ant-calendar-today-btn-disabled,\n.ant-calendar .ant-calendar-clear-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-today-btn:only-child,\n.ant-calendar .ant-calendar-clear-btn:only-child {\n  margin: 0;\n}\n.ant-calendar .ant-calendar-clear-btn {\n  display: none;\n  position: absolute;\n  right: 5px;\n  text-indent: -76px;\n  overflow: hidden;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 20px;\n  top: 7px;\n  margin: 0;\n}\n.ant-calendar .ant-calendar-clear-btn:after {\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e62e\";\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  display: inline-block;\n  line-height: 1;\n  width: 20px;\n  text-indent: 43px;\n  transition: color 0.3s ease;\n}\n.ant-calendar .ant-calendar-clear-btn:hover:after {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-calendar .ant-calendar-ok-btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: 500;\n  text-align: center;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1.15;\n  padding: 0 15px;\n  height: 28px;\n  user-select: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  position: relative;\n  color: #fff;\n  background-color: #108ee9;\n  border-color: #108ee9;\n  padding: 0 7px;\n  font-size: 12px;\n  border-radius: 4px;\n  height: 22px;\n  line-height: 1.5;\n}\n.ant-calendar .ant-calendar-ok-btn > .anticon {\n  line-height: 1;\n}\n.ant-calendar .ant-calendar-ok-btn,\n.ant-calendar .ant-calendar-ok-btn:active,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  outline: 0;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):hover {\n  text-decoration: none;\n}\n.ant-calendar .ant-calendar-ok-btn:not([disabled]):active {\n  outline: 0;\n  transition: none;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled > *,\n.ant-calendar .ant-calendar-ok-btn[disabled] > * {\n  pointer-events: none;\n}\n.ant-calendar .ant-calendar-ok-btn-lg {\n  padding: 0 15px;\n  font-size: 14px;\n  border-radius: 4px;\n  height: 32px;\n}\n.ant-calendar .ant-calendar-ok-btn-sm {\n  padding: 0 7px;\n  font-size: 12px;\n  border-radius: 4px;\n  height: 22px;\n}\n.ant-calendar .ant-calendar-ok-btn > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn:hover,\n.ant-calendar .ant-calendar-ok-btn:focus {\n  color: #fff;\n  background-color: #49a9ee;\n  border-color: #49a9ee;\n}\n.ant-calendar .ant-calendar-ok-btn:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn:focus > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn:hover > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn:focus > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn:active,\n.ant-calendar .ant-calendar-ok-btn.active {\n  color: #fff;\n  background-color: #0e77ca;\n  border-color: #0e77ca;\n}\n.ant-calendar .ant-calendar-ok-btn:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn:active > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled,\n.ant-calendar .ant-calendar-ok-btn[disabled],\n.ant-calendar .ant-calendar-ok-btn.disabled:hover,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus,\n.ant-calendar .ant-calendar-ok-btn.disabled:active,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active,\n.ant-calendar .ant-calendar-ok-btn.disabled.active,\n.ant-calendar .ant-calendar-ok-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child:after,\n.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n  border-color: #d9d9d9;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child {\n  color: currentColor;\n}\n.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: transparent;\n}\n.ant-calendar-time-picker {\n  position: absolute;\n  width: 100%;\n  top: 34px;\n  background-color: #fff;\n}\n.ant-calendar-time-picker-panel {\n  z-index: 1050;\n  position: absolute;\n  width: 100%;\n}\n.ant-calendar-time-picker-inner {\n  display: inline-block;\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  background-clip: padding-box;\n  line-height: 1.5;\n  overflow: hidden;\n  width: 100%;\n}\n.ant-calendar-time-picker-combobox {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-1,\n.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {\n  width: 50%;\n}\n.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {\n  width: 33.33%;\n}\n.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {\n  width: 25%;\n}\n.ant-calendar-time-picker-input-wrap {\n  display: none;\n}\n.ant-calendar-time-picker-select {\n  float: left;\n  font-size: 12px;\n  border-right: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  height: 206px;\n}\n.ant-calendar-time-picker-select:hover {\n  overflow-y: auto;\n}\n.ant-calendar-time-picker-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.ant-calendar-time-picker-select:last-child {\n  border-right: 0;\n}\n.ant-calendar-time-picker-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-height: 206px;\n}\n.ant-calendar-time-picker-select li {\n  text-align: center;\n  list-style: none;\n  box-sizing: content-box;\n  margin: 0;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.3s ease;\n}\n.ant-calendar-time-picker-select li:last-child:after {\n  content: '';\n  height: 182px;\n  display: block;\n}\n.ant-calendar-time-picker-select li:hover {\n  background: #ecf6fd;\n}\nli.ant-calendar-time-picker-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.ant-calendar-time-picker-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-calendar-time-picker-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-calendar-time .ant-calendar-day-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-time .ant-calendar-footer {\n  position: relative;\n  height: auto;\n  line-height: auto;\n}\n.ant-calendar-time .ant-calendar-footer-btn {\n  text-align: right;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {\n  float: left;\n  margin: 0;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-time-picker {\n  position: absolute;\n  width: 100%;\n  top: 34px;\n  background-color: #fff;\n}\n.ant-calendar-time-picker-panel {\n  z-index: 1050;\n  position: absolute;\n  width: 100%;\n}\n.ant-calendar-time-picker-inner {\n  display: inline-block;\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  background-clip: padding-box;\n  line-height: 1.5;\n  overflow: hidden;\n  width: 100%;\n}\n.ant-calendar-time-picker-combobox {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-1,\n.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {\n  width: 100%;\n}\n.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {\n  width: 50%;\n}\n.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {\n  width: 33.33%;\n}\n.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {\n  width: 25%;\n}\n.ant-calendar-time-picker-input-wrap {\n  display: none;\n}\n.ant-calendar-time-picker-select {\n  float: left;\n  font-size: 12px;\n  border-right: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  height: 206px;\n}\n.ant-calendar-time-picker-select:hover {\n  overflow-y: auto;\n}\n.ant-calendar-time-picker-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.ant-calendar-time-picker-select:last-child {\n  border-right: 0;\n}\n.ant-calendar-time-picker-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  max-height: 206px;\n}\n.ant-calendar-time-picker-select li {\n  text-align: center;\n  list-style: none;\n  box-sizing: content-box;\n  margin: 0;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.3s ease;\n}\n.ant-calendar-time-picker-select li:last-child:after {\n  content: '';\n  height: 182px;\n  display: block;\n}\n.ant-calendar-time-picker-select li:hover {\n  background: #ecf6fd;\n}\nli.ant-calendar-time-picker-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.ant-calendar-time-picker-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-calendar-time-picker-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-calendar-time .ant-calendar-day-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-time .ant-calendar-footer {\n  position: relative;\n  height: auto;\n  line-height: auto;\n}\n.ant-calendar-time .ant-calendar-footer-btn {\n  text-align: right;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {\n  float: left;\n  margin: 0;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-month-panel {\n  position: absolute;\n  top: 1px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  border-radius: 4px;\n  background: #fff;\n  outline: none;\n}\n.ant-calendar-month-panel > div {\n  height: 100%;\n}\n.ant-calendar-month-panel-hidden {\n  display: none;\n}\n.ant-calendar-month-panel-header {\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  user-select: none;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-month-panel-header a:hover {\n  color: #49a9ee;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select-arrow,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  color: rgba(0, 0, 0, 0.43);\n  font-family: Arial, \"Hiragino Sans GB\", \"Microsoft Yahei\", \"Microsoft Sans Serif\", sans-serif;\n  padding: 0 5px;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 34px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn {\n  left: 7px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:after {\n  content: '\u00AB';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {\n  right: 7px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:after,\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:after {\n  content: '\u00BB';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn {\n  left: 29px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:after {\n  content: '\u2039';\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn {\n  right: 29px;\n}\n.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:after {\n  content: '\u203A';\n}\n.ant-calendar-month-panel-body {\n  height: calc(100% - 34px);\n}\n.ant-calendar-month-panel-table {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  border-collapse: separate;\n}\n.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-month-panel-cell {\n  text-align: center;\n}\n.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month,\n.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month:hover {\n  cursor: not-allowed;\n  color: #bcbcbc;\n  background: #f7f7f7;\n}\n.ant-calendar-month-panel-month {\n  display: inline-block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  background: transparent;\n  text-align: center;\n  height: 24px;\n  line-height: 24px;\n  padding: 0 6px;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-month-panel-month:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-calendar-year-panel {\n  position: absolute;\n  top: 1px;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  border-radius: 4px;\n  background: #fff;\n  outline: none;\n}\n.ant-calendar-year-panel > div {\n  height: 100%;\n}\n.ant-calendar-year-panel-hidden {\n  display: none;\n}\n.ant-calendar-year-panel-header {\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  user-select: none;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-year-panel-header a:hover {\n  color: #49a9ee;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select-arrow,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  color: rgba(0, 0, 0, 0.43);\n  font-family: Arial, \"Hiragino Sans GB\", \"Microsoft Yahei\", \"Microsoft Sans Serif\", sans-serif;\n  padding: 0 5px;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 34px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn {\n  left: 7px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:after {\n  content: '\u00AB';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {\n  right: 7px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:after,\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:after {\n  content: '\u00BB';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn {\n  left: 29px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:after {\n  content: '\u2039';\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn {\n  right: 29px;\n}\n.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:after {\n  content: '\u203A';\n}\n.ant-calendar-year-panel-body {\n  height: calc(100% - 34px);\n}\n.ant-calendar-year-panel-table {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  border-collapse: separate;\n}\n.ant-calendar-year-panel-cell {\n  text-align: center;\n}\n.ant-calendar-year-panel-year {\n  display: inline-block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  background: transparent;\n  text-align: center;\n  height: 24px;\n  line-height: 24px;\n  padding: 0 6px;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-year-panel-year:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-year-panel-last-decade-cell .ant-calendar-year-panel-year,\n.ant-calendar-year-panel-next-decade-cell .ant-calendar-year-panel-year {\n  user-select: none;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-decade-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  background: #fff;\n  border-radius: 4px;\n  outline: none;\n}\n.ant-calendar-decade-panel-hidden {\n  display: none;\n}\n.ant-calendar-decade-panel-header {\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  user-select: none;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-calendar-decade-panel-header a:hover {\n  color: #49a9ee;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select {\n  padding: 0 2px;\n  font-weight: bold;\n  display: inline-block;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 34px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select-arrow,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select-arrow {\n  display: none;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  position: absolute;\n  top: 0;\n  color: rgba(0, 0, 0, 0.43);\n  font-family: Arial, \"Hiragino Sans GB\", \"Microsoft Yahei\", \"Microsoft Sans Serif\", sans-serif;\n  padding: 0 5px;\n  font-size: 16px;\n  display: inline-block;\n  line-height: 34px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn {\n  left: 7px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:after {\n  content: '\u00AB';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {\n  right: 7px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:after,\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:after {\n  content: '\u00BB';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn {\n  left: 29px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:after {\n  content: '\u2039';\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn {\n  right: 29px;\n}\n.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:after {\n  content: '\u203A';\n}\n.ant-calendar-decade-panel-body {\n  height: calc(100% - 34px);\n}\n.ant-calendar-decade-panel-table {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  border-collapse: separate;\n}\n.ant-calendar-decade-panel-cell {\n  text-align: center;\n  white-space: nowrap;\n}\n.ant-calendar-decade-panel-decade {\n  display: inline-block;\n  margin: 0 auto;\n  color: rgba(0, 0, 0, 0.65);\n  background: transparent;\n  text-align: center;\n  height: 24px;\n  line-height: 24px;\n  padding: 0 6px;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n.ant-calendar-decade-panel-decade:hover {\n  background: #ecf6fd;\n  cursor: pointer;\n}\n.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {\n  background: #108ee9;\n  color: #fff;\n}\n.ant-calendar-decade-panel-last-century-cell .ant-calendar-decade-panel-decade,\n.ant-calendar-decade-panel-next-century-cell .ant-calendar-decade-panel-decade {\n  user-select: none;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-calendar-month .ant-calendar-month-panel,\n.ant-calendar-month .ant-calendar-year-panel {\n  top: 0;\n  height: 248px;\n}\n.ant-calendar-picker-container {\n  position: relative;\n  left: -2px;\n}\n.ant-calendar-picker-container.top {\n  bottom: -2px;\n}\n.ant-calendar-picker-container.bottom {\n  top: -2px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzDatePickerComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: ChangeDetectorRef, },
]; };
NzDatePickerComponent.propDecorators = {
    'nzDisabledDate': [{ type: Input },],
    'nzAllowClear': [{ type: Input },],
    'nzShowTime': [{ type: Input },],
    'nzPlaceHolder': [{ type: Input },],
    'nzFormat': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzMode': [{ type: Input },],
    'trigger': [{ type: ViewChild, args: ['trigger',] },],
    'timePickerInner': [{ type: ViewChild, args: [NzTimePickerInnerComponent,] },],
    '_nzCalendarPicker': [{ type: HostBinding, args: ['class.ant-calendar-picker',] },],
    'nzDisabled': [{ type: Input },],
};
var NzTimePickerComponent = (function (_super) {
    tslib_1.__extends(NzTimePickerComponent, _super);
    function NzTimePickerComponent() {
        var _this = _super.apply(this, arguments) || this;
        _this._disabled = false;
        _this._dropDownPosition = 'bottom';
        _this._triggerWidth = 0;
        _this._positions = DEFAULT_DATEPICKER_POSITIONS.slice();
        return _this;
    }
    Object.defineProperty(NzTimePickerComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
            this._closeCalendar();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    NzTimePickerComponent.prototype._setTriggerWidth = function () {
        this._triggerWidth = this.trigger.nativeElement.getBoundingClientRect().width;
    };
    /**
     * @param {?} position
     * @return {?}
     */
    NzTimePickerComponent.prototype.onPositionChange = function (position) {
        var /** @type {?} */ _position = position.connectionPair.originY === 'bottom' ? 'top' : 'bottom';
        if (this._dropDownPosition !== _position) {
            this._dropDownPosition = _position;
            this._cdr.detectChanges();
        }
    };
    /**
     * @param {?} box
     * @return {?}
     */
    NzTimePickerComponent.prototype._manualChangeInput = function (box) {
        var /** @type {?} */ _tempMoment = moment(box.value, this._format);
        if (Date.parse(_tempMoment.toDate().toString())) {
            this.nzValue = new Date((moment(this._value).hour(_tempMoment.hour()).minute(_tempMoment.minute()).second(_tempMoment.second())).toDate().getTime());
            this.onChange(this._value);
        }
        // this._closeCalendar();
    };
    /**
     * @return {?}
     */
    NzTimePickerComponent.prototype._overHour = function () {
        var /** @type {?} */ _start = this._format.indexOf('HH');
        var /** @type {?} */ _end = _start + 2;
        this._inputTimeInstance.nativeElement.setSelectionRange(_start, _end);
    };
    /**
     * @return {?}
     */
    NzTimePickerComponent.prototype._overMinute = function () {
        var /** @type {?} */ _start = this._format.indexOf('mm');
        var /** @type {?} */ _end = _start + 2;
        this._inputTimeInstance.nativeElement.setSelectionRange(_start, _end);
    };
    /**
     * @return {?}
     */
    NzTimePickerComponent.prototype._overSecond = function () {
        var /** @type {?} */ _start = this._format.indexOf('ss');
        var /** @type {?} */ _end = _start + 2;
        this._inputTimeInstance.nativeElement.setSelectionRange(_start, _end);
    };
    /**
     * @return {?}
     */
    NzTimePickerComponent.prototype._clearValue = function () {
        this.nzValue = null;
        this._selectedHour = null;
        this._selectedMinute = null;
        this.onChange(this._value);
        this._selectedSecond = null;
    };
    /**
     * @return {?}
     */
    NzTimePickerComponent.prototype._openCalendar = function () {
        var _this = this;
        this._open = true;
        this._setTriggerWidth();
        setTimeout(function (_) {
            _this._initPosition();
            _this._inputTimeInstance.nativeElement.setSelectionRange(0, 8);
        });
    };
    /**
     * @return {?}
     */
    NzTimePickerComponent.prototype._closeCalendar = function () {
        if (!this._open) {
            return;
        }
        this._open = false;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzTimePickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    return NzTimePickerComponent;
}(NzTimePickerInnerComponent));
NzTimePickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-timepicker',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    DropDownAnimation
                ],
                template: "\n    <span\n      class=\"ant-time-picker\"\n      [class.ant-time-picker-large]=\"nzSize=='large'\"\n      [class.ant-time-picker-small]=\"nzSize=='small'\"\n      nz-overlay-origin #origin=\"nzOverlayOrigin\"\n      #trigger>\n      <input\n        [disabled]=\"nzDisabled\"\n        class=\"ant-time-picker-input\"\n        [attr.placeholder]=\"nzPlaceHolder\"\n        (click)=\"_openCalendar()\"\n        (blur)=\"onTouched()\"\n        [value]=\"_value|nzDate:_format\">\n      <span class=\"ant-time-picker-icon\"></span>\n    </span>\n    <ng-template\n      nz-connected-overlay\n      hasBackdrop\n      [positions]=\"_positions\"\n      [origin]=\"origin\"\n      (backdropClick)=\"_closeCalendar()\"\n      (detach)=\"_closeCalendar()\"\n      (positionChange)=\"onPositionChange($event)\"\n      [open]=\"_open\">\n      <div class=\"ant-time-picker-panel\"\n        [class.top]=\"_dropDownPosition==='top'\"\n        [class.bottom]=\"_dropDownPosition==='bottom'\"\n        [style.width]=\"_width\"\n        [@dropDownAnimation]=\"_dropDownPosition\">\n        <div class=\"ant-time-picker-panel-inner\">\n          <div class=\"ant-time-picker-panel-input-wrap\">\n            <input class=\"ant-time-picker-panel-input\"\n              [attr.placeholder]=\"nzPlaceHolder\"\n              #inputTimeInstance\n              [value]=\"_value|nzDate:_format\"\n              (blur)=\"_manualChangeInput(inputTimeInstance)\"\n              (keydown.Enter)=\"_manualChangeInput(inputTimeInstance)\">\n            <a class=\"ant-time-picker-panel-clear-btn\" title=\"\u6E05\u9664\" (click)=\"_clearValue()\"></a>\n          </div>\n          <div class=\"ant-time-picker-panel-combobox\">\n            <div class=\"ant-time-picker-panel-select\"\n              #hourListInstance *ngIf=\"_showHour\"\n              (mouseover)=\"_overHour()\">\n              <ul>\n                <ng-template\n                  ngFor\n                  let-_hour\n                  [ngForOf]=\"_hourList\"\n                  let-i=\"index\">\n                  <li\n                    [class.ant-time-picker-panel-select-option-selected]=\"_hour.index===_selectedHour\"\n                    [class.ant-time-picker-panel-select-option-disabled]=\"_hour.disabled\"\n                    [ngClass]=\"_hour.name\"\n                    *ngIf=\"!(nzHideDisabledOptions&&_hour.disabled)\"\n                    (click)=\"_selectHour(hourListInstance,_hour.index,_hour.disabled)\">\n                    {{_hour.name}}\n                  </li>\n                </ng-template>\n              </ul>\n            </div>\n            <div\n              class=\"ant-time-picker-panel-select\"\n              #minuteListInstance\n              *ngIf=\"_showMinute\"\n              (mouseover)=\"_overMinute()\">\n              <ul>\n                <ng-template\n                  ngFor\n                  let-_minute\n                  [ngForOf]=\"_minuteList\"\n                  let-i=\"index\">\n                  <li\n                    [ngClass]=\"_minute.name\"\n                    *ngIf=\"!(nzHideDisabledOptions&&_minute.disabled)\"\n                    [class.ant-time-picker-panel-select-option-selected]=\"_minute.index===_selectedMinute\"\n                    [class.ant-time-picker-panel-select-option-disabled]=\"_minute.disabled\"\n                    (click)=\"_selectMinute(minuteListInstance,_minute.index,_minute.disabled)\">\n                    {{_minute.name}}\n                  </li>\n                </ng-template>\n              </ul>\n            </div>\n            <div\n              class=\"ant-time-picker-panel-select\"\n              #secondListInstance *ngIf=\"_showSecond\"\n              (mouseover)=\"_overSecond()\">\n              <ul>\n                <ng-template\n                  ngFor\n                  let-_second\n                  [ngForOf]=\"_secondList\"\n                  let-i=\"index\">\n                  <li\n                    [ngClass]=\"_second.name\"\n                    [class.ant-time-picker-panel-select-option-selected]=\"_second.index===_selectedSecond\"\n                    [class.ant-time-picker-panel-select-option-disabled]=\"_second.disabled\"\n                    *ngIf=\"!(nzHideDisabledOptions&&_second.disabled)\"\n                    (click)=\"_selectSecond(secondListInstance,_second.index,_second.disabled)\">\n                    {{_second.name}}\n                  </li>\n                </ng-template>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzTimePickerComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-time-picker-panel {\n  z-index: 1050;\n  position: absolute;\n}\n.ant-time-picker-panel-inner {\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n  line-height: 1.5;\n  overflow: hidden;\n  left: -2px;\n}\n.ant-time-picker-panel-input {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  width: 100%;\n  cursor: auto;\n  line-height: 1.5;\n  outline: 0;\n}\n.ant-time-picker-panel-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-time-picker-panel-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-panel-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-panel-input-wrap {\n  box-sizing: border-box;\n  position: relative;\n  padding: 6px;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-time-picker-panel-input-invalid {\n  border-color: red;\n}\n.ant-time-picker-panel-clear-btn {\n  position: absolute;\n  right: 5px;\n  cursor: pointer;\n  overflow: hidden;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 20px;\n  top: 5px;\n  margin: 0;\n}\n.ant-time-picker-panel-clear-btn:after {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  display: inline-block;\n  line-height: 1;\n  width: 20px;\n  transition: color 0.3s ease;\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e62e\";\n}\n.ant-time-picker-panel-clear-btn:hover:after {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-time-picker-panel-narrow .ant-time-picker-panel-input-wrap {\n  max-width: 112px;\n}\n.ant-time-picker-panel-select {\n  float: left;\n  font-size: 12px;\n  border-left: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  width: 56px;\n  overflow: hidden;\n  position: relative;\n  max-height: 144px;\n}\n.ant-time-picker-panel-select:hover {\n  overflow-y: auto;\n}\n.ant-time-picker-panel-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.ant-time-picker-panel-select:last-child {\n  border-right: 0;\n}\n.ant-time-picker-panel-select:only-child {\n  width: 100%;\n}\n.ant-time-picker-panel-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0 0 120px;\n  width: 100%;\n}\n.ant-time-picker-panel-select li {\n  list-style: none;\n  box-sizing: content-box;\n  margin: 0;\n  padding: 0 0 0 8px;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  text-align: left;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.3s;\n}\n.ant-time-picker-panel-select li:hover {\n  background: #ecf6fd;\n}\nli.ant-time-picker-panel-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.ant-time-picker-panel-select-option-selected:hover {\n  background: #f7f7f7;\n}\nli.ant-time-picker-panel-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-time-picker-panel-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-time-picker-panel-combobox {\n  zoom: 1;\n}\n.ant-time-picker-panel-combobox:before,\n.ant-time-picker-panel-combobox:after {\n  content: \" \";\n  display: table;\n}\n.ant-time-picker-panel-combobox:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-time-picker-panel-addon {\n  padding: 8px;\n  border-top: 1px solid #e9e9e9;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-time-picker {\n  position: relative;\n  display: inline-block;\n  outline: none;\n  font-size: 12px;\n  transition: opacity 0.3s ease;\n  width: 100px;\n}\n.ant-time-picker-input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n}\n.ant-time-picker-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-time-picker-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input:hover {\n  border-color: #49a9ee;\n}\n.ant-time-picker-input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-time-picker-input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-time-picker-input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-time-picker-input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-time-picker-input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-time-picker-input[disabled] {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input[disabled]:hover {\n  border-color: #e2e2e2;\n}\n.ant-time-picker-large .ant-time-picker-input {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-time-picker-small .ant-time-picker-input {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-time-picker-open {\n  opacity: 0;\n}\n.ant-time-picker-icon {\n  position: absolute;\n  user-select: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  width: 12px;\n  height: 12px;\n  line-height: 12px;\n  right: 8px;\n  color: rgba(0, 0, 0, 0.43);\n  top: 50%;\n  margin-top: -6px;\n}\n.ant-time-picker-icon:after {\n  content: \"\\e641\";\n  font-family: \"anticon\";\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n  display: block;\n  line-height: 1;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-time-picker-panel {\n  z-index: 1050;\n  position: absolute;\n}\n.ant-time-picker-panel-inner {\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n  line-height: 1.5;\n  overflow: hidden;\n  left: -2px;\n}\n.ant-time-picker-panel-input {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  width: 100%;\n  cursor: auto;\n  line-height: 1.5;\n  outline: 0;\n}\n.ant-time-picker-panel-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-time-picker-panel-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-panel-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-panel-input-wrap {\n  box-sizing: border-box;\n  position: relative;\n  padding: 6px;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-time-picker-panel-input-invalid {\n  border-color: red;\n}\n.ant-time-picker-panel-clear-btn {\n  position: absolute;\n  right: 5px;\n  cursor: pointer;\n  overflow: hidden;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 20px;\n  top: 5px;\n  margin: 0;\n}\n.ant-time-picker-panel-clear-btn:after {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.25);\n  display: inline-block;\n  line-height: 1;\n  width: 20px;\n  transition: color 0.3s ease;\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\e62e\";\n}\n.ant-time-picker-panel-clear-btn:hover:after {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-time-picker-panel-narrow .ant-time-picker-panel-input-wrap {\n  max-width: 112px;\n}\n.ant-time-picker-panel-select {\n  float: left;\n  font-size: 12px;\n  border-left: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  width: 56px;\n  overflow: hidden;\n  position: relative;\n  max-height: 144px;\n}\n.ant-time-picker-panel-select:hover {\n  overflow-y: auto;\n}\n.ant-time-picker-panel-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.ant-time-picker-panel-select:last-child {\n  border-right: 0;\n}\n.ant-time-picker-panel-select:only-child {\n  width: 100%;\n}\n.ant-time-picker-panel-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0 0 120px;\n  width: 100%;\n}\n.ant-time-picker-panel-select li {\n  list-style: none;\n  box-sizing: content-box;\n  margin: 0;\n  padding: 0 0 0 8px;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  text-align: left;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.3s;\n}\n.ant-time-picker-panel-select li:hover {\n  background: #ecf6fd;\n}\nli.ant-time-picker-panel-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.ant-time-picker-panel-select-option-selected:hover {\n  background: #f7f7f7;\n}\nli.ant-time-picker-panel-select-option-disabled {\n  color: rgba(0, 0, 0, 0.25);\n}\nli.ant-time-picker-panel-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n.ant-time-picker-panel-combobox {\n  zoom: 1;\n}\n.ant-time-picker-panel-combobox:before,\n.ant-time-picker-panel-combobox:after {\n  content: \" \";\n  display: table;\n}\n.ant-time-picker-panel-combobox:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-time-picker-panel-addon {\n  padding: 8px;\n  border-top: 1px solid #e9e9e9;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-topRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-enter.slide-up-enter-active.ant-time-picker-panel-placement-bottomRight,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-appear.slide-up-appear-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomLeft,\n.ant-time-picker-panel.slide-up-leave.slide-up-leave-active.ant-time-picker-panel-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-time-picker {\n  position: relative;\n  display: inline-block;\n  outline: none;\n  font-size: 12px;\n  transition: opacity 0.3s ease;\n  width: 100px;\n}\n.ant-time-picker-input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n}\n.ant-time-picker-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-time-picker-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input:hover {\n  border-color: #49a9ee;\n}\n.ant-time-picker-input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-time-picker-input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-time-picker-input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-time-picker-input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-time-picker-input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-time-picker-input[disabled] {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-time-picker-input[disabled]:hover {\n  border-color: #e2e2e2;\n}\n.ant-time-picker-large .ant-time-picker-input {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-time-picker-small .ant-time-picker-input {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-time-picker-open {\n  opacity: 0;\n}\n.ant-time-picker-icon {\n  position: absolute;\n  user-select: none;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  width: 12px;\n  height: 12px;\n  line-height: 12px;\n  right: 8px;\n  color: rgba(0, 0, 0, 0.43);\n  top: 50%;\n  margin-top: -6px;\n}\n.ant-time-picker-icon:after {\n  content: \"\\e641\";\n  font-family: \"anticon\";\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n  display: block;\n  line-height: 1;\n}\n.ant-time-picker-panel {\n  position: relative;\n  left: 0;\n}\n.ant-time-picker-panel.top {\n  bottom: -8px;\n}\n.ant-time-picker-panel.bottom {\n  top: -2px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzTimePickerComponent.ctorParameters = function () { return []; };
NzTimePickerComponent.propDecorators = {
    'trigger': [{ type: ViewChild, args: ['trigger',] },],
    'nzDisabled': [{ type: Input },],
};
var NzDatePipe = (function () {
    function NzDatePipe() {
    }
    /**
     * @param {?} value
     * @param {?} formatString
     * @return {?}
     */
    NzDatePipe.prototype.transform = function (value, formatString) {
        if (value) {
            return moment(+value).format(formatString);
        }
        else {
            return '';
        }
    };
    return NzDatePipe;
}());
NzDatePipe.decorators = [
    { type: Pipe, args: [{ name: 'nzDate' },] },
];
/**
 * @nocollapse
 */
NzDatePipe.ctorParameters = function () { return []; };
var NzUtilModule = (function () {
    function NzUtilModule() {
    }
    return NzUtilModule;
}());
NzUtilModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzDatePipe],
                exports: [NzDatePipe]
            },] },
];
/**
 * @nocollapse
 */
NzUtilModule.ctorParameters = function () { return []; };
var NzTimePickerModule = (function () {
    function NzTimePickerModule() {
    }
    return NzTimePickerModule;
}());
NzTimePickerModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, NzUtilModule, OverlayModule],
                declarations: [NzTimePickerComponent, NzTimePickerInnerComponent],
                exports: [NzTimePickerComponent, NzTimePickerInnerComponent]
            },] },
];
/**
 * @nocollapse
 */
NzTimePickerModule.ctorParameters = function () { return []; };
var NzDatePickerModule = (function () {
    function NzDatePickerModule() {
    }
    return NzDatePickerModule;
}());
NzDatePickerModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, NzTimePickerModule, NzUtilModule, NzInputModule, NzCalendarModule, FormsModule, OverlayModule],
                declarations: [NzDatePickerComponent],
                exports: [NzDatePickerComponent]
            },] },
];
/**
 * @nocollapse
 */
NzDatePickerModule.ctorParameters = function () { return []; };
var NzFormComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function NzFormComponent(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._classList = [];
        this._prefixCls = 'ant-form';
        /**
         * @deprecated Use `nzLayout` instead.
         */
        this.nzType = 'horizontal';
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzFormComponent.prototype, "nzLayout", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.nzType = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzFormComponent.prototype.setClassMap = function () {
        var _this = this;
        this._classList.forEach(function (_className) {
            _this._renderer.removeClass(_this._el, _className);
        });
        this._classList = [
            this.nzType && this._prefixCls + "-" + this.nzType
        ].filter(function (item) {
            return !!item;
        });
        this._classList.forEach(function (_className) {
            _this._renderer.addClass(_this._el, _className);
        });
    };
    /**
     * @return {?}
     */
    NzFormComponent.prototype.ngOnInit = function () {
        this.setClassMap();
    };
    return NzFormComponent;
}());
NzFormComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-form]',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 14px;\n  line-height: inherit;\n  color: rgba(0, 0, 0, 0.43);\n  border: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\nlabel {\n  font-size: 12px;\n}\ninput[type=\"search\"] {\n  box-sizing: border-box;\n}\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  line-height: normal;\n}\ninput[type=\"file\"] {\n  display: block;\n}\ninput[type=\"range\"] {\n  display: block;\n  width: 100%;\n}\nselect[multiple],\nselect[size] {\n  height: auto;\n}\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\noutput {\n  display: block;\n  padding-top: 15px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n}\nlabel {\n  position: relative;\n}\nlabel > .anticon {\n  vertical-align: top;\n  font-size: 12px;\n}\n.ant-form-item-required:before {\n  display: inline-block;\n  margin-right: 4px;\n  content: \"*\";\n  font-family: SimSun;\n  line-height: 1;\n  font-size: 12px;\n  color: #f04134;\n}\n.ant-form-hide-required-mark .ant-form-item-required:before {\n  display: none;\n}\ninput[type=\"radio\"][disabled],\ninput[type=\"checkbox\"][disabled],\ninput[type=\"radio\"].disabled,\ninput[type=\"checkbox\"].disabled {\n  cursor: not-allowed;\n}\n.ant-radio-inline.disabled,\n.ant-radio-vertical.disabled,\n.ant-checkbox-inline.disabled,\n.ant-checkbox-vertical.disabled {\n  cursor: not-allowed;\n}\n.ant-radio.disabled label,\n.ant-checkbox.disabled label {\n  cursor: not-allowed;\n}\n.ant-form-item {\n  font-size: 12px;\n  margin-bottom: 24px;\n  color: rgba(0, 0, 0, 0.65);\n  vertical-align: top;\n}\n.ant-form-item > .ant-form-item,\n.ant-form-item :not(.ant-form) > .ant-form-item {\n  margin-bottom: -24px;\n}\n.ant-form-item-control {\n  line-height: 32px;\n  position: relative;\n  zoom: 1;\n}\n.ant-form-item-control:before,\n.ant-form-item-control:after {\n  content: \" \";\n  display: table;\n}\n.ant-form-item-control:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-form-item-with-help {\n  margin-bottom: 6px;\n}\n.ant-form-item-label {\n  text-align: right;\n  vertical-align: middle;\n  line-height: 32px;\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ant-form-item-label label {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-form-item-label label:after {\n  content: \":\";\n  margin: 0 8px 0 2px;\n  position: relative;\n  top: -0.5px;\n}\n.ant-form-item .ant-switch {\n  margin: 4px 0;\n}\n.ant-form-item-no-colon .ant-form-item-label label:after {\n  content: \" \";\n}\n.ant-form-explain,\n.ant-form-extra {\n  color: rgba(0, 0, 0, 0.43);\n  line-height: 1.5;\n}\n.ant-form-extra {\n  padding-top: 4px;\n}\n.ant-form-text {\n  display: inline-block;\n  padding-right: 8px;\n}\n.ant-form-split {\n  display: block;\n  text-align: center;\n}\nform .has-feedback .ant-input {\n  padding-right: 24px;\n}\nform .has-feedback > .ant-select .ant-select-arrow,\nform .has-feedback > .ant-select .ant-select-selection__clear,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection__clear {\n  right: 28px;\n}\nform .has-feedback > .ant-select .ant-select-selection-selected-value,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value {\n  padding-right: 42px;\n}\nform .has-feedback .ant-cascader-picker-arrow {\n  padding-right: 36px;\n}\nform .has-feedback .ant-cascader-picker-clear {\n  right: 28px;\n}\nform .has-feedback .ant-calendar-picker-icon,\nform .has-feedback .ant-calendar-picker-clear {\n  right: 28px;\n}\nform textarea.ant-input {\n  height: auto;\n}\nform .ant-upload {\n  background: transparent;\n}\nform input[type=\"radio\"],\nform input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n}\nform .ant-radio-inline,\nform .ant-checkbox-inline {\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: normal;\n  cursor: pointer;\n  margin-left: 8px;\n}\nform .ant-radio-inline:first-child,\nform .ant-checkbox-inline:first-child {\n  margin-left: 0;\n}\nform .ant-checkbox-vertical,\nform .ant-radio-vertical {\n  display: block;\n}\nform .ant-checkbox-vertical + .ant-checkbox-vertical,\nform .ant-radio-vertical + .ant-radio-vertical {\n  margin-left: 0;\n}\nform .ant-input-number {\n  margin-top: -1px;\n  margin-right: 8px;\n}\nform .ant-select,\nform .ant-cascader-picker {\n  width: 100%;\n}\nform .ant-select:only-child,\nform .ant-cascader-picker:only-child {\n  display: block;\n}\nform .ant-input-group .ant-select,\nform .ant-input-group .ant-cascader-picker {\n  width: auto;\n}\nform .ant-input-group-addon .ant-select:only-child,\nform .ant-input-group-addon .ant-cascader-picker:only-child {\n  display: inline-block;\n}\n.ant-input-group-wrap .ant-select-selection {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group-wrap .ant-select-selection:hover {\n  border-color: #d9d9d9;\n}\n.ant-input-group-wrap .ant-select-selection--single {\n  margin-left: -1px;\n  height: 32px;\n  background-color: #eee;\n}\n.ant-input-group-wrap .ant-select-selection--single .ant-select-selection__rendered {\n  padding-left: 8px;\n  padding-right: 25px;\n  line-height: 30px;\n}\n.ant-input-group-wrap .ant-select-open .ant-select-selection {\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n.ant-form-vertical .ant-form-item-label,\n.ant-col-24.ant-form-item-label,\n.ant-col-xl-24.ant-form-item-label {\n  padding: 0 0 8px;\n  display: block;\n  text-align: left;\n  line-height: 1.5;\n}\n.ant-form-vertical .ant-form-item-label label:after,\n.ant-col-24.ant-form-item-label label:after,\n.ant-col-xl-24.ant-form-item-label label:after {\n  display: none;\n}\n@media (max-width: 767px) {\n  .ant-col-xs-24.ant-form-item-label {\n    padding: 0 0 8px;\n    display: block;\n    text-align: left;\n    line-height: 1.5;\n  }\n  .ant-col-xs-24.ant-form-item-label label:after {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .ant-col-sm-24.ant-form-item-label {\n    padding: 0 0 8px;\n    display: block;\n    text-align: left;\n    line-height: 1.5;\n  }\n  .ant-col-sm-24.ant-form-item-label label:after {\n    display: none;\n  }\n}\n@media (max-width: 1199px) {\n  .ant-col-md-24.ant-form-item-label {\n    padding: 0 0 8px;\n    display: block;\n    text-align: left;\n    line-height: 1.5;\n  }\n  .ant-col-md-24.ant-form-item-label label:after {\n    display: none;\n  }\n}\n@media (max-width: 1599px) {\n  .ant-col-lg-24.ant-form-item-label {\n    padding: 0 0 8px;\n    display: block;\n    text-align: left;\n    line-height: 1.5;\n  }\n  .ant-col-lg-24.ant-form-item-label label:after {\n    display: none;\n  }\n}\n.ant-form-inline .ant-form-item {\n  display: inline-block;\n  margin-right: 16px;\n  margin-bottom: 0;\n}\n.ant-form-inline .ant-form-item-with-help {\n  margin-bottom: 24px;\n}\n.ant-form-inline .ant-form-item > div {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-form-inline .ant-form-text {\n  display: inline-block;\n}\n.ant-form-inline .has-feedback {\n  display: inline-block;\n}\n.ant-form-inline .ant-form-explain {\n  position: absolute;\n}\n.has-success.has-feedback:after,\n.has-warning.has-feedback:after,\n.has-error.has-feedback:after,\n.is-validating.has-feedback:after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  visibility: visible;\n  pointer-events: none;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  text-align: center;\n  font-size: 14px;\n  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\";\n  z-index: 1;\n}\n.has-success.has-feedback:after {\n  animation-name: diffZoomIn1 !important;\n}\n.has-error.has-feedback:after {\n  animation-name: diffZoomIn2 !important;\n}\n.has-warning.has-feedback:after {\n  animation-name: diffZoomIn3 !important;\n}\n.has-success.has-feedback:after {\n  content: '\\e630';\n  color: #00a854;\n}\n.has-warning .ant-form-explain,\n.has-warning .ant-form-split {\n  color: #ffbf00;\n}\n.has-warning .ant-input,\n.has-warning .ant-input:hover {\n  border-color: #ffbf00;\n}\n.has-warning .ant-input:focus {\n  border-color: #ffce3d;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(255, 191, 0, 0.2);\n}\n.has-warning .ant-input:not([disabled]):hover {\n  border-color: #ffbf00;\n}\n.has-warning .ant-calendar-picker-open .ant-calendar-picker-input {\n  border-color: #ffce3d;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(255, 191, 0, 0.2);\n}\n.has-warning .ant-input-prefix {\n  color: #ffbf00;\n}\n.has-warning .ant-input-group-addon {\n  color: #ffbf00;\n  border-color: #ffbf00;\n  background-color: #fff;\n}\n.has-warning .has-feedback {\n  color: #ffbf00;\n}\n.has-warning.has-feedback:after {\n  content: '\\e62c';\n  color: #ffbf00;\n}\n.has-warning .ant-select-selection {\n  border-color: #ffbf00;\n}\n.has-warning .ant-select-open .ant-select-selection,\n.has-warning .ant-select-focused .ant-select-selection {\n  border-color: #ffce3d;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(255, 191, 0, 0.2);\n}\n.has-warning .ant-calendar-picker-icon:after,\n.has-warning .ant-picker-icon:after,\n.has-warning .ant-select-arrow,\n.has-warning .ant-cascader-picker-arrow {\n  color: #ffbf00;\n}\n.has-warning .ant-input-number,\n.has-warning .ant-time-picker-input {\n  border-color: #ffbf00;\n}\n.has-warning .ant-input-number-focused,\n.has-warning .ant-time-picker-input-focused,\n.has-warning .ant-input-number:focus,\n.has-warning .ant-time-picker-input:focus {\n  border-color: #ffce3d;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(255, 191, 0, 0.2);\n}\n.has-warning .ant-input-number:not([disabled]):hover,\n.has-warning .ant-time-picker-input:not([disabled]):hover {\n  border-color: #ffbf00;\n}\n.has-error .ant-form-explain,\n.has-error .ant-form-split {\n  color: #f04134;\n}\n.has-error .ant-input,\n.has-error .ant-input:hover {\n  border-color: #f04134;\n}\n.has-error .ant-input:focus {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.has-error .ant-input:not([disabled]):hover {\n  border-color: #f04134;\n}\n.has-error .ant-calendar-picker-open .ant-calendar-picker-input {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.has-error .ant-input-prefix {\n  color: #f04134;\n}\n.has-error .ant-input-group-addon {\n  color: #f04134;\n  border-color: #f04134;\n  background-color: #fff;\n}\n.has-error .has-feedback {\n  color: #f04134;\n}\n.has-error.has-feedback:after {\n  content: '\\e62e';\n  color: #f04134;\n}\n.has-error .ant-select-selection {\n  border-color: #f04134;\n}\n.has-error .ant-select-open .ant-select-selection,\n.has-error .ant-select-focused .ant-select-selection {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.has-error .ant-input-group-addon .ant-select-selection {\n  border-color: transparent;\n  box-shadow: none;\n}\n.has-error .ant-calendar-picker-icon:after,\n.has-error .ant-picker-icon:after,\n.has-error .ant-select-arrow,\n.has-error .ant-cascader-picker-arrow {\n  color: #f04134;\n}\n.has-error .ant-input-number,\n.has-error .ant-time-picker-input {\n  border-color: #f04134;\n}\n.has-error .ant-input-number-focused,\n.has-error .ant-time-picker-input-focused,\n.has-error .ant-input-number:focus,\n.has-error .ant-time-picker-input:focus {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.has-error .ant-input-number:not([disabled]):hover,\n.has-error .ant-time-picker-input:not([disabled]):hover {\n  border-color: #f04134;\n}\n.has-error .ant-mention-wrapper .ant-mention-editor,\n.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):hover {\n  border-color: #f04134;\n}\n.has-error .ant-mention-wrapper.ant-mention-active .ant-mention-editor,\n.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):focus {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.is-validating.has-feedback:after {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n  content: \"\\e64d\";\n  color: #108ee9;\n}\n.ant-advanced-search-form .ant-form-item {\n  margin-bottom: 16px;\n}\n.ant-advanced-search-form .ant-input,\n.ant-advanced-search-form .ant-input-group .ant-input,\n.ant-advanced-search-form .ant-input-group .ant-input-group-addon {\n  height: 28px;\n}\n@keyframes diffZoomIn1 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes diffZoomIn2 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes diffZoomIn3 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 14px;\n  line-height: inherit;\n  color: rgba(0, 0, 0, 0.43);\n  border: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\nlabel {\n  font-size: 12px;\n}\ninput[type=\"search\"] {\n  box-sizing: border-box;\n}\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  line-height: normal;\n}\ninput[type=\"file\"] {\n  display: block;\n}\ninput[type=\"range\"] {\n  display: block;\n  width: 100%;\n}\nselect[multiple],\nselect[size] {\n  height: auto;\n}\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: thin dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\noutput {\n  display: block;\n  padding-top: 15px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n}\nlabel {\n  position: relative;\n}\nlabel > .anticon {\n  vertical-align: top;\n  font-size: 12px;\n}\n.ant-form-item-required:before {\n  display: inline-block;\n  margin-right: 4px;\n  content: \"*\";\n  font-family: SimSun;\n  line-height: 1;\n  font-size: 12px;\n  color: #f04134;\n}\n.ant-form-hide-required-mark .ant-form-item-required:before {\n  display: none;\n}\ninput[type=\"radio\"][disabled],\ninput[type=\"checkbox\"][disabled],\ninput[type=\"radio\"].disabled,\ninput[type=\"checkbox\"].disabled {\n  cursor: not-allowed;\n}\n.ant-radio-inline.disabled,\n.ant-radio-vertical.disabled,\n.ant-checkbox-inline.disabled,\n.ant-checkbox-vertical.disabled {\n  cursor: not-allowed;\n}\n.ant-radio.disabled label,\n.ant-checkbox.disabled label {\n  cursor: not-allowed;\n}\n.ant-form-item {\n  font-size: 12px;\n  margin-bottom: 24px;\n  color: rgba(0, 0, 0, 0.65);\n  vertical-align: top;\n}\n.ant-form-item > .ant-form-item,\n.ant-form-item :not(.ant-form) > .ant-form-item {\n  margin-bottom: -24px;\n}\n.ant-form-item-control {\n  line-height: 32px;\n  position: relative;\n  zoom: 1;\n}\n.ant-form-item-control:before,\n.ant-form-item-control:after {\n  content: \" \";\n  display: table;\n}\n.ant-form-item-control:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-form-item-with-help {\n  margin-bottom: 6px;\n}\n.ant-form-item-label {\n  text-align: right;\n  vertical-align: middle;\n  line-height: 32px;\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ant-form-item-label label {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-form-item-label label:after {\n  content: \":\";\n  margin: 0 8px 0 2px;\n  position: relative;\n  top: -0.5px;\n}\n.ant-form-item .ant-switch {\n  margin: 4px 0;\n}\n.ant-form-item-no-colon .ant-form-item-label label:after {\n  content: \" \";\n}\n.ant-form-explain,\n.ant-form-extra {\n  color: rgba(0, 0, 0, 0.43);\n  line-height: 1.5;\n}\n.ant-form-extra {\n  padding-top: 4px;\n}\n.ant-form-text {\n  display: inline-block;\n  padding-right: 8px;\n}\n.ant-form-split {\n  display: block;\n  text-align: center;\n}\nform .has-feedback .ant-input {\n  padding-right: 24px;\n}\nform .has-feedback > .ant-select .ant-select-arrow,\nform .has-feedback > .ant-select .ant-select-selection__clear,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection__clear {\n  right: 28px;\n}\nform .has-feedback > .ant-select .ant-select-selection-selected-value,\nform .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-selection-selected-value {\n  padding-right: 42px;\n}\nform .has-feedback .ant-cascader-picker-arrow {\n  padding-right: 36px;\n}\nform .has-feedback .ant-cascader-picker-clear {\n  right: 28px;\n}\nform .has-feedback .ant-calendar-picker-icon,\nform .has-feedback .ant-calendar-picker-clear {\n  right: 28px;\n}\nform textarea.ant-input {\n  height: auto;\n}\nform .ant-upload {\n  background: transparent;\n}\nform input[type=\"radio\"],\nform input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n}\nform .ant-radio-inline,\nform .ant-checkbox-inline {\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: normal;\n  cursor: pointer;\n  margin-left: 8px;\n}\nform .ant-radio-inline:first-child,\nform .ant-checkbox-inline:first-child {\n  margin-left: 0;\n}\nform .ant-checkbox-vertical,\nform .ant-radio-vertical {\n  display: block;\n}\nform .ant-checkbox-vertical + .ant-checkbox-vertical,\nform .ant-radio-vertical + .ant-radio-vertical {\n  margin-left: 0;\n}\nform .ant-input-number {\n  margin-top: -1px;\n  margin-right: 8px;\n}\nform .ant-select,\nform .ant-cascader-picker {\n  width: 100%;\n}\nform .ant-select:only-child,\nform .ant-cascader-picker:only-child {\n  display: block;\n}\nform .ant-input-group .ant-select,\nform .ant-input-group .ant-cascader-picker {\n  width: auto;\n}\nform .ant-input-group-addon .ant-select:only-child,\nform .ant-input-group-addon .ant-cascader-picker:only-child {\n  display: inline-block;\n}\n.ant-input-group-wrap .ant-select-selection {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.ant-input-group-wrap .ant-select-selection:hover {\n  border-color: #d9d9d9;\n}\n.ant-input-group-wrap .ant-select-selection--single {\n  margin-left: -1px;\n  height: 32px;\n  background-color: #eee;\n}\n.ant-input-group-wrap .ant-select-selection--single .ant-select-selection__rendered {\n  padding-left: 8px;\n  padding-right: 25px;\n  line-height: 30px;\n}\n.ant-input-group-wrap .ant-select-open .ant-select-selection {\n  border-color: #d9d9d9;\n  box-shadow: none;\n}\n.ant-form-vertical .ant-form-item-label,\n.ant-col-24.ant-form-item-label,\n.ant-col-xl-24.ant-form-item-label {\n  padding: 0 0 8px;\n  display: block;\n  text-align: left;\n  line-height: 1.5;\n}\n.ant-form-vertical .ant-form-item-label label:after,\n.ant-col-24.ant-form-item-label label:after,\n.ant-col-xl-24.ant-form-item-label label:after {\n  display: none;\n}\n@media (max-width: 767px) {\n  .ant-col-xs-24.ant-form-item-label {\n    padding: 0 0 8px;\n    display: block;\n    text-align: left;\n    line-height: 1.5;\n  }\n  .ant-col-xs-24.ant-form-item-label label:after {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .ant-col-sm-24.ant-form-item-label {\n    padding: 0 0 8px;\n    display: block;\n    text-align: left;\n    line-height: 1.5;\n  }\n  .ant-col-sm-24.ant-form-item-label label:after {\n    display: none;\n  }\n}\n@media (max-width: 1199px) {\n  .ant-col-md-24.ant-form-item-label {\n    padding: 0 0 8px;\n    display: block;\n    text-align: left;\n    line-height: 1.5;\n  }\n  .ant-col-md-24.ant-form-item-label label:after {\n    display: none;\n  }\n}\n@media (max-width: 1599px) {\n  .ant-col-lg-24.ant-form-item-label {\n    padding: 0 0 8px;\n    display: block;\n    text-align: left;\n    line-height: 1.5;\n  }\n  .ant-col-lg-24.ant-form-item-label label:after {\n    display: none;\n  }\n}\n.ant-form-inline .ant-form-item {\n  display: inline-block;\n  margin-right: 16px;\n  margin-bottom: 0;\n}\n.ant-form-inline .ant-form-item-with-help {\n  margin-bottom: 24px;\n}\n.ant-form-inline .ant-form-item > div {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-form-inline .ant-form-text {\n  display: inline-block;\n}\n.ant-form-inline .has-feedback {\n  display: inline-block;\n}\n.ant-form-inline .ant-form-explain {\n  position: absolute;\n}\n.has-success.has-feedback:after,\n.has-warning.has-feedback:after,\n.has-error.has-feedback:after,\n.is-validating.has-feedback:after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  visibility: visible;\n  pointer-events: none;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  text-align: center;\n  font-size: 14px;\n  animation: zoomIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);\n  font-family: 'anticon';\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\";\n  z-index: 1;\n}\n.has-success.has-feedback:after {\n  animation-name: diffZoomIn1 !important;\n}\n.has-error.has-feedback:after {\n  animation-name: diffZoomIn2 !important;\n}\n.has-warning.has-feedback:after {\n  animation-name: diffZoomIn3 !important;\n}\n.has-success.has-feedback:after {\n  content: '\\e630';\n  color: #00a854;\n}\n.has-warning .ant-form-explain,\n.has-warning .ant-form-split {\n  color: #ffbf00;\n}\n.has-warning .ant-input,\n.has-warning .ant-input:hover {\n  border-color: #ffbf00;\n}\n.has-warning .ant-input:focus {\n  border-color: #ffce3d;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(255, 191, 0, 0.2);\n}\n.has-warning .ant-input:not([disabled]):hover {\n  border-color: #ffbf00;\n}\n.has-warning .ant-calendar-picker-open .ant-calendar-picker-input {\n  border-color: #ffce3d;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(255, 191, 0, 0.2);\n}\n.has-warning .ant-input-prefix {\n  color: #ffbf00;\n}\n.has-warning .ant-input-group-addon {\n  color: #ffbf00;\n  border-color: #ffbf00;\n  background-color: #fff;\n}\n.has-warning .has-feedback {\n  color: #ffbf00;\n}\n.has-warning.has-feedback:after {\n  content: '\\e62c';\n  color: #ffbf00;\n}\n.has-warning .ant-select-selection {\n  border-color: #ffbf00;\n}\n.has-warning .ant-select-open .ant-select-selection,\n.has-warning .ant-select-focused .ant-select-selection {\n  border-color: #ffce3d;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(255, 191, 0, 0.2);\n}\n.has-warning .ant-calendar-picker-icon:after,\n.has-warning .ant-picker-icon:after,\n.has-warning .ant-select-arrow,\n.has-warning .ant-cascader-picker-arrow {\n  color: #ffbf00;\n}\n.has-warning .ant-input-number,\n.has-warning .ant-time-picker-input {\n  border-color: #ffbf00;\n}\n.has-warning .ant-input-number-focused,\n.has-warning .ant-time-picker-input-focused,\n.has-warning .ant-input-number:focus,\n.has-warning .ant-time-picker-input:focus {\n  border-color: #ffce3d;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(255, 191, 0, 0.2);\n}\n.has-warning .ant-input-number:not([disabled]):hover,\n.has-warning .ant-time-picker-input:not([disabled]):hover {\n  border-color: #ffbf00;\n}\n.has-error .ant-form-explain,\n.has-error .ant-form-split {\n  color: #f04134;\n}\n.has-error .ant-input,\n.has-error .ant-input:hover {\n  border-color: #f04134;\n}\n.has-error .ant-input:focus {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.has-error .ant-input:not([disabled]):hover {\n  border-color: #f04134;\n}\n.has-error .ant-calendar-picker-open .ant-calendar-picker-input {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.has-error .ant-input-prefix {\n  color: #f04134;\n}\n.has-error .ant-input-group-addon {\n  color: #f04134;\n  border-color: #f04134;\n  background-color: #fff;\n}\n.has-error .has-feedback {\n  color: #f04134;\n}\n.has-error.has-feedback:after {\n  content: '\\e62e';\n  color: #f04134;\n}\n.has-error .ant-select-selection {\n  border-color: #f04134;\n}\n.has-error .ant-select-open .ant-select-selection,\n.has-error .ant-select-focused .ant-select-selection {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.has-error .ant-input-group-addon .ant-select-selection {\n  border-color: transparent;\n  box-shadow: none;\n}\n.has-error .ant-calendar-picker-icon:after,\n.has-error .ant-picker-icon:after,\n.has-error .ant-select-arrow,\n.has-error .ant-cascader-picker-arrow {\n  color: #f04134;\n}\n.has-error .ant-input-number,\n.has-error .ant-time-picker-input {\n  border-color: #f04134;\n}\n.has-error .ant-input-number-focused,\n.has-error .ant-time-picker-input-focused,\n.has-error .ant-input-number:focus,\n.has-error .ant-time-picker-input:focus {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.has-error .ant-input-number:not([disabled]):hover,\n.has-error .ant-time-picker-input:not([disabled]):hover {\n  border-color: #f04134;\n}\n.has-error .ant-mention-wrapper .ant-mention-editor,\n.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):hover {\n  border-color: #f04134;\n}\n.has-error .ant-mention-wrapper.ant-mention-active .ant-mention-editor,\n.has-error .ant-mention-wrapper .ant-mention-editor:not([disabled]):focus {\n  border-color: #f46e65;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(240, 65, 52, 0.2);\n}\n.is-validating.has-feedback:after {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n  content: \"\\e64d\";\n  color: #108ee9;\n}\n.ant-advanced-search-form .ant-form-item {\n  margin-bottom: 16px;\n}\n.ant-advanced-search-form .ant-input,\n.ant-advanced-search-form .ant-input-group .ant-input,\n.ant-advanced-search-form .ant-input-group .ant-input-group-addon {\n  height: 28px;\n}\n@keyframes diffZoomIn1 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes diffZoomIn2 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes diffZoomIn3 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.ant-form-item > label {\n  color: rgba(0, 0, 0, 0.85);\n  text-align: right;\n  vertical-align: middle;\n  padding: 7px 0;\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ant-form-item > label:after {\n  content: \":\";\n  margin: 0 8px 0 2px;\n  position: relative;\n  top: -0.5px;\n}\n.ant-form-item-control nz-input {\n  width: 100%;\n}\n.ant-form-item-control nz-select.ant-select {\n  display: inline-block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzFormComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzFormComponent.propDecorators = {
    'nzType': [{ type: Input },],
    'nzLayout': [{ type: Input },],
};
var NzFormItemDirective = (function () {
    function NzFormItemDirective() {
        this._withHelp = 0;
        this._nzFormItem = true;
    }
    /**
     * @return {?}
     */
    NzFormItemDirective.prototype.enableHelp = function () {
        this._withHelp++;
    };
    ;
    /**
     * @return {?}
     */
    NzFormItemDirective.prototype.disableHelp = function () {
        this._withHelp--;
    };
    ;
    Object.defineProperty(NzFormItemDirective.prototype, "withHelp", {
        /**
         * @return {?}
         */
        get: function () {
            return this._withHelp > 0;
        },
        enumerable: true,
        configurable: true
    });
    ;
    return NzFormItemDirective;
}());
NzFormItemDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-form-item]'
            },] },
];
/**
 * @nocollapse
 */
NzFormItemDirective.ctorParameters = function () { return []; };
NzFormItemDirective.propDecorators = {
    '_nzFormItem': [{ type: HostBinding, args: ["class.ant-form-item",] },],
    'withHelp': [{ type: HostBinding, args: ["class.ant-form-item-with-help",] },],
};
var NzFormControlComponent = (function () {
    function NzFormControlComponent() {
        this._hasFeedback = false;
        this._nzFormItemControlWrapper = true;
    }
    Object.defineProperty(NzFormControlComponent.prototype, "nzHasFeedback", {
        /**
         * @return {?}
         */
        get: function () {
            return this._hasFeedback;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._hasFeedback = true;
            }
            else {
                this._hasFeedback = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzFormControlComponent.prototype, "isWarning", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isDirtyAndError('warning');
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzFormControlComponent.prototype, "isValidate", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isDirtyAndError('validating') || this.nzValidateStatus === 'pending' || this.nzValidateStatus && this.nzValidateStatus.dirty && this.nzValidateStatus.pending;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzFormControlComponent.prototype, "isError", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isDirtyAndError('error')
                || this._isDirtyAndError('required')
                || this._isDirtyAndError('pattern')
                || this._isDirtyAndError('email')
                || this._isDirtyAndError('maxlength')
                || this._isDirtyAndError('minlength');
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzFormControlComponent.prototype, "isSuccess", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzValidateStatus === 'success' || this.nzValidateStatus && this.nzValidateStatus.dirty && this.nzValidateStatus.valid;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzFormControlComponent.prototype, "hasFeedBack", {
        /**
         * @return {?}
         */
        get: function () {
            return (this.nzHasFeedback);
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?} name
     * @return {?}
     */
    NzFormControlComponent.prototype._isDirtyAndError = function (name) {
        return this.nzValidateStatus === name || this.nzValidateStatus && this.nzValidateStatus.dirty && this.nzValidateStatus.hasError && this.nzValidateStatus.hasError(name);
    };
    return NzFormControlComponent;
}());
NzFormControlComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-form-control]',
                template: "\n    <div class=\"ant-form-item-control\"\n      [class.has-warning]=\"isWarning\"\n      [class.has-error]=\"isError\"\n      [class.has-success]=\"isSuccess\"\n      [class.has-feedback]=\"hasFeedBack\"\n      [class.is-validating]=\"isValidate\">\n      <ng-content></ng-content>\n    </div>\n  ",
                styles: []
            },] },
];
/**
 * @nocollapse
 */
NzFormControlComponent.ctorParameters = function () { return []; };
NzFormControlComponent.propDecorators = {
    '_nzFormItemControlWrapper': [{ type: HostBinding, args: ["class.ant-form-item-control-wrapper",] },],
    'nzHasFeedback': [{ type: Input },],
    'nzValidateStatus': [{ type: Input },],
};
var NzFormExplainComponent = (function () {
    /**
     * @param {?} _nzFormItem
     */
    function NzFormExplainComponent(_nzFormItem) {
        this._nzFormItem = _nzFormItem;
        this._nzFormExplain = true;
    }
    /**
     * @return {?}
     */
    NzFormExplainComponent.prototype.ngOnDestroy = function () {
        this._nzFormItem.disableHelp();
    };
    /**
     * @return {?}
     */
    NzFormExplainComponent.prototype.ngOnInit = function () {
        this._nzFormItem.enableHelp();
    };
    return NzFormExplainComponent;
}());
NzFormExplainComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-form-explain]',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n  ",
                styles: []
            },] },
];
/**
 * @nocollapse
 */
NzFormExplainComponent.ctorParameters = function () { return [
    { type: NzFormItemDirective, },
]; };
NzFormExplainComponent.propDecorators = {
    '_nzFormExplain': [{ type: HostBinding, args: ["class.ant-form-explain",] },],
};
var NzFormTextDirective = (function () {
    function NzFormTextDirective() {
        this._nzFormText = true;
    }
    return NzFormTextDirective;
}());
NzFormTextDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-form-text]'
            },] },
];
/**
 * @nocollapse
 */
NzFormTextDirective.ctorParameters = function () { return []; };
NzFormTextDirective.propDecorators = {
    '_nzFormText': [{ type: HostBinding, args: ["class.ant-form-text",] },],
};
var NzFormSplitDirective = (function () {
    function NzFormSplitDirective() {
        this._nzFormSplit = true;
    }
    return NzFormSplitDirective;
}());
NzFormSplitDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-form-split]'
            },] },
];
/**
 * @nocollapse
 */
NzFormSplitDirective.ctorParameters = function () { return []; };
NzFormSplitDirective.propDecorators = {
    '_nzFormSplit': [{ type: HostBinding, args: ["class.ant-form-split",] },],
};
var NzFormExtraDirective = (function () {
    function NzFormExtraDirective() {
        this._nzFormExtra = true;
    }
    return NzFormExtraDirective;
}());
NzFormExtraDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-form-extra]'
            },] },
];
/**
 * @nocollapse
 */
NzFormExtraDirective.ctorParameters = function () { return []; };
NzFormExtraDirective.propDecorators = {
    '_nzFormExtra': [{ type: HostBinding, args: ["class.ant-form-extra",] },],
};
var NzFormLabelDirective = (function () {
    function NzFormLabelDirective() {
        this._nzFormItemLabel = true;
    }
    return NzFormLabelDirective;
}());
NzFormLabelDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-form-label]'
            },] },
];
/**
 * @nocollapse
 */
NzFormLabelDirective.ctorParameters = function () { return []; };
NzFormLabelDirective.propDecorators = {
    '_nzFormItemLabel': [{ type: HostBinding, args: ["class.ant-form-item-label",] },],
};
var NzFormItemRequiredDirective = (function () {
    function NzFormItemRequiredDirective() {
        this.nzRequired = true;
    }
    return NzFormItemRequiredDirective;
}());
NzFormItemRequiredDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-form-item-required]'
            },] },
];
/**
 * @nocollapse
 */
NzFormItemRequiredDirective.ctorParameters = function () { return []; };
NzFormItemRequiredDirective.propDecorators = {
    'nzRequired': [{ type: Input }, { type: HostBinding, args: ["class.ant-form-item-required",] },],
};
var NzFormModule = (function () {
    function NzFormModule() {
    }
    return NzFormModule;
}());
NzFormModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzFormExtraDirective, NzFormLabelDirective, NzFormComponent, NzFormItemDirective, NzFormControlComponent, NzFormExplainComponent, NzFormTextDirective, NzFormSplitDirective, NzFormItemRequiredDirective],
                exports: [NzFormExtraDirective, NzFormLabelDirective, NzFormComponent, NzFormItemDirective, NzFormControlComponent, NzFormExplainComponent, NzFormTextDirective, NzFormSplitDirective, NzFormItemRequiredDirective],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzFormModule.ctorParameters = function () { return []; };
var NzInputNumberComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function NzInputNumberComponent(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._size = 'default';
        this._prefixCls = 'ant-input-number';
        this._step = 1;
        this._precisionStep = 0;
        this._precisionFactor = 1;
        this._disabledUp = false;
        this._disabledDown = false;
        this._focused = false;
        this._mouseInside = false;
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.nzPlaceHolder = '';
        this.nzMin = -Infinity;
        this.nzMax = Infinity;
        this.nzDisabled = false;
        this.nzBlur = new EventEmitter();
        this.nzFocus = new EventEmitter();
        this._el = this._elementRef.nativeElement;
        this._renderer.addClass(this._el, "" + this._prefixCls);
    }
    Object.defineProperty(NzInputNumberComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._renderer.removeClass(this._el, this._prefixCls + "-" + this._size);
            this._size = { large: 'lg', small: 'sm' }[value];
            this._renderer.addClass(this._el, this._prefixCls + "-" + this._size);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzInputNumberComponent.prototype, "nzStep", {
        /**
         * @return {?}
         */
        get: function () {
            return this._step;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._step = value;
            var /** @type {?} */ stepString = value.toString();
            if (stepString.indexOf('e-') >= 0) {
                this._precisionStep = parseInt(stepString.slice(stepString.indexOf('e-')), 10);
            }
            if (stepString.indexOf('.') >= 0) {
                this._precisionStep = stepString.length - stepString.indexOf('.') - 1;
            }
            this._precisionFactor = Math.pow(10, this._precisionStep);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} $event
     * @return {?}
     */
    NzInputNumberComponent.prototype._numberUp = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this._inputNumber.nativeElement.focus();
        if (this.nzValue === undefined) {
            this.nzValue = this.nzMin || 0;
        }
        if (!this._disabledUp) {
            this.nzValue = this.toPrecisionAsStep((this._precisionFactor * this.nzValue + this._precisionFactor * this.nzStep) / this._precisionFactor);
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzInputNumberComponent.prototype._numberDown = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this._inputNumber.nativeElement.focus();
        if (this.nzValue === undefined) {
            this.nzValue = this.nzMin || 0;
        }
        if (!this._disabledDown) {
            this.nzValue = this.toPrecisionAsStep((this._precisionFactor * this.nzValue - this._precisionFactor * this.nzStep) / this._precisionFactor);
        }
    };
    Object.defineProperty(NzInputNumberComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateValue(value);
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?} $event
     * @return {?}
     */
    NzInputNumberComponent.prototype._emitBlur = function ($event) {
        // avoid unnecessary events
        if (this._focused && !this._mouseInside) {
            this._checkValue();
            this._focused = false;
            this.nzBlur.emit($event);
        }
        this.onTouched();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzInputNumberComponent.prototype._emitFocus = function ($event) {
        // avoid unnecessary events
        if (!this._focused) {
            this._focused = true;
            this.nzFocus.emit($event);
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzInputNumberComponent.prototype._emitKeydown = function ($event) {
        if ($event.keyCode === TAB && this._focused) {
            this._focused = false;
            this.nzBlur.emit($event);
        }
    };
    /**
     * @return {?}
     */
    NzInputNumberComponent.prototype._userInputChange = function () {
        var /** @type {?} */ numberValue = +this._displayValue;
        if (this._isNumber(numberValue) && (numberValue <= this.nzMax) && (numberValue >= this.nzMin)) {
            this.nzValue = numberValue;
        }
    };
    /**
     * @return {?}
     */
    NzInputNumberComponent.prototype._checkValue = function () {
        this._displayValue = this.nzValue;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzInputNumberComponent.prototype._getBoundValue = function (value) {
        if (value > this.nzMax) {
            return this.nzMax;
        }
        else if (value < this.nzMin) {
            return this.nzMin;
        }
        else {
            return value;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzInputNumberComponent.prototype._isNumber = function (value) {
        return !isNaN(value) && isFinite(value);
    };
    /**
     * @param {?} num
     * @return {?}
     */
    NzInputNumberComponent.prototype.toPrecisionAsStep = function (num) {
        if (isNaN(num) || num === '') {
            return num;
        }
        return Number(Number(num).toFixed(this._precisionStep));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzInputNumberComponent.prototype.writeValue = function (value) {
        // this.nzValue = value;
        this._updateValue(value, false);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzInputNumberComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzInputNumberComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzInputNumberComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    /**
     * @param {?} value
     * @param {?=} emitChange
     * @return {?}
     */
    NzInputNumberComponent.prototype._updateValue = function (value, emitChange) {
        if (emitChange === void 0) { emitChange = true; }
        if (this._value === value) {
            return;
        }
        this._value = this._getBoundValue(value);
        this._displayValue = this._value;
        this._inputNumber.nativeElement.value = this._value;
        if (emitChange) {
            this.onChange(this._value);
        }
        this._disabledUp = (this.nzValue !== undefined) && !((this.nzValue + this.nzStep) <= this.nzMax);
        this._disabledDown = (this.nzValue !== undefined) && !((this.nzValue - this.nzStep) >= this.nzMin);
    };
    return NzInputNumberComponent;
}());
NzInputNumberComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-input-number',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"ant-input-number-handler-wrap\"\n         (mouseover)=\"_mouseInside = true\"\n         (mouseout)=\"_mouseInside = false\">\n      <a class=\"ant-input-number-handler ant-input-number-handler-up\"\n         [ngClass]=\"{'ant-input-number-handler-up-disabled':_disabledUp}\"\n         (click)=\"_numberUp($event)\">\n        <span\n          class=\"ant-input-number-handler-up-inner\"\n          (click)=\"$event.preventDefault();\"></span>\n      </a>\n      <a\n        class=\"ant-input-number-handler ant-input-number-handler-down\"\n        [ngClass]=\"{'ant-input-number-handler-down-disabled':_disabledDown}\"\n        (click)=\"_numberDown($event)\">\n        <span\n          class=\"ant-input-number-handler-down-inner\"\n          (click)=\"$event.preventDefault();\">\n        </span>\n      </a>\n    </div>\n    <div\n      class=\"ant-input-number-input-wrap\">\n      <input class=\"ant-input-number-input\"\n             #inputNumber\n             [placeholder]=\"nzPlaceHolder\"\n             [disabled]=\"nzDisabled\"\n             [(ngModel)]=\"_displayValue\"\n             (blur)=\"_emitBlur($event)\"\n             (focus)=\"_emitFocus($event)\"\n             (keydown)=\"_emitKeydown($event)\"\n             (ngModelChange)=\"_userInputChange()\"\n             [attr.min]=\"nzMin\"\n             [attr.max]=\"nzMax\"\n             [attr.step]=\"_step\"\n             autocomplete=\"off\">\n    </div>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzInputNumberComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-input-number {\n  position: relative;\n  padding: 4px 7px;\n  width: 100%;\n  cursor: text;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  transition: all .3s;\n  margin: 0;\n  padding: 0;\n  font-size: 12px;\n  height: 28px;\n  display: inline-block;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  width: 80px;\n}\n.ant-input-number::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-input-number:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-number::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-number:hover {\n  border-color: #49a9ee;\n}\n.ant-input-number:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-input-number-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-number-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-input-number {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-input-number-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-input-number-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-input-number-handler {\n  text-align: center;\n  line-height: 0;\n  height: 50%;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.43);\n  position: relative;\n  transition: all 0.1s linear;\n  display: block;\n  width: 100%;\n  font-weight: bold;\n}\n.ant-input-number-handler:active {\n  background: #f4f4f4;\n}\n.ant-input-number-handler:hover .ant-input-number-handler-up-inner,\n.ant-input-number-handler:hover .ant-input-number-handler-down-inner {\n  color: #49a9ee;\n}\n.ant-input-number-handler-up-inner,\n.ant-input-number-handler-down-inner {\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  line-height: 1;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 12px;\n  user-select: none;\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  transition: all 0.1s linear;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 7px 9;\n  transform: scale(0.58333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  right: 4px;\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-input-number-handler-up-inner:before,\n.ant-input-number-handler-down-inner:before {\n  display: block;\n  font-family: \"anticon\" !important;\n}\n:root .ant-input-number-handler-up-inner,\n:root .ant-input-number-handler-down-inner {\n  filter: none;\n}\n:root .ant-input-number-handler-up-inner,\n:root .ant-input-number-handler-down-inner {\n  font-size: 12px;\n}\n.ant-input-number:hover {\n  border-color: #49a9ee;\n}\n.ant-input-number-focused {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-input-number-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-number-disabled:hover {\n  border-color: #e2e2e2;\n}\n.ant-input-number-input {\n  width: 100%;\n  text-align: left;\n  outline: 0;\n  -moz-appearance: textfield;\n  height: 26px;\n  transition: all 0.3s linear;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  border: 0;\n  border-radius: 4px;\n  padding: 0 7px;\n  display: block;\n}\n.ant-input-number-input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-input-number-input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-number-input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-number-input[disabled] {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-input-number-input[disabled]:hover {\n  border-color: #e2e2e2;\n}\n.ant-input-number-lg {\n  padding: 0;\n}\n.ant-input-number-lg input {\n  height: 30px;\n}\n.ant-input-number-sm {\n  padding: 0;\n}\n.ant-input-number-sm input {\n  height: 20px;\n}\n.ant-input-number-handler-wrap {\n  border-left: 1px solid #d9d9d9;\n  width: 22px;\n  height: 100%;\n  background: #fff;\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0;\n  border-radius: 0 4px 4px 0;\n  transition: opacity 0.24s linear 0.1s;\n  z-index: 2;\n}\n.ant-input-number-handler-wrap:hover .ant-input-number-handler {\n  height: 40%;\n}\n.ant-input-number:hover .ant-input-number-handler-wrap {\n  opacity: 1;\n}\n.ant-input-number-handler-up {\n  cursor: pointer;\n}\n.ant-input-number-handler-up-inner {\n  top: 50%;\n  margin-top: -6px;\n}\n.ant-input-number-handler-up-inner:before {\n  text-align: center;\n  content: \"\\e61e\";\n}\n.ant-input-number-handler-up:hover {\n  height: 60% !important;\n}\n.ant-input-number-handler-down {\n  border-top: 1px solid #d9d9d9;\n  top: -1px;\n  cursor: pointer;\n}\n.ant-input-number-handler-down-inner {\n  top: 50%;\n  margin-top: -6px;\n}\n.ant-input-number-handler-down-inner:before {\n  text-align: center;\n  content: \"\\e61d\";\n}\n.ant-input-number-handler-down:hover {\n  height: 60% !important;\n}\n.ant-input-number-handler-down-disabled .ant-input-number-handler-down-inner,\n.ant-input-number-handler-up-disabled .ant-input-number-handler-down-inner,\n.ant-input-number-disabled .ant-input-number-handler-down-inner,\n.ant-input-number-handler-down-disabled .ant-input-number-handler-up-inner,\n.ant-input-number-handler-up-disabled .ant-input-number-handler-up-inner,\n.ant-input-number-disabled .ant-input-number-handler-up-inner {\n  opacity: 0.72;\n  color: #ccc !important;\n  cursor: not-allowed;\n}\n.ant-input-number-disabled .ant-input-number-input {\n  opacity: 0.72;\n  cursor: not-allowed;\n  background-color: #f7f7f7;\n}\n.ant-input-number-disabled .ant-input-number-handler-wrap {\n  display: none;\n}\n.ant-input-number-disabled .ant-input-number-handler {\n  opacity: 0.72;\n  color: #ccc !important;\n  cursor: not-allowed;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzInputNumberComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzInputNumberComponent.propDecorators = {
    '_inputNumber': [{ type: ViewChild, args: ['inputNumber',] },],
    'nzPlaceHolder': [{ type: Input },],
    'nzMin': [{ type: Input },],
    'nzMax': [{ type: Input },],
    'nzDisabled': [{ type: Input }, { type: HostBinding, args: ['class.ant-input-number-disabled',] },],
    'nzSize': [{ type: Input },],
    'nzStep': [{ type: Input },],
    'nzBlur': [{ type: Output },],
    'nzFocus': [{ type: Output },],
};
var NzInputNumberModule = (function () {
    function NzInputNumberModule() {
    }
    return NzInputNumberModule;
}());
NzInputNumberModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule],
                declarations: [NzInputNumberComponent],
                exports: [NzInputNumberComponent]
            },] },
];
/**
 * @nocollapse
 */
NzInputNumberModule.ctorParameters = function () { return []; };
var NzMessageConfig = (function () {
    function NzMessageConfig() {
    }
    return NzMessageConfig;
}());
var NZ_MESSAGE_DEFAULT_CONFIG = new InjectionToken('NZ_MESSAGE_DEFAULT_CONFIG');
var NZ_MESSAGE_CONFIG = new InjectionToken('NZ_MESSAGE_CONFIG');
var NZ_MESSAGE_DEFAULT_CONFIG_PROVIDER = {
    provide: NZ_MESSAGE_DEFAULT_CONFIG,
    useValue: {
        nzDuration: 1500,
        nzAnimate: true,
        nzPauseOnHover: true,
        nzMaxStack: 7,
    }
};
var NzMessageContainerComponent = (function () {
    /**
     * @param {?} defaultConfig
     * @param {?} config
     */
    function NzMessageContainerComponent(defaultConfig, config) {
        this.messages = [];
        this.config = Object.assign({}, defaultConfig, config);
    }
    /**
     * @return {?}
     */
    NzMessageContainerComponent.prototype.ngOnInit = function () { };
    /**
     * @param {?} message
     * @return {?}
     */
    NzMessageContainerComponent.prototype.createMessage = function (message) {
        if (this.messages.length >= this.config.nzMaxStack) {
            this.messages.splice(0, 1);
        }
        message.options = this._mergeMessageOptions(message.options);
        this.messages.push(message);
    };
    /**
     * @param {?} messageId
     * @return {?}
     */
    NzMessageContainerComponent.prototype.removeMessage = function (messageId) {
        var _this = this;
        this.messages.some(function (message, index) {
            if (message.messageId === messageId) {
                _this.messages.splice(index, 1);
                return true;
            }
        });
    };
    /**
     * @return {?}
     */
    NzMessageContainerComponent.prototype.removeMessageAll = function () {
        this.messages = [];
    };
    /**
     * @param {?} options
     * @return {?}
     */
    NzMessageContainerComponent.prototype._mergeMessageOptions = function (options) {
        var /** @type {?} */ defaultOptions = {
            nzDuration: this.config.nzDuration,
            nzAnimate: this.config.nzAnimate,
            nzPauseOnHover: this.config.nzPauseOnHover
        };
        return Object.assign(defaultOptions, options);
    };
    return NzMessageContainerComponent;
}());
NzMessageContainerComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-message-container',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"ant-message\">\n      <nz-message *ngFor=\"let message of messages; let i = index\" [nzMessage]=\"message\" [nzIndex]=\"i\"></nz-message>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-message {\n  font-size: 12px;\n  position: fixed;\n  z-index: 1010;\n  width: 100%;\n  top: 16px;\n  left: 0;\n  pointer-events: none;\n}\n.ant-message-notice {\n  padding: 8px;\n  text-align: center;\n}\n.ant-message-notice:first-child {\n  margin-top: -8px;\n}\n.ant-message-notice-content {\n  padding: 8px 16px;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  background: #fff;\n  display: inline-block;\n  pointer-events: all;\n}\n.ant-message-success .anticon {\n  color: #00a854;\n}\n.ant-message-error .anticon {\n  color: #f04134;\n}\n.ant-message-warning .anticon {\n  color: #ffbf00;\n}\n.ant-message-info .anticon,\n.ant-message-loading .anticon {\n  color: #108ee9;\n}\n.ant-message .anticon {\n  margin-right: 8px;\n  font-size: 14px;\n  top: 1px;\n  position: relative;\n}\n.ant-message-notice.move-up-leave.move-up-leave-active {\n  animation-name: MessageMoveOut;\n  overflow: hidden;\n  animation-duration: .3s;\n}\n@keyframes MessageMoveOut {\n  0% {\n    opacity: 1;\n    max-height: 150px;\n    padding: 8px;\n  }\n  100% {\n    opacity: 0;\n    max-height: 0;\n    padding: 0;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzMessageContainerComponent.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [NZ_MESSAGE_DEFAULT_CONFIG,] },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [NZ_MESSAGE_CONFIG,] },] },
]; };
var NzMessageComponent = (function () {
    /**
     * @param {?} _messageContainer
     */
    function NzMessageComponent(_messageContainer) {
        this._messageContainer = _messageContainer;
        this._eraseTimer = null;
    }
    /**
     * @return {?}
     */
    NzMessageComponent.prototype.ngOnInit = function () {
        this._options = this.nzMessage.options;
        if (this._options.nzAnimate) {
            this.nzMessage.state = 'enter';
        }
        this._autoErase = this._options.nzDuration > 0;
        if (this._autoErase) {
            this._initErase();
            this._startEraseTimeout();
        }
    };
    /**
     * @return {?}
     */
    NzMessageComponent.prototype.ngOnDestroy = function () {
        if (this._autoErase) {
            this._clearEraseTimeout();
        }
    };
    /**
     * @return {?}
     */
    NzMessageComponent.prototype.onEnter = function () {
        if (this._autoErase && this._options.nzPauseOnHover) {
            this._clearEraseTimeout();
            this._updateTTL();
        }
    };
    /**
     * @return {?}
     */
    NzMessageComponent.prototype.onLeave = function () {
        if (this._autoErase && this._options.nzPauseOnHover) {
            this._startEraseTimeout();
        }
    };
    /**
     * @return {?}
     */
    NzMessageComponent.prototype._destroy = function () {
        var _this = this;
        if (this._options.nzAnimate) {
            this.nzMessage.state = 'leave';
            setTimeout(function () { return _this._messageContainer.removeMessage(_this.nzMessage.messageId); }, 200);
        }
        else {
            this._messageContainer.removeMessage(this.nzMessage.messageId);
        }
    };
    /**
     * @return {?}
     */
    NzMessageComponent.prototype._initErase = function () {
        this._eraseTTL = this._options.nzDuration;
        this._eraseTimingStart = Date.now();
    };
    /**
     * @return {?}
     */
    NzMessageComponent.prototype._updateTTL = function () {
        if (this._autoErase) {
            this._eraseTTL -= Date.now() - this._eraseTimingStart;
        }
    };
    /**
     * @return {?}
     */
    NzMessageComponent.prototype._startEraseTimeout = function () {
        var _this = this;
        if (this._eraseTTL > 0) {
            this._clearEraseTimeout(); // To prevent calling _startEraseTimeout() more times to create more timer
            this._eraseTimer = window.setTimeout(function () { return _this._destroy(); }, this._eraseTTL);
            this._eraseTimingStart = Date.now();
        }
        else {
            this._destroy();
        }
    };
    /**
     * @return {?}
     */
    NzMessageComponent.prototype._clearEraseTimeout = function () {
        if (this._eraseTimer !== null) {
            window.clearTimeout(this._eraseTimer);
            this._eraseTimer = null;
        }
    };
    return NzMessageComponent;
}());
NzMessageComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-message',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('enterLeave', [
                        state('enter', style({ opacity: 1, transform: 'translateY(0)' })),
                        transition('* => enter', [
                            style({ opacity: 0, transform: 'translateY(-50%)' }),
                            animate('100ms linear')
                        ]),
                        state('leave', style({ opacity: 0, transform: 'translateY(-50%)' })),
                        transition('* => leave', [
                            style({ opacity: 1, transform: 'translateY(0)' }),
                            animate('100ms linear')
                        ]),
                    ])
                ],
                template: "\n    <div class=\"ant-message-notice\"\n      [@enterLeave]=\"nzMessage.state\"\n      (mouseenter)=\"onEnter()\"\n      (mouseleave)=\"onLeave()\">\n      <div class=\"ant-message-notice-content\">\n        <div *ngIf=\"!nzMessage.html\" class=\"ant-message-custom-content\" [ngClass]=\"'ant-message-' + nzMessage.type\">\n          <ng-container [ngSwitch]=\"nzMessage.type\">\n            <i *ngSwitchCase=\"'success'\" class=\"anticon anticon-check-circle\"></i>\n            <i *ngSwitchCase=\"'info'\" class=\"anticon anticon-info-circle\"></i>\n            <i *ngSwitchCase=\"'warning'\" class=\"anticon anticon-exclamation-circle\"></i>\n            <i *ngSwitchCase=\"'error'\" class=\"anticon anticon-cross-circle\"></i>\n            <i *ngSwitchCase=\"'loading'\" class=\"anticon anticon-spin anticon-loading\"></i>\n          </ng-container>\n          <span>{{nzMessage.content}}</span>\n        </div>\n        <div *ngIf=\"nzMessage.html\" [innerHTML]=\"nzMessage.html\"></div>\n      </div>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-message {\n  font-size: 12px;\n  position: fixed;\n  z-index: 1010;\n  width: 100%;\n  top: 16px;\n  left: 0;\n  pointer-events: none;\n}\n.ant-message-notice {\n  padding: 8px;\n  text-align: center;\n}\n.ant-message-notice:first-child {\n  margin-top: -8px;\n}\n.ant-message-notice-content {\n  padding: 8px 16px;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  background: #fff;\n  display: inline-block;\n  pointer-events: all;\n}\n.ant-message-success .anticon {\n  color: #00a854;\n}\n.ant-message-error .anticon {\n  color: #f04134;\n}\n.ant-message-warning .anticon {\n  color: #ffbf00;\n}\n.ant-message-info .anticon,\n.ant-message-loading .anticon {\n  color: #108ee9;\n}\n.ant-message .anticon {\n  margin-right: 8px;\n  font-size: 14px;\n  top: 1px;\n  position: relative;\n}\n.ant-message-notice.move-up-leave.move-up-leave-active {\n  animation-name: MessageMoveOut;\n  overflow: hidden;\n  animation-duration: .3s;\n}\n@keyframes MessageMoveOut {\n  0% {\n    opacity: 1;\n    max-height: 150px;\n    padding: 8px;\n  }\n  100% {\n    opacity: 0;\n    max-height: 0;\n    padding: 0;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzMessageComponent.ctorParameters = function () { return [
    { type: NzMessageContainerComponent, },
]; };
NzMessageComponent.propDecorators = {
    'nzMessage': [{ type: Input },],
    'nzIndex': [{ type: Input },],
};
/**
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty$1(value) {
    return value != null && "" + value !== 'false';
}
// Default set of positions for the overlay. Follows the behavior of a dropdown
var defaultPositionList$1 = [
    new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
    new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' })
];
var FloaterOptions = (function () {
    function FloaterOptions() {
        // ---------------------------------------------------------
        // | Configurations
        // ---------------------------------------------------------
        // Current position strategy
        this.positionStrategyType = 'connected';
        // Whether keep overlay existing except call detach() or destroy() manually
        this.persist = false;
        // ---------------------------------------------------------
        // | Emitters
        // ---------------------------------------------------------
        // Event emitted when the backdrop is clicked
        this.backdropClick = new EventEmitter();
        // Event emitted when the position has changed
        this.positionChange = new EventEmitter();
        // Event emitted when the overlay has been attached
        this.attach = new EventEmitter();
        // Event emitted when the overlay has been detached
        this.detach = new EventEmitter();
    }
    return FloaterOptions;
}());
var FloaterProps = (function (_super) {
    tslib_1.__extends(FloaterProps, _super);
    /**
     * @param {?} options
     */
    function FloaterProps(options) {
        var _this = _super.call(this) || this;
        _this._hasBackdrop = false;
        _this._emitterSubscriptions = [];
        // Validating
        _this._validateOptions(options);
        // Merge options
        Object.assign(_this, options);
        // Default values
        _this._initDefaultOptions();
        // Event listeners
        _this._initEventListeners();
        return _this;
    }
    Object.defineProperty(FloaterProps.prototype, "hasBackdrop", {
        /**
         * @return {?}
         */
        get: function () {
            return this._hasBackdrop;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._hasBackdrop = coerceBooleanProperty$1(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} options
     * @return {?}
     */
    FloaterProps.prototype._validateOptions = function (options) {
        if (!options.content) {
            throw new Error('[FloaterOptions] "content" is required.');
        }
        if (options.content instanceof TemplateRef && !options.viewContainerRef) {
            throw new Error('[FloaterOptions] "viewContainerRef" is required for "content" of TemplateRef.');
        }
        if (options.positionStrategyType === 'connected' && !options.positionStrategyOptions) {
            throw new Error('[FloaterOptions] "positionStrategyOptions" can\'t be empty when position strategy type is "connected".');
        }
    };
    /**
     * @return {?}
     */
    FloaterProps.prototype._initDefaultOptions = function () {
        var /** @type {?} */ strategyOptions = (this.positionStrategyOptions);
        if (this.positionStrategyType === 'connected') {
            if (!strategyOptions.positions || !strategyOptions.positions.length) {
                strategyOptions.positions = defaultPositionList$1;
            }
        }
    };
    /**
     * @return {?}
     */
    FloaterProps.prototype._initEventListeners = function () {
        var /** @type {?} */ subscriptions = this._emitterSubscriptions;
        if (this.onBackdropClick) {
            subscriptions.push(this.backdropClick.subscribe(this.onBackdropClick));
        }
        if (this.onPositionChange) {
            subscriptions.push(this.positionChange.subscribe(this.onPositionChange));
        }
        if (this.onAttach) {
            subscriptions.push(this.attach.subscribe(this.onAttach));
        }
        if (this.onDetach) {
            subscriptions.push(this.detach.subscribe(this.onDetach));
        }
    };
    /**
     * @param {?} position
     * @return {?}
     */
    FloaterProps.prototype.setPositionStrategy = function (position) {
        this._position = position;
    };
    /**
     * @return {?}
     */
    FloaterProps.prototype.getPositionStrategy = function () {
        return this._position;
    };
    /**
     * @return {?}
     */
    FloaterProps.prototype.destroy = function () {
        this._emitterSubscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
        this._emitterSubscriptions = null;
    };
    return FloaterProps;
}(FloaterOptions));
/**
 * Floater object to manage overlay (Enhanced verion of ConnectedOverlayDirective)
 * NOTE: don't like ConnectedOverlayDirective, Floater has no dependencies with directive (such as Component, Directive ...)
 *  but this will means that you should destroy it and incidental resources manually using destroy() method!
 */
var Floater = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _renderer
     * @param {?} options
     */
    function Floater(_overlay, _renderer, options) {
        this._overlay = _overlay;
        this._renderer = _renderer;
        this._stateAttached = false;
        this._stateDestroyed = false;
        this._props = new FloaterProps(options);
        var _a = this._props, content = _a.content, viewContainerRef = _a.viewContainerRef, injector = _a.injector;
        if (content instanceof TemplateRef) {
            this._contentPortal = new TemplatePortal(content, viewContainerRef);
        }
        else if (typeof content === 'function') {
            this._contentPortal = new ComponentPortal(content, viewContainerRef, injector);
        }
        else {
            throw new Error('[Floater] Not support "content" type.');
        }
    }
    Object.defineProperty(Floater.prototype, "overlayRef", {
        /**
         * @return {?}
         */
        get: function () {
            return this._overlayRef;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Floater.prototype, "attachedResult", {
        /**
         * @return {?}
         */
        get: function () {
            return this._attachedResult;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Floater.prototype, "dir", {
        /**
         * @return {?}
         */
        get: function () {
            return this._props.dir ? this._props.dir.value : 'ltr';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    Floater.prototype.getComponentInstance = function () {
        if (!this._isCreatedByComponent()) {
            throw new Error("Cant't get ComponentRef when created without ComponentType (Should fill the \"content\" option with value of ComponentType)");
        }
        return ((this.attachedResult)).instance;
    };
    /**
     * @return {?}
     */
    Floater.prototype.attach = function () {
        if (!this._stateAttached) {
            this._stateAttached = true;
            this._attachOverlay();
        }
        return this;
    };
    /**
     * @return {?}
     */
    Floater.prototype.detach = function () {
        if (this._stateAttached) {
            this._stateAttached = false;
            this._detachOverlay();
        }
        return this;
    };
    /**
     * @return {?}
     */
    Floater.prototype.destroy = function () {
        if (!this._stateDestroyed) {
            this._stateDestroyed = true;
            this._destroyOverlay();
        }
        return this;
    };
    /**
     * @return {?}
     */
    Floater.prototype._attachOverlay = function () {
        // console.log('[Floater] Attach overlay');
        var _a = this._props, hasBackdrop = _a.hasBackdrop, backdropClick = _a.backdropClick, attach = _a.attach, persist = _a.persist;
        if (!this._overlayRef) {
            this._createOverlay();
        }
        var /** @type {?} */ position = this._props.getPositionStrategy();
        if (position instanceof ConnectedPositionStrategy) {
            position.withDirection(this.dir);
        }
        this._overlayRef.getState().direction = this.dir;
        if (!persist) {
            this._initEscapeListener();
        }
        if (!this._overlayRef.hasAttached()) {
            this._attachedResult = this._overlayRef.attach(this._contentPortal);
            if (this._isCreatedByComponent()) {
                this._handleAttachedComponent(/** @type {?} */ (this._attachedResult));
            }
            if (attach) {
                attach.emit();
            }
        }
        if (hasBackdrop && backdropClick) {
            this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function () {
                backdropClick.emit();
            });
        }
    };
    /**
     * @return {?}
     */
    Floater.prototype._detachOverlay = function () {
        // console.log('[Floater] Detach overlay');
        var detach = this._props.detach;
        if (this._overlayRef) {
            this._overlayRef.detach();
            if (detach) {
                detach.emit();
            }
        }
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
            this._backdropSubscription = null;
        }
        if (this._escapeListener) {
            this._escapeListener();
            this._escapeListener = null;
        }
    };
    /**
     * @return {?}
     */
    Floater.prototype._destroyOverlay = function () {
        // console.log('[Floater] Destroy overlay');
        if (this._overlayRef) {
            this.overlayRef.dispose();
        }
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
        }
        if (this._positionSubscription) {
            this._positionSubscription.unsubscribe();
        }
        if (this._escapeListener) {
            this._escapeListener();
        }
        this._props.destroy();
    };
    /**
     * @return {?}
     */
    Floater.prototype._createOverlay = function () {
        this._overlayRef = this._overlay.create(this._buildConfig(), this._props.paneClass);
    };
    /**
     * @return {?}
     */
    Floater.prototype._buildConfig = function () {
        var /** @type {?} */ overlayConfig = new OverlayState();
        var _a = this._props, width = _a.width, height = _a.height, minWidth = _a.minWidth, minHeight = _a.minHeight, hasBackdrop = _a.hasBackdrop, backdropClass = _a.backdropClass;
        if (width || width === 0) {
            overlayConfig.width = width;
        }
        if (height || height === 0) {
            overlayConfig.height = height;
        }
        if (minWidth || minWidth === 0) {
            overlayConfig.minWidth = minWidth;
        }
        if (minHeight || minHeight === 0) {
            overlayConfig.minHeight = minHeight;
        }
        overlayConfig.hasBackdrop = hasBackdrop;
        if (backdropClass) {
            overlayConfig.backdropClass = backdropClass;
        }
        var /** @type {?} */ strategy = this._createPositionStrategy();
        if (strategy) {
            this._props.setPositionStrategy(strategy);
            overlayConfig.positionStrategy = strategy;
            // Use noop scroll strategy by default
            overlayConfig.scrollStrategy =
                this._props.scrollStrategy ? this._props.scrollStrategy : this._overlay.scrollStrategies.noop();
        }
        return overlayConfig;
    };
    /**
     * @return {?}
     */
    Floater.prototype._createPositionStrategy = function () {
        var _a = this._props, strategyType = _a.positionStrategyType, strategyOptions = _a.positionStrategyOptions;
        var /** @type {?} */ strategy = null;
        if (strategyType === 'connected') {
            var _b = (strategyOptions), positions = _b.positions, origin = _b.origin, offsetX = _b.offsetX, offsetY = _b.offsetY;
            var /** @type {?} */ pos = positions[0];
            var /** @type {?} */ originPoint = { originX: pos.originX, originY: pos.originY };
            var /** @type {?} */ overlayPoint = { overlayX: pos.overlayX, overlayY: pos.overlayY };
            var /** @type {?} */ elementRef = origin instanceof OverlayOrigin ? origin.elementRef : origin;
            strategy = this._overlay.position()
                .connectedTo(elementRef, originPoint, overlayPoint)
                .withOffsetX(offsetX || 0)
                .withOffsetY(offsetY || 0);
            this._handlePositionChanges(strategy);
            if (!this._props.scrollStrategy) {
                this._props.scrollStrategy = this._overlay.scrollStrategies.reposition();
            }
        }
        else if (strategyType === 'free') {
            strategy = this._overlay.position().free();
        }
        return strategy;
    };
    /**
     * @param {?} strategy
     * @return {?}
     */
    Floater.prototype._handlePositionChanges = function (strategy) {
        var _a = this._props, strategyOptions = _a.positionStrategyOptions, positionChange = _a.positionChange;
        var /** @type {?} */ positions = ((strategyOptions)).positions;
        for (var /** @type {?} */ i = 1; i < positions.length; i++) {
            strategy.withFallbackPosition({ originX: positions[i].originX, originY: positions[i].originY }, { overlayX: positions[i].overlayX, overlayY: positions[i].overlayY });
        }
        if (positionChange) {
            this._positionSubscription =
                strategy.onPositionChange.subscribe(function (pos) { return positionChange.emit(pos); });
        }
    };
    /**
     * @return {?}
     */
    Floater.prototype._isCreatedByComponent = function () {
        return this._contentPortal instanceof ComponentPortal;
    };
    /**
     * @param {?} componentRef
     * @return {?}
     */
    Floater.prototype._handleAttachedComponent = function (componentRef) {
        var /** @type {?} */ instance = componentRef.instance, /** @type {?} */ afterComponentCreated = this._props.afterComponentCreated;
        if (afterComponentCreated) {
            afterComponentCreated(instance);
        }
    };
    /**
     * @return {?}
     */
    Floater.prototype._initEscapeListener = function () {
        var _this = this;
        var /** @type {?} */ listener = function (event) {
            if (event.keyCode === ESCAPE) {
                _this._detachOverlay();
            }
        };
        if (this._renderer instanceof Renderer2) {
            this._escapeListener = this._renderer.listen('document', 'keydown', listener);
        }
        else if (this._renderer instanceof Document) {
            // console.log('[Floater/_initEscapeListener]use document', this._renderer);
            this._renderer.addEventListener('keydown', listener);
            this._escapeListener = function () {
                ((_this._renderer)).removeEventListener('keydown', listener);
            };
        }
    };
    return Floater;
}());
Injectable();
var FloaterService = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _document
     */
    function FloaterService(_overlay, _document) {
        this._overlay = _overlay;
        this._document = _document;
        // console.log('[FloaterService] constructed once.');
    }
    /**
     * @template T
     * @param {?} strategyType
     * @param {?} content
     * @param {?=} viewContainerRef
     * @param {?=} strategyOptions
     * @param {?=} options
     * @return {?}
     */
    FloaterService.prototype.create = function (strategyType, content, viewContainerRef, strategyOptions, options) {
        options = Object.assign(options || {}, {
            content: content,
            viewContainerRef: viewContainerRef,
            positionStrategyType: strategyType,
            positionStrategyOptions: strategyOptions
        });
        return new Floater(this._overlay, this._document, options);
    };
    /**
     * @template T
     * @param {?} content
     * @param {?=} viewContainerRef
     * @param {?=} strategyOptions
     * @param {?=} options
     * @return {?}
     */
    FloaterService.prototype.createConnected = function (content, viewContainerRef, strategyOptions, options) {
        return this.create('connected', content, viewContainerRef, strategyOptions, options);
    };
    /**
     * @template T
     * @param {?} content
     * @param {?=} viewContainerRef
     * @param {?=} strategyOptions
     * @param {?=} options
     * @return {?}
     */
    FloaterService.prototype.createFree = function (content, viewContainerRef, strategyOptions, options) {
        return this.create('free', content, viewContainerRef, strategyOptions, options);
    };
    /**
     * Persistently create/initialize a Component and append it's DOM to body(under overlay)
     * NOTE: the attaching operation is persistent, means that it is no methods to detach the component while attached (no relative resources can be released), SO take care of using it!
     * @template T
     * @param {?} component Component class
     * @param {?=} viewContainerRef Container reference that component will created and append to
     * @param {?=} injector Injector that will be used while creating component dynamically
     * @return {?} Instance of the component
     */
    FloaterService.prototype.persistAttachComponent = function (component, viewContainerRef, injector) {
        return this.createFree(component, viewContainerRef, null, {
            injector: injector,
            persist: true
        }).attach().getComponentInstance();
    };
    return FloaterService;
}());
/**
 * @nocollapse
 */
FloaterService.ctorParameters = function () { return [
    { type: Overlay, },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
]; };
/**
 * @param {?} overlay
 * @param {?} doc
 * @param {?} floaterService
 * @return {?}
 */
function FLOATER_SERVICE_PROVIDER_FACTORY(overlay, doc, floaterService) {
    return floaterService || new FloaterService(overlay, doc);
}
var FLOATER_SERVICE_PROVIDER = {
    provide: FloaterService,
    useFactory: FLOATER_SERVICE_PROVIDER_FACTORY,
    deps: [Overlay, DOCUMENT, [new Optional(), new SkipSelf(), FloaterService]]
};
var providers$1 = [
    FLOATER_SERVICE_PROVIDER
];
var FloaterModule = (function () {
    function FloaterModule() {
    }
    return FloaterModule;
}());
FloaterModule.decorators = [
    { type: NgModule, args: [{
                imports: [OverlayModule],
                providers: providers$1
            },] },
];
/**
 * @nocollapse
 */
FloaterModule.ctorParameters = function () { return []; };
var providers = [
    NZ_MESSAGE_DEFAULT_CONFIG_PROVIDER
];
var NzMessageModule = (function () {
    function NzMessageModule() {
    }
    return NzMessageModule;
}());
NzMessageModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FloaterModule],
                declarations: [NzMessageContainerComponent, NzMessageComponent],
                providers: providers,
                entryComponents: [NzMessageContainerComponent]
            },] },
];
/**
 * @nocollapse
 */
NzMessageModule.ctorParameters = function () { return []; };
var NzModalSubject = (function (_super) {
    tslib_1.__extends(NzModalSubject, _super);
    function NzModalSubject() {
        var _this = _super.call(this) || this;
        _this.eventsQueue = {};
        _this.subscribe(function (value) {
            var eventQueue = _this.eventsQueue[value] || [];
            eventQueue.forEach(function (cb) {
                if (cb) {
                    cb();
                }
            });
        });
        return _this;
    }
    /**
     * @param {?=} type
     * @return {?}
     */
    NzModalSubject.prototype.destroy = function (type) {
        if (type === void 0) { type = 'onCancel'; }
        if (!this.isStopped && !this.closed) {
            this.next(type);
        }
    };
    /**
     * @param {?} eventType
     * @param {?} cb
     * @return {?}
     */
    NzModalSubject.prototype.on = function (eventType, cb) {
        if (this.eventsQueue[eventType]) {
            this.eventsQueue[eventType].push(cb);
        }
        else {
            this.eventsQueue[eventType] = [cb];
        }
    };
    return NzModalSubject;
}(Subject$1));
NzModalSubject.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NzModalSubject.ctorParameters = function () { return []; };
var NzGlobalMonitorService = (function () {
    function NzGlobalMonitorService() {
        this.counter = 0;
        this.lastClickPos = {
            x: 0,
            y: 0
        };
        this._navItemSource = new EventEmitter();
        this._observeGlobalEvents();
    }
    /**
     * @return {?}
     */
    NzGlobalMonitorService.prototype.getGlobalCount = function () {
        return ++this.counter;
    };
    /**
     * @param {?} status
     * @return {?}
     */
    NzGlobalMonitorService.prototype.setDocumentOverflowHidden = function (status) {
        document.body.style.overflow = status ? 'hidden' : '';
    };
    ;
    /**
     * @return {?}
     */
    NzGlobalMonitorService.prototype._observeGlobalEvents = function () {
        var _this = this;
        // 监听document的点击事件，记录点击坐标，并抛出 documentClick 事件
        document.addEventListener('click', function (e) {
            _this.lastClickPos = {
                x: e.clientX,
                y: e.clientY
            };
            _this._navItemSource.emit('documentClick');
        });
    };
    return NzGlobalMonitorService;
}());
var nzGlobalMonitor = new NzGlobalMonitorService();
var NzModalComponent = (function () {
    /**
     * @param {?} subject
     * @param {?} _vcr
     */
    function NzModalComponent(subject, _vcr) {
        this.subject = subject;
        this._vcr = _vcr;
        this._prefixCls = 'ant-modal';
        this._visible = false;
        this._confirmLoading = false;
        this._closable = true;
        this._width = '520px';
        this._zIndex = 1000;
        this._maskClosable = true;
        this._title = '';
        this._content = '';
        this._okText = '确 定';
        this._cancelText = '取 消';
        this._style = {};
        this._wrapClass = this._prefixCls + "-wrap";
        this._customClass = '';
        this._animationStatus = '';
        this._componentParams = {};
        this._footerHide = false;
        this.modalId = "nzModal" + nzGlobalMonitor.getGlobalCount();
        this.nzVisibleChange = new EventEmitter();
        this.nzOnOk = new EventEmitter();
        this.nzOnCancel = new EventEmitter();
        this.subject.modalId = this.modalId;
    }
    Object.defineProperty(NzModalComponent.prototype, "nzVisible", {
        /**
         * @return {?}
         */
        get: function () {
            return this._visible;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var _this = this;
            // debugger
            if (this._visible === value) {
                return;
            }
            if (value) {
                this.anmiateFade('enter');
                this.subject.next('onShow');
                // 每次触发点击事件的时候，通过全局监听的类，记录下点击的位置，计算动画的origin
                setTimeout(function () {
                    _this.setStyles({
                        x: nzGlobalMonitor.lastClickPos.x || 0,
                        y: nzGlobalMonitor.lastClickPos.y || 0
                    });
                });
            }
            else {
                this.anmiateFade('leave');
                this.subject.next('onHide');
            }
            this._visible = value;
            this.nzVisibleChange.emit(this._visible);
            // 设置全局的overflow样式
            nzGlobalMonitor.setDocumentOverflowHidden(value);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzModalComponent.prototype, "nzConfirmLoading", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._confirmLoading = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzClosable", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._closable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzClass", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._customClass = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzWidth", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._width = typeof value === 'number' ? value + 'px' : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzZIndex", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._zIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzTitle", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value instanceof TemplateRef) {
                this._titleTpl = value;
            }
            else {
                this._title = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzContent", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value instanceof ComponentFactory) {
                // 如果容器对象已存在，则直接渲染，如果不存在，则设置到_bodyComponent，在ngAfterViewInit中执行
                if (this.bodyEl) {
                    var /** @type {?} */ compRef = this.bodyEl.createComponent(value, null, this._vcr.injector);
                    Object.assign(compRef.instance, this._componentParams);
                }
                else {
                    this._bodyComponent = value;
                }
            }
            else if (value instanceof TemplateRef) {
                this._contentTpl = value;
            }
            else {
                this._content = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzFooter", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value instanceof TemplateRef) {
                this._footerTpl = value;
            }
            else {
                this._footerHide = !value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzOkText", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._okText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzCancelText", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._cancelText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzMaskClosable", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._maskClosable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzStyle", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._style = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzWrapClassName", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._wrapClass = this._prefixCls + "-wrap " + value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzModalComponent.prototype, "nzComponentParams", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._componentParams = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} e
     * @return {?}
     */
    NzModalComponent.prototype.onEsc = function (e) {
        this.clickCancel(e);
    };
    /**
     * @param {?=} origin
     * @return {?}
     */
    NzModalComponent.prototype.setStyles = function (origin) {
        var /** @type {?} */ el = this.contentEl.nativeElement;
        var /** @type {?} */ transformOrigin = origin ? origin.x - el.offsetLeft + "px " + (origin.y - el.offsetTop) + "px 0px" : '';
        this._bodyStyleMap = Object.assign({
            'width': this._width,
            'transform-origin': transformOrigin
        }, this._style);
    };
    /**
     * @return {?}
     */
    NzModalComponent.prototype.setClassMap = function () {
        this._maskClassMap = (_a = {},
            _a[this._prefixCls + "-mask"] = true,
            _a[this._prefixCls + "-mask-hidden"] = !this._visible && !this._animationStatus,
            _a['fade-enter'] = this._animationStatus === 'enter',
            _a['fade-enter-active'] = this._animationStatus === 'enter',
            _a['fade-leave'] = this._animationStatus === 'leave',
            _a['fade-leave-active'] = this._animationStatus === 'leave',
            _a);
        this._bodyClassMap = (_b = {},
            _b[this._prefixCls] = true,
            _b['zoom-enter'] = this._animationStatus === 'enter',
            _b['zoom-enter-active'] = this._animationStatus === 'enter',
            _b['zoom-leave'] = this._animationStatus === 'leave',
            _b['zoom-leave-active'] = this._animationStatus === 'leave',
            _b);
        var _a, _b;
    };
    /**
     * @param {?} status
     * @return {?}
     */
    NzModalComponent.prototype.anmiateFade = function (status) {
        var _this = this;
        this._animationStatus = status;
        this.setClassMap();
        setTimeout(function (_) {
            _this._animationStatus = '';
            _this.setClassMap();
            _this.subject.next(status === 'enter' ? 'onShown' : 'onHidden');
            // modal打开后，默认焦点设置到modal上
            if (status === 'enter') {
                _this.contentEl.nativeElement.parentNode.focus();
            }
        }, 200);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzModalComponent.prototype.closeFromMask = function (e) {
        if (this._maskClosable && e.target.getAttribute('role') === 'dialog') {
            this.clickCancel(e);
        }
    };
    /**
     * @param {?} loading
     * @return {?}
     */
    NzModalComponent.prototype.setConfirmLoading = function (loading) {
        this.nzConfirmLoading = loading;
    };
    /**
     * @return {?}
     */
    NzModalComponent.prototype.open = function () {
        this.nzVisible = true;
    };
    /**
     * @return {?}
     */
    NzModalComponent.prototype.close = function () {
        this.nzVisible = false;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzModalComponent.prototype.clickOk = function (e) {
        if (this.nzOnOk) {
            this.nzOnOk.emit(e);
        }
        else {
            this.nzVisible = false;
        }
        this.subject.next('onOk');
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzModalComponent.prototype.clickCancel = function (e) {
        this.nzOnCancel.emit(e);
        this.subject.next('onCancel');
    };
    /**
     * @return {?}
     */
    NzModalComponent.prototype.ngOnInit = function () {
        this.setClassMap();
        this.setStyles();
    };
    /**
     * @return {?}
     */
    NzModalComponent.prototype.ngAfterViewInit = function () {
        if (this._bodyComponent) {
            var /** @type {?} */ compRef = this.bodyEl.createComponent(this._bodyComponent, null, this._vcr.injector);
            Object.assign(compRef.instance, this._componentParams);
        }
    };
    /**
     * @return {?}
     */
    NzModalComponent.prototype.ngOnDestroy = function () {
        if (this._visible) {
            nzGlobalMonitor.setDocumentOverflowHidden(false);
        }
        this.subject.next('onDestroy');
        this.subject.unsubscribe();
        this.subject = null;
    };
    return NzModalComponent;
}());
NzModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-modal',
                viewProviders: [NzModalSubject],
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div [ngClass]=\"_customClass\">\n      <div [ngClass]=\"_maskClassMap\"\n        [style.zIndex]=\"_zIndex\"></div>\n      <div tabindex=\"-1\" role=\"dialog\"\n        [attr.aria-labelledby]=\"modalId\"\n        (click)=\"closeFromMask($event)\"\n        [ngClass]=\"_wrapClass\"\n        [style.zIndex]=\"_zIndex\"\n        [ngStyle]=\"{ 'display': !_visible && !_animationStatus ? 'none' : '' }\">\n\n        <div #modal_content role=\"document\" [ngClass]=\"_bodyClassMap\" [ngStyle]=\"_bodyStyleMap\">\n          <div class=\"ant-modal-content\">\n            <ng-template [ngIf]=\"_closable\">\n              <button aria-label=\"Close\" class=\"ant-modal-close\" (click)=\"clickCancel($event)\">\n                <span class=\"ant-modal-close-x\"></span>\n              </button>\n            </ng-template>\n            <div class=\"ant-modal-header\" *ngIf=\"_title || _titleTpl\">\n              <div class=\"ant-modal-title\" [attr.id]=\"modalId\">\n                <ng-template #defaultTitle>{{ _title }}</ng-template>\n                <ng-template [ngTemplateOutlet]=\"_titleTpl || defaultTitle\"></ng-template>\n              </div>\n            </div>\n            <div class=\"ant-modal-body\">\n              <ng-template #defaultContent>{{ _content }}</ng-template>\n              <ng-template [ngTemplateOutlet]=\"_contentTpl || defaultContent\"></ng-template>\n              <ng-template #modal_component></ng-template>\n            </div>\n            <div class=\"ant-modal-footer\" *ngIf=\"!_footerHide\">\n              <ng-template #defaultFooter>\n                <button nz-button [nzType]=\"'ghost'\" [nzSize]=\"'large'\" (click)=\"clickCancel($event)\">\n                  <span>{{ _cancelText }}</span>\n                </button>\n                <button nz-button [nzType]=\"'primary'\" [nzSize]=\"'large'\" (click)=\"clickOk($event)\" [nzLoading]=\"_confirmLoading\">\n                  <span>{{ _okText }}</span>\n                </button>\n              </ng-template>\n              <ng-template [ngTemplateOutlet]=\"_footerTpl || defaultFooter\"></ng-template>\n            </div>\n          </div>\n        </div>\n        <div tabindex=\"0\" style=\"width: 0px; height: 0px; overflow: hidden;\">sentinel</div>\n      </div>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-modal {\n  position: relative;\n  width: auto;\n  margin: 0 auto;\n  top: 100px;\n  padding-bottom: 24px;\n}\n.ant-modal-wrap {\n  position: fixed;\n  overflow: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.ant-modal-title {\n  margin: 0;\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-modal-content {\n  position: relative;\n  background-color: #fff;\n  border: 0;\n  border-radius: 4px;\n  background-clip: padding-box;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n.ant-modal-close {\n  cursor: pointer;\n  border: 0;\n  background: transparent;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n  font-weight: 700;\n  line-height: 1;\n  text-decoration: none;\n  transition: color .3s ease;\n  color: rgba(0, 0, 0, 0.43);\n  outline: 0;\n}\n.ant-modal-close-x {\n  display: block;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n  font-size: 14px;\n}\n.ant-modal-close-x:before {\n  content: \"\\e633\";\n  display: block;\n  font-family: \"anticon\" !important;\n}\n.ant-modal-close:focus,\n.ant-modal-close:hover {\n  color: #444;\n  text-decoration: none;\n}\n.ant-modal-header {\n  padding: 13px 16px;\n  border-radius: 4px 4px 0 0;\n  background: #fff;\n  color: rgba(0, 0, 0, 0.65);\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-modal-body {\n  padding: 16px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.ant-modal-footer {\n  border-top: 1px solid #e9e9e9;\n  padding: 10px 16px 10px 10px;\n  text-align: right;\n  border-radius: 0 0 4px 4px;\n}\n.ant-modal-footer button + button {\n  margin-left: 8px;\n  margin-bottom: 0;\n}\n.ant-modal.zoom-enter,\n.ant-modal.zoom-appear {\n  animation-duration: 0.3s;\n  transform: none;\n  opacity: 0;\n}\n.ant-modal-mask {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: #373737;\n  background-color: rgba(55, 55, 55, 0.6);\n  height: 100%;\n  z-index: 1000;\n  filter: alpha(opacity=50);\n}\n.ant-modal-mask-hidden {\n  display: none;\n}\n.ant-modal-open {\n  overflow: hidden;\n}\n@media (max-width: 768px) {\n  .ant-modal {\n    width: auto !important;\n    margin: 10px;\n  }\n  .vertical-center-modal .ant-modal {\n    flex: 1;\n  }\n}\n.ant-confirm .ant-modal-header {\n  display: none;\n}\n.ant-confirm .ant-modal-close {\n  display: none;\n}\n.ant-confirm .ant-modal-body {\n  padding: 30px 40px;\n}\n.ant-confirm-body-wrapper {\n  zoom: 1;\n}\n.ant-confirm-body-wrapper:before,\n.ant-confirm-body-wrapper:after {\n  content: \" \";\n  display: table;\n}\n.ant-confirm-body-wrapper:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-confirm-body .ant-confirm-title {\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n  font-size: 14px;\n}\n.ant-confirm-body .ant-confirm-content {\n  margin-left: 42px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n  margin-top: 8px;\n}\n.ant-confirm-body > .anticon {\n  font-size: 24px;\n  margin-right: 16px;\n  padding: 0 1px;\n  float: left;\n}\n.ant-confirm .ant-confirm-btns {\n  margin-top: 30px;\n  float: right;\n}\n.ant-confirm .ant-confirm-btns button + button {\n  margin-left: 10px;\n  margin-bottom: 0;\n}\n.ant-confirm-error .ant-confirm-body > .anticon {\n  color: #f04134;\n}\n.ant-confirm-warning .ant-confirm-body > .anticon,\n.ant-confirm-confirm .ant-confirm-body > .anticon {\n  color: #ffbf00;\n}\n.ant-confirm-info .ant-confirm-body > .anticon {\n  color: #108ee9;\n}\n.ant-confirm-success .ant-confirm-body > .anticon {\n  color: #00a854;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzModalComponent.ctorParameters = function () { return [
    { type: NzModalSubject, },
    { type: ViewContainerRef, },
]; };
NzModalComponent.propDecorators = {
    'contentEl': [{ type: ViewChild, args: ['modal_content',] },],
    'bodyEl': [{ type: ViewChild, args: ['modal_component', { read: ViewContainerRef },] },],
    'nzVisible': [{ type: Input },],
    'nzConfirmLoading': [{ type: Input },],
    'nzClosable': [{ type: Input },],
    'nzClass': [{ type: Input },],
    'nzWidth': [{ type: Input },],
    'nzZIndex': [{ type: Input },],
    'nzTitle': [{ type: Input },],
    'nzContent': [{ type: Input },],
    'nzFooter': [{ type: Input },],
    'nzOkText': [{ type: Input },],
    'nzCancelText': [{ type: Input },],
    'nzMaskClosable': [{ type: Input },],
    'nzStyle': [{ type: Input },],
    'nzWrapClassName': [{ type: Input },],
    'nzComponentParams': [{ type: Input },],
    'nzVisibleChange': [{ type: Output },],
    'nzOnOk': [{ type: Output },],
    'nzOnCancel': [{ type: Output },],
    'onEsc': [{ type: HostListener, args: ['keydown.esc', ['$event'],] },],
};
var NzConfirmComponent = (function () {
    /**
     * @param {?} subject
     */
    function NzConfirmComponent(subject) {
        this.subject = subject;
        this._prefixCls = 'ant-modal';
        this._prefixConfirmCls = 'ant-confirm';
        this._visible = false;
        this._width = '416px';
        this._zIndex = 1000;
        this._iconTypeCls = 'anticon anticon-question-circle';
        this._title = '';
        this._content = '';
        this._maskClosable = true;
        this._okText = '知道了';
        this._cancelText = '';
        this._animationStatus = '';
        this._confirmLoading = false;
        this._customClass = '';
        this._typeCls = this._prefixConfirmCls + "-confirm";
    }
    Object.defineProperty(NzConfirmComponent.prototype, "nzVisible", {
        /**
         * @return {?}
         */
        get: function () {
            return this._visible;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var _this = this;
            if (this._visible === value) {
                return;
            }
            if (value) {
                this.anmiateFade('enter');
                this.subject.next('onShow');
                // 每次触发点击事件的时候，通过全局监听的类，记录下点击的位置，计算动画的origin
                setTimeout(function () {
                    _this.setStyles({
                        x: nzGlobalMonitor.lastClickPos.x || 0,
                        y: nzGlobalMonitor.lastClickPos.y || 0
                    });
                }, 10);
            }
            else {
                this.anmiateFade('leave');
                this.subject.next('onHide');
            }
            this._visible = value;
            // 设置全局的overflow样式
            nzGlobalMonitor.setDocumentOverflowHidden(value);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzConfirmComponent.prototype, "nzWidth", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._width = typeof value === 'number' ? value + 'px' : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzClass", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._customClass = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzZIndex", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._zIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzTitle", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value instanceof TemplateRef) {
                this._titleTpl = value;
            }
            else {
                this._title = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzContent", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value instanceof TemplateRef) {
                this._contentTpl = value;
            }
            else {
                this._content = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzMaskClosable", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._maskClosable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzOkText", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._okText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzCancelText", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._cancelText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzIconType", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._iconTypeCls = "anticon anticon-" + value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzConfirmType", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._typeCls = this._prefixConfirmCls + "-" + value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzConfirmComponent.prototype, "nzConfirmLoading", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._confirmLoading = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} e
     * @return {?}
     */
    NzConfirmComponent.prototype.onEsc = function (e) {
        this.subject.next('onCancel');
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzConfirmComponent.prototype.onEnter = function (e) {
        this.subject.next('onOk');
    };
    /**
     * @param {?=} origin
     * @return {?}
     */
    NzConfirmComponent.prototype.setStyles = function (origin) {
        var /** @type {?} */ el = this.contentEl.nativeElement;
        var /** @type {?} */ transformOrigin = origin ? origin.x - el.offsetLeft + "px " + (origin.y - el.offsetTop) + "px 0px" : '';
        this._bodyStyleMap = {
            'width': this._width,
            'transform-origin': transformOrigin
        };
    };
    /**
     * @return {?}
     */
    NzConfirmComponent.prototype.setClassMap = function () {
        this._maskClassMap = (_a = {},
            _a[this._prefixCls + "-mask"] = true,
            _a[this._prefixCls + "-mask-hidden"] = !this._visible && !this._animationStatus,
            _a['fade-enter'] = this._animationStatus === 'enter',
            _a['fade-enter-active'] = this._animationStatus === 'enter',
            _a['fade-leave'] = this._animationStatus === 'leave',
            _a['fade-leave-active'] = this._animationStatus === 'leave',
            _a);
        this._bodyClassMap = (_b = {},
            _b[this._prefixCls] = true,
            _b[this._prefixConfirmCls] = true,
            _b[this._typeCls] = true,
            _b['zoom-enter'] = this._animationStatus === 'enter',
            _b['zoom-enter-active'] = this._animationStatus === 'enter',
            _b['zoom-leave'] = this._animationStatus === 'leave',
            _b['zoom-leave-active'] = this._animationStatus === 'leave',
            _b);
        var _a, _b;
    };
    /**
     * @param {?} status
     * @return {?}
     */
    NzConfirmComponent.prototype.anmiateFade = function (status) {
        var _this = this;
        this._animationStatus = status;
        this.setClassMap();
        setTimeout(function (_) {
            _this._animationStatus = '';
            _this.setClassMap();
            _this.subject.next(status === 'enter' ? 'onShown' : 'onHidden');
            // modal打开后，默认焦点设置到modal上
            if (status === 'enter') {
                _this.contentEl.nativeElement.parentNode.focus();
            }
        }, 200);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzConfirmComponent.prototype.closeFromMask = function (e) {
        if (this._maskClosable && e.target.getAttribute('role') === 'dialog') {
            this.subject.next('onCancel');
        }
    };
    /**
     * @return {?}
     */
    NzConfirmComponent.prototype.ngOnInit = function () {
        this.setClassMap();
        this.setStyles();
    };
    /**
     * @return {?}
     */
    NzConfirmComponent.prototype.ngOnDestroy = function () {
        if (this._visible) {
            nzGlobalMonitor.setDocumentOverflowHidden(false);
        }
        this.subject.next('onDestroy');
        this.subject.unsubscribe();
        this.subject = null;
    };
    return NzConfirmComponent;
}());
NzConfirmComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-confirm',
                viewProviders: [NzModalSubject],
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div [ngClass]=\"_customClass\">\n      <div [ngClass]=\"_maskClassMap\"\n        [style.zIndex]=\"_zIndex\"></div>\n      <div tabindex=\"-1\" role=\"dialog\"\n        (click)=\"closeFromMask($event)\"\n        class=\"ant-modal-wrap\"\n        [style.zIndex]=\"_zIndex\"\n        [ngStyle]=\"{ 'display': !_visible && !_animationStatus ? 'none' : 'block' }\">\n\n        <div #confirm_content role=\"document\" [ngClass]=\"_bodyClassMap\" [ngStyle]=\"_bodyStyleMap\">\n          <div class=\"ant-modal-content\">\n            <div class=\"ant-modal-body\">\n              <div style=\"zoom: 1; overflow: hidden;\">\n                <div class=\"ant-confirm-body\">\n                  <i [ngClass]=\"_iconTypeCls\"></i>\n                  <span class=\"ant-confirm-title\">\n                    <ng-template #defaultTitle>{{ _title }}</ng-template>\n                    <ng-template [ngTemplateOutlet]=\"_titleTpl || defaultTitle\"></ng-template>\n                  </span>\n                  <div class=\"ant-confirm-content\">\n                    <ng-template #defaultContent>\n                      <div [innerHTML]=\"_content\"></div>\n                    </ng-template>\n                    <ng-template [ngTemplateOutlet]=\"_contentTpl || defaultContent\"></ng-template>\n                  </div>\n                </div>\n                <div class=\"ant-confirm-btns\">\n                  <ng-template [ngIf]=\"_cancelText\">\n                    <button nz-button [nzType]=\"'ghost'\" [nzSize]=\"'large'\" (click)=\"subject.next('onCancel')\">\n                      <span>{{ _cancelText }}</span>\n                    </button>\n                  </ng-template>\n                  <button nz-button #confirm_ok_btn [nzType]=\"'primary'\" [nzSize]=\"'large'\" [nzSize]=\"'large'\" (click)=\"subject.next('onOk')\" [nzLoading]=\"_confirmLoading\">\n                    <span>{{ _okText }}</span>\n                  </button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div tabindex=\"0\" style=\"width: 0px; height: 0px; overflow: hidden;\">sentinel</div>\n      </div>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-modal {\n  position: relative;\n  width: auto;\n  margin: 0 auto;\n  top: 100px;\n  padding-bottom: 24px;\n}\n.ant-modal-wrap {\n  position: fixed;\n  overflow: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.ant-modal-title {\n  margin: 0;\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-modal-content {\n  position: relative;\n  background-color: #fff;\n  border: 0;\n  border-radius: 4px;\n  background-clip: padding-box;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n.ant-modal-close {\n  cursor: pointer;\n  border: 0;\n  background: transparent;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n  font-weight: 700;\n  line-height: 1;\n  text-decoration: none;\n  transition: color .3s ease;\n  color: rgba(0, 0, 0, 0.43);\n  outline: 0;\n}\n.ant-modal-close-x {\n  display: block;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n  font-size: 14px;\n}\n.ant-modal-close-x:before {\n  content: \"\\e633\";\n  display: block;\n  font-family: \"anticon\" !important;\n}\n.ant-modal-close:focus,\n.ant-modal-close:hover {\n  color: #444;\n  text-decoration: none;\n}\n.ant-modal-header {\n  padding: 13px 16px;\n  border-radius: 4px 4px 0 0;\n  background: #fff;\n  color: rgba(0, 0, 0, 0.65);\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-modal-body {\n  padding: 16px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.ant-modal-footer {\n  border-top: 1px solid #e9e9e9;\n  padding: 10px 16px 10px 10px;\n  text-align: right;\n  border-radius: 0 0 4px 4px;\n}\n.ant-modal-footer button + button {\n  margin-left: 8px;\n  margin-bottom: 0;\n}\n.ant-modal.zoom-enter,\n.ant-modal.zoom-appear {\n  animation-duration: 0.3s;\n  transform: none;\n  opacity: 0;\n}\n.ant-modal-mask {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: #373737;\n  background-color: rgba(55, 55, 55, 0.6);\n  height: 100%;\n  z-index: 1000;\n  filter: alpha(opacity=50);\n}\n.ant-modal-mask-hidden {\n  display: none;\n}\n.ant-modal-open {\n  overflow: hidden;\n}\n@media (max-width: 768px) {\n  .ant-modal {\n    width: auto !important;\n    margin: 10px;\n  }\n  .vertical-center-modal .ant-modal {\n    flex: 1;\n  }\n}\n.ant-confirm .ant-modal-header {\n  display: none;\n}\n.ant-confirm .ant-modal-close {\n  display: none;\n}\n.ant-confirm .ant-modal-body {\n  padding: 30px 40px;\n}\n.ant-confirm-body-wrapper {\n  zoom: 1;\n}\n.ant-confirm-body-wrapper:before,\n.ant-confirm-body-wrapper:after {\n  content: \" \";\n  display: table;\n}\n.ant-confirm-body-wrapper:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-confirm-body .ant-confirm-title {\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n  font-size: 14px;\n}\n.ant-confirm-body .ant-confirm-content {\n  margin-left: 42px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n  margin-top: 8px;\n}\n.ant-confirm-body > .anticon {\n  font-size: 24px;\n  margin-right: 16px;\n  padding: 0 1px;\n  float: left;\n}\n.ant-confirm .ant-confirm-btns {\n  margin-top: 30px;\n  float: right;\n}\n.ant-confirm .ant-confirm-btns button + button {\n  margin-left: 10px;\n  margin-bottom: 0;\n}\n.ant-confirm-error .ant-confirm-body > .anticon {\n  color: #f04134;\n}\n.ant-confirm-warning .ant-confirm-body > .anticon,\n.ant-confirm-confirm .ant-confirm-body > .anticon {\n  color: #ffbf00;\n}\n.ant-confirm-info .ant-confirm-body > .anticon {\n  color: #108ee9;\n}\n.ant-confirm-success .ant-confirm-body > .anticon {\n  color: #00a854;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzConfirmComponent.ctorParameters = function () { return [
    { type: NzModalSubject, },
]; };
NzConfirmComponent.propDecorators = {
    'contentEl': [{ type: ViewChild, args: ['confirm_content',] },],
    'nzVisible': [{ type: Input },],
    'nzWidth': [{ type: Input },],
    'nzClass': [{ type: Input },],
    'nzZIndex': [{ type: Input },],
    'nzTitle': [{ type: Input },],
    'nzContent': [{ type: Input },],
    'nzMaskClosable': [{ type: Input },],
    'nzOkText': [{ type: Input },],
    'nzCancelText': [{ type: Input },],
    'nzIconType': [{ type: Input },],
    'nzConfirmType': [{ type: Input },],
    'nzConfirmLoading': [{ type: Input },],
    'onEsc': [{ type: HostListener, args: ['keydown.esc', ['$event'],] },],
    'onEnter': [{ type: HostListener, args: ['keydown.enter', ['$event'],] },],
};
var BaseOptions = (function () {
    function BaseOptions() {
        /**
         * The modal display status
         */
        this.visible = false;
    }
    return BaseOptions;
}());
var ModalOptions = (function (_super) {
    tslib_1.__extends(ModalOptions, _super);
    function ModalOptions() {
        var _this = _super.apply(this, arguments) || this;
        _this.closable = true;
        _this.maskClosable = true;
        return _this;
    }
    return ModalOptions;
}(BaseOptions));
ModalOptions.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ModalOptions.ctorParameters = function () { return []; };
var ConfirmOptions = (function (_super) {
    tslib_1.__extends(ConfirmOptions, _super);
    function ConfirmOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConfirmOptions;
}(BaseOptions));
ConfirmOptions.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ConfirmOptions.ctorParameters = function () { return []; };
var NzModalService = (function () {
    /**
     * @param {?} _appRef
     * @param {?} _cfr
     */
    function NzModalService(_appRef, _cfr) {
        this._appRef = _appRef;
        this._cfr = _cfr;
        this._modalCompFactory = this._cfr.resolveComponentFactory(NzModalComponent);
        this._confirmCompFactory = this._cfr.resolveComponentFactory(NzConfirmComponent);
    }
    /**
     * @param {?} config
     * @param {?=} options
     * @return {?}
     */
    NzModalService.prototype._initConfig = function (config, options) {
        if (options === void 0) { options = {}; }
        var /** @type {?} */ props = {};
        var /** @type {?} */ optionalParams = [
            'componentParams',
            'visible',
            'title',
            'content',
            'footer',
            'width',
            'zIndex',
            'okText',
            'cancelText',
            'style',
            'class',
            'onOk',
            'onCancel',
            'closable',
            'maskClosable',
            'wrapClassName',
            'iconType',
            'confirmType',
            'moduleWithComponentFactories'
        ];
        config = Object.assign(options, config);
        optionalParams.forEach(function (key) {
            if (config[key] !== undefined) {
                var /** @type {?} */ modalKey = 'nz' + key.replace(/^\w{1}/, function (a) {
                    return a.toLocaleUpperCase();
                });
                props[modalKey] = config[key];
            }
        });
        var /** @type {?} */ isShowConfirmLoading = !!config['showConfirmLoading'];
        props['onOk'] = this._getConfirmCb(props['nzOnOk'], isShowConfirmLoading);
        props['onCancel'] = this._getConfirmCb(props['nzOnCancel']);
        // 在service模式下，不需要nzOnOk，防止触发this.nzOnOk.emit(e);
        delete props['nzOnOk'];
        delete props['nzOnCancel'];
        return props;
    };
    /**
     * @param {?=} fn
     * @param {?=} isShowConfirmLoading
     * @return {?}
     */
    NzModalService.prototype._getConfirmCb = function (fn, isShowConfirmLoading) {
        if (isShowConfirmLoading === void 0) { isShowConfirmLoading = false; }
        return function (_close, _instance) {
            if (isShowConfirmLoading) {
                _instance.nzConfirmLoading = true;
            }
            if (fn) {
                var /** @type {?} */ ret = fn();
                if (!ret) {
                    _close();
                }
                else if (ret.then) {
                    ret.then(_close);
                }
            }
            else {
                _close();
            }
        };
    };
    /**
     * @param {?} props
     * @param {?} factory
     * @return {?}
     */
    NzModalService.prototype._open = function (props, factory) {
        // 在body的内部最前插入一个<nz-modal></nz-modal>方便进行ApplicationRef.bootstrap
        document.body.insertBefore(document.createElement(factory.selector), document.body.firstChild);
        // document.body.appendChild(document.createElement(factory.selector));
        var /** @type {?} */ customComponentFactory;
        var /** @type {?} */ compRef;
        var /** @type {?} */ instance;
        var /** @type {?} */ subject;
        if (props['nzContent'] instanceof Type) {
            customComponentFactory = this._cfr.resolveComponentFactory(props['nzContent']);
            // 将编译出来的ngmodule中的用户component的factory作为modal内容存入
            props['nzContent'] = customComponentFactory;
        }
        compRef = this._appRef.bootstrap(factory);
        instance = compRef.instance;
        subject = instance.subject;
        ['onOk', 'onCancel'].forEach(function (eventType) {
            subject.on(eventType, function () {
                var /** @type {?} */ eventHandler = props[eventType];
                if (eventHandler) {
                    eventHandler(function () {
                        instance.nzVisible = false;
                        setTimeout(function () {
                            compRef.destroy();
                        }, 200);
                    }, instance);
                }
            });
        });
        Object.assign(instance, props, {
            nzVisible: true
        });
        return subject;
    };
    /**
     * Open modal dialog
     * @param {?} config
     * @return {?}
     */
    NzModalService.prototype.open = function (config) {
        var /** @type {?} */ options = new ModalOptions();
        var /** @type {?} */ props = this._initConfig(config, options);
        return this._open(props, this._modalCompFactory);
    };
    /**
     * Open confirm dialog
     * @param {?} config
     * @return {?}
     */
    NzModalService.prototype._openConfirm = function (config) {
        var /** @type {?} */ options = new ConfirmOptions();
        var /** @type {?} */ props = this._initConfig(config, options);
        return this._open(props, this._confirmCompFactory);
    };
    /**
     * Open info dialog
     * @param {?} props
     * @return {?}
     */
    NzModalService.prototype.info = function (props) {
        var /** @type {?} */ config = Object.assign({}, {
            confirmType: 'info',
            iconType: 'info-circle'
        }, props);
        return this._openConfirm(config);
    };
    /**
     * Open success dialog
     * @param {?} props
     * @return {?}
     */
    NzModalService.prototype.success = function (props) {
        var /** @type {?} */ config = Object.assign({
            confirmType: 'success',
            iconType: 'check-circle'
        }, props);
        return this._openConfirm(config);
    };
    /**
     * Open error dialog
     * @param {?} props
     * @return {?}
     */
    NzModalService.prototype.error = function (props) {
        var /** @type {?} */ config = Object.assign({
            confirmType: 'error',
            iconType: 'cross-circle'
        }, props);
        return this._openConfirm(config);
    };
    /**
     * Open warning dialog
     * @param {?} props
     * @return {?}
     */
    NzModalService.prototype.warning = function (props) {
        var /** @type {?} */ config = Object.assign({
            confirmType: 'warning',
            iconType: 'exclamation-circle'
        }, props);
        return this._openConfirm(config);
    };
    /**
     * Open confirm dialog
     * @param {?} props
     * @return {?}
     */
    NzModalService.prototype.confirm = function (props) {
        var /** @type {?} */ config = Object.assign({
            confirmType: 'confirm',
            okText: '确 定',
            cancelText: '取 消'
        }, props);
        return this._openConfirm(config);
    };
    return NzModalService;
}());
NzModalService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NzModalService.ctorParameters = function () { return [
    { type: ApplicationRef, },
    { type: ComponentFactoryResolver, },
]; };
var NzModalModule = (function () {
    function NzModalModule() {
    }
    return NzModalModule;
}());
NzModalModule.decorators = [
    { type: NgModule, args: [{
                entryComponents: [NzModalComponent, NzConfirmComponent],
                providers: [NzModalSubject, NzModalService],
                declarations: [NzModalComponent, NzConfirmComponent],
                exports: [NzModalComponent, NzConfirmComponent],
                imports: [CommonModule, NzButtonModule]
            },] },
];
/**
 * @nocollapse
 */
NzModalModule.ctorParameters = function () { return []; };
var NzNotificationConfig = (function (_super) {
    tslib_1.__extends(NzNotificationConfig, _super);
    function NzNotificationConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NzNotificationConfig;
}(NzMessageConfig));
var NZ_NOTIFICATION_DEFAULT_CONFIG = new InjectionToken('NZ_NOTIFICATION_DEFAULT_CONFIG');
var NZ_NOTIFICATION_CONFIG = new InjectionToken('NZ_NOTIFICATION_CONFIG');
var NZ_NOTIFICATION_DEFAULT_CONFIG_PROVIDER = {
    provide: NZ_NOTIFICATION_DEFAULT_CONFIG,
    useValue: {
        nzTop: '24px',
        nzRight: '0px',
        nzDuration: 4500,
        nzMaxStack: 7,
        nzPauseOnHover: true,
        nzAnimate: true
    }
};
var NzNotificationContainerComponent = (function (_super) {
    tslib_1.__extends(NzNotificationContainerComponent, _super);
    /**
     * @param {?} defaultConfig
     * @param {?} config
     */
    function NzNotificationContainerComponent(defaultConfig, config) {
        return _super.call(this, defaultConfig, config) || this;
    }
    return NzNotificationContainerComponent;
}(NzMessageContainerComponent));
NzNotificationContainerComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-notification-container',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"ant-notification\" [style.top]=\"config.nzTop\" [style.right]=\"config.nzRight\">\n      <nz-notification *ngFor=\"let message of messages; let i = index\" [nzMessage]=\"message\" [nzIndex]=\"i\"></nz-notification>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-notification {\n  position: fixed;\n  z-index: 1010;\n  width: 335px;\n  margin-right: 24px;\n}\n.ant-notification-topLeft,\n.ant-notification-bottomLeft {\n  margin-left: 24px;\n  margin-right: 0;\n}\n.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,\n.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationLeftFadeIn;\n}\n.ant-notification-notice {\n  padding: 16px;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  background: #fff;\n  line-height: 1.5;\n  position: relative;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n.ant-notification-notice-message {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.85);\n  margin-bottom: 4px;\n  line-height: 20px;\n  display: inline-block;\n}\n.ant-notification-notice-message-single-line-auto-margin {\n  width: calc(335px - 16px * 2 - 24px - 48px - 100%);\n  background-color: transparent;\n  pointer-events: none;\n  display: block;\n  max-width: 4px;\n}\n.ant-notification-notice-message-single-line-auto-margin:before {\n  content: '';\n  display: block;\n  padding-bottom: 100%;\n}\n.ant-notification-notice-description {\n  font-size: 12px;\n}\n.ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 24px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-message {\n  font-size: 14px;\n  margin-left: 48px;\n  margin-bottom: 4px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-left: 48px;\n  font-size: 12px;\n}\n.ant-notification-notice-icon {\n  position: absolute;\n  font-size: 32px;\n  line-height: 32px;\n}\n.ant-notification-notice-icon-success {\n  color: #00a854;\n}\n.ant-notification-notice-icon-info {\n  color: #108ee9;\n}\n.ant-notification-notice-icon-warning {\n  color: #ffbf00;\n}\n.ant-notification-notice-icon-error {\n  color: #f04134;\n}\n.ant-notification-notice-close-x:after {\n  font-size: 12px;\n  content: \"\\e633\";\n  font-family: \"anticon\";\n  cursor: pointer;\n}\n.ant-notification-notice-close {\n  position: absolute;\n  right: 16px;\n  top: 10px;\n  color: rgba(0, 0, 0, 0.43);\n  outline: none;\n  text-decoration: none;\n}\n.ant-notification-notice-close:hover {\n  color: #404040;\n}\n.ant-notification-notice-btn {\n  float: right;\n  margin-top: 16px;\n}\n.ant-notification .notification-fade-effect {\n  animation-duration: 0.24s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-notification-fade-enter,\n.ant-notification-fade-appear {\n  opacity: 0;\n  animation-duration: 0.24s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-play-state: paused;\n}\n.ant-notification-fade-leave {\n  animation-duration: 0.24s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-duration: 0.2s;\n  animation-play-state: paused;\n}\n.ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationFadeIn;\n  animation-play-state: running;\n}\n.ant-notification-fade-leave.ant-notification-fade-leave-active {\n  animation-name: NotificationFadeOut;\n  animation-play-state: running;\n}\n@keyframes NotificationFadeIn {\n  0% {\n    opacity: 0;\n    left: 335px;\n  }\n  100% {\n    left: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationLeftFadeIn {\n  0% {\n    opacity: 0;\n    right: 335px;\n  }\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationFadeOut {\n  0% {\n    opacity: 1;\n    margin-bottom: 10px;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    max-height: 150px;\n  }\n  100% {\n    opacity: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    max-height: 0;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzNotificationContainerComponent.ctorParameters = function () { return [
    { type: NzNotificationConfig, decorators: [{ type: Optional }, { type: Inject, args: [NZ_NOTIFICATION_DEFAULT_CONFIG,] },] },
    { type: NzNotificationConfig, decorators: [{ type: Optional }, { type: Inject, args: [NZ_NOTIFICATION_CONFIG,] },] },
]; };
var NzNotificationComponent = (function (_super) {
    tslib_1.__extends(NzNotificationComponent, _super);
    /**
     * @param {?} container
     */
    function NzNotificationComponent(container) {
        return _super.call(this, container) || this;
    }
    /**
     * @return {?}
     */
    NzNotificationComponent.prototype.onClickClose = function () {
        this._destroy();
    };
    return NzNotificationComponent;
}(NzMessageComponent));
NzNotificationComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-notification',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('enterLeave', [
                        state('enter', style({ opacity: 1, transform: 'translateX(0)' })),
                        transition('* => enter', [
                            style({ opacity: 0, transform: 'translateX(5%)' }),
                            animate('100ms linear')
                        ]),
                        state('leave', style({ opacity: 0, transform: 'translateY(-10%)' })),
                        transition('* => leave', [
                            style({ opacity: 1, transform: 'translateY(0)' }),
                            animate('100ms linear')
                        ]),
                    ])
                ],
                template: "\n    <div class=\"ant-notification-notice ant-notification-notice-closable\"\n      [@enterLeave]=\"nzMessage.state\"\n      (mouseenter)=\"onEnter()\"\n      (mouseleave)=\"onLeave()\">\n      <div *ngIf=\"!nzMessage.html\" class=\"ant-notification-notice-content\">\n        <div class=\"ant-notification-notice-content\" [ngClass]=\"{ 'ant-notification-notice-with-icon': nzMessage.type !== 'blank' }\">\n          <ng-container [ngSwitch]=\"nzMessage.type\">\n            <i *ngSwitchCase=\"'success'\" class=\"ant-notification-notice-icon ant-notification-notice-icon-success anticon anticon-check-circle-o\"></i>\n            <i *ngSwitchCase=\"'info'\" class=\"ant-notification-notice-icon ant-notification-notice-icon-info anticon anticon-info-circle-o\"></i>\n            <i *ngSwitchCase=\"'warning'\" class=\"ant-notification-notice-icon ant-notification-notice-icon-warning anticon anticon-exclamation-circle-o\"></i>\n            <i *ngSwitchCase=\"'error'\" class=\"ant-notification-notice-icon ant-notification-notice-icon-error anticon anticon-cross-circle-o\"></i>\n          </ng-container>\n          <div class=\"ant-notification-notice-message\">{{nzMessage.title}}</div>\n          <div class=\"ant-notification-notice-description\">{{nzMessage.content}}</div>\n        </div>\n      </div>\n      <div *ngIf=\"nzMessage.html\" [innerHTML]=\"nzMessage.html\"></div>\n      <a tabindex=\"0\" class=\"ant-notification-notice-close\" (click)=\"onClickClose()\">\n        <span class=\"ant-notification-notice-close-x\"></span>\n      </a>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-notification {\n  position: fixed;\n  z-index: 1010;\n  width: 335px;\n  margin-right: 24px;\n}\n.ant-notification-topLeft,\n.ant-notification-bottomLeft {\n  margin-left: 24px;\n  margin-right: 0;\n}\n.ant-notification-topLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-bottomLeft .ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-topLeft .ant-notification-fade-appear.ant-notification-fade-appear-active,\n.ant-notification-bottomLeft .ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationLeftFadeIn;\n}\n.ant-notification-notice {\n  padding: 16px;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  background: #fff;\n  line-height: 1.5;\n  position: relative;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n.ant-notification-notice-message {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.85);\n  margin-bottom: 4px;\n  line-height: 20px;\n  display: inline-block;\n}\n.ant-notification-notice-message-single-line-auto-margin {\n  width: calc(335px - 16px * 2 - 24px - 48px - 100%);\n  background-color: transparent;\n  pointer-events: none;\n  display: block;\n  max-width: 4px;\n}\n.ant-notification-notice-message-single-line-auto-margin:before {\n  content: '';\n  display: block;\n  padding-bottom: 100%;\n}\n.ant-notification-notice-description {\n  font-size: 12px;\n}\n.ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 24px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-message {\n  font-size: 14px;\n  margin-left: 48px;\n  margin-bottom: 4px;\n}\n.ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-left: 48px;\n  font-size: 12px;\n}\n.ant-notification-notice-icon {\n  position: absolute;\n  font-size: 32px;\n  line-height: 32px;\n}\n.ant-notification-notice-icon-success {\n  color: #00a854;\n}\n.ant-notification-notice-icon-info {\n  color: #108ee9;\n}\n.ant-notification-notice-icon-warning {\n  color: #ffbf00;\n}\n.ant-notification-notice-icon-error {\n  color: #f04134;\n}\n.ant-notification-notice-close-x:after {\n  font-size: 12px;\n  content: \"\\e633\";\n  font-family: \"anticon\";\n  cursor: pointer;\n}\n.ant-notification-notice-close {\n  position: absolute;\n  right: 16px;\n  top: 10px;\n  color: rgba(0, 0, 0, 0.43);\n  outline: none;\n  text-decoration: none;\n}\n.ant-notification-notice-close:hover {\n  color: #404040;\n}\n.ant-notification-notice-btn {\n  float: right;\n  margin-top: 16px;\n}\n.ant-notification .notification-fade-effect {\n  animation-duration: 0.24s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-notification-fade-enter,\n.ant-notification-fade-appear {\n  opacity: 0;\n  animation-duration: 0.24s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-play-state: paused;\n}\n.ant-notification-fade-leave {\n  animation-duration: 0.24s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  animation-duration: 0.2s;\n  animation-play-state: paused;\n}\n.ant-notification-fade-enter.ant-notification-fade-enter-active,\n.ant-notification-fade-appear.ant-notification-fade-appear-active {\n  animation-name: NotificationFadeIn;\n  animation-play-state: running;\n}\n.ant-notification-fade-leave.ant-notification-fade-leave-active {\n  animation-name: NotificationFadeOut;\n  animation-play-state: running;\n}\n@keyframes NotificationFadeIn {\n  0% {\n    opacity: 0;\n    left: 335px;\n  }\n  100% {\n    left: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationLeftFadeIn {\n  0% {\n    opacity: 0;\n    right: 335px;\n  }\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n}\n@keyframes NotificationFadeOut {\n  0% {\n    opacity: 1;\n    margin-bottom: 10px;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    max-height: 150px;\n  }\n  100% {\n    opacity: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    max-height: 0;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzNotificationComponent.ctorParameters = function () { return [
    { type: NzNotificationContainerComponent, },
]; };
var providers$2 = [
    NZ_NOTIFICATION_DEFAULT_CONFIG_PROVIDER
];
var NzNotificationModule = (function () {
    function NzNotificationModule() {
    }
    return NzNotificationModule;
}());
NzNotificationModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FloaterModule],
                declarations: [NzNotificationComponent, NzNotificationContainerComponent],
                providers: providers$2,
                entryComponents: [NzNotificationContainerComponent],
            },] },
];
/**
 * @nocollapse
 */
NzNotificationModule.ctorParameters = function () { return []; };
var NzPaginationComponent = (function () {
    /**
     * @param {?} _elementRef
     */
    function NzPaginationComponent(_elementRef) {
        this._elementRef = _elementRef;
        this._current = 1;
        this._pageSize = 10;
        this._firstIndex = 1;
        this._lastIndex = Infinity;
        this._pages = [];
        this._options = [10, 20, 30, 40, 50];
        this._showSizeChanger = false;
        this._showQuickJumper = false;
        this._showTotal = false;
        this._simple = false;
        this.nzPageSizeChange = new EventEmitter();
        this.nzPageIndexChange = new EventEmitter();
        this.nzPageIndexClickChange = new EventEmitter();
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzPaginationComponent.prototype, "nzShowSizeChanger", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showSizeChanger;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._showSizeChanger = true;
            }
            else {
                this._showSizeChanger = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzPaginationComponent.prototype, "nzShowQuickJumper", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showQuickJumper;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._showQuickJumper = true;
            }
            else {
                this._showQuickJumper = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzPaginationComponent.prototype, "nzShowTotal", {
        /**
         * @return {?}
         */
        get: function () {
            return this._showTotal;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._showTotal = true;
            }
            else {
                this._showTotal = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzPaginationComponent.prototype, "nzSimple", {
        /**
         * @return {?}
         */
        get: function () {
            return this._simple;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._simple = true;
            }
            else {
                this._simple = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} pageSize
     * @return {?}
     */
    NzPaginationComponent.prototype._jumpBefore = function (pageSize) {
        this._jumpPage(this._current - Math.round(pageSize / 2));
    };
    /**
     * @param {?} pageSize
     * @return {?}
     */
    NzPaginationComponent.prototype._jumpAfter = function (pageSize) {
        this._jumpPage(this._current + Math.round(pageSize / 2));
    };
    Object.defineProperty(NzPaginationComponent.prototype, "nzPageIndex", {
        /**
         * @return {?}
         */
        get: function () {
            return this._current;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._current === value) {
                return;
            }
            if (value > this._lastIndex || value < this._firstIndex) {
                return;
            }
            this._current = Number(value);
            this._buildIndexes();
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Object.defineProperty(NzPaginationComponent.prototype, "nzPageSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._pageSize;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === this._pageSize) {
                return;
            }
            this._pageSize = value;
            this.nzPageIndexChange.emit(this.nzPageIndex);
            this._buildIndexes();
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Object.defineProperty(NzPaginationComponent.prototype, "nzTotal", {
        /**
         * @return {?}
         */
        get: function () {
            return this._total;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === this._total) {
                return;
            }
            this._total = value;
            this._buildIndexes();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?} $event
     * @return {?}
     */
    NzPaginationComponent.prototype._pageSizeChange = function ($event) {
        this.nzPageSize = $event;
        this.nzPageSizeChange.emit($event);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzPaginationComponent.prototype._nzPageIndexChange = function ($event) {
        this.nzPageIndex = $event;
        this.nzPageIndexChange.emit(this.nzPageIndex);
    };
    /**
     * generate indexes list
     * @return {?}
     */
    NzPaginationComponent.prototype._buildIndexes = function () {
        this._lastIndex = Math.ceil(this._total / this._pageSize);
        if (this._current > this._lastIndex) {
            this._jumpPage(this._lastIndex);
        }
        var /** @type {?} */ tmpPages = [];
        if (this._lastIndex <= 9) {
            for (var /** @type {?} */ i = 2; i <= this._lastIndex - 1; i++) {
                tmpPages.push({ index: i });
            }
        }
        else {
            var /** @type {?} */ current = +this._current;
            var /** @type {?} */ left = Math.max(2, current - 2);
            var /** @type {?} */ right = Math.min(current + 2, this._lastIndex - 1);
            if (current - 1 <= 2) {
                right = 5;
            }
            if (this._lastIndex - current <= 2) {
                left = this._lastIndex - 4;
            }
            for (var /** @type {?} */ i = left; i <= right; i++) {
                tmpPages.push({ index: i });
            }
        }
        this._pages = tmpPages;
    };
    /**
     * @param {?} index
     * @return {?}
     */
    NzPaginationComponent.prototype._jumpPage = function (index) {
        if (index === this._firstIndex - 1 || index === this._lastIndex + 1 || index === this.nzPageIndex) {
            return;
        }
        if (index < this._firstIndex) {
            this.nzPageIndex = this._firstIndex;
        }
        else if (index > this._lastIndex) {
            this.nzPageIndex = this._lastIndex;
        }
        else {
            this.nzPageIndex = index;
        }
        this.nzPageIndexClickChange.emit(this.nzPageIndex);
        this.nzPageIndexChange.emit(this.nzPageIndex);
    };
    Object.defineProperty(NzPaginationComponent.prototype, "_isLastIndex", {
        /**
         * @return {?}
         */
        get: function () {
            return this._current === this._lastIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzPaginationComponent.prototype, "_isFirstIndex", {
        /**
         * @return {?}
         */
        get: function () {
            return this._current === this._firstIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzPaginationComponent.prototype, "_roundPageSize", {
        /**
         * @return {?}
         */
        get: function () {
            return Math.round(this._pageSize / 2);
        },
        enumerable: true,
        configurable: true
    });
    return NzPaginationComponent;
}());
NzPaginationComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-pagination',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ul class=\"ant-pagination ant-pagination-simple\" *ngIf=\"nzSimple\">\n      <li\n        title=\"\u4E0A\u4E00\u9875\"\n        class=\"ant-pagination-prev\"\n        (click)=\"_jumpPage(_current-1)\"\n        [class.ant-pagination-disabled]=\"_isFirstIndex\">\n        <a></a>\n      </li>\n      <li [attr.title]=\"_current+'/'+_lastIndex\" class=\"ant-pagination-simple-pager\">\n        <input [ngModel]=\"nzPageIndex\" (ngModelChange)=\"_nzPageIndexChange($event)\" size=\"3\"><span class=\"ant-pagination-slash\">\uFF0F</span>{{_lastIndex}}\n      </li>\n      <li\n        title=\"\u4E0B\u4E00\u9875\"\n        class=\"ant-pagination-next\"\n        (click)=\"_jumpPage(_current+1)\"\n        [class.ant-pagination-disabled]=\"_isLastIndex\">\n        <a></a>\n      </li>\n    </ul>\n    <ul *ngIf=\"!nzSimple\" class=\"ant-pagination\" [class.mini]=\"nzSize=='small'\">\n      <span class=\"ant-pagination-total-text\" *ngIf=\"nzShowTotal\">\u5171 {{_total}} \u6761</span>\n      <li\n        title=\"\u4E0A\u4E00\u9875\"\n        class=\"ant-pagination-prev\"\n        (click)=\"_jumpPage(_current-1)\"\n        [class.ant-pagination-disabled]=\"_isFirstIndex\">\n        <a></a>\n      </li>\n      <li\n        title=\"\u7B2C\u4E00\u9875\"\n        class=\"ant-pagination-item\"\n        (click)=\"_jumpPage(_firstIndex)\"\n        [class.ant-pagination-item-active]=\"_isFirstIndex\">\n        <a>{{_firstIndex}}</a>\n      </li>\n      <li\n        [attr.title]=\"'\u5411\u524D '+_roundPageSize+' \u9875'\"\n        (click)=\"_jumpBefore(_pageSize)\"\n        class=\"ant-pagination-jump-prev\"\n        *ngIf=\"(_lastIndex >9)&&(_current-3>_firstIndex)\">\n        <a></a>\n      </li>\n      <li\n        *ngFor=\"let page of _pages\"\n        [attr.title]=\"page.index\"\n        class=\"ant-pagination-item\"\n        (click)=\"_jumpPage(page.index)\"\n        [class.ant-pagination-item-active]=\"_current==page.index\">\n        <a>{{page.index}}</a>\n      </li>\n      <li\n        [attr.title]=\"'\u5411\u540E '+_roundPageSize+' \u9875'\"\n        (click)=\"_jumpAfter(_pageSize)\"\n        class=\"ant-pagination-jump-next\"\n        *ngIf=\"(_lastIndex >9)&&(_current+3<_lastIndex)\">\n        <a></a>\n      </li>\n      <li\n        [attr.title]=\"'\u6700\u540E\u4E00\u9875: '+_lastIndex\"\n        class=\"ant-pagination-item\"\n        (click)=\"_jumpPage(_lastIndex)\"\n        *ngIf=\"(_lastIndex>0)&&(_lastIndex!==_firstIndex)\"\n        [class.ant-pagination-item-active]=\"_isLastIndex\">\n        <a>{{_lastIndex}}</a>\n      </li>\n      <li\n        title=\"\u4E0B\u4E00\u9875\"\n        class=\"ant-pagination-next\"\n        (click)=\"_jumpPage(_current+1)\"\n        [class.ant-pagination-disabled]=\"_isLastIndex\">\n        <a></a>\n      </li>\n      <div class=\"ant-pagination-options\">\n        <nz-select\n          *ngIf=\"nzShowSizeChanger\"\n          [nzSize]=\"nzSize=='small'?'small':''\"\n          class=\"ant-pagination-options-size-changer\"\n          [ngModel]=\"_pageSize\"\n          (ngModelChange)=\"_pageSizeChange($event)\">\n          <nz-option\n            *ngFor=\"let option of _options\"\n            [nzLabel]=\"option+ '\u6761/\u9875'\"\n            [nzValue]=\"option\">\n          </nz-option>\n          <nz-option\n            *ngIf=\"_options.indexOf(nzPageSize)==-1\"\n            [nzLabel]=\"nzPageSize+ '\u6761/\u9875'\"\n            [nzValue]=\"nzPageSize\">\n          </nz-option>\n        </nz-select>\n        <div class=\"ant-pagination-options-quick-jumper\"\n          *ngIf=\"nzShowQuickJumper\">\n          \u8DF3\u81F3<input [ngModel]=\"nzPageIndex\" (ngModelChange)=\"_nzPageIndexChange($event)\">\u9875\n        </div>\n      </div>\n    </ul>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-pagination {\n  font-size: 12px;\n}\n.ant-pagination:after {\n  content: \" \";\n  display: block;\n  height: 0;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n.ant-pagination-total-text {\n  display: inline-block;\n  vertical-align: middle;\n  height: 28px;\n  line-height: 28px;\n  margin-right: 8px;\n}\n.ant-pagination-item {\n  cursor: pointer;\n  border-radius: 4px;\n  user-select: none;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n  list-style: none;\n  display: inline-block;\n  vertical-align: middle;\n  border: 1px solid #d9d9d9;\n  background-color: #fff;\n  margin-right: 8px;\n  font-family: Arial;\n  outline: 0;\n}\n.ant-pagination-item a {\n  text-decoration: none;\n  color: rgba(0, 0, 0, 0.65);\n  transition: none;\n  margin: 0 6px;\n}\n.ant-pagination-item:focus,\n.ant-pagination-item:hover {\n  transition: all .3s;\n  border-color: #108ee9;\n}\n.ant-pagination-item:focus a,\n.ant-pagination-item:hover a {\n  color: #108ee9;\n}\n.ant-pagination-item-active {\n  background-color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-pagination-item-active:focus,\n.ant-pagination-item-active:hover {\n  background-color: #49a9ee;\n  border-color: #49a9ee;\n}\n.ant-pagination-item-active a,\n.ant-pagination-item-active:focus a,\n.ant-pagination-item-active:hover a {\n  color: #fff;\n}\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  outline: 0;\n}\n.ant-pagination-jump-prev:after,\n.ant-pagination-jump-next:after {\n  content: \"\u2022\u2022\u2022\";\n  display: block;\n  letter-spacing: 2px;\n  color: rgba(0, 0, 0, 0.25);\n  text-align: center;\n}\n.ant-pagination-jump-prev:focus:after,\n.ant-pagination-jump-next:focus:after,\n.ant-pagination-jump-prev:hover:after,\n.ant-pagination-jump-next:hover:after {\n  color: #108ee9;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  letter-spacing: -1px;\n  font-family: \"anticon\";\n}\n:root .ant-pagination-jump-prev:focus:after,\n:root .ant-pagination-jump-next:focus:after,\n:root .ant-pagination-jump-prev:hover:after,\n:root .ant-pagination-jump-next:hover:after {\n  filter: none;\n}\n:root .ant-pagination-jump-prev:focus:after,\n:root .ant-pagination-jump-next:focus:after,\n:root .ant-pagination-jump-prev:hover:after,\n:root .ant-pagination-jump-next:hover:after {\n  font-size: 12px;\n}\n.ant-pagination-jump-prev:focus:after,\n.ant-pagination-jump-prev:hover:after {\n  content: \"\\e620\\e620\";\n}\n.ant-pagination-jump-next:focus:after,\n.ant-pagination-jump-next:hover:after {\n  content: \"\\e61f\\e61f\";\n}\n.ant-pagination-prev,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  margin-right: 8px;\n}\n.ant-pagination-prev,\n.ant-pagination-next,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  font-family: Arial;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.65);\n  border-radius: 4px;\n  list-style: none;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n  transition: all .3s;\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-pagination-prev,\n.ant-pagination-next {\n  border: 1px solid #d9d9d9;\n  background-color: #fff;\n  outline: 0;\n}\n.ant-pagination-prev a,\n.ant-pagination-next a {\n  color: rgba(0, 0, 0, 0.65);\n  outline: none;\n}\n.ant-pagination-prev a:after,\n.ant-pagination-next a:after {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  display: block;\n  height: 26px;\n  line-height: 26px;\n  font-family: \"anticon\";\n  text-align: center;\n}\n:root .ant-pagination-prev a:after,\n:root .ant-pagination-next a:after {\n  filter: none;\n}\n:root .ant-pagination-prev a:after,\n:root .ant-pagination-next a:after {\n  font-size: 12px;\n}\n.ant-pagination-prev:focus,\n.ant-pagination-next:focus,\n.ant-pagination-prev:hover,\n.ant-pagination-next:hover {\n  border-color: #108ee9;\n}\n.ant-pagination-prev:focus a,\n.ant-pagination-next:focus a,\n.ant-pagination-prev:hover a,\n.ant-pagination-next:hover a {\n  color: #108ee9;\n}\n.ant-pagination-prev a:after {\n  content: \"\\e620\";\n  display: block;\n}\n.ant-pagination-next a:after {\n  content: \"\\e61f\";\n  display: block;\n}\n.ant-pagination-disabled {\n  cursor: not-allowed;\n}\n.ant-pagination-disabled:hover {\n  border-color: #d9d9d9;\n}\n.ant-pagination-disabled:hover a {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-pagination-disabled a {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination-slash {\n  margin: 0 10px 0 5px;\n}\n.ant-pagination-options {\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 16px;\n}\n.ant-pagination-options-size-changer {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-pagination-options-quick-jumper {\n  display: inline-block;\n  height: 28px;\n  line-height: 28px;\n}\n.ant-pagination-options-quick-jumper input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n  margin: 0 8px;\n  width: 50px;\n}\n.ant-pagination-options-quick-jumper input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination-options-quick-jumper input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination-options-quick-jumper input:hover {\n  border-color: #49a9ee;\n}\n.ant-pagination-options-quick-jumper input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-pagination-options-quick-jumper input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination-options-quick-jumper input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-pagination-options-quick-jumper input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-pagination-options-quick-jumper input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-pagination-options-quick-jumper input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-pagination-simple .ant-pagination-prev,\n.ant-pagination-simple .ant-pagination-next {\n  border: 0;\n  height: 24px;\n  line-height: 24px;\n  margin: 0;\n  font-size: 18px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 8px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input {\n  margin: 0 8px;\n  box-sizing: border-box;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  outline: none;\n  padding: 5px 8px;\n  height: 24px;\n  text-align: center;\n  transition: border-color 0.3s;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input:hover {\n  border-color: #108ee9;\n}\n.ant-pagination.mini .ant-pagination-total-text {\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-item {\n  border: 0;\n  margin: 0;\n  min-width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-prev,\n.ant-pagination.mini .ant-pagination-next {\n  margin: 0;\n  min-width: 20px;\n  height: 20px;\n  line-height: 20px;\n  border: 0;\n}\n.ant-pagination.mini .ant-pagination-prev a:after,\n.ant-pagination.mini .ant-pagination-next a:after {\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-jump-prev,\n.ant-pagination.mini .ant-pagination-jump-next {\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-options {\n  margin-left: 8px;\n}\n.ant-pagination.mini .ant-pagination-options-quick-jumper {\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-options-quick-jumper input {\n  padding: 1px 7px;\n  height: 22px;\n  width: 44px;\n}\n@media only screen and (max-width: 1024px) {\n  .ant-pagination-item-after-jump-prev,\n  .ant-pagination-item-before-jump-next {\n    display: none;\n  }\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-pagination {\n  font-size: 12px;\n}\n.ant-pagination:after {\n  content: \" \";\n  display: block;\n  height: 0;\n  clear: both;\n  overflow: hidden;\n  visibility: hidden;\n}\n.ant-pagination-total-text {\n  display: inline-block;\n  vertical-align: middle;\n  height: 28px;\n  line-height: 28px;\n  margin-right: 8px;\n}\n.ant-pagination-item {\n  cursor: pointer;\n  border-radius: 4px;\n  user-select: none;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n  list-style: none;\n  display: inline-block;\n  vertical-align: middle;\n  border: 1px solid #d9d9d9;\n  background-color: #fff;\n  margin-right: 8px;\n  font-family: Arial;\n  outline: 0;\n}\n.ant-pagination-item a {\n  text-decoration: none;\n  color: rgba(0, 0, 0, 0.65);\n  transition: none;\n  margin: 0 6px;\n}\n.ant-pagination-item:focus,\n.ant-pagination-item:hover {\n  transition: all .3s;\n  border-color: #108ee9;\n}\n.ant-pagination-item:focus a,\n.ant-pagination-item:hover a {\n  color: #108ee9;\n}\n.ant-pagination-item-active {\n  background-color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-pagination-item-active:focus,\n.ant-pagination-item-active:hover {\n  background-color: #49a9ee;\n  border-color: #49a9ee;\n}\n.ant-pagination-item-active a,\n.ant-pagination-item-active:focus a,\n.ant-pagination-item-active:hover a {\n  color: #fff;\n}\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  outline: 0;\n}\n.ant-pagination-jump-prev:after,\n.ant-pagination-jump-next:after {\n  content: \"\u2022\u2022\u2022\";\n  display: block;\n  letter-spacing: 2px;\n  color: rgba(0, 0, 0, 0.25);\n  text-align: center;\n}\n.ant-pagination-jump-prev:focus:after,\n.ant-pagination-jump-next:focus:after,\n.ant-pagination-jump-prev:hover:after,\n.ant-pagination-jump-next:hover:after {\n  color: #108ee9;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  letter-spacing: -1px;\n  font-family: \"anticon\";\n}\n:root .ant-pagination-jump-prev:focus:after,\n:root .ant-pagination-jump-next:focus:after,\n:root .ant-pagination-jump-prev:hover:after,\n:root .ant-pagination-jump-next:hover:after {\n  filter: none;\n}\n:root .ant-pagination-jump-prev:focus:after,\n:root .ant-pagination-jump-next:focus:after,\n:root .ant-pagination-jump-prev:hover:after,\n:root .ant-pagination-jump-next:hover:after {\n  font-size: 12px;\n}\n.ant-pagination-jump-prev:focus:after,\n.ant-pagination-jump-prev:hover:after {\n  content: \"\\e620\\e620\";\n}\n.ant-pagination-jump-next:focus:after,\n.ant-pagination-jump-next:hover:after {\n  content: \"\\e61f\\e61f\";\n}\n.ant-pagination-prev,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  margin-right: 8px;\n}\n.ant-pagination-prev,\n.ant-pagination-next,\n.ant-pagination-jump-prev,\n.ant-pagination-jump-next {\n  font-family: Arial;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.65);\n  border-radius: 4px;\n  list-style: none;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n  transition: all .3s;\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-pagination-prev,\n.ant-pagination-next {\n  border: 1px solid #d9d9d9;\n  background-color: #fff;\n  outline: 0;\n}\n.ant-pagination-prev a,\n.ant-pagination-next a {\n  color: rgba(0, 0, 0, 0.65);\n  outline: none;\n}\n.ant-pagination-prev a:after,\n.ant-pagination-next a:after {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  display: block;\n  height: 26px;\n  line-height: 26px;\n  font-family: \"anticon\";\n  text-align: center;\n}\n:root .ant-pagination-prev a:after,\n:root .ant-pagination-next a:after {\n  filter: none;\n}\n:root .ant-pagination-prev a:after,\n:root .ant-pagination-next a:after {\n  font-size: 12px;\n}\n.ant-pagination-prev:focus,\n.ant-pagination-next:focus,\n.ant-pagination-prev:hover,\n.ant-pagination-next:hover {\n  border-color: #108ee9;\n}\n.ant-pagination-prev:focus a,\n.ant-pagination-next:focus a,\n.ant-pagination-prev:hover a,\n.ant-pagination-next:hover a {\n  color: #108ee9;\n}\n.ant-pagination-prev a:after {\n  content: \"\\e620\";\n  display: block;\n}\n.ant-pagination-next a:after {\n  content: \"\\e61f\";\n  display: block;\n}\n.ant-pagination-disabled {\n  cursor: not-allowed;\n}\n.ant-pagination-disabled:hover {\n  border-color: #d9d9d9;\n}\n.ant-pagination-disabled:hover a {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-pagination-disabled a {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination-slash {\n  margin: 0 10px 0 5px;\n}\n.ant-pagination-options {\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 16px;\n}\n.ant-pagination-options-size-changer {\n  display: inline-block;\n  margin-right: 8px;\n}\n.ant-pagination-options-quick-jumper {\n  display: inline-block;\n  height: 28px;\n  line-height: 28px;\n}\n.ant-pagination-options-quick-jumper input {\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  width: 100%;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: all .3s;\n  margin: 0 8px;\n  width: 50px;\n}\n.ant-pagination-options-quick-jumper input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n  opacity: 1;\n}\n.ant-pagination-options-quick-jumper input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination-options-quick-jumper input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination-options-quick-jumper input:hover {\n  border-color: #49a9ee;\n}\n.ant-pagination-options-quick-jumper input:focus {\n  border-color: #49a9ee;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-pagination-options-quick-jumper input-disabled {\n  background-color: #f7f7f7;\n  opacity: 1;\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-pagination-options-quick-jumper input-disabled:hover {\n  border-color: #e2e2e2;\n}\ntextarea.ant-pagination-options-quick-jumper input {\n  max-width: 100%;\n  height: auto;\n  vertical-align: bottom;\n}\n.ant-pagination-options-quick-jumper input-lg {\n  padding: 6px 7px;\n  height: 32px;\n}\n.ant-pagination-options-quick-jumper input-sm {\n  padding: 1px 7px;\n  height: 22px;\n}\n.ant-pagination-simple .ant-pagination-prev,\n.ant-pagination-simple .ant-pagination-next {\n  border: 0;\n  height: 24px;\n  line-height: 24px;\n  margin: 0;\n  font-size: 18px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 8px;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input {\n  margin: 0 8px;\n  box-sizing: border-box;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  outline: none;\n  padding: 5px 8px;\n  height: 24px;\n  text-align: center;\n  transition: border-color 0.3s;\n}\n.ant-pagination-simple .ant-pagination-simple-pager input:hover {\n  border-color: #108ee9;\n}\n.ant-pagination.mini .ant-pagination-total-text {\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-item {\n  border: 0;\n  margin: 0;\n  min-width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-prev,\n.ant-pagination.mini .ant-pagination-next {\n  margin: 0;\n  min-width: 20px;\n  height: 20px;\n  line-height: 20px;\n  border: 0;\n}\n.ant-pagination.mini .ant-pagination-prev a:after,\n.ant-pagination.mini .ant-pagination-next a:after {\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-jump-prev,\n.ant-pagination.mini .ant-pagination-jump-next {\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-options {\n  margin-left: 8px;\n}\n.ant-pagination.mini .ant-pagination-options-quick-jumper {\n  height: 20px;\n  line-height: 20px;\n}\n.ant-pagination.mini .ant-pagination-options-quick-jumper input {\n  padding: 1px 7px;\n  height: 22px;\n  width: 44px;\n}\n@media only screen and (max-width: 1024px) {\n  .ant-pagination-item-after-jump-prev,\n  .ant-pagination-item-before-jump-next {\n    display: none;\n  }\n}\n.ant-pagination {\n  user-select: none;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzPaginationComponent.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NzPaginationComponent.propDecorators = {
    'nzShowSizeChanger': [{ type: Input },],
    'nzShowQuickJumper': [{ type: Input },],
    'nzShowTotal': [{ type: Input },],
    'nzSimple': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzPageSizeChange': [{ type: Output },],
    'nzPageIndexChange': [{ type: Output },],
    'nzPageIndexClickChange': [{ type: Output },],
    'nzPageIndex': [{ type: Input },],
    'nzPageSize': [{ type: Input },],
    'nzTotal': [{ type: Input },],
};
var NzPaginationModule = (function () {
    function NzPaginationModule() {
    }
    return NzPaginationModule;
}());
NzPaginationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzPaginationComponent],
                exports: [NzPaginationComponent],
                imports: [CommonModule, FormsModule, NzSelectModule]
            },] },
];
/**
 * @nocollapse
 */
NzPaginationModule.ctorParameters = function () { return []; };
var NzPopconfirmDirective = (function () {
    /**
     * @param {?} elementRef
     */
    function NzPopconfirmDirective(elementRef) {
        this.elementRef = elementRef;
    }
    return NzPopconfirmDirective;
}());
NzPopconfirmDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-popconfirm]',
            },] },
];
/**
 * @nocollapse
 */
NzPopconfirmDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
var NzTooltipDirective = (function () {
    /**
     * @param {?} elementRef
     */
    function NzTooltipDirective(elementRef) {
        this.elementRef = elementRef;
    }
    return NzTooltipDirective;
}());
NzTooltipDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-tooltip]',
            },] },
];
/**
 * @nocollapse
 */
NzTooltipDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NzTooltipDirective.propDecorators = {
    'isTooltipOpen': [{ type: HostBinding, args: ['class.ant-tooltip-open',] },],
};
var NzToolTipComponent = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _cdr
     */
    function NzToolTipComponent(_renderer, _cdr) {
        this._renderer = _renderer;
        this._cdr = _cdr;
        this.nzOverlayClassName = '';
        this.nzOverlayStyle = {};
        this.nzVisibleChange = new EventEmitter();
        this.visibleSource = new BehaviorSubject$1(false);
        this.visible$ = this.visibleSource.asObservable();
        this._prefix = 'ant-tooltip-placement';
        this._positions = DEFAULT_4_POSITIONS.slice();
        this._classMap = {};
        this._placement = 'top';
        this._trigger = 'hover';
        this._hasBackdrop = false;
    }
    Object.defineProperty(NzToolTipComponent.prototype, "nzVisible", {
        /**
         * @return {?}
         */
        get: function () {
            return this.visibleSource.value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this.visibleSource.value !== value) {
                this.visibleSource.next(value);
                this.nzVisibleChange.emit(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzToolTipComponent.prototype, "nzTrigger", {
        /**
         * @return {?}
         */
        get: function () {
            return this._trigger;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._trigger = value;
            this._hasBackdrop = this._trigger === 'click';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzToolTipComponent.prototype, "nzPlacement", {
        /**
         * @return {?}
         */
        get: function () {
            return this._placement;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value !== this._placement) {
                this._placement = value;
                this._positions.unshift(/** @type {?} */ (POSITION_MAP[this.nzPlacement]));
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzToolTipComponent.prototype.updatePosition = function () {
        if (this.overlay && this.overlay.overlayRef) {
            this.overlay.overlayRef.updatePosition();
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzToolTipComponent.prototype.onPositionChange = function ($event) {
        for (var /** @type {?} */ key in POSITION_MAP) {
            if (JSON.stringify($event.connectionPair) === JSON.stringify(POSITION_MAP[key])) {
                this.nzPlacement = key;
                break;
            }
        }
        this.setClassMap();
        /** TODO may cause performance problem */
        this._cdr.detectChanges();
    };
    /**
     * @return {?}
     */
    NzToolTipComponent.prototype.show = function () {
        this.nzVisible = true;
        this.nzOrigin.isTooltipOpen = true;
    };
    /**
     * @return {?}
     */
    NzToolTipComponent.prototype.hide = function () {
        this.nzVisible = false;
        this.nzOrigin.isTooltipOpen = false;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzToolTipComponent.prototype._afterVisibilityAnimation = function (e) {
        if (e.toState === 'false' && !this.nzVisible) {
            this.nzVisibleChange.emit(false);
        }
        if (e.toState === 'true' && this.nzVisible) {
            this.nzVisibleChange.emit(true);
        }
    };
    /**
     * @return {?}
     */
    NzToolTipComponent.prototype.setClassMap = function () {
        this._classMap = (_a = {},
            _a[this.nzOverlayClassName] = true,
            _a[this._prefix + "-" + this._placement] = true,
            _a);
        var _a;
    };
    /**
     * @return {?}
     */
    NzToolTipComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this._trigger === 'hover') {
            this._renderer.listen(this.nzOrigin.elementRef.nativeElement, 'mouseenter', function () { return _this.show(); });
            this._renderer.listen(this.nzOrigin.elementRef.nativeElement, 'mouseleave', function () { return _this.hide(); });
        }
        else if (this._trigger === 'focus') {
            this._renderer.listen(this.nzOrigin.elementRef.nativeElement, 'focus', function () { return _this.show(); });
            this._renderer.listen(this.nzOrigin.elementRef.nativeElement, 'blur', function () { return _this.hide(); });
        }
        else if (this._trigger === 'click') {
            this._renderer.listen(this.nzOrigin.elementRef.nativeElement, 'click', function (e) {
                e.preventDefault();
                _this.show();
            });
        }
    };
    return NzToolTipComponent;
}());
NzToolTipComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-tooltip',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    FadeAnimation
                ],
                template: "\n    <ng-content></ng-content>\n    <ng-template\n      #overlay=\"nzConnectedOverlay\"\n      nz-connected-overlay\n      [origin]=\"nzOrigin\"\n      [hasBackdrop]=\"_hasBackdrop\"\n      (backdropClick)=\"hide()\"\n      (detach)=\"hide()\"\n      (positionChange)=\"onPositionChange($event)\"\n      [positions]=\"_positions\"\n      [open]=\"visible$ | async\">\n      <div class=\"ant-tooltip\" [ngClass]=\"_classMap\" [ngStyle]=\"nzOverlayStyle\" [@fadeAnimation]=\"''+(visible$ | async)\"\n        (@fadeAnimation.done)=\"_afterVisibilityAnimation($event)\">\n        <div class=\"ant-tooltip-content\">\n          <div class=\"ant-tooltip-arrow\"></div>\n          <div class=\"ant-tooltip-inner\">\n            <span *ngIf=\"!nzTemplate\">{{nzTitle}}</span>\n            <ng-template\n              *ngIf=\"nzTemplate\"\n              [ngTemplateOutlet]=\"nzTemplate\">\n            </ng-template>\n          </div>\n        </div>\n      </div>\n    </ng-template>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-tooltip {\n  position: absolute;\n  z-index: 1060;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.ant-tooltip-hidden {\n  display: none;\n}\n.ant-tooltip-placement-top,\n.ant-tooltip-placement-topLeft,\n.ant-tooltip-placement-topRight {\n  padding-bottom: 8px;\n}\n.ant-tooltip-placement-right,\n.ant-tooltip-placement-rightTop,\n.ant-tooltip-placement-rightBottom {\n  padding-left: 8px;\n}\n.ant-tooltip-placement-bottom,\n.ant-tooltip-placement-bottomLeft,\n.ant-tooltip-placement-bottomRight {\n  padding-top: 8px;\n}\n.ant-tooltip-placement-left,\n.ant-tooltip-placement-leftTop,\n.ant-tooltip-placement-leftBottom {\n  padding-right: 8px;\n}\n.ant-tooltip-inner {\n  max-width: 250px;\n  padding: 8px 10px;\n  color: #fff;\n  text-align: left;\n  text-decoration: none;\n  background-color: rgba(64, 64, 64, 0.85);\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  min-height: 34px;\n}\n.ant-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow,\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  bottom: 3px;\n  border-width: 5px 5px 0;\n  border-top-color: rgba(64, 64, 64, 0.85);\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow {\n  left: 16px;\n}\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  right: 16px;\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow,\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow,\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  left: 3px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: rgba(64, 64, 64, 0.85);\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow {\n  top: 8px;\n}\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  bottom: 8px;\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow,\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow,\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  right: 3px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: rgba(64, 64, 64, 0.85);\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow {\n  top: 8px;\n}\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  bottom: 8px;\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  top: 3px;\n  border-width: 0 5px 5px;\n  border-bottom-color: rgba(64, 64, 64, 0.85);\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {\n  left: 16px;\n}\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  right: 16px;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-tooltip {\n  position: absolute;\n  z-index: 1060;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.ant-tooltip-hidden {\n  display: none;\n}\n.ant-tooltip-placement-top,\n.ant-tooltip-placement-topLeft,\n.ant-tooltip-placement-topRight {\n  padding-bottom: 8px;\n}\n.ant-tooltip-placement-right,\n.ant-tooltip-placement-rightTop,\n.ant-tooltip-placement-rightBottom {\n  padding-left: 8px;\n}\n.ant-tooltip-placement-bottom,\n.ant-tooltip-placement-bottomLeft,\n.ant-tooltip-placement-bottomRight {\n  padding-top: 8px;\n}\n.ant-tooltip-placement-left,\n.ant-tooltip-placement-leftTop,\n.ant-tooltip-placement-leftBottom {\n  padding-right: 8px;\n}\n.ant-tooltip-inner {\n  max-width: 250px;\n  padding: 8px 10px;\n  color: #fff;\n  text-align: left;\n  text-decoration: none;\n  background-color: rgba(64, 64, 64, 0.85);\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  min-height: 34px;\n}\n.ant-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow,\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  bottom: 3px;\n  border-width: 5px 5px 0;\n  border-top-color: rgba(64, 64, 64, 0.85);\n}\n.ant-tooltip-placement-top .ant-tooltip-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-tooltip-placement-topLeft .ant-tooltip-arrow {\n  left: 16px;\n}\n.ant-tooltip-placement-topRight .ant-tooltip-arrow {\n  right: 16px;\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow,\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow,\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  left: 3px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: rgba(64, 64, 64, 0.85);\n}\n.ant-tooltip-placement-right .ant-tooltip-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-tooltip-placement-rightTop .ant-tooltip-arrow {\n  top: 8px;\n}\n.ant-tooltip-placement-rightBottom .ant-tooltip-arrow {\n  bottom: 8px;\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow,\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow,\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  right: 3px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: rgba(64, 64, 64, 0.85);\n}\n.ant-tooltip-placement-left .ant-tooltip-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-tooltip-placement-leftTop .ant-tooltip-arrow {\n  top: 8px;\n}\n.ant-tooltip-placement-leftBottom .ant-tooltip-arrow {\n  bottom: 8px;\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  top: 3px;\n  border-width: 0 5px 5px;\n  border-bottom-color: rgba(64, 64, 64, 0.85);\n}\n.ant-tooltip-placement-bottom .ant-tooltip-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-tooltip-placement-bottomLeft .ant-tooltip-arrow {\n  left: 16px;\n}\n.ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n  right: 16px;\n}\n.ant-tooltip {\n  position: relative;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzToolTipComponent.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: ChangeDetectorRef, },
]; };
NzToolTipComponent.propDecorators = {
    'nzTitle': [{ type: Input },],
    'nzOverlayClassName': [{ type: Input },],
    'nzOverlayStyle': [{ type: Input },],
    'nzVisibleChange': [{ type: Output },],
    'nzOrigin': [{ type: ContentChild, args: [NzTooltipDirective,] },],
    'nzTemplate': [{ type: ContentChild, args: ['nzTemplate',] },],
    'overlay': [{ type: ViewChild, args: ['overlay',] },],
    'nzVisible': [{ type: Input },],
    'nzTrigger': [{ type: Input },],
    'nzPlacement': [{ type: Input },],
};
var NzPopconfirmComponent = (function (_super) {
    tslib_1.__extends(NzPopconfirmComponent, _super);
    function NzPopconfirmComponent() {
        var _this = _super.apply(this, arguments) || this;
        _this._prefix = 'ant-popover-placement';
        _this._trigger = 'click';
        _this._hasBackdrop = true;
        _this._condition = false;
        _this.nzOkText = '确定';
        _this.nzCancelText = '取消';
        _this.nzOnCancel = new EventEmitter();
        _this.nzOnConfirm = new EventEmitter();
        return _this;
    }
    Object.defineProperty(NzPopconfirmComponent.prototype, "nzCondition", {
        /**
         * @return {?}
         */
        get: function () {
            return this._condition;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._condition = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzPopconfirmComponent.prototype.show = function () {
        if (!this._condition) {
            this.nzVisible = true;
        }
        else {
            this.onConfirm();
        }
    };
    /**
     * @return {?}
     */
    NzPopconfirmComponent.prototype.onCancel = function () {
        this.nzOnCancel.emit();
        this.nzVisible = false;
    };
    /**
     * @return {?}
     */
    NzPopconfirmComponent.prototype.onConfirm = function () {
        this.nzOnConfirm.emit();
        this.nzVisible = false;
    };
    return NzPopconfirmComponent;
}(NzToolTipComponent));
NzPopconfirmComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-popconfirm',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    FadeAnimation
                ],
                template: "\n    <ng-content></ng-content>\n    <ng-template\n      nz-connected-overlay\n      [origin]=\"nzOrigin\"\n      [hasBackdrop]=\"_hasBackdrop\"\n      (backdropClick)=\"hide()\"\n      (detach)=\"hide()\"\n      (positionChange)=\"onPositionChange($event)\"\n      [positions]=\"_positions\"\n      [open]=\"visible$ | async\">\n      <div class=\"ant-popover\" [ngClass]=\"_classMap\" [ngStyle]=\"nzOverlayStyle\" [@fadeAnimation]=\"''+(visible$ | async)\"\n        (@fadeAnimation.done)=\"_afterVisibilityAnimation($event)\">\n        <div class=\"ant-popover-content\">\n          <div class=\"ant-popover-arrow\"></div>\n          <div class=\"ant-popover-inner\">\n            <div>\n              <div class=\"ant-popover-inner-content\">\n                <div class=\"ant-popover-message\" *ngIf=\"!nzTemplate\">\n                  <i class=\"anticon anticon-exclamation-circle\"></i>\n                  <div class=\"ant-popover-message-title\">{{nzTitle}}</div>\n                </div>\n                <div class=\"ant-popover-buttons\" *ngIf=\"!nzTemplate\">\n                  <button nz-button [nzSize]=\"'small'\" (click)=\"onCancel()\"><span>{{nzCancelText}}</span></button>\n                  <button nz-button [nzSize]=\"'small'\" [nzType]=\"'primary'\" (click)=\"onConfirm()\">\n                    <span>{{nzOkText}}</span></button>\n                </div>\n                <ng-template\n                  *ngIf=\"nzTemplate\"\n                  [ngTemplateOutlet]=\"nzTemplate\">\n                </ng-template>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1030;\n  cursor: auto;\n  user-select: text;\n  white-space: normal;\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: normal;\n  text-align: left;\n}\n.ant-popover:after {\n  content: \"\";\n  position: absolute;\n  background: rgba(255, 255, 255, 0.01);\n}\n.ant-popover-hidden {\n  display: none;\n}\n.ant-popover-placement-top,\n.ant-popover-placement-topLeft,\n.ant-popover-placement-topRight {\n  padding-bottom: 8px;\n}\n.ant-popover-placement-right,\n.ant-popover-placement-rightTop,\n.ant-popover-placement-rightBottom {\n  padding-left: 8px;\n}\n.ant-popover-placement-bottom,\n.ant-popover-placement-bottomLeft,\n.ant-popover-placement-bottomRight {\n  padding-top: 8px;\n}\n.ant-popover-placement-left,\n.ant-popover-placement-leftTop,\n.ant-popover-placement-leftBottom {\n  padding-right: 8px;\n}\n.ant-popover-inner {\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-popover-title {\n  min-width: 177px;\n  margin: 0;\n  padding: 0 16px;\n  line-height: 32px;\n  height: 32px;\n  border-bottom: 1px solid #e9e9e9;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 500;\n}\n.ant-popover-inner-content {\n  padding: 8px 16px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message {\n  padding: 8px 0 16px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message > .anticon {\n  color: #ffbf00;\n  line-height: 17px;\n  position: absolute;\n}\n.ant-popover-message-title {\n  padding-left: 20px;\n}\n.ant-popover-buttons {\n  text-align: right;\n  margin-bottom: 8px;\n}\n.ant-popover-buttons button {\n  margin-left: 8px;\n}\n.ant-popover-arrow,\n.ant-popover-arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.ant-popover-arrow {\n  border-width: 5px;\n}\n.ant-popover-arrow:after {\n  border-width: 4px;\n  content: \"\";\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  border-bottom-width: 0;\n  border-top-color: rgba(217, 217, 217, 0.7);\n  bottom: 3px;\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  bottom: 1px;\n  margin-left: -4px;\n  border-bottom-width: 0;\n  border-top-color: #fff;\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  left: 3px;\n  border-left-width: 0;\n  border-right-color: rgba(217, 217, 217, 0.7);\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  left: 1px;\n  bottom: -4px;\n  border-left-width: 0;\n  border-right-color: #fff;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  border-top-width: 0;\n  border-bottom-color: rgba(217, 217, 217, 0.7);\n  top: 3px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  top: 1px;\n  margin-left: -4px;\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  right: 3px;\n  border-right-width: 0;\n  border-left-color: rgba(217, 217, 217, 0.7);\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  right: 1px;\n  border-right-width: 0;\n  border-left-color: #fff;\n  bottom: -4px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1030;\n  cursor: auto;\n  user-select: text;\n  white-space: normal;\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: normal;\n  text-align: left;\n}\n.ant-popover:after {\n  content: \"\";\n  position: absolute;\n  background: rgba(255, 255, 255, 0.01);\n}\n.ant-popover-hidden {\n  display: none;\n}\n.ant-popover-placement-top,\n.ant-popover-placement-topLeft,\n.ant-popover-placement-topRight {\n  padding-bottom: 8px;\n}\n.ant-popover-placement-right,\n.ant-popover-placement-rightTop,\n.ant-popover-placement-rightBottom {\n  padding-left: 8px;\n}\n.ant-popover-placement-bottom,\n.ant-popover-placement-bottomLeft,\n.ant-popover-placement-bottomRight {\n  padding-top: 8px;\n}\n.ant-popover-placement-left,\n.ant-popover-placement-leftTop,\n.ant-popover-placement-leftBottom {\n  padding-right: 8px;\n}\n.ant-popover-inner {\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-popover-title {\n  min-width: 177px;\n  margin: 0;\n  padding: 0 16px;\n  line-height: 32px;\n  height: 32px;\n  border-bottom: 1px solid #e9e9e9;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 500;\n}\n.ant-popover-inner-content {\n  padding: 8px 16px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message {\n  padding: 8px 0 16px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message > .anticon {\n  color: #ffbf00;\n  line-height: 17px;\n  position: absolute;\n}\n.ant-popover-message-title {\n  padding-left: 20px;\n}\n.ant-popover-buttons {\n  text-align: right;\n  margin-bottom: 8px;\n}\n.ant-popover-buttons button {\n  margin-left: 8px;\n}\n.ant-popover-arrow,\n.ant-popover-arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.ant-popover-arrow {\n  border-width: 5px;\n}\n.ant-popover-arrow:after {\n  border-width: 4px;\n  content: \"\";\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  border-bottom-width: 0;\n  border-top-color: rgba(217, 217, 217, 0.7);\n  bottom: 3px;\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  bottom: 1px;\n  margin-left: -4px;\n  border-bottom-width: 0;\n  border-top-color: #fff;\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  left: 3px;\n  border-left-width: 0;\n  border-right-color: rgba(217, 217, 217, 0.7);\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  left: 1px;\n  bottom: -4px;\n  border-left-width: 0;\n  border-right-color: #fff;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  border-top-width: 0;\n  border-bottom-color: rgba(217, 217, 217, 0.7);\n  top: 3px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  top: 1px;\n  margin-left: -4px;\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  right: 3px;\n  border-right-width: 0;\n  border-left-color: rgba(217, 217, 217, 0.7);\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  right: 1px;\n  border-right-width: 0;\n  border-left-color: #fff;\n  bottom: -4px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover {\n  position: relative;\n  margin: 1px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzPopconfirmComponent.ctorParameters = function () { return []; };
NzPopconfirmComponent.propDecorators = {
    'nzContent': [{ type: Input },],
    'nzOkText': [{ type: Input },],
    'nzCancelText': [{ type: Input },],
    'nzCondition': [{ type: Input },],
    'nzOnCancel': [{ type: Output },],
    'nzOnConfirm': [{ type: Output },],
    'nzOrigin': [{ type: ContentChild, args: [NzPopconfirmDirective,] },],
};
var NzPopconfirmModule = (function () {
    function NzPopconfirmModule() {
    }
    return NzPopconfirmModule;
}());
NzPopconfirmModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzPopconfirmComponent, NzPopconfirmDirective],
                exports: [NzPopconfirmComponent, NzPopconfirmDirective],
                imports: [CommonModule, NzButtonModule, OverlayModule]
            },] },
];
/**
 * @nocollapse
 */
NzPopconfirmModule.ctorParameters = function () { return []; };
var NzPopoverDirective = (function () {
    /**
     * @param {?} elementRef
     */
    function NzPopoverDirective(elementRef) {
        this.elementRef = elementRef;
    }
    return NzPopoverDirective;
}());
NzPopoverDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-popover]',
            },] },
];
/**
 * @nocollapse
 */
NzPopoverDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
var NzPopoverComponent = (function (_super) {
    tslib_1.__extends(NzPopoverComponent, _super);
    function NzPopoverComponent() {
        var _this = _super.apply(this, arguments) || this;
        _this._prefix = 'ant-popover-placement';
        return _this;
    }
    return NzPopoverComponent;
}(NzToolTipComponent));
NzPopoverComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-popover',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    FadeAnimation
                ],
                template: "\n    <ng-content></ng-content>\n    <ng-template\n      nz-connected-overlay\n      [origin]=\"nzOrigin\"\n      [hasBackdrop]=\"_hasBackdrop\"\n      (backdropClick)=\"hide()\"\n      (detach)=\"hide()\"\n      (positionChange)=\"onPositionChange($event)\"\n      [positions]=\"_positions\"\n      [open]=\"visible$ | async\">\n      <div class=\"ant-popover\" [ngClass]=\"_classMap\" [ngStyle]=\"nzOverlayStyle\" [@fadeAnimation]=\"''+(visible$ | async)\"\n        (@fadeAnimation.done)=\"_afterVisibilityAnimation($event)\">\n        <div class=\"ant-popover-content\">\n          <div class=\"ant-popover-arrow\"></div>\n          <div class=\"ant-popover-inner\">\n            <div class=\"ant-popover-title\">{{nzTitle}}</div>\n            <div class=\"ant-popover-inner-content\">\n              <span *ngIf=\"!nzTemplate\">{{nzContent}}</span>\n              <ng-template\n                *ngIf=\"nzTemplate\"\n                [ngTemplateOutlet]=\"nzTemplate\">\n              </ng-template>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1030;\n  cursor: auto;\n  user-select: text;\n  white-space: normal;\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: normal;\n  text-align: left;\n}\n.ant-popover:after {\n  content: \"\";\n  position: absolute;\n  background: rgba(255, 255, 255, 0.01);\n}\n.ant-popover-hidden {\n  display: none;\n}\n.ant-popover-placement-top,\n.ant-popover-placement-topLeft,\n.ant-popover-placement-topRight {\n  padding-bottom: 8px;\n}\n.ant-popover-placement-right,\n.ant-popover-placement-rightTop,\n.ant-popover-placement-rightBottom {\n  padding-left: 8px;\n}\n.ant-popover-placement-bottom,\n.ant-popover-placement-bottomLeft,\n.ant-popover-placement-bottomRight {\n  padding-top: 8px;\n}\n.ant-popover-placement-left,\n.ant-popover-placement-leftTop,\n.ant-popover-placement-leftBottom {\n  padding-right: 8px;\n}\n.ant-popover-inner {\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-popover-title {\n  min-width: 177px;\n  margin: 0;\n  padding: 0 16px;\n  line-height: 32px;\n  height: 32px;\n  border-bottom: 1px solid #e9e9e9;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 500;\n}\n.ant-popover-inner-content {\n  padding: 8px 16px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message {\n  padding: 8px 0 16px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message > .anticon {\n  color: #ffbf00;\n  line-height: 17px;\n  position: absolute;\n}\n.ant-popover-message-title {\n  padding-left: 20px;\n}\n.ant-popover-buttons {\n  text-align: right;\n  margin-bottom: 8px;\n}\n.ant-popover-buttons button {\n  margin-left: 8px;\n}\n.ant-popover-arrow,\n.ant-popover-arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.ant-popover-arrow {\n  border-width: 5px;\n}\n.ant-popover-arrow:after {\n  border-width: 4px;\n  content: \"\";\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  border-bottom-width: 0;\n  border-top-color: rgba(217, 217, 217, 0.7);\n  bottom: 3px;\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  bottom: 1px;\n  margin-left: -4px;\n  border-bottom-width: 0;\n  border-top-color: #fff;\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  left: 3px;\n  border-left-width: 0;\n  border-right-color: rgba(217, 217, 217, 0.7);\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  left: 1px;\n  bottom: -4px;\n  border-left-width: 0;\n  border-right-color: #fff;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  border-top-width: 0;\n  border-bottom-color: rgba(217, 217, 217, 0.7);\n  top: 3px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  top: 1px;\n  margin-left: -4px;\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  right: 3px;\n  border-right-width: 0;\n  border-left-color: rgba(217, 217, 217, 0.7);\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  right: 1px;\n  border-right-width: 0;\n  border-left-color: #fff;\n  bottom: -4px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1030;\n  cursor: auto;\n  user-select: text;\n  white-space: normal;\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: normal;\n  text-align: left;\n}\n.ant-popover:after {\n  content: \"\";\n  position: absolute;\n  background: rgba(255, 255, 255, 0.01);\n}\n.ant-popover-hidden {\n  display: none;\n}\n.ant-popover-placement-top,\n.ant-popover-placement-topLeft,\n.ant-popover-placement-topRight {\n  padding-bottom: 8px;\n}\n.ant-popover-placement-right,\n.ant-popover-placement-rightTop,\n.ant-popover-placement-rightBottom {\n  padding-left: 8px;\n}\n.ant-popover-placement-bottom,\n.ant-popover-placement-bottomLeft,\n.ant-popover-placement-bottomRight {\n  padding-top: 8px;\n}\n.ant-popover-placement-left,\n.ant-popover-placement-leftTop,\n.ant-popover-placement-leftBottom {\n  padding-right: 8px;\n}\n.ant-popover-inner {\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-popover-title {\n  min-width: 177px;\n  margin: 0;\n  padding: 0 16px;\n  line-height: 32px;\n  height: 32px;\n  border-bottom: 1px solid #e9e9e9;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 500;\n}\n.ant-popover-inner-content {\n  padding: 8px 16px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message {\n  padding: 8px 0 16px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-popover-message > .anticon {\n  color: #ffbf00;\n  line-height: 17px;\n  position: absolute;\n}\n.ant-popover-message-title {\n  padding-left: 20px;\n}\n.ant-popover-buttons {\n  text-align: right;\n  margin-bottom: 8px;\n}\n.ant-popover-buttons button {\n  margin-left: 8px;\n}\n.ant-popover-arrow,\n.ant-popover-arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.ant-popover-arrow {\n  border-width: 5px;\n}\n.ant-popover-arrow:after {\n  border-width: 4px;\n  content: \"\";\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  border-bottom-width: 0;\n  border-top-color: rgba(217, 217, 217, 0.7);\n  bottom: 3px;\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  bottom: 1px;\n  margin-left: -4px;\n  border-bottom-width: 0;\n  border-top-color: #fff;\n}\n.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-popover-placement-topLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-topRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  left: 3px;\n  border-left-width: 0;\n  border-right-color: rgba(217, 217, 217, 0.7);\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  left: 1px;\n  bottom: -4px;\n  border-left-width: 0;\n  border-right-color: #fff;\n}\n.ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-popover-placement-rightTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-rightBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  border-top-width: 0;\n  border-bottom-color: rgba(217, 217, 217, 0.7);\n  top: 3px;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  top: 1px;\n  margin-left: -4px;\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {\n  left: 50%;\n  margin-left: -5px;\n}\n.ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow {\n  left: 16px;\n}\n.ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {\n  right: 16px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  right: 3px;\n  border-right-width: 0;\n  border-left-color: rgba(217, 217, 217, 0.7);\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow:after,\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow:after {\n  content: \" \";\n  right: 1px;\n  border-right-width: 0;\n  border-left-color: #fff;\n  bottom: -4px;\n}\n.ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {\n  top: 50%;\n  margin-top: -5px;\n}\n.ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {\n  top: 12px;\n}\n.ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow {\n  bottom: 12px;\n}\n.ant-popover {\n  position: relative;\n  margin: 1px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzPopoverComponent.ctorParameters = function () { return []; };
NzPopoverComponent.propDecorators = {
    'nzContent': [{ type: Input },],
    'nzOrigin': [{ type: ContentChild, args: [NzPopoverDirective,] },],
};
var NzPopoverModule = (function () {
    function NzPopoverModule() {
    }
    return NzPopoverModule;
}());
NzPopoverModule.decorators = [
    { type: NgModule, args: [{
                entryComponents: [NzPopoverComponent],
                exports: [NzPopoverDirective, NzPopoverComponent],
                declarations: [NzPopoverDirective, NzPopoverComponent],
                imports: [CommonModule, OverlayModule]
            },] },
];
/**
 * @nocollapse
 */
NzPopoverModule.ctorParameters = function () { return []; };
var NzRateComponent = (function () {
    function NzRateComponent() {
        this._prefixCls = 'ant-rate';
        this._innerPrefixCls = this._prefixCls + "-star";
        this._starArray = new Array();
        this._count = 5;
        this._value = 0;
        this._hoverValue = 0; // 鼠标悬浮时的星数，为正整数，和_hasHalf配合使用
        this._hasHalf = false;
        this._allowHalf = false;
        this._disabled = false;
        this._floatReg = /^\d+(\.\d+)?$/;
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
    }
    Object.defineProperty(NzRateComponent.prototype, "nzCount", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._count = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzRateComponent.prototype, "nzAllowHalf", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._allowHalf = true;
            }
            else {
                this._allowHalf = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzRateComponent.prototype, "nzDefaultValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._value = value;
            if (this._floatReg.test(value)) {
                value += 0.5;
                this._hasHalf = true;
            }
            this._hoverValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzRateComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value === value) {
                return;
            }
            this._value = value;
            if (this._floatReg.test(value)) {
                value += 0.5;
                this._hasHalf = true;
            }
            this._hoverValue = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzRateComponent.prototype, "nzDisabled", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzRateComponent.prototype.setClassMap = function () {
        this._classMap = (_a = {},
            _a[this._prefixCls] = true,
            _a[this._prefixCls + "-disabled"] = this._disabled,
            _a);
        var _a;
    };
    /**
     * @return {?}
     */
    NzRateComponent.prototype.setChildrenClassMap = function () {
        var /** @type {?} */ index = 0;
        while (index < this._count) {
            this._starArray.push(index++);
        }
    };
    /**
     * @param {?} e
     * @param {?} index
     * @param {?} isFull
     * @return {?}
     */
    NzRateComponent.prototype._clickRate = function (e, index, isFull) {
        e.stopPropagation();
        if (this._disabled) {
            return;
        }
        this._hoverValue = this._value = index + 1;
        this._hasHalf = !isFull && this._allowHalf;
        if (this._hasHalf) {
            this._value -= 0.5;
        }
        this.onChange(this._value);
    };
    /**
     * @param {?} e
     * @param {?} index
     * @param {?} isFull
     * @return {?}
     */
    NzRateComponent.prototype._hoverRate = function (e, index, isFull) {
        e.stopPropagation();
        if (this._disabled) {
            return;
        }
        var /** @type {?} */ isHalf = !isFull && this._allowHalf;
        // 如果星数一致，则不作操作，用于提高性能
        if (this._hoverValue === index + 1 && isHalf === this._hasHalf) {
            return;
        }
        this._hoverValue = index + 1;
        this._hasHalf = isHalf;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzRateComponent.prototype._leaveRate = function (e) {
        e.stopPropagation();
        var /** @type {?} */ oldVal = this._value;
        if (this._floatReg.test(oldVal)) {
            oldVal += 0.5;
            this._hasHalf = true;
        }
        this._hoverValue = oldVal;
    };
    /**
     * @param {?} i
     * @return {?}
     */
    NzRateComponent.prototype.setClasses = function (i) {
        return _a = {},
            _a[this._innerPrefixCls] = true,
            _a[this._innerPrefixCls + "-full"] = (i + 1 < this._hoverValue) || (!this._hasHalf) && (i + 1 === this._hoverValue),
            _a[this._innerPrefixCls + "-half"] = (this._hasHalf) && (i + 1 === this._hoverValue),
            _a[this._innerPrefixCls + "-active"] = (this._hasHalf) && (i + 1 === this._hoverValue),
            _a[this._innerPrefixCls + "-zero"] = (i + 1 > this._hoverValue),
            _a;
        var _a;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzRateComponent.prototype.writeValue = function (value) {
        this.nzValue = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzRateComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzRateComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzRateComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    /**
     * @return {?}
     */
    NzRateComponent.prototype.ngOnInit = function () {
        this.setClassMap();
        this.setChildrenClassMap();
    };
    return NzRateComponent;
}());
NzRateComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-rate',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ul [ngClass]=\"_classMap\" (mouseleave)=\"_leaveRate($event)\">\n      <li *ngFor=\"let star of _starArray; let i = index\"\n        [ngClass]=\"setClasses(i)\"\n        (mouseover)=\"_hoverRate($event, i, true)\"\n        (click)=\"_clickRate($event, i, true)\">\n        <div class=\"ant-rate-star-first\" (mouseover)=\"_hoverRate($event, i)\" (click)=\"_clickRate($event, i)\">\n          <i class=\"anticon anticon-star\"></i></div>\n        <div class=\"ant-rate-star-second\" (mouseover)=\"_hoverRate($event, i, true)\" (click)=\"_clickRate($event, i, true)\">\n          <i class=\"anticon anticon-star\"></i></div>\n      </li>\n    </ul>\n  ",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzRateComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-rate {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  font-size: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.ant-rate-disabled .ant-rate-star {\n  cursor: not-allowed;\n}\n.ant-rate-disabled .ant-rate-star:hover {\n  transform: scale(1);\n}\n.ant-rate-star {\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n  margin-right: 8px;\n  position: relative;\n  transition: all .3s;\n  color: #e9e9e9;\n  cursor: pointer;\n}\n.ant-rate-star-first,\n.ant-rate-star-second {\n  user-select: none;\n  transition: all .3s;\n}\n.ant-rate-star:hover {\n  transform: scale(1.1);\n}\n.ant-rate-star-first {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  opacity: 0;\n}\n.ant-rate-star-half .ant-rate-star-first,\n.ant-rate-star-half .ant-rate-star-second {\n  opacity: 1;\n}\n.ant-rate-star-half .ant-rate-star-first,\n.ant-rate-star-full .ant-rate-star-second {\n  color: #f5a623;\n}\n.ant-rate-star-half:hover .ant-rate-star-first,\n.ant-rate-star-full:hover .ant-rate-star-second {\n  color: #f7b84f;\n}\n.ant-rate-text {\n  margin-left: 8px;\n  vertical-align: middle;\n  display: inline-block;\n  font-size: 12px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzRateComponent.ctorParameters = function () { return []; };
NzRateComponent.propDecorators = {
    'nzCount': [{ type: Input },],
    'nzAllowHalf': [{ type: Input },],
    'nzDefaultValue': [{ type: Input },],
    'nzDisabled': [{ type: Input },],
};
var NzRateModule = (function () {
    function NzRateModule() {
    }
    return NzRateModule;
}());
NzRateModule.decorators = [
    { type: NgModule, args: [{
                exports: [NzRateComponent],
                declarations: [NzRateComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzRateModule.ctorParameters = function () { return []; };
var NzSpinComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function NzSpinComponent(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.nzSpinning = true;
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzSpinComponent.prototype, "nzTip", {
        /**
         * @return {?}
         */
        get: function () {
            return this._tip;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._tip = value || '加载中...';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSpinComponent.prototype, "isNested", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzSpinning && (this._ref.nativeElement.childNodes.length !== 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSpinComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._size = { large: 'lg', small: 'sm' }[value];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzSpinComponent.prototype.ngAfterContentInit = function () {
        if (this._ref.nativeElement.children.length !== 0) {
            this._renderer.setStyle(this._el, 'display', 'block');
        }
    };
    return NzSpinComponent;
}());
NzSpinComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-spin',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div>\n      <div class=\"ant-spin\" [ngClass]=\"{'ant-spin-spinning':nzSpinning,'ant-spin-lg':_size=='lg','ant-spin-sm':_size=='sm','ant-spin-show-text':_tip}\">\n        <span class=\"ant-spin-dot\"><i></i><i></i><i></i><i></i></span>\n        <div class=\"ant-spin-text\">{{_tip}}</div>\n      </div>\n    </div>\n    <div class=\"ant-spin-container\" [class.ant-spin-blur]=\"nzSpinning\" #ref [hidden]=\"ref.children.length == 0\"><ng-content></ng-content></div>\n\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-spin {\n  color: #108ee9;\n  vertical-align: middle;\n  text-align: center;\n  opacity: 0;\n  position: absolute;\n  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  font-size: 12px;\n  display: none;\n}\n.ant-spin-spinning {\n  opacity: 1;\n  position: static;\n  display: inline-block;\n}\n.ant-spin-nested-loading {\n  position: relative;\n}\n.ant-spin-nested-loading > div > .ant-spin {\n  position: absolute;\n  height: 100%;\n  max-height: 320px;\n  width: 100%;\n  z-index: 4;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -10px;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  padding-top: 6px;\n}\n.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {\n  margin-top: -20px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {\n  margin: -7px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {\n  padding-top: 3px;\n}\n.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {\n  margin-top: -17px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {\n  margin: -16px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {\n  padding-top: 12px;\n}\n.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {\n  margin-top: -26px;\n}\n.ant-spin-container {\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  position: relative;\n}\n.ant-spin-blur {\n  overflow: hidden;\n  opacity: 0.7;\n  -webkit-filter: blur(0.5px);\n  filter: blur(0.5px);\n  /* autoprefixer: off */\n  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=1, MakeShadow=false);\n  /* autoprefixer: on */\n  -webkit-transform: translateZ(0);\n}\n.ant-spin-blur:after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: #fff;\n  opacity: 0.3;\n  transition: all .3s;\n  z-index: 10;\n}\n.ant-spin-tip {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-spin-dot {\n  position: relative;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  transform: rotate(45deg);\n  animation: antRotate 1.2s infinite linear;\n}\n.ant-spin-dot i {\n  width: 9px;\n  height: 9px;\n  border-radius: 100%;\n  background-color: #108ee9;\n  transform: scale(0.75);\n  display: block;\n  position: absolute;\n  opacity: 0.3;\n  animation: antSpinMove 1s infinite linear alternate;\n  transform-origin: 50% 50%;\n}\n.ant-spin-dot i:nth-child(1) {\n  left: 0;\n  top: 0;\n}\n.ant-spin-dot i:nth-child(2) {\n  right: 0;\n  top: 0;\n  animation-delay: 0.4s;\n}\n.ant-spin-dot i:nth-child(3) {\n  right: 0;\n  bottom: 0;\n  animation-delay: 0.8s;\n}\n.ant-spin-dot i:nth-child(4) {\n  left: 0;\n  bottom: 0;\n  animation-delay: 1.2s;\n}\n.ant-spin-sm .ant-spin-dot {\n  width: 14px;\n  height: 14px;\n}\n.ant-spin-sm .ant-spin-dot i {\n  width: 6px;\n  height: 6px;\n}\n.ant-spin-lg .ant-spin-dot {\n  width: 32px;\n  height: 32px;\n}\n.ant-spin-lg .ant-spin-dot i {\n  width: 14px;\n  height: 14px;\n}\n.ant-spin.ant-spin-show-text .ant-spin-text {\n  display: block;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /* IE10+ */\n  .ant-spin-blur {\n    background: #fff;\n    opacity: 0.5;\n  }\n}\n@keyframes antSpinMove {\n  to {\n    opacity: 1;\n  }\n}\n@keyframes antRotate {\n  to {\n    transform: rotate(405deg);\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzSpinComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzSpinComponent.propDecorators = {
    'nzSpinning': [{ type: Input },],
    'nzTip': [{ type: Input },],
    '_ref': [{ type: ViewChild, args: ['ref',] },],
    'isNested': [{ type: HostBinding, args: ['class.ant-spin-nested-loading',] },],
    'nzSize': [{ type: Input },],
};
var NzSpinModule = (function () {
    function NzSpinModule() {
    }
    return NzSpinModule;
}());
NzSpinModule.decorators = [
    { type: NgModule, args: [{
                exports: [NzSpinComponent],
                declarations: [NzSpinComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzSpinModule.ctorParameters = function () { return []; };
var NzToolTipModule = (function () {
    function NzToolTipModule() {
    }
    return NzToolTipModule;
}());
NzToolTipModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzToolTipComponent, NzTooltipDirective],
                exports: [NzToolTipComponent, NzTooltipDirective],
                imports: [CommonModule, OverlayModule],
                entryComponents: [NzToolTipComponent]
            },] },
];
/**
 * @nocollapse
 */
NzToolTipModule.ctorParameters = function () { return []; };
var NzSliderService = (function () {
    function NzSliderService() {
    }
    /**
     * @param {?} e
     * @return {?}
     */
    NzSliderService.prototype.pauseEvent = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    /**
     * @param {?} num
     * @return {?}
     */
    NzSliderService.prototype.getPrecision = function (num) {
        var /** @type {?} */ numStr = num.toString(), /** @type {?} */ dotIndex = numStr.indexOf('.');
        return dotIndex >= 0 ? numStr.length - dotIndex - 1 : 0;
    };
    /**
     * @param {?} arr
     * @return {?}
     */
    NzSliderService.prototype.cloneArray = function (arr) {
        return arr.slice();
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzSliderService.prototype.isNotTouchEvent = function (e) {
        return !e.touches || e.touches.length > 1 ||
            (e.type.toLowerCase() === 'touchend' && e.touches.length > 0);
    };
    /**
     * @param {?} min
     * @param {?} max
     * @param {?} value
     * @return {?}
     */
    NzSliderService.prototype.valueToOffset = function (min, max, value) {
        return (value - min) / (max - min) * 100;
    };
    /**
     * @param {?} num
     * @param {?} min
     * @param {?} max
     * @return {?}
     */
    NzSliderService.prototype.correctNumLimit = function (num, min, max) {
        if (isNaN(num = +num)) {
            return min;
        }
        if (num < min) {
            num = min;
        }
        else if (num > max) {
            num = max;
        }
        return num;
    };
    /**
     * get the offset of an element relative to the document (Reference from jquery's offset())
     * @param {?} elem HTMLElement ref
     * @return {?}
     */
    NzSliderService.prototype.getElementOffset = function (elem) {
        // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
        // Support: IE <=11 only
        // Running getBoundingClientRect on a
        // disconnected node in IE throws an error
        if (!elem.getClientRects().length) {
            return { top: 0, left: 0 };
        }
        // Get document-relative position by adding viewport scroll to viewport-relative gBCR
        var /** @type {?} */ rect = elem.getBoundingClientRect(), /** @type {?} */ win = elem.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    };
    return NzSliderService;
}());
NzSliderService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NzSliderService.ctorParameters = function () { return []; };
var NzSliderComponent = (function () {
    /**
     * @param {?} utils
     */
    function NzSliderComponent(utils) {
        this.utils = utils;
        // Debugging
        this.nzDebugId = null; // set this id will print debug informations to console
        // Dynamic property settings
        this.nzDisabled = false;
        // Static configurations (properties that can only specify once)
        this.nzStep = 1;
        this.nzMarks = null;
        this.nzDots = false;
        this.nzMin = 0;
        this.nzMax = 100;
        this.nzIncluded = true;
        this.nzDefaultValue = null;
        this.nzOnAfterChange = new EventEmitter();
        // Inside properties
        this._range = false;
        this._vertical = false;
        this.value = null;
        this.cacheSliderStart = null;
        this.cacheSliderLength = null;
        this.prefixCls = 'ant-slider';
        this.activeValueIndex = null; // Current activated handle's index ONLY for range=true
        this.track = { offset: null, length: null }; // Track's offset and length
        this.bounds = { lower: null, upper: null }; // now for nz-slider-step
        this.isDragging = false; // Current dragging state
    }
    Object.defineProperty(NzSliderComponent.prototype, "nzVertical", {
        /**
         * @return {?}
         */
        get: function () {
            return this._vertical;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._vertical = true;
            }
            else {
                this._vertical = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSliderComponent.prototype, "nzRange", {
        /**
         * @return {?}
         */
        get: function () {
            return this._range;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._range = true;
            }
            else {
                this._range = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} val
     * @param {?=} isWriteValue
     * @return {?}
     */
    NzSliderComponent.prototype.setValue = function (val, isWriteValue) {
        if (isWriteValue === void 0) { isWriteValue = false; }
        if (isWriteValue) {
            this.value = this.formatValue(val);
            this.log("[ngModel:setValue/writeValue]Update track & handles");
            this.updateTrackAndHandles();
            // if (!this.isValueEqual(this.value, val)) {
            //   this.log(`[ngModel:setValue/writeValue]onValueChange`, val);
            //   if (this.onValueChange) { // NOTE: onValueChange will be unavailable when writeValue() called at the first time
            //     this.onValueChange(this.value);
            //   }
            // }
        }
        else {
            if (!this.isValueEqual(this.value, val)) {
                this.value = val;
                this.log("[Normal:setValue]Update track & handles");
                this.updateTrackAndHandles();
                this.log("[Normal:setValue]onValueChange", val);
                if (this.onValueChange) {
                    this.onValueChange(this.value);
                }
            }
        }
    };
    /**
     * @param {?=} cloneAndSort
     * @return {?}
     */
    NzSliderComponent.prototype.getValue = function (cloneAndSort) {
        if (cloneAndSort === void 0) { cloneAndSort = false; }
        if (cloneAndSort && this.nzRange) {
            return this.utils.cloneArray(/** @type {?} */ (this.value)).sort(function (a, b) { return a - b; });
        }
        return this.value;
    };
    /**
     * @param {?=} value
     * @return {?}
     */
    NzSliderComponent.prototype.getValueToOffset = function (value) {
        var _this = this;
        if (typeof value === 'undefined') {
            value = this.getValue(true);
        }
        return this.nzRange ?
            ((value)).map(function (val) { return _this.valueToOffset(val); }) :
            this.valueToOffset(value);
    };
    /**
     * @param {?} val
     * @return {?}
     */
    NzSliderComponent.prototype.writeValue = function (val) {
        if (typeof this.onValueChange !== 'function') {
            return;
        } // ignore the first initial call
        this.log("[ngModel/writeValue]current writing value = ", val);
        this.setValue(val, true);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzSliderComponent.prototype.registerOnChange = function (fn) {
        this.onValueChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzSliderComponent.prototype.registerOnTouched = function (fn) {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzSliderComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
        this.toggleDragDisabled(isDisabled);
        this.setClassMap();
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype.ngOnInit = function () {
        // initial checking
        this.checkValidValue(this.nzDefaultValue); // check nzDefaultValue
        // default handles
        this.handles = this._generateHandles(this.nzRange ? 2 : 1);
        // initialize
        this.sliderDOM = this.slider.nativeElement;
        if (this.getValue() === null) {
            this.setValue(this.formatValue(null));
        } // init with default value
        this.marksArray = this.nzMarks === null ? null : this.toMarksArray(this.nzMarks);
        // event bindings
        this.createDrag();
        // initialize drag's disabled status
        this.toggleDragDisabled(this.nzDisabled);
        // the first time to init classes
        this.setClassMap();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NzSliderComponent.prototype.ngOnChanges = function (changes) {
        var nzDisabled = changes.nzDisabled;
        if (nzDisabled && !nzDisabled.firstChange) {
            this.toggleDragDisabled(nzDisabled.currentValue);
            this.setClassMap();
        }
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeDrag();
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype.setClassMap = function () {
        var _a = this, prefixCls = _a.prefixCls, nzDisabled = _a.nzDisabled, nzVertical = _a.nzVertical, marksArray = _a.marksArray;
        this.classMap = (_b = {},
            _b[prefixCls] = true,
            _b[prefixCls + "-disabled"] = nzDisabled,
            _b[prefixCls + "-vertical"] = nzVertical,
            _b[prefixCls + "-with-marks"] = marksArray ? marksArray.length : 0,
            _b);
        var _b;
    };
    /**
     * @param {?} pointerValue
     * @return {?}
     */
    NzSliderComponent.prototype.setActiveValueIndex = function (pointerValue) {
        if (this.nzRange) {
            var /** @type {?} */ minimal_1 = null, /** @type {?} */ gap_1, /** @type {?} */ activeIndex_1;
            ((this.getValue())).forEach(function (val, index) {
                gap_1 = Math.abs(pointerValue - val);
                if (minimal_1 === null || gap_1 < minimal_1) {
                    minimal_1 = gap_1;
                    activeIndex_1 = index;
                }
            });
            this.activeValueIndex = activeIndex_1;
        }
    };
    /**
     * @param {?} pointerValue
     * @return {?}
     */
    NzSliderComponent.prototype.setActiveValue = function (pointerValue) {
        if (this.nzRange) {
            var /** @type {?} */ newValue = this.utils.cloneArray(/** @type {?} */ (this.value));
            newValue[this.activeValueIndex] = pointerValue;
            this.setValue(newValue);
        }
        else {
            this.setValue(pointerValue);
        }
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype.updateTrackAndHandles = function () {
        var _this = this;
        var /** @type {?} */ value = this.getValue();
        var /** @type {?} */ offset = this.getValueToOffset(value);
        var /** @type {?} */ valueSorted = this.getValue(true);
        var /** @type {?} */ offsetSorted = this.getValueToOffset(valueSorted);
        var /** @type {?} */ boundParts = this.nzRange ? (valueSorted) : [0, valueSorted];
        var /** @type {?} */ trackParts = this.nzRange ? [offsetSorted[0], offsetSorted[1] - offsetSorted[0]] : [0, offsetSorted];
        this.handles.forEach(function (handle, index) {
            handle.offset = _this.nzRange ? offset[index] : offset;
            handle.value = _this.nzRange ? value[index] : value;
        });
        this.bounds.lower = boundParts[0], this.bounds.upper = boundParts[1];
        this.track.offset = trackParts[0], this.track.length = trackParts[1];
    };
    /**
     * @param {?} marks
     * @return {?}
     */
    NzSliderComponent.prototype.toMarksArray = function (marks) {
        var _a = this, nzMin = _a.nzMin, nzMax = _a.nzMax;
        var /** @type {?} */ marksArray = [];
        for (var /** @type {?} */ key in marks) {
            var /** @type {?} */ mark = marks[key];
            var /** @type {?} */ val = typeof key === 'number' ? key : parseFloat(key);
            if (val < nzMin || val > nzMax) {
                continue;
            }
            marksArray.push({ value: val, offset: this.valueToOffset(val), config: mark });
        }
        return marksArray;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSliderComponent.prototype.onDragStart = function (value) {
        this.log('[onDragStart]dragging value = ', value);
        this.toggleDragMoving(true);
        // cache DOM layout/reflow operations
        this.cacheSliderProperty();
        // trigger drag start
        this.setActiveValueIndex(value);
        this.setActiveValue(value);
        // Tooltip visibility of handles
        this._showHandleTooltip(this.nzRange ? this.activeValueIndex : 0);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSliderComponent.prototype.onDragMove = function (value) {
        this.log('[onDragMove]dragging value = ', value);
        // trigger drag moving
        this.setActiveValue(value);
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype.onDragEnd = function () {
        this.log('[onDragEnd]');
        this.toggleDragMoving(false);
        this.nzOnAfterChange.emit(this.getValue(true));
        // remove cache DOM layout/reflow operations
        this.cacheSliderProperty(true);
        // Hide all tooltip
        this._hideAllHandleTooltip();
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype.createDrag = function () {
        var _this = this;
        var /** @type {?} */ sliderDOM = this.sliderDOM, /** @type {?} */ orientField = this.nzVertical ? 'pageY' : 'pageX', /** @type {?} */ mouse = {
            start: 'mousedown', move: 'mousemove', end: 'mouseup',
            pluckKey: [orientField]
        }, /** @type {?} */ touch = {
            start: 'touchstart', move: 'touchmove', end: 'touchend',
            pluckKey: ['touches', '0', orientField],
            filter: function (e) { return !_this.utils.isNotTouchEvent(/** @type {?} */ (e)); }
        };
        // make observables
        [mouse, touch].forEach(function (source) {
            var start = source.start, move = source.move, end = source.end, pluckKey = source.pluckKey, _a = source.filter, filter$$1 = _a === void 0 ? function () { return true; } : _a;
            // start
            source.startPlucked$ = (_b = ((RxChain.from(fromEvent$1(sliderDOM, start))))
                .call(filter$1, filter$$1)
                .call(_do$1, _this.utils.pauseEvent)).call.apply(_b, [pluck$1].concat(pluckKey)).call(map$1, function (position) { return _this.findClosestValue(position); })
                .result();
            // end
            source.end$ = fromEvent$1(document, end);
            // resolve move
            source.moveResolved$ = (_c = ((RxChain.from(fromEvent$1(document, move))))
                .call(filter$1, filter$$1)
                .call(_do$1, _this.utils.pauseEvent)).call.apply(_c, [pluck$1].concat(pluckKey)).call(distinctUntilChanged$1)
                .call(map$1, function (position) { return _this.findClosestValue(position); })
                .call(distinctUntilChanged$1)
                .call(takeUntil$1, source.end$)
                .result();
            var _b, _c;
            // merge to become moving
            // source.move$ = source.startPlucked$.mergeMapTo(source.moveResolved$);
        });
        // merge mouse and touch observables
        this.dragstart$ = merge$1(mouse.startPlucked$, touch.startPlucked$);
        // this.dragmove$ = Observable.merge(mouse.move$, touch.move$);
        this.dragmove$ = merge$1(mouse.moveResolved$, touch.moveResolved$);
        this.dragend$ = merge$1(mouse.end$, touch.end$);
    };
    /**
     * @param {?=} periods
     * @return {?}
     */
    NzSliderComponent.prototype.subscribeDrag = function (periods) {
        if (periods === void 0) { periods = ['start', 'move', 'end']; }
        this.log('[subscribeDrag]this.dragstart$ = ', this.dragstart$);
        if (periods.indexOf('start') !== -1 && this.dragstart$ && !this.dragstart_) {
            this.dragstart_ = this.dragstart$.subscribe(this.onDragStart.bind(this));
        }
        if (periods.indexOf('move') !== -1 && this.dragmove$ && !this.dragmove_) {
            this.dragmove_ = this.dragmove$.subscribe(this.onDragMove.bind(this));
        }
        if (periods.indexOf('end') !== -1 && this.dragend$ && !this.dragend_) {
            this.dragend_ = this.dragend$.subscribe(this.onDragEnd.bind(this));
        }
    };
    /**
     * @param {?=} periods
     * @return {?}
     */
    NzSliderComponent.prototype.unsubscribeDrag = function (periods) {
        if (periods === void 0) { periods = ['start', 'move', 'end']; }
        this.log('[unsubscribeDrag]this.dragstart_ = ', this.dragstart_);
        if (periods.indexOf('start') !== -1 && this.dragstart_) {
            this.dragstart_.unsubscribe();
            this.dragstart_ = null;
        }
        if (periods.indexOf('move') !== -1 && this.dragmove_) {
            this.dragmove_.unsubscribe();
            this.dragmove_ = null;
        }
        if (periods.indexOf('end') !== -1 && this.dragend_) {
            this.dragend_.unsubscribe();
            this.dragend_ = null;
        }
    };
    /**
     * @param {?} movable
     * @return {?}
     */
    NzSliderComponent.prototype.toggleDragMoving = function (movable) {
        var /** @type {?} */ periods = ['move', 'end'];
        if (movable) {
            this.isDragging = true;
            this.subscribeDrag(periods);
        }
        else {
            this.isDragging = false;
            this.unsubscribeDrag(periods);
        }
    };
    /**
     * @param {?} disabled
     * @return {?}
     */
    NzSliderComponent.prototype.toggleDragDisabled = function (disabled) {
        if (disabled) {
            this.unsubscribeDrag();
        }
        else {
            this.subscribeDrag(['start']);
        }
    };
    /**
     * @param {?} position
     * @return {?}
     */
    NzSliderComponent.prototype.findClosestValue = function (position) {
        var _a = this, nzVertical = _a.nzVertical, nzStep = _a.nzStep, nzMin = _a.nzMin, nzMax = _a.nzMax, nzMarks = _a.nzMarks, nzDots = _a.nzDots, utils = _a.utils, /** @type {?} */ sliderStart = this.getSliderStartPosition(), /** @type {?} */ sliderLength = this.getSliderLength();
        var /** @type {?} */ ratio = utils.correctNumLimit((position - sliderStart) / sliderLength, 0, 1), /** @type {?} */ val = (nzMax - nzMin) * (nzVertical ? 1 - ratio : ratio) + nzMin, /** @type {?} */ points = ((nzMarks === null ? [] : Object.keys(nzMarks).map(parseFloat)));
        // push closest step
        if (nzStep !== null && !nzDots) {
            var /** @type {?} */ closest_1 = Math.round(val / nzStep) * nzStep;
            points.push(closest_1);
        }
        // calculate gaps
        var /** @type {?} */ gaps = points.map(function (point) { return Math.abs(val - point); });
        var /** @type {?} */ closest = points[gaps.indexOf(Math.min.apply(Math, gaps))];
        // return the fixed
        return nzStep === null ? closest :
            parseFloat(closest.toFixed(utils.getPrecision(nzStep)));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSliderComponent.prototype.valueToOffset = function (value) {
        return this.utils.valueToOffset(this.nzMin, this.nzMax, value);
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype.getSliderStartPosition = function () {
        if (this.cacheSliderStart !== null) {
            return this.cacheSliderStart;
        }
        var /** @type {?} */ offset = this.utils.getElementOffset(this.sliderDOM);
        return this.nzVertical ? offset.top : offset.left;
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype.getSliderLength = function () {
        if (this.cacheSliderLength !== null) {
            return this.cacheSliderLength;
        }
        var /** @type {?} */ sliderDOM = this.sliderDOM;
        return this.nzVertical ?
            sliderDOM.clientHeight : sliderDOM.clientWidth;
    };
    /**
     * @param {?=} remove
     * @return {?}
     */
    NzSliderComponent.prototype.cacheSliderProperty = function (remove) {
        if (remove === void 0) { remove = false; }
        this.cacheSliderStart = remove ? null : this.getSliderStartPosition();
        this.cacheSliderLength = remove ? null : this.getSliderLength();
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSliderComponent.prototype.formatValue = function (value) {
        var _this = this;
        if (!this.checkValidValue(value)) {
            value = this.nzDefaultValue === null ?
                (this.nzRange ? [this.nzMin, this.nzMax] : this.nzMin) : this.nzDefaultValue;
        }
        else {
            value = this.nzRange ?
                ((value)).map(function (val) { return _this.utils.correctNumLimit(val, _this.nzMin, _this.nzMax); }) :
                this.utils.correctNumLimit(value, this.nzMin, this.nzMax);
        }
        return value;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSliderComponent.prototype.checkValidValue = function (value) {
        var /** @type {?} */ range = this.nzRange;
        if (value === null || value === undefined) {
            return false;
        } // it's an invalid value, just return
        var /** @type {?} */ isArray = Array.isArray(value);
        if (!isArray) {
            if (typeof value !== 'number') {
                value = parseFloat(value);
            }
            if (isNaN(value)) {
                return false;
            } // it's an invalid value, just return
        }
        if (isArray !== !!range) {
            throw new Error("The \"nzRange\" can't match the \"nzValue\"'s type, please check these properties: \"nzRange\", \"nzValue\", \"nzDefaultValue\".");
        }
        return true;
    };
    /**
     * @param {?} value
     * @param {?} val
     * @return {?}
     */
    NzSliderComponent.prototype.isValueEqual = function (value, val) {
        if (typeof value !== typeof val) {
            return false;
        }
        if (Array.isArray(value)) {
            var /** @type {?} */ len = ((value)).length;
            for (var /** @type {?} */ i = 0; i < len; i++) {
                if (value[i] !== val[i]) {
                    return false;
                }
            }
            return true;
        }
        else {
            return value === val;
        }
    };
    /**
     * @param {...?} messages
     * @return {?}
     */
    NzSliderComponent.prototype.log = function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        if (this.nzDebugId !== null) {
            var /** @type {?} */ args = ["[nz-slider][#" + this.nzDebugId + "] "].concat(Array.prototype.slice.call(arguments));
            console.log.apply(null, args);
        }
    };
    /**
     * @param {?=} handleIndex
     * @return {?}
     */
    NzSliderComponent.prototype._showHandleTooltip = function (handleIndex) {
        var _this = this;
        if (handleIndex === void 0) { handleIndex = 0; }
        this.handles.forEach(function (handle, index) {
            _this.handles[index].active = index === handleIndex;
        });
    };
    /**
     * @return {?}
     */
    NzSliderComponent.prototype._hideAllHandleTooltip = function () {
        this.handles.forEach(function (handle) { return handle.active = false; });
    };
    /**
     * @param {?} amount
     * @return {?}
     */
    NzSliderComponent.prototype._generateHandles = function (amount) {
        var /** @type {?} */ handles = [];
        for (var /** @type {?} */ i = 0; i < amount; i++) {
            handles.push({ offset: null, value: null, active: false });
        }
        return handles;
    };
    return NzSliderComponent;
}());
NzSliderComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-slider',
                encapsulation: ViewEncapsulation.None,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzSliderComponent; }),
                        multi: true
                    }],
                template: "\n    <div #slider [ngClass]=\"classMap\">\n      <div class=\"ant-slider-rail\"></div>\n      <nz-slider-track\n        nzClassName=\"{{prefixCls}}-track\"\n        [nzVertical]=\"nzVertical\"\n        [nzIncluded]=\"nzIncluded\"\n        [nzOffset]=\"track.offset\"\n        [nzLength]=\"track.length\"\n      ></nz-slider-track>\n      <nz-slider-step *ngIf=\"marksArray\"\n        nzPrefixCls=\"{{prefixCls}}\"\n        [nzVertical]=\"nzVertical\"\n        [nzLowerBound]=\"bounds.lower\"\n        [nzUpperBound]=\"bounds.upper\"\n        [nzMarksArray]=\"marksArray\"\n        [nzIncluded]=\"nzIncluded\"\n      ></nz-slider-step>\n      <nz-slider-handle\n        *ngFor=\"let handle of handles;\"\n        nzClassName=\"{{prefixCls}}-handle\"\n        [nzVertical]=\"nzVertical\"\n        [nzOffset]=\"handle.offset\"\n        [nzValue]=\"handle.value\"\n        [nzActive]=\"handle.active\"\n        [nzTipFormatter]=\"nzTipFormatter\"\n      ></nz-slider-handle>\n      <nz-slider-marks *ngIf=\"marksArray\"\n        nzClassName=\"{{prefixCls}}-mark\"\n        [nzVertical]=\"nzVertical\"\n        [nzMin]=\"nzMin\"\n        [nzMax]=\"nzMax\"\n        [nzLowerBound]=\"bounds.lower\"\n        [nzUpperBound]=\"bounds.upper\"\n        [nzMarksArray]=\"marksArray\"\n        [nzIncluded]=\"nzIncluded\"\n      ></nz-slider-marks>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-slider {\n  position: relative;\n  margin: 10px 6px;\n  padding: 4px 0;\n  height: 12px;\n  cursor: pointer;\n}\n.ant-slider-vertical {\n  width: 12px;\n  height: 100%;\n  margin: 6px 10px;\n  padding: 0 4px;\n}\n.ant-slider-vertical .ant-slider-rail {\n  height: 100%;\n  width: 4px;\n}\n.ant-slider-vertical .ant-slider-track {\n  width: 4px;\n}\n.ant-slider-vertical .ant-slider-handle {\n  margin-left: -5px;\n  margin-bottom: -7px;\n}\n.ant-slider-vertical .ant-slider-mark {\n  top: 0;\n  left: 12px;\n  width: 18px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-mark-text {\n  left: 4px;\n  white-space: nowrap;\n}\n.ant-slider-vertical .ant-slider-step {\n  width: 4px;\n  height: 100%;\n}\n.ant-slider-vertical .ant-slider-dot {\n  top: auto;\n  left: 2px;\n  margin-bottom: -4px;\n}\n.ant-slider-with-marks {\n  margin-bottom: 28px;\n}\n.ant-slider-rail {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  background-color: #e9e9e9;\n  transition: background-color 0.3s ease;\n}\n.ant-slider-track {\n  position: absolute;\n  height: 4px;\n  border-radius: 4px;\n  background-color: #9fd2f6;\n  transition: background-color 0.3s ease;\n}\n.ant-slider-handle {\n  position: absolute;\n  margin-left: -7px;\n  margin-top: -5px;\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  border-radius: 50%;\n  border: solid 2px #88c7f4;\n  background-color: #fff;\n  transition: border-color 0.3s ease, transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n}\n.ant-slider-handle:hover {\n  border-color: #49a9ee;\n  transform: scale(1.2);\n  transform-origin: center center;\n}\n.ant-slider-handle:active {\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n}\n.ant-slider:hover .ant-slider-rail {\n  background-color: #e1e1e1;\n}\n.ant-slider:hover .ant-slider-track {\n  background-color: #70bbf2;\n}\n.ant-slider:hover .ant-slider-handle {\n  border-color: #49a9ee;\n}\n.ant-slider-mark {\n  position: absolute;\n  top: 14px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n.ant-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-slider-mark-text-active {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n.ant-slider-dot {\n  position: absolute;\n  top: -2px;\n  margin-left: -4px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid #e9e9e9;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n.ant-slider-dot:first-child {\n  margin-left: -4px;\n}\n.ant-slider-dot:last-child {\n  margin-left: -4px;\n}\n.ant-slider-dot-active {\n  border-color: #88c7f4;\n}\n.ant-slider-disabled {\n  cursor: not-allowed;\n}\n.ant-slider-disabled .ant-slider-track {\n  background-color: rgba(0, 0, 0, 0.25) !important;\n}\n.ant-slider-disabled .ant-slider-handle,\n.ant-slider-disabled .ant-slider-dot {\n  border-color: rgba(0, 0, 0, 0.25) !important;\n  background-color: #fff;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n.ant-slider-disabled .ant-slider-mark-text,\n.ant-slider-disabled .ant-slider-dot {\n  cursor: not-allowed !important;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzSliderComponent.ctorParameters = function () { return [
    { type: NzSliderService, },
]; };
NzSliderComponent.propDecorators = {
    'nzDebugId': [{ type: Input },],
    'nzDisabled': [{ type: Input },],
    'nzStep': [{ type: Input },],
    'nzMarks': [{ type: Input },],
    'nzDots': [{ type: Input },],
    'nzMin': [{ type: Input },],
    'nzMax': [{ type: Input },],
    'nzIncluded': [{ type: Input },],
    'nzDefaultValue': [{ type: Input },],
    'nzTipFormatter': [{ type: Input },],
    'nzOnAfterChange': [{ type: Output },],
    'nzVertical': [{ type: Input },],
    'nzRange': [{ type: Input },],
    'slider': [{ type: ViewChild, args: ['slider',] },],
};
var NzSliderTrackComponent = (function () {
    function NzSliderTrackComponent() {
        this.style = {};
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NzSliderTrackComponent.prototype.ngOnChanges = function (changes) {
        var _a = this, nzOffset = _a.nzOffset, nzLength = _a.nzLength, nzIncluded = _a.nzIncluded, nzVertical = _a.nzVertical, style$$1 = _a.style;
        if (changes.nzIncluded) {
            style$$1.visibility = nzIncluded ? 'visible' : 'hidden';
        }
        if (changes.nzVertical || changes.nzOffset || changes.nzLength) {
            if (nzVertical) {
                style$$1.bottom = nzOffset + "%";
                style$$1.height = nzLength + "%";
            }
            else {
                style$$1.left = nzOffset + "%";
                style$$1.width = nzLength + "%";
            }
        }
    };
    return NzSliderTrackComponent;
}());
NzSliderTrackComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-slider-track',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div [class]=\"nzClassName\" [ngStyle]=\"style\"></div>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzSliderTrackComponent.ctorParameters = function () { return []; };
NzSliderTrackComponent.propDecorators = {
    'nzOffset': [{ type: Input },],
    'nzLength': [{ type: Input },],
    'nzClassName': [{ type: Input },],
    'nzVertical': [{ type: Input },],
    'nzIncluded': [{ type: Input },],
};
var NzSliderHandleComponent = (function () {
    /**
     * @param {?} _slider
     */
    function NzSliderHandleComponent(_slider) {
        this._slider = _slider;
        this.style = {};
    }
    Object.defineProperty(NzSliderHandleComponent.prototype, "nzActive", {
        /**
         * @param {?} show
         * @return {?}
         */
        set: function (show) {
            if (this.tooltip) {
                if (show) {
                    this.tooltip.show();
                }
                else {
                    this.tooltip.hide();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzSliderHandleComponent.prototype.ngOnInit = function () {
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NzSliderHandleComponent.prototype.ngOnChanges = function (changes) {
        if (changes.nzOffset) {
            this._updateStyle();
        }
        if (changes.nzValue) {
            this._updateTooltipTitle(); // [For tooltip]
            this._updateTooltipPosition(); // [For tooltip]
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzSliderHandleComponent.prototype.onMouseEnter = function ($event) {
        if (!this._slider.isDragging) {
            this.nzActive = true;
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzSliderHandleComponent.prototype.onMouseLeave = function ($event) {
        if (!this._slider.isDragging) {
            this.nzActive = false;
        }
    };
    /**
     * @return {?}
     */
    NzSliderHandleComponent.prototype._updateTooltipTitle = function () {
        this.tooltipTitle = this.nzTipFormatter ? this.nzTipFormatter(this.nzValue) : this.nzValue;
    };
    /**
     * @return {?}
     */
    NzSliderHandleComponent.prototype._updateTooltipPosition = function () {
        var _this = this;
        if (this.tooltip) {
            window.setTimeout(function () { return _this.tooltip.updatePosition(); }, 0); // MAY use ngAfterViewChecked? but this will be called so many times.
        }
    };
    /**
     * @return {?}
     */
    NzSliderHandleComponent.prototype._updateStyle = function () {
        this.style[this.nzVertical ? 'bottom' : 'left'] = this.nzOffset + "%";
    };
    return NzSliderHandleComponent;
}());
NzSliderHandleComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-slider-handle',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <nz-tooltip *ngIf=\"nzTipFormatter !== null\" #tooltip [nzTitle]=\"tooltipTitle\" [nzTrigger]=\"null\">\n      <div nz-tooltip [class]=\"nzClassName\" [ngStyle]=\"style\"></div>\n    </nz-tooltip>\n    <div *ngIf=\"nzTipFormatter === null\" [class]=\"nzClassName\" [ngStyle]=\"style\"></div>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzSliderHandleComponent.ctorParameters = function () { return [
    { type: NzSliderComponent, },
]; };
NzSliderHandleComponent.propDecorators = {
    'nzClassName': [{ type: Input },],
    'nzVertical': [{ type: Input },],
    'nzOffset': [{ type: Input },],
    'nzValue': [{ type: Input },],
    'nzTipFormatter': [{ type: Input },],
    'nzActive': [{ type: Input },],
    'tooltip': [{ type: ViewChild, args: ['tooltip',] },],
    'onMouseEnter': [{ type: HostListener, args: ['mouseenter', ['$event'],] },],
    'onMouseLeave': [{ type: HostListener, args: ['mouseleave', ['$event'],] },],
};
var NzSliderStepComponent = (function () {
    function NzSliderStepComponent() {
        // Dynamic properties
        this.nzLowerBound = null;
        this.nzUpperBound = null;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NzSliderStepComponent.prototype.ngOnChanges = function (changes) {
        if (changes.nzLowerBound || changes.nzUpperBound) {
            this.togglePointActive();
        }
    };
    /**
     * @return {?}
     */
    NzSliderStepComponent.prototype.ngOnInit = function () {
        var /** @type {?} */ orient = this.nzVertical ? 'bottom' : 'left', /** @type {?} */ prefixCls = this.nzPrefixCls;
        this.attrs = this.nzMarksArray.map(function (mark) {
            var value = mark.value, offset = mark.offset;
            return {
                id: value,
                value: value,
                offset: offset,
                style: (_a = {},
                    _a[orient] = offset + "%",
                    _a),
                classes: (_b = {},
                    _b[prefixCls + "-dot"] = true,
                    _b[prefixCls + "-dot-active"] = false,
                    _b)
            };
            var _a, _b;
        });
        this.togglePointActive();
    };
    /**
     * @param {?} index
     * @param {?} attr
     * @return {?}
     */
    NzSliderStepComponent.prototype.trackById = function (index, attr) {
        return attr.id;
    };
    /**
     * @return {?}
     */
    NzSliderStepComponent.prototype.togglePointActive = function () {
        var _a = this, nzPrefixCls = _a.nzPrefixCls, attrs = _a.attrs, nzLowerBound = _a.nzLowerBound, nzUpperBound = _a.nzUpperBound, nzIncluded = _a.nzIncluded;
        if (attrs && nzLowerBound !== null && nzUpperBound !== null) {
            attrs.forEach(function (attr) {
                var /** @type {?} */ value = attr.value, /** @type {?} */ isActive = (!nzIncluded && value === nzUpperBound) ||
                    (nzIncluded && value <= nzUpperBound && value >= nzLowerBound);
                attr.classes[nzPrefixCls + "-dot-active"] = isActive;
            });
        }
    };
    return NzSliderStepComponent;
}());
NzSliderStepComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-slider-step',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"{{nzPrefixCls}}-step\">\n      <span *ngFor=\"let attr of attrs; trackBy: trackById\" [ngClass]=\"attr.classes\" [ngStyle]=\"attr.style\"></span>\n    </div>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzSliderStepComponent.ctorParameters = function () { return []; };
NzSliderStepComponent.propDecorators = {
    'nzLowerBound': [{ type: Input },],
    'nzUpperBound': [{ type: Input },],
    'nzPrefixCls': [{ type: Input },],
    'nzVertical': [{ type: Input },],
    'nzMarksArray': [{ type: Input },],
    'nzIncluded': [{ type: Input },],
};
var NzSliderMarksComponent = (function () {
    function NzSliderMarksComponent() {
        // Dynamic properties
        this.nzLowerBound = null;
        this.nzUpperBound = null;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NzSliderMarksComponent.prototype.ngOnChanges = function (changes) {
        if (changes.nzLowerBound || changes.nzUpperBound) {
            this.togglePointActive();
        }
    };
    /**
     * @return {?}
     */
    NzSliderMarksComponent.prototype.ngOnInit = function () {
        var _a = this, nzVertical = _a.nzVertical, nzClassName = _a.nzClassName, nzMarksArray = _a.nzMarksArray, nzMin = _a.nzMin, nzMax = _a.nzMax, nzLowerBound = _a.nzLowerBound, nzUpperBound = _a.nzUpperBound;
        var /** @type {?} */ range = nzMax - nzMin;
        this.attrs = nzMarksArray.map(function (mark) {
            var value = mark.value, offset = mark.offset, config = mark.config;
            // calc styles
            var /** @type {?} */ label = config, /** @type {?} */ style$$1;
            if (nzVertical) {
                style$$1 = {
                    marginBottom: '-50%',
                    bottom: (value - nzMin) / range * 100 + "%"
                };
            }
            else {
                var /** @type {?} */ marksCount = nzMarksArray.length, /** @type {?} */ unit = 100 / (marksCount - 1), /** @type {?} */ markWidth = unit * 0.9;
                style$$1 = {
                    width: markWidth + "%",
                    marginLeft: -markWidth / 2 + "%",
                    left: (value - nzMin) / range * 100 + "%"
                };
            }
            // custom configuration
            if (typeof config === 'object') {
                label = config.label;
                if (config.style) {
                    style$$1 = Object.assign({}, style$$1, config.style);
                }
            }
            return {
                id: value,
                value: value,
                offset: offset,
                classes: (_a = {},
                    _a[nzClassName + "-text"] = true,
                    _a),
                style: style$$1,
                label: label
            };
            var _a;
        }); // END - map
        this.togglePointActive();
    };
    /**
     * @param {?} index
     * @param {?} attr
     * @return {?}
     */
    NzSliderMarksComponent.prototype.trackById = function (index, attr) {
        return attr.id;
    };
    /**
     * @return {?}
     */
    NzSliderMarksComponent.prototype.togglePointActive = function () {
        var _a = this, nzClassName = _a.nzClassName, attrs = _a.attrs, nzLowerBound = _a.nzLowerBound, nzUpperBound = _a.nzUpperBound, nzIncluded = _a.nzIncluded;
        if (attrs && nzLowerBound !== null && nzUpperBound !== null) {
            attrs.forEach(function (attr) {
                var /** @type {?} */ value = attr.value, /** @type {?} */ isActive = (!nzIncluded && value === nzUpperBound) ||
                    (nzIncluded && value <= nzUpperBound && value >= nzLowerBound);
                attr.classes[nzClassName + "-text-active"] = isActive;
            });
        }
    };
    return NzSliderMarksComponent;
}());
NzSliderMarksComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-slider-marks',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div [class]=\"nzClassName\">\n      <span *ngFor=\"let attr of attrs; trackBy: trackById\" [ngClass]=\"attr.classes\" [ngStyle]=\"attr.style\" [innerHTML]=\"attr.label\"></span>\n    </div>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzSliderMarksComponent.ctorParameters = function () { return []; };
NzSliderMarksComponent.propDecorators = {
    'nzLowerBound': [{ type: Input },],
    'nzUpperBound': [{ type: Input },],
    'nzClassName': [{ type: Input },],
    'nzVertical': [{ type: Input },],
    'nzMarksArray': [{ type: Input },],
    'nzMin': [{ type: Input },],
    'nzMax': [{ type: Input },],
    'nzIncluded': [{ type: Input },],
};
var NzSliderModule = (function () {
    function NzSliderModule() {
    }
    return NzSliderModule;
}());
NzSliderModule.decorators = [
    { type: NgModule, args: [{
                exports: [NzSliderComponent, NzSliderTrackComponent, NzSliderHandleComponent, NzSliderStepComponent, NzSliderMarksComponent],
                declarations: [NzSliderComponent, NzSliderTrackComponent, NzSliderHandleComponent, NzSliderStepComponent, NzSliderMarksComponent],
                imports: [CommonModule, NzToolTipModule],
                providers: [NzSliderService]
            },] },
];
/**
 * @nocollapse
 */
NzSliderModule.ctorParameters = function () { return []; };
var NzSwitchComponent = (function () {
    function NzSwitchComponent() {
        this._prefixCls = 'ant-switch';
        this._innerPrefixCls = this._prefixCls + "-inner";
        this._checked = false;
        this._disabled = false;
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
    }
    Object.defineProperty(NzSwitchComponent.prototype, "nzSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._size;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._size = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzSwitchComponent.prototype, "nzDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = value;
            this.setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?} e
     * @return {?}
     */
    NzSwitchComponent.prototype.onClick = function (e) {
        e.preventDefault();
        if (!this._disabled) {
            this.updateValue(!this._checked);
            this.onChange(this._checked);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSwitchComponent.prototype.updateValue = function (value) {
        if (this._checked === value) {
            return;
        }
        this._checked = value;
        this.setClassMap();
    };
    /**
     * @return {?}
     */
    NzSwitchComponent.prototype.setClassMap = function () {
        this._classMap = (_a = {},
            _a[this._prefixCls] = true,
            _a[this._prefixCls + "-checked"] = this._checked,
            _a[this._prefixCls + "-disabled"] = this._disabled,
            _a[this._prefixCls + "-small"] = this._size === 'small',
            _a);
        var _a;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzSwitchComponent.prototype.writeValue = function (value) {
        this.updateValue(value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzSwitchComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzSwitchComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NzSwitchComponent.prototype.setDisabledState = function (isDisabled) {
        this.nzDisabled = isDisabled;
    };
    /**
     * @return {?}
     */
    NzSwitchComponent.prototype.ngOnInit = function () {
        this.setClassMap();
    };
    return NzSwitchComponent;
}());
NzSwitchComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-switch',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <span [ngClass]=\"_classMap\" tabindex=\"0\">\n      <span [ngClass]=\"_innerPrefixCls\">\n        <ng-template [ngIf]=\"_checked\">\n          <ng-content select=\"[checked]\"></ng-content>\n        </ng-template>\n        <ng-template [ngIf]=\"!_checked\">\n          <ng-content select=\"[unchecked]\"></ng-content>\n        </ng-template>\n      </span>\n    </span>\n  ",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzSwitchComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-switch {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  height: 22px;\n  min-width: 44px;\n  line-height: 20px;\n  vertical-align: middle;\n  border-radius: 20px;\n  border: 1px solid transparent;\n  background-color: rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  transition: all 0.36s;\n  user-select: none;\n}\n.ant-switch-inner {\n  color: #fff;\n  font-size: 12px;\n  margin-left: 24px;\n  margin-right: 6px;\n  display: block;\n}\n.ant-switch:after {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  left: 1px;\n  top: 1px;\n  border-radius: 18px;\n  background-color: #fff;\n  content: \" \";\n  cursor: pointer;\n  transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.ant-switch:active:after {\n  width: 24px;\n}\n.ant-switch:focus {\n  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);\n  outline: 0;\n}\n.ant-switch:focus:hover {\n  box-shadow: none;\n}\n.ant-switch-small {\n  height: 14px;\n  min-width: 28px;\n  line-height: 12px;\n}\n.ant-switch-small .ant-switch-inner {\n  margin-left: 18px;\n  margin-right: 3px;\n}\n.ant-switch-small:after {\n  width: 12px;\n  height: 12px;\n  top: 0;\n  left: 0.5px;\n}\n.ant-switch-small:active:after {\n  width: 16px;\n}\n.ant-switch-small.ant-switch-checked:after {\n  left: 100%;\n  margin-left: -12.5px;\n}\n.ant-switch-small.ant-switch-checked .ant-switch-inner {\n  margin-left: 3px;\n  margin-right: 18px;\n}\n.ant-switch-small:active.ant-switch-checked:after {\n  margin-left: -16.5px;\n}\n.ant-switch-checked {\n  background-color: #108ee9;\n}\n.ant-switch-checked .ant-switch-inner {\n  margin-left: 6px;\n  margin-right: 24px;\n}\n.ant-switch-checked:after {\n  left: 100%;\n  margin-left: -19px;\n}\n.ant-switch-checked:active:after {\n  margin-left: -25px;\n}\n.ant-switch-disabled {\n  cursor: not-allowed;\n  background: #f4f4f4;\n}\n.ant-switch-disabled:after {\n  background: #ccc;\n  cursor: not-allowed;\n}\n.ant-switch-disabled .ant-switch-inner {\n  color: rgba(0, 0, 0, 0.25);\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzSwitchComponent.ctorParameters = function () { return []; };
NzSwitchComponent.propDecorators = {
    'nzSize': [{ type: Input },],
    'nzDisabled': [{ type: Input },],
    'onClick': [{ type: HostListener, args: ['click', ['$event'],] },],
};
var NzSwitchModule = (function () {
    function NzSwitchModule() {
    }
    return NzSwitchModule;
}());
NzSwitchModule.decorators = [
    { type: NgModule, args: [{
                exports: [NzSwitchComponent],
                declarations: [NzSwitchComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzSwitchModule.ctorParameters = function () { return []; };
var scrollbarWidth;
// Measure scrollbar width for padding body during modal show/hide
var scrollbarMeasure = {
    position: 'absolute',
    top: '-9999px',
    width: '50px',
    height: '50px',
    overflow: 'scroll',
};
/**
 * @return {?}
 */
function measureScrollbar() {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return 0;
    }
    if (scrollbarWidth) {
        return scrollbarWidth;
    }
    var /** @type {?} */ scrollDiv = document.createElement('div');
    for (var /** @type {?} */ scrollProp in scrollbarMeasure) {
        if (scrollbarMeasure.hasOwnProperty(scrollProp)) {
            scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
        }
    }
    document.body.appendChild(scrollDiv);
    var /** @type {?} */ width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    scrollbarWidth = width;
    return scrollbarWidth;
}
var NzThDirective = (function () {
    /**
     * @param {?} _elementRef
     */
    function NzThDirective(_elementRef) {
        this._elementRef = _elementRef;
        this._el = this._elementRef.nativeElement;
    }
    return NzThDirective;
}());
NzThDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-th]'
            },] },
];
/**
 * @nocollapse
 */
NzThDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NzThDirective.propDecorators = {
    'nzWidth': [{ type: Input },],
    'nzCheckbox': [{ type: Input }, { type: HostBinding, args: ["class.ant-table-selection-column",] },],
    'nzExpand': [{ type: Input }, { type: HostBinding, args: ["class.ant-table-expand-icon-th",] },],
};
var NzTableComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _cd
     */
    function NzTableComponent(_elementRef, _cd) {
        this._elementRef = _elementRef;
        this._cd = _cd;
        /**
         * public data for ngFor tr
         */
        this.data = [];
        this._current = 1;
        this._pageSize = 10;
        this._dataSet = [];
        this._isInit = false;
        this._isAjax = false;
        this.ths = [];
        this.nzPageSizeChange = new EventEmitter();
        this.nzPageIndexChange = new EventEmitter();
        this.nzDataChange = new EventEmitter();
        this.nzPageIndexChangeClick = new EventEmitter();
        this.nzBordered = false;
        this.nzCustomNoResult = false;
        this.nzIsPagination = true;
        this.nzLoading = false;
        this.nzShowSizeChanger = false;
        this.nzShowQuickJumper = false;
        this.nzShowTotal = false;
        this.nzShowFooter = false;
        this.nzShowTitle = false;
        this.nzIsPageIndexReset = true;
        this._el = this._elementRef.nativeElement;
    }
    Object.defineProperty(NzTableComponent.prototype, "setThs", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.ths = value.toArray();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTableComponent.prototype, "nzScroll", {
        /**
         * @return {?}
         */
        get: function () {
            return this._scroll;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._scroll = value;
            this._cd.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTableComponent.prototype, "nzAjaxData", {
        /**
         * async data
         * @return {?}
         */
        get: function () {
            return this.data;
        },
        /**
         * @param {?} data
         * @return {?}
         */
        set: function (data) {
            this._isAjax = true;
            this.data = data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTableComponent.prototype, "nzDataSource", {
        /**
         * sync data
         * @return {?}
         */
        get: function () {
            return this._dataSet;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._dataSet = value;
            this.nzTotal = this._dataSet.length;
            this._generateData(true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTableComponent.prototype, "nzPageIndex", {
        /**
         * @return {?}
         */
        get: function () {
            return this._current;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._current === value) {
                return;
            }
            this._current = value;
            this._generateData();
            this.nzPageIndexChange.emit(this.nzPageIndex);
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    /**
     * @param {?} value
     * @return {?}
     */
    NzTableComponent.prototype.pageChangeClick = function (value) {
        this.nzPageIndexChangeClick.emit(value);
    };
    Object.defineProperty(NzTableComponent.prototype, "nzPageSize", {
        /**
         * @return {?}
         */
        get: function () {
            return this._pageSize;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._pageSize === value) {
                return;
            }
            this._pageSize = value;
            this._generateData();
            if (this._isInit) {
                this.nzPageSizeChange.emit(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Object.defineProperty(NzTableComponent.prototype, "nzTotal", {
        /**
         * @return {?}
         */
        get: function () {
            return this._total;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._total === value) {
                return;
            }
            this._total = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @param {?=} forceRefresh
     * @return {?}
     */
    NzTableComponent.prototype._generateData = function (forceRefresh) {
        if (forceRefresh === void 0) { forceRefresh = false; }
        if (!this._isAjax) {
            if (this.nzIsPagination) {
                if (forceRefresh) {
                    if (this.nzIsPageIndexReset) {
                        this.nzPageIndex = 1;
                    }
                    else {
                        var /** @type {?} */ maxPageIndex = Math.ceil(this._dataSet.length / this.nzPageSize);
                        this.nzPageIndex = !this.nzPageIndex ? 1 : (this.nzPageIndex > maxPageIndex ? maxPageIndex : this.nzPageIndex);
                    }
                }
                this.data = this._dataSet.slice((this.nzPageIndex - 1) * this.nzPageSize, this.nzPageIndex * this.nzPageSize);
            }
            else {
                this.data = this._dataSet;
            }
            this.nzDataChange.emit(this.data);
        }
    };
    /**
     * @return {?}
     */
    NzTableComponent.prototype.ngOnInit = function () {
        var /** @type {?} */ scrollbarWidth = measureScrollbar();
        this._headerBottomStyle = {
            marginBottom: "-" + scrollbarWidth + "px",
            paddingBottom: "0px"
        };
    };
    /**
     * @return {?}
     */
    NzTableComponent.prototype.ngAfterViewInit = function () {
        this._isInit = true;
    };
    return NzTableComponent;
}());
NzTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-table',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div\n      class=\"ant-table-wrapper\"\n      [class.ant-table-empty]=\"data.length==0\">\n      <nz-spin [nzSpinning]=\"nzLoading\">\n        <div>\n          <div\n            class=\"ant-table\"\n            [class.ant-table-fixed-header]=\"nzScroll\"\n            [class.ant-table-scroll-position-left]=\"nzScroll\"\n            [class.ant-table-bordered]=\"nzBordered\"\n            [class.ant-table-large]=\"(nzSize!=='middle')&&(nzSize!=='small')\"\n            [class.ant-table-middle]=\"nzSize=='middle'\"\n            [class.ant-table-small]=\"nzSize=='small'\">\n            <div class=\"ant-table-title\" *ngIf=\"nzShowTitle\">\n              <ng-content select=\"[nz-table-title]\"></ng-content>\n            </div>\n            <div class=\"ant-table-content\">\n              <div [class.ant-table-scroll]=\"nzScroll\">\n                <div class=\"ant-table-header\" [ngStyle]=\"_headerBottomStyle\" *ngIf=\"nzScroll\">\n                  <table>\n                    <colgroup>\n                      <col *ngFor=\"let th of ths\" [style.width]=\"th.nzWidth\" [style.minWidth]=\"th.nzWidth\">\n                    </colgroup>\n                    <ng-template [ngTemplateOutlet]=\"fixedHeader\"></ng-template>\n                  </table>\n                </div>\n                <div class=\"ant-table-body\" [style.maxHeight.px]=\"nzScroll?.y\" [style.overflowY]=\"nzScroll?.y?'scroll':''\">\n                  <table>\n                    <colgroup>\n                      <col [style.width]=\"th.nzWidth\" [style.minWidth]=\"th.nzWidth\" *ngFor=\"let th of ths\">\n                    </colgroup>\n                    <ng-content></ng-content>\n                  </table>\n                </div>\n                <div class=\"ant-table-placeholder\" *ngIf=\"data.length==0 && !nzCustomNoResult\">\n                  <span>\u6CA1\u6709\u6570\u636E</span>\n                </div>\n                <div class=\"ant-table-placeholder\" *ngIf=\"data.length==0 && nzCustomNoResult\">\n                  <ng-content select=\"[noResult]\"></ng-content>\n                </div>\n                <div class=\"ant-table-footer\" *ngIf=\"nzShowFooter\">\n                  <ng-content select=\"[nz-table-footer]\"></ng-content>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <nz-pagination\n          *ngIf=\"nzIsPagination&&data.length\"\n          class=\"ant-table-pagination\"\n          [nzShowSizeChanger]=\"nzShowSizeChanger\"\n          [nzShowQuickJumper]=\"nzShowQuickJumper\"\n          [nzShowTotal]=\"nzShowTotal\"\n          [nzSize]=\"(nzSize=='middle'||nzSize=='small')?'small':''\"\n          [(nzPageSize)]=\"nzPageSize\"\n          [nzTotal]=\"nzTotal\"\n          [(nzPageIndex)]=\"nzPageIndex\"\n          (nzPageIndexClickChange)=\"pageChangeClick($event)\">\n        </nz-pagination>\n      </nz-spin>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-table-wrapper {\n  zoom: 1;\n}\n.ant-table-wrapper:before,\n.ant-table-wrapper:after {\n  content: \" \";\n  display: table;\n}\n.ant-table-wrapper:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-table {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n  overflow: hidden;\n  position: relative;\n  border-radius: 4px 4px 0 0;\n  /* fix firefox scrollbar bug */\n}\n.ant-table-body {\n  transition: opacity 0.3s ease;\n}\n.ant-table table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  text-align: left;\n  border-radius: 4px 4px 0 0;\n  overflow: hidden;\n}\n.ant-table-thead > tr > th {\n  background: #f7f7f7;\n  font-weight: 500;\n  transition: background .3s ease;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-table-thead > tr > th[colspan] {\n  text-align: center;\n}\n.ant-table-thead > tr > th .anticon-filter,\n.ant-table-thead > tr > th .ant-table-filter-icon {\n  position: relative;\n  margin-left: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  color: #aaa;\n  transition: all .3s;\n  width: 14px;\n}\n.ant-table-thead > tr > th .anticon-filter:hover,\n.ant-table-thead > tr > th .ant-table-filter-icon:hover {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-table-thead > tr > th .anticon-filter:after,\n.ant-table-thead > tr > th .ant-table-filter-icon:after {\n  content: '';\n  position: absolute;\n  width: 14px;\n  height: 50px;\n  left: 0;\n  top: -19px;\n}\n.ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {\n  color: #108ee9;\n}\n.ant-table-tbody > tr > td {\n  border-bottom: 1px solid #e9e9e9;\n  transition: all .3s;\n}\n.ant-table-thead > tr,\n.ant-table-tbody > tr {\n  transition: all .3s;\n}\n.ant-table-thead > tr.ant-table-row-hover > td,\n.ant-table-tbody > tr.ant-table-row-hover > td,\n.ant-table-thead > tr:hover > td,\n.ant-table-tbody > tr:hover > td {\n  background: #ecf6fd;\n}\n.ant-table-thead > tr:hover {\n  background: none;\n}\n.ant-table-footer {\n  padding: 16px 8px;\n  background: #f7f7f7;\n  border-radius: 0 0 4px 4px;\n  position: relative;\n}\n.ant-table-footer:before {\n  content: '';\n  height: 1px;\n  background: #f7f7f7;\n  position: absolute;\n  top: -1px;\n  width: 100%;\n  left: 0;\n}\n.ant-table.ant-table-bordered .ant-table-footer {\n  border: 1px solid #e9e9e9;\n}\n.ant-table-title {\n  padding: 16px 0;\n  position: relative;\n  top: 1px;\n  border-radius: 4px 4px 0 0;\n}\n.ant-table.ant-table-bordered .ant-table-title {\n  border: 1px solid #e9e9e9;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-table-title + .ant-table-content {\n  position: relative;\n  border-radius: 4px 4px 0 0;\n  overflow: hidden;\n}\n.ant-table-bordered .ant-table-title + .ant-table-content,\n.ant-table-bordered .ant-table-title + .ant-table-content table {\n  border-radius: 0;\n}\n.ant-table-without-column-header .ant-table-title + .ant-table-content,\n.ant-table-without-column-header table {\n  border-radius: 0;\n}\n.ant-table-tbody > tr.ant-table-row-selected {\n  background: #fafafa;\n}\n.ant-table-thead > tr > th.ant-table-column-sort {\n  background: #eee;\n}\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td {\n  padding: 16px 8px;\n  word-break: break-all;\n}\n.ant-table-thead > tr > th.ant-table-selection-column-custom {\n  padding-left: 16px;\n  padding-right: 0;\n}\n.ant-table-thead > tr > th.ant-table-selection-column,\n.ant-table-tbody > tr > td.ant-table-selection-column {\n  text-align: center;\n  min-width: 62px;\n  width: 62px;\n}\n.ant-table-expand-icon-th,\n.ant-table-row-expand-icon-cell {\n  text-align: center;\n  min-width: 50px;\n  width: 50px;\n}\n.ant-table-header {\n  background: #f7f7f7;\n  overflow: hidden;\n}\n.ant-table-header table {\n  border-radius: 4px 4px 0 0;\n}\n.ant-table-loading {\n  position: relative;\n}\n.ant-table-loading .ant-table-body {\n  background: #fff;\n  opacity: 0.5;\n}\n.ant-table-loading .ant-table-spin-holder {\n  height: 20px;\n  line-height: 20px;\n  left: 50%;\n  top: 50%;\n  margin-left: -30px;\n  position: absolute;\n}\n.ant-table-loading .ant-table-with-pagination {\n  margin-top: -20px;\n}\n.ant-table-loading .ant-table-without-pagination {\n  margin-top: 10px;\n}\n.ant-table-middle .ant-table-thead > tr > th:not(.ant-table-selection-column),\n.ant-table-middle .ant-table-tbody > tr > td {\n  padding: 10px 8px;\n}\n.ant-table-middle .ant-table-title,\n.ant-table-middle .ant-table-footer {\n  padding: 10px 8px;\n}\n.ant-table-middle .ant-table-column-sorter-up:after {\n  top: -13px;\n  height: 13px;\n}\n.ant-table-middle .ant-table-column-sorter-down:after {\n  bottom: -11px;\n  height: 13px;\n}\n.ant-table-middle .ant-table-thead > tr > th .anticon-filter:after,\n.ant-table-middle .ant-table-thead > tr > th .ant-table-filter-icon:after {\n  height: 38px;\n  top: -13px;\n}\n.ant-table-small {\n  border: 1px solid #e9e9e9;\n  border-radius: 4px;\n}\n.ant-table-small .ant-table-header > table,\n.ant-table-small .ant-table-body > table {\n  border: 0;\n  padding: 0 8px;\n}\n.ant-table-small .ant-table-thead > tr > th {\n  background: #fff;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-table-small .ant-table-tbody > tr > td {\n  padding: 6px 8px;\n}\n.ant-table-small .ant-table-title,\n.ant-table-small .ant-table-footer,\n.ant-table-small .ant-table-thead > tr > th:not(.ant-table-selection-column) {\n  padding: 10px 8px;\n}\n.ant-table-small .ant-table-title {\n  border-bottom: 1px solid #e9e9e9;\n  top: 0;\n}\n.ant-table-small .ant-table-header {\n  background: #fff;\n}\n.ant-table-small .ant-table-header table {\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-table-small .ant-table-placeholder,\n.ant-table-small .ant-table-row:last-child td {\n  border-bottom: 0;\n}\n.ant-table-small .ant-table-column-sorter-up:after {\n  top: -14px;\n  height: 13px;\n}\n.ant-table-small .ant-table-column-sorter-down:after {\n  bottom: -11px;\n  height: 13px;\n}\n.ant-table-small .ant-table-thead > tr > th .anticon-filter:after,\n.ant-table-small .ant-table-thead > tr > th .ant-table-filter-icon:after {\n  height: 39px;\n  top: -14px;\n}\n.ant-table-column-sorter {\n  position: relative;\n  margin-left: 4px;\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  vertical-align: middle;\n  text-align: center;\n}\n.ant-table-column-sorter-up,\n.ant-table-column-sorter-down {\n  line-height: 4px;\n  display: block;\n  width: 14px;\n  cursor: pointer;\n}\n.ant-table-column-sorter-up:hover .anticon,\n.ant-table-column-sorter-down:hover .anticon {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-table-column-sorter-up.on .anticon-caret-up,\n.ant-table-column-sorter-down.on .anticon-caret-up,\n.ant-table-column-sorter-up.on .anticon-caret-down,\n.ant-table-column-sorter-down.on .anticon-caret-down {\n  color: #108ee9;\n}\n.ant-table-column-sorter-up:after,\n.ant-table-column-sorter-down:after {\n  position: absolute;\n  content: '';\n  height: 20px;\n  width: 14px;\n  left: 0;\n}\n.ant-table-column-sorter-up:after {\n  top: -19px;\n}\n.ant-table-column-sorter-down:after {\n  bottom: -17px;\n}\n.ant-table-column-sorter .anticon-caret-up,\n.ant-table-column-sorter .anticon-caret-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  line-height: 6px;\n  height: 6px;\n  color: #aaa;\n}\n:root .ant-table-column-sorter .anticon-caret-up,\n:root .ant-table-column-sorter .anticon-caret-down {\n  filter: none;\n}\n:root .ant-table-column-sorter .anticon-caret-up,\n:root .ant-table-column-sorter .anticon-caret-down {\n  font-size: 12px;\n}\n.ant-table-column-sorter .anticon-caret-up:before,\n.ant-table-column-sorter .anticon-caret-down:before {\n  -moz-transform-origin: 53% 50%;\n  /* fix firefox position */\n}\n.ant-table-bordered .ant-table-header > table,\n.ant-table-bordered .ant-table-body > table,\n.ant-table-bordered .ant-table-fixed-left table,\n.ant-table-bordered .ant-table-fixed-right table {\n  border: 1px solid #e9e9e9;\n  border-right: 0;\n  border-bottom: 0;\n}\n.ant-table-bordered.ant-table-empty .ant-table-placeholder {\n  border-left: 1px solid #e9e9e9;\n  border-right: 1px solid #e9e9e9;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {\n  border-bottom: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {\n  border-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {\n  border-top: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-placeholder {\n  border: 0;\n}\n.ant-table-bordered .ant-table-thead > tr > th {\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-table-bordered .ant-table-thead > tr > th,\n.ant-table-bordered .ant-table-tbody > tr > td {\n  border-right: 1px solid #e9e9e9;\n}\n.ant-table-bordered.ant-table-small {\n  border-right: 0;\n}\n.ant-table-bordered.ant-table-small .ant-table-header > table,\n.ant-table-bordered.ant-table-small .ant-table-body > table,\n.ant-table-bordered.ant-table-small .ant-table-fixed-left table,\n.ant-table-bordered.ant-table-small .ant-table-fixed-right table {\n  border: 0;\n  padding: 0;\n}\n.ant-table-bordered.ant-table-small .ant-table-title {\n  border: 0;\n  border-bottom: 1px solid #e9e9e9;\n  border-right: 1px solid #e9e9e9;\n}\n.ant-table-bordered.ant-table-small .ant-table-footer {\n  border: 0;\n  border-top: 1px solid #e9e9e9;\n  border-right: 1px solid #e9e9e9;\n}\n.ant-table-bordered.ant-table-small .ant-table-footer:before {\n  display: none;\n}\n.ant-table-bordered.ant-table-small .ant-table-placeholder {\n  border-left: 0;\n  border-bottom: 0;\n}\n.ant-table-placeholder {\n  position: relative;\n  padding: 16px 8px;\n  background: #fff;\n  border-bottom: 1px solid #e9e9e9;\n  text-align: center;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-table-placeholder .anticon {\n  margin-right: 4px;\n}\n.ant-table-pagination {\n  margin: 16px 0;\n  float: right;\n}\n.ant-table-filter-dropdown {\n  min-width: 96px;\n  margin-left: -8px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu {\n  border: 0;\n  box-shadow: none;\n  border-radius: 4px 4px 0 0;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-without-submenu {\n  max-height: 400px;\n  overflow-x: hidden;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {\n  padding: 0;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-sub {\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title:after {\n  color: #108ee9;\n  font-weight: bold;\n  text-shadow: 0 0 2px #d2eafb;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-item {\n  overflow: hidden;\n}\n.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,\n.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {\n  border-radius: 0;\n}\n.ant-table-filter-dropdown-btns {\n  overflow: hidden;\n  padding: 7px 8px;\n  border-top: 1px solid #e9e9e9;\n}\n.ant-table-filter-dropdown-link {\n  color: #108ee9;\n}\n.ant-table-filter-dropdown-link:hover {\n  color: #49a9ee;\n}\n.ant-table-filter-dropdown-link:active {\n  color: #0e77ca;\n}\n.ant-table-filter-dropdown-link.confirm {\n  float: left;\n}\n.ant-table-filter-dropdown-link.clear {\n  float: right;\n}\n.ant-table-selection-select-all-custom {\n  margin-right: 4px !important;\n}\n.ant-table-selection .anticon-down {\n  color: #aaa;\n  transition: all .3s;\n}\n.ant-table-selection-menu {\n  min-width: 96px;\n  margin-top: 5px;\n  margin-left: -30px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-table-selection-menu .ant-action-down {\n  color: #aaa;\n}\n.ant-table-selection-down {\n  cursor: pointer;\n  padding: 0;\n  display: inline-block;\n  line-height: 1;\n}\n.ant-table-selection-down:hover .anticon-down {\n  color: #666;\n}\n.ant-table-row-expand-icon {\n  cursor: pointer;\n  display: inline-block;\n  width: 17px;\n  height: 17px;\n  text-align: center;\n  line-height: 14px;\n  border: 1px solid #e9e9e9;\n  user-select: none;\n  background: #fff;\n}\n.ant-table-row-expanded:after {\n  content: '-';\n}\n.ant-table-row-collapsed:after {\n  content: '+';\n}\n.ant-table-row-spaced {\n  visibility: hidden;\n}\n.ant-table-row-spaced:after {\n  content: '.';\n}\n.ant-table-row[class*=\"ant-table-row-level-0\"] .ant-table-selection-column > span {\n  display: inline-block;\n}\ntr.ant-table-expanded-row,\ntr.ant-table-expanded-row:hover {\n  background: #fbfbfb;\n}\n.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-right: 8px;\n}\n.ant-table-scroll {\n  overflow: auto;\n  overflow-x: hidden;\n}\n.ant-table-scroll table {\n  width: auto;\n  min-width: 100%;\n}\n.ant-table-body-inner {\n  height: 100%;\n}\n.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {\n  position: relative;\n  background: #fff;\n}\n.ant-table-fixed-header .ant-table-body-inner {\n  overflow: scroll;\n}\n.ant-table-fixed-header .ant-table-scroll .ant-table-header {\n  overflow: scroll;\n  padding-bottom: 20px;\n  margin-bottom: -20px;\n}\n.ant-table-fixed-header.ant-table-empty .ant-table-scroll .ant-table-body {\n  padding-bottom: 20px;\n  margin-bottom: -20px;\n}\n.ant-table-fixed-left,\n.ant-table-fixed-right {\n  position: absolute;\n  top: 0;\n  overflow: hidden;\n  transition: box-shadow 0.3s ease;\n  border-radius: 0;\n}\n.ant-table-fixed-left table,\n.ant-table-fixed-right table {\n  width: auto;\n  background: #fff;\n}\n.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,\n.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {\n  border-radius: 0;\n}\n.ant-table-fixed-left {\n  left: 0;\n  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.2);\n}\n.ant-table-fixed-left .ant-table-header {\n  overflow-y: hidden;\n}\n.ant-table-fixed-left .ant-table-body-inner {\n  margin-right: -20px;\n  padding-right: 20px;\n}\n.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {\n  padding-right: 0;\n}\n.ant-table-fixed-left,\n.ant-table-fixed-left table {\n  border-radius: 4px 0 0 0;\n}\n.ant-table-fixed-right {\n  right: 0;\n  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.2);\n}\n.ant-table-fixed-right,\n.ant-table-fixed-right table {\n  border-radius: 0 4px 0 0;\n}\n.ant-table-fixed-right .ant-table-expanded-row {\n  color: transparent;\n  pointer-events: none;\n}\n.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {\n  box-shadow: none;\n}\n.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {\n  box-shadow: none;\n}\n",
                    ".nz-resize-container {\n  position: relative;\n}\n.nz-resize-y {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 10px;\n  height: 102%;\n  background: transparent;\n  cursor: col-resize;\n}\n.nz-resizing th,\n.nz-resizing td {\n  user-select: none;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzTableComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: ChangeDetectorRef, },
]; };
NzTableComponent.propDecorators = {
    'nzPageSizeChange': [{ type: Output },],
    'nzPageIndexChange': [{ type: Output },],
    'nzDataChange': [{ type: Output },],
    'nzPageIndexChangeClick': [{ type: Output },],
    'nzBordered': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzCustomNoResult': [{ type: Input },],
    'nzIsPagination': [{ type: Input },],
    'nzLoading': [{ type: Input },],
    'nzShowSizeChanger': [{ type: Input },],
    'nzShowQuickJumper': [{ type: Input },],
    'nzShowTotal': [{ type: Input },],
    'nzShowFooter': [{ type: Input },],
    'nzShowTitle': [{ type: Input },],
    'nzIsPageIndexReset': [{ type: Input },],
    'fixedHeader': [{ type: ContentChild, args: ['nzFixedHeader',] },],
    'setThs': [{ type: ContentChildren, args: [NzThDirective, { descendants: true },] },],
    'nzScroll': [{ type: Input },],
    'nzAjaxData': [{ type: Input },],
    'nzDataSource': [{ type: Input },],
    'nzPageIndex': [{ type: Input },],
    'nzPageSize': [{ type: Input },],
    'nzTotal': [{ type: Input },],
};
var NzTdDirective = (function () {
    /**
     * @param {?} _elementRef
     */
    function NzTdDirective(_elementRef) {
        this._elementRef = _elementRef;
        this._el = this._elementRef.nativeElement;
    }
    return NzTdDirective;
}());
NzTdDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-td]'
            },] },
];
/**
 * @nocollapse
 */
NzTdDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NzTdDirective.propDecorators = {
    'nzCheckbox': [{ type: Input }, { type: HostBinding, args: ["class.ant-table-selection-column",] },],
    'nzExpand': [{ type: Input }, { type: HostBinding, args: ["class.ant-table-row-expand-icon-cell",] },],
};
var NzRowExpandIconComponent = (function () {
    function NzRowExpandIconComponent() {
        this.nzExpand = false;
        this.nzShowExpand = false;
        this.nzExpandChange = new EventEmitter();
        this._expandIcon = true;
    }
    Object.defineProperty(NzRowExpandIconComponent.prototype, "expanded", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzExpand && !this.nzShowExpand;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzRowExpandIconComponent.prototype, "collapsed", {
        /**
         * @return {?}
         */
        get: function () {
            return !this.nzExpand && !this.nzShowExpand;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzRowExpandIconComponent.prototype.onClick = function () {
        this.nzExpand = !this.nzExpand;
        this.nzExpandChange.emit(this.nzExpand);
    };
    return NzRowExpandIconComponent;
}());
NzRowExpandIconComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-row-expand-icon',
                template: ""
            },] },
];
/**
 * @nocollapse
 */
NzRowExpandIconComponent.ctorParameters = function () { return []; };
NzRowExpandIconComponent.propDecorators = {
    'nzExpand': [{ type: Input },],
    'nzShowExpand': [{ type: Input }, { type: HostBinding, args: ['class.ant-table-row-spaced',] },],
    'nzExpandChange': [{ type: Output },],
    'expanded': [{ type: HostBinding, args: ["class.ant-table-row-expanded",] },],
    'collapsed': [{ type: HostBinding, args: ["class.ant-table-row-collapsed",] },],
    '_expandIcon': [{ type: HostBinding, args: ["class.ant-table-row-expand-icon",] },],
    'onClick': [{ type: HostListener, args: ['click',] },],
};
var NzRowIndentComponent = (function () {
    function NzRowIndentComponent() {
        this._rowIndent = true;
    }
    Object.defineProperty(NzRowIndentComponent.prototype, "paddingLeft", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzIndentSize * 20;
        },
        enumerable: true,
        configurable: true
    });
    return NzRowIndentComponent;
}());
NzRowIndentComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-row-indent',
                template: ""
            },] },
];
/**
 * @nocollapse
 */
NzRowIndentComponent.ctorParameters = function () { return []; };
NzRowIndentComponent.propDecorators = {
    'nzIndentSize': [{ type: Input },],
    'paddingLeft': [{ type: HostBinding, args: ["style.paddingLeft.px",] },],
    '_rowIndent': [{ type: HostBinding, args: ["class.ant-table-row-indent",] },],
};
var NzMenuComponent = (function () {
    function NzMenuComponent() {
        /**
         * set when has submenu component
         */
        this.hasSubMenu = false;
        /**
         * set when in dropdown component
         */
        this.isInDropDown = false;
        /**
         * collection of menu item
         */
        this.menuItems = [];
        /**
         * collection of sub menu
         */
        this.subMenus = [];
        /**
         * view init flat
         */
        this.isInit = false;
        /**
         * opened index of array
         */
        this._subMenusOpenIndex = [];
        /**
         * nzInlineCollapsed
         */
        this._nzInlineCollapsed = false;
        this.nzMode = 'vertical';
        this.nzTheme = 'light';
        this.nzClickActive = true;
    }
    Object.defineProperty(NzMenuComponent.prototype, "nzInlineCollapsed", {
        /**
         * @return {?}
         */
        get: function () {
            return this._nzInlineCollapsed;
        },
        /**
         * @param {?} state
         * @return {?}
         */
        set: function (state$$1) {
            var _this = this;
            this._nzInlineCollapsed = state$$1;
            if (!this.isInit) {
                return;
            }
            if (this._nzInlineCollapsed) {
                this.hideSubMenus();
                // after the animation is over
                setTimeout(function () { return _this.nzMode = 'vertical'; }, 150);
            }
            else {
                this.reductionSubMenus();
                this.nzMode = this._tempMode;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "_isInDropDownClass", {
        /**
         * define host class
         * @return {?}
         */
        get: function () {
            return this.isInDropDown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "_isNotInDropDownClass", {
        /**
         * @return {?}
         */
        get: function () {
            return !this.isInDropDown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "setDropDownThemeLightClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isInDropDown && (this.nzTheme === 'light');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "setDropDownThemeDarkClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isInDropDown && (this.nzTheme === 'dark');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "setMenuThemeLightClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzTheme === 'light');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "setMenuThemeDarkClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzTheme === 'dark');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "setMenuVerticalClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzMode === 'vertical');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "setMenuHorizontalClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzMode === 'horizontal');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "setMenuInlineClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzMode === 'inline');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuComponent.prototype, "setMenuInlineCollapsedClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzMode !== 'horizontal') && this.nzInlineCollapsed;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    NzMenuComponent.prototype.ngOnChanges = function (changes) {
        for (var /** @type {?} */ propName in changes) {
            if (propName === 'nzMode') {
                if (this.isInit) {
                    this.subMenus.forEach(function (submenu) {
                        submenu.nzOpen = false;
                        submenu.nzOpenChange.emit(false);
                    });
                }
            }
        }
    };
    /**
     * @return {?}
     */
    NzMenuComponent.prototype.ngAfterViewInit = function () {
        this.isInit = true;
        this._tempMode = this.nzMode;
    };
    /**
     * trigger when menu item clicked
     * @return {?}
     */
    NzMenuComponent.prototype.clearAllSelected = function () {
        this.menuItems.forEach(function (menu) { return menu.nzSelected = false; });
    };
    /**
     * @return {?}
     */
    NzMenuComponent.prototype.hideSubMenus = function () {
        var _this = this;
        this._subMenusOpenIndex = [];
        this.subMenus.forEach(function (submenu, index) {
            if (submenu.nzOpen) {
                _this._subMenusOpenIndex.push(index);
            }
            submenu.nzOpen = false;
        });
    };
    /**
     * @return {?}
     */
    NzMenuComponent.prototype.reductionSubMenus = function () {
        var _this = this;
        this._subMenusOpenIndex.forEach(function (i) { return _this.subMenus[i].nzOpen = true; });
        this._subMenusOpenIndex = [];
    };
    /**
     * api for dropdown or navigation to set isInDropDown status
     * @param {?} value
     * @return {?}
     */
    NzMenuComponent.prototype.setDropDown = function (value) {
        var _this = this;
        setTimeout(function (_) {
            _this.isInDropDown = value;
            _this.menuItems.forEach(function (menu) { return menu.isInDropDown = value; });
            _this.subMenus.forEach(function (subMenu) { return subMenu.isInDropDown = value; });
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzMenuComponent.prototype.setHasSubMenu = function (value) {
        var _this = this;
        setTimeout(function (_) {
            _this.hasSubMenu = value;
        });
    };
    return NzMenuComponent;
}());
NzMenuComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-menu]',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-menu {\n  outline: none;\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n  z-index: 1050;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  color: rgba(0, 0, 0, 0.65);\n  background: #fff;\n  line-height: 46px;\n  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-hidden {\n  display: none;\n}\n.ant-menu-item-group-list {\n  margin: 0;\n  padding: 0;\n}\n.ant-menu-item-group-title {\n  color: rgba(0, 0, 0, 0.43);\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 8px 16px;\n}\n.ant-menu-item,\n.ant-menu-submenu,\n.ant-menu-submenu-title {\n  cursor: pointer;\n}\n.ant-menu-submenu,\n.ant-menu-submenu-inline {\n  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item,\n.ant-menu-submenu-title {\n  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item:active,\n.ant-menu-submenu-title:active {\n  background: #ecf6fd;\n}\n.ant-menu-submenu .ant-menu-sub {\n  cursor: initial;\n  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item > a {\n  display: block;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-menu-item > a:hover {\n  color: #108ee9;\n}\n.ant-menu-item > a:focus {\n  text-decoration: none;\n}\n.ant-menu-item > a:before {\n  position: absolute;\n  background-color: transparent;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  content: '';\n}\n.ant-menu-item-divider {\n  height: 1px;\n  overflow: hidden;\n  background-color: #e9e9e9;\n  line-height: 0;\n}\n.ant-menu-item:hover,\n.ant-menu-item-active,\n.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n.ant-menu-submenu-active,\n.ant-menu-submenu-title:hover {\n  color: #108ee9;\n}\n.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open {\n  z-index: 1050;\n}\n.ant-menu-horizontal .ant-menu-item,\n.ant-menu-horizontal .ant-menu-submenu {\n  margin-top: -1px;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {\n  background-color: transparent;\n}\n.ant-menu-item-selected {\n  color: #108ee9;\n}\n.ant-menu-item-selected > a,\n.ant-menu-item-selected > a:hover {\n  color: #108ee9;\n}\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #ecf6fd;\n}\n.ant-menu-horizontal,\n.ant-menu-inline,\n.ant-menu-vertical {\n  z-index: auto;\n}\n.ant-menu-inline,\n.ant-menu-vertical {\n  border-right: 1px solid #e9e9e9;\n}\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-item {\n  margin-left: -1px;\n  left: 1px;\n  position: relative;\n  z-index: 1;\n}\n.ant-menu-inline .ant-menu-item:after,\n.ant-menu-vertical .ant-menu-item:after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-right: 3px solid #108ee9;\n  transform: scaleY(0.0001);\n  opacity: 0;\n  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.ant-menu-vertical.ant-menu-sub {\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub .ant-menu-item {\n  border-right: 0;\n  margin-left: 0;\n  left: 0;\n}\n.ant-menu-vertical.ant-menu-sub .ant-menu-item:after {\n  border-right: 0;\n}\n.ant-menu-vertical.ant-menu-sub > .ant-menu-item:first-child {\n  border-radius: 4px 4px 0 0;\n}\n.ant-menu-vertical.ant-menu-sub > .ant-menu-item:last-child,\n.ant-menu-vertical.ant-menu-sub > .ant-menu-item-group:last-child > .ant-menu-item-group-list:last-child > .ant-menu-item:last-child {\n  border-radius: 0 0 4px 4px;\n}\n.ant-menu-vertical.ant-menu-sub > .ant-menu-item:only-child {\n  border-radius: 4px;\n}\n.ant-menu-inline {\n  width: 100%;\n}\n.ant-menu-inline .ant-menu-selected:after,\n.ant-menu-inline .ant-menu-item-selected:after {\n  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  opacity: 1;\n  transform: scaleY(1);\n}\n.ant-menu-vertical.ant-menu-inline-collapsed,\n.ant-menu-inline-collapsed {\n  width: 64px;\n}\n.ant-menu-vertical.ant-menu-inline-collapsed > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-item,\n.ant-menu-vertical.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  left: 0;\n  text-overflow: clip;\n  padding: 0 24px;\n}\n.ant-menu-vertical.ant-menu-inline-collapsed > .ant-menu-item:after,\n.ant-menu-inline-collapsed > .ant-menu-item:after,\n.ant-menu-vertical.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title:after,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title:after {\n  display: none;\n}\n.ant-menu-vertical.ant-menu-inline-collapsed > .ant-menu-item .anticon,\n.ant-menu-inline-collapsed > .ant-menu-item .anticon,\n.ant-menu-vertical.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {\n  font-size: 16px;\n  line-height: 42px;\n  margin: 0;\n}\n.ant-menu-vertical.ant-menu-inline-collapsed > .ant-menu-item .anticon + span,\n.ant-menu-inline-collapsed > .ant-menu-item .anticon + span,\n.ant-menu-vertical.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {\n  max-width: 0;\n  display: inline-block;\n  opacity: 0;\n}\n.ant-menu-vertical.ant-menu-inline-collapsed-tooltip,\n.ant-menu-inline-collapsed-tooltip {\n  pointer-events: none;\n}\n.ant-menu-vertical.ant-menu-inline-collapsed-tooltip .anticon,\n.ant-menu-inline-collapsed-tooltip .anticon {\n  display: none;\n}\n.ant-menu-vertical.ant-menu-inline-collapsed-tooltip a,\n.ant-menu-inline-collapsed-tooltip a {\n  color: rgba(255, 255, 255, 0.91);\n}\n.ant-menu-submenu-horizontal > .ant-menu {\n  top: 100%;\n  left: 0;\n  position: absolute;\n  min-width: 100%;\n  margin-top: 7px;\n  z-index: 1050;\n}\n.ant-menu-submenu-vertical {\n  z-index: 1;\n}\n.ant-menu-submenu-vertical > .ant-menu {\n  top: 0;\n  left: 100%;\n  position: absolute;\n  min-width: 160px;\n  margin-left: 4px;\n  z-index: 1050;\n}\n.ant-menu-item,\n.ant-menu-submenu-title {\n  margin: 0;\n  padding: 0 20px;\n  position: relative;\n  display: block;\n  white-space: nowrap;\n}\n.ant-menu-item .anticon,\n.ant-menu-submenu-title .anticon {\n  min-width: 14px;\n  margin-right: 8px;\n  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-item .anticon + span,\n.ant-menu-submenu-title .anticon + span {\n  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  opacity: 1;\n}\n.ant-menu > .ant-menu-item-divider {\n  height: 1px;\n  margin: 1px 0;\n  overflow: hidden;\n  padding: 0;\n  line-height: 0;\n  background-color: #e9e9e9;\n}\n.ant-menu-submenu {\n  position: relative;\n}\n.ant-menu-submenu > .ant-menu {\n  background-color: #fff;\n  border-radius: 4px;\n}\n.ant-menu-submenu > .ant-menu-submenu-title:after {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-menu-submenu-vertical > .ant-menu-submenu-title:after {\n  font-family: \"anticon\" !important;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n  position: absolute;\n  content: \"\\e61d\";\n  right: 16px;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  transform: rotate(270deg) scale(0.75);\n}\n.ant-menu-submenu-inline > .ant-menu-submenu-title:after {\n  font-family: \"anticon\" !important;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  text-rendering: auto;\n  position: absolute;\n  content: \"\\e61d\";\n  right: 16px;\n  top: 0;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-menu-submenu-inline > .ant-menu-submenu-title:after {\n  filter: none;\n}\n:root .ant-menu-submenu-inline > .ant-menu-submenu-title:after {\n  font-size: 12px;\n}\n.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title:after {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  transform: rotate(180deg) scale(0.75);\n}\n.ant-menu-vertical .ant-menu-submenu-selected {\n  color: #108ee9;\n}\n.ant-menu-vertical .ant-menu-submenu-selected > a {\n  color: #108ee9;\n}\n.ant-menu-horizontal {\n  border: 0;\n  border-bottom: 1px solid #e9e9e9;\n  box-shadow: none;\n  z-index: 0;\n}\n.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-horizontal > .ant-menu-submenu {\n  position: relative;\n  top: 1px;\n  float: left;\n  border-bottom: 2px solid transparent;\n}\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-submenu:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu-active,\n.ant-menu-horizontal > .ant-menu-item-open,\n.ant-menu-horizontal > .ant-menu-submenu-open,\n.ant-menu-horizontal > .ant-menu-item-selected,\n.ant-menu-horizontal > .ant-menu-submenu-selected {\n  border-bottom: 2px solid #108ee9;\n  color: #108ee9;\n}\n.ant-menu-horizontal > .ant-menu-item > a,\n.ant-menu-horizontal > .ant-menu-submenu > a {\n  display: block;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-menu-horizontal > .ant-menu-item > a:hover,\n.ant-menu-horizontal > .ant-menu-submenu > a:hover {\n  color: #108ee9;\n}\n.ant-menu-horizontal:after {\n  content: \"\\20\";\n  display: block;\n  height: 0;\n  clear: both;\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-submenu-title,\n.ant-menu-inline .ant-menu-submenu-title {\n  padding: 0 16px;\n  font-size: 12px;\n  line-height: 42px;\n  height: 42px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ant-menu-item-group-list .ant-menu-item,\n.ant-menu-item-group-list .ant-menu-submenu-title {\n  padding: 0 16px 0 28px;\n}\n.ant-menu-vertical.ant-menu-sub {\n  padding: 0;\n  transform-origin: 0 0;\n}\n.ant-menu-vertical.ant-menu-sub > .ant-menu-item,\n.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu {\n  transform-origin: 0 0;\n}\n.ant-menu-root.ant-menu-vertical,\n.ant-menu-root.ant-menu-inline {\n  box-shadow: none;\n}\n.ant-menu-sub.ant-menu-inline {\n  padding: 0;\n  border: 0;\n  box-shadow: none;\n  border-radius: 0;\n}\n.ant-menu-sub.ant-menu-inline > .ant-menu-item,\n.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  line-height: 42px;\n  height: 42px;\n  list-style-type: disc;\n  list-style-position: inside;\n}\n.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {\n  padding-left: 32px;\n}\n.ant-menu-item-disabled,\n.ant-menu-submenu-disabled {\n  color: rgba(0, 0, 0, 0.25) !important;\n  cursor: not-allowed;\n  background: none;\n  border-color: transparent !important;\n}\n.ant-menu-item-disabled > a,\n.ant-menu-submenu-disabled > a {\n  color: rgba(0, 0, 0, 0.25) !important;\n  pointer-events: none;\n}\n.ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(0, 0, 0, 0.25) !important;\n  cursor: not-allowed;\n}\n.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub {\n  color: rgba(255, 255, 255, 0.67);\n  background: #404040;\n}\n.ant-menu-dark .ant-menu-inline.ant-menu-sub {\n  background: #333;\n}\n.ant-menu-dark.ant-menu-horizontal {\n  border-bottom-color: #404040;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {\n  border-color: #404040;\n  border-bottom: 0;\n}\n.ant-menu-dark .ant-menu-item,\n.ant-menu-dark .ant-menu-item-group-title,\n.ant-menu-dark .ant-menu-item > a {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-menu-dark.ant-menu-inline,\n.ant-menu-dark.ant-menu-vertical {\n  border-right: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item,\n.ant-menu-dark.ant-menu-vertical .ant-menu-item {\n  border-right: 0;\n  margin-left: 0;\n  left: 0;\n}\n.ant-menu-dark.ant-menu-inline .ant-menu-item:after,\n.ant-menu-dark.ant-menu-vertical .ant-menu-item:after {\n  border-right: 0;\n}\n.ant-menu-dark .ant-menu-item:hover,\n.ant-menu-dark .ant-menu-item-active,\n.ant-menu-dark .ant-menu-submenu-active,\n.ant-menu-dark:not(.ant-menu-inline) .ant-menu-submenu-open,\n.ant-menu-dark .ant-menu-submenu-selected,\n.ant-menu-dark .ant-menu-submenu:hover,\n.ant-menu-dark .ant-menu-submenu-title:hover {\n  background-color: transparent;\n  color: #fff;\n}\n.ant-menu-dark .ant-menu-item:hover > a,\n.ant-menu-dark .ant-menu-item-active > a,\n.ant-menu-dark .ant-menu-submenu-active > a,\n.ant-menu-dark:not(.ant-menu-inline) .ant-menu-submenu-open > a,\n.ant-menu-dark .ant-menu-submenu-selected > a,\n.ant-menu-dark .ant-menu-submenu:hover > a,\n.ant-menu-dark .ant-menu-submenu-title:hover > a {\n  color: #fff;\n}\n.ant-menu-dark .ant-menu-item-selected {\n  border-right: 0;\n  color: #fff;\n}\n.ant-menu-dark .ant-menu-item-selected:after {\n  border-right: 0;\n}\n.ant-menu-dark .ant-menu-item-selected > a,\n.ant-menu-dark .ant-menu-item-selected > a:hover {\n  color: #fff;\n}\n.ant-menu.ant-menu-dark .ant-menu-item-selected {\n  background-color: #108ee9;\n}\n.ant-menu-dark .ant-menu-item-disabled,\n.ant-menu-dark .ant-menu-submenu-disabled,\n.ant-menu-dark .ant-menu-item-disabled > a,\n.ant-menu-dark .ant-menu-submenu-disabled > a {\n  opacity: 0.8;\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,\n.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {\n  color: rgba(255, 255, 255, 0.35) !important;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzMenuComponent.ctorParameters = function () { return []; };
NzMenuComponent.propDecorators = {
    'nzMode': [{ type: Input },],
    'nzTheme': [{ type: Input },],
    'nzClickActive': [{ type: Input },],
    'nzInlineCollapsed': [{ type: Input },],
    '_isInDropDownClass': [{ type: HostBinding, args: ['class.ant-dropdown-menu',] }, { type: HostBinding, args: ['class.ant-menu-dropdown-vertical',] }, { type: HostBinding, args: ['class.ant-dropdown-menu-root',] },],
    '_isNotInDropDownClass': [{ type: HostBinding, args: ['class.ant-menu',] }, { type: HostBinding, args: ['class.ant-menu-root',] },],
    'setDropDownThemeLightClass': [{ type: HostBinding, args: ['class.ant-dropdown-menu-light',] },],
    'setDropDownThemeDarkClass': [{ type: HostBinding, args: ['class.ant-dropdown-menu-dark',] },],
    'setMenuThemeLightClass': [{ type: HostBinding, args: ['class.ant-menu-light',] },],
    'setMenuThemeDarkClass': [{ type: HostBinding, args: ['class.ant-menu-dark',] },],
    'setMenuVerticalClass': [{ type: HostBinding, args: ['class.ant-menu-vertical',] },],
    'setMenuHorizontalClass': [{ type: HostBinding, args: ['class.ant-menu-horizontal',] },],
    'setMenuInlineClass': [{ type: HostBinding, args: ['class.ant-menu-inline',] },],
    'setMenuInlineCollapsedClass': [{ type: HostBinding, args: ['class.ant-menu-inline-collapsed',] },],
};
var NzDropDownDirective = (function () {
    /**
     * @param {?} elementRef
     */
    function NzDropDownDirective(elementRef) {
        this.elementRef = elementRef;
        this._dropDownTrigger = true;
    }
    return NzDropDownDirective;
}());
NzDropDownDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-dropdown]',
            },] },
];
/**
 * @nocollapse
 */
NzDropDownDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NzDropDownDirective.propDecorators = {
    '_dropDownTrigger': [{ type: HostBinding, args: ['class.ant-dropdown-trigger',] },],
};
var NzDropDownComponent = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _changeDetector
     */
    function NzDropDownComponent(_renderer, _changeDetector) {
        var _this = this;
        this._renderer = _renderer;
        this._changeDetector = _changeDetector;
        this.hasFilterButton = false;
        this._triggerWidth = 0;
        this._placement = 'bottomLeft';
        this._dropDownPosition = 'bottom';
        this._positions = DEFAULT_DROPDOWN_POSITIONS.slice();
        this.nzTrigger = 'hover';
        this.nzClickHide = true;
        this.nzVisible = false;
        this._visibleChange = new Subject$1();
        this.nzVisibleChange = new EventEmitter();
        this._onVisibleChange = function (visible) {
            if (visible) {
                if (!_this._triggerWidth) {
                    _this._setTriggerWidth();
                }
            }
            if (_this.nzVisible !== visible) {
                _this.nzVisible = visible;
                _this.nzVisibleChange.emit(_this.nzVisible);
            }
            _this._changeDetector.markForCheck();
        };
    }
    Object.defineProperty(NzDropDownComponent.prototype, "nzPlacement", {
        /**
         * @return {?}
         */
        get: function () {
            return this._placement;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._placement = value;
            this._dropDownPosition = (this.nzPlacement.indexOf('top') !== -1) ? 'top' : 'bottom';
            this._positions.unshift(/** @type {?} */ (POSITION_MAP[this._placement]));
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    NzDropDownComponent.prototype._onClickEvent = function () {
        if (this.nzTrigger === 'click') {
            this._show();
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzDropDownComponent.prototype._onMouseEnterEvent = function (e) {
        if (this.nzTrigger === 'hover') {
            this._show();
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzDropDownComponent.prototype._onMouseLeaveEvent = function (e) {
        if (this.nzTrigger === 'hover') {
            this._hide();
        }
    };
    /**
     * @return {?}
     */
    NzDropDownComponent.prototype._hide = function () {
        this._visibleChange.next(false);
    };
    /**
     * @return {?}
     */
    NzDropDownComponent.prototype._show = function () {
        this._visibleChange.next(true);
    };
    /**
     * @param {?} position
     * @return {?}
     */
    NzDropDownComponent.prototype._onPositionChange = function (position) {
        this._dropDownPosition = position.connectionPair.originY;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NzDropDownComponent.prototype._clickDropDown = function ($event) {
        $event.stopPropagation();
        if (this.nzClickHide) {
            this._hide();
        }
    };
    /**
     * @return {?}
     */
    NzDropDownComponent.prototype._setTriggerWidth = function () {
        this._triggerWidth = this._nzOrigin.elementRef.nativeElement.getBoundingClientRect().width;
    };
    /**
     * @param {?} observable$
     * @return {?}
     */
    NzDropDownComponent.prototype._startSubscribe = function (observable$) {
        this._subscription = debounceTime$1.call(observable$, 300)
            .subscribe(this._onVisibleChange);
    };
    /**
     * @return {?}
     */
    NzDropDownComponent.prototype.ngOnInit = function () {
        if (this._nzMenu) {
            this._nzMenu.setDropDown(true);
        }
    };
    /**
     * @return {?}
     */
    NzDropDownComponent.prototype.ngOnDestroy = function () {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    NzDropDownComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var /** @type {?} */ mouse$;
        if (this.nzTrigger === 'hover') {
            mouse$ = Observable$1.create(function (observer) {
                var /** @type {?} */ disposeMouseEnter = _this._renderer.listen(_this._nzOrigin.elementRef.nativeElement, 'mouseenter', function () {
                    observer.next(true);
                });
                var /** @type {?} */ disposeMouseLeave = _this._renderer.listen(_this._nzOrigin.elementRef.nativeElement, 'mouseleave', function () {
                    observer.next(false);
                });
                return function () {
                    disposeMouseEnter();
                    disposeMouseLeave();
                };
            });
        }
        if (this.nzTrigger === 'click') {
            mouse$ = Observable$1.create(function (observer) {
                var /** @type {?} */ dispose = _this._renderer.listen(_this._nzOrigin.elementRef.nativeElement, 'click', function (e) {
                    e.preventDefault();
                    observer.next(true);
                });
                return function () { return dispose(); };
            });
        }
        var /** @type {?} */ observable$ = merge$1(mouse$, this._visibleChange);
        this._startSubscribe(observable$);
    };
    Object.defineProperty(NzDropDownComponent.prototype, "_hasBackdrop", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzTrigger === 'click';
        },
        enumerable: true,
        configurable: true
    });
    return NzDropDownComponent;
}());
NzDropDownComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-dropdown',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    DropDownAnimation
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: "\n    <div>\n      <ng-content></ng-content>\n    </div>\n    <ng-template\n      nz-connected-overlay\n      [hasBackdrop]=\"_hasBackdrop\"\n      [positions]=\"_positions\"\n      [origin]=\"_nzOrigin\"\n      (backdropClick)=\"_hide()\"\n      [minWidth]=\"_triggerWidth\"\n      (positionChange)=\"_onPositionChange($event)\"\n      [open]=\"nzVisible\">\n      <div\n        class=\"{{'ant-dropdown ant-dropdown-placement-'+nzPlacement}}\"\n        [@dropDownAnimation]=\"_dropDownPosition\"\n        (mouseenter)=\"_onMouseEnterEvent($event)\"\n        (mouseleave)=\"_onMouseLeaveEvent($event)\"\n        [style.minWidth.px]=\"_triggerWidth\"\n        (click)=\"_clickDropDown($event)\">\n        <div [class.ant-table-filter-dropdown]=\"hasFilterButton\">\n          <ng-content select=\"[nz-menu]\"></ng-content>\n          <ng-content select=\"[nz-table-filter]\"></ng-content>\n        </div>\n        <ng-content select=\"[nz-dropdown-custom]\"></ng-content>\n      </div>\n    </ng-template>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-dropdown {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  z-index: 1050;\n  display: block;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1.5;\n}\n.ant-dropdown-wrap {\n  position: relative;\n}\n.ant-dropdown-wrap .ant-btn > .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-wrap .anticon-down:before {\n  transition: transform 0.2s ease;\n}\n.ant-dropdown-wrap-open .anticon-down:before {\n  transform: rotate(180deg);\n}\n.ant-dropdown-hidden,\n.ant-dropdown-menu-hidden {\n  display: none;\n}\n.ant-dropdown-menu {\n  outline: none;\n  position: relative;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n}\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title {\n  padding: 7px 8px;\n  margin: 0;\n  clear: both;\n  font-size: 12px;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.65);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all .3s;\n}\n.ant-dropdown-menu-item > a,\n.ant-dropdown-menu-submenu-title > a {\n  color: rgba(0, 0, 0, 0.65);\n  display: block;\n  padding: 7px 8px;\n  margin: -7px -8px;\n  transition: all .3s;\n}\n.ant-dropdown-menu-item > a:focus,\n.ant-dropdown-menu-submenu-title > a:focus {\n  text-decoration: none;\n}\n.ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-submenu-title-selected,\n.ant-dropdown-menu-item-selected > a,\n.ant-dropdown-menu-submenu-title-selected > a {\n  color: #108ee9;\n  background-color: #ecf6fd;\n}\n.ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-submenu-title:hover {\n  background-color: #ecf6fd;\n}\n.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-submenu-title-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown-menu-submenu-title-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item:first-child,\n.ant-dropdown-menu-submenu-title:first-child,\n.ant-dropdown-menu-item:first-child > a,\n.ant-dropdown-menu-submenu-title:first-child > a {\n  border-radius: 4px 4px 0 0;\n}\n.ant-dropdown-menu-item:last-child,\n.ant-dropdown-menu-submenu-title:last-child,\n.ant-dropdown-menu-item:last-child > a,\n.ant-dropdown-menu-submenu-title:last-child > a {\n  border-radius: 0 0 4px 4px;\n}\n.ant-dropdown-menu-item:only-child,\n.ant-dropdown-menu-submenu-title:only-child,\n.ant-dropdown-menu-item:only-child > a,\n.ant-dropdown-menu-submenu-title:only-child > a {\n  border-radius: 4px;\n}\n.ant-dropdown-menu-item-divider,\n.ant-dropdown-menu-submenu-title-divider {\n  height: 1px;\n  overflow: hidden;\n  background-color: #e9e9e9;\n  line-height: 0;\n}\n.ant-dropdown-menu-submenu-title:after {\n  font-family: \"anticon\" !important;\n  position: absolute;\n  content: \"\\e61f\";\n  right: 8px;\n  color: rgba(0, 0, 0, 0.43);\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-menu-submenu-title:after {\n  filter: none;\n}\n:root .ant-dropdown-menu-submenu-title:after {\n  font-size: 12px;\n}\n.ant-dropdown-menu-submenu-vertical {\n  position: relative;\n}\n.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {\n  top: 0;\n  left: 100%;\n  position: absolute;\n  min-width: 100%;\n  margin-left: 4px;\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title:after {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-dropdown-menu-submenu:first-child .ant-dropdown-menu-submenu-title {\n  border-radius: 4px 4px 0 0;\n}\n.ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {\n  border-radius: 0 0 4px 4px;\n}\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-dropdown-trigger .anticon-down,\n.ant-dropdown-link .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-trigger .anticon-down,\n:root .ant-dropdown-link .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-trigger .anticon-down,\n:root .ant-dropdown-link .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-button {\n  white-space: nowrap;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n  padding-right: 8px;\n}\n.ant-dropdown-button .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-button .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-button .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-menu-dark,\n.ant-dropdown-menu-dark .ant-dropdown-menu {\n  background: #404040;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:after {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover {\n  color: #fff;\n  background: transparent;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {\n  background: #108ee9;\n  color: #fff;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-dropdown {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  z-index: 1050;\n  display: block;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1.5;\n}\n.ant-dropdown-wrap {\n  position: relative;\n}\n.ant-dropdown-wrap .ant-btn > .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-wrap .anticon-down:before {\n  transition: transform 0.2s ease;\n}\n.ant-dropdown-wrap-open .anticon-down:before {\n  transform: rotate(180deg);\n}\n.ant-dropdown-hidden,\n.ant-dropdown-menu-hidden {\n  display: none;\n}\n.ant-dropdown-menu {\n  outline: none;\n  position: relative;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n}\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title {\n  padding: 7px 8px;\n  margin: 0;\n  clear: both;\n  font-size: 12px;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.65);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all .3s;\n}\n.ant-dropdown-menu-item > a,\n.ant-dropdown-menu-submenu-title > a {\n  color: rgba(0, 0, 0, 0.65);\n  display: block;\n  padding: 7px 8px;\n  margin: -7px -8px;\n  transition: all .3s;\n}\n.ant-dropdown-menu-item > a:focus,\n.ant-dropdown-menu-submenu-title > a:focus {\n  text-decoration: none;\n}\n.ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-submenu-title-selected,\n.ant-dropdown-menu-item-selected > a,\n.ant-dropdown-menu-submenu-title-selected > a {\n  color: #108ee9;\n  background-color: #ecf6fd;\n}\n.ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-submenu-title:hover {\n  background-color: #ecf6fd;\n}\n.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-submenu-title-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown-menu-submenu-title-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item:first-child,\n.ant-dropdown-menu-submenu-title:first-child,\n.ant-dropdown-menu-item:first-child > a,\n.ant-dropdown-menu-submenu-title:first-child > a {\n  border-radius: 4px 4px 0 0;\n}\n.ant-dropdown-menu-item:last-child,\n.ant-dropdown-menu-submenu-title:last-child,\n.ant-dropdown-menu-item:last-child > a,\n.ant-dropdown-menu-submenu-title:last-child > a {\n  border-radius: 0 0 4px 4px;\n}\n.ant-dropdown-menu-item:only-child,\n.ant-dropdown-menu-submenu-title:only-child,\n.ant-dropdown-menu-item:only-child > a,\n.ant-dropdown-menu-submenu-title:only-child > a {\n  border-radius: 4px;\n}\n.ant-dropdown-menu-item-divider,\n.ant-dropdown-menu-submenu-title-divider {\n  height: 1px;\n  overflow: hidden;\n  background-color: #e9e9e9;\n  line-height: 0;\n}\n.ant-dropdown-menu-submenu-title:after {\n  font-family: \"anticon\" !important;\n  position: absolute;\n  content: \"\\e61f\";\n  right: 8px;\n  color: rgba(0, 0, 0, 0.43);\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-menu-submenu-title:after {\n  filter: none;\n}\n:root .ant-dropdown-menu-submenu-title:after {\n  font-size: 12px;\n}\n.ant-dropdown-menu-submenu-vertical {\n  position: relative;\n}\n.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {\n  top: 0;\n  left: 100%;\n  position: absolute;\n  min-width: 100%;\n  margin-left: 4px;\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title:after {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-dropdown-menu-submenu:first-child .ant-dropdown-menu-submenu-title {\n  border-radius: 4px 4px 0 0;\n}\n.ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {\n  border-radius: 0 0 4px 4px;\n}\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-dropdown-trigger .anticon-down,\n.ant-dropdown-link .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-trigger .anticon-down,\n:root .ant-dropdown-link .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-trigger .anticon-down,\n:root .ant-dropdown-link .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-button {\n  white-space: nowrap;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n  padding-right: 8px;\n}\n.ant-dropdown-button .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-button .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-button .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-menu-dark,\n.ant-dropdown-menu-dark .ant-dropdown-menu {\n  background: #404040;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:after {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover {\n  color: #fff;\n  background: transparent;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {\n  background: #108ee9;\n  color: #fff;\n}\nnz-dropdown {\n  position: relative;\n  display: inline-block;\n}\nnz-dropdown-button {\n  position: relative;\n  display: inline-block;\n}\n.ant-dropdown {\n  top: 100%;\n  left: 0;\n  position: relative;\n  width: 100%;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzDropDownComponent.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: ChangeDetectorRef, },
]; };
NzDropDownComponent.propDecorators = {
    '_nzOrigin': [{ type: ContentChild, args: [NzDropDownDirective,] },],
    '_nzMenu': [{ type: ContentChild, args: [NzMenuComponent,] },],
    'nzTrigger': [{ type: Input },],
    'nzClickHide': [{ type: Input },],
    'nzVisible': [{ type: Input },],
    '_visibleChange': [{ type: Output },],
    'nzVisibleChange': [{ type: Output },],
    'nzPlacement': [{ type: Input },],
};
var NzTableFilterComponent = (function () {
    /**
     * @param {?} nzDropDownComponent
     */
    function NzTableFilterComponent(nzDropDownComponent) {
        this.nzDropDownComponent = nzDropDownComponent;
        this._dropDownButton = true;
    }
    /**
     * @return {?}
     */
    NzTableFilterComponent.prototype.hideDropDown = function () {
        this.nzDropDownComponent.nzVisible = false;
        this.nzDropDownComponent._hide();
    };
    /**
     * @return {?}
     */
    NzTableFilterComponent.prototype.ngOnInit = function () {
        this.nzDropDownComponent.hasFilterButton = true;
        this.nzDropDownComponent.nzClickHide = false;
    };
    return NzTableFilterComponent;
}());
NzTableFilterComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-table-filter]',
                template: "\n    <a class=\"ant-table-filter-dropdown-link confirm\" (click)=\"hideDropDown()\">\n      <ng-content select=\"[nz-table-filter-confirm]\"></ng-content>\n    </a>\n    <a class=\"ant-table-filter-dropdown-link clear\" (click)=\"hideDropDown()\">\n      <ng-content select=\"[nz-table-filter-clear]\"></ng-content>\n    </a>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzTableFilterComponent.ctorParameters = function () { return [
    { type: NzDropDownComponent, },
]; };
NzTableFilterComponent.propDecorators = {
    '_dropDownButton': [{ type: HostBinding, args: ['class.ant-table-filter-dropdown-btns',] },],
};
var NzTheadDirective = (function () {
    function NzTheadDirective() {
        this._nzTableThead = true;
    }
    return NzTheadDirective;
}());
NzTheadDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-thead]'
            },] },
];
/**
 * @nocollapse
 */
NzTheadDirective.ctorParameters = function () { return []; };
NzTheadDirective.propDecorators = {
    '_nzTableThead': [{ type: HostBinding, args: ["class.ant-table-thead",] },],
};
var NzTbodyDirective = (function () {
    function NzTbodyDirective() {
        this._nzTableTbody = true;
    }
    return NzTbodyDirective;
}());
NzTbodyDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-tbody]'
            },] },
];
/**
 * @nocollapse
 */
NzTbodyDirective.ctorParameters = function () { return []; };
NzTbodyDirective.propDecorators = {
    '_nzTableTbody': [{ type: HostBinding, args: ["class.ant-table-tbody",] },],
};
var NzTbodyTrDirective = (function () {
    function NzTbodyTrDirective() {
        this._nzTableRow = true;
    }
    return NzTbodyTrDirective;
}());
NzTbodyTrDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-tbody-tr]'
            },] },
];
/**
 * @nocollapse
 */
NzTbodyTrDirective.ctorParameters = function () { return []; };
NzTbodyTrDirective.propDecorators = {
    '_nzTableRow': [{ type: HostBinding, args: ["class.ant-table-row",] },],
};
var NzTableDividerDirective = (function () {
    function NzTableDividerDirective() {
        this._nzDivider = true;
    }
    return NzTableDividerDirective;
}());
NzTableDividerDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-table-divider]'
            },] },
];
/**
 * @nocollapse
 */
NzTableDividerDirective.ctorParameters = function () { return []; };
NzTableDividerDirective.propDecorators = {
    '_nzDivider': [{ type: HostBinding, args: ["class.ant-divider",] },],
};
var NzTableSortComponent = (function () {
    /**
     * @param {?} nzThDirective
     * @param {?} _renderer
     */
    function NzTableSortComponent(nzThDirective, _renderer) {
        this.nzThDirective = nzThDirective;
        this._renderer = _renderer;
        this._value = null;
        this.nzValueChange = new EventEmitter();
    }
    Object.defineProperty(NzTableSortComponent.prototype, "nzValue", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._value = value;
            if ((this._value !== 'ascend') && (this._value !== 'descend')) {
                if (this.nzThDirective) {
                    this._renderer.removeClass(this.nzThDirective._el, 'ant-table-column-sort');
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    NzTableSortComponent.prototype._setValue = function (value) {
        if (this.nzValue === value) {
            this.nzValue = null;
            if (this.nzThDirective) {
                this._renderer.removeClass(this.nzThDirective._el, 'ant-table-column-sort');
            }
        }
        else {
            this.nzValue = value;
            if (this.nzThDirective) {
                this._renderer.addClass(this.nzThDirective._el, 'ant-table-column-sort');
            }
        }
        this.nzValueChange.emit(this.nzValue);
    };
    /**
     * @return {?}
     */
    NzTableSortComponent.prototype.ngOnInit = function () {
    };
    return NzTableSortComponent;
}());
NzTableSortComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-table-sort',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"ant-table-column-sorter\">\n      <span class=\"ant-table-column-sorter-up\" [ngClass]=\"{'on':_value == 'ascend'}\" title=\"\u2191\" (click)=\"_setValue('ascend')\">\n        <i class=\"anticon anticon-caret-up\"></i>\n      </span>\n      <span class=\"ant-table-column-sorter-down\" [ngClass]=\"{'on':_value == 'descend'}\" title=\"\u2193\" (click)=\"_setValue('descend')\">\n        <i class=\"anticon anticon-caret-down\"></i>\n      </span>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-table-wrapper {\n  zoom: 1;\n}\n.ant-table-wrapper:before,\n.ant-table-wrapper:after {\n  content: \" \";\n  display: table;\n}\n.ant-table-wrapper:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-table {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.65);\n  overflow: hidden;\n  position: relative;\n  border-radius: 4px 4px 0 0;\n  /* fix firefox scrollbar bug */\n}\n.ant-table-body {\n  transition: opacity 0.3s ease;\n}\n.ant-table table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  text-align: left;\n  border-radius: 4px 4px 0 0;\n  overflow: hidden;\n}\n.ant-table-thead > tr > th {\n  background: #f7f7f7;\n  font-weight: 500;\n  transition: background .3s ease;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-table-thead > tr > th[colspan] {\n  text-align: center;\n}\n.ant-table-thead > tr > th .anticon-filter,\n.ant-table-thead > tr > th .ant-table-filter-icon {\n  position: relative;\n  margin-left: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  color: #aaa;\n  transition: all .3s;\n  width: 14px;\n}\n.ant-table-thead > tr > th .anticon-filter:hover,\n.ant-table-thead > tr > th .ant-table-filter-icon:hover {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-table-thead > tr > th .anticon-filter:after,\n.ant-table-thead > tr > th .ant-table-filter-icon:after {\n  content: '';\n  position: absolute;\n  width: 14px;\n  height: 50px;\n  left: 0;\n  top: -19px;\n}\n.ant-table-thead > tr > th .ant-table-filter-selected.anticon-filter {\n  color: #108ee9;\n}\n.ant-table-tbody > tr > td {\n  border-bottom: 1px solid #e9e9e9;\n  transition: all .3s;\n}\n.ant-table-thead > tr,\n.ant-table-tbody > tr {\n  transition: all .3s;\n}\n.ant-table-thead > tr.ant-table-row-hover > td,\n.ant-table-tbody > tr.ant-table-row-hover > td,\n.ant-table-thead > tr:hover > td,\n.ant-table-tbody > tr:hover > td {\n  background: #ecf6fd;\n}\n.ant-table-thead > tr:hover {\n  background: none;\n}\n.ant-table-footer {\n  padding: 16px 8px;\n  background: #f7f7f7;\n  border-radius: 0 0 4px 4px;\n  position: relative;\n}\n.ant-table-footer:before {\n  content: '';\n  height: 1px;\n  background: #f7f7f7;\n  position: absolute;\n  top: -1px;\n  width: 100%;\n  left: 0;\n}\n.ant-table.ant-table-bordered .ant-table-footer {\n  border: 1px solid #e9e9e9;\n}\n.ant-table-title {\n  padding: 16px 0;\n  position: relative;\n  top: 1px;\n  border-radius: 4px 4px 0 0;\n}\n.ant-table.ant-table-bordered .ant-table-title {\n  border: 1px solid #e9e9e9;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.ant-table-title + .ant-table-content {\n  position: relative;\n  border-radius: 4px 4px 0 0;\n  overflow: hidden;\n}\n.ant-table-bordered .ant-table-title + .ant-table-content,\n.ant-table-bordered .ant-table-title + .ant-table-content table {\n  border-radius: 0;\n}\n.ant-table-without-column-header .ant-table-title + .ant-table-content,\n.ant-table-without-column-header table {\n  border-radius: 0;\n}\n.ant-table-tbody > tr.ant-table-row-selected {\n  background: #fafafa;\n}\n.ant-table-thead > tr > th.ant-table-column-sort {\n  background: #eee;\n}\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td {\n  padding: 16px 8px;\n  word-break: break-all;\n}\n.ant-table-thead > tr > th.ant-table-selection-column-custom {\n  padding-left: 16px;\n  padding-right: 0;\n}\n.ant-table-thead > tr > th.ant-table-selection-column,\n.ant-table-tbody > tr > td.ant-table-selection-column {\n  text-align: center;\n  min-width: 62px;\n  width: 62px;\n}\n.ant-table-expand-icon-th,\n.ant-table-row-expand-icon-cell {\n  text-align: center;\n  min-width: 50px;\n  width: 50px;\n}\n.ant-table-header {\n  background: #f7f7f7;\n  overflow: hidden;\n}\n.ant-table-header table {\n  border-radius: 4px 4px 0 0;\n}\n.ant-table-loading {\n  position: relative;\n}\n.ant-table-loading .ant-table-body {\n  background: #fff;\n  opacity: 0.5;\n}\n.ant-table-loading .ant-table-spin-holder {\n  height: 20px;\n  line-height: 20px;\n  left: 50%;\n  top: 50%;\n  margin-left: -30px;\n  position: absolute;\n}\n.ant-table-loading .ant-table-with-pagination {\n  margin-top: -20px;\n}\n.ant-table-loading .ant-table-without-pagination {\n  margin-top: 10px;\n}\n.ant-table-middle .ant-table-thead > tr > th:not(.ant-table-selection-column),\n.ant-table-middle .ant-table-tbody > tr > td {\n  padding: 10px 8px;\n}\n.ant-table-middle .ant-table-title,\n.ant-table-middle .ant-table-footer {\n  padding: 10px 8px;\n}\n.ant-table-middle .ant-table-column-sorter-up:after {\n  top: -13px;\n  height: 13px;\n}\n.ant-table-middle .ant-table-column-sorter-down:after {\n  bottom: -11px;\n  height: 13px;\n}\n.ant-table-middle .ant-table-thead > tr > th .anticon-filter:after,\n.ant-table-middle .ant-table-thead > tr > th .ant-table-filter-icon:after {\n  height: 38px;\n  top: -13px;\n}\n.ant-table-small {\n  border: 1px solid #e9e9e9;\n  border-radius: 4px;\n}\n.ant-table-small .ant-table-header > table,\n.ant-table-small .ant-table-body > table {\n  border: 0;\n  padding: 0 8px;\n}\n.ant-table-small .ant-table-thead > tr > th {\n  background: #fff;\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-table-small .ant-table-tbody > tr > td {\n  padding: 6px 8px;\n}\n.ant-table-small .ant-table-title,\n.ant-table-small .ant-table-footer,\n.ant-table-small .ant-table-thead > tr > th:not(.ant-table-selection-column) {\n  padding: 10px 8px;\n}\n.ant-table-small .ant-table-title {\n  border-bottom: 1px solid #e9e9e9;\n  top: 0;\n}\n.ant-table-small .ant-table-header {\n  background: #fff;\n}\n.ant-table-small .ant-table-header table {\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-table-small .ant-table-placeholder,\n.ant-table-small .ant-table-row:last-child td {\n  border-bottom: 0;\n}\n.ant-table-small .ant-table-column-sorter-up:after {\n  top: -14px;\n  height: 13px;\n}\n.ant-table-small .ant-table-column-sorter-down:after {\n  bottom: -11px;\n  height: 13px;\n}\n.ant-table-small .ant-table-thead > tr > th .anticon-filter:after,\n.ant-table-small .ant-table-thead > tr > th .ant-table-filter-icon:after {\n  height: 39px;\n  top: -14px;\n}\n.ant-table-column-sorter {\n  position: relative;\n  margin-left: 4px;\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  vertical-align: middle;\n  text-align: center;\n}\n.ant-table-column-sorter-up,\n.ant-table-column-sorter-down {\n  line-height: 4px;\n  display: block;\n  width: 14px;\n  cursor: pointer;\n}\n.ant-table-column-sorter-up:hover .anticon,\n.ant-table-column-sorter-down:hover .anticon {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-table-column-sorter-up.on .anticon-caret-up,\n.ant-table-column-sorter-down.on .anticon-caret-up,\n.ant-table-column-sorter-up.on .anticon-caret-down,\n.ant-table-column-sorter-down.on .anticon-caret-down {\n  color: #108ee9;\n}\n.ant-table-column-sorter-up:after,\n.ant-table-column-sorter-down:after {\n  position: absolute;\n  content: '';\n  height: 20px;\n  width: 14px;\n  left: 0;\n}\n.ant-table-column-sorter-up:after {\n  top: -19px;\n}\n.ant-table-column-sorter-down:after {\n  bottom: -17px;\n}\n.ant-table-column-sorter .anticon-caret-up,\n.ant-table-column-sorter .anticon-caret-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 8px 9;\n  transform: scale(0.66666667) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  line-height: 6px;\n  height: 6px;\n  color: #aaa;\n}\n:root .ant-table-column-sorter .anticon-caret-up,\n:root .ant-table-column-sorter .anticon-caret-down {\n  filter: none;\n}\n:root .ant-table-column-sorter .anticon-caret-up,\n:root .ant-table-column-sorter .anticon-caret-down {\n  font-size: 12px;\n}\n.ant-table-column-sorter .anticon-caret-up:before,\n.ant-table-column-sorter .anticon-caret-down:before {\n  -moz-transform-origin: 53% 50%;\n  /* fix firefox position */\n}\n.ant-table-bordered .ant-table-header > table,\n.ant-table-bordered .ant-table-body > table,\n.ant-table-bordered .ant-table-fixed-left table,\n.ant-table-bordered .ant-table-fixed-right table {\n  border: 1px solid #e9e9e9;\n  border-right: 0;\n  border-bottom: 0;\n}\n.ant-table-bordered.ant-table-empty .ant-table-placeholder {\n  border-left: 1px solid #e9e9e9;\n  border-right: 1px solid #e9e9e9;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-header > table {\n  border-bottom: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-body > table {\n  border-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-body-inner > table {\n  border-top: 0;\n}\n.ant-table-bordered.ant-table-fixed-header .ant-table-placeholder {\n  border: 0;\n}\n.ant-table-bordered .ant-table-thead > tr > th {\n  border-bottom: 1px solid #e9e9e9;\n}\n.ant-table-bordered .ant-table-thead > tr > th,\n.ant-table-bordered .ant-table-tbody > tr > td {\n  border-right: 1px solid #e9e9e9;\n}\n.ant-table-bordered.ant-table-small {\n  border-right: 0;\n}\n.ant-table-bordered.ant-table-small .ant-table-header > table,\n.ant-table-bordered.ant-table-small .ant-table-body > table,\n.ant-table-bordered.ant-table-small .ant-table-fixed-left table,\n.ant-table-bordered.ant-table-small .ant-table-fixed-right table {\n  border: 0;\n  padding: 0;\n}\n.ant-table-bordered.ant-table-small .ant-table-title {\n  border: 0;\n  border-bottom: 1px solid #e9e9e9;\n  border-right: 1px solid #e9e9e9;\n}\n.ant-table-bordered.ant-table-small .ant-table-footer {\n  border: 0;\n  border-top: 1px solid #e9e9e9;\n  border-right: 1px solid #e9e9e9;\n}\n.ant-table-bordered.ant-table-small .ant-table-footer:before {\n  display: none;\n}\n.ant-table-bordered.ant-table-small .ant-table-placeholder {\n  border-left: 0;\n  border-bottom: 0;\n}\n.ant-table-placeholder {\n  position: relative;\n  padding: 16px 8px;\n  background: #fff;\n  border-bottom: 1px solid #e9e9e9;\n  text-align: center;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-table-placeholder .anticon {\n  margin-right: 4px;\n}\n.ant-table-pagination {\n  margin: 16px 0;\n  float: right;\n}\n.ant-table-filter-dropdown {\n  min-width: 96px;\n  margin-left: -8px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu {\n  border: 0;\n  box-shadow: none;\n  border-radius: 4px 4px 0 0;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-without-submenu {\n  max-height: 400px;\n  overflow-x: hidden;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-item > label + span {\n  padding: 0;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-sub {\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-table-filter-dropdown .ant-dropdown-menu .ant-dropdown-submenu-contain-selected .ant-dropdown-menu-submenu-title:after {\n  color: #108ee9;\n  font-weight: bold;\n  text-shadow: 0 0 2px #d2eafb;\n}\n.ant-table-filter-dropdown .ant-dropdown-menu-item {\n  overflow: hidden;\n}\n.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-item:last-child,\n.ant-table-filter-dropdown > .ant-dropdown-menu > .ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {\n  border-radius: 0;\n}\n.ant-table-filter-dropdown-btns {\n  overflow: hidden;\n  padding: 7px 8px;\n  border-top: 1px solid #e9e9e9;\n}\n.ant-table-filter-dropdown-link {\n  color: #108ee9;\n}\n.ant-table-filter-dropdown-link:hover {\n  color: #49a9ee;\n}\n.ant-table-filter-dropdown-link:active {\n  color: #0e77ca;\n}\n.ant-table-filter-dropdown-link.confirm {\n  float: left;\n}\n.ant-table-filter-dropdown-link.clear {\n  float: right;\n}\n.ant-table-selection-select-all-custom {\n  margin-right: 4px !important;\n}\n.ant-table-selection .anticon-down {\n  color: #aaa;\n  transition: all .3s;\n}\n.ant-table-selection-menu {\n  min-width: 96px;\n  margin-top: 5px;\n  margin-left: -30px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-table-selection-menu .ant-action-down {\n  color: #aaa;\n}\n.ant-table-selection-down {\n  cursor: pointer;\n  padding: 0;\n  display: inline-block;\n  line-height: 1;\n}\n.ant-table-selection-down:hover .anticon-down {\n  color: #666;\n}\n.ant-table-row-expand-icon {\n  cursor: pointer;\n  display: inline-block;\n  width: 17px;\n  height: 17px;\n  text-align: center;\n  line-height: 14px;\n  border: 1px solid #e9e9e9;\n  user-select: none;\n  background: #fff;\n}\n.ant-table-row-expanded:after {\n  content: '-';\n}\n.ant-table-row-collapsed:after {\n  content: '+';\n}\n.ant-table-row-spaced {\n  visibility: hidden;\n}\n.ant-table-row-spaced:after {\n  content: '.';\n}\n.ant-table-row[class*=\"ant-table-row-level-0\"] .ant-table-selection-column > span {\n  display: inline-block;\n}\ntr.ant-table-expanded-row,\ntr.ant-table-expanded-row:hover {\n  background: #fbfbfb;\n}\n.ant-table .ant-table-row-indent + .ant-table-row-expand-icon {\n  margin-right: 8px;\n}\n.ant-table-scroll {\n  overflow: auto;\n  overflow-x: hidden;\n}\n.ant-table-scroll table {\n  width: auto;\n  min-width: 100%;\n}\n.ant-table-body-inner {\n  height: 100%;\n}\n.ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {\n  position: relative;\n  background: #fff;\n}\n.ant-table-fixed-header .ant-table-body-inner {\n  overflow: scroll;\n}\n.ant-table-fixed-header .ant-table-scroll .ant-table-header {\n  overflow: scroll;\n  padding-bottom: 20px;\n  margin-bottom: -20px;\n}\n.ant-table-fixed-header.ant-table-empty .ant-table-scroll .ant-table-body {\n  padding-bottom: 20px;\n  margin-bottom: -20px;\n}\n.ant-table-fixed-left,\n.ant-table-fixed-right {\n  position: absolute;\n  top: 0;\n  overflow: hidden;\n  transition: box-shadow 0.3s ease;\n  border-radius: 0;\n}\n.ant-table-fixed-left table,\n.ant-table-fixed-right table {\n  width: auto;\n  background: #fff;\n}\n.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-outer .ant-table-fixed,\n.ant-table-fixed-header .ant-table-fixed-right .ant-table-body-outer .ant-table-fixed {\n  border-radius: 0;\n}\n.ant-table-fixed-left {\n  left: 0;\n  box-shadow: 6px 0 6px -4px rgba(0, 0, 0, 0.2);\n}\n.ant-table-fixed-left .ant-table-header {\n  overflow-y: hidden;\n}\n.ant-table-fixed-left .ant-table-body-inner {\n  margin-right: -20px;\n  padding-right: 20px;\n}\n.ant-table-fixed-header .ant-table-fixed-left .ant-table-body-inner {\n  padding-right: 0;\n}\n.ant-table-fixed-left,\n.ant-table-fixed-left table {\n  border-radius: 4px 0 0 0;\n}\n.ant-table-fixed-right {\n  right: 0;\n  box-shadow: -6px 0 6px -4px rgba(0, 0, 0, 0.2);\n}\n.ant-table-fixed-right,\n.ant-table-fixed-right table {\n  border-radius: 0 4px 0 0;\n}\n.ant-table-fixed-right .ant-table-expanded-row {\n  color: transparent;\n  pointer-events: none;\n}\n.ant-table.ant-table-scroll-position-left .ant-table-fixed-left {\n  box-shadow: none;\n}\n.ant-table.ant-table-scroll-position-right .ant-table-fixed-right {\n  box-shadow: none;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzTableSortComponent.ctorParameters = function () { return [
    { type: NzThDirective, decorators: [{ type: Host }, { type: Optional },] },
    { type: Renderer2, },
]; };
NzTableSortComponent.propDecorators = {
    'nzValueChange': [{ type: Output },],
    'nzValue': [{ type: Input },],
};
var NzTableModule = (function () {
    function NzTableModule() {
    }
    return NzTableModule;
}());
NzTableModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzRowIndentComponent, NzRowExpandIconComponent, NzTableFilterComponent, NzTableComponent, NzThDirective, NzTdDirective, NzTheadDirective, NzTbodyDirective, NzTbodyTrDirective, NzTableDividerDirective, NzTableSortComponent],
                exports: [NzRowIndentComponent, NzRowExpandIconComponent, NzTableFilterComponent, NzTableComponent, NzThDirective, NzTdDirective, NzTheadDirective, NzTbodyDirective, NzTbodyTrDirective, NzTableDividerDirective, NzTableSortComponent],
                imports: [CommonModule, NzPaginationModule, NzSpinModule]
            },] },
];
/**
 * @nocollapse
 */
NzTableModule.ctorParameters = function () { return []; };
var NzTabsInkBarDirective = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _ngZone
     */
    function NzTabsInkBarDirective(_renderer, _elementRef, _ngZone) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
        this._nzTabsInkBar = true;
        this.nzPositionMode = 'horizontal';
    }
    /**
     * @param {?} element
     * @return {?}
     */
    NzTabsInkBarDirective.prototype.alignToElement = function (element) {
        var _this = this;
        this.show();
        this._ngZone.runOutsideAngular(function () {
            requestAnimationFrame(function () {
                /** when horizontal remove height style and add transfrom left **/
                if (_this.nzPositionMode === 'horizontal') {
                    _this._renderer.removeStyle(_this._elementRef.nativeElement, 'height');
                    _this._renderer.setStyle(_this._elementRef.nativeElement, 'transform', "translate3d(" + _this._getLeftPosition(element) + ", 0px, 0px)");
                    _this._renderer.setStyle(_this._elementRef.nativeElement, 'width', _this._getElementWidth(element));
                }
                else {
                    /** when vertical remove width style and add transfrom top **/
                    _this._renderer.removeStyle(_this._elementRef.nativeElement, 'width');
                    _this._renderer.setStyle(_this._elementRef.nativeElement, 'transform', "translate3d(0px, " + _this._getTopPosition(element) + ", 0px)");
                    _this._renderer.setStyle(_this._elementRef.nativeElement, 'height', _this._getElementHeight(element));
                }
            });
        });
    };
    /**
     * @return {?}
     */
    NzTabsInkBarDirective.prototype.show = function () {
        this._renderer.setStyle(this._elementRef.nativeElement, 'visibility', 'visible');
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzTabsInkBarDirective.prototype.setDisplay = function (value) {
        this._renderer.setStyle(this._elementRef.nativeElement, 'display', value);
    };
    /**
     * @return {?}
     */
    NzTabsInkBarDirective.prototype.hide = function () {
        this._renderer.setStyle(this._elementRef.nativeElement, 'visibility', 'hidden');
    };
    /**
     * @param {?} element
     * @return {?}
     */
    NzTabsInkBarDirective.prototype._getLeftPosition = function (element) {
        return element ? element.offsetLeft + 'px' : '0';
    };
    /**
     * @param {?} element
     * @return {?}
     */
    NzTabsInkBarDirective.prototype._getElementWidth = function (element) {
        return element ? element.offsetWidth + 'px' : '0';
    };
    /**
     * @param {?} element
     * @return {?}
     */
    NzTabsInkBarDirective.prototype._getTopPosition = function (element) {
        return element ? element.offsetTop + 'px' : '0';
    };
    /**
     * @param {?} element
     * @return {?}
     */
    NzTabsInkBarDirective.prototype._getElementHeight = function (element) {
        return element ? element.offsetHeight + 'px' : '0';
    };
    return NzTabsInkBarDirective;
}());
NzTabsInkBarDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-tabs-ink-bar]',
            },] },
];
/**
 * @nocollapse
 */
NzTabsInkBarDirective.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: ElementRef, },
    { type: NgZone, },
]; };
NzTabsInkBarDirective.propDecorators = {
    '_nzTabsInkBar': [{ type: HostBinding, args: ['class.ant-tabs-ink-bar',] },],
    'nzAnimated': [{ type: Input }, { type: HostBinding, args: ['class.ant-tabs-ink-bar-animated',] },],
    'nzPositionMode': [{ type: Input },],
};
/** code from https://github.com/angular/material2 */
var NzTabChangeEvent = (function () {
    function NzTabChangeEvent() {
    }
    return NzTabChangeEvent;
}());
var NzTabSetComponent = (function () {
    /**
     * @param {?} _renderer
     */
    function NzTabSetComponent(_renderer) {
        this._renderer = _renderer;
        this._prefixCls = 'ant-tabs';
        this._tabPosition = 'top';
        this._tabPositionMode = 'horizontal';
        this._indexToSelect = 0;
        this._selectedIndex = null;
        this._isViewInit = false;
        this._tabs = [];
        this.nzAnimated = true;
        this.nzShowPagination = true;
        this.nzHide = false;
        this.nzSelectChange = new EventEmitter(true);
        this.nzSize = 'default';
        this._type = 'line';
        this.tabs = [];
    }
    Object.defineProperty(NzTabSetComponent.prototype, "nzSelectedIndex", {
        /**
         * @return {?}
         */
        get: function () {
            return this._selectedIndex;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._indexToSelect = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabSetComponent.prototype, "nzSelectedIndexChange", {
        /**
         * @return {?}
         */
        get: function () {
            return map$1.call(this.nzSelectChange, function (event) { return event.index; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabSetComponent.prototype, "nzTabPosition", {
        /**
         * @return {?}
         */
        get: function () {
            return this._tabPosition;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._tabPosition === value) {
                return;
            }
            this._tabPosition = value;
            if ((this._tabPosition === 'top') || (this._tabPosition === 'bottom')) {
                this._tabPositionMode = 'horizontal';
            }
            else {
                this._tabPositionMode = 'vertical';
            }
            this._setPosition(value);
            this._setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NzTabSetComponent.prototype, "nzType", {
        /**
         * @return {?}
         */
        get: function () {
            return this._type;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._type === value) {
                return;
            }
            this._type = value;
            if (this._type === 'card') {
                this.nzAnimated = false;
            }
            this._setClassMap();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    NzTabSetComponent.prototype._setPosition = function (value) {
        if (this._isViewInit) {
            if (value === 'bottom') {
                this._renderer.insertBefore(this._hostContent.nativeElement, this._tabContent.nativeElement, this._tabNav._elementRef.nativeElement);
            }
            else {
                this._renderer.insertBefore(this._hostContent.nativeElement, this._tabNav._elementRef.nativeElement, this._tabContent.nativeElement);
            }
        }
    };
    /**
     * @return {?}
     */
    NzTabSetComponent.prototype._setClassMap = function () {
        this._classMap = (_a = {},
            _a[this._prefixCls] = true,
            _a[this._prefixCls + "-vertical"] = (this._tabPosition === 'left') || (this._tabPosition === 'right'),
            _a[this._prefixCls + "-" + this._tabPosition] = this._tabPosition,
            _a[this._prefixCls + "-no-animation"] = (this.nzAnimated === false) || (((this.nzAnimated)).tabPane === false),
            _a[this._prefixCls + "-" + this._type] = this._type,
            _a[this._prefixCls + "-mini"] = (this.nzSize === 'small'),
            _a);
        var _a;
    };
    /**
     * @param {?} index
     * @return {?}
     */
    NzTabSetComponent.prototype.clickLabel = function (index) {
        this.nzSelectedIndex = index;
        this._tabs[index].nzClick.emit();
    };
    /**
     * @return {?}
     */
    NzTabSetComponent.prototype.ngOnInit = function () {
        this._setClassMap();
    };
    /**
     * @return {?}
     */
    NzTabSetComponent.prototype.ngAfterContentChecked = function () {
        var _this = this;
        // Clamp the next selected index to the bounds of 0 and the tabs length. Note the `|| 0`, which
        // ensures that values like NaN can't get through and which would otherwise throw the
        // component into an infinite loop (since Math.max(NaN, 0) === NaN).
        var /** @type {?} */ indexToSelect = this._indexToSelect =
            Math.min(this._tabs.length - 1, Math.max(this._indexToSelect || 0, 0));
        // If there is a change in selected index, emit a change event. Should not trigger if
        // the selected index has not yet been initialized.
        if (this._selectedIndex !== indexToSelect && this._selectedIndex != null) {
            this.nzSelectChange.emit(this._createChangeEvent(indexToSelect));
        }
        // Setup the position for each tab and optionally setup an origin on the next selected tab.
        this._tabs.forEach(function (tab, index) {
            tab.position = index - indexToSelect;
            // If there is already a selected tab, then set up an origin for the next selected tab
            // if it doesn't have one already.
            if (_this._selectedIndex != null && tab.position === 0 && !tab.origin) {
                tab.origin = indexToSelect - _this._selectedIndex;
            }
        });
        this._selectedIndex = indexToSelect;
    };
    /**
     * @return {?}
     */
    NzTabSetComponent.prototype.ngAfterViewInit = function () {
        this._isViewInit = true;
        this._setPosition(this._tabPosition);
    };
    /**
     * @param {?} index
     * @return {?}
     */
    NzTabSetComponent.prototype._createChangeEvent = function (index) {
        var /** @type {?} */ event = new NzTabChangeEvent;
        event.index = index;
        if (this._tabs && this._tabs.length) {
            event.tab = this._tabs[index];
            this._tabs.forEach(function (item, i) {
                if (i !== index) {
                    item.nzDeselect.emit();
                }
            });
            event.tab.nzSelect.emit();
        }
        return event;
    };
    Object.defineProperty(NzTabSetComponent.prototype, "inkBarAnimated", {
        /**
         * @return {?}
         */
        get: function () {
            return (this.nzAnimated === true) || (((this.nzAnimated)).inkBar === true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabSetComponent.prototype, "tabPaneAnimated", {
        /**
         * @return {?}
         */
        get: function () {
            return (this.nzAnimated === true) || (((this.nzAnimated)).tabPane === true);
        },
        enumerable: true,
        configurable: true
    });
    return NzTabSetComponent;
}());
NzTabSetComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-tabset',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div [ngClass]=\"_classMap\" #hostContent>\n      <nz-tabs-nav\n        #tabNav\n        [nzSize]=\"nzSize\"\n        [nzType]=\"nzType\"\n        [nzShowPagination]=\"nzShowPagination\"\n        [nzPositionMode]=\"_tabPositionMode\"\n        [nzAnimated]=\"inkBarAnimated\"\n        [nzHideBar]=\"nzHide\"\n        [selectedIndex]=\"nzSelectedIndex\">\n        <ng-template #tabBarExtraContent>\n          <ng-template [ngTemplateOutlet]=\"nzTabBarExtraContent\"></ng-template>\n        </ng-template>\n        <div\n          nz-tab-label\n          [class.ant-tabs-tab-active]=\"(nzSelectedIndex == i)&&!nzHide\"\n          [disabled]=\"tab.disabled\"\n          (click)=\"clickLabel(i)\"\n          *ngFor=\"let tab of _tabs; let i = index\">\n          <ng-template [ngTemplateOutlet]=\"tab._tabHeading\"></ng-template>\n        </div>\n      </nz-tabs-nav>\n      <div class=\"ant-tabs-content\"\n        #tabContent\n        [class.ant-tabs-content-animated]=\"tabPaneAnimated\"\n        [class.ant-tabs-content-no-animated]=\"!tabPaneAnimated\"\n        [style.margin-left.%]=\"tabPaneAnimated&&(-nzSelectedIndex*100)\">\n        <nz-tab-body\n          class=\"ant-tabs-tabpane\"\n          [class.ant-tabs-tabpane-active]=\"(nzSelectedIndex == i)&&!nzHide\"\n          [class.ant-tabs-tabpane-inactive]=\"(nzSelectedIndex != i)||nzHide\"\n          [content]=\"tab.content\"\n          *ngFor=\"let tab of _tabs; let i = index\">\n        </nz-tab-body>\n      </div>\n    </div>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-container {\n  height: 32px;\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-ink-bar {\n  visibility: hidden;\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {\n  margin: 0;\n  border: 1px solid #d9d9d9;\n  border-bottom: 0;\n  border-radius: 4px 4px 0 0;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  background: #f9f9f9;\n  margin-right: 2px;\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {\n  padding: 5px 16px 4px;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {\n  background: #fff;\n  border-color: #d9d9d9;\n  color: #108ee9;\n  padding-bottom: 5px;\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-inactive {\n  padding: 0;\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-wrap {\n  margin-bottom: 0;\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {\n  color: rgba(0, 0, 0, 0.43);\n  transition: all .3s;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  margin-right: 0;\n  opacity: 0;\n  position: absolute;\n  right: 2px;\n  top: 50%;\n  margin-top: -5px;\n  overflow: hidden;\n  text-align: center;\n  border-radius: 2px;\n  width: 14px;\n  height: 14px;\n  line-height: 1;\n}\n:root .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {\n  filter: none;\n}\n:root .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {\n  font-size: 12px;\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close:hover {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ant-tabs.ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane,\n.ant-tabs.ant-tabs-editable-card .ant-tabs-content > .ant-tabs-tabpane {\n  transition: none !important;\n}\n.ant-tabs.ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane-inactive,\n.ant-tabs.ant-tabs-editable-card .ant-tabs-content > .ant-tabs-tabpane-inactive {\n  overflow: hidden;\n}\n.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab:hover .anticon-close {\n  opacity: 1;\n}\n.ant-tabs-extra-content {\n  line-height: 32px;\n}\n.ant-tabs-extra-content .ant-tabs-new-tab {\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  color: rgba(0, 0, 0, 0.43);\n  transition: all .3s;\n}\n:root .ant-tabs-extra-content .ant-tabs-new-tab {\n  filter: none;\n}\n:root .ant-tabs-extra-content .ant-tabs-new-tab {\n  font-size: 12px;\n}\n.ant-tabs-extra-content .ant-tabs-new-tab:hover {\n  color: #108ee9;\n  border-color: #108ee9;\n}\n.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-container {\n  height: auto;\n}\n.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {\n  border-bottom: 1px solid #d9d9d9;\n  margin-bottom: 8px;\n}\n.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {\n  padding-bottom: 4px;\n}\n.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab:last-child {\n  margin-bottom: 8px;\n}\n.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-new-tab {\n  width: 90%;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-left > .ant-tabs-bar .ant-tabs-nav-wrap {\n  margin-right: 0;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab {\n  border-right: 0;\n  border-radius: 4px 0 0 4px;\n  margin-right: 1px;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab-active {\n  margin-right: -1px;\n  padding-right: 18px;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-right > .ant-tabs-bar .ant-tabs-nav-wrap {\n  margin-left: 0;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-right > .ant-tabs-bar .ant-tabs-tab {\n  border-left: 0;\n  border-radius: 0 4px 4px 0;\n  margin-left: 1px;\n}\n.ant-tabs-vertical.ant-tabs-card.ant-tabs-right > .ant-tabs-bar .ant-tabs-tab-active {\n  margin-left: -1px;\n  padding-left: 18px;\n}\n.ant-tabs {\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n  zoom: 1;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-tabs:before,\n.ant-tabs:after {\n  content: \" \";\n  display: table;\n}\n.ant-tabs:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-tabs-ink-bar {\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  bottom: 1px;\n  box-sizing: border-box;\n  height: 2px;\n  background-color: #108ee9;\n  transform-origin: 0 0;\n}\n.ant-tabs-bar {\n  border-bottom: 1px solid #d9d9d9;\n  margin-bottom: 16px;\n  outline: none;\n  transition: padding .45s;\n}\n.ant-tabs-nav-container {\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 1.5;\n  box-sizing: border-box;\n  position: relative;\n  white-space: nowrap;\n  margin-bottom: -1px;\n  transition: padding .45s;\n  zoom: 1;\n}\n.ant-tabs-nav-container:before,\n.ant-tabs-nav-container:after {\n  content: \" \";\n  display: table;\n}\n.ant-tabs-nav-container:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-tabs-nav-container-scrolling {\n  padding-left: 32px;\n  padding-right: 32px;\n}\n.ant-tabs-tab-prev,\n.ant-tabs-tab-next {\n  user-select: none;\n  z-index: 2;\n  width: 0;\n  height: 0;\n  line-height: 32px;\n  cursor: pointer;\n  border: 0;\n  background-color: transparent;\n  position: absolute;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.43);\n  transition: width .3s, height .3s, opacity .3s, color .3s;\n  opacity: 0;\n  pointer-events: none;\n}\n.ant-tabs-tab-prev.ant-tabs-tab-arrow-show,\n.ant-tabs-tab-next.ant-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 32px;\n  height: 100%;\n  pointer-events: auto;\n}\n.ant-tabs-tab-prev:hover,\n.ant-tabs-tab-next:hover {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-tabs-tab-prev-icon,\n.ant-tabs-tab-next-icon {\n  font-style: normal;\n  font-weight: bold;\n  font-variant: normal;\n  line-height: inherit;\n  vertical-align: baseline;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  text-transform: none;\n}\n.ant-tabs-tab-prev-icon:before,\n.ant-tabs-tab-next-icon:before {\n  display: block;\n  font-family: \"anticon\" !important;\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-tabs-tab-prev-icon:before,\n:root .ant-tabs-tab-next-icon:before {\n  filter: none;\n}\n:root .ant-tabs-tab-prev-icon:before,\n:root .ant-tabs-tab-next-icon:before {\n  font-size: 12px;\n}\n.ant-tabs-tab-btn-disabled {\n  cursor: not-allowed;\n}\n.ant-tabs-tab-btn-disabled,\n.ant-tabs-tab-btn-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-tabs-tab-next {\n  right: 2px;\n}\n.ant-tabs-tab-next-icon:before {\n  content: \"\\e61f\";\n}\n.ant-tabs-tab-prev {\n  left: 0;\n}\n.ant-tabs-tab-prev-icon:before {\n  content: \"\\e620\";\n}\n:root .ant-tabs-tab-prev {\n  filter: none;\n}\n.ant-tabs-nav-wrap {\n  overflow: hidden;\n  margin-bottom: -1px;\n}\n.ant-tabs-nav-scroll {\n  overflow: hidden;\n  white-space: nowrap;\n}\n.ant-tabs-nav {\n  box-sizing: border-box;\n  padding-left: 0;\n  transition: transform 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);\n  position: relative;\n  margin: 0;\n  list-style: none;\n  display: inline-block;\n}\n.ant-tabs-nav:before,\n.ant-tabs-nav:after {\n  display: table;\n  content: \" \";\n}\n.ant-tabs-nav:after {\n  clear: both;\n}\n.ant-tabs-nav .ant-tabs-tab-disabled {\n  pointer-events: none;\n  cursor: default;\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-tabs-nav .ant-tabs-tab {\n  display: inline-block;\n  height: 100%;\n  margin-right: 24px;\n  box-sizing: border-box;\n  position: relative;\n  padding: 8px 20px;\n  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n  cursor: pointer;\n  text-decoration: none;\n}\n.ant-tabs-nav .ant-tabs-tab:last-child {\n  margin-right: 0;\n}\n.ant-tabs-nav .ant-tabs-tab:hover {\n  color: #49a9ee;\n}\n.ant-tabs-nav .ant-tabs-tab:active {\n  color: #0e77ca;\n}\n.ant-tabs-nav .ant-tabs-tab .anticon {\n  width: 14px;\n  height: 14px;\n  margin-right: 8px;\n}\n.ant-tabs-nav .ant-tabs-tab-active {\n  color: #108ee9;\n}\n.ant-tabs-mini .ant-tabs-nav-container {\n  font-size: 12px;\n}\n.ant-tabs-mini .ant-tabs-tab {\n  margin-right: 0;\n  padding: 8px 16px;\n}\n.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content {\n  width: 100%;\n}\n.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content > .ant-tabs-tabpane {\n  flex-shrink: 0;\n  width: 100%;\n  transition: opacity .45s;\n  opacity: 1;\n}\n.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content > .ant-tabs-tabpane-inactive {\n  opacity: 0;\n  height: 0;\n  padding: 0 !important;\n  pointer-events: none;\n}\n.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content-animated {\n  display: flex;\n  flex-direction: row;\n  will-change: margin-left;\n  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs-vertical > .ant-tabs-bar {\n  border-bottom: 0;\n  height: 100%;\n}\n.ant-tabs-vertical > .ant-tabs-bar-tab-prev.ant-tabs-tab-arrow-show,\n.ant-tabs-vertical > .ant-tabs-bar-tab-next.ant-tabs-tab-arrow-show {\n  width: 100%;\n  height: 32px;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab {\n  float: none;\n  margin-right: 0;\n  margin-bottom: 16px;\n  display: block;\n  padding: 8px 24px;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab:last-child {\n  margin-bottom: 0;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-extra-content {\n  text-align: center;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-scroll {\n  width: auto;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-container,\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-wrap {\n  height: 100%;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-container {\n  margin-bottom: 0;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-container.ant-tabs-nav-container-scrolling {\n  padding: 32px 0;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-wrap {\n  margin-bottom: 0;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav {\n  width: 100%;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-ink-bar {\n  width: 2px;\n  left: auto;\n  height: auto;\n  top: 0;\n}\n.ant-tabs-vertical > .ant-tabs-content {\n  overflow: hidden;\n  width: auto;\n  margin-top: 0 !important;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-next {\n  width: 100%;\n  bottom: 0;\n  height: 32px;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-next-icon:before {\n  content: \"\\e61d\";\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-prev {\n  top: 0;\n  width: 100%;\n  height: 32px;\n}\n.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-prev-icon:before {\n  content: \"\\e61e\";\n}\n.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar {\n  float: left;\n  border-right: 1px solid #e9e9e9;\n  margin-right: -1px;\n  margin-bottom: 0;\n}\n.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab {\n  text-align: right;\n}\n.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-nav-container {\n  margin-right: -1px;\n}\n.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-nav-wrap {\n  margin-right: -1px;\n}\n.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-ink-bar {\n  right: 1px;\n}\n.ant-tabs-vertical.ant-tabs-left > .ant-tabs-content {\n  padding-left: 24px;\n  border-left: 1px solid #e9e9e9;\n}\n.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar {\n  float: right;\n  border-left: 1px solid #e9e9e9;\n  margin-left: -1px;\n  margin-bottom: 0;\n}\n.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-nav-container {\n  margin-left: -1px;\n}\n.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-nav-wrap {\n  margin-left: -1px;\n}\n.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-ink-bar {\n  left: 1px;\n}\n.ant-tabs-vertical.ant-tabs-right > .ant-tabs-content {\n  padding-right: 24px;\n  border-right: 1px solid #e9e9e9;\n}\n.ant-tabs-bottom > .ant-tabs-bar {\n  margin-bottom: 0;\n  margin-top: 16px;\n}\n.ant-tabs-top .ant-tabs-ink-bar-animated,\n.ant-tabs-bottom .ant-tabs-ink-bar-animated {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-tabs-left .ant-tabs-ink-bar-animated,\n.ant-tabs-right .ant-tabs-ink-bar-animated {\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.no-flex > .ant-tabs-content-animated,\n.ant-tabs-no-animation > .ant-tabs-content-animated,\n.ant-tabs-vertical > .ant-tabs-content-animated {\n  transform: none !important;\n  margin-left: 0 !important;\n}\n.no-flex > .ant-tabs-content > .ant-tabs-tabpane-inactive,\n.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-tabpane-inactive,\n.ant-tabs-vertical > .ant-tabs-content > .ant-tabs-tabpane-inactive {\n  display: none;\n}\n",
                    "nz-tab {\n  display: block;\n}\nnz-tabs-nav {\n  display: block;\n}\nnz-tabset {\n  display: block;\n  position: relative;\n  overflow: hidden;\n}\nnz-tabset .ant-tabs {\n  height: 100%;\n}\nnz-tab-body {\n  display: block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzTabSetComponent.ctorParameters = function () { return [
    { type: Renderer2, },
]; };
NzTabSetComponent.propDecorators = {
    'nzTabBarExtraContent': [{ type: ContentChild, args: ['nzTabBarExtraContent',] },],
    '_tabNav': [{ type: ViewChild, args: ['tabNav',] },],
    '_tabContent': [{ type: ViewChild, args: ['tabContent',] },],
    '_hostContent': [{ type: ViewChild, args: ['hostContent',] },],
    'nzAnimated': [{ type: Input },],
    'nzShowPagination': [{ type: Input },],
    'nzHide': [{ type: Input },],
    'nzSelectedIndex': [{ type: Input },],
    'nzSelectedIndexChange': [{ type: Output },],
    'nzSelectChange': [{ type: Output },],
    'nzSize': [{ type: Input },],
    'nzTabPosition': [{ type: Input },],
    'nzType': [{ type: Input },],
};
var NzTabComponent = (function () {
    /**
     * @param {?} nzTabSetComponent
     */
    function NzTabComponent(nzTabSetComponent) {
        this.nzTabSetComponent = nzTabSetComponent;
        this.position = null;
        this.origin = null;
        this.disabled = false;
        this.nzSelect = new EventEmitter();
        this.nzClick = new EventEmitter();
        this.nzDeselect = new EventEmitter();
        this._nzTabsTabpane = true;
    }
    Object.defineProperty(NzTabComponent.prototype, "nzDisabled", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabComponent.prototype, "content", {
        /**
         * @return {?}
         */
        get: function () {
            return this._content;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzTabComponent.prototype.ngOnInit = function () {
        this.nzTabSetComponent._tabs.push(this);
    };
    /**
     * @return {?}
     */
    NzTabComponent.prototype.ngOnDestroy = function () {
        this.nzTabSetComponent._tabs.splice(this.nzTabSetComponent._tabs.indexOf(this), 1);
    };
    return NzTabComponent;
}());
NzTabComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-tab',
                template: "\n    <ng-template>\n      <ng-content></ng-content>\n    </ng-template>\n  ",
                styles: []
            },] },
];
/**
 * @nocollapse
 */
NzTabComponent.ctorParameters = function () { return [
    { type: NzTabSetComponent, },
]; };
NzTabComponent.propDecorators = {
    'nzDisabled': [{ type: Input },],
    'nzSelect': [{ type: Output },],
    'nzClick': [{ type: Output },],
    'nzDeselect': [{ type: Output },],
    '_tabHeading': [{ type: ContentChild, args: ['nzTabHeading',] },],
    '_nzTabsTabpane': [{ type: HostBinding, args: ['class.ant-tabs-tabpane',] },],
    '_content': [{ type: ViewChild, args: [TemplateRef,] },],
};
var NzTabLabelDirective = (function () {
    /**
     * @param {?} elementRef
     */
    function NzTabLabelDirective(elementRef) {
        this.elementRef = elementRef;
        this._nzTabsTab = true;
        this.disabled = false;
    }
    /**
     * @return {?}
     */
    NzTabLabelDirective.prototype.getOffsetLeft = function () {
        return this.elementRef.nativeElement.offsetLeft;
    };
    /**
     * @return {?}
     */
    NzTabLabelDirective.prototype.getOffsetWidth = function () {
        return this.elementRef.nativeElement.offsetWidth;
    };
    /**
     * @return {?}
     */
    NzTabLabelDirective.prototype.getOffsetTop = function () {
        return this.elementRef.nativeElement.offsetTop;
    };
    /**
     * @return {?}
     */
    NzTabLabelDirective.prototype.getOffsetHeight = function () {
        return this.elementRef.nativeElement.offsetHeight;
    };
    return NzTabLabelDirective;
}());
NzTabLabelDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-tab-label]'
            },] },
];
/**
 * @nocollapse
 */
NzTabLabelDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NzTabLabelDirective.propDecorators = {
    '_nzTabsTab': [{ type: HostBinding, args: ['class.ant-tabs-tab',] },],
    'disabled': [{ type: Input }, { type: HostBinding, args: ['class.ant-tabs-tab-disabled',] },],
};
/** code from https://github.com/angular/material2 */
var EXAGGERATED_OVERSCROLL = 64;
var NzTabsNavComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _ngZone
     * @param {?} _renderer
     * @param {?} _dir
     */
    function NzTabsNavComponent(_elementRef, _ngZone, _renderer, _dir) {
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
        this._renderer = _renderer;
        this._dir = _dir;
        this._showPaginationControls = false;
        this._disableScrollAfter = true;
        this._disableScrollBefore = true;
        this._scrollDistance = 0;
        this._selectedIndexChanged = false;
        this._realignInkBar = null;
        this._selectedIndex = 0;
        this._tabPositionMode = 'horizontal';
        this.nzAnimated = true;
        this.nzHideBar = false;
        this.nzSize = 'default';
        this._type = 'line';
        this._nzTabsBar = true;
        this.nzShowPagination = true;
    }
    Object.defineProperty(NzTabsNavComponent.prototype, "nzType", {
        /**
         * @return {?}
         */
        get: function () {
            return this._type;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._type = value;
            if (this._type !== 'line') {
                this._inkBar.setDisplay('none');
            }
            else {
                this._inkBar.setDisplay('block');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabsNavComponent.prototype, "nzPositionMode", {
        /**
         * @return {?}
         */
        get: function () {
            return this._tabPositionMode;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._tabPositionMode = value;
            this._alignInkBarToSelectedTab();
            if (this.nzShowPagination) {
                this._updatePagination();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabsNavComponent.prototype, "selectedIndex", {
        /**
         * @return {?}
         */
        get: function () {
            return this._selectedIndex;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selectedIndexChanged = this._selectedIndex !== value;
            this._selectedIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype._onContentChanges = function () {
        if (this.nzShowPagination) {
            this._updatePagination();
        }
        this._alignInkBarToSelectedTab();
    };
    /**
     * @param {?} scrollDir
     * @return {?}
     */
    NzTabsNavComponent.prototype._scrollHeader = function (scrollDir) {
        // Move the scroll distance one-third the length of the tab list's viewport.
        this.scrollDistance += (scrollDir === 'before' ? -1 : 1) * this.viewWidthHeightPix / 3;
    };
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype.ngAfterContentChecked = function () {
        if (this._tabLabelCount !== this._labelWrappers.length) {
            if (this.nzShowPagination) {
                this._updatePagination();
            }
            this._tabLabelCount = this._labelWrappers.length;
        }
        if (this._selectedIndexChanged) {
            this._scrollToLabel(this._selectedIndex);
            if (this.nzShowPagination) {
                this._checkScrollingControls();
            }
            this._alignInkBarToSelectedTab();
            this._selectedIndexChanged = false;
        }
        if (this._scrollDistanceChanged) {
            if (this.nzShowPagination) {
                this._updateTabScrollPosition();
            }
            this._scrollDistanceChanged = false;
        }
    };
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._realignInkBar = this._ngZone.runOutsideAngular(function () {
            var /** @type {?} */ dirChange = _this._dir ? _this._dir.change : of$1(null);
            var /** @type {?} */ resize = typeof window !== 'undefined' ?
                auditTime$1.call(fromEvent$1(window, 'resize'), 10) :
                of$1(null);
            return startWith$1.call(merge$1(dirChange, resize), null).subscribe(function () {
                if (_this.nzShowPagination) {
                    _this._updatePagination();
                }
                _this._alignInkBarToSelectedTab();
            });
        });
    };
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype._updateTabScrollPosition = function () {
        var /** @type {?} */ scrollDistance = this.scrollDistance;
        if (this.nzPositionMode === 'horizontal') {
            var /** @type {?} */ translateX = this._getLayoutDirection() === 'ltr' ? -scrollDistance : scrollDistance;
            this._renderer.setStyle(this._tabList.nativeElement, 'transform', "translate3d(" + translateX + "px, 0, 0)");
        }
        else {
            this._renderer.setStyle(this._tabList.nativeElement, 'transform', "translate3d(0," + -scrollDistance + "px, 0)");
        }
    };
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype._updatePagination = function () {
        this._checkPaginationEnabled();
        this._checkScrollingControls();
        this._updateTabScrollPosition();
    };
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype._checkPaginationEnabled = function () {
        this._showPaginationControls =
            this.tabListScrollWidthHeightPix > this.elementRefOffSetWidthHeight;
        if (!this._showPaginationControls) {
            this.scrollDistance = 0;
        }
    };
    /**
     * @param {?} labelIndex
     * @return {?}
     */
    NzTabsNavComponent.prototype._scrollToLabel = function (labelIndex) {
        var /** @type {?} */ selectedLabel = this._labelWrappers
            ? this._labelWrappers.toArray()[labelIndex]
            : null;
        if (!selectedLabel) {
            return;
        }
        // The view length is the visible width of the tab labels.
        var /** @type {?} */ labelBeforePos, /** @type {?} */ labelAfterPos;
        if (this.nzPositionMode === 'horizontal') {
            if (this._getLayoutDirection() === 'ltr') {
                labelBeforePos = selectedLabel.getOffsetLeft();
                labelAfterPos = labelBeforePos + selectedLabel.getOffsetWidth();
            }
            else {
                labelAfterPos = this._tabList.nativeElement.offsetWidth - selectedLabel.getOffsetLeft();
                labelBeforePos = labelAfterPos - selectedLabel.getOffsetWidth();
            }
        }
        else {
            labelBeforePos = selectedLabel.getOffsetTop();
            labelAfterPos = labelBeforePos + selectedLabel.getOffsetHeight();
        }
        var /** @type {?} */ beforeVisiblePos = this.scrollDistance;
        var /** @type {?} */ afterVisiblePos = this.scrollDistance + this.viewWidthHeightPix;
        if (labelBeforePos < beforeVisiblePos) {
            // Scroll header to move label to the before direction
            this.scrollDistance -= beforeVisiblePos - labelBeforePos + EXAGGERATED_OVERSCROLL;
        }
        else if (labelAfterPos > afterVisiblePos) {
            // Scroll header to move label to the after direction
            this.scrollDistance += labelAfterPos - afterVisiblePos + EXAGGERATED_OVERSCROLL;
        }
    };
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype._checkScrollingControls = function () {
        // Check if the pagination arrows should be activated.
        this._disableScrollBefore = this.scrollDistance === 0;
        this._disableScrollAfter = this.scrollDistance === this._getMaxScrollDistance();
    };
    /**
     * Determines what is the maximum length in pixels that can be set for the scroll distance. This
     * is equal to the difference in width between the tab list container and tab header container.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @return {?}
     */
    NzTabsNavComponent.prototype._getMaxScrollDistance = function () {
        return (this.tabListScrollWidthHeightPix - this.viewWidthHeightPix) || 0;
    };
    Object.defineProperty(NzTabsNavComponent.prototype, "scrollDistance", {
        /**
         * @return {?}
         */
        get: function () {
            return this._scrollDistance;
        },
        /**
         * Sets the distance in pixels that the tab header should be transformed in the X-axis.
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._scrollDistance = Math.max(0, Math.min(this._getMaxScrollDistance(), v));
            // Mark that the scroll distance has changed so that after the view is checked, the CSS
            // transformation can move the header.
            this._scrollDistanceChanged = true;
            this._checkScrollingControls();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabsNavComponent.prototype, "viewWidthHeightPix", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ PAGINATION_PIX = 0;
            if (this._showPaginationControls) {
                PAGINATION_PIX = 64;
            }
            if (this.nzPositionMode === 'horizontal') {
                return this._tabListContainer.nativeElement.offsetWidth - PAGINATION_PIX;
            }
            else {
                return this._tabListContainer.nativeElement.offsetHeight - PAGINATION_PIX;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabsNavComponent.prototype, "tabListScrollWidthHeightPix", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.nzPositionMode === 'horizontal') {
                return this._tabList.nativeElement.scrollWidth;
            }
            else {
                return this._tabList.nativeElement.scrollHeight;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTabsNavComponent.prototype, "elementRefOffSetWidthHeight", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.nzPositionMode === 'horizontal') {
                return this._elementRef.nativeElement.offsetWidth;
            }
            else {
                return this._elementRef.nativeElement.offsetHeight;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype._getLayoutDirection = function () {
        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
    };
    /**
     * @return {?}
     */
    NzTabsNavComponent.prototype._alignInkBarToSelectedTab = function () {
        if (this.nzType === 'line') {
            var /** @type {?} */ selectedLabelWrapper = this._labelWrappers && this._labelWrappers.length
                ? this._labelWrappers.toArray()[this.selectedIndex].elementRef.nativeElement
                : null;
            if (this._inkBar) {
                this._inkBar.alignToElement(selectedLabelWrapper);
            }
        }
    };
    return NzTabsNavComponent;
}());
NzTabsNavComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-tabs-nav',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div style=\"float:right;\" *ngIf=\"_tabBarExtraContent\">\n      <div class=\"ant-tabs-extra-content\">\n        <ng-template [ngTemplateOutlet]=\"_tabBarExtraContent\">\n        </ng-template>\n      </div>\n    </div>\n    <div class=\"ant-tabs-nav-container\" [class.ant-tabs-nav-container-scrolling]=\"_showPaginationControls\" #tabListContainer>\n      <span class=\"ant-tabs-tab-prev ant-tabs-tab-arrow-show\" (click)=\"_scrollHeader('before')\" [class.ant-tabs-tab-btn-disabled]=\"_disableScrollBefore\" *ngIf=\"_showPaginationControls\">\n        <span class=\"ant-tabs-tab-prev-icon\"></span>\n      </span>\n      <span class=\"ant-tabs-tab-next ant-tabs-tab-arrow-show\" (click)=\"_scrollHeader('after')\" [class.ant-tabs-tab-btn-disabled]=\"_disableScrollAfter\" *ngIf=\"_showPaginationControls\">\n        <span class=\"ant-tabs-tab-next-icon\"></span>\n      </span>\n      <div class=\"ant-tabs-nav-wrap\">\n        <div class=\"ant-tabs-nav-scroll\">\n          <div class=\"ant-tabs-nav\" [class.ant-tabs-nav-animated]=\"nzAnimated\" #tabList (cdkObserveContent)=\"_onContentChanges()\">\n            <div nz-tabs-ink-bar [hidden]=\"nzHideBar\" [nzAnimated]=\"nzAnimated\" [nzPositionMode]=\"nzPositionMode\" style=\"display: block;\"></div>\n            <ng-content></ng-content>\n          </div>\n        </div>\n      </div>\n    </div>"
            },] },
];
/**
 * @nocollapse
 */
NzTabsNavComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: NgZone, },
    { type: Renderer2, },
    { type: Directionality, decorators: [{ type: Optional },] },
]; };
NzTabsNavComponent.propDecorators = {
    'nzAnimated': [{ type: Input },],
    'nzHideBar': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzType': [{ type: Input },],
    '_tabBarExtraContent': [{ type: ContentChild, args: ['tabBarExtraContent',] },],
    '_labelWrappers': [{ type: ContentChildren, args: [NzTabLabelDirective,] },],
    '_inkBar': [{ type: ViewChild, args: [NzTabsInkBarDirective,] },],
    '_tabListContainer': [{ type: ViewChild, args: ['tabListContainer',] },],
    '_tabList': [{ type: ViewChild, args: ['tabList',] },],
    '_nzTabsBar': [{ type: HostBinding, args: ['class.ant-tabs-bar',] },],
    'nzShowPagination': [{ type: Input },],
    'nzPositionMode': [{ type: Input },],
    'selectedIndex': [{ type: Input },],
};
var NzTabBodyComponent = (function () {
    function NzTabBodyComponent() {
    }
    return NzTabBodyComponent;
}());
NzTabBodyComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-tab-body',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-template [ngTemplateOutlet]=\"content\"></ng-template>\n  ",
            },] },
];
/**
 * @nocollapse
 */
NzTabBodyComponent.ctorParameters = function () { return []; };
NzTabBodyComponent.propDecorators = {
    'content': [{ type: Input },],
};
var NzTabsModule = (function () {
    function NzTabsModule() {
    }
    return NzTabsModule;
}());
NzTabsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzTabComponent, NzTabSetComponent, NzTabsNavComponent, NzTabLabelDirective, NzTabsInkBarDirective, NzTabBodyComponent],
                exports: [NzTabComponent, NzTabSetComponent, NzTabsNavComponent, NzTabLabelDirective, NzTabsInkBarDirective, NzTabBodyComponent],
                imports: [CommonModule, PortalModule, ObserveContentModule]
            },] },
];
/**
 * @nocollapse
 */
NzTabsModule.ctorParameters = function () { return []; };
var NzTagComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _render
     */
    function NzTagComponent(_elementRef, _render) {
        this._elementRef = _elementRef;
        this._render = _render;
        this._prefixCls = 'ant-tag';
        this._closed = false;
        /**
         * Whether tag is closable
         */
        this.nzClosable = false;
        /**
         * Event: emit before close
         */
        this.nzBeforeClose = new EventEmitter();
        /**
         * Event: emit after close
         */
        this.nzClose = new EventEmitter();
    }
    Object.defineProperty(NzTagComponent.prototype, "_dataShow", {
        /**
         * @return {?}
         */
        get: function () {
            return !this._closed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTagComponent.prototype, "_backgroundColor", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ isPresetColor = this._isPresetColor(this.nzColor);
            return (this.nzColor && !isPresetColor) ? this.nzColor : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    NzTagComponent.prototype._afterClose = function (event) {
        if (this._closed) {
            this.nzClose.emit(event);
        }
    };
    Object.defineProperty(NzTagComponent.prototype, "_tagCls", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ isPresetColor = this._isPresetColor(this.nzColor);
            return _a = {},
                _a[this._prefixCls] = true,
                _a[this._prefixCls + "-" + this.nzColor] = isPresetColor,
                _a[this._prefixCls + "-has-color"] = (this.nzColor && !isPresetColor),
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzTagComponent.prototype, "_textClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this._prefixCls + "-text";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    NzTagComponent.prototype._close = function (event) {
        this.nzBeforeClose.emit(event);
        if (event.defaultPrevented) {
            return;
        }
        this._closed = true;
    };
    /**
     * @param {?} color
     * @return {?}
     */
    NzTagComponent.prototype._isPresetColor = function (color) {
        return /^(pink|red|yellow|orange|cyan|green|blue|purple)(-inverse)?$/.test(color);
    };
    /**
     * @return {?}
     */
    NzTagComponent.prototype.ngOnInit = function () {
    };
    /**
     * @return {?}
     */
    NzTagComponent.prototype.ngAfterViewInit = function () {
        this._render.addClass(this._elementRef.nativeElement, this._prefixCls + "-root");
    };
    return NzTagComponent;
}());
NzTagComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-tag',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    TagAnimation
                ],
                template: "\n    <span *ngIf=\"!_closed\"\n      [ngClass]=\"_tagCls\"\n      [style.backgroundColor]=\"_backgroundColor\"\n      [@tagAnimation]\n      (@tagAnimation.done)=\"_afterClose($event)\">\n      <span [class]=\"_textClass\"><ng-content></ng-content></span>\n      <i class=\"anticon anticon-cross\" (click)=\"_close($event)\" *ngIf=\"nzClosable\"></i>\n    </span>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-tag {\n  display: inline-block;\n  line-height: 20px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 4px;\n  border: 1px solid #e9e9e9;\n  background: #f3f3f3;\n  font-size: 12px;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  opacity: 1;\n  margin-right: 8px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.ant-tag:hover {\n  opacity: 0.85;\n}\n.ant-tag,\n.ant-tag a,\n.ant-tag a:hover {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-tag-text a:first-child:last-child {\n  display: inline-block;\n  margin: 0 -8px;\n  padding: 0 8px;\n}\n.ant-tag .anticon-cross {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  cursor: pointer;\n  font-weight: bold;\n  margin-left: 3px;\n  transition: all 0.3s ease;\n  opacity: 0.66;\n}\n:root .ant-tag .anticon-cross {\n  filter: none;\n}\n:root .ant-tag .anticon-cross {\n  font-size: 12px;\n}\n.ant-tag .anticon-cross:hover {\n  opacity: 1;\n}\n.ant-tag-has-color {\n  border-color: transparent;\n}\n.ant-tag-has-color,\n.ant-tag-has-color a,\n.ant-tag-has-color a:hover,\n.ant-tag-has-color .anticon-cross,\n.ant-tag-has-color .anticon-cross:hover {\n  color: #fff;\n}\n.ant-tag-checkable {\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {\n  color: #108ee9;\n}\n.ant-tag-checkable:active,\n.ant-tag-checkable-checked {\n  color: #fff;\n}\n.ant-tag-checkable-checked {\n  background-color: #108ee9;\n}\n.ant-tag-checkable:active {\n  background-color: #0e77ca;\n}\n.ant-tag-close {\n  width: 0 !important;\n  padding: 0;\n  margin: 0;\n}\n.ant-tag-zoom-enter,\n.ant-tag-zoom-appear {\n  animation: antFadeIn 0.2s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  animation-fill-mode: both;\n}\n.ant-tag-zoom-leave {\n  animation: antZoomOut 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  animation-fill-mode: both;\n}\n.ant-tag-pink {\n  color: #f5317f;\n  background: #fdd8e7;\n  border-color: #fdd8e7;\n}\n.ant-tag-pink-inverse {\n  background: #f5317f;\n  border-color: #f5317f;\n  color: #fff;\n}\n.ant-tag-red {\n  color: #f04134;\n  background: #fcdbd9;\n  border-color: #fcdbd9;\n}\n.ant-tag-red-inverse {\n  background: #f04134;\n  border-color: #f04134;\n  color: #fff;\n}\n.ant-tag-orange {\n  color: #f56a00;\n  background: #fde3cf;\n  border-color: #fde3cf;\n}\n.ant-tag-orange-inverse {\n  background: #f56a00;\n  border-color: #f56a00;\n  color: #fff;\n}\n.ant-tag-yellow {\n  color: #ffbf00;\n  background: #fff3cf;\n  border-color: #fff3cf;\n}\n.ant-tag-yellow-inverse {\n  background: #ffbf00;\n  border-color: #ffbf00;\n  color: #fff;\n}\n.ant-tag-cyan {\n  color: #00a2ae;\n  background: #cfedf0;\n  border-color: #cfedf0;\n}\n.ant-tag-cyan-inverse {\n  background: #00a2ae;\n  border-color: #00a2ae;\n  color: #fff;\n}\n.ant-tag-green {\n  color: #00a854;\n  background: #cfefdf;\n  border-color: #cfefdf;\n}\n.ant-tag-green-inverse {\n  background: #00a854;\n  border-color: #00a854;\n  color: #fff;\n}\n.ant-tag-blue {\n  color: #108ee9;\n  background: #d2eafb;\n  border-color: #d2eafb;\n}\n.ant-tag-blue-inverse {\n  background: #108ee9;\n  border-color: #108ee9;\n  color: #fff;\n}\n.ant-tag-purple {\n  color: #7265e6;\n  background: #e4e2fa;\n  border-color: #e4e2fa;\n}\n.ant-tag-purple-inverse {\n  background: #7265e6;\n  border-color: #7265e6;\n  color: #fff;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-tag-root {\n  display: inline-block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzTagComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzTagComponent.propDecorators = {
    'nzClosable': [{ type: Input },],
    'nzColor': [{ type: Input },],
    'nzBeforeClose': [{ type: Output },],
    'nzClose': [{ type: Output },],
    '_dataShow': [{ type: HostBinding, args: ['attr.data-show',] },],
};
var NzCheckableTagComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _render
     */
    function NzCheckableTagComponent(_elementRef, _render) {
        this._elementRef = _elementRef;
        this._render = _render;
        this._prefixCls = 'ant-tag';
        this._closed = false;
        /**
         * Whether tag is checked
         */
        this.nzChecked = false;
        /**
         * Whether tag is closable
         */
        this.nzClosable = false;
        /**
         * Event: emit before close
         */
        this.nzBeforeClose = new EventEmitter();
        /**
         * Event: emit after close
         */
        this.nzClose = new EventEmitter();
        /**
         * Event: emit on change
         */
        this.nzChange = new EventEmitter();
    }
    Object.defineProperty(NzCheckableTagComponent.prototype, "_dataShow", {
        /**
         * @return {?}
         */
        get: function () {
            return !this._closed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCheckableTagComponent.prototype, "_backgroundColor", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ isPresetColor = this._isPresetColor(this.nzColor);
            return (this.nzColor && !isPresetColor) ? this.nzColor : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    NzCheckableTagComponent.prototype._afterClose = function (event) {
        if (this._closed) {
            this.nzClose.emit(event);
        }
    };
    Object.defineProperty(NzCheckableTagComponent.prototype, "_tagCls", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ isPresetColor = this._isPresetColor(this.nzColor);
            return _a = {},
                _a[this._prefixCls] = true,
                _a[this._prefixCls + "-" + this.nzColor] = isPresetColor,
                _a[this._prefixCls + "-has-color"] = (this.nzColor && !isPresetColor),
                _a[this._prefixCls + "-checkable"] = true,
                _a[this._prefixCls + "-checkable-checked"] = this.nzChecked,
                _a;
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCheckableTagComponent.prototype, "_textClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this._prefixCls + "-text";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    NzCheckableTagComponent.prototype._handleClick = function (event) {
        event.preventDefault();
        this.nzChange.emit(!this.nzChecked);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NzCheckableTagComponent.prototype._close = function (event) {
        this.nzBeforeClose.emit(event);
        if (event.defaultPrevented) {
            return;
        }
        this._closed = true;
    };
    /**
     * @param {?} color
     * @return {?}
     */
    NzCheckableTagComponent.prototype._isPresetColor = function (color) {
        return /^(pink|red|yellow|orange|cyan|green|blue|purple)(-inverse)?$/.test(color);
    };
    /**
     * @return {?}
     */
    NzCheckableTagComponent.prototype.ngOnInit = function () {
    };
    /**
     * @return {?}
     */
    NzCheckableTagComponent.prototype.ngAfterViewInit = function () {
        this._render.addClass(this._elementRef.nativeElement, this._prefixCls + "-root");
    };
    return NzCheckableTagComponent;
}());
NzCheckableTagComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-checkable-tag',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    TagAnimation
                ],
                template: "\n    <span *ngIf=\"!_closed\"\n      [ngClass]=\"_tagCls\"\n      [style.backgroundColor]=\"_backgroundColor\"\n      [@tagAnimation]\n      (@tagAnimation.done)=\"_afterClose($event)\">\n      <span [class]=\"_textClass\"><ng-content></ng-content></span>\n      <i class=\"anticon anticon-cross\" (click)=\"_close($event)\" *ngIf=\"nzClosable\"></i>\n    </span>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-tag {\n  display: inline-block;\n  line-height: 20px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 4px;\n  border: 1px solid #e9e9e9;\n  background: #f3f3f3;\n  font-size: 12px;\n  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  opacity: 1;\n  margin-right: 8px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.ant-tag:hover {\n  opacity: 0.85;\n}\n.ant-tag,\n.ant-tag a,\n.ant-tag a:hover {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-tag-text a:first-child:last-child {\n  display: inline-block;\n  margin: 0 -8px;\n  padding: 0 8px;\n}\n.ant-tag .anticon-cross {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  cursor: pointer;\n  font-weight: bold;\n  margin-left: 3px;\n  transition: all 0.3s ease;\n  opacity: 0.66;\n}\n:root .ant-tag .anticon-cross {\n  filter: none;\n}\n:root .ant-tag .anticon-cross {\n  font-size: 12px;\n}\n.ant-tag .anticon-cross:hover {\n  opacity: 1;\n}\n.ant-tag-has-color {\n  border-color: transparent;\n}\n.ant-tag-has-color,\n.ant-tag-has-color a,\n.ant-tag-has-color a:hover,\n.ant-tag-has-color .anticon-cross,\n.ant-tag-has-color .anticon-cross:hover {\n  color: #fff;\n}\n.ant-tag-checkable {\n  background-color: transparent;\n  border-color: transparent;\n}\n.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {\n  color: #108ee9;\n}\n.ant-tag-checkable:active,\n.ant-tag-checkable-checked {\n  color: #fff;\n}\n.ant-tag-checkable-checked {\n  background-color: #108ee9;\n}\n.ant-tag-checkable:active {\n  background-color: #0e77ca;\n}\n.ant-tag-close {\n  width: 0 !important;\n  padding: 0;\n  margin: 0;\n}\n.ant-tag-zoom-enter,\n.ant-tag-zoom-appear {\n  animation: antFadeIn 0.2s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  animation-fill-mode: both;\n}\n.ant-tag-zoom-leave {\n  animation: antZoomOut 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n  animation-fill-mode: both;\n}\n.ant-tag-pink {\n  color: #f5317f;\n  background: #fdd8e7;\n  border-color: #fdd8e7;\n}\n.ant-tag-pink-inverse {\n  background: #f5317f;\n  border-color: #f5317f;\n  color: #fff;\n}\n.ant-tag-red {\n  color: #f04134;\n  background: #fcdbd9;\n  border-color: #fcdbd9;\n}\n.ant-tag-red-inverse {\n  background: #f04134;\n  border-color: #f04134;\n  color: #fff;\n}\n.ant-tag-orange {\n  color: #f56a00;\n  background: #fde3cf;\n  border-color: #fde3cf;\n}\n.ant-tag-orange-inverse {\n  background: #f56a00;\n  border-color: #f56a00;\n  color: #fff;\n}\n.ant-tag-yellow {\n  color: #ffbf00;\n  background: #fff3cf;\n  border-color: #fff3cf;\n}\n.ant-tag-yellow-inverse {\n  background: #ffbf00;\n  border-color: #ffbf00;\n  color: #fff;\n}\n.ant-tag-cyan {\n  color: #00a2ae;\n  background: #cfedf0;\n  border-color: #cfedf0;\n}\n.ant-tag-cyan-inverse {\n  background: #00a2ae;\n  border-color: #00a2ae;\n  color: #fff;\n}\n.ant-tag-green {\n  color: #00a854;\n  background: #cfefdf;\n  border-color: #cfefdf;\n}\n.ant-tag-green-inverse {\n  background: #00a854;\n  border-color: #00a854;\n  color: #fff;\n}\n.ant-tag-blue {\n  color: #108ee9;\n  background: #d2eafb;\n  border-color: #d2eafb;\n}\n.ant-tag-blue-inverse {\n  background: #108ee9;\n  border-color: #108ee9;\n  color: #fff;\n}\n.ant-tag-purple {\n  color: #7265e6;\n  background: #e4e2fa;\n  border-color: #e4e2fa;\n}\n.ant-tag-purple-inverse {\n  background: #7265e6;\n  border-color: #7265e6;\n  color: #fff;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-tag-root {\n  display: inline-block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCheckableTagComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzCheckableTagComponent.propDecorators = {
    'nzChecked': [{ type: Input },],
    'nzClosable': [{ type: Input },],
    'nzColor': [{ type: Input },],
    'nzBeforeClose': [{ type: Output },],
    'nzClose': [{ type: Output },],
    'nzChange': [{ type: Output },],
    '_dataShow': [{ type: HostBinding, args: ['attr.data-show',] },],
    '_handleClick': [{ type: HostListener, args: ['click', ['$event'],] },],
};
var NzTagModule = (function () {
    function NzTagModule() {
    }
    return NzTagModule;
}());
NzTagModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule],
                declarations: [
                    NzTagComponent, NzCheckableTagComponent
                ],
                exports: [
                    NzTagComponent, NzCheckableTagComponent
                ]
            },] },
];
/**
 * @nocollapse
 */
NzTagModule.ctorParameters = function () { return []; };
var NzProgressComponent = (function () {
    function NzProgressComponent() {
        this._statusColorMap = {
            normal: '#108ee9',
            exception: '#ff5500',
            success: '#87d068',
        };
        this._pathString = '';
        this._pathStyle = {};
        this._circleStyle = {};
        this._percent = 0;
        this._hasFormat = false;
        this._rawStatus = 'normal';
        // ngModel Access
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.nzType = 'line';
        this.nzStrokeWidth = this.nzType === 'line' ? 10 : 6;
        this.nzWidth = 132;
        this.nzShowInfo = true;
        this.nzStatus = 'normal';
        this._format = function (percent) { return percent + '%'; };
    }
    Object.defineProperty(NzProgressComponent.prototype, "_setFormat", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._format = value;
            this._hasFormat = true;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzProgressComponent.prototype.updateCircleStatus = function () {
        var /** @type {?} */ circleSize = this.nzWidth || 132;
        this._circleStyle = {
            'width.px': circleSize,
            'height.px': circleSize,
            'font-size.px': circleSize * 0.16 + 6,
        };
        var /** @type {?} */ radius = 50 - this.nzStrokeWidth / 2;
        var /** @type {?} */ len = Math.PI * 2 * radius;
        this._pathString = 'M 50,50 m 0,-' + radius + '\n     a ' + radius + ',' + radius + ' 0 1 1 0,' + 2 * radius + '\n     a ' + radius + ',' + radius + ' 0 1 1 0,-' + 2 * radius;
        this._pathStyle = {
            'stroke-dasharray': len + 'px ' + len + 'px',
            'stroke-dashoffset': (100 - this._percent) / 100 * len + 'px',
            'transition': 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s ease'
        };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NzProgressComponent.prototype.writeValue = function (value) {
        this._percent = value;
        if (this._percent === 100) {
            this.nzStatus = 'success';
        }
        else {
            this.nzStatus = this._rawStatus;
        }
        if (this.nzType === 'circle') {
            this.updateCircleStatus();
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzProgressComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NzProgressComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * @return {?}
     */
    NzProgressComponent.prototype.ngOnInit = function () {
        this._rawStatus = this.nzStatus;
    };
    return NzProgressComponent;
}());
NzProgressComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-progress',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div [ngClass]=\"'ant-progress ant-progress-status-'+nzStatus\"\n      [class.ant-progress-line]=\"nzType=='line'\"\n      [class.ant-progress-show-info]=\"nzShowInfo\"\n      [class.ant-progress-circle]=\"nzType=='circle'\">\n      <div *ngIf=\"nzType=='line'\">\n        <div class=\"ant-progress-outer\"><!----><div class=\"ant-progress-inner\"><!----><div class=\"ant-progress-bg\" [style.width.%]=\"_percent\" [style.height.px]=\"nzStrokeWidth\"></div><!----></div><!----></div><!----><span class=\"ant-progress-text\" *ngIf=\"nzShowInfo\"><ng-template [ngIf]=\"(nzStatus=='active')||(nzStatus=='normal')||(_hasFormat)\">{{_format(_percent)}}</ng-template><ng-template [ngIf]=\"(nzStatus=='exception')||(nzStatus=='success')&&(!_hasFormat)\"><i class=\"anticon\" [ngClass]=\"{'anticon-check-circle':nzStatus=='success','anticon-cross-circle':nzStatus=='exception'}\"></i></ng-template></span>\n      </div>\n      <div class=\"ant-progress-inner\" *ngIf=\"nzType=='circle'\" [ngStyle]=\"_circleStyle\">\n        <svg class=\"rc-progress-circle \" viewBox=\"0 0 100 100\" *ngIf=\"nzType=='circle'\">\n          <path class=\"rc-progress-circle-trail\" [attr.d]=\"_pathString\" stroke=\"#f3f3f3\" [attr.stroke-width]=\"nzStrokeWidth\" fill-opacity=\"0\"></path>\n          <path class=\"rc-progress-circle-path\" [attr.d]=\"_pathString\" stroke-linecap=\"round\" [attr.stroke]=\"_statusColorMap[nzStatus]\" stroke-width=\"6\" fill-opacity=\"0\" [ngStyle]=\"_pathStyle\"></path>\n        </svg>\n        <span class=\"ant-progress-text\" *ngIf=\"nzShowInfo\"><ng-template [ngIf]=\"(nzStatus=='active')||(nzStatus=='normal')||(_hasFormat)\">{{_format(_percent)}}</ng-template><ng-template [ngIf]=\"(nzStatus=='exception')||(nzStatus=='success')&&!(_hasFormat)\"><i class=\"anticon\" [ngClass]=\"{'anticon-check':nzStatus=='success','anticon-cross':nzStatus=='exception'}\"></i></ng-template></span>\n      </div>\n    </div>\n  ",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return NzProgressComponent; }),
                        multi: true
                    }
                ],
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-progress {\n  display: inline-block;\n}\n.ant-progress-line {\n  width: 100%;\n  font-size: 12px;\n  position: relative;\n}\n.ant-progress-outer {\n  display: inline-block;\n  width: 100%;\n  margin-right: 0;\n  padding-right: 0;\n}\n.ant-progress-show-info .ant-progress-outer {\n  padding-right: 2.75em;\n  margin-right: -2.75em;\n}\n.ant-progress-inner {\n  display: inline-block;\n  width: 100%;\n  background-color: #f7f7f7;\n  border-radius: 100px;\n  vertical-align: middle;\n}\n.ant-progress-circle-trail {\n  stroke: #f7f7f7;\n}\n.ant-progress-circle-path {\n  stroke: #108ee9;\n}\n.ant-progress-bg {\n  border-radius: 100px;\n  background-color: #108ee9;\n  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;\n  position: relative;\n}\n.ant-progress-text {\n  width: 2em;\n  text-align: left;\n  font-size: 1em;\n  margin-left: 0.75em;\n  vertical-align: middle;\n  display: inline-block;\n}\n.ant-progress-text .anticon {\n  font-size: 12px;\n}\n.ant-progress-status-active .ant-progress-bg:before {\n  content: \"\";\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  border-radius: 10px;\n  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;\n}\n.ant-progress-status-exception .ant-progress-bg {\n  background-color: #f04134;\n}\n.ant-progress-status-exception .ant-progress-text {\n  color: #f04134;\n}\n.ant-progress-status-exception .ant-progress-circle-path {\n  stroke: #f04134;\n}\n.ant-progress-status-success .ant-progress-bg {\n  background-color: #00a854;\n}\n.ant-progress-status-success .ant-progress-text {\n  color: #00a854;\n}\n.ant-progress-status-success .ant-progress-circle-path {\n  stroke: #00a854;\n}\n.ant-progress-circle .ant-progress-inner {\n  position: relative;\n  line-height: 1;\n  background-color: transparent;\n}\n.ant-progress-circle .ant-progress-text {\n  display: block;\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  line-height: 1;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  font-family: tahoma;\n  margin: 0;\n}\n.ant-progress-circle .ant-progress-text .anticon {\n  font-size: 1.16666667em;\n}\n.ant-progress-circle .ant-progress-status-exception .ant-progress-text {\n  color: #f04134;\n}\n.ant-progress-circle .ant-progress-status-success .ant-progress-text {\n  color: #00a854;\n}\n@keyframes ant-progress-active {\n  0% {\n    opacity: 0.1;\n    width: 0;\n  }\n  20% {\n    opacity: 0.5;\n    width: 0;\n  }\n  100% {\n    opacity: 0;\n    width: 100%;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzProgressComponent.ctorParameters = function () { return []; };
NzProgressComponent.propDecorators = {
    'nzType': [{ type: Input },],
    'nzStrokeWidth': [{ type: Input },],
    'nzWidth': [{ type: Input },],
    'nzShowInfo': [{ type: Input },],
    'nzStatus': [{ type: Input },],
    '_setFormat': [{ type: Input, args: ['nzFormat',] },],
};
var NzProgressModule = (function () {
    function NzProgressModule() {
    }
    return NzProgressModule;
}());
NzProgressModule.decorators = [
    { type: NgModule, args: [{
                exports: [NzProgressComponent],
                declarations: [NzProgressComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzProgressModule.ctorParameters = function () { return []; };
var NzStepConnectService = (function () {
    function NzStepConnectService() {
        this.lastElementSizeEvent = new EventEmitter();
        this.currentEvent = new EventEmitter();
        this.itemIndex = 0;
        this.direction = 'horizontal';
        this.directionEvent = new EventEmitter();
        this.processDot = false;
        this.processDotEvent = new EventEmitter();
        this.errorIndexObject = new EventEmitter();
    }
    return NzStepConnectService;
}());
NzStepConnectService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NzStepConnectService.ctorParameters = function () { return []; };
var NzStepsComponent = (function () {
    /**
     * @param {?} nzStepConnectService
     */
    function NzStepsComponent(nzStepConnectService) {
        this.nzStepConnectService = nzStepConnectService;
        this._progressDot = false;
        this._direction = 'horizontal';
    }
    Object.defineProperty(NzStepsComponent.prototype, "nzDirection", {
        /**
         * @return {?}
         */
        get: function () {
            return this._direction;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._direction = value;
            this.nzStepConnectService.direction = value;
            this.nzStepConnectService.directionEvent.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzStepsComponent.prototype, "nzProgressDot", {
        /**
         * @return {?}
         */
        get: function () {
            return this._progressDot;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._progressDot = true;
            }
            else {
                this._progressDot = (value);
            }
            this.nzStepConnectService.processDot = true;
            this.nzStepConnectService.processDotEvent.next(true);
            this.setDirectionClass();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzStepsComponent.prototype, "nzStatus", {
        /**
         * @param {?} status
         * @return {?}
         */
        set: function (status) {
            this._status = status;
            this.nzStepConnectService.errorIndex = this._status;
            this.nzStepConnectService.errorIndexObject.next(this._status);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzStepsComponent.prototype, "nzCurrent", {
        /**
         * @return {?}
         */
        get: function () {
            return this._current;
        },
        /**
         * @param {?} current
         * @return {?}
         */
        set: function (current) {
            this._current = current;
            this.nzStepConnectService.current = current;
            this.nzStepConnectService.currentEvent.next(current);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzStepsComponent.prototype.setDirectionClass = function () {
        this._stepsClassMap = (_a = {},
            _a["ant-steps-" + this.nzDirection] = true,
            _a["ant-steps-label-" + this.nzDirection] = true,
            _a["ant-steps-dot"] = this.nzProgressDot,
            _a['ant-steps-small'] = this.nzSize === 'small',
            _a);
        var _a;
    };
    /**
     * @return {?}
     */
    NzStepsComponent.prototype.ngOnInit = function () {
        this.setDirectionClass();
        if (this._status) {
            this.nzStepConnectService.errorIndex = this._status;
            this.nzStepConnectService.errorIndexObject.next(this._status);
        }
    };
    /**
     * @return {?}
     */
    NzStepsComponent.prototype.ngOnDestroy = function () {
        this.nzStepConnectService.itemIndex = 0;
    };
    return NzStepsComponent;
}());
NzStepsComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-steps',
                encapsulation: ViewEncapsulation.None,
                providers: [NzStepConnectService],
                template: "\n    <div class=\"ant-steps\" [ngClass]=\"_stepsClassMap\">\n      <ng-content></ng-content>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-steps {\n  font-size: 0;\n  line-height: 1.5;\n}\n.ant-steps .ant-steps-item {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner {\n  border-color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner > .ant-steps-icon {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {\n  background: rgba(0, 0, 0, 0.25);\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-title {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-description {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner {\n  border-color: #108ee9;\n  background-color: #108ee9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon {\n  color: #fff;\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {\n  background: #108ee9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-title {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-description {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner {\n  border-color: #108ee9;\n  background-color: #fff;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner > .ant-steps-icon {\n  color: #108ee9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {\n  background: #108ee9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-tail > i:after {\n  width: 100%;\n  background: #108ee9;\n  transition: all .6s;\n  opacity: 1;\n  box-shadow: 0 0 0 0 #108ee9;\n  animation: tailEffect .4s;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-title {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-description {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner {\n  border-color: #f04134;\n  background-color: #fff;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner > .ant-steps-icon {\n  color: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {\n  background: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-title {\n  color: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-description {\n  color: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.ant-steps .ant-steps-item.ant-steps-next-error .ant-steps-tail > i,\n.ant-steps .ant-steps-item.ant-steps-next-error .ant-steps-tail > i:after {\n  background-color: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-custom .ant-steps-head-inner {\n  background: none;\n  border: 0;\n  width: auto;\n  height: auto;\n}\n.ant-steps .ant-steps-item.ant-steps-custom .ant-steps-head-inner > .ant-steps-icon {\n  font-size: 26px;\n  width: 26px;\n  height: 26px;\n}\n.ant-steps .ant-steps-item.ant-steps-custom.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon {\n  color: #108ee9;\n}\n.ant-steps .ant-steps-head,\n.ant-steps .ant-steps-main {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-steps .ant-steps-head {\n  background: #fff;\n}\n.ant-steps .ant-steps-head-inner {\n  display: block;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  width: 26px;\n  height: 26px;\n  line-height: 23px;\n  text-align: center;\n  border-radius: 26px;\n  font-size: 14px;\n  margin-right: 8px;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n.ant-steps .ant-steps-head-inner > .ant-steps-icon {\n  line-height: 1;\n  color: #108ee9;\n  position: relative;\n}\n.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon {\n  font-size: 12px;\n}\n.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon-cross,\n.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon-check {\n  font-weight: bold;\n}\n.ant-steps .ant-steps-title {\n  font-size: 14px;\n  line-height: 26px;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n  background-color: #fff;\n  display: inline-block;\n  padding-right: 10px;\n}\n.ant-steps .ant-steps-title > a:first-child:last-child {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-steps .ant-steps-item:last-child .ant-steps-title {\n  padding-right: 0;\n  width: 100%;\n}\n.ant-steps .ant-steps-item:last-child .ant-steps-tail {\n  display: none;\n}\n.ant-steps .ant-steps-description {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-tail {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 13px;\n  padding: 0 10px;\n}\n.ant-steps .ant-steps-tail > i {\n  display: inline-block;\n  vertical-align: top;\n  background: #e9e9e9;\n  height: 1px;\n  border-radius: 1px;\n  width: 100%;\n  position: relative;\n}\n.ant-steps .ant-steps-tail > i:after {\n  position: absolute;\n  content: '';\n  top: 0;\n  width: 0;\n  background: #e9e9e9;\n  height: 100%;\n  opacity: 0;\n}\n.ant-steps.ant-steps-small .ant-steps-head-inner {\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  width: 18px;\n  height: 18px;\n  line-height: 15px;\n  text-align: center;\n  border-radius: 18px;\n  font-size: 12px;\n  margin-right: 10px;\n}\n.ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 9px 9;\n  transform: scale(0.75) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  top: 0;\n}\n:root .ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {\n  filter: none;\n}\n:root .ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {\n  font-size: 12px;\n}\n.ant-steps.ant-steps-small .ant-steps-main {\n  margin-top: 0;\n}\n.ant-steps.ant-steps-small .ant-steps-title {\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n}\n.ant-steps.ant-steps-small .ant-steps-description {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps.ant-steps-small .ant-steps-tail {\n  top: 8px;\n  padding: 0 8px;\n}\n.ant-steps.ant-steps-small .ant-steps-tail > i {\n  height: 1px;\n  border-radius: 1px;\n  width: 100%;\n}\n.ant-steps.ant-steps-small .ant-steps-custom .ant-steps-head-inner > .ant-steps-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n.ant-steps-vertical > .ant-steps-item {\n  display: block;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-tail {\n  position: absolute;\n  left: 13px;\n  top: 0;\n  height: 100%;\n  width: 1px;\n  padding: 30px 0 4px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-tail > i {\n  height: 100%;\n  width: 1px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-tail > i:after {\n  height: 0;\n  width: 100%;\n}\n.ant-steps-vertical .ant-steps-status-finish .ant-steps-tail > i:after {\n  height: 100%;\n}\n.ant-steps-vertical .ant-steps-head {\n  float: left;\n}\n.ant-steps-vertical .ant-steps-head-inner {\n  margin-right: 16px;\n}\n.ant-steps-vertical .ant-steps-main {\n  min-height: 47px;\n  overflow: hidden;\n  display: block;\n}\n.ant-steps-vertical .ant-steps-main .ant-steps-title {\n  line-height: 26px;\n}\n.ant-steps-vertical .ant-steps-main .ant-steps-description {\n  padding-bottom: 12px;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-tail {\n  position: absolute;\n  left: 9px;\n  top: 0;\n  padding: 22px 0 4px;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-tail > i {\n  height: 100%;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-title {\n  line-height: 18px;\n}\n.ant-steps-horizontal.ant-steps-hidden {\n  visibility: hidden;\n}\n.ant-steps-horizontal .ant-steps-description {\n  max-width: 120px;\n}\n.ant-steps-horizontal .ant-steps-item:not(:first-child) .ant-steps-head {\n  padding-left: 10px;\n  margin-left: -10px;\n}\n.ant-steps-dot .ant-steps-item .ant-steps-step {\n  display: inline-block;\n  text-align: center;\n  width: 120px;\n}\n.ant-steps-dot .ant-steps-item:not(:first-child) .ant-steps-head {\n  margin-left: 0;\n  padding-left: 0;\n}\n.ant-steps-dot .ant-steps-tail {\n  margin: 0 0 0 60px;\n  padding: 0;\n  width: 100%;\n  top: 1px;\n}\n.ant-steps-dot .ant-steps-tail > i {\n  height: 3px;\n}\n.ant-steps-dot .ant-steps-head {\n  display: inline-block;\n  padding-right: 0;\n}\n.ant-steps-dot .ant-steps-head-inner {\n  margin: 0 auto;\n  width: 5px;\n  height: 5px;\n  line-height: 5px;\n  border: 0;\n}\n.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot {\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 2.5px;\n  position: relative;\n}\n.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot:after {\n  content: '';\n  background: rgba(255, 255, 255, 0.001);\n  width: 40px;\n  height: 24px;\n  position: absolute;\n  top: -8px;\n  left: -16px;\n}\n.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot:hover {\n  transform: scale(1.3);\n}\n.ant-steps-dot .ant-steps-main {\n  display: block;\n  margin-top: 10px;\n}\n.ant-steps-dot .ant-steps-main .ant-steps-title {\n  padding-right: 0;\n  background-color: transparent;\n}\n.ant-steps-dot .ant-steps-status-process .ant-steps-head {\n  top: -1px;\n}\n.ant-steps-dot .ant-steps-status-process .ant-steps-head-inner {\n  width: 7px;\n  height: 7px;\n  line-height: 7px;\n}\n.ant-steps-dot .ant-steps-status-process .ant-steps-head-inner .ant-steps-icon-dot {\n  border-radius: 3.5px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-tail {\n  left: 2px;\n  height: 100%;\n  padding: 0;\n  top: 15px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-tail > i {\n  height: 100%;\n  width: 3px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-head {\n  top: 12px;\n  left: 1px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-status-process .ant-steps-head {\n  left: 0;\n}\n@keyframes tailEffect {\n  to {\n    box-shadow: 0 0 3px 3px transparent;\n  }\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzStepsComponent.ctorParameters = function () { return [
    { type: NzStepConnectService, },
]; };
NzStepsComponent.propDecorators = {
    'nzDirection': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzProgressDot': [{ type: Input },],
    'nzStatus': [{ type: Input },],
    'nzCurrent': [{ type: Input },],
};
var NzStepComponent = (function () {
    /**
     * @param {?} erf
     * @param {?} nzStepConnectService
     * @param {?} _renderer
     */
    function NzStepComponent(erf, nzStepConnectService, _renderer) {
        this.erf = erf;
        this.nzStepConnectService = nzStepConnectService;
        this._renderer = _renderer;
        this._status = 'wait';
        this._ifCustomStatus = false;
        this._last = false;
        this._processDot = false;
        this._direction = 'horizontal';
        this._el = erf.nativeElement;
    }
    Object.defineProperty(NzStepComponent.prototype, "nzStatus", {
        /**
         * @return {?}
         */
        get: function () {
            return this._status;
        },
        /**
         * @param {?} status
         * @return {?}
         */
        set: function (status) {
            this._status = status;
            this._ifCustomStatus = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzStepComponent.prototype, "_current", {
        /**
         * @return {?}
         */
        get: function () {
            return this._currentIndex;
        },
        /**
         * @param {?} current
         * @return {?}
         */
        set: function (current) {
            this._currentIndex = current;
            if (!this._ifCustomStatus) {
                if (current > this.index) {
                    this._status = 'finish';
                }
                else if (current === this.index) {
                    if (this.nzStepConnectService.errorIndex) {
                        this._status = 'error';
                    }
                    else {
                        this._status = 'process';
                    }
                }
                else {
                    this._status = 'wait';
                }
            }
            this.initClassMap();
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    NzStepComponent.prototype.initClassMap = function () {
        this.stepStatusClass = (_a = {},
            _a['ant-steps-item'] = true,
            _a["ant-steps-status-wait"] = this._status === 'wait',
            _a["ant-steps-status-process"] = this._status === 'process',
            _a["ant-steps-status-finish"] = this._status === 'finish',
            _a["ant-steps-status-error"] = this._status === 'error',
            _a['ant-steps-item-last'] = this._last,
            _a['ant-steps-custom'] = !!this.nzIcon,
            _a['ant-steps-next-error'] = (this.nzStepConnectService.errorIndex === 'error' && this._current === this.index - 1),
            _a);
        for (var /** @type {?} */ i in this.stepStatusClass) {
            if (this.stepStatusClass[i]) {
                this._renderer.addClass(this._el, i);
            }
            else {
                this._renderer.removeClass(this._el, i);
            }
        }
        var _a;
    };
    /**
     * @return {?}
     */
    NzStepComponent.prototype.init = function () {
        var _this = this;
        // 记录个数
        this.index = this.nzStepConnectService.itemIndex;
        this._processDot = this.nzStepConnectService.processDot;
        this._direction = this.nzStepConnectService.direction;
        this._current = this.nzStepConnectService.current;
        this._processDotEventSubscription = this.nzStepConnectService.processDotEvent.subscribe(function (data) {
            _this._processDot = data;
        });
        this._directionEventSubscription = this.nzStepConnectService.directionEvent.subscribe(function (data) {
            _this._direction = data;
        });
        this._currentEventSubscription = this.nzStepConnectService.currentEvent.subscribe(function (data) {
            _this._current = data;
        });
        this._errorIndexObjectSubscription = this.nzStepConnectService.errorIndexObject.subscribe(function (data) {
            if (_this._current === _this.index) {
                _this._status = data;
            }
        });
        this.initClassMap();
        this.nzStepConnectService.itemIndex += 1;
        /** judge if last step */
        if (!this.erf.nativeElement.nextElementSibling) {
            this._last = true;
        }
        else {
            this.nzStepConnectService.lastElementSizeEvent.subscribe(function (data) {
                var count = data.count, width = data.width;
                _this._renderer.setStyle(_this.erf.nativeElement, 'width', (100 / (count - 1)) + '%');
                _this._renderer.setStyle(_this.erf.nativeElement, 'margin-right', (-(width / (count - 1) + 5)) + 'px');
                if (_this._direction === 'horizontal') {
                    _this._renderer.setStyle(_this._stepsTail.nativeElement, 'padding-right', ((width / (count - 1) + 5)) + 'px');
                }
            });
        }
    };
    /**
     * @return {?}
     */
    NzStepComponent.prototype.ngOnInit = function () {
        this.init();
    };
    /**
     * @return {?}
     */
    NzStepComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this._last) {
            setTimeout(function (_) {
                _this.nzStepConnectService.lastElementSizeEvent.next({
                    count: _this.erf.nativeElement.parentElement.childElementCount,
                    width: _this.erf.nativeElement.firstElementChild.offsetWidth
                });
            });
        }
    };
    /**
     * @return {?}
     */
    NzStepComponent.prototype.ngOnDestroy = function () {
        if (this._processDotEventSubscription) {
            this._processDotEventSubscription.unsubscribe();
        }
        if (this._directionEventSubscription) {
            this._directionEventSubscription.unsubscribe();
        }
        if (this._currentEventSubscription) {
            this._currentEventSubscription.unsubscribe();
        }
        if (this._errorIndexObjectSubscription) {
            this._errorIndexObjectSubscription.unsubscribe();
        }
    };
    return NzStepComponent;
}());
NzStepComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-step',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"ant-steps-tail\" #stepsTail *ngIf=\"_last !== true\">\n      <i></i>\n    </div>\n    <div class=\"ant-steps-step\">\n      <div class=\"ant-steps-head\">\n        <div class=\"ant-steps-head-inner\">\n          <ng-template [ngIf]=\"!_processDot\">\n            <span class=\"ant-steps-icon anticon anticon-check\" *ngIf=\"_status === 'finish' && !nzIcon\"></span>\n            <span class=\"ant-steps-icon anticon anticon-cross\" *ngIf=\"_status === 'error'\"></span>\n            <span class=\"ant-steps-icon\" *ngIf=\"(_status === 'process' || _status === 'wait') && !nzIcon\">{{index + 1}}</span>\n            <span class=\"ant-steps-icon\" *ngIf=\"nzIcon\">\n            <ng-template [ngTemplateOutlet]=\"nzIcon\"></ng-template>\n          </span>\n          </ng-template>\n          <ng-template [ngIf]=\"_processDot\">\n            <span class=\"ant-steps-icon\">\n              <span class=\"ant-steps-icon-dot\"></span>\n            </span>\n          </ng-template>\n        </div>\n      </div>\n      <div class=\"ant-steps-main\">\n        <div class=\"ant-steps-title\">{{nzTitle}}</div>\n        <div class=\"ant-steps-description\">{{nzDescription}}</div>\n      </div>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-steps {\n  font-size: 0;\n  line-height: 1.5;\n}\n.ant-steps .ant-steps-item {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner {\n  border-color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner > .ant-steps-icon {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {\n  background: rgba(0, 0, 0, 0.25);\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-title {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-description {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-item.ant-steps-status-wait .ant-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner {\n  border-color: #108ee9;\n  background-color: #108ee9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon {\n  color: #fff;\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {\n  background: #108ee9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-title {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-description {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-steps .ant-steps-item.ant-steps-status-process .ant-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner {\n  border-color: #108ee9;\n  background-color: #fff;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner > .ant-steps-icon {\n  color: #108ee9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {\n  background: #108ee9;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-tail > i:after {\n  width: 100%;\n  background: #108ee9;\n  transition: all .6s;\n  opacity: 1;\n  box-shadow: 0 0 0 0 #108ee9;\n  animation: tailEffect .4s;\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-title {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-item.ant-steps-status-finish .ant-steps-description {\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner {\n  border-color: #f04134;\n  background-color: #fff;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner > .ant-steps-icon {\n  color: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-head-inner > .ant-steps-icon .ant-steps-icon-dot {\n  background: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-title {\n  color: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-description {\n  color: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-status-error .ant-steps-tail > i {\n  background-color: #e9e9e9;\n}\n.ant-steps .ant-steps-item.ant-steps-next-error .ant-steps-tail > i,\n.ant-steps .ant-steps-item.ant-steps-next-error .ant-steps-tail > i:after {\n  background-color: #f04134;\n}\n.ant-steps .ant-steps-item.ant-steps-custom .ant-steps-head-inner {\n  background: none;\n  border: 0;\n  width: auto;\n  height: auto;\n}\n.ant-steps .ant-steps-item.ant-steps-custom .ant-steps-head-inner > .ant-steps-icon {\n  font-size: 26px;\n  width: 26px;\n  height: 26px;\n}\n.ant-steps .ant-steps-item.ant-steps-custom.ant-steps-status-process .ant-steps-head-inner > .ant-steps-icon {\n  color: #108ee9;\n}\n.ant-steps .ant-steps-head,\n.ant-steps .ant-steps-main {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n}\n.ant-steps .ant-steps-head {\n  background: #fff;\n}\n.ant-steps .ant-steps-head-inner {\n  display: block;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  width: 26px;\n  height: 26px;\n  line-height: 23px;\n  text-align: center;\n  border-radius: 26px;\n  font-size: 14px;\n  margin-right: 8px;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n.ant-steps .ant-steps-head-inner > .ant-steps-icon {\n  line-height: 1;\n  color: #108ee9;\n  position: relative;\n}\n.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon {\n  font-size: 12px;\n}\n.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon-cross,\n.ant-steps .ant-steps-head-inner > .ant-steps-icon.anticon-check {\n  font-weight: bold;\n}\n.ant-steps .ant-steps-title {\n  font-size: 14px;\n  line-height: 26px;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n  background-color: #fff;\n  display: inline-block;\n  padding-right: 10px;\n}\n.ant-steps .ant-steps-title > a:first-child:last-child {\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-steps .ant-steps-item:last-child .ant-steps-title {\n  padding-right: 0;\n  width: 100%;\n}\n.ant-steps .ant-steps-item:last-child .ant-steps-tail {\n  display: none;\n}\n.ant-steps .ant-steps-description {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps .ant-steps-tail {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 13px;\n  padding: 0 10px;\n}\n.ant-steps .ant-steps-tail > i {\n  display: inline-block;\n  vertical-align: top;\n  background: #e9e9e9;\n  height: 1px;\n  border-radius: 1px;\n  width: 100%;\n  position: relative;\n}\n.ant-steps .ant-steps-tail > i:after {\n  position: absolute;\n  content: '';\n  top: 0;\n  width: 0;\n  background: #e9e9e9;\n  height: 100%;\n  opacity: 0;\n}\n.ant-steps.ant-steps-small .ant-steps-head-inner {\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  width: 18px;\n  height: 18px;\n  line-height: 15px;\n  text-align: center;\n  border-radius: 18px;\n  font-size: 12px;\n  margin-right: 10px;\n}\n.ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 9px 9;\n  transform: scale(0.75) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  top: 0;\n}\n:root .ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {\n  filter: none;\n}\n:root .ant-steps.ant-steps-small .ant-steps-head-inner > .ant-steps-icon.anticon {\n  font-size: 12px;\n}\n.ant-steps.ant-steps-small .ant-steps-main {\n  margin-top: 0;\n}\n.ant-steps.ant-steps-small .ant-steps-title {\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n}\n.ant-steps.ant-steps-small .ant-steps-description {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.43);\n}\n.ant-steps.ant-steps-small .ant-steps-tail {\n  top: 8px;\n  padding: 0 8px;\n}\n.ant-steps.ant-steps-small .ant-steps-tail > i {\n  height: 1px;\n  border-radius: 1px;\n  width: 100%;\n}\n.ant-steps.ant-steps-small .ant-steps-custom .ant-steps-head-inner > .ant-steps-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n.ant-steps-vertical > .ant-steps-item {\n  display: block;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-tail {\n  position: absolute;\n  left: 13px;\n  top: 0;\n  height: 100%;\n  width: 1px;\n  padding: 30px 0 4px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-tail > i {\n  height: 100%;\n  width: 1px;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-tail > i:after {\n  height: 0;\n  width: 100%;\n}\n.ant-steps-vertical .ant-steps-status-finish .ant-steps-tail > i:after {\n  height: 100%;\n}\n.ant-steps-vertical .ant-steps-head {\n  float: left;\n}\n.ant-steps-vertical .ant-steps-head-inner {\n  margin-right: 16px;\n}\n.ant-steps-vertical .ant-steps-main {\n  min-height: 47px;\n  overflow: hidden;\n  display: block;\n}\n.ant-steps-vertical .ant-steps-main .ant-steps-title {\n  line-height: 26px;\n}\n.ant-steps-vertical .ant-steps-main .ant-steps-description {\n  padding-bottom: 12px;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-tail {\n  position: absolute;\n  left: 9px;\n  top: 0;\n  padding: 22px 0 4px;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-tail > i {\n  height: 100%;\n}\n.ant-steps-vertical.ant-steps-small .ant-steps-title {\n  line-height: 18px;\n}\n.ant-steps-horizontal.ant-steps-hidden {\n  visibility: hidden;\n}\n.ant-steps-horizontal .ant-steps-description {\n  max-width: 120px;\n}\n.ant-steps-horizontal .ant-steps-item:not(:first-child) .ant-steps-head {\n  padding-left: 10px;\n  margin-left: -10px;\n}\n.ant-steps-dot .ant-steps-item .ant-steps-step {\n  display: inline-block;\n  text-align: center;\n  width: 120px;\n}\n.ant-steps-dot .ant-steps-item:not(:first-child) .ant-steps-head {\n  margin-left: 0;\n  padding-left: 0;\n}\n.ant-steps-dot .ant-steps-tail {\n  margin: 0 0 0 60px;\n  padding: 0;\n  width: 100%;\n  top: 1px;\n}\n.ant-steps-dot .ant-steps-tail > i {\n  height: 3px;\n}\n.ant-steps-dot .ant-steps-head {\n  display: inline-block;\n  padding-right: 0;\n}\n.ant-steps-dot .ant-steps-head-inner {\n  margin: 0 auto;\n  width: 5px;\n  height: 5px;\n  line-height: 5px;\n  border: 0;\n}\n.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot {\n  float: left;\n  width: 100%;\n  height: 100%;\n  border-radius: 2.5px;\n  position: relative;\n}\n.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot:after {\n  content: '';\n  background: rgba(255, 255, 255, 0.001);\n  width: 40px;\n  height: 24px;\n  position: absolute;\n  top: -8px;\n  left: -16px;\n}\n.ant-steps-dot .ant-steps-head-inner .ant-steps-icon-dot:hover {\n  transform: scale(1.3);\n}\n.ant-steps-dot .ant-steps-main {\n  display: block;\n  margin-top: 10px;\n}\n.ant-steps-dot .ant-steps-main .ant-steps-title {\n  padding-right: 0;\n  background-color: transparent;\n}\n.ant-steps-dot .ant-steps-status-process .ant-steps-head {\n  top: -1px;\n}\n.ant-steps-dot .ant-steps-status-process .ant-steps-head-inner {\n  width: 7px;\n  height: 7px;\n  line-height: 7px;\n}\n.ant-steps-dot .ant-steps-status-process .ant-steps-head-inner .ant-steps-icon-dot {\n  border-radius: 3.5px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-tail {\n  left: 2px;\n  height: 100%;\n  padding: 0;\n  top: 15px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-tail > i {\n  height: 100%;\n  width: 3px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-head {\n  top: 12px;\n  left: 1px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-status-process .ant-steps-head {\n  left: 0;\n}\n@keyframes tailEffect {\n  to {\n    box-shadow: 0 0 3px 3px transparent;\n  }\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-steps-horizontal nz-step:not(:first-child) .ant-steps-head {\n  padding-left: 10px;\n  margin-left: -10px;\n}\nnz-step {\n  display: block;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-tail {\n  margin-left: 0;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-step {\n  text-align: left;\n  width: auto;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-head-inner {\n  margin-right: 16px;\n}\n.ant-steps-dot.ant-steps-vertical .ant-steps-main {\n  margin-top: 0;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzStepComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: NzStepConnectService, },
    { type: Renderer2, },
]; };
NzStepComponent.propDecorators = {
    'nzIcon': [{ type: ContentChild, args: ['nzIcon',] },],
    '_stepsTail': [{ type: ViewChild, args: ['stepsTail',] },],
    'nzStatus': [{ type: Input },],
    'nzTitle': [{ type: Input },],
    'nzDescription': [{ type: Input },],
};
var NzStepsModule = (function () {
    function NzStepsModule() {
    }
    return NzStepsModule;
}());
NzStepsModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [NzStepsComponent, NzStepComponent],
                declarations: [NzStepsComponent, NzStepComponent],
                providers: [NzStepConnectService]
            },] },
];
/**
 * @nocollapse
 */
NzStepsModule.ctorParameters = function () { return []; };
var NzDropDownButtonComponent = (function (_super) {
    tslib_1.__extends(NzDropDownButtonComponent, _super);
    function NzDropDownButtonComponent() {
        var _this = _super.apply(this, arguments) || this;
        _this.nzDisable = false;
        _this.nzSize = 'default';
        _this.nzType = 'default';
        _this.nzClick = new EventEmitter();
        _this._onVisibleChange = function (visible) {
            if (_this.nzDisable) {
                return;
            }
            if (visible) {
                if (!_this._triggerWidth) {
                    _this._setTriggerWidth();
                }
            }
            if (_this.nzVisible !== visible) {
                _this.nzVisible = visible;
                _this.nzVisibleChange.emit(_this.nzVisible);
            }
            _this._changeDetector.markForCheck();
        };
        return _this;
    }
    /**
     * rewrite afterViewInit hook
     * @return {?}
     */
    NzDropDownButtonComponent.prototype.ngAfterViewInit = function () {
        this._startSubscribe(this._visibleChange);
    };
    return NzDropDownButtonComponent;
}(NzDropDownComponent));
NzDropDownButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-dropdown-button',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    DropDownAnimation
                ],
                template: "\n    <div class=\"ant-btn-group ant-dropdown-button\" nz-dropdown>\n      <button\n        type=\"button\"\n        nz-button\n        [disabled]=\"nzDisable\"\n        [nzType]=\"nzType\"\n        [nzSize]=\"nzSize\"\n        (click)=\"nzClick.emit($event)\">\n        <span><ng-content></ng-content></span></button><button\n        [nzType]=\"nzType\"\n        [nzSize]=\"nzSize\"\n        nz-button type=\"button\"\n        class=\"ant-dropdown-trigger\"\n        [disabled]=\"nzDisable\"\n        (click)=\"_onClickEvent()\"\n        (mouseenter)=\"_onMouseEnterEvent($event)\"\n        (mouseleave)=\"_onMouseLeaveEvent($event)\">\n        <i class=\"anticon anticon-down\"></i></button>\n    </div>\n    <ng-template\n      nz-connected-overlay\n      [hasBackdrop]=\"_hasBackdrop\"\n      [positions]=\"_positions\"\n      [origin]=\"_nzOrigin\"\n      (backdropClick)=\"_hide()\"\n      (detach)=\"_hide()\"\n      [minWidth]=\"_triggerWidth\"\n      (positionChange)=\"_onPositionChange($event)\"\n      [open]=\"nzVisible\">\n      <div\n        class=\"{{'ant-dropdown ant-dropdown-placement-'+nzPlacement}}\"\n        [@dropDownAnimation]=\"_dropDownPosition\"\n        (mouseenter)=\"_onMouseEnterEvent($event)\"\n        (mouseleave)=\"_onMouseLeaveEvent($event)\"\n        [style.minWidth.px]=\"_triggerWidth\"\n        (click)=\"_clickDropDown($event)\">\n        <ng-content select=\"[nz-menu]\"></ng-content>\n      </div>\n    </ng-template>    ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-dropdown {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  z-index: 1050;\n  display: block;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1.5;\n}\n.ant-dropdown-wrap {\n  position: relative;\n}\n.ant-dropdown-wrap .ant-btn > .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-wrap .anticon-down:before {\n  transition: transform 0.2s ease;\n}\n.ant-dropdown-wrap-open .anticon-down:before {\n  transform: rotate(180deg);\n}\n.ant-dropdown-hidden,\n.ant-dropdown-menu-hidden {\n  display: none;\n}\n.ant-dropdown-menu {\n  outline: none;\n  position: relative;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n}\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title {\n  padding: 7px 8px;\n  margin: 0;\n  clear: both;\n  font-size: 12px;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.65);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all .3s;\n}\n.ant-dropdown-menu-item > a,\n.ant-dropdown-menu-submenu-title > a {\n  color: rgba(0, 0, 0, 0.65);\n  display: block;\n  padding: 7px 8px;\n  margin: -7px -8px;\n  transition: all .3s;\n}\n.ant-dropdown-menu-item > a:focus,\n.ant-dropdown-menu-submenu-title > a:focus {\n  text-decoration: none;\n}\n.ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-submenu-title-selected,\n.ant-dropdown-menu-item-selected > a,\n.ant-dropdown-menu-submenu-title-selected > a {\n  color: #108ee9;\n  background-color: #ecf6fd;\n}\n.ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-submenu-title:hover {\n  background-color: #ecf6fd;\n}\n.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-submenu-title-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown-menu-submenu-title-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item:first-child,\n.ant-dropdown-menu-submenu-title:first-child,\n.ant-dropdown-menu-item:first-child > a,\n.ant-dropdown-menu-submenu-title:first-child > a {\n  border-radius: 4px 4px 0 0;\n}\n.ant-dropdown-menu-item:last-child,\n.ant-dropdown-menu-submenu-title:last-child,\n.ant-dropdown-menu-item:last-child > a,\n.ant-dropdown-menu-submenu-title:last-child > a {\n  border-radius: 0 0 4px 4px;\n}\n.ant-dropdown-menu-item:only-child,\n.ant-dropdown-menu-submenu-title:only-child,\n.ant-dropdown-menu-item:only-child > a,\n.ant-dropdown-menu-submenu-title:only-child > a {\n  border-radius: 4px;\n}\n.ant-dropdown-menu-item-divider,\n.ant-dropdown-menu-submenu-title-divider {\n  height: 1px;\n  overflow: hidden;\n  background-color: #e9e9e9;\n  line-height: 0;\n}\n.ant-dropdown-menu-submenu-title:after {\n  font-family: \"anticon\" !important;\n  position: absolute;\n  content: \"\\e61f\";\n  right: 8px;\n  color: rgba(0, 0, 0, 0.43);\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-menu-submenu-title:after {\n  filter: none;\n}\n:root .ant-dropdown-menu-submenu-title:after {\n  font-size: 12px;\n}\n.ant-dropdown-menu-submenu-vertical {\n  position: relative;\n}\n.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {\n  top: 0;\n  left: 100%;\n  position: absolute;\n  min-width: 100%;\n  margin-left: 4px;\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title:after {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-dropdown-menu-submenu:first-child .ant-dropdown-menu-submenu-title {\n  border-radius: 4px 4px 0 0;\n}\n.ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {\n  border-radius: 0 0 4px 4px;\n}\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-dropdown-trigger .anticon-down,\n.ant-dropdown-link .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-trigger .anticon-down,\n:root .ant-dropdown-link .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-trigger .anticon-down,\n:root .ant-dropdown-link .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-button {\n  white-space: nowrap;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n  padding-right: 8px;\n}\n.ant-dropdown-button .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-button .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-button .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-menu-dark,\n.ant-dropdown-menu-dark .ant-dropdown-menu {\n  background: #404040;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:after {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover {\n  color: #fff;\n  background: transparent;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {\n  background: #108ee9;\n  color: #fff;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-dropdown {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  z-index: 1050;\n  display: block;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1.5;\n}\n.ant-dropdown-wrap {\n  position: relative;\n}\n.ant-dropdown-wrap .ant-btn > .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-wrap .ant-btn > .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-wrap .anticon-down:before {\n  transition: transform 0.2s ease;\n}\n.ant-dropdown-wrap-open .anticon-down:before {\n  transform: rotate(180deg);\n}\n.ant-dropdown-hidden,\n.ant-dropdown-menu-hidden {\n  display: none;\n}\n.ant-dropdown-menu {\n  outline: none;\n  position: relative;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n}\n.ant-dropdown-menu-item,\n.ant-dropdown-menu-submenu-title {\n  padding: 7px 8px;\n  margin: 0;\n  clear: both;\n  font-size: 12px;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.65);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all .3s;\n}\n.ant-dropdown-menu-item > a,\n.ant-dropdown-menu-submenu-title > a {\n  color: rgba(0, 0, 0, 0.65);\n  display: block;\n  padding: 7px 8px;\n  margin: -7px -8px;\n  transition: all .3s;\n}\n.ant-dropdown-menu-item > a:focus,\n.ant-dropdown-menu-submenu-title > a:focus {\n  text-decoration: none;\n}\n.ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-submenu-title-selected,\n.ant-dropdown-menu-item-selected > a,\n.ant-dropdown-menu-submenu-title-selected > a {\n  color: #108ee9;\n  background-color: #ecf6fd;\n}\n.ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-submenu-title:hover {\n  background-color: #ecf6fd;\n}\n.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-submenu-title-disabled {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown-menu-submenu-title-disabled:hover {\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.ant-dropdown-menu-item:first-child,\n.ant-dropdown-menu-submenu-title:first-child,\n.ant-dropdown-menu-item:first-child > a,\n.ant-dropdown-menu-submenu-title:first-child > a {\n  border-radius: 4px 4px 0 0;\n}\n.ant-dropdown-menu-item:last-child,\n.ant-dropdown-menu-submenu-title:last-child,\n.ant-dropdown-menu-item:last-child > a,\n.ant-dropdown-menu-submenu-title:last-child > a {\n  border-radius: 0 0 4px 4px;\n}\n.ant-dropdown-menu-item:only-child,\n.ant-dropdown-menu-submenu-title:only-child,\n.ant-dropdown-menu-item:only-child > a,\n.ant-dropdown-menu-submenu-title:only-child > a {\n  border-radius: 4px;\n}\n.ant-dropdown-menu-item-divider,\n.ant-dropdown-menu-submenu-title-divider {\n  height: 1px;\n  overflow: hidden;\n  background-color: #e9e9e9;\n  line-height: 0;\n}\n.ant-dropdown-menu-submenu-title:after {\n  font-family: \"anticon\" !important;\n  position: absolute;\n  content: \"\\e61f\";\n  right: 8px;\n  color: rgba(0, 0, 0, 0.43);\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-menu-submenu-title:after {\n  filter: none;\n}\n:root .ant-dropdown-menu-submenu-title:after {\n  font-size: 12px;\n}\n.ant-dropdown-menu-submenu-vertical {\n  position: relative;\n}\n.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {\n  top: 0;\n  left: 100%;\n  position: absolute;\n  min-width: 100%;\n  margin-left: 4px;\n  transform-origin: 0 0;\n}\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title:after {\n  color: rgba(0, 0, 0, 0.25);\n}\n.ant-dropdown-menu-submenu:first-child .ant-dropdown-menu-submenu-title {\n  border-radius: 4px 4px 0 0;\n}\n.ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {\n  border-radius: 0 0 4px 4px;\n}\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight,\n.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpIn;\n}\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight,\n.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownIn;\n}\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,\n.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {\n  animation-name: antSlideUpOut;\n}\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,\n.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {\n  animation-name: antSlideDownOut;\n}\n.ant-dropdown-trigger .anticon-down,\n.ant-dropdown-link .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-trigger .anticon-down,\n:root .ant-dropdown-link .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-trigger .anticon-down,\n:root .ant-dropdown-link .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-button {\n  white-space: nowrap;\n}\n.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n  padding-right: 8px;\n}\n.ant-dropdown-button .anticon-down {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 10px 9;\n  transform: scale(0.83333333) rotate(0deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n}\n:root .ant-dropdown-button .anticon-down {\n  filter: none;\n}\n:root .ant-dropdown-button .anticon-down {\n  font-size: 12px;\n}\n.ant-dropdown-menu-dark,\n.ant-dropdown-menu-dark .ant-dropdown-menu {\n  background: #404040;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:after,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:after {\n  color: rgba(255, 255, 255, 0.67);\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover {\n  color: #fff;\n  background: transparent;\n}\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,\n.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {\n  background: #108ee9;\n  color: #fff;\n}\nnz-dropdown {\n  position: relative;\n  display: inline-block;\n}\nnz-dropdown-button {\n  position: relative;\n  display: inline-block;\n}\n.ant-dropdown {\n  top: 100%;\n  left: 0;\n  position: relative;\n  width: 100%;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzDropDownButtonComponent.ctorParameters = function () { return []; };
NzDropDownButtonComponent.propDecorators = {
    'nzDisable': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzType': [{ type: Input },],
    'content': [{ type: ViewChild, args: ['content',] },],
    'nzClick': [{ type: Output },],
    '_nzOrigin': [{ type: ViewChild, args: [NzDropDownDirective,] },],
};
var NzSubMenuComponent = (function () {
    /**
     * @param {?} nzMenuComponent
     * @param {?} cd
     */
    function NzSubMenuComponent(nzMenuComponent, cd) {
        this.nzMenuComponent = nzMenuComponent;
        this.cd = cd;
        this.isInDropDown = false;
        this.level = 1;
        this._$mouseSubject = new Subject$1();
        this.nzOpen = false;
        this.nzOpenChange = new EventEmitter();
        this.nzMenuComponent.setHasSubMenu(true);
        this.nzMenuComponent.subMenus.push(this);
    }
    Object.defineProperty(NzSubMenuComponent.prototype, "subItemSelected", {
        /**
         * @return {?}
         */
        get: function () {
            var _this = this;
            return !!this.nzMenuComponent.menuItems.find(function (e) { return e.selected && e.nzSubMenuComponent === _this; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "submenuSelected", {
        /**
         * @return {?}
         */
        get: function () {
            var _this = this;
            return !!this.subMenus._results.find(function (e) { return e !== _this && e.subItemSelected; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "expandState", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.nzOpen && this.nzMenuComponent.nzMode !== 'vertical') {
                return 'expand';
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzSubMenuComponent.prototype.clickSubMenuTitle = function () {
        if ((this.nzMenuComponent.nzMode === 'inline') || (!this.isInDropDown)) {
            this.nzOpen = !this.nzOpen;
            this.nzOpenChange.emit(this.nzOpen);
        }
    };
    /**
     * @return {?}
     */
    NzSubMenuComponent.prototype.clickSubMenuDropDown = function () {
        if (this.isInDropDown || (this.nzMenuComponent.nzMode === 'vertical') || (this.nzMenuComponent.nzMode === 'horizontal')) {
            this._$mouseSubject.next(false);
            this.nzOpen = false;
            this.nzOpenChange.emit(this.nzOpen);
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzSubMenuComponent.prototype.onMouseEnterEvent = function (e) {
        if ((this.nzMenuComponent.nzMode === 'horizontal') || (this.nzMenuComponent.nzMode === 'vertical') || this.isInDropDown) {
            this._$mouseSubject.next(true);
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzSubMenuComponent.prototype.onMouseLeaveEvent = function (e) {
        if ((this.nzMenuComponent.nzMode === 'horizontal') || (this.nzMenuComponent.nzMode === 'vertical') || this.isInDropDown) {
            this._$mouseSubject.next(false);
        }
    };
    Object.defineProperty(NzSubMenuComponent.prototype, "setDropDownSubmenuClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isInDropDown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "setMenuSubmenuOpenClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzOpen);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "setDropDownVerticalClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isInDropDown && (this.nzMenuComponent.nzMode === 'vertical');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "setDropDownHorizontalClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isInDropDown && (this.nzMenuComponent.nzMode === 'horizontal');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "setMenuSubmenuClass", {
        /**
         * @return {?}
         */
        get: function () {
            return !this.isInDropDown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "setMenuSubmenuSelectedClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.submenuSelected || this.subItemSelected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "setMenuVerticalClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzMenuComponent.nzMode === 'vertical');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "setMenuHorizontalClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzMenuComponent.nzMode === 'horizontal');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSubMenuComponent.prototype, "setMenuInlineClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && (this.nzMenuComponent.nzMode === 'inline');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzSubMenuComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.isInDropDown = this.nzMenuComponent.isInDropDown;
        if (this.subMenus.length && (this.nzMenuComponent.nzMode === 'inline')) {
            this.subMenus.filter(function (x) { return x !== _this; }).forEach(function (menu) {
                setTimeout(function (_) {
                    menu.level = _this.level + 1;
                });
            });
        }
    };
    /**
     * @return {?}
     */
    NzSubMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        debounceTime$1.call(this._$mouseSubject, 300).subscribe(function (data) {
            _this.nzOpen = data;
        });
    };
    /**
     * @return {?}
     */
    NzSubMenuComponent.prototype.ngOnDestroy = function () {
        this._$mouseSubject.unsubscribe();
    };
    return NzSubMenuComponent;
}());
NzSubMenuComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-submenu]',
                animations: [
                    trigger('fadeAnimation', [
                        state('*', style({ opacity: 1 })),
                        transition('* => void', [
                            animate(150, style({ opacity: 0, display: 'none' }))
                        ]),
                        transition('void => *', [
                            style({ opacity: '0' }),
                            animate(150, style({ opacity: 1 }))
                        ])
                    ]),
                    trigger('expandAnimation', [
                        transition('expand => void', [
                            style({ height: '*', overflow: 'hidden' }),
                            animate(150, style({ height: 0 }))
                        ]),
                        transition('void => expand', [
                            style({ height: 0, overflow: 'hidden' }),
                            animate(150, style({ height: '*' }))
                        ])
                    ])
                ],
                template: "\n    <div\n      [class.ant-dropdown-menu-submenu-title]=\"isInDropDown\"\n      [class.ant-menu-submenu-title]=\"!isInDropDown\"\n      (mouseenter)=\"onMouseEnterEvent($event)\"\n      (mouseleave)=\"onMouseLeaveEvent($event)\"\n      (click)=\"clickSubMenuTitle()\"\n      [style.paddingLeft.px]=\"(nzMenuComponent.nzMode === 'inline')?(level*24):null\">\n      <ng-content select=\"[title]\"></ng-content>\n    </div>\n    <ul\n      [class.ant-dropdown-menu]=\"isInDropDown\"\n      [@fadeAnimation]\n      [@expandAnimation]=\"expandState\"\n      [class.ant-menu]=\"!isInDropDown\"\n      [class.ant-dropdown-menu-vertical]=\"isInDropDown\"\n      [class.ant-menu-vertical]=\"(!isInDropDown)&&(nzMenuComponent.nzMode!=='inline')\"\n      [class.ant-menu-inline]=\"(!isInDropDown)&&(nzMenuComponent.nzMode==='inline')\"\n      [class.ant-dropdown-menu-sub]=\"isInDropDown\"\n      [class.ant-menu-sub]=\"!isInDropDown\"\n      *ngIf=\"nzOpen\"\n      (click)=\"clickSubMenuDropDown()\"\n      (mouseleave)=\"onMouseLeaveEvent($event)\"\n      (mouseenter)=\"onMouseEnterEvent($event)\">\n      <ng-content></ng-content>\n    </ul>\n  ",
            },] },
];
/**
 * @nocollapse
 */
NzSubMenuComponent.ctorParameters = function () { return [
    { type: NzMenuComponent, },
    { type: ChangeDetectorRef, },
]; };
NzSubMenuComponent.propDecorators = {
    'subMenus': [{ type: ContentChildren, args: [NzSubMenuComponent,] },],
    'nzOpen': [{ type: Input },],
    'nzOpenChange': [{ type: Output },],
    'onMouseEnterEvent': [{ type: HostListener, args: ['mouseenter', ['$event'],] },],
    'onMouseLeaveEvent': [{ type: HostListener, args: ['mouseleave', ['$event'],] },],
    'setDropDownSubmenuClass': [{ type: HostBinding, args: ['class.ant-dropdown-menu-submenu',] },],
    'setMenuSubmenuOpenClass': [{ type: HostBinding, args: ['class.ant-menu-submenu-open',] },],
    'setDropDownVerticalClass': [{ type: HostBinding, args: ['class.ant-dropdown-menu-submenu-vertical',] },],
    'setDropDownHorizontalClass': [{ type: HostBinding, args: ['class.ant-dropdown-menu-submenu-horizontal',] },],
    'setMenuSubmenuClass': [{ type: HostBinding, args: ['class.ant-menu-submenu',] },],
    'setMenuSubmenuSelectedClass': [{ type: HostBinding, args: ['class.ant-menu-submenu-selected',] },],
    'setMenuVerticalClass': [{ type: HostBinding, args: ['class.ant-menu-submenu-vertical',] },],
    'setMenuHorizontalClass': [{ type: HostBinding, args: ['class.ant-menu-submenu-horizontal',] },],
    'setMenuInlineClass': [{ type: HostBinding, args: ['class.ant-menu-submenu-inline',] },],
};
var PADDING_BASE = 24;
var NzMenuItemComponent = (function () {
    /**
     * @param {?} _renderer
     * @param {?} cd
     * @param {?} nzMenuComponent
     * @param {?} nzSubMenuComponent
     * @param {?} hostElement
     */
    function NzMenuItemComponent(_renderer, cd, nzMenuComponent, nzSubMenuComponent, hostElement) {
        this._renderer = _renderer;
        this.cd = cd;
        this.nzMenuComponent = nzMenuComponent;
        this.nzSubMenuComponent = nzSubMenuComponent;
        this.hostElement = hostElement;
        this.level = 0;
        this.padding = null;
        this.isInDropDown = false;
        this.selected = false;
        this.nzDisable = false;
        this.nzMenuComponent.menuItems.push(this);
        /** store origin padding in padding */
        if (this.hostElement.nativeElement.style['padding-left']) {
            this.padding = parseInt(this.hostElement.nativeElement.style['padding-left'], 10);
        }
    }
    Object.defineProperty(NzMenuItemComponent.prototype, "nzSelected", {
        /**
         * @return {?}
         */
        get: function () {
            return this.selected;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.selected = value;
            if (value) {
                this._renderer.addClass(this.hostElement.nativeElement, this.isInDropDown ? 'ant-dropdown-menu-item-selected' : 'ant-menu-item-selected');
            }
            else {
                this._renderer.removeClass(this.hostElement.nativeElement, this.isInDropDown ? 'ant-dropdown-menu-item-selected' : 'ant-menu-item-selected');
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * clear all item selected status except this
     * @return {?}
     */
    NzMenuItemComponent.prototype._onClickItem = function () {
        if (this.nzMenuComponent.nzClickActive && (!this.nzDisable)) {
            this.nzMenuComponent.clearAllSelected();
            this.nzSelected = true;
        }
    };
    Object.defineProperty(NzMenuItemComponent.prototype, "_isInDropDownClass", {
        /**
         * define host class
         * @return {?}
         */
        get: function () {
            return this.isInDropDown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuItemComponent.prototype, "_isNotInDropDownClass", {
        /**
         * @return {?}
         */
        get: function () {
            return !this.isInDropDown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuItemComponent.prototype, "setDropDownDisableClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isInDropDown && this.nzDisable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuItemComponent.prototype, "setMenuDisableClass", {
        /**
         * @return {?}
         */
        get: function () {
            return (!this.isInDropDown) && this.nzDisable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzMenuItemComponent.prototype, "setPaddingLeft", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.nzSubMenuComponent) {
                /** if in sub menu component */
                if (this.nzSubMenuComponent.nzMenuComponent.nzMode === 'inline') {
                    /** if host menu's mode is inline add PADDING_BASE * level padding */
                    return (this.nzSubMenuComponent.level + 1) * PADDING_BASE;
                }
                else {
                    /** return origin padding */
                    return this.padding;
                }
            }
            else if (this.nzMenuComponent.hasSubMenu && (this.nzMenuComponent.nzMode === 'inline')) {
                /** not in sub menu component but root menu's mode is inline and contains submenu return default padding*/
                return PADDING_BASE;
            }
            else {
                return this.padding;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzMenuItemComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function (_) {
            _this.isInDropDown = _this.nzMenuComponent.isInDropDown;
        });
    };
    return NzMenuItemComponent;
}());
NzMenuItemComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-menu-item]',
                template: "\n    <ng-content></ng-content>",
            },] },
];
/**
 * @nocollapse
 */
NzMenuItemComponent.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: ChangeDetectorRef, },
    { type: NzMenuComponent, },
    { type: NzSubMenuComponent, decorators: [{ type: Optional },] },
    { type: ElementRef, },
]; };
NzMenuItemComponent.propDecorators = {
    'nzDisable': [{ type: Input },],
    'nzSelected': [{ type: Input },],
    '_onClickItem': [{ type: HostListener, args: ['click', ['$event'],] },],
    '_isInDropDownClass': [{ type: HostBinding, args: ['class.ant-dropdown-menu-item',] },],
    '_isNotInDropDownClass': [{ type: HostBinding, args: ['class.ant-menu-item',] },],
    'setDropDownDisableClass': [{ type: HostBinding, args: ['class.ant-dropdown-menu-item-disabled',] },],
    'setMenuDisableClass': [{ type: HostBinding, args: ['class.ant-menu-item-disabled',] },],
    'setPaddingLeft': [{ type: HostBinding, args: ['style.padding-left.px',] },],
};
var NzMenuDividerComponent = (function () {
    function NzMenuDividerComponent() {
        this._nzDropdownMenuItemDivider = true;
    }
    return NzMenuDividerComponent;
}());
NzMenuDividerComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-menu-divider]',
                template: "\n    <ng-content></ng-content>",
            },] },
];
/**
 * @nocollapse
 */
NzMenuDividerComponent.ctorParameters = function () { return []; };
NzMenuDividerComponent.propDecorators = {
    '_nzDropdownMenuItemDivider': [{ type: HostBinding, args: ['class.ant-dropdown-menu-item-divider',] },],
};
var NzMenuGroupComponent = (function () {
    function NzMenuGroupComponent() {
        this._nzMenuItemGroup = true;
    }
    return NzMenuGroupComponent;
}());
NzMenuGroupComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-menu-group]',
                template: "\n    <div class=\"ant-menu-item-group-title\">\n      <ng-content select=\"[title]\"></ng-content>\n    </div>\n    <ul class=\"ant-menu-item-group-list\">\n      <ng-content></ng-content>\n    </ul>",
            },] },
];
/**
 * @nocollapse
 */
NzMenuGroupComponent.ctorParameters = function () { return []; };
NzMenuGroupComponent.propDecorators = {
    '_nzMenuItemGroup': [{ type: HostBinding, args: ['class.ant-menu-item-group',] },],
};
var NzMenuModule = (function () {
    function NzMenuModule() {
    }
    return NzMenuModule;
}());
NzMenuModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule, NzButtonModule],
                declarations: [NzMenuComponent, NzMenuItemComponent, NzSubMenuComponent, NzMenuDividerComponent, NzMenuGroupComponent],
                exports: [NzMenuComponent, NzMenuItemComponent, NzSubMenuComponent, NzMenuDividerComponent, NzMenuGroupComponent]
            },] },
];
/**
 * @nocollapse
 */
NzMenuModule.ctorParameters = function () { return []; };
var NzDropDownModule = (function () {
    function NzDropDownModule() {
    }
    return NzDropDownModule;
}());
NzDropDownModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, OverlayModule, FormsModule, NzButtonModule, NzMenuModule],
                declarations: [NzDropDownComponent, NzDropDownButtonComponent, NzDropDownDirective],
                exports: [NzDropDownComponent, NzDropDownButtonComponent, NzDropDownDirective]
            },] },
];
/**
 * @nocollapse
 */
NzDropDownModule.ctorParameters = function () { return []; };
var NzBreadCrumbComponent = (function () {
    function NzBreadCrumbComponent() {
        this.nzSeparator = '/';
        this._nzBreadcrumb = true;
    }
    return NzBreadCrumbComponent;
}());
NzBreadCrumbComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-breadcrumb',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-breadcrumb {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n}\n.ant-breadcrumb a {\n  color: rgba(0, 0, 0, 0.65);\n  transition: color .3s;\n}\n.ant-breadcrumb a:hover {\n  color: #49a9ee;\n}\n.ant-breadcrumb > span:last-child {\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-breadcrumb > span:last-child .ant-breadcrumb-separator {\n  display: none;\n}\n.ant-breadcrumb-separator {\n  margin: 0 8px;\n  color: rgba(0, 0, 0, 0.3);\n}\n.ant-breadcrumb-link > .anticon + span {\n  margin-left: 4px;\n}\n",
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-breadcrumb {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n}\n.ant-breadcrumb a {\n  color: rgba(0, 0, 0, 0.65);\n  transition: color .3s;\n}\n.ant-breadcrumb a:hover {\n  color: #49a9ee;\n}\n.ant-breadcrumb > span:last-child {\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-breadcrumb > span:last-child .ant-breadcrumb-separator {\n  display: none;\n}\n.ant-breadcrumb-separator {\n  margin: 0 8px;\n  color: rgba(0, 0, 0, 0.3);\n}\n.ant-breadcrumb-link > .anticon + span {\n  margin-left: 4px;\n}\n.ant-breadcrumb {\n  display: block;\n}\n.ant-breadcrumb > nz-breadcrumb-item:last-child {\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.65);\n}\n.ant-breadcrumb > nz-breadcrumb-item:last-child .ant-breadcrumb-separator {\n  display: none;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzBreadCrumbComponent.ctorParameters = function () { return []; };
NzBreadCrumbComponent.propDecorators = {
    'nzSeparator': [{ type: Input },],
    '_nzBreadcrumb': [{ type: HostBinding, args: ['class.ant-breadcrumb',] },],
};
var NzBreadCrumbItemComponent = (function () {
    /**
     * @param {?} nzBreadCrumbComponent
     */
    function NzBreadCrumbItemComponent(nzBreadCrumbComponent) {
        this.nzBreadCrumbComponent = nzBreadCrumbComponent;
    }
    return NzBreadCrumbItemComponent;
}());
NzBreadCrumbItemComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-breadcrumb-item',
                template: "\n    <span class=\"ant-breadcrumb-link\">\n      <ng-content></ng-content>\n    </span>\n    <span class=\"ant-breadcrumb-separator\">{{nzBreadCrumbComponent?.nzSeparator}}</span>"
            },] },
];
/**
 * @nocollapse
 */
NzBreadCrumbItemComponent.ctorParameters = function () { return [
    { type: NzBreadCrumbComponent, },
]; };
var NzBreadCrumbModule = (function () {
    function NzBreadCrumbModule() {
    }
    return NzBreadCrumbModule;
}());
NzBreadCrumbModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [NzBreadCrumbComponent, NzBreadCrumbItemComponent],
                exports: [NzBreadCrumbComponent, NzBreadCrumbItemComponent]
            },] },
];
/**
 * @nocollapse
 */
NzBreadCrumbModule.ctorParameters = function () { return []; };
var NzLayoutComponent = (function () {
    function NzLayoutComponent() {
        this.hasSider = false;
        this._nzLayout = true;
    }
    return NzLayoutComponent;
}());
NzLayoutComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-layout',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-layout {\n  display: flex;\n  flex-direction: column;\n  flex: auto;\n  background: #ececec;\n}\n.ant-layout.ant-layout-has-sider {\n  flex-direction: row;\n}\n.ant-layout.ant-layout-has-sider > .ant-layout,\n.ant-layout.ant-layout-has-sider > .ant-layout-content {\n  overflow-x: hidden;\n}\n.ant-layout-header,\n.ant-layout-footer {\n  flex: 0 0 auto;\n}\n.ant-layout-header {\n  background: #404040;\n  padding: 0 50px;\n  height: 64px;\n  line-height: 64px;\n}\n.ant-layout-footer {\n  padding: 24px 50px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 12px;\n}\n.ant-layout-content {\n  flex: auto;\n}\n.ant-layout-sider {\n  transition: all 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n  position: relative;\n  background: #404040;\n  /* fix firefox can't set width smaller than content on flex item */\n  min-width: 0;\n}\n.ant-layout-sider-has-trigger {\n  padding-bottom: 48px;\n}\n.ant-layout-sider-right {\n  order: 1;\n}\n.ant-layout-sider-trigger {\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  bottom: 0;\n  cursor: pointer;\n  height: 48px;\n  line-height: 48px;\n  background: rgba(64, 64, 64, 0.88);\n  color: #fff;\n}\n.ant-layout-sider-zero-width > * {\n  overflow: hidden;\n}\n.ant-layout-sider-zero-width-trigger {\n  position: absolute;\n  top: 64px;\n  right: -36px;\n  text-align: center;\n  width: 36px;\n  height: 42px;\n  line-height: 42px;\n  background: #404040;\n  color: #fff;\n  font-size: 18px;\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n  transition: background .3s ease;\n}\n.ant-layout-sider-zero-width-trigger:hover {\n  background: #535353;\n}\n",
                    "nz-layout,\nnz-footer,\nnz-header,\nnz-content {\n  display: block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzLayoutComponent.ctorParameters = function () { return []; };
NzLayoutComponent.propDecorators = {
    'hasSider': [{ type: HostBinding, args: ['class.ant-layout-has-sider',] },],
    '_nzLayout': [{ type: HostBinding, args: ['class.ant-layout',] },],
};
var NzHeaderComponent = (function () {
    function NzHeaderComponent() {
        this._nzLayoutHeader = true;
    }
    return NzHeaderComponent;
}());
NzHeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-header',
                template: "\n    <ng-content></ng-content>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzHeaderComponent.ctorParameters = function () { return []; };
NzHeaderComponent.propDecorators = {
    '_nzLayoutHeader': [{ type: HostBinding, args: ['class.ant-layout-header',] },],
};
var NzContentComponent = (function () {
    function NzContentComponent() {
        this._nzLayoutContent = true;
    }
    return NzContentComponent;
}());
NzContentComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-content',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzContentComponent.ctorParameters = function () { return []; };
NzContentComponent.propDecorators = {
    '_nzLayoutContent': [{ type: HostBinding, args: ['class.ant-layout-content',] },],
};
var NzFooterComponent = (function () {
    function NzFooterComponent() {
        this._nzLayoutFooter = true;
    }
    return NzFooterComponent;
}());
NzFooterComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-footer',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzFooterComponent.ctorParameters = function () { return []; };
NzFooterComponent.propDecorators = {
    '_nzLayoutFooter': [{ type: HostBinding, args: ['class.ant-layout-footer',] },],
};
var NzSiderComponent = (function () {
    /**
     * @param {?} nzLayoutComponent
     */
    function NzSiderComponent(nzLayoutComponent) {
        this.nzLayoutComponent = nzLayoutComponent;
        this._dimensionMap = {
            xl: '1600px',
            lg: '1200px',
            md: '992px',
            sm: '768px',
            xs: '480px',
        };
        this._below = false;
        this.nzWidth = '200';
        this.nzTrigger = true;
        this.nzCollapsedWidth = 64;
        this.nzCollapsed = false;
        this._collapsible = false;
        this.nzCollapsedChange = new EventEmitter();
        this._nzLayoutSider = true;
        if (this.nzLayoutComponent) {
            this.nzLayoutComponent.hasSider = true;
        }
        if (typeof window !== 'undefined') {
            var matchMediaPolyfill = function (mediaQuery) {
                return {
                    media: mediaQuery,
                    matches: false,
                    addListener: function () {
                    },
                    removeListener: function () {
                    },
                };
            };
            window.matchMedia = window.matchMedia || matchMediaPolyfill;
        }
    }
    Object.defineProperty(NzSiderComponent.prototype, "nzCollapsible", {
        /**
         * @return {?}
         */
        get: function () {
            return this._collapsible;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === '') {
                this._collapsible = true;
            }
            else {
                this._collapsible = (value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSiderComponent.prototype, "setZeroClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzCollapsed && (this.nzCollapsedWidth === 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSiderComponent.prototype, "setFlex", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.nzCollapsed) {
                return "0 0 " + this.nzCollapsedWidth + "px";
            }
            else {
                return "0 0 " + this.nzWidth + "px";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSiderComponent.prototype, "setWidth", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.nzCollapsed) {
                return this.nzCollapsedWidth;
            }
            else {
                return this.nzWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} e
     * @return {?}
     */
    NzSiderComponent.prototype.onWindowResize = function (e) {
        if (this.nzBreakpoint) {
            var /** @type {?} */ matchBelow = window.matchMedia("(max-width: " + this._dimensionMap[this.nzBreakpoint] + ")").matches;
            this._below = matchBelow;
            this.nzCollapsed = matchBelow;
            this.nzCollapsedChange.emit(matchBelow);
        }
    };
    /**
     * @return {?}
     */
    NzSiderComponent.prototype.toggleCollapse = function () {
        this.nzCollapsed = !this.nzCollapsed;
        this.nzCollapsedChange.emit(this.nzCollapsed);
    };
    Object.defineProperty(NzSiderComponent.prototype, "_isZeroTrigger", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzCollapsible && this.nzTrigger && (this.nzCollapsedWidth === 0) && ((this.nzBreakpoint && this._below) || (!this.nzBreakpoint));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzSiderComponent.prototype, "_isSiderTrgger", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nzCollapsible && this.nzTrigger && (this.nzCollapsedWidth !== 0);
        },
        enumerable: true,
        configurable: true
    });
    return NzSiderComponent;
}());
NzSiderComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-sider',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ng-content></ng-content>\n    <span class=\"ant-layout-sider-zero-width-trigger\" *ngIf=\"_isZeroTrigger\" (click)=\"toggleCollapse()\">\n      <i class=\"anticon anticon-bars\"></i>\n    </span>\n    <div class=\"ant-layout-sider-trigger\" *ngIf=\"_isSiderTrgger\" (click)=\"toggleCollapse()\">\n      <i class=\"anticon\" [class.anticon-left]=\"!nzCollapsed\" [class.anticon-right]=\"nzCollapsed\"></i>\n    </div>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzSiderComponent.ctorParameters = function () { return [
    { type: NzLayoutComponent, decorators: [{ type: Optional }, { type: Host },] },
]; };
NzSiderComponent.propDecorators = {
    'nzWidth': [{ type: Input },],
    'nzTrigger': [{ type: Input },],
    'nzCollapsedWidth': [{ type: Input },],
    'nzBreakpoint': [{ type: Input },],
    'nzCollapsed': [{ type: Input }, { type: HostBinding, args: ['class.ant-layout-sider-collapsed',] },],
    'nzCollapsible': [{ type: Input },],
    'nzCollapsedChange': [{ type: Output },],
    '_nzLayoutSider': [{ type: HostBinding, args: ['class.ant-layout-sider',] },],
    'setZeroClass': [{ type: HostBinding, args: ['class.ant-layout-sider-zero-width',] },],
    'setFlex': [{ type: HostBinding, args: ['style.flex',] },],
    'setWidth': [{ type: HostBinding, args: ['style.width.px',] },],
    'onWindowResize': [{ type: HostListener, args: ['window:resize', ['$event'],] },],
};
var NzLayoutModule = (function () {
    function NzLayoutModule() {
    }
    return NzLayoutModule;
}());
NzLayoutModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzLayoutComponent, NzHeaderComponent, NzContentComponent, NzFooterComponent, NzSiderComponent],
                exports: [NzLayoutComponent, NzHeaderComponent, NzContentComponent, NzFooterComponent, NzSiderComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzLayoutModule.ctorParameters = function () { return []; };
var NZ_ROOT_CONFIG = new InjectionToken('NzRootConfig');
/**
 * @param {?} document
 * @param {?=} options
 * @return {?}
 */
function createNzRootInitializer(document, options) {
    return function nzRootInitializer() {
        if (options) {
            var /** @type {?} */ style$$1 = document.createElement('style');
            style$$1.innerHTML = "\n        @font-face {\n          font-family: '" + options.extraFontName + "';\n          src: url('" + options.extraFontUrl + ".eot'); /* IE9*/\n          src:\n            /* IE6-IE8 */\n            url('" + options.extraFontUrl + ".eot?#iefix') format('embedded-opentype'),\n            /* chrome\u3001firefox */\n            url('" + options.extraFontUrl + ".woff') format('woff'),\n            /* chrome\u3001firefox\u3001opera\u3001Safari, Android, iOS 4.2+*/\n            url('" + options.extraFontUrl + ".ttf') format('truetype'),\n            /* iOS 4.1- */\n            url('" + options.extraFontUrl + ".svg#iconfont') format('svg');\n        }\n      ";
            document.head.appendChild(style$$1);
        }
    };
}
var NzRootComponent = (function () {
    /**
     * @param {?} _document
     * @param {?} options
     */
    function NzRootComponent(_document, options) {
        this._document = _document;
        this.options = options;
    }
    /**
     * @return {?}
     */
    NzRootComponent.prototype.ngOnInit = function () {
        if (this.nzExtraFontName && this.nzExtraFontUrl && !this.options) {
            var /** @type {?} */ options = { extraFontName: this.nzExtraFontName, extraFontUrl: this.nzExtraFontUrl };
            var /** @type {?} */ initializer = createNzRootInitializer(this._document, options);
            initializer();
        }
    };
    return NzRootComponent;
}());
NzRootComponent.decorators = [
    { type: Component, args: [{
                selector: '[nz-root],nz-root',
                template: "\n    <ng-content></ng-content>\n  ",
            },] },
];
/**
 * @nocollapse
 */
NzRootComponent.ctorParameters = function () { return [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
    { type: undefined, decorators: [{ type: Inject, args: [NZ_ROOT_CONFIG,] }, { type: Optional },] },
]; };
NzRootComponent.propDecorators = {
    'nzExtraFontName': [{ type: Input },],
    'nzExtraFontUrl': [{ type: Input },],
};
var NzRootStyleComponent = (function () {
    function NzRootStyleComponent() {
    }
    return NzRootStyleComponent;
}());
NzRootStyleComponent.decorators = [
    { type: Component, args: [{
                template: "",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */\n/* Document\n   ========================================================================== */\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\nhtml {\n  line-height: 1.15;\n  /* 1 */\n  -ms-text-size-adjust: 100%;\n  /* 2 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n}\n/* Sections\n   ========================================================================== */\n/**\n * Remove the margin in all browsers (opinionated).\n */\nbody {\n  margin: 0;\n}\n/**\n * Add the correct display in IE 9-.\n */\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n/**\n * Correct the font size and margin on 'h1' elements within 'section' and\n * 'article' contexts in Chrome, Firefox, and Safari.\n */\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n/* Grouping content\n   ========================================================================== */\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\nfigcaption,\nfigure,\nmain {\n  /* 1 */\n  display: block;\n}\n/**\n * Add the correct margin in IE 8.\n */\nfigure {\n  margin: 1em 40px;\n}\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\nhr {\n  box-sizing: content-box;\n  /* 1 */\n  height: 0;\n  /* 1 */\n  overflow: visible;\n  /* 2 */\n}\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd 'em' font sizing in all browsers.\n */\npre {\n  font-family: monospace, monospace;\n  /* 1 */\n  /* stylelint-disable-line */\n  font-size: 1em;\n  /* 2 */\n}\n/* Text-level semantics\n   ========================================================================== */\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\na {\n  background-color: transparent;\n  /* 1 */\n  -webkit-text-decoration-skip: objects;\n  /* 2 */\n}\n/**\n * 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\nabbr[title] {\n  border-bottom: none;\n  /* 1 */\n  text-decoration: underline;\n  /* 2 */\n  text-decoration: underline dotted;\n  /* 2 */\n}\n/**\n * Prevent the duplicate application of 'bolder' by the next rule in Safari 6.\n */\nb,\nstrong {\n  font-weight: inherit;\n}\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\nb,\nstrong {\n  font-weight: bolder;\n}\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd 'em' font sizing in all browsers.\n */\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  /* 1 */\n  /* stylelint-disable-line */\n  font-size: 1em;\n  /* 2 */\n}\n/**\n * Add the correct font style in Android 4.3-.\n */\ndfn {\n  font-style: italic;\n}\n/**\n * Add the correct background and color in IE 9-.\n */\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n/**\n * Add the correct font size in all browsers.\n */\nsmall {\n  font-size: 80%;\n}\n/**\n * Prevent 'sub' and 'sup' elements from affecting the line height in\n * all browsers.\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\n/* Embedded content\n   ========================================================================== */\n/**\n * Add the correct display in IE 9-.\n */\naudio,\nvideo {\n  display: inline-block;\n}\n/**\n * Add the correct display in iOS 4-7.\n */\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n/**\n * Remove the border on images inside links in IE 10-.\n */\nimg {\n  border-style: none;\n}\n/**\n * Hide the overflow in IE.\n */\nsvg:not(:root) {\n  overflow: hidden;\n}\n/* Forms\n   ========================================================================== */\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  line-height: 1.15;\n  /* 1 */\n  margin: 0;\n  /* 2 */\n}\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\nbutton,\ninput {\n  /* 1 */\n  overflow: visible;\n}\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\nbutton,\nselect {\n  /* 1 */\n  text-transform: none;\n}\n/**\n * 1. Prevent a WebKit bug where (2) destroys native 'audio' and 'video'\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n  /* 2 */\n}\n/**\n * Remove the inner border and padding in Firefox.\n */\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n/**\n * Restore the focus styles unset by the previous rule.\n */\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n/**\n * Correct the padding in Firefox.\n */\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from 'fieldset' elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    'fieldset' elements in all browsers.\n */\nlegend {\n  box-sizing: border-box;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  display: table;\n  /* 1 */\n  max-width: 100%;\n  /* 1 */\n  padding: 0;\n  /* 3 */\n  white-space: normal;\n  /* 1 */\n}\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\nprogress {\n  display: inline-block;\n  /* 1 */\n  vertical-align: baseline;\n  /* 2 */\n}\n/**\n * Remove the default vertical scrollbar in IE.\n */\ntextarea {\n  overflow: auto;\n}\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to 'inherit' in Safari.\n */\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n/* Interactive\n   ========================================================================== */\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\ndetails,\nmenu {\n  display: block;\n}\n/*\n * Add the correct display in all browsers.\n */\nsummary {\n  display: list-item;\n}\n/* Scripting\n   ========================================================================== */\n/**\n * Add the correct display in IE 9-.\n */\ncanvas {\n  display: inline-block;\n}\n/**\n * Add the correct display in IE.\n */\ntemplate {\n  display: none;\n}\n/* Hidden\n   ========================================================================== */\n/**\n * Add the correct display in IE 10-.\n */\n[hidden] {\n  display: none;\n}\n@font-face {\n  font-family: \"Helvetica Neue For Number\";\n  src: local(\"Helvetica Neue\");\n  unicode-range: U+30-39;\n}\n* {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n*:before,\n*:after {\n  box-sizing: border-box;\n}\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n}\nbody {\n  font-family: \"Helvetica Neue For Number\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"PingFang SC\", \"Hiragino Sans GB\", \"Microsoft YaHei\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n}\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\npre,\ncode,\nform,\nfieldset,\nlegend,\ninput,\ntextarea,\np,\nblockquote,\nth,\ntd,\nhr,\nbutton,\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  margin: 0;\n  padding: 0;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n}\nul,\nol {\n  list-style: none;\n}\ninput::-ms-clear,\ninput::-ms-reveal {\n  display: none;\n}\n::selection {\n  background: #108ee9;\n  color: #fff;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n}\na {\n  color: #108ee9;\n  background: transparent;\n  text-decoration: none;\n  outline: none;\n  cursor: pointer;\n  transition: color .3s ease;\n}\na:focus {\n  text-decoration: underline;\n  text-decoration-skip: ink;\n}\na:hover {\n  color: #49a9ee;\n}\na:active {\n  color: #0e77ca;\n}\na:active,\na:hover {\n  outline: 0;\n  text-decoration: none;\n}\na[disabled] {\n  color: rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.ant-divider {\n  margin: 0 6px;\n  display: inline-block;\n  height: 8px;\n  width: 1px;\n  background: #ccc;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: Consolas, Menlo, Courier, monospace;\n}\n.clearfix {\n  zoom: 1;\n}\n.clearfix:before,\n.clearfix:after {\n  content: \" \";\n  display: table;\n}\n.clearfix:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n@font-face {\n  font-family: 'anticon';\n  src: url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.eot');\n  /* IE9*/\n  src: url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.eot?#iefix') format('embedded-opentype'), /* chrome\u3001firefox */ url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.woff') format('woff'), /* chrome\u3001firefox\u3001opera\u3001Safari, Android, iOS 4.2+*/ url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.ttf') format('truetype'), /* iOS 4.1- */ url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.svg#iconfont') format('svg');\n}\n.anticon {\n  display: inline-block;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  line-height: 1;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.anticon:before {\n  display: block;\n  font-family: \"anticon\" !important;\n}\n.anticon-step-forward:before {\n  content: \"\\e600\";\n}\n.anticon-step-backward:before {\n  content: \"\\e601\";\n}\n.anticon-forward:before {\n  content: \"\\e602\";\n}\n.anticon-backward:before {\n  content: \"\\e603\";\n}\n.anticon-caret-right:before {\n  content: \"\\e604\";\n}\n.anticon-caret-left:before {\n  content: \"\\e605\";\n}\n.anticon-caret-down:before {\n  content: \"\\e606\";\n}\n.anticon-caret-up:before {\n  content: \"\\e607\";\n}\n.anticon-right-circle:before {\n  content: \"\\e608\";\n}\n.anticon-circle-right:before {\n  content: \"\\e608\";\n}\n.anticon-caret-circle-right:before {\n  content: \"\\e608\";\n}\n.anticon-left-circle:before {\n  content: \"\\e609\";\n}\n.anticon-circle-left:before {\n  content: \"\\e609\";\n}\n.anticon-caret-circle-left:before {\n  content: \"\\e609\";\n}\n.anticon-up-circle:before {\n  content: \"\\e60a\";\n}\n.anticon-circle-up:before {\n  content: \"\\e60a\";\n}\n.anticon-caret-circle-up:before {\n  content: \"\\e60a\";\n}\n.anticon-down-circle:before {\n  content: \"\\e60b\";\n}\n.anticon-circle-down:before {\n  content: \"\\e60b\";\n}\n.anticon-caret-circle-down:before {\n  content: \"\\e60b\";\n}\n.anticon-right-circle-o:before {\n  content: \"\\e60c\";\n}\n.anticon-circle-o-right:before {\n  content: \"\\e60c\";\n}\n.anticon-caret-circle-o-right:before {\n  content: \"\\e60c\";\n}\n.anticon-left-circle-o:before {\n  content: \"\\e60d\";\n}\n.anticon-circle-o-left:before {\n  content: \"\\e60d\";\n}\n.anticon-caret-circle-o-left:before {\n  content: \"\\e60d\";\n}\n.anticon-up-circle-o:before {\n  content: \"\\e60e\";\n}\n.anticon-circle-o-up:before {\n  content: \"\\e60e\";\n}\n.anticon-caret-circle-o-up:before {\n  content: \"\\e60e\";\n}\n.anticon-down-circle-o:before {\n  content: \"\\e60f\";\n}\n.anticon-circle-o-down:before {\n  content: \"\\e60f\";\n}\n.anticon-caret-circle-o-down:before {\n  content: \"\\e60f\";\n}\n.anticon-verticle-left:before {\n  content: \"\\e610\";\n}\n.anticon-verticle-right:before {\n  content: \"\\e611\";\n}\n.anticon-rollback:before {\n  content: \"\\e612\";\n}\n.anticon-retweet:before {\n  content: \"\\e613\";\n}\n.anticon-shrink:before {\n  content: \"\\e614\";\n}\n.anticon-arrows-alt:before {\n  content: \"\\e615\";\n}\n.anticon-arrow-salt:before {\n  content: \"\\e615\";\n}\n.anticon-reload:before {\n  content: \"\\e616\";\n}\n.anticon-double-right:before {\n  content: \"\\e617\";\n}\n.anticon-double-left:before {\n  content: \"\\e618\";\n}\n.anticon-arrow-down:before {\n  content: \"\\e619\";\n}\n.anticon-arrow-up:before {\n  content: \"\\e61a\";\n}\n.anticon-arrow-right:before {\n  content: \"\\e61b\";\n}\n.anticon-arrow-left:before {\n  content: \"\\e61c\";\n}\n.anticon-down:before {\n  content: \"\\e61d\";\n}\n.anticon-up:before {\n  content: \"\\e61e\";\n}\n.anticon-right:before {\n  content: \"\\e61f\";\n}\n.anticon-left:before {\n  content: \"\\e620\";\n}\n.anticon-minus-square-o:before {\n  content: \"\\e621\";\n}\n.anticon-minus-circle:before {\n  content: \"\\e622\";\n}\n.anticon-minus-circle-o:before {\n  content: \"\\e623\";\n}\n.anticon-minus:before {\n  content: \"\\e624\";\n}\n.anticon-plus-circle-o:before {\n  content: \"\\e625\";\n}\n.anticon-plus-circle:before {\n  content: \"\\e626\";\n}\n.anticon-plus:before {\n  content: \"\\e627\";\n}\n.anticon-info-circle:before {\n  content: \"\\e628\";\n}\n.anticon-info-circle-o:before {\n  content: \"\\e629\";\n}\n.anticon-info:before {\n  content: \"\\e62a\";\n}\n.anticon-exclamation:before {\n  content: \"\\e62b\";\n}\n.anticon-exclamation-circle:before {\n  content: \"\\e62c\";\n}\n.anticon-exclamation-circle-o:before {\n  content: \"\\e62d\";\n}\n.anticon-close-circle:before {\n  content: \"\\e62e\";\n}\n.anticon-cross-circle:before {\n  content: \"\\e62e\";\n}\n.anticon-close-circle-o:before {\n  content: \"\\e62f\";\n}\n.anticon-cross-circle-o:before {\n  content: \"\\e62f\";\n}\n.anticon-check-circle:before {\n  content: \"\\e630\";\n}\n.anticon-check-circle-o:before {\n  content: \"\\e631\";\n}\n.anticon-check:before {\n  content: \"\\e632\";\n}\n.anticon-close:before {\n  content: \"\\e633\";\n}\n.anticon-cross:before {\n  content: \"\\e633\";\n}\n.anticon-customer-service:before {\n  content: \"\\e634\";\n}\n.anticon-customerservice:before {\n  content: \"\\e634\";\n}\n.anticon-credit-card:before {\n  content: \"\\e635\";\n}\n.anticon-code-o:before {\n  content: \"\\e636\";\n}\n.anticon-book:before {\n  content: \"\\e637\";\n}\n.anticon-bar-chart:before {\n  content: \"\\e638\";\n}\n.anticon-bars:before {\n  content: \"\\e639\";\n}\n.anticon-question:before {\n  content: \"\\e63a\";\n}\n.anticon-question-circle:before {\n  content: \"\\e63b\";\n}\n.anticon-question-circle-o:before {\n  content: \"\\e63c\";\n}\n.anticon-pause:before {\n  content: \"\\e63d\";\n}\n.anticon-pause-circle:before {\n  content: \"\\e63e\";\n}\n.anticon-pause-circle-o:before {\n  content: \"\\e63f\";\n}\n.anticon-clock-circle:before {\n  content: \"\\e640\";\n}\n.anticon-clock-circle-o:before {\n  content: \"\\e641\";\n}\n.anticon-swap:before {\n  content: \"\\e642\";\n}\n.anticon-swap-left:before {\n  content: \"\\e643\";\n}\n.anticon-swap-right:before {\n  content: \"\\e644\";\n}\n.anticon-plus-square-o:before {\n  content: \"\\e645\";\n}\n.anticon-frown:before {\n  content: \"\\e646\";\n}\n.anticon-frown-circle:before {\n  content: \"\\e646\";\n}\n.anticon-ellipsis:before {\n  content: \"\\e647\";\n}\n.anticon-copy:before {\n  content: \"\\e648\";\n}\n.anticon-menu-fold:before {\n  content: \"\\e658\";\n}\n.anticon-mail:before {\n  content: \"\\e659\";\n}\n.anticon-logout:before {\n  content: \"\\e65a\";\n}\n.anticon-link:before {\n  content: \"\\e65b\";\n}\n.anticon-area-chart:before {\n  content: \"\\e65c\";\n}\n.anticon-line-chart:before {\n  content: \"\\e65d\";\n}\n.anticon-home:before {\n  content: \"\\e65e\";\n}\n.anticon-laptop:before {\n  content: \"\\e65f\";\n}\n.anticon-star:before {\n  content: \"\\e660\";\n}\n.anticon-star-o:before {\n  content: \"\\e661\";\n}\n.anticon-folder:before {\n  content: \"\\e662\";\n}\n.anticon-filter:before {\n  content: \"\\e663\";\n}\n.anticon-file:before {\n  content: \"\\e664\";\n}\n.anticon-exception:before {\n  content: \"\\e665\";\n}\n.anticon-meh:before {\n  content: \"\\e666\";\n}\n.anticon-meh-circle:before {\n  content: \"\\e666\";\n}\n.anticon-meh-o:before {\n  content: \"\\e667\";\n}\n.anticon-shopping-cart:before {\n  content: \"\\e668\";\n}\n.anticon-save:before {\n  content: \"\\e669\";\n}\n.anticon-user:before {\n  content: \"\\e66a\";\n}\n.anticon-video-camera:before {\n  content: \"\\e66b\";\n}\n.anticon-to-top:before {\n  content: \"\\e66c\";\n}\n.anticon-team:before {\n  content: \"\\e66d\";\n}\n.anticon-tablet:before {\n  content: \"\\e66e\";\n}\n.anticon-solution:before {\n  content: \"\\e66f\";\n}\n.anticon-search:before {\n  content: \"\\e670\";\n}\n.anticon-share-alt:before {\n  content: \"\\e671\";\n}\n.anticon-setting:before {\n  content: \"\\e672\";\n}\n.anticon-poweroff:before {\n  content: \"\\e6d5\";\n}\n.anticon-picture:before {\n  content: \"\\e674\";\n}\n.anticon-phone:before {\n  content: \"\\e675\";\n}\n.anticon-paper-clip:before {\n  content: \"\\e676\";\n}\n.anticon-notification:before {\n  content: \"\\e677\";\n}\n.anticon-mobile:before {\n  content: \"\\e678\";\n}\n.anticon-menu-unfold:before {\n  content: \"\\e679\";\n}\n.anticon-inbox:before {\n  content: \"\\e67a\";\n}\n.anticon-lock:before {\n  content: \"\\e67b\";\n}\n.anticon-qrcode:before {\n  content: \"\\e67c\";\n}\n.anticon-play-circle:before {\n  content: \"\\e6d0\";\n}\n.anticon-play-circle-o:before {\n  content: \"\\e6d1\";\n}\n.anticon-tag:before {\n  content: \"\\e6d2\";\n}\n.anticon-tag-o:before {\n  content: \"\\e6d3\";\n}\n.anticon-tags:before {\n  content: \"\\e67d\";\n}\n.anticon-tags-o:before {\n  content: \"\\e67e\";\n}\n.anticon-cloud-o:before {\n  content: \"\\e67f\";\n}\n.anticon-cloud:before {\n  content: \"\\e680\";\n}\n.anticon-cloud-upload:before {\n  content: \"\\e681\";\n}\n.anticon-cloud-download:before {\n  content: \"\\e682\";\n}\n.anticon-cloud-download-o:before {\n  content: \"\\e683\";\n}\n.anticon-cloud-upload-o:before {\n  content: \"\\e684\";\n}\n.anticon-environment:before {\n  content: \"\\e685\";\n}\n.anticon-environment-o:before {\n  content: \"\\e686\";\n}\n.anticon-eye:before {\n  content: \"\\e687\";\n}\n.anticon-eye-o:before {\n  content: \"\\e688\";\n}\n.anticon-camera:before {\n  content: \"\\e689\";\n}\n.anticon-camera-o:before {\n  content: \"\\e68a\";\n}\n.anticon-windows:before {\n  content: \"\\e68b\";\n}\n.anticon-apple:before {\n  content: \"\\e68c\";\n}\n.anticon-apple-o:before {\n  content: \"\\e6d4\";\n}\n.anticon-android:before {\n  content: \"\\e938\";\n}\n.anticon-android-o:before {\n  content: \"\\e68d\";\n}\n.anticon-aliwangwang:before {\n  content: \"\\e68e\";\n}\n.anticon-aliwangwang-o:before {\n  content: \"\\e68f\";\n}\n.anticon-export:before {\n  content: \"\\e691\";\n}\n.anticon-edit:before {\n  content: \"\\e692\";\n}\n.anticon-circle-down-o:before {\n  content: \"\\e693\";\n}\n.anticon-circle-down-:before {\n  content: \"\\e694\";\n}\n.anticon-appstore-o:before {\n  content: \"\\e695\";\n}\n.anticon-appstore:before {\n  content: \"\\e696\";\n}\n.anticon-scan:before {\n  content: \"\\e697\";\n}\n.anticon-file-text:before {\n  content: \"\\e698\";\n}\n.anticon-folder-open:before {\n  content: \"\\e699\";\n}\n.anticon-hdd:before {\n  content: \"\\e69a\";\n}\n.anticon-ie:before {\n  content: \"\\e69b\";\n}\n.anticon-file-jpg:before {\n  content: \"\\e69c\";\n}\n.anticon-like:before {\n  content: \"\\e64c\";\n}\n.anticon-like-o:before {\n  content: \"\\e69d\";\n}\n.anticon-dislike:before {\n  content: \"\\e64b\";\n}\n.anticon-dislike-o:before {\n  content: \"\\e69e\";\n}\n.anticon-delete:before {\n  content: \"\\e69f\";\n}\n.anticon-enter:before {\n  content: \"\\e6a0\";\n}\n.anticon-pushpin-o:before {\n  content: \"\\e6a1\";\n}\n.anticon-pushpin:before {\n  content: \"\\e6a2\";\n}\n.anticon-heart:before {\n  content: \"\\e6a3\";\n}\n.anticon-heart-o:before {\n  content: \"\\e6a4\";\n}\n.anticon-pay-circle:before {\n  content: \"\\e6a5\";\n}\n.anticon-pay-circle-o:before {\n  content: \"\\e6a6\";\n}\n.anticon-smile:before {\n  content: \"\\e6a7\";\n}\n.anticon-smile-circle:before {\n  content: \"\\e6a7\";\n}\n.anticon-smile-o:before {\n  content: \"\\e6a8\";\n}\n.anticon-frown-o:before {\n  content: \"\\e6a9\";\n}\n.anticon-calculator:before {\n  content: \"\\e6aa\";\n}\n.anticon-message:before {\n  content: \"\\e6ab\";\n}\n.anticon-chrome:before {\n  content: \"\\e6ac\";\n}\n.anticon-github:before {\n  content: \"\\e6ad\";\n}\n.anticon-file-unknown:before {\n  content: \"\\e6af\";\n}\n.anticon-file-excel:before {\n  content: \"\\e6b0\";\n}\n.anticon-file-ppt:before {\n  content: \"\\e6b1\";\n}\n.anticon-file-word:before {\n  content: \"\\e6b2\";\n}\n.anticon-file-pdf:before {\n  content: \"\\e6b3\";\n}\n.anticon-desktop:before {\n  content: \"\\e6b4\";\n}\n.anticon-upload:before {\n  content: \"\\e6b6\";\n}\n.anticon-download:before {\n  content: \"\\e6b7\";\n}\n.anticon-pie-chart:before {\n  content: \"\\e6b8\";\n}\n.anticon-unlock:before {\n  content: \"\\e6ba\";\n}\n.anticon-calendar:before {\n  content: \"\\e6bb\";\n}\n.anticon-windows-o:before {\n  content: \"\\e6bc\";\n}\n.anticon-dot-chart:before {\n  content: \"\\e6bd\";\n}\n.anticon-bar-chart:before {\n  content: \"\\e6be\";\n}\n.anticon-code:before {\n  content: \"\\e6bf\";\n}\n.anticon-api:before {\n  content: \"\\e951\";\n}\n.anticon-plus-square:before {\n  content: \"\\e6c0\";\n}\n.anticon-minus-square:before {\n  content: \"\\e6c1\";\n}\n.anticon-close-square:before {\n  content: \"\\e6c2\";\n}\n.anticon-close-square-o:before {\n  content: \"\\e6c3\";\n}\n.anticon-check-square:before {\n  content: \"\\e6c4\";\n}\n.anticon-check-square-o:before {\n  content: \"\\e6c5\";\n}\n.anticon-fast-backward:before {\n  content: \"\\e6c6\";\n}\n.anticon-fast-forward:before {\n  content: \"\\e6c7\";\n}\n.anticon-up-square:before {\n  content: \"\\e6c8\";\n}\n.anticon-down-square:before {\n  content: \"\\e6c9\";\n}\n.anticon-left-square:before {\n  content: \"\\e6ca\";\n}\n.anticon-right-square:before {\n  content: \"\\e6cb\";\n}\n.anticon-right-square-o:before {\n  content: \"\\e6cc\";\n}\n.anticon-left-square-o:before {\n  content: \"\\e6cd\";\n}\n.anticon-down-square-o:before {\n  content: \"\\e6ce\";\n}\n.anticon-up-square-o:before {\n  content: \"\\e6cf\";\n}\n.anticon-loading:before {\n  content: \"\\e64d\";\n}\n.anticon-loading-3-quarters:before {\n  content: \"\\e6ae\";\n}\n.anticon-bulb:before {\n  content: \"\\e649\";\n}\n.anticon-select:before {\n  content: \"\\e64a\";\n}\n.anticon-addfile:before,\n.anticon-file-add:before {\n  content: \"\\e910\";\n}\n.anticon-addfolder:before,\n.anticon-folder-add:before {\n  content: \"\\e914\";\n}\n.anticon-switcher:before {\n  content: \"\\e913\";\n}\n.anticon-rocket:before {\n  content: \"\\e90f\";\n}\n.anticon-dingding:before {\n  content: \"\\e923\";\n}\n.anticon-dingding-o:before {\n  content: \"\\e925\";\n}\n.anticon-bell:before {\n  content: \"\\e64e\";\n}\n.anticon-disconnect:before {\n  content: \"\\e64f\";\n}\n.anticon-database:before {\n  content: \"\\e650\";\n}\n.anticon-compass:before {\n  content: \"\\e6db\";\n}\n.anticon-barcode:before {\n  content: \"\\e652\";\n}\n.anticon-hourglass:before {\n  content: \"\\e653\";\n}\n.anticon-key:before {\n  content: \"\\e654\";\n}\n.anticon-flag:before {\n  content: \"\\e655\";\n}\n.anticon-layout:before {\n  content: \"\\e656\";\n}\n.anticon-login:before {\n  content: \"\\e657\";\n}\n.anticon-printer:before {\n  content: \"\\e673\";\n}\n.anticon-sound:before {\n  content: \"\\e6e9\";\n}\n.anticon-usb:before {\n  content: \"\\e6d7\";\n}\n.anticon-skin:before {\n  content: \"\\e6d8\";\n}\n.anticon-tool:before {\n  content: \"\\e6d9\";\n}\n.anticon-sync:before {\n  content: \"\\e6da\";\n}\n.anticon-wifi:before {\n  content: \"\\e6d6\";\n}\n.anticon-car:before {\n  content: \"\\e6dc\";\n}\n.anticon-copyright:before {\n  content: \"\\e6de\";\n}\n.anticon-schedule:before {\n  content: \"\\e6df\";\n}\n.anticon-user-add:before {\n  content: \"\\e6ed\";\n}\n.anticon-user-delete:before {\n  content: \"\\e6e0\";\n}\n.anticon-usergroup-add:before {\n  content: \"\\e6dd\";\n}\n.anticon-usergroup-delete:before {\n  content: \"\\e6e1\";\n}\n.anticon-man:before {\n  content: \"\\e6e2\";\n}\n.anticon-woman:before {\n  content: \"\\e6ec\";\n}\n.anticon-shop:before {\n  content: \"\\e6e3\";\n}\n.anticon-gift:before {\n  content: \"\\e6e4\";\n}\n.anticon-idcard:before {\n  content: \"\\e6e5\";\n}\n.anticon-medicine-box:before {\n  content: \"\\e6e6\";\n}\n.anticon-red-envelope:before {\n  content: \"\\e6e7\";\n}\n.anticon-coffee:before {\n  content: \"\\e6e8\";\n}\n.anticon-trademark:before {\n  content: \"\\e651\";\n}\n.anticon-safety:before {\n  content: \"\\e6ea\";\n}\n.anticon-wallet:before {\n  content: \"\\e6eb\";\n}\n.anticon-bank:before {\n  content: \"\\e6ee\";\n}\n.anticon-trophy:before {\n  content: \"\\e6ef\";\n}\n.anticon-contacts:before {\n  content: \"\\e6f0\";\n}\n.anticon-global:before {\n  content: \"\\e6f1\";\n}\n.anticon-shake:before {\n  content: \"\\e94f\";\n}\n.anticon-fork:before {\n  content: \"\\e6f2\";\n}\n.anticon-spin:before {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.fade-enter,\n.fade-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.fade-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.fade-enter.fade-enter-active,\n.fade-appear.fade-appear-active {\n  animation-name: antFadeIn;\n  animation-play-state: running;\n}\n.fade-leave.fade-leave-active {\n  animation-name: antFadeOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.fade-enter,\n.fade-appear {\n  opacity: 0;\n  animation-timing-function: linear;\n}\n.fade-leave {\n  animation-timing-function: linear;\n}\n@keyframes antFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes antFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.move-up-enter,\n.move-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-up-enter.move-up-enter-active,\n.move-up-appear.move-up-appear-active {\n  animation-name: antMoveUpIn;\n  animation-play-state: running;\n}\n.move-up-leave.move-up-leave-active {\n  animation-name: antMoveUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-up-enter,\n.move-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-up-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-down-enter,\n.move-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-down-enter.move-down-enter-active,\n.move-down-appear.move-down-appear-active {\n  animation-name: antMoveDownIn;\n  animation-play-state: running;\n}\n.move-down-leave.move-down-leave-active {\n  animation-name: antMoveDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-down-enter,\n.move-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-down-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-left-enter,\n.move-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-left-enter.move-left-enter-active,\n.move-left-appear.move-left-appear-active {\n  animation-name: antMoveLeftIn;\n  animation-play-state: running;\n}\n.move-left-leave.move-left-leave-active {\n  animation-name: antMoveLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-left-enter,\n.move-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-left-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n.move-right-enter,\n.move-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.move-right-enter.move-right-enter-active,\n.move-right-appear.move-right-appear-active {\n  animation-name: antMoveRightIn;\n  animation-play-state: running;\n}\n.move-right-leave.move-right-leave-active {\n  animation-name: antMoveRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.move-right-enter,\n.move-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.move-right-leave {\n  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n}\n@keyframes antMoveDownIn {\n  0% {\n    transform-origin: 0 0;\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  100% {\n    transform-origin: 0 0;\n    transform: translateY(0%);\n    opacity: 1;\n  }\n}\n@keyframes antMoveDownOut {\n  0% {\n    transform-origin: 0 0;\n    transform: translateY(0%);\n    opacity: 1;\n  }\n  100% {\n    transform-origin: 0 0;\n    transform: translateY(100%);\n    opacity: 0;\n  }\n}\n@keyframes antMoveLeftIn {\n  0% {\n    transform-origin: 0 0;\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  100% {\n    transform-origin: 0 0;\n    transform: translateX(0%);\n    opacity: 1;\n  }\n}\n@keyframes antMoveLeftOut {\n  0% {\n    transform-origin: 0 0;\n    transform: translateX(0%);\n    opacity: 1;\n  }\n  100% {\n    transform-origin: 0 0;\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n}\n@keyframes antMoveRightIn {\n  0% {\n    opacity: 0;\n    transform-origin: 0 0;\n    transform: translateX(100%);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 0 0;\n    transform: translateX(0%);\n  }\n}\n@keyframes antMoveRightOut {\n  0% {\n    transform-origin: 0 0;\n    transform: translateX(0%);\n    opacity: 1;\n  }\n  100% {\n    transform-origin: 0 0;\n    transform: translateX(100%);\n    opacity: 0;\n  }\n}\n@keyframes antMoveUpIn {\n  0% {\n    transform-origin: 0 0;\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n  100% {\n    transform-origin: 0 0;\n    transform: translateY(0%);\n    opacity: 1;\n  }\n}\n@keyframes antMoveUpOut {\n  0% {\n    transform-origin: 0 0;\n    transform: translateY(0%);\n    opacity: 1;\n  }\n  100% {\n    transform-origin: 0 0;\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n}\n@keyframes loadingCircle {\n  0% {\n    transform-origin: 50% 50%;\n    transform: rotate(0deg);\n  }\n  100% {\n    transform-origin: 50% 50%;\n    transform: rotate(360deg);\n  }\n}\n.slide-up-enter,\n.slide-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-up-enter.slide-up-enter-active,\n.slide-up-appear.slide-up-appear-active {\n  animation-name: antSlideUpIn;\n  animation-play-state: running;\n}\n.slide-up-leave.slide-up-leave-active {\n  animation-name: antSlideUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-up-enter,\n.slide-up-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-up-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-down-enter,\n.slide-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-down-enter.slide-down-enter-active,\n.slide-down-appear.slide-down-appear-active {\n  animation-name: antSlideDownIn;\n  animation-play-state: running;\n}\n.slide-down-leave.slide-down-leave-active {\n  animation-name: antSlideDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-down-enter,\n.slide-down-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-left-enter,\n.slide-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-left-enter.slide-left-enter-active,\n.slide-left-appear.slide-left-appear-active {\n  animation-name: antSlideLeftIn;\n  animation-play-state: running;\n}\n.slide-left-leave.slide-left-leave-active {\n  animation-name: antSlideLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-left-enter,\n.slide-left-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-left-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n.slide-right-enter,\n.slide-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.slide-right-enter.slide-right-enter-active,\n.slide-right-appear.slide-right-appear-active {\n  animation-name: antSlideRightIn;\n  animation-play-state: running;\n}\n.slide-right-leave.slide-right-leave-active {\n  animation-name: antSlideRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.slide-right-enter,\n.slide-right-appear {\n  opacity: 0;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.slide-right-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@keyframes antSlideUpIn {\n  0% {\n    opacity: 0;\n    transform-origin: 0% 0%;\n    transform: scaleY(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 0% 0%;\n    transform: scaleY(1);\n  }\n}\n@keyframes antSlideUpOut {\n  0% {\n    opacity: 1;\n    transform-origin: 0% 0%;\n    transform: scaleY(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 0% 0%;\n    transform: scaleY(0.8);\n  }\n}\n@keyframes antSlideDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 100% 100%;\n    transform: scaleY(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 100% 100%;\n    transform: scaleY(1);\n  }\n}\n@keyframes antSlideDownOut {\n  0% {\n    opacity: 1;\n    transform-origin: 100% 100%;\n    transform: scaleY(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 100% 100%;\n    transform: scaleY(0.8);\n  }\n}\n@keyframes antSlideLeftIn {\n  0% {\n    opacity: 0;\n    transform-origin: 0% 0%;\n    transform: scaleX(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 0% 0%;\n    transform: scaleX(1);\n  }\n}\n@keyframes antSlideLeftOut {\n  0% {\n    opacity: 1;\n    transform-origin: 0% 0%;\n    transform: scaleX(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 0% 0%;\n    transform: scaleX(0.8);\n  }\n}\n@keyframes antSlideRightIn {\n  0% {\n    opacity: 0;\n    transform-origin: 100% 0%;\n    transform: scaleX(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 100% 0%;\n    transform: scaleX(1);\n  }\n}\n@keyframes antSlideRightOut {\n  0% {\n    opacity: 1;\n    transform-origin: 100% 0%;\n    transform: scaleX(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 100% 0%;\n    transform: scaleX(0.8);\n  }\n}\n.swing-enter,\n.swing-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.swing-enter.swing-enter-active,\n.swing-appear.swing-appear-active {\n  animation-name: antSwingIn;\n  animation-play-state: running;\n}\n@keyframes antSwingIn {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  20% {\n    transform: translateX(-10px);\n  }\n  40% {\n    transform: translateX(10px);\n  }\n  60% {\n    transform: translateX(-5px);\n  }\n  80% {\n    transform: translateX(5px);\n  }\n}\n.zoom-enter,\n.zoom-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-enter.zoom-enter-active,\n.zoom-appear.zoom-appear-active {\n  animation-name: antZoomIn;\n  animation-play-state: running;\n}\n.zoom-leave.zoom-leave-active {\n  animation-name: antZoomOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-enter,\n.zoom-appear {\n  transform: scale(0);\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-enter.zoom-big-enter-active,\n.zoom-big-appear.zoom-big-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.zoom-big-leave.zoom-big-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-enter,\n.zoom-big-appear {\n  transform: scale(0);\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-fast-leave {\n  animation-duration: 0.1s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-big-fast-enter.zoom-big-fast-enter-active,\n.zoom-big-fast-appear.zoom-big-fast-appear-active {\n  animation-name: antZoomBigIn;\n  animation-play-state: running;\n}\n.zoom-big-fast-leave.zoom-big-fast-leave-active {\n  animation-name: antZoomBigOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-big-fast-enter,\n.zoom-big-fast-appear {\n  transform: scale(0);\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-big-fast-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-up-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-up-enter.zoom-up-enter-active,\n.zoom-up-appear.zoom-up-appear-active {\n  animation-name: antZoomUpIn;\n  animation-play-state: running;\n}\n.zoom-up-leave.zoom-up-leave-active {\n  animation-name: antZoomUpOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-up-enter,\n.zoom-up-appear {\n  transform: scale(0);\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-up-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-down-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-down-enter.zoom-down-enter-active,\n.zoom-down-appear.zoom-down-appear-active {\n  animation-name: antZoomDownIn;\n  animation-play-state: running;\n}\n.zoom-down-leave.zoom-down-leave-active {\n  animation-name: antZoomDownOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-down-enter,\n.zoom-down-appear {\n  transform: scale(0);\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-left-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-left-enter.zoom-left-enter-active,\n.zoom-left-appear.zoom-left-appear-active {\n  animation-name: antZoomLeftIn;\n  animation-play-state: running;\n}\n.zoom-left-leave.zoom-left-leave-active {\n  animation-name: antZoomLeftOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-left-enter,\n.zoom-left-appear {\n  transform: scale(0);\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-left-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-right-leave {\n  animation-duration: 0.2s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.zoom-right-enter.zoom-right-enter-active,\n.zoom-right-appear.zoom-right-appear-active {\n  animation-name: antZoomRightIn;\n  animation-play-state: running;\n}\n.zoom-right-leave.zoom-right-leave-active {\n  animation-name: antZoomRightOut;\n  animation-play-state: running;\n  pointer-events: none;\n}\n.zoom-right-enter,\n.zoom-right-appear {\n  transform: scale(0);\n  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n}\n.zoom-right-leave {\n  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n@keyframes antZoomIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.2);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes antZoomOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.2);\n  }\n}\n@keyframes antZoomBigIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes antZoomBigOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n}\n@keyframes antZoomUpIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 0%;\n    transform: scale(0.8);\n  }\n  100% {\n    transform-origin: 50% 0%;\n    transform: scale(1);\n  }\n}\n@keyframes antZoomUpOut {\n  0% {\n    transform-origin: 50% 0%;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 0%;\n    transform: scale(0.8);\n  }\n}\n@keyframes antZoomLeftIn {\n  0% {\n    opacity: 0;\n    transform-origin: 0% 50%;\n    transform: scale(0.8);\n  }\n  100% {\n    transform-origin: 0% 50%;\n    transform: scale(1);\n  }\n}\n@keyframes antZoomLeftOut {\n  0% {\n    transform-origin: 0% 50%;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 0% 50%;\n    transform: scale(0.8);\n  }\n}\n@keyframes antZoomRightIn {\n  0% {\n    opacity: 0;\n    transform-origin: 100% 50%;\n    transform: scale(0.8);\n  }\n  100% {\n    transform-origin: 100% 50%;\n    transform: scale(1);\n  }\n}\n@keyframes antZoomRightOut {\n  0% {\n    transform-origin: 100% 50%;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 100% 50%;\n    transform: scale(0.8);\n  }\n}\n@keyframes antZoomDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0.8);\n  }\n  100% {\n    transform-origin: 50% 100%;\n    transform: scale(1);\n  }\n}\n@keyframes antZoomDownOut {\n  0% {\n    transform-origin: 50% 100%;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0.8);\n  }\n}\n.ant-motion-collapse {\n  overflow: hidden;\n}\n.ant-motion-collapse-active {\n  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n",
                    "/**\n * Global styles for all components (NOTE: antd's global style is at components/style)\n */\n.nz-overlay-container {\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 1000;\n}\n.nz-overlay-backdrop {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  -webkit-tap-highlight-color: transparent;\n  transition: opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  opacity: 0;\n  position: absolute;\n  pointer-events: auto;\n  z-index: 1000;\n}\n.nz-overlay-pane {\n  position: absolute;\n  pointer-events: auto;\n  z-index: 1000;\n}\n",
                ],
                encapsulation: ViewEncapsulation.None,
            },] },
];
/**
 * @nocollapse
 */
NzRootStyleComponent.ctorParameters = function () { return []; };
var NzRootModule = (function () {
    /**
     * @param {?} _document
     * @param {?} injector
     * @param {?} resolver
     */
    function NzRootModule(_document, injector, resolver) {
        var componentFactory = resolver.resolveComponentFactory(NzRootStyleComponent);
        var div = _document.createElement('div');
        this.styleHostComponent = componentFactory.create(injector, null, div);
    }
    /**
     * @return {?}
     */
    NzRootModule.prototype.ngOnDestroy = function () {
        this.styleHostComponent.destroy();
    };
    return NzRootModule;
}());
NzRootModule.decorators = [
    { type: NgModule, args: [{
                exports: [NzRootComponent],
                declarations: [NzRootComponent, NzRootStyleComponent],
                imports: [CommonModule],
                entryComponents: [NzRootStyleComponent],
                providers: [
                    { provide: APP_INITIALIZER, multi: true, useFactory: createNzRootInitializer, deps: [DOCUMENT, [new Optional(), NZ_ROOT_CONFIG]] },
                ],
            },] },
];
/**
 * @nocollapse
 */
NzRootModule.ctorParameters = function () { return [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
    { type: Injector, },
    { type: ComponentFactoryResolver, },
]; };
var NzCarouselContentDirective = (function () {
    /**
     * @param {?} _el
     */
    function NzCarouselContentDirective(_el) {
        this._el = _el;
        this.width = 0;
        this.isActive = false;
        this.left = null;
        this.top = null;
        this.fadeMode = false;
        this._nzSlickSlide = true;
        this.nativeElement = this._el.nativeElement;
    }
    Object.defineProperty(NzCarouselContentDirective.prototype, "setActiveClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isActive === true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCarouselContentDirective.prototype, "setWidth", {
        /**
         * @return {?}
         */
        get: function () {
            return this.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCarouselContentDirective.prototype, "setLeft", {
        /**
         * @return {?}
         */
        get: function () {
            return this.left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCarouselContentDirective.prototype, "setTop", {
        /**
         * @return {?}
         */
        get: function () {
            return this.top;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCarouselContentDirective.prototype, "setPosition", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.fadeMode) {
                return 'relative';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NzCarouselContentDirective.prototype, "setOpacity", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.fadeMode) {
                return this.isActive ? 1 : 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    return NzCarouselContentDirective;
}());
NzCarouselContentDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-carousel-content]',
            },] },
];
/**
 * @nocollapse
 */
NzCarouselContentDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NzCarouselContentDirective.propDecorators = {
    '_nzSlickSlide': [{ type: HostBinding, args: ['class.slick-slide',] },],
    'setActiveClass': [{ type: HostBinding, args: ['class.slick-active',] },],
    'setWidth': [{ type: HostBinding, args: ['style.width.px',] },],
    'setLeft': [{ type: HostBinding, args: ['style.left.px',] },],
    'setTop': [{ type: HostBinding, args: ['style.top.px',] },],
    'setPosition': [{ type: HostBinding, args: ['style.position',] },],
    'setOpacity': [{ type: HostBinding, args: ['style.opacity',] },],
};
var NzCarouselComponent = (function () {
    /**
     * @param {?} hostElement
     * @param {?} _renderer
     */
    function NzCarouselComponent(hostElement, _renderer) {
        this.hostElement = hostElement;
        this._renderer = _renderer;
        this.activeIndex = 0;
        this.transform = 'translate3d(0px, 0px, 0px)';
        this.nzAutoPlay = false;
        this.nzDots = true;
        this.nzEffect = 'scrollx';
        this.nzVertical = false;
        this._nzCarousel = true;
    }
    Object.defineProperty(NzCarouselComponent.prototype, "_slideContents", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.slideContents = value;
            this.renderContent();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} content
     * @param {?} i
     * @return {?}
     */
    NzCarouselComponent.prototype.setActive = function (content, i) {
        if (this.nzAutoPlay) {
            this.createInterval();
        }
        this.activeIndex = i;
        if (this.nzEffect !== 'fade') {
            if (!this.nzVertical) {
                this.transform = "translate3d(" + -this.activeIndex * this.hostElement.nativeElement.offsetWidth + "px, 0px, 0px)";
            }
            else {
                this.transform = "translate3d(0px, " + -this.activeIndex * this.hostElement.nativeElement.offsetHeight + "px, 0px)";
            }
        }
        this.slideContents.forEach(function (slide) {
            slide.isActive = false;
        });
        content.isActive = true;
    };
    /**
     * @return {?}
     */
    NzCarouselComponent.prototype.ngAfterViewInit = function () {
        this.renderContent();
    };
    /**
     * @return {?}
     */
    NzCarouselComponent.prototype.renderContent = function () {
        var _this = this;
        setTimeout(function (_) {
            if (_this.slideContents.first) {
                _this.slideContents.first.isActive = true;
            }
            _this.slideContents.forEach(function (content, i) {
                content.width = _this.hostElement.nativeElement.offsetWidth;
                if (_this.nzEffect === 'fade') {
                    content.fadeMode = true;
                    if (!_this.nzVertical) {
                        content.left = -i * content.width;
                    }
                    else {
                        content.top = -i * _this.hostElement.nativeElement.offsetHeight;
                    }
                }
            });
            if (_this.nzAutoPlay) {
                _this.createInterval();
            }
            if (_this.nzVertical) {
                _this._renderer.removeStyle(_this.slickList.nativeElement, 'height');
                if (_this.slideContents.first) {
                    _this._renderer.setStyle(_this.slickList.nativeElement, 'height', _this.slideContents.first.nativeElement.offsetHeight + "px");
                }
                _this._renderer.removeStyle(_this.slickTrack.nativeElement, 'height');
                _this._renderer.setStyle(_this.slickTrack.nativeElement, 'height', _this.slideContents.length * _this.hostElement.nativeElement.offsetHeight + "px");
            }
            else {
                _this._renderer.removeStyle(_this.slickTrack.nativeElement, 'width');
                _this._renderer.setStyle(_this.slickTrack.nativeElement, 'width', _this.slideContents.length * _this.hostElement.nativeElement.offsetWidth + "px");
            }
        });
    };
    /**
     * @return {?}
     */
    NzCarouselComponent.prototype.createInterval = function () {
        var _this = this;
        this.clearInterval();
        this.interval = setInterval(function (_) {
            if (_this.activeIndex < _this.slideContents.length - 1) {
                _this.activeIndex++;
            }
            else {
                _this.activeIndex = 0;
            }
            _this.setActive(_this.slideContents.toArray()[_this.activeIndex], _this.activeIndex);
        }, 3000);
    };
    /**
     * @return {?}
     */
    NzCarouselComponent.prototype.clearInterval = function () {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    };
    /**
     * @return {?}
     */
    NzCarouselComponent.prototype.ngOnDestroy = function () {
        this.clearInterval();
    };
    return NzCarouselComponent;
}());
NzCarouselComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-carousel',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"slick-initialized slick-slider\" [class.slick-vertical]=\"nzVertical\">\n      <div class=\"slick-list\" #slickList>\n        <div class=\"slick-track\" style=\"opacity: 1;\" [style.transform]=\"transform\" #slickTrack>\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <ul class=\"slick-dots\" style=\"display: block;\" *ngIf=\"nzDots\">\n        <li [class.slick-active]=\"content.isActive\" *ngFor=\"let content of slideContents; let i =index\" (click)=\"setActive(content,i)\">\n          <button>1</button>\n        </li>\n      </ul>\n    </div>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-carousel .slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n.ant-carousel .slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.ant-carousel .slick-list:focus {\n  outline: none;\n}\n.ant-carousel .slick-list.dragging {\n  cursor: pointer;\n}\n.ant-carousel .slick-slider .slick-track,\n.ant-carousel .slick-slider .slick-list {\n  transform: translate3d(0, 0, 0);\n}\n.ant-carousel .slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n}\n.ant-carousel .slick-track:before,\n.ant-carousel .slick-track:after {\n  content: \"\";\n  display: table;\n}\n.ant-carousel .slick-track:after {\n  clear: both;\n}\n.slick-loading .ant-carousel .slick-track {\n  visibility: hidden;\n}\n.ant-carousel .slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  display: none;\n}\n[dir=\"rtl\"] .ant-carousel .slick-slide {\n  float: right;\n}\n.ant-carousel .slick-slide img {\n  display: block;\n}\n.ant-carousel .slick-slide.slick-loading img {\n  display: none;\n}\n.ant-carousel .slick-slide.dragging img {\n  pointer-events: none;\n}\n.ant-carousel .slick-initialized .slick-slide {\n  display: block;\n}\n.ant-carousel .slick-loading .slick-slide {\n  visibility: hidden;\n}\n.ant-carousel .slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n.ant-carousel .slick-arrow.slick-hidden {\n  display: none;\n}\n.ant-carousel .slick-prev,\n.ant-carousel .slick-next {\n  position: absolute;\n  display: block;\n  height: 20px;\n  width: 20px;\n  line-height: 0;\n  font-size: 0;\n  cursor: pointer;\n  background: transparent;\n  color: transparent;\n  top: 50%;\n  margin-top: -10px;\n  padding: 0;\n  border: 0;\n  outline: none;\n}\n.ant-carousel .slick-prev:hover,\n.ant-carousel .slick-next:hover,\n.ant-carousel .slick-prev:focus,\n.ant-carousel .slick-next:focus {\n  outline: none;\n  background: transparent;\n  color: transparent;\n}\n.ant-carousel .slick-prev:hover:before,\n.ant-carousel .slick-next:hover:before,\n.ant-carousel .slick-prev:focus:before,\n.ant-carousel .slick-next:focus:before {\n  opacity: 1;\n}\n.ant-carousel .slick-prev.slick-disabled:before,\n.ant-carousel .slick-next.slick-disabled:before {\n  opacity: 0.25;\n}\n.ant-carousel .slick-prev {\n  left: -25px;\n}\n.ant-carousel .slick-prev:before {\n  content: \"\u2190\";\n}\n.ant-carousel .slick-next {\n  right: -25px;\n}\n.ant-carousel .slick-next:before {\n  content: \"\u2192\";\n}\n.ant-carousel .slick-dots {\n  position: absolute;\n  bottom: 12px;\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n}\n.ant-carousel .slick-dots li {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  text-align: center;\n  margin: 0 2px;\n  padding: 0;\n}\n.ant-carousel .slick-dots li button {\n  border: 0;\n  cursor: pointer;\n  background: #fff;\n  opacity: 0.3;\n  display: block;\n  width: 16px;\n  height: 3px;\n  border-radius: 1px;\n  outline: none;\n  font-size: 0;\n  color: transparent;\n  transition: all .5s;\n}\n.ant-carousel .slick-dots li button:hover,\n.ant-carousel .slick-dots li button:focus {\n  opacity: 0.75;\n}\n.ant-carousel .slick-dots li.slick-active button {\n  background: #fff;\n  opacity: 1;\n  width: 24px;\n}\n.ant-carousel .slick-dots li.slick-active button:hover,\n.ant-carousel .slick-dots li.slick-active button:focus {\n  opacity: 1;\n}\n.ant-carousel-vertical .slick-dots {\n  width: 3px;\n  bottom: auto;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  height: auto;\n}\n.ant-carousel-vertical .slick-dots li {\n  margin: 0 2px;\n  vertical-align: baseline;\n}\n.ant-carousel-vertical .slick-dots li button {\n  width: 3px;\n  height: 16px;\n}\n.ant-carousel-vertical .slick-dots li.slick-active button {\n  width: 3px;\n  height: 24px;\n}\n",
                    "nz-carousel {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\nnz-carousel .slick-track {\n  transition: all 0.5s ease;\n}\nnz-carousel .slick-track .slick-slide {\n  transition: opacity 500ms ease;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCarouselComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzCarouselComponent.propDecorators = {
    '_slideContents': [{ type: ContentChildren, args: [NzCarouselContentDirective,] },],
    'slickList': [{ type: ViewChild, args: ['slickList',] },],
    'slickTrack': [{ type: ViewChild, args: ['slickTrack',] },],
    'nzAutoPlay': [{ type: Input },],
    'nzDots': [{ type: Input },],
    'nzEffect': [{ type: Input },],
    'nzVertical': [{ type: Input }, { type: HostBinding, args: ['class.ant-carousel-vertical',] },],
    '_nzCarousel': [{ type: HostBinding, args: ['class.ant-carousel',] },],
};
var NzCarouselModule = (function () {
    function NzCarouselModule() {
    }
    return NzCarouselModule;
}());
NzCarouselModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzCarouselComponent, NzCarouselContentDirective],
                exports: [NzCarouselComponent, NzCarouselContentDirective],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzCarouselModule.ctorParameters = function () { return []; };
var NzCardComponent = (function () {
    function NzCardComponent() {
        this.nzBordered = true;
        this.nzLoading = false;
        this.nzNoHovering = false;
        this._nzCard = true;
    }
    return NzCardComponent;
}());
NzCardComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-card',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"ant-card-head\" *ngIf=\"title\">\n      <h3 class=\"ant-card-head-title\">\n        <ng-template\n          [ngTemplateOutlet]=\"title\">\n        </ng-template>\n      </h3>\n    </div>\n    <div class=\"ant-card-extra\" *ngIf=\"extra\">\n      <ng-template\n        [ngTemplateOutlet]=\"extra\">\n      </ng-template>\n    </div>\n    <div class=\"ant-card-body\">\n      <ng-template\n        *ngIf=\"!nzLoading\"\n        [ngTemplateOutlet]=\"body\">\n      </ng-template>\n      <div *ngIf=\"nzLoading\">\n        <p class=\"ant-card-loading-block\" style=\"width: 94%;\"></p>\n        <p>\n          <span class=\"ant-card-loading-block\" style=\"width: 28%;\"></span><span class=\"ant-card-loading-block\" style=\"width: 62%;\"></span>\n        </p>\n        <p>\n          <span class=\"ant-card-loading-block\" style=\"width: 22%;\"></span><span class=\"ant-card-loading-block\" style=\"width: 66%;\"></span>\n        </p>\n        <p>\n          <span class=\"ant-card-loading-block\" style=\"width: 56%;\"></span><span class=\"ant-card-loading-block\" style=\"width: 39%;\"></span>\n        </p>\n        <p>\n          <span class=\"ant-card-loading-block\" style=\"width: 21%;\"></span><span class=\"ant-card-loading-block\" style=\"width: 15%;\"></span><span class=\"ant-card-loading-block\" style=\"width: 40%;\"></span>\n        </p>\n      </div>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-card {\n  background: #fff;\n  border-radius: 2px;\n  font-size: 12px;\n  position: relative;\n  transition: all .3s;\n}\n.ant-card:not(.ant-card-no-hovering):hover {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  border-color: transparent;\n}\n.ant-card-bordered {\n  border: 1px solid #e9e9e9;\n}\n.ant-card-head {\n  height: 48px;\n  line-height: 48px;\n  background: #fff;\n  border-bottom: 1px solid #e9e9e9;\n  padding: 0 24px;\n  border-radius: 2px 2px 0 0;\n}\n.ant-card-head-title {\n  font-size: 14px;\n  display: inline-block;\n  text-overflow: ellipsis;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n}\n.ant-card-extra {\n  position: absolute;\n  right: 24px;\n  top: 14px;\n}\n.ant-card-body {\n  padding: 24px;\n  zoom: 1;\n}\n.ant-card-body:before,\n.ant-card-body:after {\n  content: \" \";\n  display: table;\n}\n.ant-card-body:after {\n  clear: both;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n}\n.ant-card-loading .ant-card-body {\n  user-select: none;\n  padding: 0;\n}\n.ant-card-loading-content {\n  padding: 24px;\n}\n.ant-card-loading-block {\n  display: inline-block;\n  margin: 5px 1% 0;\n  height: 14px;\n  border-radius: 2px;\n  background: linear-gradient(90deg, rgba(207, 216, 220, 0.2), rgba(207, 216, 220, 0.4), rgba(207, 216, 220, 0.2));\n  animation: card-loading 1.4s ease infinite;\n  background-size: 600% 600%;\n}\n.ant-card-contain-grid .ant-card-body {\n  margin: -0.5px;\n  padding: 0;\n}\n.ant-card-grid {\n  border-radius: 0;\n  border: 0;\n  box-shadow: 0 0 0 0.5px #e9e9e9, 0 0 0 0.5px #e9e9e9 inset;\n  width: 33.33%;\n  float: left;\n  padding: 24px;\n  transition: all .3s;\n}\n.ant-card-grid:hover {\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n}\n.ant-card-wider-padding .ant-card-head {\n  padding: 0 32px;\n}\n.ant-card-wider-padding .ant-card-body {\n  padding: 24px 32px;\n}\n.ant-card-wider-padding .ant-card-extra {\n  right: 32px;\n}\n.ant-card-padding-transition .ant-card-head,\n.ant-card-padding-transition .ant-card-body {\n  transition: padding .3s;\n}\n.ant-card-padding-transition .ant-card-extra {\n  transition: right .3s;\n}\n@keyframes card-loading {\n  0%,\n  100% {\n    background-position: 0 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n",
                    "nz-card {\n  display: block;\n  position: relative;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCardComponent.ctorParameters = function () { return []; };
NzCardComponent.propDecorators = {
    'nzBordered': [{ type: Input }, { type: HostBinding, args: ['class.ant-card-bordered',] },],
    'nzLoading': [{ type: Input },],
    'nzNoHovering': [{ type: Input }, { type: HostBinding, args: ['class.ant-card-no-hovering',] },],
    'title': [{ type: ContentChild, args: ['title',] },],
    'extra': [{ type: ContentChild, args: ['extra',] },],
    'body': [{ type: ContentChild, args: ['body',] },],
    '_nzCard': [{ type: HostBinding, args: ['class.ant-card',] },],
};
var NzCardGridDirective = (function () {
    function NzCardGridDirective() {
        this._nzCardGrid = true;
    }
    return NzCardGridDirective;
}());
NzCardGridDirective.decorators = [
    { type: Directive, args: [{
                selector: '[nz-card-grid]'
            },] },
];
/**
 * @nocollapse
 */
NzCardGridDirective.ctorParameters = function () { return []; };
NzCardGridDirective.propDecorators = {
    '_nzCardGrid': [{ type: HostBinding, args: ['class.ant-card-grid',] },],
};
var NzCardModule = (function () {
    function NzCardModule() {
    }
    return NzCardModule;
}());
NzCardModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [NzCardComponent, NzCardGridDirective],
                exports: [NzCardComponent, NzCardGridDirective]
            },] },
];
/**
 * @nocollapse
 */
NzCardModule.ctorParameters = function () { return []; };
var NzCollapsesetComponent = (function () {
    function NzCollapsesetComponent() {
        /**
         * all child collapse
         */
        this.panels = [];
        this.nzAccordion = false;
        this.nzBordered = true;
    }
    /**
     * @param {?} collapse
     * @return {?}
     */
    NzCollapsesetComponent.prototype.nzClick = function (collapse) {
        var _this = this;
        if (this.nzAccordion) {
            this.panels.map(function (item, index) {
                var /** @type {?} */ curIndex = _this.panels.indexOf(collapse);
                if (index !== curIndex) {
                    item.nzActive = false;
                }
            });
        }
    };
    /**
     * @param {?} collapse
     * @return {?}
     */
    NzCollapsesetComponent.prototype.addTab = function (collapse) {
        this.panels.push(collapse);
    };
    return NzCollapsesetComponent;
}());
NzCollapsesetComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-collapseset',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <div class=\"ant-collapse\" [class.ant-collapse-borderless]=\"!nzBordered\">\n      <ng-content></ng-content>\n    </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-collapse {\n  background-color: #f7f7f7;\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  border-bottom: 0;\n}\n.ant-collapse > .ant-collapse-item {\n  border-bottom: 1px solid #d9d9d9;\n}\n.ant-collapse > .ant-collapse-item:last-child,\n.ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {\n  border-radius: 0 0 4px 4px;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  line-height: 22px;\n  padding: 8px 0 8px 32px;\n  color: rgba(0, 0, 0, 0.85);\n  cursor: pointer;\n  position: relative;\n  transition: all .3s;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {\n  font-size: 12px;\n  font-size: 9px 9;\n  transform: scale(0.75) rotate(0);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)\";\n  zoom: 1;\n  font-style: normal;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  line-height: 1;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  color: rgba(0, 0, 0, 0.43);\n  display: inline-block;\n  font-weight: bold;\n  line-height: 40px;\n  vertical-align: middle;\n  transition: transform 0.24s;\n  top: 0;\n  left: 16px;\n}\n:root .ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {\n  filter: none;\n}\n:root .ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {\n  font-size: 12px;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow:before {\n  display: block;\n  font-family: \"anticon\" !important;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow:before {\n  content: \"\\E61F\";\n}\n.ant-collapse-anim-active {\n  transition: height 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.ant-collapse-content {\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.65);\n  padding: 0 16px;\n  background-color: #fff;\n}\n.ant-collapse-content > .ant-collapse-content-box {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.ant-collapse-content-inactive {\n  display: none;\n}\n.ant-collapse-item:last-child > .ant-collapse-content {\n  border-radius: 0 0 4px 4px;\n}\n.ant-collapse > .ant-collapse-item > .ant-collapse-header[aria-expanded=\"true\"] .arrow {\n  display: inline-block;\n  font-size: 12px;\n  font-size: 9px 9;\n  transform: scale(0.75) rotate(90deg);\n  /* IE6-IE8 */\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=0.00000000000000006123, M12=-1, M21=1, M22=0.00000000000000006123)\";\n  zoom: 1;\n}\n:root .ant-collapse > .ant-collapse-item > .ant-collapse-header[aria-expanded=\"true\"] .arrow {\n  filter: none;\n}\n:root .ant-collapse > .ant-collapse-item > .ant-collapse-header[aria-expanded=\"true\"] .arrow {\n  font-size: 12px;\n}\n.ant-collapse-borderless {\n  background-color: #fff;\n  border: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item-active {\n  border: 0;\n}\n.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content {\n  background-color: transparent;\n  border-top: 1px solid #d9d9d9;\n}\n.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-header {\n  transition: all .3s;\n}\n.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-header:hover {\n  background-color: #f7f7f7;\n}\n.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,\n.ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {\n  cursor: not-allowed;\n  color: rgba(0, 0, 0, 0.25);\n  background-color: #f7f7f7;\n}\n.ant-collapse > .ant-collapse-item:not(.ant-collapse-item-disabled) > .ant-collapse-header:active {\n  background-color: #eee;\n}\n",
                    "nz-collapse {\n  display: block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCollapsesetComponent.ctorParameters = function () { return []; };
NzCollapsesetComponent.propDecorators = {
    'nzAccordion': [{ type: Input },],
    'nzBordered': [{ type: Input },],
};
var NzCollapseComponent = (function () {
    /**
     * @param {?} _collapseSet
     * @param {?} _elementRef
     */
    function NzCollapseComponent(_collapseSet, _elementRef) {
        this._collapseSet = _collapseSet;
        this._elementRef = _elementRef;
        this._nzCollapseItem = true;
        this.nzDisabled = false;
        this._el = this._elementRef.nativeElement;
        this._collapseSet.addTab(this);
    }
    Object.defineProperty(NzCollapseComponent.prototype, "nzActive", {
        /**
         * @return {?}
         */
        get: function () {
            return this._active;
        },
        /**
         * @param {?} active
         * @return {?}
         */
        set: function (active) {
            if (this._active === active) {
                return;
            }
            if (!this.nzDisabled) {
                this._active = active;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} $event
     * @return {?}
     */
    NzCollapseComponent.prototype.clickHeader = function ($event) {
        this.nzActive = !this.nzActive;
        /** trigger host collapseSet click event */
        this._collapseSet.nzClick(this);
    };
    return NzCollapseComponent;
}());
NzCollapseComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-collapse',
                template: "\n    <div class=\"ant-collapse-header\" [attr.aria-expanded]=\"_active\" (click)=\"clickHeader($event)\" role=\"tab\">\n      <i class=\"arrow\"></i>\n      <ng-template [ngIf]=\"nzTitle\">\n        {{ nzTitle }}\n      </ng-template>\n      <ng-template [ngIf]=\"!nzTitle\">\n        <ng-content select=\"[collapse-title]\"></ng-content>\n      </ng-template>\n    </div>\n    <div class=\"ant-collapse-content\" [@collapseState]=\"_active?'active':'inactive'\">\n      <div class=\"ant-collapse-content-box\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  ",
                animations: [
                    trigger('collapseState', [
                        state('inactive', style({
                            opacity: '0',
                            height: 0
                        })),
                        state('active', style({
                            opacity: '1',
                            height: '*'
                        })),
                        transition('inactive => active', animate('150ms ease-in')),
                        transition('active => inactive', animate('150ms ease-out'))
                    ])
                ]
            },] },
];
/**
 * @nocollapse
 */
NzCollapseComponent.ctorParameters = function () { return [
    { type: NzCollapsesetComponent, decorators: [{ type: Host },] },
    { type: ElementRef, },
]; };
NzCollapseComponent.propDecorators = {
    '_nzCollapseItem': [{ type: HostBinding, args: ['class.ant-collapse-item',] },],
    'nzTitle': [{ type: Input },],
    'nzDisabled': [{ type: Input }, { type: HostBinding, args: ['class.ant-collapse-item-disabled',] },],
    'nzActive': [{ type: Input },],
};
var NZ_COLLAPSE_DIRECTIVES = [NzCollapsesetComponent, NzCollapseComponent];
var NzCollapseModule = (function () {
    function NzCollapseModule() {
    }
    return NzCollapseModule;
}());
NzCollapseModule.decorators = [
    { type: NgModule, args: [{
                declarations: NZ_COLLAPSE_DIRECTIVES,
                exports: NZ_COLLAPSE_DIRECTIVES,
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzCollapseModule.ctorParameters = function () { return []; };
var NzTimelineItemComponent = (function () {
    function NzTimelineItemComponent() {
        this.itemHeadClass = { 'ant-timeline-item-head-blue': true };
        this._color = 'blue';
        this._custom = false;
        this._lastItem = false;
    }
    Object.defineProperty(NzTimelineItemComponent.prototype, "nzColor", {
        /**
         * @return {?}
         */
        get: function () {
            return this._color;
        },
        /**
         * @param {?} color
         * @return {?}
         */
        set: function (color) {
            this._color = color;
            if (color === 'green') {
                this.itemHeadClass['ant-timeline-item-head-green'] = true;
            }
            else if (color === 'red') {
                this.itemHeadClass['ant-timeline-item-head-red'] = true;
            }
            else {
                this.itemHeadClass['ant-timeline-item-head-blue'] = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzTimelineItemComponent.prototype.ngOnInit = function () {
        if (this._customContent) {
            this._custom = true;
        }
    };
    return NzTimelineItemComponent;
}());
NzTimelineItemComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-timeline-item',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <li\n      class=\"ant-timeline-item\"\n      [class.ant-timeline-item-last]=\"_lastItem\">\n      <div class=\"ant-timeline-item-tail\"></div>\n      <div class=\"ant-timeline-item-head\"\n        [class.ant-timeline-item-head-custom]=\"_custom\"\n        [ngClass]=\"itemHeadClass\">\n        <ng-template [ngTemplateOutlet]=\"_customContent\">\n        </ng-template>\n      </div>\n      <div class=\"ant-timeline-item-content\">\n        <ng-content></ng-content>\n      </div>\n    </li>",
                styles: []
            },] },
];
/**
 * @nocollapse
 */
NzTimelineItemComponent.ctorParameters = function () { return []; };
NzTimelineItemComponent.propDecorators = {
    '_customContent': [{ type: ContentChild, args: ['custom',] },],
    'nzColor': [{ type: Input },],
};
var NzTimelineComponent = (function () {
    function NzTimelineComponent() {
        this._isPending = false;
        this.items = [];
    }
    /**
     * @return {?}
     */
    NzTimelineComponent.prototype.ngOnInit = function () {
        if (this._pendingContent) {
            this._isPending = true;
        }
    };
    /**
     * @return {?}
     */
    NzTimelineComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        setTimeout(function (_) {
            if (_this._listOfTimeline && _this._listOfTimeline.length) {
                var /** @type {?} */ listArray = _this._listOfTimeline.toArray();
                listArray[listArray.length - 1]._lastItem = true;
            }
        });
    };
    return NzTimelineComponent;
}());
NzTimelineComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-timeline',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <ul class=\"ant-timeline\" [class.ant-timeline-pending]=\"_isPending\">\n      <ng-content></ng-content>\n      <li *ngIf=\"_isPending\" class=\"ant-timeline-item ant-timeline-item-pending\">\n        <div class=\"ant-timeline-item-tail\"></div>\n        <div class=\"ant-timeline-item-head ant-timeline-item-head-blue\"></div>\n        <div class=\"ant-timeline-item-content\">\n          <ng-template [ngTemplateOutlet]=\"_pendingContent\">\n          </ng-template>\n        </div>\n      </li>\n    </ul>",
                styles: ["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.ant-timeline-item {\n  position: relative;\n  padding: 0 0 12px;\n  list-style: none;\n  margin: 0;\n}\n.ant-timeline-item-tail {\n  position: absolute;\n  left: 5px;\n  top: 0;\n  height: 100%;\n  border-left: 2px solid #e9e9e9;\n}\n.ant-timeline-item-pending .ant-timeline-item-tail {\n  display: none;\n}\n.ant-timeline-item-head {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background-color: #fff;\n  border-radius: 100px;\n  border: 2px solid transparent;\n}\n.ant-timeline-item-head-blue {\n  border-color: #108ee9;\n  color: #108ee9;\n}\n.ant-timeline-item-head-red {\n  border-color: #f04134;\n  color: #f04134;\n}\n.ant-timeline-item-head-green {\n  border-color: #00a854;\n  color: #00a854;\n}\n.ant-timeline-item-head-custom {\n  position: absolute;\n  text-align: center;\n  width: 40px;\n  left: -14px;\n  line-height: 1;\n  margin-top: 6px;\n  border: 0;\n  height: auto;\n  border-radius: 0;\n  padding: 3px 0;\n  font-size: 12px;\n  transform: translateY(-50%);\n}\n.ant-timeline-item-content {\n  padding: 0 0 10px 24px;\n  font-size: 12px;\n  position: relative;\n  top: -3px;\n}\n.ant-timeline-item-last .ant-timeline-item-tail {\n  border-left: 2px dotted #e9e9e9;\n  display: none;\n}\n.ant-timeline-item-last .ant-timeline-item-content {\n  min-height: 48px;\n}\n.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {\n  display: block;\n}\n"]
            },] },
];
/**
 * @nocollapse
 */
NzTimelineComponent.ctorParameters = function () { return []; };
NzTimelineComponent.propDecorators = {
    '_listOfTimeline': [{ type: ContentChildren, args: [NzTimelineItemComponent,] },],
    '_pendingContent': [{ type: ContentChild, args: ['pending',] },],
};
var NzTimelineModule = (function () {
    function NzTimelineModule() {
    }
    return NzTimelineModule;
}());
NzTimelineModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzTimelineItemComponent, NzTimelineComponent],
                exports: [NzTimelineItemComponent, NzTimelineComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzTimelineModule.ctorParameters = function () { return []; };
var availablePrefixs = ['moz', 'ms', 'webkit'];
/**
 * @return {?}
 */
function requestAnimationFramePolyfill() {
    var /** @type {?} */ lastTime = 0;
    return function (callback) {
        var /** @type {?} */ currTime = new Date().getTime();
        var /** @type {?} */ timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var /** @type {?} */ id = window.setTimeout(function () { callback(currTime + timeToCall); }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
    };
}
/**
 * @return {?}
 */
function getRequestAnimationFrame() {
    if (typeof window === 'undefined') {
        return function () { };
    }
    if (window.requestAnimationFrame) {
        // https://github.com/vuejs/vue/issues/4465
        return window.requestAnimationFrame.bind(window);
    }
    var /** @type {?} */ prefix = availablePrefixs.filter(function (key) { return key + "RequestAnimationFrame" in window; })[0];
    return prefix
        ? window[prefix + "RequestAnimationFrame"]
        : requestAnimationFramePolyfill();
}
var reqAnimFrame = getRequestAnimationFrame();
/**
 * @param {?} t
 * @param {?} b
 * @param {?} c
 * @param {?} d
 * @return {?}
 */
function easeInOutCubic(t, b, c, d) {
    var /** @type {?} */ cc = c - b;
    t /= d / 2;
    if (t < 1) {
        return cc / 2 * t * t * t + b;
    }
    else {
        return cc / 2 * ((t -= 2) * t * t + 2) + b;
    }
}
var NzScrollService = (function () {
    /**
     * @param {?} doc
     */
    function NzScrollService(doc) {
        this.doc = doc;
    }
    /**
     * 设置 `el` 滚动条位置
     * @param {?} el
     * @param {?=} topValue
     * @return {?}
     */
    NzScrollService.prototype.setScrollTop = function (el, topValue) {
        if (topValue === void 0) { topValue = 0; }
        if (el === window) {
            this.doc.body.scrollTop = topValue;
            this.doc.documentElement.scrollTop = topValue;
        }
        else {
            ((el)).scrollTop = topValue;
        }
    };
    /**
     * 获取 `el` 相对于视窗距离
     * @param {?} el
     * @return {?}
     */
    NzScrollService.prototype.getOffset = function (el) {
        var /** @type {?} */ ret = {
            top: 0,
            left: 0
        };
        if (!el || !el.getClientRects().length)
            return ret;
        var /** @type {?} */ rect = el.getBoundingClientRect();
        if (rect.width || rect.height) {
            var /** @type {?} */ doc = el.ownerDocument.documentElement;
            ret.top = rect.top - doc.clientTop;
            ret.left = rect.left - doc.clientLeft;
        }
        else {
            ret.top = rect.top;
            ret.left = rect.left;
        }
        return ret;
    };
    /**
     * 获取 `el` 滚动条位置
     * @param {?=} el
     * @param {?=} top
     * @return {?}
     */
    NzScrollService.prototype.getScroll = function (el, top) {
        if (top === void 0) { top = true; }
        if (!el)
            el = window;
        var /** @type {?} */ prop = top ? 'pageYOffset' : 'pageXOffset';
        var /** @type {?} */ method = top ? 'scrollTop' : 'scrollLeft';
        var /** @type {?} */ isWindow = el === window;
        var /** @type {?} */ ret = isWindow ? el[prop] : el[method];
        if (isWindow && typeof ret !== 'number')
            ret = this.doc.documentElement[method];
        return ret;
    };
    /**
     * 使用动画形式将 `el` 滚动至某位置
    
    \@param {(Element | Window)} containerEl 容器，默认 `window`
    \@param {number} [targetTopValue=0] 滚动至目标 `top` 值，默认：0，相当于顶部
    \@param {Function} [easing] 动作算法，默认：`easeInOutCubic`
    \@param {Function} [callback] 动画结束后回调
     * @param {?} containerEl
     * @param {?=} targetTopValue
     * @param {?=} easing
     * @param {?=} callback
     * @return {?}
     */
    NzScrollService.prototype.scrollTo = function (containerEl, targetTopValue, easing, callback) {
        var _this = this;
        if (targetTopValue === void 0) { targetTopValue = 0; }
        if (!containerEl)
            containerEl = window;
        var /** @type {?} */ scrollTop = this.getScroll(containerEl);
        var /** @type {?} */ startTime = Date.now();
        var /** @type {?} */ frameFunc = function () {
            var /** @type {?} */ timestamp = Date.now();
            var /** @type {?} */ time = timestamp - startTime;
            _this.setScrollTop(containerEl, (easing || easeInOutCubic)(time, scrollTop, targetTopValue, 450));
            if (time < 450) {
                reqAnimFrame(frameFunc);
            }
            else {
                if (callback)
                    callback();
            }
        };
        reqAnimFrame(frameFunc);
    };
    return NzScrollService;
}());
NzScrollService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NzScrollService.ctorParameters = function () { return [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
]; };
/**
 * @param {?} doc
 * @param {?} scrollService
 * @return {?}
 */
function SCROLL_SERVICE_PROVIDER_FACTORY(doc, scrollService) {
    return scrollService || new NzScrollService(doc);
}
var SCROLL_SERVICE_PROVIDER = {
    provide: NzScrollService,
    useFactory: SCROLL_SERVICE_PROVIDER_FACTORY,
    deps: [DOCUMENT, [new Optional(), new SkipSelf(), NzScrollService]]
};
// import { Observable } from 'rxjs/Observable';
var NzBackTopComponent = (function () {
    /**
     * @param {?} scrollSrv
     * @param {?} _renderer
     */
    function NzBackTopComponent(scrollSrv, _renderer) {
        this.scrollSrv = scrollSrv;
        this._renderer = _renderer;
        this.scroll$ = null;
        this.target = null;
        this._display = false;
        this.nzVisibilityHeight = 400;
        this.nzClick = new EventEmitter();
    }
    Object.defineProperty(NzBackTopComponent.prototype, "nzTarget", {
        /**
         * @param {?} el
         * @return {?}
         */
        set: function (el) {
            this.target = el;
            this.registerScrollEvent();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzBackTopComponent.prototype.ngOnInit = function () {
        if (!this.scroll$)
            this.registerScrollEvent();
    };
    /**
     * @return {?}
     */
    NzBackTopComponent.prototype.clickBackTop = function () {
        this.scrollSrv.scrollTo(this.getTarget(), 0);
        this.nzClick.emit(true);
    };
    /**
     * @return {?}
     */
    NzBackTopComponent.prototype.getTarget = function () {
        return this.target || window;
    };
    /**
     * @return {?}
     */
    NzBackTopComponent.prototype.handleScroll = function () {
        this._display = this.scrollSrv.getScroll(this.getTarget()) > this.nzVisibilityHeight;
    };
    /**
     * @return {?}
     */
    NzBackTopComponent.prototype.removeListen = function () {
        if (this.scroll$)
            this.scroll$.unsubscribe();
    };
    /**
     * @return {?}
     */
    NzBackTopComponent.prototype.registerScrollEvent = function () {
        var _this = this;
        this.removeListen();
        this.handleScroll();
        this.scroll$ = ((RxChain.from(fromEvent$1(this.getTarget(), 'scroll'))))
            .call(throttleTime$1, 50)
            .call(distinctUntilChanged$1)
            .subscribe(function (e) {
            _this.handleScroll();
        });
    };
    /**
     * @return {?}
     */
    NzBackTopComponent.prototype.ngOnDestroy = function () {
        this.removeListen();
    };
    return NzBackTopComponent;
}());
NzBackTopComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-back-top',
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('enterLeave', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate(300, style({ opacity: 1 }))
                        ]),
                        transition(':leave', [
                            style({ opacity: 1 }),
                            animate(300, style({ opacity: 0 }))
                        ])
                    ])
                ],
                template: "\n  <div class=\"ant-back-top\" (click)=\"clickBackTop()\" [@enterLeave] *ngIf=\"_display\">\n    <ng-template #defaultContent>\n      <div class=\"ant-back-top-content\"><i class=\"anticon anticon-to-top ant-back-top-icon\"></i></div>\n    </ng-template>\n    <ng-template [ngTemplateOutlet]=\"nzTemplate || defaultContent\"></ng-template>\n  </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-back-top {\n  z-index: 10;\n  position: fixed;\n  right: 100px;\n  bottom: 50px;\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n}\n.ant-back-top-content {\n  height: 40px;\n  width: 40px;\n  border-radius: 20px;\n  background-color: rgba(64, 64, 64, 0.4);\n  color: #fff;\n  text-align: center;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-back-top-content:hover {\n  background-color: rgba(64, 64, 64, 0.6);\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-back-top-icon {\n  font-size: 20px;\n  margin-top: 10px;\n}\n",
                    ""
                ]
            },] },
];
/**
 * @nocollapse
 */
NzBackTopComponent.ctorParameters = function () { return [
    { type: NzScrollService, },
    { type: Renderer2, },
]; };
NzBackTopComponent.propDecorators = {
    'nzTemplate': [{ type: ContentChild, args: ['nzTemplate',] },],
    'nzVisibilityHeight': [{ type: Input },],
    'nzTarget': [{ type: Input },],
    'nzClick': [{ type: Output },],
};
var NzBackTopModule = (function () {
    function NzBackTopModule() {
    }
    return NzBackTopModule;
}());
NzBackTopModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzBackTopComponent],
                exports: [NzBackTopComponent],
                imports: [CommonModule],
                providers: [SCROLL_SERVICE_PROVIDER]
            },] },
];
/**
 * @nocollapse
 */
NzBackTopModule.ctorParameters = function () { return []; };
// import { Observable } from 'rxjs/Observable';
var NzAffixComponent = (function () {
    /**
     * @param {?} scrollSrv
     * @param {?} _el
     * @param {?} _renderer
     */
    function NzAffixComponent(scrollSrv, _el, _renderer) {
        this.scrollSrv = scrollSrv;
        this._el = _el;
        this._renderer = _renderer;
        this.scroll$ = null;
        this.scrollWinInTarget$ = null;
        this.target = null;
        this.fixed = false;
        this.nzOffsetTop = 0;
        this.nzOffsetBottom = 0;
        this.nzChange = new EventEmitter();
    }
    Object.defineProperty(NzAffixComponent.prototype, "nzTarget", {
        /**
         * @param {?} el
         * @return {?}
         */
        set: function (el) {
            this.target = el;
            this.registerScrollEvent();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzAffixComponent.prototype.ngOnInit = function () {
        if (!this.scroll$)
            this.registerScrollEvent();
    };
    /**
     * @return {?}
     */
    NzAffixComponent.prototype.getTarget = function () {
        return this.target || window;
    };
    /**
     * @return {?}
     */
    NzAffixComponent.prototype.reCalculate = function () {
        var /** @type {?} */ elOffset = this.scrollSrv.getOffset(this._el.nativeElement);
        this.orgOffset = {
            top: elOffset.top + this.scrollSrv.getScroll(this.getTarget()),
            left: elOffset.left + this.scrollSrv.getScroll(this.getTarget(), false)
        };
        return this;
    };
    /**
     * @return {?}
     */
    NzAffixComponent.prototype.process = function () {
        if (!this.orgOffset)
            this.reCalculate();
        var /** @type {?} */ containerScrollTop = this.scrollSrv.getScroll(this.getTarget());
        var /** @type {?} */ fixTop = this.getTarget() === window ? 0 : this.scrollSrv.getOffset(/** @type {?} */ (this.getTarget())).top;
        var /** @type {?} */ hasFixed = this.orgOffset.top - fixTop - containerScrollTop - this.nzOffsetTop <= 0;
        if (this.fixed === hasFixed)
            return;
        var /** @type {?} */ wrapEl = this.wrap.nativeElement;
        wrapEl.classList[hasFixed ? 'add' : 'remove']('ant-affix');
        if (hasFixed) {
            wrapEl.style.cssText = "top:" + (this.nzOffsetTop + fixTop) + "px;left:" + this.orgOffset.left + "px";
        }
        else {
            wrapEl.style.cssText = "";
        }
        this.fixed = hasFixed;
        this.nzChange.emit(hasFixed);
    };
    /**
     * @return {?}
     */
    NzAffixComponent.prototype.removeListen = function () {
        if (this.scroll$)
            this.scroll$.unsubscribe();
        if (this.scrollWinInTarget$)
            this.scrollWinInTarget$.unsubscribe();
    };
    /**
     * @return {?}
     */
    NzAffixComponent.prototype.registerScrollEvent = function () {
        var _this = this;
        this.removeListen();
        this.reCalculate().process();
        this.scroll$ = ((RxChain.from(fromEvent$1(this.getTarget(), 'scroll'))))
            .call(throttleTime$1, 50)
            .call(distinctUntilChanged$1)
            .subscribe(function (e) {
            _this.process();
        });
        if (this.getTarget() !== window) {
            // 当 window 滚动位发生变动时，需要重新计算滚动容器
            this.scrollWinInTarget$ = ((RxChain.from(fromEvent$1(window, 'scroll'))))
                .call(throttleTime$1, 50)
                .call(distinctUntilChanged$1)
                .subscribe(function (e) {
                _this.orgOffset = null;
                _this.fixed = false;
            });
        }
    };
    /**
     * @return {?}
     */
    NzAffixComponent.prototype.ngOnDestroy = function () {
        this.removeListen();
    };
    return NzAffixComponent;
}());
NzAffixComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-affix',
                encapsulation: ViewEncapsulation.None,
                template: "<div #wrap><ng-content></ng-content></div>",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-affix {\n  position: fixed;\n  z-index: 10;\n}\n",
                    "nz-affix {\n  display: block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzAffixComponent.ctorParameters = function () { return [
    { type: NzScrollService, },
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzAffixComponent.propDecorators = {
    'wrap': [{ type: ViewChild, args: ['wrap',] },],
    'nzTarget': [{ type: Input },],
    'nzOffsetTop': [{ type: Input },],
    'nzOffsetBottom': [{ type: Input },],
    'nzChange': [{ type: Output },],
};
var NzAffixModule = (function () {
    function NzAffixModule() {
    }
    return NzAffixModule;
}());
NzAffixModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzAffixComponent],
                exports: [NzAffixComponent],
                imports: [CommonModule],
                providers: [SCROLL_SERVICE_PROVIDER]
            },] },
];
/**
 * @nocollapse
 */
NzAffixModule.ctorParameters = function () { return []; };
var NzAnchorComponent = (function () {
    /**
     * @param {?} scrollSrv
     * @param {?} _renderer
     * @param {?} doc
     */
    function NzAnchorComponent(scrollSrv, _renderer, doc) {
        this.scrollSrv = scrollSrv;
        this._renderer = _renderer;
        this.doc = doc;
        this.links = [];
        this.scroll$ = null;
        this.target = null;
        this.animating = false;
        this._top = 0;
        this._visible = false;
        this.nzOffsetTop = 0;
        this.nzBounds = 5;
        this.nzScroll = new EventEmitter();
    }
    Object.defineProperty(NzAnchorComponent.prototype, "nzTarget", {
        /**
         * @param {?} el
         * @return {?}
         */
        set: function (el) {
            this.target = el;
            this.registerScrollEvent();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NzAnchorComponent.prototype.ngOnInit = function () {
        if (!this.scroll$)
            this.registerScrollEvent();
    };
    /**
     * @return {?}
     */
    NzAnchorComponent.prototype.getTarget = function () {
        return this.target || window;
    };
    /**
     * @return {?}
     */
    NzAnchorComponent.prototype.handleScroll = function () {
        var _this = this;
        if (this.animating)
            return;
        var /** @type {?} */ sections = [];
        this.links.forEach(function (comp) {
            comp.active = false;
            var /** @type {?} */ target = _this.doc.querySelector(comp.nzHref);
            var /** @type {?} */ top = _this.scrollSrv.getOffset(target).top;
            if (target && top < _this.nzOffsetTop + _this.nzBounds) {
                sections.push({
                    top: top,
                    comp: comp
                });
            }
        });
        this._visible = !!sections.length;
        if (!this._visible)
            return;
        var /** @type {?} */ maxSection = sections.reduce(function (prev, curr) { return curr.top > prev.top ? curr : prev; });
        maxSection.comp.active = true;
        var /** @type {?} */ linkNode = (((maxSection.comp.el.nativeElement)).querySelector('.ant-anchor-link-title'));
        this.ball.nativeElement.style.top = linkNode.offsetTop + linkNode.clientHeight / 2 - 4.5 + "px";
        this.nzScroll.emit(maxSection.comp);
    };
    /**
     * @return {?}
     */
    NzAnchorComponent.prototype.removeListen = function () {
        if (this.scroll$)
            this.scroll$.unsubscribe();
    };
    /**
     * @return {?}
     */
    NzAnchorComponent.prototype.registerScrollEvent = function () {
        var _this = this;
        this.removeListen();
        // 由于页面刷新时滚动条位置的记忆
        // 倒置在dom未渲染完成，导致计算不正确（500ms用于延后执行解决）
        setTimeout(function () {
            _this.handleScroll();
        }, 500);
        this.scroll$ = ((RxChain.from(fromEvent$1(this.getTarget(), 'scroll'))))
            .call(throttleTime$1, 50)
            .call(distinctUntilChanged$1)
            .subscribe(function (e) {
            _this.handleScroll();
        });
    };
    /**
     * @param {?} linkComp
     * @return {?}
     */
    NzAnchorComponent.prototype.add = function (linkComp) {
        this.links.push(linkComp);
    };
    /**
     * 设置滚动条至 `linkComp` 所处位置
     * @param {?} linkComp
     * @return {?}
     */
    NzAnchorComponent.prototype.scrollTo = function (linkComp) {
        var _this = this;
        var /** @type {?} */ el = this.doc.querySelector(linkComp.nzHref);
        if (!el)
            return;
        this.animating = true;
        var /** @type {?} */ containerScrollTop = this.scrollSrv.getScroll(this.getTarget());
        var /** @type {?} */ elOffsetTop = this.scrollSrv.getOffset(el).top;
        var /** @type {?} */ targetScrollTop = containerScrollTop + elOffsetTop - this.nzOffsetTop;
        this.scrollSrv.scrollTo(this.getTarget(), targetScrollTop, null, function () {
            _this.animating = false;
            _this.handleScroll();
        });
    };
    /**
     * @return {?}
     */
    NzAnchorComponent.prototype.ngOnDestroy = function () {
        this.removeListen();
    };
    return NzAnchorComponent;
}());
NzAnchorComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-anchor',
                encapsulation: ViewEncapsulation.None,
                template: "\n  <div class=\"ant-anchor-wrapper\" #container>\n    <div class=\"ant-anchor\">\n      <div class=\"ant-anchor-ink\">\n        <div class=\"ant-anchor-ink-ball\" [class.visible]=\"_visible\" #ball></div>\n      </div>\n      <ng-content></ng-content>\n    </div>\n  </div>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-anchor {\n  position: relative;\n}\n.ant-anchor-wrapper {\n  background-color: #fff;\n}\n.ant-anchor-ink {\n  position: absolute;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.ant-anchor-ink:before {\n  content: ' ';\n  position: relative;\n  width: 2px;\n  height: 100%;\n  display: block;\n  background-color: #e9e9e9;\n  margin: 0 auto;\n}\n.ant-anchor-ink-ball {\n  display: none;\n  position: absolute;\n  width: 9px;\n  height: 9px;\n  border-radius: 9px;\n  border: 3px solid #108ee9;\n  background-color: #fff;\n  left: 50%;\n  transition: top 0.3s ease-in-out;\n  transform: translateX(-50%);\n}\n.ant-anchor-ink-ball.visible {\n  display: inline-block;\n}\n.ant-anchor.fixed .ant-anchor-ink .ant-anchor-ink-ball {\n  display: none;\n}\n.ant-anchor-link {\n  padding: 8px 0 8px 18px;\n  line-height: 1;\n}\n.ant-anchor-link .ant-anchor-link {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n.ant-anchor-link-title {\n  display: block;\n  position: relative;\n  transition: all .3s;\n  color: rgba(0, 0, 0, 0.65);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 8px;\n}\n.ant-anchor-link-title:only-child {\n  margin-bottom: 0;\n}\n.ant-anchor-link-active > .ant-anchor-link-title {\n  color: #108ee9;\n}\n.ant-anchor-link > .ant-anchor-link {\n  font-size: 12px;\n}\n",
                    "nz-link {\n  display: block;\n}\n"
                ]
            },] },
];
/**
 * @nocollapse
 */
NzAnchorComponent.ctorParameters = function () { return [
    { type: NzScrollService, },
    { type: Renderer2, },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
]; };
NzAnchorComponent.propDecorators = {
    'container': [{ type: ViewChild, args: ['container',] },],
    'ball': [{ type: ViewChild, args: ['ball',] },],
    'nzTarget': [{ type: Input },],
    'nzOffsetTop': [{ type: Input },],
    'nzBounds': [{ type: Input },],
    'nzScroll': [{ type: Output },],
};
var NzAnchorLinkComponent = (function () {
    /**
     * @param {?} el
     * @param {?} _anchorComp
     */
    function NzAnchorLinkComponent(el, _anchorComp) {
        this.el = el;
        this._anchorComp = _anchorComp;
        this._nzAnchorLink = true;
        this.active = false;
        this._anchorComp.add(this);
    }
    /**
     * @return {?}
     */
    NzAnchorLinkComponent.prototype._onClick = function () {
        this._anchorComp.scrollTo(this);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    NzAnchorLinkComponent.prototype.goToClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        this._anchorComp.scrollTo(this);
        // return false;
    };
    return NzAnchorLinkComponent;
}());
NzAnchorLinkComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-link',
                encapsulation: ViewEncapsulation.None,
                template: "\n    <a (click)=\"goToClick($event)\" href=\"{{nzHref}}\" class=\"ant-anchor-link-title\">\n      <span *ngIf=\"!nzTemplate\">{{nzTitle}}</span>\n      <ng-template *ngIf=\"nzTemplate\" [ngTemplateOutlet]=\"nzTemplate\"></ng-template>\n    </a>\n    <ng-content></ng-content>\n  "
            },] },
];
/**
 * @nocollapse
 */
NzAnchorLinkComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: NzAnchorComponent, },
]; };
NzAnchorLinkComponent.propDecorators = {
    'nzHref': [{ type: Input },],
    'nzTitle': [{ type: Input },],
    'nzTemplate': [{ type: ContentChild, args: ['nzTemplate',] },],
    '_nzAnchorLink': [{ type: HostBinding, args: ['class.ant-anchor-link',] },],
    'active': [{ type: HostBinding, args: ['class.ant-anchor-link-active',] },],
    '_onClick': [{ type: HostListener, args: ['click',] },],
};
var NzAnchorModule = (function () {
    function NzAnchorModule() {
    }
    return NzAnchorModule;
}());
NzAnchorModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzAnchorComponent, NzAnchorLinkComponent],
                exports: [NzAnchorComponent, NzAnchorLinkComponent],
                imports: [CommonModule],
                providers: [SCROLL_SERVICE_PROVIDER]
            },] },
];
/**
 * @nocollapse
 */
NzAnchorModule.ctorParameters = function () { return []; };
var NzAvatarComponent = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function NzAvatarComponent(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._prefixCls = 'ant-avatar';
        this._classList = [];
        this._sizeMap = { large: 'lg', small: 'sm' };
        this._hasText = false;
        this._isSrcExist = true;
        this._hasIcon = false;
        this.nzShape = 'circle';
        this.nzSize = 'default';
        this._el = _elementRef.nativeElement;
        this._renderer.addClass(this._el, this._prefixCls);
    }
    /**
     * @return {?}
     */
    NzAvatarComponent.prototype._setClassMap = function () {
        var _this = this;
        this._classList.forEach(function (_className) {
            _this._renderer.removeClass(_this._el, _className);
        });
        this._classList = [
            this._sizeMap[this.nzSize] && this._prefixCls + "-" + this._sizeMap[this.nzSize],
            this.nzShape && this._prefixCls + "-" + this.nzShape,
            this.nzIcon && this._prefixCls + "-icon",
            this.nzSrc && this._prefixCls + "-image"
        ].filter(function (item) {
            return !!item;
        });
        this._classList.forEach(function (_className) {
            _this._renderer.addClass(_this._el, _className);
        });
        return this;
    };
    /**
     * @return {?}
     */
    NzAvatarComponent.prototype._imgError = function () {
        this._isSrcExist = false;
        // TODO(i): need force remove [nzSrc] if broken image?
        this._hasIcon = false;
        this._hasText = false;
        if (this.nzIcon) {
            this._hasIcon = true;
        }
        else if (this.nzText) {
            this._hasText = true;
        }
        this._setClassMap()._notifyCalc();
    };
    /**
     * @return {?}
     */
    NzAvatarComponent.prototype._calcStringSize = function () {
        if (!this._hasText)
            return;
        var /** @type {?} */ el = this._textEl && this._textEl.nativeElement;
        if (!el)
            return;
        var /** @type {?} */ childrenWidth = el.offsetWidth;
        var /** @type {?} */ avatarWidth = this._el.getBoundingClientRect().width;
        var /** @type {?} */ scale = avatarWidth - 8 < childrenWidth ? (avatarWidth - 8) / childrenWidth : 1;
        if (scale === 1) {
            this._textStyles = {};
        }
        else {
            this._textStyles = {
                transform: "scale(" + scale + ")",
                position: 'absolute',
                display: 'inline-block',
                left: "calc(50% - " + Math.round(childrenWidth / 2) + "px)"
            };
        }
    };
    /**
     * @return {?}
     */
    NzAvatarComponent.prototype._notifyCalc = function () {
        var _this = this;
        // If use ngAfterViewChecked, always demands more computations, so......
        setTimeout(function () {
            _this._calcStringSize();
        });
        return this;
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NzAvatarComponent.prototype.ngOnChanges = function (changes) {
        this._hasText = !this.nzSrc && !!this.nzText;
        this._hasIcon = !this.nzSrc && !!this.nzIcon;
        this._setClassMap()._notifyCalc();
    };
    return NzAvatarComponent;
}());
NzAvatarComponent.decorators = [
    { type: Component, args: [{
                selector: 'nz-avatar',
                encapsulation: ViewEncapsulation.None,
                template: "\n  <i class=\"anticon anticon-{{nzIcon}}\" *ngIf=\"nzIcon && _hasIcon\"></i>\n  <img [src]=\"nzSrc\" *ngIf=\"nzSrc && _isSrcExist\" (error)=\"_imgError($event)\"/>\n  <span class=\"ant-avatar-string\" #textEl [ngStyle]=\"_textStyles\" *ngIf=\"nzText && _hasText\">{{nzText}}</span>\n  ",
                styles: [
                    "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable declaration-bang-space-before */\n/* stylelint-disable declaration-bang-space-before */\n.ant-avatar {\n  display: inline-block;\n  text-align: center;\n  background: #ccc;\n  color: #fff;\n  white-space: nowrap;\n  position: relative;\n  overflow: hidden;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  border-radius: 16px;\n}\n.ant-avatar > * {\n  line-height: 32px;\n}\n.ant-avatar.ant-avatar-icon {\n  font-size: 18px;\n}\n.ant-avatar-lg {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 20px;\n}\n.ant-avatar-lg > * {\n  line-height: 40px;\n}\n.ant-avatar-lg.ant-avatar-icon {\n  font-size: 24px;\n}\n.ant-avatar-sm {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  border-radius: 12px;\n}\n.ant-avatar-sm > * {\n  line-height: 24px;\n}\n.ant-avatar-sm.ant-avatar-icon {\n  font-size: 14px;\n}\n.ant-avatar-square {\n  border-radius: 4px;\n}\n.ant-avatar > img {\n  width: 100%;\n  height: 100%;\n}\n",
                    ""
                ]
            },] },
];
/**
 * @nocollapse
 */
NzAvatarComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
NzAvatarComponent.propDecorators = {
    '_textEl': [{ type: ViewChild, args: ['textEl',] },],
    'nzShape': [{ type: Input },],
    'nzSize': [{ type: Input },],
    'nzText': [{ type: Input },],
    'nzSrc': [{ type: Input },],
    'nzIcon': [{ type: Input },],
};
var NzAvatarModule = (function () {
    function NzAvatarModule() {
    }
    return NzAvatarModule;
}());
NzAvatarModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NzAvatarComponent],
                exports: [NzAvatarComponent],
                imports: [CommonModule]
            },] },
];
/**
 * @nocollapse
 */
NzAvatarModule.ctorParameters = function () { return []; };
var NzMessageBaseService = (function () {
    /**
     * @param {?} floaterService
     * @param {?} containerClass
     * @param {?=} _idPrefix
     */
    function NzMessageBaseService(floaterService, containerClass, _idPrefix) {
        if (_idPrefix === void 0) { _idPrefix = ''; }
        this._idPrefix = _idPrefix;
        this._counter = 0; // Id counter for messages
        this._container = floaterService.persistAttachComponent(containerClass);
    }
    /**
     * @param {?=} messageId
     * @return {?}
     */
    NzMessageBaseService.prototype.remove = function (messageId) {
        if (messageId) {
            this._container.removeMessage(messageId);
        }
        else {
            this._container.removeMessageAll();
        }
    };
    /**
     * @param {?} message
     * @param {?=} options
     * @return {?}
     */
    NzMessageBaseService.prototype.createMessage = function (message, options) {
        var /** @type {?} */ resultMessage = Object.assign(message, {
            messageId: this._generateMessageId(),
            options: options,
            createdAt: new Date()
        });
        this._container.createMessage(resultMessage);
        return resultMessage;
    };
    /**
     * @return {?}
     */
    NzMessageBaseService.prototype._generateMessageId = function () {
        return this._idPrefix + this._counter++;
    };
    return NzMessageBaseService;
}());
var NzMessageService = (function (_super) {
    tslib_1.__extends(NzMessageService, _super);
    /**
     * @param {?} floaterService
     */
    function NzMessageService(floaterService) {
        return _super.call(this, floaterService, NzMessageContainerComponent, 'message-') || this;
    }
    /**
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzMessageService.prototype.success = function (content, options) {
        return this.createMessage({ type: 'success', content: content }, options);
    };
    /**
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzMessageService.prototype.error = function (content, options) {
        return this.createMessage({ type: 'error', content: content }, options);
    };
    /**
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzMessageService.prototype.info = function (content, options) {
        return this.createMessage({ type: 'info', content: content }, options);
    };
    /**
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzMessageService.prototype.warning = function (content, options) {
        return this.createMessage({ type: 'warning', content: content }, options);
    };
    /**
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzMessageService.prototype.loading = function (content, options) {
        return this.createMessage({ type: 'loading', content: content }, options);
    };
    /**
     * @param {?} type
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzMessageService.prototype.create = function (type, content, options) {
        return this.createMessage({ type: /** @type {?} */ (type), content: content }, options);
    };
    /**
     * @param {?} html
     * @param {?=} options
     * @return {?}
     */
    NzMessageService.prototype.html = function (html, options) {
        return this.createMessage({ html: html }, options);
    };
    return NzMessageService;
}(NzMessageBaseService));
NzMessageService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NzMessageService.ctorParameters = function () { return [
    { type: FloaterService, },
]; };
var NzNotificationService = (function (_super) {
    tslib_1.__extends(NzNotificationService, _super);
    /**
     * @param {?} floaterService
     */
    function NzNotificationService(floaterService) {
        return _super.call(this, floaterService, NzNotificationContainerComponent, 'notification-') || this;
    }
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzNotificationService.prototype.success = function (title, content, options) {
        return this.createMessage({ type: 'success', title: title, content: content }, options);
    };
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzNotificationService.prototype.error = function (title, content, options) {
        return this.createMessage({ type: 'error', title: title, content: content }, options);
    };
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzNotificationService.prototype.info = function (title, content, options) {
        return this.createMessage({ type: 'info', title: title, content: content }, options);
    };
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzNotificationService.prototype.warning = function (title, content, options) {
        return this.createMessage({ type: 'warning', title: title, content: content }, options);
    };
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzNotificationService.prototype.blank = function (title, content, options) {
        return this.createMessage({ type: 'blank', title: title, content: content }, options);
    };
    /**
     * @param {?} type
     * @param {?} title
     * @param {?} content
     * @param {?=} options
     * @return {?}
     */
    NzNotificationService.prototype.create = function (type, title, content, options) {
        return this.createMessage({ type: /** @type {?} */ (type), title: title, content: content }, options);
    };
    /**
     * @param {?} html
     * @param {?=} options
     * @return {?}
     */
    NzNotificationService.prototype.html = function (html, options) {
        return this.createMessage({ html: html }, options);
    };
    return NzNotificationService;
}(NzMessageBaseService));
NzNotificationService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
NzNotificationService.ctorParameters = function () { return [
    { type: FloaterService, },
]; };
// ---------------------------------------------------------
// | Imports
// ---------------------------------------------------------
// Common of angular
// Modules
// Services
// Tokens (eg. global services' config)
var NgZorroAntdModule = (function () {
    function NgZorroAntdModule() {
    }
    /**
     * @param {?=} options
     * @return {?}
     */
    NgZorroAntdModule.forRoot = function (options) {
        return {
            ngModule: NgZorroAntdModule,
            providers: [
                // Services
                NzNotificationService,
                NzMessageService,
                { provide: NZ_ROOT_CONFIG, useValue: options },
            ]
        };
    };
    return NgZorroAntdModule;
}());
NgZorroAntdModule.decorators = [
    { type: NgModule, args: [{
                exports: [
                    NzButtonModule,
                    NzAlertModule,
                    NzBadgeModule,
                    NzCalendarModule,
                    NzCascaderModule,
                    NzCheckboxModule,
                    NzDatePickerModule,
                    NzFormModule,
                    NzInputModule,
                    NzInputNumberModule,
                    NzGridModule,
                    NzMessageModule,
                    NzModalModule,
                    NzNotificationModule,
                    NzPaginationModule,
                    NzPopconfirmModule,
                    NzPopoverModule,
                    NzRadioModule,
                    NzRateModule,
                    NzSelectModule,
                    NzSpinModule,
                    NzSliderModule,
                    NzSwitchModule,
                    NzProgressModule,
                    NzTableModule,
                    NzTabsModule,
                    NzTagModule,
                    NzTimePickerModule,
                    NzUtilModule,
                    NzStepsModule,
                    NzDropDownModule,
                    NzMenuModule,
                    NzBreadCrumbModule,
                    NzLayoutModule,
                    NzRootModule,
                    NzCarouselModule,
                    NzCardModule,
                    NzCollapseModule,
                    NzTimelineModule,
                    NzToolTipModule,
                    NzBackTopModule,
                    NzAffixModule,
                    NzAnchorModule,
                    NzAvatarModule
                ]
            },] },
];
/**
 * @nocollapse
 */
NgZorroAntdModule.ctorParameters = function () { return []; };
/**
 * Generated bundle index. Do not edit.
 */
export { NzGridModule, NzButtonModule, NzAlertModule, NzBadgeModule, NzCalendarModule, NzCascaderModule, NzCheckboxModule, NzDatePickerModule, NzFormModule, NzInputModule, NzInputNumberModule, NzMessageModule, NzModalModule, NzNotificationModule, NzPaginationModule, NzPopconfirmModule, NzPopoverModule, NzRadioModule, NzRateModule, NzSelectModule, NzSpinModule, NzProgressModule, NzSliderModule, NzSwitchModule, NzTableModule, NzTabsModule, NzTagModule, NzTimePickerModule, NzUtilModule, NzStepsModule, NzDropDownModule, NzMenuModule, NzBreadCrumbModule, NzLayoutModule, NzRootModule, NzCarouselModule, NzCardModule, NzCollapseModule, NzTimelineModule, NzToolTipModule, NzBackTopModule, NzAffixModule, NzAnchorModule, NzAvatarModule, NzRowComponent, NzColComponent, NzColDirective, NzButtonGroupComponent, NzButtonComponent, NzAlertComponent, NzBadgeComponent, NzCalendarComponent, NzCascaderComponent, NzCheckboxGroupComponent, NzCheckboxComponent, NzDatePickerComponent, NzFormControlComponent, NzFormExplainComponent, NzFormExtraDirective, NzFormItemRequiredDirective, NzFormItemDirective, NzFormLabelDirective, NzFormSplitDirective, NzFormTextDirective, NzFormComponent, NzInputGroupComponent, NzInputComponent, NzInputDirectiveComponent, NzMessageContainerComponent, NzMessageComponent, NzConfirmComponent, NzModalComponent, NzNotificationContainerComponent, NzNotificationComponent, NzPaginationComponent, NzPopconfirmComponent, NzPopconfirmDirective, NzPopoverComponent, NzPopoverDirective, NzRadioButtonComponent, NzRadioGroupComponent, NzRadioComponent, NzRateComponent, NzOptionComponent, NzSelectComponent, NzSpinComponent, NzProgressComponent, NzSliderComponent, NzSliderHandleComponent, NzSliderMarksComponent, NzSliderStepComponent, NzSliderTrackComponent, NzSwitchComponent, NzThDirective, NzRowIndentComponent, NzTableFilterComponent, NzTableComponent, NzTheadDirective, NzTableSortComponent, NzRowExpandIconComponent, NzTableDividerDirective, NzTbodyTrDirective, NzTbodyDirective, NzTdDirective, NzTabSetComponent, NzTabsNavComponent, NzTabLabelDirective, NzTabBodyComponent, NzTabComponent, NzCheckableTagComponent, NzTagComponent, NzTimePickerInnerComponent, NzTimePickerComponent, NzStepComponent, NzStepsComponent, NzDropDownComponent, NzDropDownDirective, NzDropDownButtonComponent, NzMenuDividerComponent, NzMenuGroupComponent, NzMenuItemComponent, NzMenuComponent, NzSubMenuComponent, NzBreadCrumbItemComponent, NzBreadCrumbComponent, NzContentComponent, NzFooterComponent, NzHeaderComponent, NzLayoutComponent, NzCarouselContentDirective, NzCarouselComponent, NzCardGridDirective, NzCardComponent, NzCollapseComponent, NzCollapsesetComponent, NzTimelineItemComponent, NzTimelineComponent, NzToolTipComponent, NzTooltipDirective, NzBackTopComponent, NzAffixComponent, NzAnchorLinkComponent, NzAnchorComponent, NzAvatarComponent, NzNotificationService, NzMessageService, NzModalService, NzModalSubject, NZ_MESSAGE_CONFIG, NZ_NOTIFICATION_CONFIG, NZ_ROOT_CONFIG, NgZorroAntdModule, NZ_COLLAPSE_DIRECTIVES as ɵa, DropDownAnimation as ɵbf, FadeAnimation as ɵl, TagAnimation as ɵbg, FLOATER_SERVICE_PROVIDER as ɵbm, FLOATER_SERVICE_PROVIDER_FACTORY as ɵbl, FloaterService as ɵbk, FloaterModule as ɵbj, OVERLAY_PROVIDERS as ɵm, OverlayModule as ɵn, Overlay as ɵo, OVERLAY_CONTAINER_PROVIDER as ɵr, OVERLAY_CONTAINER_PROVIDER_FACTORY as ɵq, OverlayContainer as ɵp, ConnectedOverlayDirective as ɵt, OverlayOrigin as ɵs, OverlayPositionBuilder as ɵbd, VIEWPORT_RULER_PROVIDER as ɵw, VIEWPORT_RULER_PROVIDER_FACTORY as ɵv, ViewportRuler as ɵu, ScrollDispatchModule as ɵx, SCROLL_DISPATCHER_PROVIDER as ɵbb, SCROLL_DISPATCHER_PROVIDER_FACTORY as ɵba, ScrollDispatcher as ɵz, ScrollStrategyOptions as ɵbc, Scrollable as ɵy, NzScrollService as ɵbr, SCROLL_SERVICE_PROVIDER as ɵbt, SCROLL_SERVICE_PROVIDER_FACTORY as ɵbs, NzInputNumberComponent as ɵbi, NzSiderComponent as ɵc, NZ_MESSAGE_DEFAULT_CONFIG as ɵf, NZ_MESSAGE_DEFAULT_CONFIG_PROVIDER as ɵg, NzMessageConfig as ɵe, NzMessageBaseService as ɵd, NZ_NOTIFICATION_DEFAULT_CONFIG as ɵi, NZ_NOTIFICATION_DEFAULT_CONFIG_PROVIDER as ɵj, NzNotificationConfig as ɵh, createNzRootInitializer as ɵk, NzRootStyleComponent as ɵbq, NzRootComponent as ɵbp, NzOptionPipe as ɵbe, NzSliderService as ɵbn, NzStepConnectService as ɵbo, NzTabsInkBarDirective as ɵb, NzDatePipe as ɵbh };



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-zorro-antd/esm5/index.js
// module id = 99
// module chunks = 75